{
  "testit": {
    "catalog": {
      "title": "TestIt",
      "subtitle": "Os seus resultados de testes reutilizáveis — faça um teste uma vez e reutilize-o em qualquer CheckUp.",
      "notTaken": "Ainda não feito",
      "validDays": "Válido · {{days}}d restantes",
      "expired": "Expirado",
      "delete": "Eliminar",
      "declareHint": "Autodeclare o seu nível (não verificado). Pode substituí-lo por um teste verificado mais tarde.",
      "retake": "Refazer",
      "kindPitch": "Pitch em vídeo",
      "kindCefr": "Teste de idioma",
      "kindMotivational": "Questionário",
      "valid": "Válido",
      "takeTest": "Fazer teste",
      "heroTitle": "O seu banco de testes reutilizáveis",
      "heroSubtitle": "Os resultados válidos são usados automaticamente da próxima vez que fizer um CheckUp.",
      "statValid": "Válidos",
      "statExpired": "Expirados",
      "statUntaken": "Por fazer",
      "errorTitle": "Não foi possível carregar os seus testes",
      "errorBody": "Algo correu mal ao obter o seu banco de testes. Tente novamente daqui a pouco.",
      "band": {
        "ringValue": "{{valid}}/{{total}}",
        "ringCaption": "testes válidos",
        "ringLabel": "{{valid}} de {{total}} testes válidos",
        "allValid": "Todos os testes válidos",
        "toRenew_one": "{{count}} a renovar",
        "toRenew_other": "{{count}} a renovar",
        "toTake_one": "{{count}} por fazer",
        "toTake_other": "{{count}} por fazer",
        "nextEyebrow": "O seu próximo passo",
        "startNow": "Começar agora",
        "renewNow": "Renovar agora",
        "renewCaption": "O resultado expirou · cerca de {{minutes}} min",
        "upToDate": "Todos os resultados em dia",
        "soonestExpiry": "O primeiro a expirar é {{test}}, a {{date}}"
      },
      "measures": {
        "pitch": "Um vídeo curto em que se apresenta — a clareza e a confiança com que diz quem é e porque está a mudar de país.",
        "cefr": "O seu nível na língua, de A1 a C2 — geral e em leitura, compreensão oral, expressão oral e expressão escrita.",
        "motivational": "Um questionário curto sobre porque está a mudar de país e o que procura na sua nova vida."
      },
      "kindWithMinutes": "{{kind}} · cerca de {{minutes}} min",
      "aboutMinutes": "Cerca de {{minutes}} min",
      "expiredOn": "expirou a {{date}}",
      "viewResult": "Ver resultado",
      "renew": "Renovar"
    },
    "modal": {
      "history": "Histórico",
      "historyError": "Não foi possível carregar as suas tentativas.",
      "current": "Atual",
      "superseded": "Substituído",
      "daysLeft": "{{days}} dias restantes",
      "takenOn": "Feito em {{date}}",
      "expiresOn": "expira em {{date}}",
      "reuseNote": "Reutilizado automaticamente no seu próximo CheckUp",
      "takeNew": "Fazer um novo teste",
      "declareCta": "Declarar nível"
    },
    "test": {
      "pitch": "Pitch",
      "languageEn": "Inglês",
      "languagePt": "Português",
      "language": "Idioma",
      "motivational": "Motivacional"
    },
    "invite": {
      "bulkKindNote": "Aplica-se a todos os candidatos selecionados.",
      "kindFull": "CheckUp completo",
      "kindFullHint": "A avaliação CheckUp completa — um perfil iQulture completo.",
      "kindLabel": "O que devem completar?",
      "kindTestit": "Testes específicos",
      "kindTestitHint": "Apenas os testes que escolher abaixo — mais rápido e os resultados são reutilizáveis.",
      "previewFull": "O e-mail de convite do CheckUp completo.",
      "previewLabel": "Irão receber",
      "previewTestit": "Um convite TestIt a indicar: {{tests}}.",
      "previewTestitEmpty": "Um convite TestIt — escolha os testes acima.",
      "selectAtLeastOne": "Selecione pelo menos um teste.",
      "selectTestsHint": "Escolha um ou mais. O candidato completa apenas estes.",
      "selectTestsLabel": "Que testes devem realizar?",
      "testNeverExpires": "Sem validade",
      "wizardBannerCta": "Começar agora",
      "wizardCompleteBody": "Os seus resultados foram partilhados com a empresa. Pode fechar isto e explorar o seu painel.",
      "wizardCompleteTitle": "Todos os testes concluídos!",
      "wizardDoLater": "Fazer mais tarde",
      "wizardDone": "Concluído",
      "wizardGoToDashboard": "Ir para o painel",
      "wizardIntro": "Foi convidado a completar estes testes. Faça-os pela ordem que quiser — os seus resultados são guardados e reutilizáveis.",
      "wizardPending": "Ainda por fazer",
      "wizardProgress": "{{done}} de {{total}} concluídos",
      "wizardRetake": "Repetir",
      "wizardStart": "Começar",
      "wizardTitle": "Complete os testes para os quais foi convidado",
      "testValidityDays_one": "Válido {{count}} dia",
      "testValidityDays_other": "Válido {{count}} dias",
      "wizardBannerTitle_one": "Foi convidado a completar {{count}} teste",
      "wizardBannerTitle_other": "Foi convidado a completar {{count}} testes",
      "completeBannerTitle": "Os testes que lhe pediram estão concluídos",
      "completeBannerBody": "A empresa que os pediu pode ver os seus resultados. Não falta fazer nada."
    },
    "vetting": {
      "allComplete": "Todos os testes convidados concluídos",
      "askDescription": "Vamos pedir a {{name}} a avaliação selecionada. Se precisar de mais do que partilha agora consigo, é o talento quem decide se partilha — nada mais é partilhado até responder. Os resultados que já tem são reutilizados.",
      "askFailed": "Não foi possível enviar o pedido",
      "askForCheckup": "Pedir CheckUp completo",
      "askSend": "Enviar pedido",
      "askSending": "A enviar…",
      "askEmailFailed": "O pedido a {{name}} ficou registado, mas não foi possível enviar o e-mail",
      "askTitle": "Solicitar uma avaliação a {{name}}",
      "decline": "Recusar",
      "declined": "Recusado",
      "expired": "Expirado",
      "invitedProgress": "{{done}} de {{total}} testes concluídos",
      "latestResult": "Último resultado",
      "noPriorAttempts": "Sem tentativas anteriores",
      "noResults": "Ainda sem resultados de testes",
      "noVerdict": "Sem decisão ainda",
      "notTaken": "Não feito",
      "otherResults": "Outros resultados",
      "overviewTitle": "Avaliação TestIt",
      "pass": "Aprovar",
      "passed": "Aprovado",
      "pending": "Pendente",
      "pitchAria": "Gravação do pitch do candidato",
      "pitchUnavailable": "Gravação indisponível",
      "previousAttempts": "Tentativas anteriores",
      "remind": "Lembrar",
      "reminderFailed": "Não foi possível enviar o lembrete.",
      "reminderSent": "Lembrete enviado",
      "reminderTooSoon": "Já os lembrou há pouco — tente novamente mais tarde.",
      "takenOn": "feito a {{date}}",
      "valid": "Válido · {{days}}d restantes",
      "validShort": "Válido",
      "verdictTitle": "Veredito",
      "failed": "Análise falhou",
      "failedReason": {
        "languageMismatch": "O certificado atesta uma língua diferente da deste teste.",
        "unsupportedDocument": "Não foi possível ler o ficheiro carregado.",
        "archiveTooLarge": "O documento Word é demasiado grande para ser lido em segurança.",
        "docxEmpty": "O documento Word não tem texto nem imagem legíveis.",
        "tooManyPages": "O certificado tem mais de {{max}} páginas; só são lidos certificados com até {{max}} páginas.",
        "noLevelFound": "Não foi encontrado nenhum nível QECR no certificado.",
        "serviceUnavailable": "O nosso serviço de análise não conseguiu processar o certificado."
      },
      "withheldBody": "Este cidadão não partilhou os resultados dos testes com a sua empresa. Os testes para os quais o convidou continuam listados; se os concluiu está retido — não é «pendente».",
      "moreActions": "Mais ações",
      "repositoryTitle": "Resultados de testes guardados",
      "repositorySubtitle": "Todos os testes e o que o candidato já concluiu de cada um — só leitura. Este convite de CheckUp não pediu testes específicos.",
      "loadFailed": "Não foi possível carregar os resultados dos testes.",
      "askRequested": "Pedido enviado a {{name}} — nada mais é partilhado até responder",
      "askReminded": "Lembrámos {{name}} do que ainda falta fazer",
      "askAlreadyShared": "{{name}} já partilha isto consigo — não há nada a pedir"
    },
    "doOnWeb": "Fazer os meus testes na web",
    "doOnWebDesc": "Os testes que a sua empresa pediu são feitos no Portal Web Citizen — abra-o num browser de desktop para começar.",
    "result": {
      "overallLevel": "Nível geral",
      "skillReading": "Leitura",
      "skillListening": "Compreensão oral",
      "skillSpeaking": "Expressão oral",
      "skillWriting": "Expressão escrita",
      "selfDeclared": "Autodeclarado",
      "analyserConfidence": "Confiança da análise: {{value}}",
      "recorded": "Gravado",
      "motivationalComplete": "Questionário concluído",
      "motivationalAnswered_one": "{{count}} resposta",
      "motivationalAnswered_other": "{{count}} respostas",
      "sourceCheckup": "Do CheckUp",
      "sourceTestit": "TestIt",
      "duration": "Duração",
      "cefrLevel": "QECR {{level}}",
      "recordedDuration": "Gravado · {{duration}}",
      "answersCaption_one": "resposta",
      "answersCaption_other": "respostas"
    },
    "tabs": {
      "tests": "Testes",
      "history": "Histórico"
    },
    "brief": {
      "title": "Antes de começar: {{test}}",
      "measuresHeading": "O que mede",
      "needsHeading": "Do que vai precisar",
      "stepsHeading": "Como funciona",
      "start": "Começar o teste",
      "replaces": "O seu resultado atual ({{result}}) é substituído pelo novo e fica no seu histórico.",
      "needs": {
        "camera": "Uma câmara e um microfone",
        "quietPlace": "Um lugar sossegado — responde em inglês",
        "computer": "Um computador com acesso à internet",
        "headphones": "Auscultadores para a parte de compreensão oral",
        "resultFile": "Uma captura de ecrã, um PDF ou um ficheiro Word do resultado",
        "time": "Um momento calmo — as respostas ficam guardadas enquanto escreve"
      },
      "steps": {
        "pitch": {
          "read": "Leia as perguntas no ecrã",
          "record": "Grave as respostas num só vídeo",
          "send": "Reveja-o, grave de novo se quiser e envie-o"
        },
        "language": {
          "take": "Faça o teste no site do parceiro",
          "upload": "Envie o resultado — uma captura de ecrã, um PDF ou um ficheiro Word",
          "read": "Lemos o seu nível automaticamente e mostramos-lho"
        },
        "motivational": {
          "answer": "Responda às perguntas sobre a sua mudança, ao seu ritmo",
          "review": "Reveja as respostas",
          "send": "Envie-as"
        }
      }
    },
    "done": {
      "title": "Resultado guardado",
      "saving": "A guardar o seu resultado…",
      "validUntil": "Válido até {{date}}",
      "finish": "Concluir",
      "seeResult": "Ver resultado e histórico"
    },
    "history": {
      "deleteTitle": "Apagar esta tentativa?",
      "deleteWhat": "{{test}} · {{result}} · {{date}}",
      "deleteCurrent": "É o seu resultado atual: a tentativa anterior, se existir, passa a ser o resultado deste teste.",
      "deleteAttempt": "Apagar a tentativa de {{test}}",
      "errorTitle": "Não foi possível carregar o seu histórico",
      "errorBody": "Tente novamente daqui a pouco.",
      "emptyTitle": "Ainda sem tentativas",
      "emptyBody": "Cada teste que fizer aparece aqui, com o resultado e a data.",
      "browseTests": "Ver os testes",
      "filterLabel": "Mostrar tentativas de",
      "filterAll": "Todos"
    }
  },
  "introCarousel": {
    "back": "Voltar",
    "business": {
      "cta": "Adicionar talentos",
      "ctaSecondary": "Talvez mais tarde",
      "slides": {
        "welcome": {
          "eyebrow": "Bem-vindo à Tonnie",
          "title": "Patrocine talento global, com proteção",
          "body": "Avalie, patrocine e apoie contratações internacionais num só lugar — a Tonnie protege cada patrocínio, com registo de auditoria em cada passo."
        },
        "acquire": {
          "eyebrow": "Pool de talentos · Avaliação",
          "title": "Avalie antes de patrocinar",
          "body": "Analise a prontidão de relocalização de cada candidato no Pool de Talentos, para patrocinar apenas quem vai mesmo chegar."
        },
        "sponsor": {
          "eyebrow": "Patrocínio · Protegido",
          "title": "Patrocine com proteção",
          "body": "Aposte num talento e a Tonnie protege o investimento de ponta a ponta — verificações de prontidão, marcos e evidências mantêm cada patrocínio no rumo certo."
        },
        "mobility": {
          "eyebrow": "Mobilidade · Adaptação",
          "title": "Acompanhe a mudança e a adaptação",
          "body": "Siga cada relocalização entre trâmites legais, viagem e instalação — e veja como cada contratado patrocinado se adapta à função e ao país."
        },
        "care": {
          "eyebrow": "Care · Conformidade",
          "title": "Retenha talento, com evidências",
          "body": "Apoie o bem-estar sem vigilância e exporte registos verificados assim que auditoria, jurídico ou direção precisarem."
        },
        "start": {
          "eyebrow": "Vamos começar",
          "title": "Patrocine o seu primeiro talento",
          "body": "Adicione um talento ao seu programa — cada patrocínio fica protegido pela Tonnie, desde o primeiro dia."
        }
      }
    },
    "goToSlide": "Ir para o slide {{number}}",
    "next": "Próximo",
    "skip": "Saltar",
    "title": "Introdução à Tonnie"
  },
  "activity": {
    "task": {
      "completed": "Concluído: {{label}}",
      "completedForMember": "Concluído: {{label}} — {{member}}"
    },
    "housing": {
      "secured": "Habitação garantida"
    },
    "checkup": {
      "scored": "CheckUp pontuação calculada"
    },
    "checkin": {
      "completed": "Check-in concluído"
    },
    "checkpoint": {
      "completed": "Ponto de verificação: {{label}}"
    },
    "mission": {
      "completed": "Missão concluída: {{label}}"
    },
    "world": {
      "completed": "Mundo concluído: {{label}}"
    },
    "streak": {
      "milestone_one": "{{count}} dia seguido!",
      "milestone_other": "{{count}} dias seguidos!"
    },
    "stamp": {
      "earned": "Carimbo ganho: {{label}}"
    },
    "badge": {
      "earned": "Distintivo ganho: {{label}}"
    },
    "onboarding": {
      "completed": "Primeiros passos"
    },
    "journey": {
      "completed": "Percurso concluído!"
    },
    "event": {
      "addedFromPool": "Adicionado do pool de talentos",
      "adoptedByInvitation": "Percurso ligado a um convite de empresa",
      "arrived": "Chegado ao destino",
      "badgeEarned": "Distintivo ganho",
      "checkpointCompleted": "Ponto de verificação concluído",
      "checkupCompleted": "CheckUp concluído",
      "checkupStarted": "CheckUp iniciado",
      "companyTaskCompleted": "Tarefa da empresa concluída",
      "documentUploaded": "Documento carregado",
      "expiryRenewed": "Percurso alargada",
      "fundingChanged": "Financiamento alterado",
      "guideCompleted": "Guia concluído",
      "guideDiscarded": "Guia descartado",
      "guideRestarted": "Guia reiniciado",
      "guideRetaken": "Guia retomado",
      "guideStarted": "Guia iniciado",
      "interventionLogged": "Intervenção Care registada",
      "interventionResolved": "Intervenção Care resolvida",
      "interventionScheduled": "Intervenção Care agendada",
      "interventionUpdated": "Intervenção Care atualizada",
      "interviewRequested": "Entrevista solicitada",
      "invitationAccepted": "Convite aceito",
      "journeyArchived": "Percurso arquivado",
      "journeyCreated": "Percurso criada",
      "journeyLifecycle": "Estado do percurso alterado",
      "journeyRestored": "Percurso restaurada",
      "missionCompleted": "Missão concluída",
      "objectiveFeedbackSubmitted": "Feedback objetivo enviado",
      "pipelineStageChanged": "Fase do pipeline alterada",
      "pitchAnalyzed": "Análise de pitch",
      "protectiveActionLogged": "Ação protetora registada",
      "setPrimary": "Definir como percurso principal",
      "sponsorshipAccepted": "Patrocínio aceite",
      "sponsorshipCancelled": "Patrocínio cancelado",
      "sponsorshipDeclined": "Patrocínio recusado",
      "sponsorshipRefunded": "Patrocínio reembolsado",
      "sponsorshipStarted": "Patrocínio iniciado",
      "stampEarned": "Carimbo ganho",
      "talentArchived": "Talento arquivado",
      "talentSponsored": "Patrocínio ativado",
      "talentUnarchived": "Talento desarquivado",
      "teleportalTaskCompleted": "TelePortal tarefa concluída",
      "trackCompleted": "Rastreamento concluído",
      "vettingInviteEmailFailed": "Não foi possível enviar o e-mail do convite de avaliação",
      "visaApproved": "Visto aprovado",
      "worldCompleted": "Mundo concluído",
      "copilotInterviewCompleted": "Entrevista com o CoPilot concluída",
      "testResultsRecorded": "Resultados dos testes registados",
      "testitPassed": "Veredito TestIt: aprovado",
      "testitDeclined": "Veredito TestIt: recusado",
      "profileCompleted": "Perfil concluído",
      "documentValidated": "Documento validado",
      "relocationPlanCreated": "Plano de mudança criado",
      "relocationPlanUpdated": "Plano de mudança atualizado",
      "milestoneReached": "Marco alcançado",
      "interventionDue": "Ação de cuidado agendada a decorrer",
      "taskReopened": "Tarefa de mudança reaberta",
      "relationshipMoved": "Passou para um percurso próprio",
      "programmeLeft": "Saiu do programa",
      "shareRequested": "Pediu para ver mais",
      "shareRequestAccepted": "Partilhou o que foi pedido",
      "shareRequestDeclined": "Recusou o pedido para ver mais",
      "vettingReminded": "Lembrado do que falta fazer",
      "testitCompleted": "Concluiu os testes que foram pedidos"
    },
    "externalLevel": {
      "reached": "{{world}}: nível {{band}} alcançado"
    },
    "pipeline": {
      "transition": "Pipeline: {{from}} → {{to}}"
    },
    "business": {
      "intervention": "Intervenção: {{label}}",
      "feedbackRoutineCreated": "Rotina de feedback \"{{name}}\" criada",
      "feedbackRoutineStarted": "Rotina de feedback iniciada",
      "feedbackRoutineCompleted": "Rotina de feedback concluída",
      "feedbackRoutinePaused": "Rotina de feedback pausada",
      "protectiveAction": "Ação protetora — {{label}}",
      "interventionLogged": "Intervenção — {{label}}",
      "documentUploaded": "Documento carregado — {{label}}",
      "taskReminderSent": "Lembrete enviado — {{label}}",
      "interventionScheduled": "{{label}} agendado",
      "messageSent": "Enviado \"{{name}}\" via {{channel}}",
      "messageSentNoName": "Mensagem enviada via {{channel}}",
      "messageNotDelivered": "\"{{name}}\" via {{channel}} não foi entregue",
      "messageNotDeliveredNoName": "Mensagem via {{channel}} não foi entregue",
      "messageDispatched": "\"{{name}}\" via {{channel}} foi entregue para envio — resultado não registado",
      "messageDispatchedNoName": "Mensagem via {{channel}} foi entregue para envio — resultado não registado",
      "invitationCreated": "Convite criado",
      "invitationSent": "Convite enviado",
      "invitationReminded": "Lembrete do convite enviado",
      "invitationAccepted": "Convite aceite",
      "invitationRevoked": "Convite revogado",
      "invitationRevokedAccountDeleted": "Convite revogado — a pessoa eliminou a conta",
      "invitationExpired": "Convite expirado",
      "invitationDeclined": "Convite recusado"
    },
    "generic": "{{text}}",
    "objective": {
      "selfEvaluated": "Concluiu uma autoavaliação de objetivos"
    },
    "messageTemplate": {
      "account_email_changed": "Email de acesso alterado",
      "account_invitation_claim_code": "Código para reclamar o convite",
      "adaptation_nudge_missions": "Sugestão de missão de adaptação",
      "adaptation_streak_broken": "Lembrete de sequência de adaptação",
      "care_checkin_request": "Pedido de check-in Care",
      "care_checkpoint_overdue_reminder": "Lembrete de prazo excedido (talento)",
      "care_feedback_requested": "Pedido de feedback Care (para talento)",
      "care_intervention_due": "Intervenção Care devida (interna)",
      "care_objective_feedback_cycle_open": "Feedback objetivo — ronda aberta (talento)",
      "care_objective_feedback_due": "Feedback objetivo — devido (fornecedor)",
      "care_objective_feedback_received": "Feedback objetivo — recebido (talento)",
      "coaching_message": "Mensagem de coaching",
      "cohort_welcome": "Boas-vindas ao grupo",
      "company_nudge_digest": "Ação necessária — resumo semanal da empresa",
      "evidence_celebrate_badge": "Celebração de crachá",
      "evidence_request": "Pedido de evidência / documento",
      "integration_mission_assigned": "Missão QultureUp atribuída",
      "interview_first_requested": "Pedido de entrevista-primeiro",
      "mobility_task_assigned": "Tarefa de mobilidade atribuída",
      "mobility_task_pending": "Lembrete de tarefa de mobilidade",
      "program_enrollment": "Boas-vindas à inscrição no programa",
      "services_request_received": "Pedido de serviços Tonnie recebido (interna)",
      "sponsorship_activate": "Ativação de patrocínio — a aguardar a aceitação do talento",
      "sponsorship_invite": "Convite de patrocínio (lançamento do percurso)",
      "sponsorship_offer_reminder": "Lembrete de oferta de patrocínio (sem resposta)",
      "sponsorship_talent_accepted": "Patrocínio — talento aceito (notificação administrativa)",
      "sponsorship_talent_declined": "Patrocínio — talento recusado (notificação administrativa + reembolso)",
      "sponsorship_welcome": "Boas-vindas ao patrocínio",
      "talent_invite": "Convite de integração de talento",
      "team_invite": "Convite para membro da equipa",
      "team_invite_reminder": "Lembrete de convite para a equipa",
      "vetting_complete_checkup": "Lembrete de progresso CheckUp",
      "vetting_invite": "Convide o candidato para CheckUp",
      "vetting_invite_reminder": "Lembrete de convite (sem resposta)",
      "vetting_invite_testit": "Convide o candidato para testes específicos (TestIt)",
      "vetting_reminder": "Lembrete CheckUp",
      "talent_checkup_link": "Link do CheckUp para o computador",
      "coaching_encourage": "Coaching — incentivo",
      "coaching_challenge": "Coaching — desafio semanal",
      "coaching_checkin": "Coaching — ponto de situação",
      "coaching_celebrate": "Coaching — celebração",
      "coaching_remind": "Coaching — lembrete",
      "talent_programme_left": "Talento saiu do programa (notificação administrativa)",
      "vetting_share_request": "Pedido para ver o CheckUp (relação existente)",
      "vetting_share_request_testit": "Pedido para ver resultados de testes (relação existente)",
      "vetting_testit_reminder": "Lembrete do TestIt",
      "talent_share_request_declined": "O talento recusou um pedido (notificação ao administrador)",
      "talent_testit_completed": "O talento concluiu os testes que pediu (notificação ao administrador)",
      "fiscal_document_issued": "Fatura-recibo emitida",
      "fiscal_document_issued_company": "Fatura-recibo emitida à empresa",
      "inout_notice_lead_time": "InOut: limite de residência a aproximar-se",
      "inout_notice_confirmation": "InOut: confirmação de presença",
      "inout_notice_renewal_window": "InOut: janela de renovação aberta",
      "inout_agency_contact_request": "InOut: pedido de contacto à assessoria",
      "inout_agency_refund_request": "InOut: pedido de devolução à assessoria",
      "inout_refund_request_tonnie": "InOut: pedido de devolução à Tonnie",
      "inout_agency_dossier": "InOut: dossiê para a assessoria",
      "qultureup_academy_mission_completed": "Languages Academy: missão concluída",
      "qultureup_academy_level_reached": "Languages Academy: nível alcançado",
      "qultureup_academy_goal_reached": "Languages Academy: meta alcançada",
      "qultureup_academy_inactive": "Languages Academy: hora de uma aula"
    },
    "guide": {
      "started": "Guia {{flow}} iniciado",
      "completed": "Guia {{flow}} concluído",
      "discarded": "Guia {{flow}} descartado",
      "restarted": "Guia {{flow}} reiniciado",
      "retaken": "Guia {{flow}} refeito"
    },
    "milestone": {
      "reached": "Marco alcançado: {{label}}"
    },
    "inout": {
      "started": "InOut iniciado",
      "tripRecorded_one": "Viagem registada — {{count}} dia fora",
      "tripRecorded_other": "Viagem registada — {{count}} dias fora",
      "tripPlanned_one": "Viagem planeada — {{count}} dia",
      "tripPlanned_other": "Viagem planeada — {{count}} dias"
    }
  },
  "catalog": {
    "stamps": {
      "first_step": {
        "name": "Primeiro Passo",
        "description": "Complete o seu onboarding e comece o seu percurso"
      },
      "first_checkup": {
        "name": "Primeiro CheckUp",
        "description": "Complete a sua primeira avaliação CheckUp"
      },
      "iqulture_pro": {
        "name": "iQulture PRO",
        "description": "Alcance o status iQulture PRO (pontuação 70+)"
      },
      "visa_approved": {
        "name": "Visto Aprovado",
        "description": "O seu visto ou autorização de residência foi aprovado"
      },
      "arrived": {
        "name": "Chegado ao Destino",
        "description": "Chegou ao seu país de destino"
      },
      "housing_secured": {
        "name": "Lar, Doce Lar",
        "description": "Garantiu habitação no seu destino"
      },
      "first_mission": {
        "name": "Primeira Missão",
        "description": "Complete a sua primeira missão de aprendizagem QultureUp"
      },
      "world_explorer": {
        "name": "Explorador de Mundos",
        "description": "Complete o seu primeiro mundo QultureUp (todas as pistas)"
      },
      "streak_7": {
        "name": "Sequência de 7 Dias",
        "description": "Complete QultureUp atividades 7 dias seguidos"
      },
      "streak_30": {
        "name": "30 Dias Seguidos",
        "description": "Complete QultureUp atividades 30 dias seguidos"
      },
      "first_checkpoint": {
        "name": "Primeiro Ponto de Verificação",
        "description": "Complete o seu primeiro ponto de verificação de bem-estar Care"
      },
      "care_champion": {
        "name": "Care Campeão",
        "description": "Complete todos os 4 pontos de verificação Care agendados"
      },
      "all_heroes": {
        "name": "Percurso Completo",
        "description": "Ativou todos os 5 heróis no seu percurso"
      },
      "adaptation_master": {
        "name": "Mestre da Adaptação",
        "description": "Dominou a adaptação cultural em múltiplos mundos"
      },
      "journey_complete": {
        "name": "Percurso Completo",
        "description": "Concluiu com sucesso toda o seu percurso de integração"
      },
      "inout_started": {
        "name": "InOut iniciado",
        "description": "Comece a manter o seu registo de residência no InOut"
      },
      "inout_first_trip": {
        "name": "Primeira viagem registada",
        "description": "Registe uma viagem fora do país de acolhimento"
      },
      "inout_trip_planned": {
        "name": "Planeado com antecedência",
        "description": "Planeie uma viagem no InOut antes de sair"
      }
    },
    "badges": {
      "legal_expert": {
        "name": "Especialista Legal",
        "description": "Dominou a vertente legal e os direitos cívicos"
      },
      "culture_citizen": {
        "name": "Cultura Citizen",
        "description": "Concluiu todos os mundos culturais a nível Avançado"
      },
      "workplace_master": {
        "name": "Mestre do Local de Trabalho",
        "description": "Adaptação ao local de trabalho e domínio da língua concluídos"
      },
      "fully_adapted": {
        "name": "Totalmente Adaptado Citizen",
        "description": "Integração completa — todas os percursos terminadas"
      },
      "cultural_ambassador": {
        "name": "Embaixador Cultural",
        "description": "Adaptação cultural excecional — status de embaixador"
      }
    }
  },
  "about": {
    "aiModel": "Modelo de IA",
    "appName": "Tonnie Citizen",
    "appVersion": "Versão da app",
    "brainService": "Serviço do cérebro",
    "build": "Construir",
    "copyright": "© {{year}} Tonnie. Todos os direitos reservados.",
    "description": "Tonnie é uma plataforma global de mobilidade de talentos que reduz o fracasso na relocação e acelera a integração estável. Combinamos orientação impulsionada por IA com cuidado humano para apoiar cada passo do seu percurso.",
    "environment": "Ambiente",
    "expoSdk": "Expo SDK",
    "fetchingVersions": "A obter informações da versão...",
    "platform": "Plataforma",
    "platformApi": "API da plataforma",
    "systemInfo": "Informação do sistema",
    "title": "Sobre a Tonnie",
    "version": "Versão {{version}}"
  },
  "accessControl": {
    "accessDenied": "Acesso negado",
    "accessFeatureInCitizenApp": "Aceda a {{feature}} através da aplicação móvel Citizen.",
    "buildJourney": "Construir percurso",
    "enableFamilyProgram": "Ative o Programa Familiar na faturação para aceder a esta funcionalidade.",
    "familyMasterOnly": "Esta funcionalidade está disponível apenas para Family Masters.",
    "familyProgramRequired": "Programa familiar necessário",
    "featureInCitizenApp": "Esta funcionalidade está disponível através da aplicação móvel Citizen.",
    "featureLocked": "Funcionalidade bloqueada",
    "goToBilling": "Ir para faturação",
    "heroNotEnabled": "Herói não ativado",
    "heroNotEnabledDescription": "Este herói não está ativado no seu plano atual. Atualize ou mude de percurso para desbloqueá-lo.",
    "journeyRequired": "Percurso necessária",
    "locked": "Bloqueado",
    "needJourneyToAccess": "Precisa de criar um percurso para aceder a esta funcionalidade.",
    "noPermission": "Não tem permissão para aceder a esta funcionalidade.",
    "openCitizen": "Abrir Citizen",
    "switchJourney": "Mudar percurso",
    "talentOrFamilyMasterOnly": "Esta funcionalidade está disponível apenas para Talentos e Family Masters.",
    "upgrade": "Atualizar",
    "useCitizenMobileApp": "Usar a aplicação móvel Citizen"
  },
  "accessScenario": {
    "badges": {
      "companySponsored": "Patrocinado pela empresa",
      "familyMember": "Membro da família",
      "free": "Modo Gratuito",
      "governmentSponsored": "Patrocinado pelo governo"
    },
    "companySponsored": {
      "description": "Talento com percurso patrocinado pela empresa. Acesso total ao nível Pro, sem pagamento necessário.",
      "label": "Patrocinado pela empresa"
    },
    "familyMember": {
      "description": "Membro da família com o mesmo acesso que o Modo Gratuito. O percurso é desbloqueado através do Programa Familiar.",
      "label": "Membro da família"
    },
    "free": {
      "description": "Assinatura gratuita com acesso limitado. Atualize via Faturação para desbloquear Pro, Família ou mais Percursos.",
      "label": "Modo Gratuito"
    },
    "governmentSponsored": {
      "description": "Talento com percurso patrocinado pelo governo. Acesso total ao nível Pro, sem pagamento necessário.",
      "label": "Patrocinado pelo governo"
    },
    "info": {
      "description": "Os cenários de acesso ajudam-no a testar diferentes combinações de modos de assinatura, patrocínio de percurso e papéis de utilizador. O cenário selecionado determina quais funcionalidades pode aceder no mockup. Em produção, o seu acesso é determinado pela sua assinatura real e instâncias de percurso.",
      "title": "Sobre cenários de acesso"
    },
    "loading": "A carregar...",
    "matrix": {
      "allowed": "Acesso completo",
      "billingDescription": "Gestão de plano e faturação",
      "careDescription": "Pontos de verificação e suporte pós-chegada",
      "careNotAllowed": "Sem acesso ao Care no Modo Livre",
      "careerDescription": "Oportunidades de emprego e ferramentas de carreira",
      "checkupDescription": "Avaliação de prontidão pré-imigração",
      "citizenMobile": "Citizen móvel",
      "cvBuilder": "Construtor de CV",
      "cvBuilderDescription": "Gerador de CV e templates ao estilo da UE",
      "description": "Compare o acesso às funcionalidades em todos os cenários. Selecione um cenário para continuar.",
      "familyProgramDescription": "Gestão e convites do programa familiar",
      "familyProgramViaBilling": "Disponível via faturação. Compre o adicional familiar (€4.99/mês) para ativar.",
      "features": "Funcionalidades",
      "homeDescription": "Painel e visão geral do percurso",
      "journeyBuilder": "Construtor de percurso",
      "journeyBuilderDescription": "Configure e construa o seu percurso personalizado",
      "journeyBuilderViaBilling": "Disponível após a compra de um percurso via Faturação",
      "legend": {
        "allowed": "Acesso completo",
        "citizenMobile": "Disponível através da aplicação móvel Citizen",
        "limited": "Acesso limitado",
        "notAllowed": "Não disponível",
        "readOnly": "Apenas leitura (membro da família)",
        "viaBilling": "Disponível via faturação/Aprimoramento"
      },
      "limited": "Acesso limitado",
      "notAllowed": "Não disponível",
      "passportDescription": "Linha do tempo do percurso e conquistas",
      "passportLimited": "Ver apenas eventos/log, sem funcionalidades avançadas",
      "profileDescription": "Definições e preferências do perfil",
      "qultureupDescription": "Integração cultural e aprendizagem",
      "qultureupLimited": "Missões básicas apenas, conteúdo limitado",
      "readOnly": "Apenas leitura",
      "selected": "Selecionado",
      "teleportalDescription": "Tarefas de realocação e mobilidade",
      "teleportalLimited": "Apenas lista de verificação, sem carregamento de documentos, sem revisão de IA",
      "title": "Matriz de acesso a funcionalidades",
      "viaBilling": "Via faturação"
    },
    "select": "Selecionar cenário",
    "subtitle": "Escolha um cenário para testar diferentes níveis de acesso. Pode atualizar para Pro, adicionar Família ou comprar mais Percursos via Faturação.",
    "title": "Selecionar cenário de acesso"
  },
  "address": {
    "city": "Cidade",
    "country": "País",
    "detailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
    "search": "Pesquisar endereço",
    "searchDescription": "Comece a escrever para pesquisar um endereço",
    "searchError": "Falha ao pesquisar endereços. Por favor, tente novamente.",
    "searchPlaceholder": "Comece a escrever um endereço...",
    "typeMinChars": "Escreva pelo menos 3 caracteres para pesquisar",
    "citySearch": {
      "suggestions": "Sugestões de cidades",
      "noResults": "Nenhuma cidade encontrada — pode manter o que escreveu.",
      "unavailable": "As sugestões não estão disponíveis de momento — pode manter o que escreveu."
    }
  },
  "admin": {
    "carePillars": {
      "saveSuccess": "Configuração de pilares guardada!"
    }
  },
  "alt": {
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "copilot": "CoPilot",
    "dialogGraphic": "Gráfico de diálogo",
    "logo": "Logotipo",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "tonnieLogo": "Logótipo da Tonnie"
  },
  "assessment": {
    "analyzing": "A analisar o seu nível de conhecimento...",
    "answerPlaceholder": "Escreva a sua resposta aqui...",
    "duration": "Leva cerca de 5-10 minutos",
    "evaluating": "A avaliar as suas respostas",
    "finish": "Terminar",
    "saveFailed": "Não foi possível guardar as suas respostas. Tente novamente.",
    "getRecommendations": "Obtenha o seu nível e recomendações",
    "loadingAssessment": "A carregar avaliação...",
    "next": "Próximo",
    "personalizedResults": "Resultados personalizados",
    "previous": "Anterior",
    "questionOf": "Pergunta {{current}} de {{total}}",
    "quickAssessment": "Avaliação rápida",
    "skipAhead": "Ignorar à frente",
    "skipKnownContent": "Ignorar conteúdo que já conheces",
    "startAssessment": "Iniciar avaliação",
    "startFailed": "Não conseguimos carregar as perguntas. Verifique a sua ligação e tente novamente.",
    "startFromBeginning": "Começar do início",
    "subtitle": "Deixe-nos avaliar o seu nível atual de conhecimento cultural",
    "title": "Avaliação de conhecimento",
    "viewRecommendedPath": "Ver caminho recomendado",
    "placement": {
      "beginner": "Está a começar — o seu percurso começa pelos fundamentos da cultura.",
      "intermediate": "Já conhece o essencial — o seu percurso parte do que já sabe.",
      "advanced": "Conhece bem a cultura — o seu percurso vai mais a fundo."
    }
  },
  "assessmentChat": {
    "clickToStartRecording": "Clique para começar a gravar",
    "clickToUpload": "Clique para carregar o CV",
    "fileFormats": "PDF, DOC, DOCX",
    "notAtAll": "De todo",
    "recordAgain": "Gravar novamente",
    "recordPitch": "Grave a sua apresentação",
    "recordPitchDesc": "Grave uma apresentação de 60 segundos sobre si mesmo e os seus objetivos",
    "recordVideoDesc": "Grave um vídeo curto a apresentar-se (máx. 30 segundos)",
    "recording": "A gravar...",
    "recordingPitch": "A gravar... (máx. 60 segundos)",
    "startRecording": "Começar a gravar",
    "stopRecording": "Parar gravação",
    "typeAnswer": "Escreva a sua resposta...",
    "typeMessage": "Escreva a sua mensagem...",
    "veryMuch": "Muito"
  },
  "auth": {
    "alreadySignedIn": {
      "continueToDashboard": "Continuar para o painel",
      "description": "Está autenticado como {{email}}. Continue o seu percurso ou saia para usar uma conta diferente.",
      "descriptionBusiness": "Está autenticado como {{email}}. Continue para o painel de Negócios, ou saia para usar uma conta diferente.",
      "signingOut": "A sair…",
      "switchAccount": "Sair e usar uma conta diferente",
      "title": "Já está autenticado"
    },
    "backToLogin": "Voltar ao início de sessão",
    "biometricSignIn": "Iniciar sessão com biometria",
    "checkEmail": "Verifique o seu E-mail",
    "confirmPassword": "Confirmar palavra-passe",
    "createNewPassword": "Criar nova palavra-passe",
    "createStrongPassword": "Crie uma palavra-passe forte para a sua conta",
    "email": "Email",
    "enterEmailToReset": "Insira o seu email para redefinir a sua palavra-passe",
    "enterNewPassword": "Insira a sua nova palavra-passe abaixo",
    "errors": {
      "invalidCredentials": "Email ou palavra-passe inválidos. Por favor, tente novamente.",
      "invalidVerificationCode": "Código de verificação inválido. Por favor, tente novamente.",
      "resetFailed": "Falha ao redefinir a palavra-passe. Por favor, tente novamente ou solicite um novo link de redefinição.",
      "twoFactorRequiredOnReset": "A autenticação de dois fatores é necessária. Por favor, inicie sessão normalmente e redefina a sua palavra-passe nas Definições.",
      "unableToCreate": "Não foi possível criar a conta. Por favor, tente novamente.",
      "unableToProcess": "Não foi possível processar o seu pedido. Por favor, tente novamente mais tarde.",
      "unableToResend": "Não foi possível reenviar o código. Por favor, tente novamente."
    },
    "forgotPassword": "Esqueceu a palavra-passe?",
    "forgotPasswordTitle": "Esqueceu a palavra‑passe?",
    "goToLogin": "Ir para início de sessão",
    "hidePassword": "Ocultar palavra-passe",
    "newPassword": "Nova palavra-passe",
    "oauthError": "A autenticação OAuth não pôde ser concluída. Por favor, tente novamente.",
    "oauthFailed": "Falha ao iniciar sessão",
    "oauthRedirecting": "A redirecioná-lo agora...",
    "oauthSuccess": "Início de sessão bem-sucedido!",
    "oauthVerifying": "Por favor, aguarde enquanto verificamos a sua conta",
    "password": "Palavra-passe",
    "passwordResetSuccess": "Palavra-passe redefinida com sucesso!",
    "passwordResetSuccessDesc": "A sua palavra-passe foi redefinida com sucesso",
    "passwordResetSuccessTitle": "Redefinição de palavra‑passe bem‑sucedida",
    "resendEmail": "Reenviar email",
    "resetCode": "Redefinir código",
    "resetLinkInstructions": "Clique no link no email para redefinir a sua palavra-passe. O link expirará em 1 hora.",
    "resetLinkSent": "Link de redefinição de palavra-passe enviado para o seu email!",
    "resetLinkSentTo": "Enviámos um link de redefinição de palavra-passe para {{email}}",
    "resetPassword": "Redefinir palavra-passe",
    "returnToLogin": "Voltar ao início de sessão",
    "sendResetCode": "Enviar código de redefinição",
    "sendResetLink": "Enviar link de redefinição",
    "sessionExpiring": "Sessão a expirar",
    "sessionExpiringDesc": "Esteve inativo. A sua sessão será terminada dentro de {{seconds}} segundos.",
    "showPassword": "Mostrar palavra-passe",
    "signIn": "Iniciar sessão",
    "signOut": "Sair",
    "staySignedIn": "Manter sessão iniciada",
    "validation": {
      "passwordsMatch": "As palavras-passe coincidem"
    },
    "providerErrors": {
      "emailTaken": "Já existe uma conta com este email. Inicie sessão.",
      "accountNotFound": "Não encontrámos nenhuma conta com este email.",
      "passwordIncorrect": "A palavra-passe está incorreta. Tente novamente ou reponha-a.",
      "credentialsIncorrect": "O email ou a palavra-passe estão incorretos.",
      "passwordBreached": "Esta palavra-passe apareceu numa fuga de dados. Escolha outra, por favor.",
      "passwordTooShort": "A palavra-passe deve ter pelo menos {{passwordMinLength}} caracteres.",
      "passwordTooWeak": "Esta palavra-passe é demasiado fraca. Escolha uma mais forte, por favor.",
      "passwordUnchanged": "A nova palavra-passe tem de ser diferente da atual.",
      "codeIncorrect": "Esse código não está correto. Verifique o email e tente novamente.",
      "codeExpired": "Esse código expirou. Peça um novo.",
      "codeAttemptsExhausted": "Demasiados códigos errados. Peça um novo.",
      "emailInvalid": "Introduza um endereço de email válido.",
      "emailNotAllowed": "Este endereço de email não pode ser usado aqui.",
      "tooManyAttempts": "Demasiadas tentativas. Aguarde alguns minutos e tente novamente.",
      "accountLocked": "A sua conta está bloqueada temporariamente após demasiadas tentativas. Tente novamente mais tarde.",
      "alreadySignedIn": "Já tem sessão iniciada.",
      "botCheckFailed": "Não foi possível verificar este pedido. Atualize a página e tente novamente.",
      "passwordNotSet": "Esta conta não usa palavra-passe. Inicie sessão da forma como a criou.",
      "accountUnavailable": "Esta conta não pode ser usada. Contacte o suporte, por favor.",
      "networkUnreachable": "Não foi possível contactar o servidor. Verifique a sua ligação e tente novamente.",
      "passwordTooLong": "Esta palavra-passe é demasiado longa. Escolha uma mais curta, por favor.",
      "reverificationRequired": "Por segurança, termine sessão e volte a iniciá-la; depois tente novamente.",
      "socialCancelled": "O início de sessão foi cancelado. Pode tentar novamente ou usar o seu email.",
      "socialAccountInUse": "Essa conta já está ligada a outra conta Tonnie. Inicie sessão nessa conta ou escolha outra opção."
    },
    "passwordRule": {
      "length": "Pelo menos {{passwordMinLength}} caracteres",
      "advice": "Algumas palavras juntas formam uma palavra-passe forte e fácil de lembrar.",
      "levels": {
        "weak": "Fraca",
        "fair": "Razoável",
        "good": "Boa",
        "strong": "Forte"
      }
    },
    "passwordCard": {
      "signOutOthers": "Terminar sessão nos outros dispositivos",
      "signOutOthersHint": "Quem tiver sessão iniciada na sua conta noutro lado vai precisar da nova palavra-passe."
    },
    "social": {
      "continueWith": "Continuar com {{provider}}",
      "failed": "Não conseguimos iniciar sessão com {{provider}}. Tente novamente ou use o seu email.",
      "failedGeneric": "Não conseguimos concluir o início de sessão. Tente novamente ou use o seu email.",
      "signingIn": "A iniciar sessão…",
      "signingInDesc": "Um momento enquanto concluímos o início de sessão.",
      "returnFailed": "Não conseguimos concluir o início de sessão",
      "returnFailedDesc": "O regresso da página de início de sessão demorou demasiado. Tente novamente."
    },
    "signUpContinue": {
      "unsupported": "Não conseguimos concluir a criação da sua conta",
      "unsupportedDesc": "Esse início de sessão precisa de algo que não pedimos. Comece de novo ou registe-se com o seu email.",
      "startAgain": "Começar de novo"
    },
    "connected": {
      "connect": "Ligar {{provider}}",
      "disconnect": "Desligar",
      "disconnectTitle": "Desligar {{provider}}?",
      "disconnectDesc": "Deixará de poder iniciar sessão com {{provider}}. Pode continuar a iniciar sessão com o seu email.",
      "connected": "{{provider}} está ligado. Já pode iniciar sessão com ele.",
      "disconnected": "{{provider}} foi desligado.",
      "failed": "Não conseguimos ligar {{provider}}. Tente novamente.",
      "disconnectFailed": "Não conseguimos desligar {{provider}}. Tente novamente."
    },
    "brand": {
      "name": "Tonnie",
      "copyright": "© {{year}} Tonnie",
      "citizen": {
        "signInHeadline": "A sua mudança para o estrangeiro, guiada passo a passo.",
        "signInSubline": "Um só lugar para o seu percurso de relocalização — do primeiro CheckUp até se sentir em casa.",
        "signUpHeadline": "Comece a sua mudança com um plano.",
        "signUpSubline": "Crie a sua conta e a Tonnie guia cada passo — antes de partir, no dia e quando chegar.",
        "checkup": "Saiba onde está antes de se mudar",
        "teleportal": "Todas as tarefas da mudança, por ordem",
        "qultureup": "Conheça a cultura antes de chegar",
        "care": "Apoio depois de chegar",
        "passport": "Cada marco do seu percurso, carimbado"
      },
      "business": {
        "signInHeadline": "Relocalize o seu talento com confiança.",
        "signInSubline": "Convide, patrocine e acompanhe a mudança de cada contratação — num só lugar.",
        "signUpHeadline": "Reúna num só lugar as relocalizações da sua equipa.",
        "signUpSubline": "Crie a conta da sua empresa e convide as pessoas que está a relocalizar quando quiser.",
        "vetting": "Veja quem está pronto para se mudar",
        "mobility": "Todas as tarefas da relocalização, por ordem",
        "adaptation": "Ajude quem chega a instalar-se",
        "care": "Apoio depois da chegada"
      }
    },
    "flow": {
      "back": "Voltar",
      "continue": "Continuar",
      "orWithEmail": "ou com o seu email",
      "or": "ou",
      "emailLabel": "Email",
      "emailPlaceholder": "nome@exemplo.com",
      "change": "Alterar",
      "signIn": {
        "title": "Bem-vindo de novo",
        "descriptionCitizen": "Inicie sessão para continuar o seu percurso.",
        "descriptionBusiness": "Inicie sessão no espaço de trabalho da sua empresa.",
        "newHere": "Novo na Tonnie?",
        "createAccount": "Criar uma conta",
        "noAccount": "Não existe nenhuma conta Tonnie com este email."
      },
      "password": {
        "title": "Introduza a sua palavra‑passe",
        "label": "Palavra-passe",
        "forgot": "Esqueceu-se da palavra-passe?",
        "submit": "Iniciar sessão",
        "codeInstead": "Entrar com um código por email"
      },
      "code": {
        "title": "Verifique o seu email",
        "description": "Enviámos um código de 6 dígitos para {{email}}.",
        "newDevice": "Este dispositivo é novo para nós. Enviámos um código de 6 dígitos para {{email}} para confirmar a sua identidade.",
        "label": "Código de 6 dígitos",
        "submit": "Iniciar sessão",
        "resend": "Enviar um novo código",
        "resendIn": "Pode enviar um novo código daqui a {{seconds}} s."
      },
      "totp": {
        "title": "Introduza o código do autenticador",
        "description": "Abra a sua aplicação de autenticação e introduza o código de 6 dígitos da Tonnie.",
        "label": "Código do autenticador"
      },
      "signUp": {
        "title": "Crie a sua conta",
        "description": "Use uma conta que já tem, ou o seu email.",
        "haveAccount": "Já tem uma conta?",
        "signIn": "Iniciar sessão",
        "emailTaken": "Já existe uma conta com este email.",
        "signInInstead": "Iniciar sessão",
        "legal": "Ao continuar, aceita os termos da Tonnie.",
        "terms": "Termos de serviço",
        "privacy": "Política de privacidade",
        "step": "Passo {{current}} de {{total}}",
        "detailsTitle": "Fale-nos de si",
        "firstName": "Nome próprio",
        "lastName": "Apelido",
        "passwordLabel": "Crie uma palavra-passe",
        "submit": "Criar conta",
        "codeNext": "A seguir, enviamos-lhe um código por email para confirmar o endereço.",
        "codeTitle": "Confirme o seu email",
        "codeSubmit": "Confirmar"
      },
      "invitation": {
        "signIn": "Este convite foi enviado para {{email}}. Inicie sessão com esse endereço para o aceitar.",
        "signUp": "Este convite foi enviado para {{email}}. Crie a sua conta com esse endereço para o aceitar."
      }
    },
    "security": {
      "methods": {
        "title": "Métodos de acesso",
        "description": "Todas as formas de entrar na sua conta Tonnie, num só lugar."
      },
      "email": {
        "label": "Email",
        "badge": "Acesso e mensagens",
        "change": "Alterar"
      },
      "password": {
        "label": "Palavra-passe",
        "set": "Definida — use-a com o seu email para iniciar sessão.",
        "notSetWith": "Não definida — inicia sessão com {{providers}} ou com um código enviado para o seu email.",
        "notSet": "Não definida — inicia sessão com um código enviado para o seu email.",
        "add": "Adicionar palavra-passe",
        "change": "Alterar"
      },
      "connected": {
        "heading": "Contas ligadas",
        "connected": "Ligada",
        "notConnected": "Não ligada",
        "connect": "Ligar",
        "description": "Inicie sessão com uma conta que já tem."
      },
      "sessions": {
        "title": "Onde tem sessão iniciada",
        "description": "Termine a sessão em qualquer sítio que não reconheça.",
        "signOutOthers": "Terminar sessão nos outros dispositivos",
        "thisDevice": "Este dispositivo",
        "signOut": "Terminar sessão",
        "none": "Não há sessão iniciada noutros dispositivos."
      },
      "passwordDialog": {
        "changeTitle": "Alterar palavra‑passe",
        "addTitle": "Adicionar uma palavra‑passe",
        "description": "Vai usá-la da próxima vez que iniciar sessão com o seu email.",
        "current": "Palavra-passe atual",
        "new": "Nova palavra-passe",
        "confirm": "Confirmar nova palavra-passe",
        "submitChange": "Atualizar palavra-passe",
        "submitAdd": "Adicionar palavra-passe"
      },
      "emailDialog": {
        "step": "Passo {{current}} de {{total}}",
        "title": "Alterar o seu email",
        "description": "Vamos enviar um código para o novo endereço. Nada muda até o introduzir.",
        "current": "Atual",
        "new": "Novo email",
        "linkedNote": "O {{provider}} continua a iniciar a sua sessão. O endereço dele continua ligado e não é afetado por esta alteração.",
        "send": "Enviar código",
        "codeTitle": "Introduza o código",
        "codeDescription": "Enviámo-lo para {{email}}.",
        "codeLabel": "Código",
        "confirm": "Confirmar novo email",
        "resend": "Enviar um novo código",
        "doneTitle": "O seu email foi alterado",
        "close": "Concluído"
      }
    },
    "welcome": {
      "haveAccount": "Já tenho uma conta"
    },
    "stepUp": {
      "title": "Confirme a sua identidade",
      "description": "Por segurança, confirme a sua identidade antes desta alteração.",
      "password": "A sua palavra-passe",
      "continue": "Continuar",
      "useCode": "Receber antes um código por email",
      "confirm": "Confirmar",
      "failed": "Não foi possível confirmar a sua identidade. Tente novamente.",
      "unavailable": "Não foi possível confirmar a sua identidade aqui. Feche e tente mais tarde."
    }
  },
  "billing": {
    "availableJourneys": "Percursos disponíveis",
    "basicAccess": "Acesso básico",
    "cancel": "Cancelar",
    "cancelFailed": "Falha ao cancelar a subscrição. Por favor, tente novamente.",
    "cancelFamilyAddon": "Cancelar extra família",
    "cancelFamilyAddonError": "Falha ao cancelar o add-on familiar",
    "cancelFamilyDesc": "Os seus familiares perderão o acesso no fim do período de faturação atual.",
    "cancelMessage": "Tem certeza de que deseja cancelar a sua subscrição Pro? Manterá o acesso até ao final do seu período de faturação.",
    "cancelSubscriptionError": "Falha ao cancelar a subscrição",
    "cancelSuccess": "Subscrição cancelada. O acesso continua até ao fim do período.",
    "cancelTitle": "Cancelar subscrição",
    "checkoutError": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "checkoutFailed": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "commitmentNote": "Sem compromisso — cancele quando quiser.",
    "confirmCancellation": "Confirmar cancelamento",
    "contactSupport": "Contactar o suporte",
    "createFirstJourney": "Criar a sua primeiro percurso",
    "currentPlan": "Plano atual",
    "downgradeToFree": "Mudar para gratuito",
    "email": "Email",
    "emailPlaceholder": "membro@exemplo.com",
    "expired": "Expirado",
    "expires": "Expira",
    "expiringSoon": "A expirar em breve",
    "familyAddonError": "Falha ao comprar o complemento familiar. Por favor, tente novamente.",
    "familyCancelFailed": "Falha ao cancelar o complemento familiar. Por favor, tente novamente.",
    "familyCancelSuccess": "O seu extra família foi cancelado.",
    "familyDesc": "Leve a sua família consigo — acesso partilhado ao seu percurso de relocalização.",
    "familyMembersWithAccess": "Familiares com acesso",
    "familyProgram": "Programa família",
    "familyProgramAccess": "Acesso ao programa família",
    "familyPurchaseFailed": "Falha ao comprar o complemento familiar. Por favor, tente novamente.",
    "freeDescription": "Acesso limitado às funcionalidades da Tonnie",
    "freePlan": "Plano gratuito",
    "fullAccess": "Acesso completo",
    "invalidEmail": "Por favor, insira um endereço de email válido",
    "inviteDesc": "Envie um convite para que possam juntar-se ao seu percurso.",
    "inviteFailed": "Falha ao enviar o convite. Por favor, tente novamente.",
    "inviteFamilyMember": "Convidar um familiar",
    "inviteMember": "Enviar convite",
    "inviteSent": "Convite enviado para {{email}}",
    "journeyInstances": "Os seus percursos",
    "journeyUnlockedPro": "Este percurso está desbloqueado com o Pro.",
    "keepAddon": "Manter extra",
    "keepPro": "Manter o Pro",
    "locked": "Bloqueado",
    "manageHousehold": "Gerir o agregado familiar",
    "members": "Membros",
    "monthly": "Mensal",
    "monthlyPrice": "Preço mensal",
    "needHelp": "Precisa de ajuda?",
    "nextRenewal": "Próxima renovação",
    "noFamilyMembers": "Ainda sem familiares",
    "noJourneyInstances": "Ainda não tem percursos",
    "paymentAlreadyProcessed": "Pagamento já processado. O seu percurso está ativo!",
    "paymentCompleted": "Pagamento concluído! O seu percurso foi desbloqueado.",
    "paymentStillProcessing": "Pagamento ainda a processar. Por favor, aguarde um momento e atualize.",
    "paymentSuccessUnlocked": "Pagamento bem-sucedido! O seu percurso foi desbloqueado.",
    "paymentVerificationIssue": "Problema de verificação de pagamento. Por favor, contacte o suporte se o seu percurso não estiver desbloqueado.",
    "pending": "Pendente",
    "perMonth": "/mês",
    "perYear": "/ano",
    "pro": "Pro",
    "proDescription": "Percursos ilimitadas, todas as funcionalidades, suporte prioritário",
    "proFullAccessDesc": "Acesso total a todos os heróis, ferramentas e documentos do seu percurso.",
    "proPlan": "Plano Pro",
    "proUnlockDesc": "Desbloqueie o percurso completo com o Pro.",
    "proceedToPayment": "Continuar para o pagamento",
    "processing": "A processar",
    "purchaseFamilyAddon": "Adicionar o programa família",
    "purchased": "Comprado",
    "recentInvoices": "Faturas recentes",
    "recommended": "Recomendado",
    "renewFailed": "Falha ao renovar o percurso. Por favor, tente novamente.",
    "renewJourney": "Renovar percurso",
    "renewStripeDesc": "Será encaminhado para a Stripe para renovar a sua subscrição em segurança.",
    "revokeAccess": "Revogar acesso",
    "revokeConfirm": "Tem certeza de que deseja revogar o acesso deste membro?",
    "revokeFailed": "Falha ao revogar acesso. Por favor, tente novamente.",
    "revokeSuccess": "Acesso revogado com sucesso",
    "sendInvite": "Enviar convite",
    "sending": "A enviar",
    "statusActive": "Ativa",
    "stripeRedirectDesc": "Será encaminhado para a Stripe para concluir o pagamento em segurança.",
    "title": "Faturação",
    "unlockFailed": "Falha ao desbloquear o percurso. Por favor, tente novamente.",
    "unlockJourney": "Desbloquear percurso",
    "unlockNow": "Desbloquear agora",
    "unlocked": "Desbloqueado",
    "unlockedJourneys": "Percursos desbloqueadas",
    "upgradeToPro": "Atualizar para Pro",
    "verificationFailed": "Não foi possível verificar a sessão de checkout.",
    "verificationIssue": "Pagamento concluído, mas houve um problema na verificação. O seu acesso deverá ser atualizado em breve.",
    "verifyPaymentError": "Não foi possível verificar o pagamento. Por favor, atualize a página ou contacte o suporte.",
    "yearly": "Anual",
    "yearlyDiscount": "Poupe com faturação anual",
    "planChangesUnavailable": "Alterações de plano não estão disponíveis nesta aplicação.",
    "invoiceKind": {
      "journey_unlock": "Desbloqueio do percurso",
      "journey_renewal": "Renovação do percurso",
      "talent_sponsorship": "Patrocínio de talento",
      "pro_subscription": "Subscrição Pro",
      "enterprise_subscription": "Subscrição Enterprise",
      "family_addon": "Extra família",
      "subscription": "Subscrição",
      "inout_consultation": "Consulta InOut",
      "inout_requisition": "Requisição InOut"
    },
    "invoiceStatus": {
      "draft": "Rascunho",
      "open": "A aguardar pagamento",
      "paid": "Paga",
      "void": "Anulada",
      "uncollectible": "Pagamento falhado"
    },
    "planFeature": {
      "checkup_basic": "Acesso básico ao CheckUp",
      "career_basic": "Ferramentas de carreira básicas",
      "teleportal_limited": "Acesso limitado ao TelePortal",
      "qultureup_limited": "Acesso limitado ao QultureUp",
      "copilot_limited": "Utilização limitada do CoPilot",
      "passport_basic": "Acesso básico ao Passport",
      "journeys_unlimited": "Percursos ilimitadas",
      "checkup_full": "Acesso completo ao CheckUp",
      "teleportal_full": "Acesso completo ao TelePortal",
      "qultureup_full": "Acesso completo ao QultureUp",
      "copilot_unlimited": "Utilização ilimitada do CoPilot",
      "care_advanced": "Funcionalidades avançadas do Care",
      "passport_full": "Acesso completo ao Passport",
      "career_tools": "Ferramentas do Career",
      "journey_access_shared": "Acesso partilhado ao percurso",
      "family_dashboard": "Painel da família",
      "seats_unlimited": "Lugares ilimitados",
      "candidates_unlimited": "Candidatos ilimitados",
      "programs_unlimited": "Programas ilimitados",
      "cohorts_unlimited": "Coortes ilimitadas",
      "copilot_queries_unlimited": "Perguntas ao CoPilot ilimitadas",
      "analytics_basic": "Análises básicas",
      "analytics_advanced_api": "Análises avançadas e API",
      "mobility_adaptation_full": "Percursos completos de Mobilidade e Adaptação",
      "yearly_two_months_free": "2 meses grátis face ao plano mensal",
      "sponsorship_full_access": "Acesso completo ao percurso e à área do cidadão para o talento",
      "sponsorship_heroes": "CheckUp, TelePortal, QultureUp e Care",
      "sponsorship_passport": "Passport e conquistas",
      "family_access_optional": "Extra opcional de acesso para a família",
      "discount_vs_free": "{{count}}% de desconto face ao plano Grátis",
      "support_email": "Apoio por email",
      "support_priority": "Apoio prioritário",
      "family_members_up_to_one": "Até {{count}} membro da família",
      "family_members_up_to_other": "Até {{count}} membros da família",
      "seats_one": "{{count}} lugar (um utilizador)",
      "seats_other": "{{count}} lugares",
      "candidates_up_to_one": "Até {{count}} candidato",
      "candidates_up_to_other": "Até {{count}} candidatos",
      "programs_one": "{{count}} programa",
      "programs_other": "{{count}} programas",
      "cohorts_one": "{{count}} coorte",
      "cohorts_other": "{{count}} coortes",
      "copilot_queries_monthly_one": "{{count}} pergunta ao CoPilot por mês",
      "copilot_queries_monthly_other": "{{count}} perguntas ao CoPilot por mês",
      "access_window_months_one": "Acesso durante {{count}} mês",
      "access_window_months_other": "Acesso durante {{count}} meses"
    },
    "seeAllInvoices": "Ver todas",
    "profile": {
      "validation": {
        "legalNameRequired": "Indique o nome para a fatura.",
        "countryRequired": "Escolha o país de faturação.",
        "addressRequired": "Indique a morada de faturação.",
        "postalCodeRequired": "Indique o código postal.",
        "cityRequired": "Indique a localidade.",
        "taxIdInvalid": "Este número de contribuinte não é válido para o país escolhido.",
        "tooLong": "É demasiado longo.",
        "taxIdRequired": "Indique o número de contribuinte da empresa."
      },
      "title": "Dados de faturação",
      "description": "A quem são emitidas as suas faturas. Uma alteração aplica-se ao próximo pagamento.",
      "add": "Adicionar dados",
      "edit": "Editar",
      "empty": "Ainda sem dados de faturação. Serão pedidos antes do seu primeiro pagamento.",
      "legalName": "Nome na fatura",
      "taxId": "Número de contribuinte (NIF)",
      "taxIdHint": "Opcional. Indique-o se o quiser nas suas faturas.",
      "noTaxId": "Não indicado",
      "country": "País de faturação",
      "countryPlaceholder": "Escolha um país",
      "address": "Morada",
      "addressLine1": "Morada",
      "addressLine2": "Morada (continuação)",
      "postalCode": "Código postal",
      "city": "Localidade",
      "save": "Guardar",
      "saveAndContinue": "Guardar e continuar para o pagamento",
      "saveFailed": "Não foi possível guardar os dados de faturação. Tente de novo.",
      "beforePaymentTitle": "Dados para a sua fatura",
      "beforePaymentDescription": "Cada pagamento tem a sua fatura-recibo. Diga-nos a quem a emitir e seguimos para o pagamento."
    },
    "invoiceDocument": {
      "certified": "Ver fatura-recibo",
      "invoice": "Ver fatura",
      "receipt": "Ver recibo"
    },
    "statusPastDue": "Pagamento em atraso",
    "statusCancelled": "Cancelado",
    "statusExpired": "Expirado",
    "loadError": "Não foi possível carregar o seu plano."
  },
  "biometric": {
    "authenticating": "A autenticar...",
    "benefits": {
      "dataOnDevice": "Os seus dados permanecem no dispositivo",
      "fastLogin": "Início de sessão rápido com um toque",
      "secure": "Seguro e encriptado"
    },
    "enable": "Ativar {{name}}",
    "maybeLater": "Talvez mais tarde",
    "settingUp": "A configurar...",
    "touchSensorOrLook": "Toque no sensor ou olhe para o seu dispositivo para autenticar",
    "tryAgain": "Tente novamente",
    "use": "Usar {{name}}",
    "usePasswordInstead": "Usar palavra-passe em vez disso",
    "type": {
      "iris": "Leitura da íris",
      "generic": "Biométrico"
    },
    "usePasscode": "Usar código de acesso",
    "authenticatePrompt": "Autentique-se para continuar",
    "verifyToEnablePrompt": "Verifique para ativar o início de sessão biométrico",
    "error": {
      "initFailed": "Falha ao inicializar a autenticação biométrica",
      "notSupported": "Autenticação biométrica não suportada",
      "lockout": "Muitas tentativas falhadas. Por favor, tente novamente mais tarde.",
      "authFailed": "Autenticação falhada",
      "enableFailed": "Falha ao ativar a autenticação biométrica",
      "disableFailed": "Falha ao desativar a autenticação biométrica"
    }
  },
  "sponsorships": {
    "offer": {
      "fallbackCompany": "O seu patrocinador",
      "headline": "{{company}} gostaria de patrocinar o seu percurso",
      "subheadline": "Aceite para desbloquear a experiência Pro completa — sem custo para si.",
      "loading": "A carregar detalhes da oferta…",
      "unlocks": {
        "title": "O que o patrocínio inclui",
        "checkup": "Avaliação CheckUp completa",
        "teleportal": "Manual de relocação TelePortal",
        "qultureup": "Integração cultural QultureUp",
        "care": "Care para o percurso de imigração",
        "passport": "Passport — o seu registo portátil"
      },
      "route": "Rota: {{from}} → {{to}}",
      "declineNote": "Se recusar, a empresa é automaticamente reembolsada. Mantém o seu acesso de nível básico em qualquer caso.",
      "declineCta": "Recusar",
      "acceptCta": "Aceitar patrocínio",
      "decline": {
        "title": "Recusar este patrocínio?",
        "body": "{{company}} será reembolsada na totalidade. Ainda pode concluir o seu CheckUp no nível básico.",
        "reasonLabel": "Diga a {{company}} porquê (opcional)",
        "cancel": "Cancelar",
        "confirmCta": "Recusar de qualquer forma",
        "bodyKeepsAccess": "A {{company}} será reembolsada na totalidade. O seu percurso fica exatamente como está."
      },
      "accepted": {
        "toast": "Bem-vindo a bordo! O seu percurso está agora totalmente patrocinada."
      },
      "declined": {
        "toast": "Patrocínio recusado. {{company}} foi reembolsada."
      },
      "errors": {
        "load": "Não conseguimos carregar esta oferta de patrocínio.",
        "accept": "Não foi possível aceitar o patrocínio neste momento.",
        "decline": "Não foi possível recusar o patrocínio neste momento.",
        "notOpen": "Esta oferta já não está disponível — já foi respondida ou retirada."
      },
      "dedicatedNote": "A {{company}} vai patrocinar um novo percurso só seu nesta rota. O seu percurso atual fica como está, com as empresas que já o acompanham.",
      "takeover": {
        "subheadline": "A {{company}} passa a cobrir este percurso — sem custo para si.",
        "pro": {
          "title": "Já tem acesso completo com o Pro",
          "body": "A {{company}} assume este percurso. O seu Pro continua a cobrir as suas outros percursos, e esta volta ao seu Pro se o patrocínio for cancelado."
        },
        "paid": {
          "title": "Já pagou por este percurso",
          "refund": "A {{company}} assume-o, e reembolsamos {{amount}} — a parte não usada do desbloqueio do percurso — para o seu método de pagamento original. Os reembolsos chegam normalmente em 5 a 10 dias úteis.",
          "noRefund": "A {{company}} assume-o. Já não há nada a reembolsar do desbloqueio do percurso."
        },
        "declineNote": "Se recusar, a empresa é automaticamente reembolsada e o seu percurso fica exatamente como está."
      },
      "card": {
        "eyebrow": "Oferta de patrocínio",
        "detail": "O seu percurso para {{country}}",
        "detailDedicated": "Um novo percurso só seu para {{country}}",
        "review": "Ver oferta",
        "actionFailed": "Não foi possível concluir. Verifique a ligação e tente novamente."
      },
      "notNow": "Agora não",
      "deferredUntil": "Adiou esta oferta por agora. Fica aqui à espera até decidir e volta ao Início a {{date}}.",
      "list": {
        "title": "A {{company}} quer patrociná-lo",
        "kind": "Patrocínio",
        "sent": "Enviada a {{date}}"
      }
    }
  },
  "business": {
    "externalWorlds": {
      "course": "Curso: {{language}}",
      "line": "{{world}} · {{language}}",
      "status": {
        "never_synced": "Ainda sem progresso",
        "active": "Ativo",
        "stalled": "Parado",
        "paused": "Em pausa",
        "goal_reached": "Meta alcançada"
      },
      "hint": {
        "never_synced": "Ainda não chegou progresso de {{world}}.",
        "stalled": "Sem progresso há {{days}} dias.",
        "paused": "O cidadão retirou o consentimento para partilhar com {{world}}: o progresso deixou de chegar e é mostrado como estava.",
        "goal_reached": "Alcançou a meta do curso em {{date}}."
      },
      "bands": {
        "start": "Início",
        "current": "Atual",
        "goal": "Meta"
      },
      "bandProgress": "{{percent}} do caminho em {{band}}",
      "completion": "Percurso concluído",
      "noMissions": "Ainda sem missões",
      "progress": "Progresso global: {{percent}}",
      "paceLabel": "Ritmo",
      "pace_one": "{{count}} missão nos últimos 30 dias",
      "pace_other": "{{count}} missões nos últimos 30 dias",
      "lastActivityLabel": "Último progresso",
      "reduced": "Por agora, {{world}} envia apenas o nível atual, pelo que as percentagens são sobre esse nível.",
      "summaryOnly": "Apenas um resumo: as missões e os seus títulos ficam com o cidadão."
    },
    "activity": {
      "title": "Atividade",
      "subtitle": "Tudo o que está a acontecer nas suas competências",
      "empty": "Sem atividade ainda",
      "untitled": "Atividade"
    },
    "pipeline": {
      "stages": {
        "acquisition": "Aquisição",
        "vetting": "Verificação",
        "mobility": "Mobilidade",
        "integration": "Integração",
        "adaptation": "Adaptação",
        "care": "Care",
        "evidence": "Evidência",
        "sponsored": "Patrocinado",
        "pending_invite": "Convite pendente",
        "archived": "Arquivado",
        "cohort_assigned": "Coorte atribuída",
        "unknown": "Desconhecido"
      },
      "talentActions": "Ações de talento"
    },
    "about": {
      "aboutUs": "Sobre nós",
      "backToDashboard": "Voltar ao painel",
      "heroCare": "Gestão de pontos de verificação de Care e acompanhamento do bem-estar",
      "heroCheckup": "Resultados CheckUp, pontuações MESH e insights iQulture para verificação",
      "heroEvidence": "Evidência Passport/IRR e resultados do programa",
      "heroPrograms": "Gestão de programas e coortes",
      "heroQultureup": "Progresso de adaptação QultureUp através de Mundos, Pistas e Missões",
      "heroSponsored": "Alocações e faturação de percursos patrocinados",
      "heroTeleportal": "Progresso TelePortal nas pistas Legal, Viagem e Configuração",
      "heroes": "Heróis",
      "heroesDesc": "Conheça os heróis por detrás da Tonnie — a equipa dedicada a transformar a mobilidade global de talentos.",
      "learnMore": "Saiba mais sobre Tonnie Business",
      "platformOverview": "Visão geral da plataforma",
      "platformOverviewDesc": "A nossa plataforma ajuda as empresas a gerir todo o ciclo de vida da mobilidade de talentos — desde a procura e seleção até à realocação e cuidados contínuos.",
      "termsAndPrivacy": "Termos & privacidade",
      "title": "Sobre",
      "tonnieBusiness": "Tonnie Business",
      "tonnieBusinessDesc": "Tonnie Business é uma plataforma abrangente para gerir a mobilidade internacional de talentos, contratação e programas de integração.",
      "version": "Versão {{version}}"
    },
    "adaptationPage": {
      "active": "Ativo",
      "activeFilter": "Ativo",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "activelyLearning": "A aprender ativamente",
      "attentionReason": {
        "inactive": "Sem atividade há mais de 2 semanas",
        "declining": "Atividade em declínio",
        "not_begun": "Avaliação concluída — ainda sem missões",
        "streak_at_risk": "Sequência prestes a quebrar"
      },
      "levels": {
        "beginner": "Iniciante",
        "intermediate": "Intermédio",
        "advanced": "Avançado"
      },
      "clearFilters": "Limpar filtros",
      "coach": "Coaching",
      "errors": {
        "messageTooShort": "A mensagem deve ter pelo menos 5 caracteres",
        "messageTooLong": "A mensagem deve ter 500 caracteres ou menos"
      },
      "nudge": "Empurrão",
      "nudgeAria": "Envie um lembrete rápido para {{name}}",
      "sendCoachAria": "Enviar mensagem de coaching para {{name}}",
      "sendMessage": "Enviar mensagem",
      "streakAtRisk": "Sequência em risco",
      "talentRowActionsAria": "Ações para {{name}}",
      "tryAdjustFilters": "Tente ajustar a sua pesquisa ou filtros",
      "view": "Ver",
      "viewTalentAria": "Ver detalhes para {{name}}",
      "aiCoachDesc": "Coaching sugerido para cada talento, com base no progresso no QultureUp",
      "aiCoachRecommendations": "Recomendações do coach de IA",
      "alertDescription": "{{inactive}} talentos inativos, {{atRisk}} em risco, e {{streaks}} sequências em risco",
      "allCohorts": "Todas as coortes",
      "allEngagement": "Todo o envolvimento",
      "allTalents": "Todos os talentos",
      "atRiskExcl": "Em risco!",
      "atRiskFilter": "Em risco",
      "avgMiles": "Média de Miles",
      "avgQultureUpCompletion": "Média de conclusão QultureUp",
      "boostMotivation": "Aumentar motivação",
      "celebrateTopPerformers": "Celebrar melhores desempenhos",
      "coachAlert": "Alerta do treinador",
      "coachTip1": "Mensagens personalizadas geram 3x mais envolvimento do que as genéricas",
      "coachTip2": "Talentos que recebem check-ins semanais têm 40% mais probabilidade de completar o seu percurso",
      "coachTip3": "Celebrar pequenas vitórias aumenta a motivação e a retenção de sequências",
      "coachingCenter": "Centro de coaching",
      "coachingToolkit": "Kit de ferramentas de coaching",
      "coachingToolkitDesc": "Ferramentas de coaching personalizadas e modelos de mensagens",
      "description": "Acompanhe e gira o progresso de adaptação dos talentos, as métricas de envolvimento e os insights de coaching",
      "engagement": "Envolvimento",
      "engagementDistDesc": "Veja o envolvimento dos talentos nos diferentes níveis",
      "engagementDistribution": "Distribuição do envolvimento",
      "engagementLegendAria": "Como são calculadas as faixas de envolvimento",
      "engagementLegendTitle": "Como são calculadas as faixas",
      "engagementLegendDesc": "Cada talento é classificado com base na recência da sua atividade, na sua sequência diária e no número de missões que completou esta semana.",
      "quickActionsAllClear": "Tudo claro",
      "quickActionsAllClearDesc": "Não são necessárias ações de coaching neste momento.",
      "coachingQueueTitle": "Fila de coaching",
      "coachingQueueDesc": "Cada talento agrupado por envolvimento — os mais urgentes primeiro.",
      "coachAllCount": "Coache todos os {{count}}",
      "noCoachingTalents": "Nenhum talento em Adaptação ainda",
      "noCoachingTalentsDesc": "Os talentos aparecem aqui assim que começam o seu percurso QultureUp.",
      "engagementTrends": "Aprendizagem num relance",
      "engagementTrendsDesc": "Onde estão os seus talentos esta semana",
      "filterByCohort": "Filtrar por coorte",
      "gentleNudge": "Empurrão suave",
      "healthDashboard": "Painel de saúde",
      "healthScore": "Pontuação de saúde",
      "inactiveFilter": "Inativo",
      "insights": "Insights",
      "messageFailed": "Falha ao enviar mensagem",
      "messageSent": "Mensagem {{type}} enviada para {{name}}",
      "miles": "Miles",
      "missions": "Missões",
      "missionsThisWeek": "Missões esta semana",
      "motivateActiveLearners": "Motivar aprendizes ativos com novos desafios",
      "needAttention": "Necessita de atenção",
      "needsEncouragement": "Precisa de encorajamento",
      "noTalentsFound": "Nenhum talento encontrado",
      "notificationInApp": "O talento receberá uma notificação na app",
      "overallProgress": "Progresso geral",
      "quickCoachActions": "Ações rápidas de coaching",
      "quickCoachActionsDesc": "Ações com um clique para apoiar os seus talentos",
      "quickNudgeSent": "Empurrão rápido enviado para {{name}}",
      "reachInactiveTalents": "Alcançar talentos inativos",
      "recognizeAchievements": "Reconhecer conquistas",
      "saveStreaks": "Guardar sequências",
      "score": "Pontuação",
      "searchTalents": "Pesquisar talentos...",
      "sendPersonalizedMessage": "Escolha uma ação e depois adicione uma nota pessoal ou envie a mensagem da sua empresa.",
      "sendWeeklyChallenge": "Enviar desafio semanal",
      "setGoals": "Definir metas",
      "showYouCare": "Mostrar que se importa",
      "slowing": "A desacelerar",
      "slowingDownFilter": "A desacelerar",
      "streak": "Série",
      "thriving": "A prosperar",
      "thrivingFilter": "A prosperar",
      "title": "Adaptação",
      "topPerformers": "Melhores desempenhos",
      "topPerformersDesc": "Talentos com o maior envolvimento e progresso",
      "worlds": "Mundos",
      "writeYourMessage": "Escreva a sua mensagem",
      "engagementDescriptions": {
        "thriving": "Altamente envolvido, progresso consistente",
        "active": "Atividade regular, progresso constante",
        "slowing": "Atividade a diminuir, pode precisar de encorajamento",
        "at_risk": "Envolvimento em declínio, precisa de atenção",
        "inactive": "Sem atividade recente, atenção urgente necessária"
      },
      "engagementCriteria": {
        "thriving": "Uma sequência de {{thrivingStreak}}+ dias com forte impulso esta semana",
        "active": "Ativo recentemente com impulso semanal constante",
        "slowing": "Inativo há mais de {{slowingDays}} dias, ou recente mas a perder impulso",
        "at_risk": "Inativo há mais de {{atRiskDays}} dias, ou estagnado sem progresso esta semana",
        "inactive": "Sem atividade em {{inactiveDays}}+ dias"
      },
      "coachingBandMessage": {
        "thriving": "Celebre o progresso deles para reforçar o hábito.",
        "active": "Mantenha o impulso com um novo desafio.",
        "slowing": "Um empurrão oportuno agora evita que eles escorreguem mais.",
        "at_risk": "Contacte-o para remover bloqueios e recuperar o ritmo.",
        "inactive": "Reengaje com um check-in pessoal antes que eles se desconectem."
      },
      "coachingBandLabel": {
        "thriving": "Celebre talentos prósperos",
        "active": "Desafie talentos ativos",
        "slowing": "Treine talentos em desaceleração",
        "at_risk": "Treine talentos em risco",
        "inactive": "Treine talentos inativos"
      },
      "coachTipsTitle": "Dicas de coaching",
      "coachActions": {
        "encourage": "Encorajar",
        "challenge": "Desafiar",
        "checkin": "Check In",
        "celebrate": "Celebrar",
        "remind": "Lembrar"
      },
      "insightsRecommendations": {
        "topWorldRecommend": "O Mundo de Exploração Cultural tem o maior envolvimento — recomende-o a talentos em dificuldade",
        "sendReminders": "Enviar lembretes",
        "celebrate": "Celebrar",
        "recommend": "Recomendar",
        "checkIn": "Check In",
        "streaksAtRisk_one": "{{count}} talento está prestes a perder a sua sequência — envie um lembrete agora",
        "streaksAtRisk_other": "{{count}} talentos estão prestes a perder as suas sequências — envie lembretes agora",
        "thrivingCelebrate_one": "{{count}} talento está a prosperar — considere celebrar as suas conquistas",
        "thrivingCelebrate_other": "{{count}} talentos estão a prosperar — considere celebrar as suas conquistas",
        "inactiveCheckIn_one": "{{count}} talento não inicia sessão há mais de 2 semanas — pode precisar de um check-in",
        "inactiveCheckIn_other": "{{count}} talentos não iniciam sessão há mais de 2 semanas — podem precisar de um check-in"
      },
      "trendMetrics": {
        "activeLearners": "Aprendizes ativos",
        "weeklyMissions": "Missões semanais",
        "avgMiles": "Média de Miles"
      },
      "noOneNeedsAttention": "Ninguém precisa de atenção imediata",
      "confirmBulkSend": "Enviar {{count}}",
      "personalNote": "Nota pessoal (opcional)",
      "personalNoteHint": "Deixe vazio para enviar a mensagem de {{action}} da sua empresa, definida em Mensagens.",
      "ofTotal": "{{value}} de {{total}}",
      "viewAllInBand": "Ver todos ({{count}})",
      "dayStreak_one": "Sequência de {{count}} dia",
      "dayStreak_other": "Sequência de {{count}} dias",
      "engagementBandAria_one": "Mostrar {{count}} talento {{band}}",
      "engagementBandAria_other": "Mostrar {{count}} talentos {{band}}",
      "needsAttentionCount_one": "{{count}} precisa de atenção",
      "needsAttentionCount_other": "{{count}} precisam de atenção",
      "milesCount_one": "{{count}} Mile",
      "milesCount_other": "{{count}} Miles",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "viewAllNeedingAttention_one": "Ver o {{count}} que precisa de atenção",
      "viewAllNeedingAttention_other": "Ver todos os {{count}} que precisam de atenção",
      "confirmBulkTitle_one": "Enviar {{count}} mensagem de coaching?",
      "confirmBulkTitle_other": "Enviar {{count}} mensagens de coaching?",
      "confirmBulkDescription_one": "Prestes a enviar \"{{action}}\" para {{count}} talento. Receberá uma notificação na sua aplicação móvel.",
      "confirmBulkDescription_other": "Prestes a enviar \"{{action}}\" para {{count}} talentos. Cada um receberá uma notificação na sua aplicação móvel.",
      "searchTalentsLabel": "Pesquisar talentos",
      "sentCheckIns_one": "Check-in enviado a {{count}} talento",
      "sentCheckIns_other": "Check-in enviado a {{count}} talentos",
      "sendCheckInsTo_one": "Enviar um check-in a {{count}} talento inativo",
      "sendCheckInsTo_other": "Enviar um check-in a {{count}} talentos inativos",
      "sentStreakReminders_one": "Lembrete de sequência enviado a {{count}} talento",
      "sentStreakReminders_other": "Lembrete de sequência enviado a {{count}} talentos",
      "remindAboutStreaks_one": "Lembrar {{count}} talento com a sequência em risco",
      "remindAboutStreaks_other": "Lembrar {{count}} talentos com a sequência em risco",
      "recognizeThriving_one": "Reconhecer {{count}} talento em destaque",
      "recognizeThriving_other": "Reconhecer {{count}} talentos em destaque",
      "sentRecognition_one": "Reconhecimento enviado a {{count}} talento",
      "sentRecognition_other": "Reconhecimento enviado a {{count}} talentos",
      "sentChallenges_one": "Desafio semanal enviado a {{count}} talento",
      "sentChallenges_other": "Desafio semanal enviado a {{count}} talentos",
      "sentCoaching_one": "Coaching enviado a {{count}} talento",
      "sentCoaching_other": "Coaching enviado a {{count}} talentos"
    },
    "addTalentsWizard": {
      "addCohortToOrganize": "Adicionar um novo grupo para organizar talentos",
      "atsIntegration": "Integração ATS",
      "atsMethodDesc": "Conecte o seu sistema ATS e importe candidatos diretamente para o seu pipeline. Sincronize em tempo real com as suas ferramentas de recrutamento existentes.",
      "biWeekly": "Quinzenal (primeiras 8 semanas)",
      "cancel": "Cancelar",
      "chooseCohortForCandidates": "Escolha a qual grupo adicionar estes candidatos",
      "chooseCohortForTalents": "Escolha a que grupo adicionar estes talentos",
      "clear": "Limpar",
      "close": "Fechar",
      "cohortCreated": "Grupo \"{{name}}\" criado com sucesso",
      "cohortNamePlaceholder": "ex: Q2 2024 — Engenheiros de Backend",
      "cohortNameRequired": "Nome do grupo *",
      "cohortsCanExistWithoutProgram": "Os grupos podem existir sem um programa. As rotas são definidas por talento ao patrocinar.",
      "connectAdditionalATS": "Pode ligar sistemas ATS adicionais nas definições de integrações.",
      "createCohortButton": "Criar coorte",
      "createCohortDesc": "Crie um novo grupo. Pode atribuí-lo a um programa mais tarde ou deixá-lo por atribuir.",
      "createNewCohort": "Criar nova coorte",
      "createNewProgram": "Criar novo programa",
      "createProgramButton": "Criar programa",
      "createProgramDesc": "Crie um novo programa para organizar as suas iniciativas de contratação internacional.",
      "defaultFeedbackCadence": "Cadência de feedback padrão",
      "describeProgramPlaceholder": "Descreva os objetivos e o escopo do programa...",
      "descriptionOptional": "Descrição (opcional)",
      "deselectAll": "Desmarcar tudo",
      "downloadTemplateCsv": "Transferir modelo CSV",
      "dropFileHere": "Coloque o seu ficheiro aqui ou clique para procurar",
      "email": "Email",
      "enterProgramName": "Por favor, insira um nome de programa",
      "errorReason": "Razão",
      "errorReason_duplicate": "Duplicar",
      "errorReason_invalid": "Inválido",
      "errorReason_system": "Erro de sistema",
      "errors": {
        "cohortNameRequired": "O nome da coorte é obrigatório",
        "createCohortFailed": "Não foi possível criar o grupo. Por favor, tente novamente.",
        "createProgramFailed": "Não foi possível criar o programa. Por favor, tente novamente.",
        "emptyFile": "O ficheiro está vazio ou não tem linhas de dados",
        "endDateInvalid": "Insira uma data de fim válida",
        "malformedFile": "Não conseguimos ler este ficheiro. Tente guardá-lo como .csv e carregue-o novamente.",
        "mustMapEmail": "Mapeie pelo menos uma coluna para Email antes de continuar",
        "mustMapName": "Mapeie pelo menos uma coluna para Primeiro nome (ou Nome completo) antes de continuar",
        "noValidRows": "Nenhuma linha passou na validação. Corrija os erros acima e tente novamente.",
        "programNameRequired": "O nome do programa é obrigatório",
        "selectCohort": "Selecione um grupo antes de continuar",
        "startDateInvalid": "Insira uma data de início válida",
        "startDateRequired": "A data de início é obrigatória",
        "systemFailure": "Algo correu mal. Por favor, tente novamente.",
        "tooManyRows": "Os ficheiros estão limitados a {{max}} linhas. Divida o seu ficheiro e tente novamente.",
        "unsupportedFile": "Por favor, carregue um ficheiro .csv, .xlsx ou .xls",
        "planLimit": "O plano gratuito permite até 100 candidatos. Faça upgrade para Enterprise para adicionar mais.",
        "fileTooLarge": "O ficheiro é maior que 10 MB. Corte o ficheiro e tente novamente.",
        "cohortAtCapacity": "Esta coorte está cheia ({{max}} talentos). Escolha outra coorte ou aumente o seu limite.",
        "programAtCapacity": "Este programa está cheio ({{max}} talentos). Escolha outro programa ou aumente o seu limite."
      },
      "excelColumn": "Coluna do Excel",
      "excelCsvUpload": "Carregar Excel/CSV",
      "excelMethodDesc": "Importar talentos de ficheiros de spreadsheet. Suporta formatos Excel e CSV com mapeamento automático de colunas.",
      "expectedTalentCount": "Contagem de talentos esperada (opcional)",
      "fieldLabels": {
        "email": "Email",
        "firstName": "Primeiro nome",
        "ignore": "Ignorar",
        "lastName": "Último nome",
        "location": "Localização",
        "name": "Nome completo (será dividido)",
        "role": "Função",
        "skills": "Competências"
      },
      "fileReady": "Ficheiro pronto!",
      "fillRequiredFields": "Por favor, preencha todos os campos obrigatórios",
      "firstName": "Primeiro nome",
      "fixValidationErrors": "Por favor, corrija os erros de validação antes de continuar",
      "importCandidatesFrom": "Importar candidatos diretamente de {{name}}",
      "importMethodLabel": "Método de importação",
      "importSummary": "Resumo da importação",
      "invalidEmail": "Email inválido",
      "invalidFileType": "Por favor, carregue um ficheiro Excel ou CSV válido",
      "inviteToVetting": "Convidar para avaliação",
      "inviteToVettingFailed": "Falha ao convidar talentos",
      "lastName": "Último nome",
      "location": "Localização",
      "mapColumnsInstruction": "Mapeie as colunas do Excel para os campos Tonnie. Primeiras 5 linhas mostradas:",
      "mapTo": "Mapear Para",
      "match": "corresponder",
      "missingName": "Nome em falta",
      "monthly": "Mensal (meses 3-6)",
      "name": "Nome",
      "needDifferentATS": "Precisa de ligar um ATS diferente?",
      "noDataYet": "Sem dados ainda — talentos nesta fase preencherão esta vista",
      "noProgramUnassigned": "Sem programa (não atribuído)",
      "plusMore": "+ Mais",
      "poolMethodDesc": "Navegue e adicione talentos do seu Tonnie Talent Pool diretamente à sua pipeline.",
      "programCreated": "Programa \"{{name}}\" criado com sucesso",
      "programNamePlaceholder": "ex: Iniciativa de Talento Tecnológico",
      "programNameRequired": "Nome do programa *",
      "programOptional": "Programa (opcional)",
      "quarterly": "Trimestral (meses 6-12)",
      "readyToImport": "Pronto para importar talentos",
      "readyToMapColumns": "Pronto para mapear colunas",
      "requiredFields": "Nome e Email são campos obrigatórios",
      "resultDuplicates": "Duplicados",
      "resultFailed": "Falhou",
      "resultImported": "Importado",
      "resultPartial": "Alguns talentos não foram importados",
      "role": "Função",
      "samplePreview": "Valor de exemplo",
      "searchPlaceholder": "Pesquisar por nome, função ou localização...",
      "select": "Selecionar",
      "selectATSError": "Por favor, selecione um sistema ATS",
      "selectAllCount": "Selecionar todos ({{count}})",
      "selectCandidateError": "Por favor, selecione pelo menos um candidato",
      "selectCohortError": "Por favor, selecione uma coorte",
      "selectFile": "Selecionar ficheiro",
      "selectProgramOptional": "Selecionar programa (opcional)",
      "selectedLabel": "Selecionado",
      "startDateRequired": "Data de início *",
      "status": "Estado",
      "stepATS": "ATS",
      "stepCohort": "Coorte",
      "stepConfirm": "Confirmar",
      "stepMap": "Mapear",
      "stepMethod": "Método",
      "stepReview": "Revisão",
      "stepSelect": "Selecionar",
      "stepUpload": "Carregar",
      "supportsFileTypes": "Suporta ficheiros Excel (.xlsx, .xls) e CSV até 10MB",
      "targetArrivalDate": "Data de chegada alvo",
      "toastImportedHint": "Abra o Pipeline > coluna de Aquisição e clique em Enviar Convite para Avaliação quando estiver pronto para enviar um email a cada candidato.",
      "toastNothingImported": "Nenhum talento importado",
      "totalCandidates": "Total de candidatos",
      "totalTalents": "Total de talentos",
      "unassigned": "Não atribuído",
      "uploadDifferentFile": "Carregar um ficheiro diferente",
      "vettingNotStarted": "A avaliação ainda não começou para este talento",
      "whatHappensNext": "O que acontece a seguir?",
      "whatHappensNextDesc": "Após a importação, os talentos aparecerão na fase de Aquisição. Pode depois convidá-los para o CheckUp e patrocinar os que estiverem prontos.",
      "addingToPill": "A adicionar a: {{name}}",
      "guard": {
        "archivedTitle": "Este grupo está arquivado",
        "pausedTitle": "Este grupo está pausado",
        "programPausedTitle": "O programa principal está pausado",
        "archivedBody": "Grupos arquivados não podem aceitar novos talentos. Restaure o grupo primeiro para convidar pessoas.",
        "pausedBody": "Grupos pausados não podem aceitar novos talentos. Retome o grupo primeiro para convidar pessoas.",
        "programPausedBody": "O programa principal está pausado. Retome o programa para começar a aceitar novos talentos neste grupo.",
        "cohortPill": "Grupo: {{name}}"
      },
      "issues": {
        "emailInvalid": "Email inválido ou em falta",
        "emailDuplicate": "Duplicado da linha {{row}}",
        "nameMissing": "Falta o nome próprio",
        "textTooLong": "{{field}} tem mais de {{max}} caracteres",
        "skillsTooMany": "Mais de {{max}} competências",
        "skillTooLong": "Uma competência tem mais de {{max}} caracteres"
      },
      "candidatesAttached_one": "{{count}} candidato associado ao grupo",
      "candidatesAttached_other": "{{count}} candidatos associados ao grupo",
      "candidatesSelected_one": "{{count}} candidato selecionado",
      "candidatesSelected_other": "{{count}} candidatos selecionados",
      "candidatesWillBeAdded_one": "{{count}} candidato será adicionado a {{cohort}}",
      "candidatesWillBeAdded_other": "{{count}} candidatos serão adicionados a {{cohort}}",
      "candidatesWillBeAddedVetting_one": "{{count}} candidato será adicionado ao grupo selecionado e pode ser convidado a iniciar a triagem.",
      "candidatesWillBeAddedVetting_other": "{{count}} candidatos serão adicionados ao grupo selecionado e podem ser convidados a iniciar a triagem.",
      "errorsCount_one": "{{count}} erro",
      "errorsCount_other": "{{count}} erros",
      "errorsTitle_one": "{{count}} linha precisa de atenção",
      "errorsTitle_other": "{{count}} linhas precisam de atenção",
      "inviteToVettingSent_one": "{{count}} talento convidado para a triagem",
      "inviteToVettingSent_other": "{{count}} talentos convidados para a triagem",
      "ofShown_one": "(de {{count}} mostrado)",
      "ofShown_other": "(de {{count}} mostrados)",
      "readyToAddCandidates_one": "Pronto para adicionar {{count}} candidato do seu ATS",
      "readyToAddCandidates_other": "Pronto para adicionar {{count}} candidatos do seu ATS",
      "readyToImportTalents_one": "Pronto para importar {{count}} talento da sua folha de cálculo",
      "readyToImportTalents_other": "Pronto para importar {{count}} talentos da sua folha de cálculo",
      "reviewImportedData_one": "Rever os dados importados ({{count}} linha)",
      "reviewImportedData_other": "Rever dados importados ({{count}} linhas)",
      "rowsDetected_one": "{{count}} linha detetada",
      "rowsDetected_other": "{{count}} linhas detetadas",
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "talentsImported_one": "{{count}} talento importado",
      "talentsImported_other": "{{count}} talentos importados",
      "talentsWillBeImported_one": "{{count}} talento será importado para {{cohort}}",
      "talentsWillBeImported_other": "{{count}} talentos serão importados para {{cohort}}",
      "talentsWillBeImportedAcquisition_one": "{{count}} talento será importado para a coorte selecionada e aparecerá na fase de Aquisição.",
      "talentsWillBeImportedAcquisition_other": "{{count}} talentos serão importados para a coorte selecionada e aparecerão na fase de Aquisição.",
      "toastDuplicates_one": "{{count}} já está na sua empresa",
      "toastDuplicates_other": "{{count}} já estão na sua empresa",
      "toastFailed_one": "{{count}} falhou",
      "toastFailed_other": "{{count}} falharam",
      "toastImported_one": "{{count}} adicionado à aquisição",
      "toastImported_other": "{{count}} adicionados à aquisição",
      "validCount_one": "{{count}} válido",
      "validCount_other": "{{count}} válidos",
      "mapColumnTo": "Mapear a coluna {{column}} para"
    },
    "sponsor": {
      "modal": {
        "title": "Patrocinar o percurso de {{firstName}}",
        "subtitle": "Ative a experiência completa da Tonnie para este talento.",
        "steps": {
          "recap": "Recapitulação",
          "pricing": "Preços",
          "message": "Mensagem",
          "review": "Revisão"
        },
        "step1": {
          "noCheckup": "CheckUp pendente — a pontuação aparecerá assim que {{firstName}} completar a avaliação.",
          "craHeading": "Perfil de risco",
          "verdictHeading": "Por que patrocinar agora",
          "verdict": {
            "pro": "Candidato PRO forte. O patrocínio desbloqueia o percurso completo para uma contratação de alta confiança.",
            "potential": "Alto potencial — o patrocínio acelera o caminho da avaliação para a evidência.",
            "emerging": "Sinal emergente — o patrocínio permite uma avaliação completa através de todos os cinco heróis."
          },
          "unlocksHeading": "O que o patrocínio desbloqueia",
          "unlocksFootnote": "Uma vez que {{firstName}} aceite, todos os cinco heróis ativam.",
          "continueCta": "Continuar para preços"
        },
        "step2": {
          "heading": "Preços",
          "planNameFree": "Pagamento por utilização",
          "planNameEnterprise": "Tarifa Enterprise",
          "subtitle": "Custo único — reembolso proporcional se cancelar mais tarde.",
          "monthlyRate": "Taxa mensal",
          "duration": "Duração",
          "total": "Compromisso total",
          "billedOnce": "Cobrado uma vez via Stripe",
          "heroes": {
            "checkup": "CheckUp",
            "teleportal": "TelePortal",
            "qultureup": "QultureUp",
            "care": "Care",
            "passport": "Passport"
          },
          "familyAccess": "Acesso familiar",
          "familyAccessHint": "Incluir membros da família no percurso",
          "refundHeading": "Reembolsável de forma proporcional",
          "refundScenarios": {
            "decline": {
              "label": "Se eles recusarem",
              "body": "reembolso automático total, sem necessidade de ação."
            },
            "cancel": {
              "label": "Se cancelar a meio",
              "body": "o reembolso é igual aos meses restantes × taxa mensal."
            },
            "lock": {
              "label": "Heróis bloqueados até aceitação",
              "body": "sem risco antes que o talento aceite."
            }
          },
          "refundFootnote": "Os reembolsos são processados automaticamente através do Stripe.",
          "continueCta": "Continue a mensagem",
          "durationMonths_one": "{{count}} mês",
          "durationMonths_other": "{{count}} meses"
        },
        "step3": {
          "subtitle": "Tonnie envia um e-mail de ativação curado com o link de aceitar/rejeitar. Adicione uma nota pessoal opcional que aparecerá no e-mail acima da chamada à ação.",
          "customMessageLabel": "A sua nota (opcional)",
          "customMessagePlaceholder": "Bem-vindo a bordo — adoraríamos tê-lo connosco em {{destination}}.",
          "charsCounter": "{{count}} / {{max}}",
          "previewHeading": "Pré-visualização do e-mail",
          "previewSubheading": "O que {{firstName}} realmente receberá",
          "previewAriaLabel": "Pré-visualização do e-mail de ativação que {{firstName}} receberá",
          "previewDisclaimer": "Enviado automaticamente após o sucesso do pagamento. {{firstName}} tem tempo ilimitado para aceitar.",
          "toneHint": {
            "concise": "Conciso",
            "warm": "Aconchegante",
            "professional": "Detalhado"
          },
          "chips": {
            "label": "Inserções rápidas",
            "destination": "Adicionar destino",
            "destinationSnippet": "Mal podemos esperar para tê-lo connosco em {{destination}}.",
            "destinationAria": "Insira uma frase sobre o destino",
            "teamWelcome": "Adicionar boas-vindas da equipa",
            "teamWelcomeSnippet": "Toda a equipa da {{company}} está a torcer por si.",
            "teamWelcomeAria": "Inserir uma frase de boas-vindas da equipa",
            "signoff": "Adicionar despedida",
            "signoffSnippet": "Ansioso para construir este percurso juntos.",
            "signoffAria": "Insira uma frase de despedida pessoal"
          },
          "continueCta": "Revise e pague"
        },
        "step4": {
          "talentLabel": "Talento",
          "routeLabel": "Rota",
          "pricingLabel": "Preços",
          "rateTimesMonths": "{{rate}}/mês × {{count}}",
          "messageLabel": "Nota de ativação",
          "messageEmptyPlaceholder": "A mensagem de ativação padrão da Tonnie será enviada.",
          "routeEmpty": "Definido no perfil do talento.",
          "routeUnknown": "Não definido",
          "vatNote": "Impostos (se houver) são calculados no Stripe Checkout.",
          "previewToggle": "Pré-visualizar o e-mail de ativação",
          "previewToggleOpen": "Ocultar pré-visualização do e-mail",
          "commitmentTitle": "Está prestes a comprometer-se",
          "commitmentBody": "{{total}} hoje. Reembolso proporcional disponível durante a janela de {{durationMonths}} meses. {{firstName}} tem tempo ilimitado para aceitar.",
          "trustAriaLabel": "Sinais de confiança de pagamento",
          "trust": {
            "stripe": "Seguro pelo Stripe",
            "refundable": "Reembolso proporcional",
            "noExpiry": "Sem expiração para o talento",
            "autoSent": "Email enviado automaticamente"
          },
          "nextTitle": "O que acontece a seguir",
          "next": {
            "s1": "Abrimos o Stripe Checkout neste separador.",
            "s2": "Após o pagamento, {{firstName}} recebe automaticamente o seu e-mail de ativação.",
            "s3": "O cartão passa para Patrocinado — A aguardar aceitação."
          },
          "payCta": "Patrocinar e pagar {{total}}"
        },
        "preview": {
          "fromLabel": "De",
          "subject": "{{company}} gostaria de patrocinar o seu percurso Tonnie",
          "greeting": "Olá {{firstName}},",
          "introTail": "acabou de pagar para patrocinar o seu percurso completo Tonnie — pendente da sua aceitação.",
          "unlocksHeading": "O que desbloqueia se aceitar",
          "heroes": {
            "checkup": "avaliação completa iQulture",
            "teleportal": "playbook de visto, realocação e habitação",
            "qultureup": "missões de integração cultural",
            "care": "apoio ao bem-estar durante a mudança",
            "passport": "o seu registo portátil de progresso"
          },
          "noCost": "Não lhe custa nada. Se recusar, a {{company}} é automaticamente reembolsada e mantém o seu acesso básico.",
          "yourNoteHeading": "Uma nota da equipa",
          "ctaLabel": "Revise e responda à oferta de patrocínio",
          "noExpiry": "Esta oferta fica à sua espera — não tem prazo de validade. Leve o tempo que precisar.",
          "signOff": "Bem-vindo a bordo,",
          "signature": "A equipa Tonnie",
          "fallbackCompany": "A sua empresa"
        },
        "footer": {
          "back": "Voltar",
          "cancel": "Cancelar",
          "peekPreview": "Ver o email"
        },
        "errors": {
          "checkoutFailed": "Não foi possível abrir o Stripe Checkout. Tente novamente ou contacte o suporte.",
          "customMessageTooLong": "A sua nota deve ter 2000 caracteres ou menos.",
          "planNotFound": "Não foi possível encontrar o plano de patrocínio. Contacte o suporte.",
          "planMisconfigured": "O plano de patrocínio não está configurado corretamente. Contacte o suporte.",
          "discountUnavailable": "Esse desconto já não está disponível. Reveja o preço e tente novamente.",
          "planLimitExceeded": "Atingiu o limite do seu plano. Faça upgrade para patrocinar mais talentos.",
          "needsInvitation": "A sua empresa ainda não tem uma relação com esta pessoa, por isso não pode ser patrocinada diretamente. Convide-a primeiro a partir do Pool.",
          "inviteFromPool": "Convidar a partir do Pool",
          "alreadySponsored": "Este percurso já tem um patrocínio em curso, por isso não pode ser patrocinada novamente até esse terminar.",
          "sharedWithAnotherCompany": "Outra empresa também acompanha esta pessoa neste percurso, e um percurso patrocinado pertence a uma só empresa. Pode patrociná-la num percurso só vosso na mesma rota — ela aceita-o com a vossa oferta.",
          "sponsoredByAnotherCompany": "Outra empresa já patrocina este percurso.",
          "routeFull": "Esta pessoa já tem o máximo de percursos que uma rota permite, por isso não é possível criar um novo para vós. Pode arquivar um primeiro.",
          "sponsorDedicated": "Patrocinar num percurso próprio",
          "notSponsorable": "Este percurso já é financiado de uma forma que um patrocínio de empresa não pode assumir, por isso nada foi cobrado."
        }
      },
      "return": {
        "verifyingPayment": "A confirmar o seu pagamento…",
        "paymentFailed": "O pagamento não pôde ser confirmado",
        "paymentFailedDescription": "A Tonnie não recebeu uma sessão de Stripe Checkout paga. Se concluiu o pagamento, atualize dentro de momentos — os webhooks podem demorar alguns segundos a chegar. Caso contrário, tente novamente a partir do painel de Avaliação.",
        "backToVetting": "Voltar à avaliação",
        "stepConfirm": {
          "title": "Patrocínio pago — a aguardar aceitação",
          "subtitleHint": "O talento fica em Verificação, marcado como “Patrocínio oferecido”, até aceitar.",
          "headline": "Patrocínio pago — email de ativação enviado",
          "awaitingTitle": "A aguardar a aceitação do talento",
          "body": "O talento vai receber um email e pode aceitar ou recusar. Passa a Patrocinado quando aceitar; se recusar, é reembolsado automaticamente. Até lá, encontra-o em Verificação, onde pode reenviar a oferta ou abandoná-la.",
          "backToVetting": "Voltar à avaliação",
          "viewTalent": "Ver talento",
          "resendCta": "Reenviar e-mail de ativação",
          "resendSuccess": "Email de ativação reenviado.",
          "resendAlready": "Email de ativação já foi enviado — nenhum duplicado enviado."
        },
        "errors": {
          "missingSponsorship": "Tonnie ainda está a confirmar o pagamento. Atualize em alguns segundos e tente novamente.",
          "resendFailed": "Não foi possível reenviar o email de ativação."
        }
      }
    },
    "talentDetail": {
      "loading": "A Carregar…",
      "viewFullVettingReport": "Ver relatório completo de avaliação",
      "header": {
        "couple": "Casal",
        "familyWithKids": "Família +{{count}}",
        "singleParent": "Família monoparental +{{count}}",
        "openLinkedIn": "Abrir perfil do LinkedIn",
        "solo": "Solo",
        "sponsorCta": "Patrocinar este talento"
      },
      "iqultureBlock": {
        "ariaLabel": "Pontuação iQulture {{score}} em 100, nível {{tier}}",
        "label": "iQulture"
      },
      "kebab": {
        "label": "Mais ações"
      },
      "insights": {
        "vettingInsights": "O veredicto da Tonnie de relance — pontuação, fundamentos MESH, riscos culturais e evidências de pilares num único painel de decisão.",
        "vettingMesh": "Motivação, Inglês, Soft skills, Hard skills — os quatro sinais em que cada decisão de patrocínio confiante é baseada.",
        "vettingArchetypes": "Os arquétipos culturais revelam como {{name}} se adapta. Arquétipos de baixo risco são as suas apostas mais seguras de patrocínio.",
        "vettingPillars": "Cada pilar é pontuado de forma independente com bandeiras verdes, bandeiras vermelhas e evidências — o rasto de auditoria por trás da pontuação iQulture.",
        "vettingSkills": "O que {{name}} traz para a mesa: soft skills, hard skills e a adequação cultural.",
        "vettingPitch": "O pitch de 60 segundos de {{name}} — conheça-o nas suas próprias palavras antes de patrocinar.",
        "vettingProfile": "Identidade, histórico, contexto familiar — o perfil completo que {{name}} construiu na Tonnie.",
        "vettingActivity": "Cada sinal que Tonnie capturou: mensagens enviadas, transições de fase, marcos de heróis.",
        "sponsoredOverview": "Onde {{name}} está agora no seu percurso de realocação.",
        "sponsoredVetting": "Por que patrocinou {{name}}: a sua pontuação iQulture e evidência MESH.",
        "sponsoredMobility": "Jurídico e documentos, instalação local, viagem e logística — três pistas de mobilidade. Um bloqueio aqui atrasa tudo o resto.",
        "sponsoredAdaptation": "QultureUp transforma o choque cultural em adaptação mensurável. A consistência supera os sprints.",
        "sponsoredCare": "A estabilidade é o sucesso patrocinado. O check-in barato hoje evita a recuperação cara depois.",
        "sponsoredEvidence": "Prova tangível do percurso de {{name}}: crachás, milhas, marcos.",
        "sponsoredActivity": "Sinal ao vivo de cada herói — a resposta para 'o que tem acontecido?' que os administradores sempre precisam."
      },
      "toneRibbon": {
        "label": "Tonnie recomenda",
        "phase": {
          "invited": "Convidado",
          "started": "CheckUp em progresso",
          "submitted": "CheckUp submetido",
          "scored": "Pontuado",
          "verdict": "Pronto para o veredicto"
        },
        "tone": {
          "green": "Ajuste forte — prossiga com confiança",
          "amber": "Algumas ressalvas — reveja os insights antes de patrocinar",
          "red": "Preocupações significativas — leia as bandeiras com atenção",
          "neutralAwaiting": "A aguardar sinal do CheckUp",
          "neutralScored": "Pontuação disponível — sinal qualitativo pendente"
        }
      },
      "recommendation": {
        "green": {
          "title": "Tonnie recomenda patrocinar"
        },
        "amber": {
          "title": "Patrocinar com os olhos abertos"
        },
        "red": {
          "title": "Preocupações significativas"
        },
        "neutral": {
          "title": "Recomendação pendente"
        }
      },
      "radar": {
        "tooltip": {
          "pillar": {
            "scoreAt": "Em {{min}}–{{max}}",
            "evaluationQuestion": "Perguntas do cérebro",
            "band": {
              "excellent": "Excelente",
              "solid": "Sólido",
              "mixed": "Misturado",
              "weak": "Fraco",
              "tier": "Nível {{tier}}"
            }
          },
          "archetype": {
            "persona": "Persona {{persona}}",
            "bucketLow": "Baixo risco ({{score}})",
            "bucketModerate": "Risco moderado ({{score}})",
            "bucketHigh": "Alto risco ({{score}})"
          }
        },
        "axis": {
          "ariaLabel": "Mais sobre {{label}}"
        }
      },
      "insightsTab": {
        "label": "Insights",
        "emptyTitle": "As informações desbloqueiam uma vez que o CheckUp é pontuado",
        "verdict": {
          "scoreSuffix": "/ 100",
          "badgeLabel": "cracha iQulture",
          "scoreLabel": "pontuação iQulture",
          "confidenceBand": {
            "high": "Alta confiança",
            "moderate": "Confiança moderada",
            "low": "Baixa confiança"
          },
          "confidenceTooltip": "A confiança da Tonnie nesta avaliação: {{percent}}% (média entre os 7 pilares de avaliação).",
          "scoredToday": "Pontuado hoje",
          "scoredAgo_one": "Pontuado há {{count}} dias",
          "scoredAgo_other": "Pontuado há {{count}} dias",
          "fallbackRationale": "A Tonnie avaliou este perfil nos fundamentos MESH e em 10 arquétipos culturais — os separadores de apoio abaixo têm a análise completa.",
          "rationaleStrong": "Forte {{strongest}} ({{strongestScore}}%) sustenta este perfil.",
          "rationaleWeak": "Fraqueza em {{weakest}} ({{weakestScore}}%) é a principal preocupação.",
          "rationaleAlert": "Alerta principal: {{alert}}",
          "eyebrow": "Recomendação da Tonnie"
        },
        "deepLink": {
          "openActivity": "Abrir atividade",
          "openArchetypes": "Abrir arquétipos",
          "openMesh": "Abrir MESH",
          "openPillars": "Abrir pilares",
          "openPitch": "Abrir pitch",
          "openSkills": "Abrir competências"
        },
        "deepDive": {
          "activity": "Cronologia de envolvimento e atividade deste perfil",
          "pillars": "Para o histórico de auditoria e evidências pilar a pilar",
          "pitch": "Para conhecer este candidato nas suas próprias palavras",
          "skills": "Para o inventário completo de capacidades",
          "title": "Onde olhar a seguir"
        },
        "badgeAndScore": {
          "title": "pontuação iQulture & cracha",
          "scoreLabel": "Pontuação",
          "badgeLabel": "Emblema"
        },
        "mesh": {
          "title": "Fundamentos MESH",
          "subtitle": "Os quatro sinais sobre os quais todo patrocínio confiante é construído."
        },
        "conclusion": {
          "title": "Conclusão da Tonnie"
        },
        "snapshot": {
          "title": "À primeira vista"
        },
        "cra": {
          "title": "Arquétipos de risco cultural",
          "severityChip": "{{low}} baixo · {{moderate}} moderado · {{high}} alto",
          "severityTier": {
            "low": "baixo",
            "moderate": "moderado",
            "high": "alto"
          },
          "radarSeries": "Pontuação de risco",
          "radarA11yLabel": "Radar de arquétipos de risco cultural — {{summary}}",
          "empty": "Nenhum dado de arquétipo disponível ainda.",
          "description_one": "Onde {{name}} se posiciona no {{count}} arquétipo — mais próximo do centro = menor risco cultural.",
          "description_other": "Onde {{name}} se posiciona entre os {{count}} arquétipos — mais próximo do centro = menor risco cultural."
        },
        "pillars": {
          "title": "Avaliação de pilares",
          "description": "Os sete pilares de avaliação num só radar — quanto mais perto da margem exterior, mais forte é a pontuação do pilar.",
          "confidenceChip": "{{band}} · confiança média",
          "radarSeries": "Pontuação de pilar",
          "radarA11yLabel": "Radar de avaliação de Pilar — {{summary}}",
          "legendUnknownCodes": "Os rótulos dos eixos são códigos de pilares. Abra o separador Pilares para ver a análise completa."
        }
      },
      "tabs": {
        "testit": "TestIt",
        "activity": "Atividade",
        "adaptation": "Adaptação",
        "archetypes": "Arquetipos",
        "care": "Care",
        "checkup": "CheckUp",
        "evidence": "Evidência",
        "insights": "Insights",
        "mesh": "MESH",
        "mobility": "Mobilidade",
        "overview": "Visão geral",
        "pillars": "Pilares",
        "pitch": "Apresentação",
        "profile": "Perfil",
        "skills": "Competências",
        "vetting": "Verificação",
        "decisionRecords": "Registos de decisão",
        "stripLabel": "Secções do talento",
        "scrollPrevious": "Mostrar secções anteriores",
        "scrollNext": "Mostrar mais secções"
      },
      "communications": {
        "privacyNote": "Vê o que foi enviado e o que lhe aconteceu — nunca o conteúdo, o endereço para onde foi, nem o motivo de uma mensagem não ter sido entregue.",
        "empty": "Ainda não foi enviado nada a este talento.",
        "loadError": "Não foi possível carregar as comunicações. Tente novamente dentro de momentos.",
        "loadMore": "Carregar mensagens anteriores",
        "channelEmail": "Email",
        "channelInApp": "Na aplicação",
        "channelPush": "Push",
        "kindSystem": "Mensagem automática",
        "kindAdmin": "Mensagem da sua equipa",
        "kindInApp": "Notificação na aplicação",
        "statusQueued": "Em fila",
        "statusDispatched": "Enviada · resultado não registado",
        "statusSent": "Enviada",
        "statusDelivered": "Entregue",
        "statusOpened": "Aberta",
        "statusFailed": "Falhou",
        "statusBounced": "Devolvida",
        "statusNotDelivered": "Não entregue",
        "deliveredAt": "Entregue em {{date}}",
        "openedAt": "Aberta em {{date}}",
        "readInAppAt": "Lida na Tonnie em {{date}}"
      },
      "activity": {
        "empty": "Nenhuma atividade ainda — os eventos aparecerão aqui quando o talento avançar pelo pipeline, completar um passo CheckUp, ou receber uma mensagem.",
        "error": "Não foi possível carregar a atividade. Tente novamente daqui a pouco.",
        "eventCount_one": "{{count}} evento",
        "eventCount_other": "{{count}} eventos",
        "loadMore": "Carregar atividade anterior",
        "loadingMore": "A carregar atividade anterior…",
        "live": "Ao vivo",
        "polling": "Atualização periódica",
        "withheldBody": "Este cidadão não partilhou a sua própria atividade com a sua empresa. Os eventos apresentados são da própria empresa: movimentos no pipeline e mensagens que enviou.",
        "eventCountPartial_one": "{{count}} evento apenas da sua empresa",
        "eventCountPartial_other": "{{count}} eventos apenas da sua empresa",
        "viewLabel": "Mostrar",
        "view": {
          "all": "Tudo",
          "progress": "Progresso do talento",
          "pipeline": "Pipeline",
          "messages": "Mensagens"
        },
        "viewEmpty": "Ainda não há nada nesta vista.",
        "hero": {
          "checkup": "CheckUp",
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "pipeline": "Pipeline",
          "system": "Tonnie"
        },
        "actorNotRecorded": "Autor não registado"
      },
      "sponsored": {
        "ribbon": {
          "status": {
            "awaitingAcceptance": "A aguardar a aceitação do talento",
            "active": "Patrocínio ativo",
            "cancelling": "Processamento de reembolso",
            "talentDeclined": "Talento recusou",
            "refunded": "Reembolsado",
            "cancelled": "Cancelado",
            "pastDue": "Pagamento em atraso",
            "failed": "Pagamento falhou",
            "unknown": "Sem patrocínio ativo",
            "completed": "Concluído"
          },
          "monthsRemaining_one": "{{count}} meses restantes",
          "monthsRemaining_other": "{{count}} meses restantes",
          "refundAtRisk": "{{amount}} reembolso em risco",
          "acceptedOn": "Aceito {{date}}",
          "awaitingTalent": "A aguardar a aceitação do talento"
        },
        "health": {
          "totalMonths_one": "{{count}} meses",
          "totalMonths_other": "{{count}} meses",
          "elapsed": "{{elapsed}} de {{total}} meses decorridos",
          "awaitingActivationSent": "Ativação enviada {{ago}}",
          "awaitingBody": "O talento recebeu um link de ativação por e-mail. O patrocínio ativa no momento em que eles aceitam.",
          "cancellingBody": "O reembolso está em processamento. A Stripe nos notificará quando os fundos forem liberados; o patrocínio será movido para reembolsado automaticamente.",
          "declinedBody": "O talento recusou a oferta de patrocínio. Um reembolso total foi emitido.",
          "closedBody": "O patrocínio está encerrado e a empresa deixou de financiar este percurso. O talento mantém o seu próprio acesso e ainda pode completar o seu CheckUp.",
          "closedOn": "Encerrado {{date}}",
          "paymentFailedBody": "O último pagamento do patrocínio falhou. Atualize o método de pagamento para manter o talento ativo.",
          "refundAmount": "Valor do reembolso: {{amount}}",
          "completedBody": "O patrocínio de 12 meses chegou ao fim. Nada é reembolsado; o talento continua com o seu próprio plano.",
          "completedOn": "Terminou a {{date}}"
        },
        "heroes": {
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "notStarted": "Ainda não iniciado"
        },
        "heroesGrid": {
          "mobilitySubtitle": "Visto, documentação, prontidão para viagem",
          "adaptationSubtitle": "Preparação cultural, missões, sequência",
          "careSubtitle": "Bem-estar, estabilidade, intervenções",
          "evidenceSubtitle": "Emblemas, selos e milhas ganhos",
          "blockers_one": "{{count}} bloqueador",
          "blockers_other": "{{count}} bloqueadores",
          "worldsLabel": "Mundos",
          "missionsLabel": "Missões",
          "tracksLabel": "Faixas",
          "streakDays_one": "sequência de {{count}} dias",
          "streakDays_other": "sequência de {{count}} dias",
          "wellbeingLabel": "Pontuação de bem-estar",
          "lastCheckin": "Último {{ago}}",
          "openInterventions_one": "{{count}} abertos",
          "openInterventions_other": "{{count}} abertos",
          "moodLabel": "Humor",
          "settlementLabel": "Liquidação",
          "checkpointsValue": "{{done}}/{{total}} pontos de verificação",
          "docsReady": "Documentos prontos",
          "assessmentDone": "Avaliação concluída",
          "awaitingData": "A aguardar o primeiro check-in para mostrar a pontuação de bem-estar.",
          "miles": "Miles",
          "badges": "Emblemas",
          "stamps": "Selos",
          "openTabHint": "Abra o separador para enviar um lembrete"
        },
        "activity": {
          "preview": {
            "title": "Atividade recente",
            "viewAll": "Ver atividade completa",
            "empty": "Ainda não há eventos de patrocínio"
          }
        },
        "meta": {
          "familyAccess": "Acesso familiar",
          "familyAccessOn": "Ativado",
          "familyAccessOff": "Desativado",
          "familyAccessOnToast": "Acesso familiar ativado",
          "familyAccessOffToast": "Acesso familiar desativado",
          "familyAccessFailed": "Falha ao atualizar o acesso familiar",
          "startedAt": "Iniciado",
          "endsAt": "Termina",
          "amountPaid": "Valor pago",
          "refundIfCancelledToday": "Reembolso se cancelar hoje",
          "monthsLeft_one": "Falta {{count}} mês",
          "monthsLeft_other": "Faltam {{count}} meses"
        },
        "banner": {
          "headline": "O percurso de {{name}}",
          "miles": "Miles do percurso",
          "monthsLeft": "Meses restantes",
          "ctaViewVetting": "Ver avaliação",
          "ctaOpenMobility": "Abrir mobilidade",
          "ctaOpenAdaptation": "Abrir adaptação",
          "ctaOpenCare": "Abrir Care",
          "statusNotStarted": "Não iniciado",
          "statusLocked": "Bloqueado",
          "statusDone": "Feito",
          "day": "Dia {{day}}",
          "dayLabel": "do percurso",
          "nextEyebrow": "Onde olhar a seguir"
        },
        "footer": {
          "action": {
            "resendActivation": "Reenviar e-mail de ativação",
            "abandon": "Abandonar patrocínio",
            "cancel": "Cancelar patrocínio",
            "close": "Fechar",
            "reoffer": "Reoferecer patrocínio",
            "updatePayment": "Atualizar pagamento"
          },
          "refundProcessing": "Processamento de reembolso — sem ações enquanto o Stripe finaliza"
        },
        "smartNudge": {
          "sending": "A enviar…",
          "cta": {
            "mobility": "Enviar tarefa de mobilidade",
            "adaptation": "Enviar lembrete de adaptação",
            "care": "Enviar check-in Care"
          },
          "sent": {
            "mobility": "Lembrete da tarefa de mobilidade enviado para {{name}}",
            "adaptation": "Lembrete de adaptação enviado para {{name}}",
            "care": "Pedido de check-in Care enviado para {{name}}"
          },
          "errorMissingEmail": "Não é possível enviar — o talento não tem e-mail registado.",
          "templateMissing": "O modelo \"{{code}}\" não está configurado para este inquilino. Adicione ou restaure-o em Mensagens → Modelos.",
          "sendFailed": "Falha ao enviar lembrete",
          "fallback": {
            "mobilityTask": "o seu próximo passo de mobilidade",
            "adaptationMission": "a sua próxima missão QultureUp"
          }
        },
        "abandon": {
          "confirmTitle": "Abandonar este patrocínio?",
          "confirmDescription": "{{name}} receberá um reembolso total e o percurso reverte para acesso apenas por convite. Esta ação não pode ser desfeita.",
          "confirmCancel": "Manter patrocínio",
          "confirmAction": "Abandonar e reembolsar",
          "successToast": "Patrocínio abandonado · reembolso emitido",
          "failedToast": "Falha ao abandonar patrocínio"
        },
        "resendActivation": {
          "successToast": "E-mail de ativação reenviado",
          "failedToast": "Falha ao reenviar e-mail de ativação"
        },
        "noSponsorshipTitle": "Sem patrocínio ativo para este percurso",
        "noSponsorshipBody": "O talento não tem nenhum patrocínio ativo para este percurso. Veja o separador Patrocinado no pipeline, caso esteja patrocinado outro percurso, ou inicie um novo a partir do painel de Avaliação.",
        "relative": {
          "justNow": "agora mesmo",
          "minAgo_one": "há {{count}}m",
          "minAgo_other": "há {{count}}m",
          "hourAgo_one": "há {{count}}h",
          "hourAgo_other": "há {{count}}h",
          "dayAgo_one": "Há {{count}}d",
          "dayAgo_other": "Há {{count}}d"
        },
        "alreadyAnswered": "O talento já respondeu a esta oferta de patrocínio."
      },
      "nudge": {
        "cta": "Enviar lembrete",
        "description": "Escolha uma mensagem modelo para os reativar. Pode substituir o corpo antes de enviar.",
        "failed": "Falha ao enviar lembrete",
        "noTemplates": "Nenhum modelo configurado para esta etapa. Adicione um em Mensagens → Modelos.",
        "overrideHint": "Deixe em branco para enviar o modelo tal como está. O que escrever aqui substitui o corpo do modelo.",
        "overrideLabel": "Mensagem personalizada (opcional)",
        "overridePlaceholder": "Adicione uma nota pessoal antes de enviar…",
        "recommended": "Recomendado",
        "send": "Enviar lembrete",
        "sending": "A enviar…",
        "sent": "“{{name}}” enviado",
        "templateLabel": "Modelo",
        "title": "Enviar um lembrete"
      },
      "mobility": {
        "blocked": "Bloqueado",
        "blockers": {
          "onTrack": "Em andamento — sem bloqueios ou tarefas em atraso.",
          "blockedTracks_one": "{{count}} pista bloqueada",
          "blockedTracks_other": "{{count}} pistas bloqueadas",
          "overdueTasks_one": "{{count}} tarefa em atraso",
          "overdueTasks_other": "{{count}} tarefas em atraso"
        },
        "docStatus": {
          "pending": "Pendente",
          "uploaded": "Carregado",
          "validated": "Validado",
          "rejected": "Rejeitado",
          "missing": "Em falta"
        },
        "documents": {
          "title": "Documentos",
          "otherTrack": "Outro",
          "certified": "Certificado",
          "expiringSoon": "A expirar em breve",
          "downloadAll": "Descarregar tudo",
          "downloadSelected": "Transferir {{count}}",
          "downloadError": "Não foi possível transferir os documentos.",
          "select": "Selecionar documento",
          "withheldBody": "Este cidadão não partilhou os seus documentos com a sua empresa. A lista abaixo continua correta — o que já não pode ser descarregado são os ficheiros em si."
        },
        "error": "Não foi possível carregar os dados de mobilidade.",
        "header": {
          "title": "Percurso de realocação",
          "subtitle": "Tarefas, documentos e marcos em cada pista"
        },
        "noTracks": "Nenhuma pista de mobilidade foi iniciada ainda.",
        "nudge": "Enviar lembrete de mobilidade",
        "progress": "{{percent}}% completo",
        "taskStatus": {
          "pending": "A fazer",
          "in_progress": "Em progresso",
          "completed": "Completo",
          "blocked": "Bloqueado",
          "skipped": "Ignorado",
          "archived": "Arquivado"
        },
        "tasks": {
          "title": "Tarefas de talento",
          "talent": "Talento",
          "otherTrack": "Outro",
          "blocking": "Bloqueante",
          "blockedBy": "Bloqueado por {{count}}",
          "overdue": "Atrasado",
          "certified": "Certificado",
          "docCount_one": "{{count}} documento",
          "docCount_other": "{{count}} documentos",
          "location": {
            "home_country": "País de origem",
            "target_country": "Destino",
            "online": "Online",
            "either": "Qualquer"
          },
          "ownership": {
            "company": "Empresa",
            "government": "Governo",
            "dual": "Partilhado"
          }
        },
        "timeline": {
          "title": "Marcos",
          "summary": "{{reached}} de {{total}} alcançados",
          "reached": "Alcançado"
        }
      },
      "adaptation": {
        "error": "Não foi possível carregar os dados de adaptação.",
        "header": {
          "assessedOn": "Avaliado em {{date}}",
          "miles": "Miles",
          "missions": "Missões",
          "notAssessed": "Não avaliado",
          "streak": "Série",
          "streakDays": "{{count}}d",
          "timeLearning": "Tempo de aprendizagem",
          "title": "Adaptação"
        },
        "overviewTab": "Visão geral",
        "tracksTab": "Mundos & pistas",
        "thisWeek": "Esta semana",
        "ariaWeekly": "Gráfico de envolvimento semanal",
        "missionsProgress": "{{completed}} de {{total}} missões",
        "tracksProgress": "{{completed}}/{{total}} pistas",
        "noWorlds": "Nenhum mundo QultureUp iniciado ainda.",
        "tracksTitle": "Mundos & pistas",
        "levelAll": "Todos",
        "noTracksForLevel": "Nenhuma pista neste nível.",
        "noMissions": "Nenhuma missão nesta pista ainda.",
        "recommendedNext": "Recomendado a seguir",
        "status": {
          "completed": "Completo",
          "in_progress": "Em progresso",
          "locked": "Bloqueado",
          "not_started": "Não iniciado"
        },
        "suggest": "Sugerir",
        "suggestionSent": "Sugerido “{{mission}}” — enviado por email",
        "worldsTitle": "Mundos",
        "missionsCount_one": "missão",
        "missionsCount_other": "missões"
      },
      "evidence": {
        "error": "Não foi possível carregar os dados de evidência.",
        "export": {
          "title": "Registo de percurso",
          "description": "Exportar o registo completo do percurso do talento como relatório PDF ou ficheiro CSV.",
          "pdf": "Exportar PDF",
          "csv": "Exportar CSV"
        },
        "header": {
          "title": "Percurso Passport",
          "subtitle": "Selos, distintivos e milhas acumuladas ao longo do percurso",
          "miles": "Total de Miles",
          "level": "Nível Citizen",
          "stamps": "Selos",
          "badges": "Emblemas",
          "thisWeek": "Esta semana"
        }
      },
      "care": {
        "checkins": {
          "empty": "Ainda não houve check-ins.",
          "last30Days": "Últimos 30 dias",
          "lastCheckin": "Último check-in {{date}}",
          "moodTrend": "Tendência de humor",
          "privacyNote": "As entradas individuais de humor permanecem privadas para o talento — apenas a frequência e a tendência são mostradas.",
          "streak": "Série de dias",
          "title": "Atividade de check-in",
          "trend": {
            "down": "A cair",
            "stable": "Estável",
            "up": "A subir"
          }
        },
        "commitment": {
          "component": {
            "careResponsiveness": "Care responsividade",
            "checkinConsistency": "Consistência de check-in",
            "engagementLevel": "Envolvimento",
            "integrationProgress": "Progresso de integração",
            "pillarStability": "Estabilidade do pilar",
            "tenureStability": "Estabilidade de permanência"
          },
          "empty": "O Índice de Compromisso aparecerá uma vez que o talento tenha check-ins ou pontos de verificação.",
          "history": {
            "empty": "Histórico ainda não suficiente — a linha de tendência aparece após um segundo cálculo.",
            "range": "{{min}}–{{max}}",
            "title": "Histórico do índice",
            "ariaLabel_one": "Histórico do Índice de Compromisso, {{count}} ponto de dados de {{min}} a {{max}}",
            "ariaLabel_other": "Histórico do Índice de Compromisso, {{count}} pontos de dados de {{min}} a {{max}}"
          },
          "level": {
            "at_risk": "Em risco",
            "champion": "Campeão",
            "committed": "Comprometido",
            "engaged": "Envolvido",
            "flight_risk": "Risco de saída"
          },
          "noRisks": "Sem sinais de risco ativos.",
          "risks": "Sinais de risco",
          "risksRestricted": "Os sinais de risco estão restritos nesta empresa. Fale com um administrador se precisar deles.",
          "title": "Índice de compromisso",
          "trend": {
            "declining": "Em declínio",
            "improving": "A Melhorar",
            "stable": "Estável"
          }
        },
        "checkpoints": {
          "empty": "Ainda não há pontos de verificação agendados.",
          "status": {
            "cancelled": "Cancelado",
            "completed": "Completo",
            "due": "Devido",
            "in_progress": "Em curso",
            "overdue": "Atrasado",
            "scheduled": "Agendado",
            "skipped": "Ignorado"
          },
          "title": "Checkpoints"
        },
        "error": "Não foi possível carregar os dados de cuidado.",
        "header": {
          "title": "Care",
          "stage": "Fase: {{stage}}"
        },
        "pillars": {
          "concerns": "Preocupações:",
          "empty": "Ainda não há pilares de bem-estar.",
          "title": "Pilares de bem-estar"
        },
        "interventions": {
          "empty": "Ainda não há intervenções agendadas.",
          "loadError": "Não foi possível carregar as intervenções.",
          "past": "Passado",
          "retry": "Tente novamente",
          "subtitle": "Agende seguimentos de cuidados recorrentes ou únicos para este talento.",
          "title": "Care intervenções",
          "upcoming": "Próximos"
        },
        "withheldBody": "Este cidadão não partilhou o seu registo Care com a sua empresa. A pontuação de bem-estar, os pilares e os checkpoints estão retidos. As intervenções apresentadas abaixo são o registo da própria empresa sobre o que enviou."
      },
      "consent": {
        "withheld": {
          "srLabel": "Retido — não partilhado por este cidadão",
          "tooltip": "Este cidadão não partilhou esta informação com a sua empresa. Está retida, não é zero.",
          "title": "Retido pelo cidadão",
          "body": "Este cidadão não partilhou esta informação com a sua empresa. Está retida — não é zero nem está em falta.",
          "householdGroup": "Membro do agregado — nome retido"
        }
      },
      "checkup": {
        "withheldBody": "Este cidadão não partilhou o seu CheckUp com a sua empresa. As pontuações, a análise MESH e a análise do pitch estão retidas — não estão em falta nem são zero.",
        "completedOn": "CheckUp concluído a {{date}}",
        "awaitingConsentBody": "{{name}} concluiu o CheckUp e não partilhou o resultado com a sua empresa. A decisão de o partilhar cabe ao talento. Até lá, as pontuações, a análise MESH e a análise do pitch estão retidas — não estão em falta nem são zero.",
        "withdrawnBody": "{{name}} deixou de partilhar o resultado do CheckUp com a sua empresa. As pontuações, a análise MESH e a análise do pitch estão retidas — não estão em falta nem são zero."
      }
    },
    "askTonnieServices": {
      "budgetLabel": "Intervalo de orçamento (opcional)",
      "budgetPlaceholder": "Se tiver um intervalo de orçamento em mente, por favor partilhe...",
      "description": "Peça Tonnie para lidar com todo o processo de forma turn-key (Pacote Tonnie). Os Serviços Tonnie elaborarão uma proposta para a sua aprovação.",
      "descriptionLabel": "Descrição das necessidades",
      "descriptionPlaceholder": "Descreva as suas necessidades e requisitos específicos...",
      "scopes": {
        "adaptationDesc": "QultureUp e adaptação cultural",
        "adaptationLabel": "Adaptação",
        "careDesc": "Suporte pós-chegada e Care",
        "careLabel": "Care & estabilidade",
        "hireDesc": "Aquisição e sourcing de talentos",
        "hireLabel": "Contratar",
        "mobilityDesc": "Visto, viagem e realocação",
        "mobilityLabel": "Mobilidade",
        "sponsorDesc": "Decisões de avaliação e patrocínio",
        "sponsorLabel": "Patrocinador"
      },
      "serviceScopeHint": "Selecione as partes do processo que gostaria que a Tonnie gerisse:",
      "serviceScopeLabel": "Escopo do serviço",
      "submitFailed": "Falha ao submeter pedido",
      "submitRequest": "Submeter pedido",
      "submitSuccess": "Pedido submetido — os Serviços Tonnie vão contactá-lo em breve",
      "submitting": "A submeter…",
      "timelineLabel": "Expectativas de cronograma",
      "timelinePlaceholder": "Quando precisa que isto seja concluído? Algum prazo específico?",
      "title": "Pergunte aos serviços Tonnie",
      "whatHappensNextBody": "Os serviços Tonnie irão rever o seu pedido e elaborar uma proposta (taxa diária / honorários / pacote) para a sua aprovação. Uma vez aprovada, o modo Pack Tonnie será ativado e o progresso será refletido no seu pipeline.",
      "whatHappensNextTitle": "O que acontece a seguir?"
    },
    "auth": {
      "backToSignIn": "Voltar ao início de sessão",
      "inviteRoleAdmin": "Admin",
      "inviteRoleMember": "Membro da equipa",
      "joinCompanySubtitle": "Crie a sua conta para se juntar como {{role}}",
      "joinCompanyTitle": "Junte-se à {{company}}",
      "noAccess": {
        "acceptInvitation": "Aceitar um convite",
        "contactAdmin": "Contacte o seu administrador",
        "description": "Está autenticado como {{email}}, mas esta conta ainda não tem acesso ao Tonnie Business.",
        "hint": "Peça a um colega de equipa para o convidar, aceite um convite pendente ou saia para usar uma conta diferente.",
        "signingOut": "A sair…",
        "switchAccount": "Sair e usar uma conta diferente",
        "title": "Sem acesso a negócios"
      },
      "signUp": "Registar"
    },
    "billing": {
      "statusLabel": {
        "active": "Ativo",
        "pending": "Pendente",
        "paid": "Pago",
        "cancelling": "A cancelar",
        "cancelled": "Cancelado",
        "past_due": "Vencido",
        "overdue": "Atrasado",
        "failed": "Falhou",
        "completed": "Completo"
      },
      "active": "Ativo",
      "activeSponsorships": "Patrocínios ativos",
      "checkoutCancelled": "Checkout cancelado",
      "checkoutSuccessPending": "Pagamento recebido — a sua conta será atualizada em breve.",
      "checkoutSuccessVerified": "Pagamento confirmado — a sua conta foi atualizada.",
      "checkoutVerifyError": "Recebemos o seu pagamento, mas não conseguimos confirmá-lo em tempo real. Atualize daqui a pouco.",
      "coPilot": "CoPilot",
      "cohorts": "Coortes",
      "description": "O seu plano, patrocínios, faturas e método de pagamento",
      "downgradeDialog": {
        "confirmDowngrade": "Confirmar desclassificação",
        "description": "Veja o que muda antes de passar para um plano inferior",
        "discountedRate": "Taxa com desconto",
        "keepEnterprise": "Manter Enterprise",
        "loseAccess": "Perderá acesso a:",
        "periodEndNote": "O Enterprise mantém-se ativo até ao fim do período já pago; depois, a empresa passa para o plano Gratuito.",
        "sponsorshipNote": "Nota: os patrocínios ativos continuam à taxa atual até expirarem. Os novos patrocínios serão cobrados à taxa do plano Gratuito.",
        "title": "Diálogo de desclassificação",
        "unlimitedProgramsCohorts": "Cohortes de programas ilimitados",
        "unlimitedTeam": "Equipa ilimitada"
      },
      "downgradeFailed": "Não foi possível cancelar a subscrição.",
      "downgradeSuccess": "Desclassificado para o plano Gratuito. Algumas funcionalidades estão agora limitadas.",
      "downgradeScheduled": "O Enterprise termina a {{date}}. Até lá, nada muda.",
      "enterprisePlanMissing": "Plano Enterprise não configurado. Contacte o suporte.",
      "familyAccessDesc": "O acesso familiar inclui membros do agregado familiar na mesmo percurso.",
      "familyAddonToggled": "Addon familiar {{action}} para {{name}}",
      "familyToggleFailed": "Não foi possível alternar o acesso familiar.",
      "invoices": {
        "description": "Todas as faturas da sua empresa, prontas a transferir",
        "empty": "Ainda sem faturas",
        "emptyHint": "As faturas aparecerão após o seu primeiro pagamento.",
        "title": "Faturas",
        "view": "Ver",
        "viewAllInStripe": "Ver todas em Stripe",
        "paymentReference": "Ref. de pagamento {{reference}}",
        "refunded": "Reembolsado {{amount}}",
        "documentUnavailable": "Não foi possível abrir este documento agora. Tente novamente."
      },
      "limitedFeaturesDesc": "O que o seu plano atual não inclui",
      "managePlan": "Gerir plano",
      "monthlySpend": "Gasto mensal",
      "nextInvoice": "Próxima fatura",
      "payment": {
        "addressLabel": "Endereço de faturação",
        "billingSummary": "Resumo da faturação",
        "currency": "Moeda",
        "dueOn": "Vencimento {{date}}",
        "enterpriseSubscription": "Subscrição Enterprise",
        "nextInvoiceEstimate": "Estimativa da próxima fatura",
        "noAddress": "Sem endereço registado",
        "openStripePortal": "Abrir portal Stripe",
        "paymentsSecuredBy": "Pagamentos garantidos por",
        "portalSummary": "Abra o portal de faturação para gerir a sua subscrição, métodos de pagamento e faturas.",
        "securePaymentVia": "Pagamento seguro via"
      },
      "planLabel": "Plano {{plan}}",
      "planUpdated": "O seu plano foi atualizado. Nenhum novo pagamento é necessário.",
      "plans": {
        "anonymizedReporting": "Relatórios anonimizados",
        "breakEvenPoint": "Ponto de equilíbrio",
        "checkupTeleportalQultureupCare": "CheckUp, TelePortal, QultureUp e Care",
        "complianceAuditTools": "Ferramentas de auditoria de conformidade",
        "contactSales": "Contactar vendas",
        "currentPlan": "Plano atual",
        "custom": "Personalizado",
        "customIntegrations": "Integrações personalizadas",
        "customJourneyTemplates": "Modelos de percurso personalizados",
        "dedicatedSupport": "Suporte dedicado",
        "downgradeToFree": "Descer para gratuito",
        "eachSponsorshipIncludes": "Cada patrocínio inclui",
        "enterprise": "Empresa",
        "enterpriseRate": "Taxa empresarial",
        "familyAccessOptional": "Acesso familiar opcional",
        "free": "Gratuito",
        "freePlanRate": "Taxa do plano gratuito",
        "fullJourneyCitizenAccess": "Acesso completo ao percurso Citizen",
        "fullMobilityAdaptation": "Adaptação completa à mobilidade",
        "fullMobilityAdaptationTitle": "Mobilidade e adaptação completa",
        "getStarted": "Começar",
        "government": "Governo",
        "governmentContactDesc": "Contacte a nossa equipa de vendas para configurar um contrato personalizado para programas públicos.",
        "intelligenceDesc": "Desbloqueie suporte completo à Mobilidade e Adaptação com análises avançadas e acesso à API.",
        "inviteWholeTeamDesc": "Convide toda a sua equipa com lugares, programas e coortes ilimitados.",
        "mobilityAdaptationLocked": "Adaptação à mobilidade bloqueada",
        "multiYearContracts": "Contratos de vários anos",
        "percentOff": "{{percent}}% de desconto",
        "passportAchievements": "Conquistas Passport",
        "perTalentJourney": "Por percurso de talento",
        "perTalentPerMonth": "Por talento por mês",
        "publicPrograms": "Programas públicos",
        "quickRoi": "Roi rápido",
        "recommended": "Recomendado",
        "savePercent": "Poupe {{percent}}%",
        "savePerYear": "Poupe em patrocínios",
        "scaleYourMobility": "Escale a sua mobilidade",
        "sponsorship": "Patrocínio",
        "sponsorshipRate": "Taxa de patrocínio",
        "sponsorshipsDropDesc": "As taxas de patrocínio descem para o nível Empresarial, por isso cada percurso de talento custa menos.",
        "tailoredToYourNeeds": "Adaptado às suas necessidades",
        "unlimitedTeamScale": "Escala de equipa ilimitada",
        "whyUpgrade": "Por que atualizar",
        "totalSuffix": "total",
        "sponsorshipMonthlyCaption_one": "{{rate}}/mês · acesso de {{count}} mês",
        "sponsorshipMonthlyCaption_other": "{{rate}}/mês · acesso de {{count}} meses",
        "sponsorshipRateError": "Não foi possível carregar a taxa de patrocínio. Por favor, atualize."
      },
      "portalUnavailable": "O Portal do Cliente Stripe ainda não está disponível. Complete uma compra primeiro.",
      "programs": "Programas",
      "redirectingToStripe": "A redirecionar para a checkout Stripe...",
      "renewsOn": "Renova em {{date}}",
      "enterpriseEndsOn": "O Enterprise termina a {{date}}",
      "sponsorships": {
        "access": "Acesso",
        "activeSponsorships": "Patrocínios ativos",
        "addFamilyAccess": "Adicionar acesso familiar",
        "description": "Os percursos que a sua empresa patrocina, com datas e custo",
        "empty": "Ainda sem patrocínios",
        "enterpriseDiscount": "Desconto empresarial",
        "family": "Família",
        "removeFamilyAccess": "Remover acesso familiar",
        "title": "Patrocínios",
        "totalSponsored": "Total patrocinado",
        "rowActionsAria": "Ações para {{name}}",
        "viewDetails": "Ver detalhes",
        "yourRate": "A sua taxa",
        "accessMonths_one": "{{count}} mês",
        "accessMonths_other": "{{count}} meses",
        "monthsLeft_one": "{{count}} mês restante",
        "monthsLeft_other": "{{count}} meses restantes",
        "journeyProgress": "Progresso do percurso"
      },
      "subscriptionError": "Não foi possível carregar a assinatura. Por favor, atualize.",
      "tabs": {
        "invoices": "Faturas",
        "payment": "Pagamento",
        "plans": "Planos",
        "sponsorships": "Patrocínios",
        "fiscal": "Faturação certificada"
      },
      "title": "Faturação",
      "totalSponsored": "Total patrocinado",
      "unlimitedAccessDesc": "Tudo o que o seu plano inclui, sem limites",
      "upgradeDialog": {
        "continueToPayment": "Continuar para pagamento",
        "description": "Desbloquear assentos ilimitados, candidatos, programas e suporte total à mobilidade.",
        "monthlyLabel": "Mensal",
        "saveYearly": "Poupe {{amount}} por ano",
        "whatYouGet": "O que recebe",
        "yearlyLabel": "Anual"
      },
      "upgradeFailed": "Não foi possível iniciar o checkout. Por favor, tente novamente.",
      "upgradeToEnterprise": "Atualizar para Enterprise",
      "vetting": "Verificação",
      "stage": {
        "preMobility": "Pré-Mobilidade",
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care",
        "stable": "Estável"
      },
      "planUnavailable": "Este plano não pode ser adquirido neste momento. Contacte o suporte, por favor.",
      "details": {
        "title": "Dados de faturação",
        "description": "A quem são emitidas as faturas da empresa. Uma alteração aplica-se ao próximo pagamento.",
        "edit": "Editar",
        "legalName": "Denominação social",
        "taxId": "NIF / número de IVA",
        "country": "País de faturação",
        "countryPlaceholder": "Escolha um país",
        "addressLine1": "Morada",
        "addressLine2": "Morada (continuação)",
        "postalCode": "Código postal",
        "city": "Localidade",
        "save": "Guardar",
        "saveAndContinue": "Guardar e continuar para o pagamento",
        "saveFailed": "Não foi possível guardar os dados de faturação. Tente de novo.",
        "beforePaymentTitle": "Dados para a fatura",
        "beforePaymentDescription": "Cada pagamento tem uma fatura-recibo emitida à sua empresa. Complete os dados e seguimos para o pagamento."
      },
      "fiscal": {
        "title": "Faturação certificada — reconciliação",
        "description": "Cada pagamento da plataforma e a sua fatura-recibo, em todas as empresas e cidadãos. Só a equipa Tonnie vê isto.",
        "enabled": "Emissão ligada",
        "disabled": "Emissão desligada",
        "providerJasmin": "Jasmin",
        "providerSimulated": "Simulado — nada real é emitido",
        "issueFrom": "Emissão desde {{date}}",
        "configMissing": "Configuração em falta ou inválida",
        "count": {
          "issued": "Emitidas",
          "pending": "Pendentes",
          "failed": "Falhadas",
          "creditNotesPending": "Notas de crédito por emitir",
          "retroactive": "Pagamentos anteriores por faturar"
        },
        "attentionTitle": "Precisa de alguém",
        "attentionEmpty": "Nada precisa de atenção.",
        "reason": {
          "failed": "Não foi possível emitir a fatura-recibo",
          "pending": "À espera há mais de uma hora",
          "creditNotePending": "Reembolsado — emita a nota de crédito no Jasmin"
        },
        "refunded": "{{amount}} reembolsados",
        "retry": "Tentar de novo",
        "creditNoteIssued": "Nota de crédito emitida",
        "done": "Feito.",
        "actionFailed": "Não resultou. Tente de novo.",
        "loadFailed": "Não foi possível carregar a reconciliação.",
        "alert": {
          "nextYearSeriesMissing": "A série de {{year}} ainda não está configurada — crie-a e comunique-a no Jasmin antes de 31 de dezembro.",
          "euConsumerThreshold": "Vendas a consumidores de outros países da UE em {{year}}: {{amount}} do limiar de {{threshold}} — decida o OSS com a contabilista.",
          "failedDocuments_one": "{{count}} fatura-recibo falhou — ver abaixo.",
          "failedDocuments_other": "{{count}} faturas-recibo falharam — ver abaixo."
        }
      }
    },
    "businessMessages": {
      "analytics": {
        "attemptedCount_one": "{{count}} tentativa",
        "attemptedCount_other": "{{count}} tentativas",
        "byEngagement": "Por envolvimento",
        "channelPerformance": "Desempenho do canal",
        "channelPerformanceDesc": "Como cada canal entrega e é aberto",
        "deliveryRate": "Taxa de entrega",
        "messagesByCategory": "Mensagens por categoria",
        "messagesByCategoryDesc": "Mensagens enviadas em cada categoria",
        "noChannelDataYet": "Ainda não foi enviada nenhuma mensagem — as taxas aparecem aqui assim que a primeira sair.",
        "noTemplatesYet": "Crie o seu primeiro template para ver aqui o envolvimento.",
        "openRate": "Taxa de abertura",
        "templatesCount_one": "{{count}} modelo",
        "templatesCount_other": "{{count}} modelos",
        "topTemplates": "Templates principais"
      },
      "cohortAllSuppressed": "Ninguém recebeu esta mensagem — todos nesta coorte desativaram estes e-mails.",
      "cohortSentWithSuppressed": "Enviada para {{queued}}. {{suppressed}} não receberam — desativaram estes e-mails.",
      "suppressedByPreferenceGeneric": "O destinatário desativou estes e-mails — não foi enviado nada",
      "suppressedByPreference": "{{name}} desativou estes e-mails — não foi enviado nada",
      "channels": {
        "channelIntegrations": "Integrações de canal",
        "channelIntegrationsDesc": "Os canais por onde as suas mensagens podem sair",
        "comingSoon": "Em breve",
        "configure": "Configurar",
        "connected": "Ligado",
        "delivered": "Entregues",
        "email": "Email",
        "getHelp": "Obter ajuda",
        "openRate": "Taxa de abertura",
        "opened": "Aberto",
        "push": "Push",
        "setupRequired": "Configuração necessária",
        "sms": "SMS",
        "test": "Teste",
        "viewDocumentation": "Ver documentação",
        "whatsapp": "WhatsApp",
        "names": {
          "email": "Email",
          "whatsapp": "WhatsApp",
          "sms": "SMS",
          "push": "Citizen push"
        },
        "descriptions": {
          "email": "Envie emails HTML ricos com anexos e rastreamento",
          "whatsapp": "Envie mensagens WhatsApp via Business API",
          "sms": "Envie mensagens SMS para notificações urgentes",
          "push": "Notificações push para a aplicação móvel Citizen"
        },
        "attempts": "Tentativas"
      },
      "composer": {
        "bold": "Negrito (**texto**)",
        "boldHtml": "Negrito (<strong>texto</strong>)",
        "boldShort": "Negrito",
        "channelsLabel": "Canais de entrega",
        "formattingToolbar": "Formatação de texto",
        "italic": "Itálico (*texto*)",
        "italicHtml": "Itálico (<em>texto</em>)",
        "italicShort": "Itálico",
        "link": "Link ([texto](url))",
        "linkHtml": "Link (<a href=\"…\">texto</a>)",
        "linkShort": "Ligar",
        "message": "Mensagem",
        "messageBodyHtml": "Corpo da mensagem (HTML)",
        "messagePlaceholder": "Escreva a sua mensagem aqui…",
        "noSubject": "(sem assunto)",
        "noTemplate": "Mensagem em branco — escreva a sua própria",
        "previewDesktop": "Desktop",
        "previewEmpty": "Comece a escrever para ver a pré-visualização.",
        "previewLabel": "Pré-visualização ao vivo",
        "previewMobile": "Móvel",
        "previewPlain": "Texto simples",
        "recipientsCount_one": "{{count}} destinatário",
        "recipientsCount_other": "{{count}} destinatários",
        "rendering": "A gerar…",
        "startFromTemplate": "Começar a partir de um modelo (opcional)",
        "subject": "Assunto",
        "subjectPlaceholder": "Um lembrete amigável — o seu CheckUp está à espera",
        "tagsLabel": "Inserir uma etiqueta",
        "tagsUsed": "Usado nesta mensagem",
        "templatePlaceholder": "Escolha um modelo ou deixe em branco",
        "viaEmail": "Email"
      },
      "description": "Modelos, envios e entregas de cada mensagem da sua empresa",
      "editor": {
        "bodyRequired": "O corpo é obrigatório",
        "bodyTooLong": "O corpo é demasiado longo",
        "cancel": "Cancelar",
        "category": "Categoria",
        "channelRequired": "Selecione pelo menos um canal",
        "createNewTemplate": "Criar novo modelo",
        "editTemplate": "Editar modelo",
        "editorDescription": "Configure o seu modelo de mensagem com canais, conteúdo e etiquetas de personalização.",
        "hintPlain": "Use a barra de ferramentas (ou **negrito**, *itálico*, [link](url)) para formatação. Use {{variable}} como marcadores para inserir valores dinâmicos.",
        "nameRequired": "O nome é obrigatório",
        "nameTooLong": "O nome é muito longo",
        "saveChanges": "Guardar alterações",
        "saving": "A guardar…",
        "sendTest": "Enviar teste",
        "templateName": "Nome do modelo",
        "templateNamePlaceholder": "Introduza o nome do modelo...",
        "testSendSaveFirst": "Guarde as suas alterações antes de enviar um teste",
        "testSending": "A enviar teste…",
        "unsaved": "Alterações não guardadas",
        "unsavedConfirm": "Tem alterações não guardadas. Descartá-las e continuar?"
      },
      "newTemplate": "Novo modelo",
      "stats": {
        "activeTemplates": "Modelos ativos",
        "avgOpenRate": "Taxa média de abertura",
        "delivered": "Entregues",
        "sendAttempts": "Tentativas de envio"
      },
      "tabs": {
        "analytics": "Análises",
        "channels": "Canais",
        "messageTemplates": "Modelos de mensagem"
      },
      "templates": {
        "activated": "Modelo ativado",
        "allCategories": "Todas as categorias",
        "allChannels": "Todos os canais",
        "createFailed": "Não foi possível criar o modelo",
        "createFirstTemplate": "Criar primeiro modelo",
        "createTemplate": "Criar modelo",
        "created": "Modelo criado",
        "deactivated": "Modelo desativado",
        "delete": "Eliminar",
        "deleteFailed": "Não foi possível eliminar o modelo",
        "deleteTitle": "Eliminar modelo?",
        "deleteWarning": "Isto remove permanentemente \"{{name}}\". Esta ação não pode ser desfeita.",
        "deleted": "Modelo eliminado",
        "deleting": "A eliminar…",
        "duplicate": "Duplicar",
        "duplicateFailed": "Não foi possível duplicar o modelo",
        "duplicated": "Modelo duplicado",
        "edit": "Editar",
        "filterCategory": "Categoria",
        "filterChannel": "Canal",
        "inactive": "Inativo",
        "loadError": "Não foi possível carregar os modelos.",
        "noTemplatesFound": "Nenhum modelo encontrado",
        "restoreDefault": "Restaurar padrão",
        "restoreFailed": "Falha ao restaurar o modelo padrão",
        "restored": "Modelo padrão restaurado",
        "saveFailed": "Não foi possível guardar o modelo",
        "saved": "Modelo guardado",
        "searchPlaceholder": "Pesquisar...",
        "sendTest": "Enviar teste",
        "testSendFailed": "Falha ao enviar a mensagem de teste",
        "testSent": "Mensagem de teste enviada",
        "toggleFailed": "Não foi possível atualizar o estado do template",
        "tryAdjustingSearch": "Tente ajustar a pesquisa",
        "talentTagWithoutSubject": "Esta mensagem é enviada à sua equipa sem se referir a nenhum talento, por isso {{tags}} não tem ninguém a quem se referir. Use {{readerTag}} para se dirigir ao leitor.",
        "activeToggle": "Ativo: {{name}}",
        "moreActions": "Mais ações para {{name}}",
        "alwaysOn": "Sempre ativo: a plataforma envia ela própria os emails de conta e segurança.",
        "sourceDuplicate": "Duplicado",
        "sourceCustom": "Personalizado",
        "sourceCustomized": "Alterado",
        "sourceSystem": "Predefinido",
        "deliveredCount_one": "{{count}} entregue",
        "deliveredCount_other": "{{count}} entregues",
        "opened_one": "{{count}} aberto",
        "opened_other": "{{count}} abertos",
        "sent_one": "{{count}} enviado",
        "sent_other": "{{count}} enviados",
        "searchLabel": "Pesquisar modelos"
      },
      "title": "Mensagens",
      "categories": {
        "names": {
          "vetting": "Verificação",
          "sponsorship": "Patrocínio",
          "mobility": "Mobilidade",
          "adaptation": "Adaptação",
          "care": "Care",
          "evidence": "Evidência",
          "general": "Geral",
          "account": "Conta e segurança",
          "fiscal_document": "Faturas",
          "inout": "Avisos InOut",
          "inout_agency": "Correio para a assessoria",
          "qultureup": "Avisos QultureUp"
        },
        "descriptions": {
          "vetting": "CheckUp convites, resultados e acompanhamentos",
          "sponsorship": "Convites de percurso e comunicações de patrocínio",
          "mobility": "TelePortal tarefas, documentos e atualizações de status",
          "adaptation": "QultureUp missões e recomendações de aprendizagem",
          "care": "Check-ins, intervenções e apoio ao bem-estar",
          "evidence": "Passport atualizações, emblemas e conquistas",
          "general": "Anúncios gerais e mensagens personalizadas",
          "account": "Códigos e avisos de segurança que a plataforma envia. Chegam às pessoas independentemente das suas definições de notificação.",
          "fiscal_document": "O aviso que a plataforma envia quando a fatura-recibo de um pagamento é emitida. Chega a todos, sejam quais forem as definições de notificações.",
          "inout": "Avisos sobre o registo de residência de uma pessoa: um limite a aproximar-se, uma pergunta de presença, uma janela de renovação. A plataforma envia-os; cada pessoa escolhe como nas definições do InOut.",
          "inout_agency": "O que a plataforma envia sobre o ticket de uma pessoa com uma assessoria — à caixa de tickets da assessoria ou à da Tonnie — a pedido dessa pessoa. Chega sejam quais forem as definições de notificações.",
          "qultureup": "Avisos sobre o progresso de uma pessoa num World do QultureUp com um parceiro (a Languages Academy): uma missão concluída, um nível ou a meta alcançados, um lembrete após algum tempo parado. A plataforma envia-os; cada pessoa escolhe como nas suas definições de notificações."
        }
      },
      "variables": {
        "talentFirstName": "Primeiro nome do talento",
        "talentLastName": "Último nome do talento",
        "talentFullName": "Nome completo do talento",
        "talentEmail": "Endereço de email do talento",
        "recipientFirstName": "Primeiro nome do destinatário",
        "recipientLastName": "Último nome do destinatário",
        "recipientFullName": "Nome completo do destinatário",
        "recipientEmail": "Endereço de email do destinatário",
        "talentRole": "Função do talento",
        "companyName": "Nome da empresa patrocinadora",
        "companyContact": "Pessoa de contacto da empresa",
        "programName": "Nome do programa",
        "cohortName": "Nome do grupo",
        "journeyStage": "Estágio atual do percurso",
        "checkupBadge": "iQulture nível de emblema",
        "mobilityArrivalDate": "Data estimada de chegada",
        "mobilityNextTask": "Próxima tarefa de mobilidade",
        "missionName": "QultureUp nome da missão",
        "actionUrl": "URL/link da ação",
        "actionDeadline": "Prazo da ação"
      },
      "cohortRecipientCount_one": "{{count}} membro",
      "cohortRecipientCount_other": "{{count}} membros",
      "cohortSent_one": "Mensagem enviada para {{count}} pessoa.",
      "cohortSent_other": "Mensagem enviada para {{count}} pessoas."
    },
    "businessNotifications": {
      "allCaughtUp": "Tudo em dia",
      "allNotifications": "Todas as notificações",
      "allTab": "Todas ({{count}})",
      "delete": "Eliminar",
      "deleteCount": "Eliminar ({{count}})",
      "filter": "Filtrar",
      "markAllRead": "Marcar tudo como lido",
      "markAsRead": "Marcar como lido",
      "new": "Novo",
      "noNotifications": "Sem notificações",
      "noNotificationsDesc": "A nova atividade dos seus talentos aparecerá aqui",
      "noUnreadNotifications": "Sem notificações não lidas",
      "selectAll": "Selecionar tudo",
      "settings": "Definições",
      "summary": {
        "completed": "Completo",
        "unread": "Não lidas",
        "urgent": "Urgente",
        "warnings": "Avisos"
      },
      "title": "Notificações",
      "unreadTab": "Não lido ({{count}})",
      "unreadUrgent": "{{unread}} não lido, {{urgent}} urgente",
      "urgentBadge": "Distintivo urgente",
      "viewDetails": "Ver detalhes",
      "viewDetailsButton": "Botão ver detalhes",
      "categories": {
        "all": "Todos",
        "mobility": "Mobilidade",
        "care": "Care",
        "vetting": "Verificação",
        "evidence": "Evidência",
        "cohorts": "Coortes"
      },
      "unreadCount_one": "{{count}} notificação não lida",
      "unreadCount_other": "{{count}} notificações não lidas",
      "actionsFor": "Ações para “{{title}}”",
      "selectNotification": "Selecionar “{{title}}”"
    },
    "businessOnboarding": {
      "addTalents": {
        "addFromATSOrExcel": "Adicionar candidatos do seu ATS ou carregar um ficheiro Excel/CSV",
        "addTalentsButton": "Adicionar talentos",
        "added": "Adicionado",
        "afterOnboarding": "Após completar a integração, convide estes talentos para o CheckUp a partir do menu de Aquisição",
        "emptyStateDescription": "Importar candidatos do seu ATS ou carregar um ficheiro Excel/CSV. Um coorte padrão será criado automaticamente.",
        "importDescription": "Importe os seus candidatos para começar. Os talentos importados aparecerão no menu de Aquisição, onde poderá convidá-los para CheckUp (vetting). Um coorte padrão será criado automaticamente quando adicionar os seus primeiros talentos.",
        "importTalents": "Importar talentos",
        "startImport": "Iniciar importação",
        "step1": "Selecione um grupo de talentos para convidar para CheckUp (vetting e avaliação)",
        "step2": "Após a conclusão do CheckUp, pode patrocinar talentos avaliados e definir a sua rota de migração",
        "step3": "Os talentos patrocinados iniciarão o percurso através de: Mobilidade -> Adaptação -> Care -> Evidência",
        "step4": "Organize as suas iniciativas de contratação com programas e coortes, a qualquer momento",
        "step5": "Use o CoPilot para operações guiadas e suporte durante todo o processo",
        "title": "Adicionar talentos",
        "whatsNext": "Qual é o próximo passo?",
        "whatsNextDescription": "Após importar talentos, eles aparecerão no menu de Aquisição. A partir daí:",
        "readyForCheckUp_one": "{{count}} talento pronto para o CheckUp",
        "readyForCheckUp_other": "{{count}} talentos prontos para o CheckUp",
        "talentsAdded_one": "{{count}} talento adicionado",
        "talentsAdded_other": "{{count}} talentos adicionados"
      },
      "additionalDetails": {
        "billing": {
          "billingAddressHint": "Usado para faturas e notificações de faturação",
          "billingAddressLabel": "Endereço de faturação",
          "billingAddressPlaceholder": "Endereço da rua",
          "businessTypeLabel": "Tipo de negócio",
          "city": "Cidade",
          "complement": "Apartamento, suíte, etc. (opcional)",
          "complementPlaceholder": "ex. Suíte 200",
          "country": "País",
          "description": "Obrigatório antes de poder atualizar para um plano pago.",
          "legalNameLabel": "Nome da entidade legal",
          "postalCodeLabel": "Código postal",
          "state": "Estado / Região",
          "street": "Rua",
          "taxIdLabel": "NIF / IVA",
          "title": "Faturação & legal"
        },
        "contact": {
          "description": "Telefone direto e ano de fundação da empresa.",
          "foundedLabel": "Ano de fundação",
          "phoneLabel": "Telefone de contacto",
          "title": "Informações de contacto & da empresa"
        },
        "description": "Todos os campos são opcionais. Expanda as secções que quer preencher — o resto fica como lembrete no seu painel.",
        "geographic": {
          "branchesLabel": "Escritórios filiais",
          "cityPlaceholder": "Cidade",
          "countryPlaceholder": "País",
          "description": "Filiais, requisitos linguísticos e arranjo de trabalho.",
          "languagesLabel": "Requisitos de língua",
          "title": "Detalhes geográficos",
          "workArrangement": "Arranjo de trabalho",
          "minimumLevel": "Nível mínimo",
          "languageLabel": "Língua"
        },
        "hiring": {
          "challengesLabel": "Principais desafios (máx. 3)",
          "description": "Objetivos, prazo, maturidade, funções-alvo e desafios.",
          "goalsLabel": "Objetivos principais de contratação",
          "maturityLabel": "Maturidade do programa de mobilidade",
          "rolesLabel": "Tipos de funções-alvo",
          "timeframeLabel": "Prazo de contratação",
          "title": "Detalhes da contratação"
        },
        "title": "Preencha os detalhes restantes"
      },
      "companyProfile": {
        "businessDetails": {
          "description": "Ajude-nos a entender o seu modelo de negócio e presença online",
          "title": "Detalhes do negócio"
        },
        "businessType": "Tipo de negócio",
        "businessTypes": {
          "agency": "Agência",
          "enterprise": "Empresa",
          "scaleup": "Escalável",
          "startup": "Startup",
          "startupDesc": "Fase inicial, alto crescimento",
          "scaleupDesc": "Modelo comprovado, a escalar rapidamente",
          "enterpriseDesc": "Grande empresa estabelecida",
          "agencyDesc": "Fornecedor de serviços"
        },
        "companyInfo": {
          "description": "Detalhes básicos sobre a sua organização",
          "title": "Informações da empresa"
        },
        "companyName": "Nome da empresa",
        "companySize": "Tamanho da empresa",
        "description": "Conte-nos sobre a sua organização. Esta informação ajuda-nos a personalizar a sua experiência e a preparar os requisitos de conformidade.",
        "emailPlaceholder": "john@company.com",
        "emailRequired": "Email *",
        "enterCompanyName": "Insira o nome da empresa",
        "enterPhoneNumber": "Introduza o seu número de telefone",
        "forContractsAndLegal": "Para contratos e documentos legais",
        "foundedYear": "Ano de fundação",
        "fullNamePlaceholder": "John Doe",
        "fullNameRequired": "Nome completo *",
        "industry": "Indústria",
        "legalEntityName": "Nome da entidade legal",
        "legalEntityPlaceholder": "ex., Company Inc., Company Ltd.",
        "legalInfo": {
          "description": "Para preparação de conformidade e contratos (opcional, mas recomendado para empresas)",
          "title": "Informações legais"
        },
        "linkedinCompanyPage": "Página da empresa no LinkedIn",
        "phone": "Telefone",
        "primaryContact": {
          "description": "O principal ponto de contacto da sua organização",
          "title": "Contacto principal"
        },
        "registeredCountry": "País registado",
        "registeredCountryDesc": "Onde a sua empresa está legalmente registada",
        "registeredCountryRequired": "País registado *",
        "requiredForEnterprise": "Necessário para faturação empresarial",
        "roleJobTitle": "Função / Título do trabalho",
        "selectCountry": "Selecionar país",
        "selectIndustry": "Selecione a indústria",
        "selectRole": "Selecione a função",
        "selectSize": "Selecione o tamanho",
        "selectYear": "Selecione o ano",
        "taxIdPlaceholder": "ex., DE123456789",
        "taxIdVat": "NIF / Número de IVA",
        "title": "Perfil da empresa",
        "website": "Website",
        "industries": {
          "technology": "Tecnologia",
          "healthcare": "Cuidados de saúde",
          "finance": "Finanças",
          "manufacturing": "Manufatura",
          "retail": "Retalho",
          "hospitality": "Hotelaria",
          "construction": "Construção",
          "education": "Educação",
          "consulting": "Consultoria",
          "logistics": "Logística",
          "energy": "Energia",
          "telecommunications": "Telecomunicações",
          "mediaEntertainment": "Media & entretenimento",
          "realEstate": "Imobiliário",
          "other": "Outro"
        },
        "companySizes": {
          "size1to50": "1-50 funcionários",
          "size51to200": "51-200 funcionários",
          "size201to500": "201-500 funcionários",
          "size501to1000": "501-1000 funcionários",
          "size1000plus": "1000+ funcionários"
        },
        "contactRoles": {
          "ceoFounder": "CEO / Fundador",
          "hrDirector": "Diretor de RH",
          "headOfTalentAcquisition": "Responsável pela aquisição de talento",
          "mobilityManager": "Gestor de mobilidade",
          "hrBusinessPartner": "Parceiro de negócios de RH",
          "peopleOperations": "Operações de pessoas",
          "recruiter": "Recrutador",
          "other": "Outro"
        }
      },
      "complete": "Integração concluída!",
      "confirmCard": {
        "backToConfirm": "Voltar à vista preenchida automaticamente",
        "dataFrom": "Dados de",
        "description": "Extraímos isto do website público da sua empresa. Confirme se está correto.",
        "editDetails": "Editar detalhes",
        "loading": "A procurar a sua empresa...",
        "loadingDesc": "Isto geralmente leva 2–3 segundos.",
        "manualDesc": "Não conseguimos detetar automaticamente a sua empresa. Por favor, preencha os básicos abaixo.",
        "multipleSources": "múltiplas fontes",
        "retry": "Tentar detetar automaticamente novamente",
        "thatsUs": "Somos nós",
        "title": "São estes os seus dados?",
        "yourRole": "A sua função na {{company}}"
      },
      "errors": {
        "cohortCreation": "Falha ao criar o grupo. Por favor, tente novamente.",
        "completion": "Falha ao finalizar a integração. Por favor, tente novamente.",
        "programCreation": "Falha ao criar o programa. Por favor, tente novamente."
      },
      "geographicSetup": {
        "addAnotherCountry": "Adicionar outro país...",
        "addBranchOffice": "Adicionar escritório filial",
        "branchOfficesDesc": "Adicione outros locais que podem receber talentos realocados (opcional)",
        "branchOfficesTitle": "Filiais",
        "canReceiveTalent": "Pode receber talentos",
        "city": "Cidade",
        "cityName": "Nome da cidade",
        "cityPlaceholder": "ex: Lisboa, Berlim, Amesterdão",
        "cityRequired": "Cidade *",
        "country": "País",
        "countryRequired": "País *",
        "description": "Configure os locais da sua empresa e os mercados de contratação-alvo. Isto ajuda-nos a pré-configurar rotas de migração e requisitos de conformidade.",
        "headquartersDesc": "O local do seu escritório principal onde os talentos realocados trabalharão principalmente",
        "headquartersTitle": "Localização da sede",
        "languageRequirementsDesc": "Quais idiomas os candidatos devem falar? (Opcional)",
        "languageRequirementsTitle": "Requisitos de idioma",
        "migrationRoutesDesc": "Com base na sua configuração, estas rotas de migração serão pré-configuradas",
        "migrationRoutesPreview": "Pré-visualização das rotas de migração",
        "officeName": "Nome do escritório",
        "officeNamePlaceholder": "ex: Escritório de Berlim",
        "popularSourceMarkets": "Mercados fonte populares",
        "selectCountry": "Selecionar país",
        "selectedMarkets": "Mercados selecionados ({{count}})",
        "targetHiringMarketsDesc": "De onde planeia contratar? Selecione os seus mercados de origem.",
        "targetHiringMarketsTitle": "Mercados de contratação alvo",
        "workArrangementDesc": "Que regime de trabalho oferece aos talentos realocados?",
        "workArrangementTitle": "Arranjo de trabalho",
        "languages": {
          "english": "Inglês",
          "spanish": "Spanish",
          "portuguese": "Portuguese",
          "german": "German",
          "french": "French",
          "dutch": "Dutch",
          "italian": "Italian",
          "polish": "Polish",
          "arabic": "Arabic",
          "chineseMandarin": "Chinês (Mandarim)",
          "japanese": "Japanese",
          "korean": "Korean"
        },
        "languageLevels": {
          "a1": "A1 — Iniciante",
          "a2": "A2 — Elementar",
          "b1": "B1 — Intermediário",
          "b2": "B2 — Intermediário superior",
          "c1": "C1 — Avançado",
          "c2": "C2 — Proficiência"
        },
        "workArrangements": {
          "onsite": "Presencial",
          "onsiteDesc": "Presença total no escritório",
          "hybrid": "Híbrido",
          "hybridDesc": "Mistura de escritório e remoto",
          "flexible": "Flexível",
          "flexibleDesc": "Escolha do empregado"
        },
        "minimumLevelFor": "Nível mínimo de {{language}}",
        "otherMarketLabel": "Outro mercado de contratação",
        "addMarket": "Adicionar mercado",
        "addLanguage": "Adicionar {{language}}"
      },
      "hiringContext": {
        "annualHiringVolume": "Volume anual de contratação internacional",
        "description": "Ajude-nos a perceber os seus objetivos e a sua estratégia de contratação. Isto permite-nos personalizar a sua experiência e dar-lhe recomendações relevantes.",
        "hiringGoalsDesc": "O que pretende alcançar? Selecione todas as opções aplicáveis.",
        "hiringGoalsTitle": "Objetivos de contratação",
        "mobilityProgramMaturity": "Maturidade do programa de mobilidade",
        "primaryUseCaseDesc": "Qual é a sua principal razão para usar a Tonnie? Selecione a opção que melhor descreve a sua situação.",
        "primaryUseCaseTitle": "Caso de uso principal",
        "scaleTimelineDesc": "Ajude-nos a entender o escopo e a urgência das suas necessidades de contratação.",
        "scaleTimelineTitle": "Escala & cronograma",
        "targetRoleTypesDesc": "Para que tipos de funções está sobretudo a contratar? Selecione todas as opções aplicáveis.",
        "targetRoleTypesTitle": "Tipos de funções alvo",
        "topChallengesDesc": "Quais são os seus maiores desafios com a contratação internacional? Selecione os seus 3 principais.",
        "topChallengesTitle": "Principais desafios",
        "useCases": {
          "costOptimization": "Otimização de custos",
          "costOptimizationDesc": "Acesso a talentos de diferentes mercados",
          "diversity": "Diversidade & inclusão",
          "diversityDesc": "Construir equipas internacionais diversas",
          "globalExpansion": "Expansão global",
          "globalExpansionDesc": "Expansão das operações para novos mercados com talento local",
          "internationalHiring": "Contratação internacional",
          "internationalHiringDesc": "Contratação de talento internacional para se mudar para os seus escritórios",
          "remoteToRelocation": "Remoto para realocação",
          "remoteToRelocationDesc": "Converter trabalhadores remotos em empregados realocados",
          "talentShortage": "Escassez de talento",
          "talentShortageDesc": "Abordar lacunas de talento local com sourcing global"
        },
        "volumes": {
          "enterprise": "Escala empresarial",
          "established": "Programa estabelecido",
          "growing": "Programa em crescimento",
          "starting": "A começar"
        },
        "whenPlanToStart": "Quando planeia começar?",
        "goals": {
          "reduceTimeToHire": "Reduzir o tempo para contratação de candidatos internacionais",
          "improveCandidateExperience": "Melhorar a experiência do candidato durante a relocação",
          "increaseRetention": "Aumentar a retenção de funcionários relocados",
          "streamlineCompliance": "Agilizar processos de conformidade e vistos",
          "trackMobilityRoi": "Rastrear e medir o ROI da mobilidade",
          "reduceRelocationCosts": "Reduzir custos de relocação",
          "buildTalentPipeline": "Construir um pipeline de talentos sustentável",
          "improveOnboarding": "Melhorar a integração e adaptação pós-chegada"
        },
        "challenges": {
          "immigrationVisa": "Complexidade de imigração e vistos",
          "findingCandidates": "Encontrar candidatos internacionais qualificados",
          "candidateDropoff": "Desistência de candidatos durante a relocação",
          "postArrival": "Adaptação e retenção pós-chegada",
          "complianceLegal": "Complexidade de conformidade e legal",
          "costManagement": "Gestão de custos",
          "trackingReporting": "Rastreamento e relatórios"
        },
        "timeframes": {
          "immediate": "Imediato",
          "immediateDesc": "Pronto para começar agora",
          "planningDesc": "Fase de planeamento",
          "futureDesc": "Pipeline futuro",
          "strategicDesc": "Planeamento estratégico"
        },
        "maturity": {
          "firstTime": "Primeira vez",
          "firstTimeDesc": "Novo na contratação internacional",
          "someExperience": "Alguma experiência",
          "someExperienceDesc": "Fez algumas relocacões",
          "establishedProgram": "Programa estabelecido",
          "establishedProgramDesc": "Função de mobilidade madura"
        },
        "roleTypes": {
          "engineering": "Engenharia",
          "product": "Produto",
          "design": "Design",
          "dataScience": "Ciência de dados",
          "devops": "DevOps / Infraestrutura",
          "marketing": "Marketing",
          "sales": "Vendas",
          "customerSuccess": "Sucesso do cliente",
          "finance": "Finanças",
          "hrPeople": "RH / Pessoas",
          "operations": "Operações",
          "executive": "Executivo / Liderança",
          "other": "Outro"
        }
      },
      "hiringSignals": {
        "annualVolume": "Volume de contratações anual",
        "annualVolumeDesc": "Quantas contratações internacionais espera nos próximos 12 meses?",
        "description": "Duas perguntas rápidas para que possamos personalizar o seu espaço de trabalho.",
        "primaryUseCase": "Caso de uso principal",
        "title": "O que o traz à Tonnie?"
      },
      "loadingProgress": "A carregar o seu progresso...",
      "markets": {
        "description": "Escolha até 3 mercados. Pode sempre adicionar mais tarde.",
        "headquarters": "Sede",
        "targetMarkets": "Mercados de contratação alvo",
        "title": "De onde está a contratar?"
      },
      "progressRestored": "O seu progresso foi restaurado",
      "progressSaved": "Progresso guardado",
      "validation": {
        "requiredFields": "Por favor, complete os campos obrigatórios antes de continuar."
      },
      "review": {
        "editDescription": "Revise os seus detalhes e guarde quando estiver pronto. Pode sempre voltar a este assistente a partir da página de Definições.",
        "editTitle": "O seu perfil organizacional",
        "firstTimeDescription": "Aqui está o que capturámos para o ajudar a começar. Pode sempre adicionar mais detalhes mais tarde a partir do seu painel.",
        "firstTimeNotice": "Toque em Completar Configuração para ativar o seu espaço de trabalho. Detalhes opcionais em falta aparecerão como lembretes no seu painel.",
        "firstTimeTitle": "Está tudo pronto",
        "jumpToAdditional": "Voltar a detalhes adicionais",
        "missingFieldsNotice_one": "Ainda tem {{count}} detalhe opcional por preencher. Preenchê-lo melhora a correspondência por IA e desbloqueia a faturação.",
        "missingFieldsNotice_other": "Ainda tem {{count}} detalhes opcionais por preencher. Preenchê-los melhora a correspondência por IA e desbloqueia a faturação."
      },
      "roles": {
        "founderExec": "Fundador / Exec",
        "hrPeople": "RH / Pessoas",
        "mobilityManager": "Gestor de mobilidade",
        "talentAcquisition": "Aquisição de talento"
      },
      "saveFailed": "Falha ao guardar progresso",
      "steps": {
        "addTalents": {
          "badge": "Chave",
          "description": "Ative a sua conta ao adicionar talentos",
          "title": "Adicionar primeiros talentos"
        },
        "additionalDetails": {
          "description": "Campos opcionais para melhorar a correspondência e desbloquear a faturação.",
          "title": "Detalhes adicionais"
        },
        "companyProfile": {
          "description": "Conte-nos sobre a sua organização",
          "title": "Perfil da empresa"
        },
        "geographicSetup": {
          "description": "Localizações e rotas de migração",
          "title": "Configuração geográfica"
        },
        "hiringContext": {
          "description": "Os seus objetivos e estratégia de contratação",
          "title": "Contexto de contratação"
        },
        "review": {
          "description": "Confirme o que capturámos e finalize a configuração.",
          "title": "Rever & completar"
        }
      },
      "updated": "Perfil atualizado",
      "wizard": {
        "completeSetup": "Completar configuração",
        "completing": "A configurar...",
        "progressSaved": "O seu progresso será guardado automaticamente",
        "saveChanges": "Guardar alterações",
        "skipInfo": "Pode pular e completar depois",
        "subtitle": "Integração da empresa",
        "title": "Tonnie Business"
      }
    },
    "businessSettings": {
      "branding": {
        "a11yBrandConsistency": "Mantenha a consistência da marca enquanto garante acessibilidade",
        "a11yColorBlind": "Teste com simuladores de daltonismo",
        "a11yContrast": "Assegure contraste suficiente entre o texto e o fundo (WCAG AA: 4.5:1)",
        "accessibilityGuidelines": "Diretrizes de acessibilidade",
        "activateTheme": "Ativar tema",
        "activateThisTheme": "Ativar este tema",
        "active": "Ativo",
        "appIcon": "Ícone da app",
        "appIconDesc": "O ícone quadrado mostrado nos separadores do browser e nos telemóveis",
        "assets": "Ativos",
        "colors": "Cores",
        "customDesc": "As cores da sua marca",
        "customMode": "Modo personalizado",
        "dark": "Escuro",
        "darkDesc": "Texto claro sobre fundo escuro",
        "dashboard": "Painel de controle",
        "description": "O seu logótipo, cores e tema em todo o portal",
        "draft": "Rascunho",
        "enterPreviewDesc": "Veja o portal com a sua marca antes de guardar",
        "enterPreviewMode": "Entrar no modo de visualização",
        "exitPreview": "Sair da visualização",
        "favicon": "Favicon",
        "faviconDesc": "O pequeno ícone no separador do browser",
        "fileFormatsHint": "{{formats}} (máx {{maxSize}})",
        "heroImageN": "Imagem hero {{number}}",
        "heroImages": "Imagens hero",
        "heroImagesDesc": "Imagens de destaque mostradas no topo das suas páginas",
        "light": "Claro",
        "lightDesc": "Texto escuro sobre fundo claro",
        "loginPage": "Página de início de sessão",
        "preview": "Pré-visualizar",
        "previewModeActive": "Modo de visualização ativo",
        "primaryLogo": "Logotipo principal",
        "primaryLogoDesc": "Mostrado na barra lateral e nos documentos que partilha",
        "replace": "Substituir",
        "saveDraft": "Guardar rascunho",
        "secondaryLogo": "Logotipo secundário",
        "secondaryLogoDesc": "Uma versão compacta para espaços pequenos",
        "switchToCustomAssets": "Mudar para ativos personalizados",
        "switchToCustomColors": "Mudar para cores personalizadas",
        "switchToCustomPreview": "Mudar para visualização personalizada",
        "themeMode": "Modo de tema",
        "themeModeDesc": "Claro, escuro ou as suas cores",
        "title": "Branding",
        "upload": "Carregar",
        "uploading": "A carregar…",
        "colorNames": {
          "primary": "Primária",
          "secondary": "Secundária",
          "accent": "Destaque",
          "success": "Sucesso",
          "warning": "Aviso",
          "error": "Erro",
          "background": "Fundo",
          "foreground": "Texto"
        },
        "colorPickerLabel": "Seletor de cor: {{name}}",
        "colorHexLabel": "Código hexadecimal: {{name}}"
      },
      "care": {
        "description": "Como o Care funciona para os seus talentos: pilares, check-ins e objetivos",
        "enterpriseDescription": "As definições personalizadas do Care fazem parte do plano Enterprise",
        "features": {
          "checkpointSchedule": "Cronograma de checkpoint",
          "checkpointScheduleDesc": "Quando os talentos fazem os check-ins do Care",
          "customPillars": "Pilares personalizados",
          "customPillarsDesc": "Que pilares de bem-estar os seus talentos avaliam",
          "feedbackConfig": "Configuração de feedback",
          "feedbackConfigDesc": "Quem dá feedback sobre objetivos, e com que frequência",
          "talentObjectives": "Objetivos dos talentos",
          "talentObjectivesDesc": "Os objetivos em que os seus talentos trabalham",
          "title": "Funcionalidades"
        },
        "saveFailed": "Não foi possível guardar a configuração de Care. Por favor, tente novamente.",
        "saved": "Configuração do Care guardada",
        "title": "Care"
      },
      "compliance": {
        "actionLabels": {
          "system_template_dispatched_pre_clerk": "Email do sistema enviado",
          "talent_bulk_imported": "Talentos importados em massa",
          "talent_invitation_created": "Convite criado",
          "talent_invitation_email_failed": "E-mail do convite não enviado",
          "talent_invitation_revoked": "Convite revogado",
          "talent_invitation_sent": "Convite enviado",
          "talent_invited_to_vetting": "Convidado para avaliação",
          "account_email_changed": "Email da conta alterado",
          "account_name_changed": "Nome da conta alterado",
          "affiliate_payout_cancelled": "Pagamento de afiliado cancelado",
          "affiliate_payout_invoice_attached": "Fatura anexada ao pagamento de afiliado",
          "affiliate_payout_requested": "Pagamento de afiliado pedido",
          "affiliate_platform_overview_viewed": "Visão geral da plataforma de afiliados consultada",
          "communications_relinked_to_account": "Mensagens associadas à conta",
          "evidence_blob_read": "Ficheiro de evidência aberto",
          "evidence_blob_released": "Ficheiro de evidência libertado",
          "evidence_capture_expired": "Registo de decisão expirado",
          "evidence_capture_read": "Registo de decisão aberto",
          "evidence_diff_viewed": "Registo de decisão comparado com hoje",
          "evidence_item_redacted": "Elemento de evidência ocultado",
          "feature_flags_write": "Funcionalidades ativadas alteradas",
          "invitation_claimed": "Convite reclamado",
          "pool_bulk_imported": "Candidatos importados em massa",
          "pool_candidate_ingested": "Candidato adicionado ao grupo",
          "pool_cv_viewed": "CV do candidato consultado",
          "service_credential_created": "Credencial de serviço criada",
          "service_credential_revoked": "Credencial de serviço revogada",
          "talent_invitation_deleted": "Convite eliminado",
          "talent_invitation_superseded": "Convite substituído por um novo",
          "account_name_reconciled": "Nome da conta reconciliado",
          "ops_vault_orphan_delete": "Ficheiro órfão removido",
          "talent_invitation_declined": "Convite recusado",
          "fiscal_document_retried": "Fatura-recibo emitida de novo",
          "fiscal_credit_note_recorded": "Nota de crédito registada",
          "fiscal_config_written": "Configuração de faturação alterada",
          "fiscal_retroactive_queued": "Faturas de pagamentos anteriores em fila",
          "inout_cases_listed": "Tickets InOut listados",
          "inout_case_viewed": "Ticket InOut consultado",
          "inout_case_event_recorded": "Evento de ticket InOut registado",
          "inout_tracking_file_previewed": "Ficheiro de acompanhamento InOut pré-visualizado",
          "inout_tracking_file_loaded": "Ficheiro de acompanhamento InOut carregado",
          "inout_refund_request_handled": "Pedido de devolução InOut tratado",
          "inout_reconciliation_viewed": "Reconciliação InOut consultada",
          "inout_portal_saved": "Portal InOut guardado"
        },
        "allActions": "Todas as ações",
        "allUsers": "Todos os utilizadores",
        "auditLogs": "Registos de auditoria",
        "auditLogsDesc": "Acompanhe quem fez o quê, quando e onde na sua empresa.",
        "date": "Data",
        "description": "Registos de auditoria, retenção de dados e definições de privacidade da empresa",
        "loadMore": "Carregar mais",
        "loading": "A Carregar…",
        "noResults": "Nenhum evento de auditoria corresponde aos seus filtros.",
        "resourceLabels": {
          "journey_invitation": "Convite de percurso",
          "message_template": "Modelo de mensagem",
          "tenant": "Organização",
          "affiliate_payout": "Pagamento de afiliado",
          "affiliate_platform": "Plataforma de afiliados",
          "engagement_evidence_blob": "Ficheiro de evidência",
          "engagement_evidence_capture": "Registo de decisão",
          "engagement_evidence_item": "Elemento de evidência",
          "platform_configs": "Definições da plataforma",
          "service_credential": "Credencial de serviço",
          "talent": "Talento",
          "user": "Utilizador",
          "vault_file": "Ficheiro do cofre",
          "billing_invoice": "Pagamento",
          "inout_case": "Ticket InOut",
          "inout_reconciliation": "Reconciliação InOut",
          "inout_tracking_import": "Ficheiro de acompanhamento InOut",
          "inout_portal": "Portal InOut"
        },
        "showing": "A mostrar {{shown}} de {{total}}",
        "systemActor": "Sistema",
        "title": "Conformidade",
        "filterByUser": "Filtrar por utilizador",
        "filterByAction": "Filtrar por ação"
      },
      "description": "A sua organização, equipa, marca e preferências",
      "enterpriseLock": {
        "badge": "Empresa",
        "description": "Esta funcionalidade está disponível no plano Enterprise.",
        "title": "Bloqueado",
        "upgrade": "Atualizar para Enterprise"
      },
      "organization": {
        "annualVolume": "Volume anual",
        "billingAddress": "Endereço de faturação",
        "billingCity": "Cidade",
        "billingCountry": "País",
        "billingLegal": "Informação legal",
        "billingLegalDesc": "Usado em faturas, contratos e documentos fiscais.",
        "billingState": "Estado / Região",
        "branchOffices": "Filiais",
        "businessType": "Tipo de negócio",
        "companyName": "Nome da empresa",
        "companyProfile": "Perfil da empresa",
        "companyProfileDesc": "O nome, o setor e os contactos da sua empresa",
        "companySetup": "Configuração da empresa",
        "companySize": "Tamanho da empresa",
        "complement": "Apartamento, suite, etc.",
        "contactEmail": "Email de contacto",
        "contactPhone": "Telefone de contacto",
        "contactRole": "Função do contacto",
        "description": "O perfil da sua empresa, localizações e contexto de contratação",
        "editInOnboardingWizard": "Editar no assistente de integração",
        "foundedYear": "Fundado",
        "geographicSetup": "Configuração geográfica",
        "geographicSetupDesc": "Onde a sua empresa está sediada e para onde os talentos se mudam",
        "headquarters": "Sede",
        "hiringContext": "Contexto de contratação",
        "hiringContextDesc": "As funções para que contrata e os desafios que enfrenta",
        "hiringGoals": "Objetivos de contratação",
        "industry": "Indústria",
        "languageRequirements": "Requisitos de língua",
        "legalName": "Nome legal",
        "linkedin": "LinkedIn",
        "maturityLevel": "Nível de maturidade",
        "postalCode": "Código postal",
        "primaryContact": "Contacto principal",
        "primaryUseCase": "Caso de uso principal",
        "registeredCountry": "País registado",
        "targetHiringMarkets": "Mercados de contratação alvo",
        "targetRoles": "Funções alvo",
        "taxId": "NIF / IVA",
        "timeframe": "Prazo",
        "title": "Organização",
        "topChallenges": "Principais desafios",
        "website": "Website",
        "workArrangement": "Arranjo de trabalho"
      },
      "preferences": {
        "dateFormat": "Formato de data",
        "description": "Idioma, notificações e como o portal funciona para si",
        "discardChanges": "Descartar",
        "emailNotifications": "Notificações por email",
        "emailNotificationsDesc": "Que atualizações recebe por email",
        "language": "Língua",
        "localization": "Localização",
        "localizationDesc": "O seu idioma, fuso horário e formato de data",
        "moreComingSoon": "Mais preferências estão a caminho — idiomas adicionais, fusos horários e controlos de notificações aparecerão aqui à medida que os implementarmos.",
        "pushNotifications": "Notificações push",
        "pushNotificationsDesc": "Que atualizações aparecem como notificações do browser",
        "saveFailed": "Não foi possível guardar as preferências. Por favor, tente novamente.",
        "savePreferences": "Guardar preferências",
        "quietHours": "Horário de silêncio",
        "quietHoursDesc": "Pausar notificações push durante este período.",
        "quietHoursEnd": "Até",
        "quietHoursStart": "De",
        "saved": "Preferências atualizadas",
        "timezone": "Fuso horário",
        "title": "Preferências",
        "unsavedChanges": "Tem alterações não guardadas",
        "channelsTitle": "Canais de notificação",
        "channelsDesc": "Como recebe as notificações.",
        "categoriesTitle": "Sobre o que é notificado",
        "categoriesDesc": "Escolha que tipos de novidades recebe.",
        "category": {
          "hero": "Percurso do talento",
          "heroDesc": "Progresso de CheckUp, Care e mobilidade dos seus talentos.",
          "system": "Conta e sistema",
          "systemDesc": "Segurança, conta e manutenção da plataforma.",
          "social": "Pessoas e pipeline",
          "socialDesc": "Avaliações, equipa e interações com candidatos.",
          "alert": "Alertas e faturação",
          "alertDesc": "Sensíveis a tempo ou dinheiro: faturação, pagamentos e prazos."
        }
      },
      "sections": {
        "branding": "Branding",
        "brandingDesc": "Tema, cores e ativos",
        "care": "Care",
        "careDesc": "Configuração e pilares do Care",
        "compliance": "Conformidade",
        "complianceDesc": "Registos de auditoria, retenção de dados e exportações",
        "organization": "Organização",
        "organizationDesc": "Perfil e configuração da empresa",
        "preferences": "Preferências",
        "preferencesDesc": "Notificações, idioma e localidade",
        "profile": "Perfil",
        "profileDesc": "As suas informações pessoais e avatar",
        "security": "Segurança",
        "securityDesc": "Autenticação, palavras-passe e acesso",
        "team": "Equipa",
        "teamDesc": "Membros, funções e permissões",
        "serviceCredentials": "Credenciais de serviço",
        "serviceCredentialsDesc": "Tokens apenas de leitura para scripts e ferramentas de relatórios"
      },
      "security": {
        "accountDeleteFailed": "Falha ao eliminar conta",
        "accountDeleted": "Conta eliminada",
        "confirmDelete": "Eliminar para sempre",
        "confirmDeleteOrg": "Eliminar organização para sempre",
        "dangerZone": "Zona de perigo",
        "dangerZoneDesc": "Ações irreversíveis. Por favor, tenha certeza.",
        "deleteAccount": "Eliminar conta",
        "deleteAccountConfirmPrompt": "Escreva DELETE para confirmar:",
        "deleteAccountDesc": "Remover permanentemente a sua conta de utilizador e todos os dados associados.",
        "deleteAccountTitle": "Eliminar conta",
        "deleteAccountWarning": "Esta ação é permanente e não pode ser desfeita. Todos os seus dados serão removidos.",
        "deleteOrg": "Eliminar organização",
        "deleteOrgConfirmPrompt": "Escreva o nome da organização para confirmar:",
        "deleteOrgFailed": "Falha ao eliminar a organização. Por favor, tente novamente ou contacte o suporte.",
        "deleteOrgSuccess": "Organização eliminada.",
        "deleteOrgTitle": "Eliminar organização",
        "deleteOrgWarning": "Isto irá eliminar permanentemente a organização, todas as associações de equipa, programas, coortes e dados de talento.",
        "deleteOrganization": "Eliminar esta organização",
        "deleteOrganizationDesc": "Remover a organização, todos os membros da equipa, programas e dados. Isto não pode ser desfeito.",
        "deleting": "A eliminar…",
        "description": "Início de sessão, sessões e eliminação da sua organização",
        "title": "Segurança",
        "deleteOrgStripeWarning_one": "Organização eliminada. {{count}} subscrição não pôde ser cancelada automaticamente — contacte o suporte se surgirem questões de faturação.",
        "deleteOrgStripeWarning_other": "Organização eliminada. {{count}} subscrições não puderam ser canceladas automaticamente — contacte o suporte se surgirem questões de faturação."
      },
      "team": {
        "description": "Gerir membros da equipa e convites",
        "enterpriseDescription": "Gestão total da equipa com acesso baseado em funções",
        "features": {
          "activityTracking": "Rastreamento de atividade",
          "activityTrackingDesc": "Ver quando os membros da equipa acederam pela última vez à plataforma",
          "roleBasedAccess": "Acesso baseado em funções",
          "roleBasedAccessDesc": "Atribuir funções para controlar o que cada membro pode ver e fazer",
          "stakeholderIdentification": "Gestão de stakeholders",
          "stakeholderIdentificationDesc": "Identificar proprietários de orçamento e campeões de programa",
          "title": "Funcionalidades",
          "unlimitedMembers": "Membros ilimitados",
          "unlimitedMembersDesc": "Convide toda a sua equipa — sem limites de lugares"
        },
        "invitationResent": "Convite reenviado",
        "invitationRevoked": "Convite revogado",
        "invitations": {
          "description": "Gerir convites pendentes para o seu espaço de trabalho.",
          "expired": "Expirado",
          "pending": "Pendente",
          "resend": "Reenviar",
          "revoke": "Revogar",
          "sentOn": "Enviado",
          "title": "Convites pendentes"
        },
        "inviteDesc": "Envie um convite por email para se juntar à sua organização.",
        "inviteEmailLabel": "Endereço de email",
        "inviteFailed": "Falha ao enviar convite",
        "inviteRoleLabel": "Função",
        "inviteSent": "Convite enviado",
        "inviteTitle": "Convidar membro da equipa",
        "memberRemoved": "Membro da equipa removido",
        "members": {
          "description": "Membros ativos da equipa com acesso à sua organização",
          "inviteMember": "Convidar membro",
          "title": "Membros"
        },
        "removeConfirm": "Remover {{name}} da equipa?",
        "removeFailed": "Falha ao remover membro da equipa",
        "resendFailed": "Falha ao reenviar convite",
        "revokeFailed": "Falha ao revogar convite",
        "roleAdmin": "Admin",
        "roleTeamMember": "Membro da equipa",
        "roles": {
          "adminDesc": "Acesso total — gerir equipa, faturação, programas e definições",
          "description": "Funções disponíveis e as suas permissões",
          "teamMemberDesc": "Acesso a programas, talentos e painéis de mobilidade",
          "title": "Funções"
        },
        "sendInvite": "Enviar convite",
        "sending": "A enviar…",
        "stats": {
          "pendingInvitations": "Convites pendentes",
          "teamMembers": "Total de membros"
        },
        "title": "Equipa"
      },
      "title": "Definições",
      "inviteEmailPlaceholder": "colega@empresa.com",
      "serviceCredentials": {
        "title": "Credenciais de serviço",
        "description": "Tokens apenas de leitura que permitem a um script ou ferramenta de relatórios obter dados do cohort sem que alguém inicie sessão.",
        "howToTitle": "Como usar uma credencial",
        "howToBody": "Envie o token num cabeçalho Authorization: Authorization: Bearer <token>. Só permite ler snapshots de coortes e programas, não pode alterar nada e deixa de funcionar no momento em que o revogar ou expirar.",
        "empty": "Ainda não existem credenciais",
        "emptyHint": "Crie uma quando um script ou ferramenta de relatórios precisar de ler dados do cohort por si.",
        "create": "Nova credencial",
        "createTitle": "Nova credencial de serviço",
        "createDescription": "Só verá o token uma vez. Guarde-o antes de fechar.",
        "nameLabel": "Nome",
        "namePlaceholder": "Relatório trimestral do cohort",
        "nameHint": "Para conseguir distinguir esta credencial das outras mais tarde.",
        "scopeLabel": "Acesso",
        "scopeCohortRead": "Ler dados do cohort",
        "scopeHint": "Apenas leitura. Uma credencial nunca altera dados nem gere credenciais.",
        "cohortModeLabel": "Cohorts",
        "cohortAll": "Todos os cohorts",
        "cohortPick": "Apenas os cohorts que eu escolher",
        "cohortsLabel": "Quais cohorts",
        "cohortsHint": "Escolha pelo menos um.",
        "expiryLabel": "Expira em",
        "expiryHint": "Credenciais sempre expiram. Noventa dias é o máximo.",
        "revealTitle": "Copie o seu token agora",
        "revealWarning": "Este token é mostrado apenas uma vez. Guarde-o agora — não poderá ser mostrado novamente.",
        "copy": "Copiar",
        "copied": "Copiado",
        "storedConfirm": "Guardei este token num local seguro",
        "done": "Concluído",
        "statusActive": "Ativa",
        "statusExpired": "Expirada",
        "statusRevoked": "Revogada",
        "allCohorts": "Todos os cohorts",
        "neverUsed": "Nunca utilizada",
        "revoke": "Revogar",
        "revokeTitle": "Revogar esta credencial?",
        "revokeDescription": "Tudo o que a utiliza deixa de funcionar imediatamente. Isto não pode ser anulado.",
        "revokeReasonLabel": "Motivo (opcional)",
        "revokeConfirm": "Revogar credencial",
        "issued": "Credencial criada",
        "revoked": "Credencial revogada",
        "issueFailed": "Não foi possível criar a credencial",
        "revokeFailed": "Não foi possível revogar a credencial",
        "loadFailed": "Não foi possível carregar as credenciais",
        "expiryDays_one": "{{count}} dia",
        "expiryDays_other": "{{count}} dias",
        "cohortCount_one": "{{count}} cohort",
        "cohortCount_other": "{{count}} cohorts",
        "expiringSoon_one": "Expira em {{count}} dia",
        "expiringSoon_other": "Expira em {{count}} dias"
      }
    },
    "care": {
      "config": {
        "addCustomObjective": "Adicionar objetivo personalizado",
        "addToCatalog": "Adicionar ao catálogo",
        "baselineDescription": "Configure as definições padrão do Care para a sua organização. Estas definições serão automaticamente herdadas por todos os Programas e Coortes. Programas ou Coortes individuais podem personalizar se necessário.",
        "cadences": {
          "monthly": "Mensal",
          "quarterlyRecommended": "Trimestral (recomendado)",
          "semiannual": "Semestral"
        },
        "careModelSummary": "Resumo do modelo Care",
        "carePillars": "Pilares Care",
        "carePillarsDescription": "Selecione quais dimensões de estabilidade os talentos irão auto-relatar durante as verificações. Programas e Coortes podem ativar/desativar estes.",
        "pillarCatalog": {
          "housing_stability": {
            "name": "Estabilidade habitacional",
            "description": "Monitorizar transições e estabilidade habitacional após a chegada"
          },
          "schooling_childcare": {
            "name": "Educação e cuidados infantis",
            "description": "Acompanhar a educação e os arranjos de cuidados infantis das crianças"
          },
          "work_fit": {
            "name": "Adequação ao trabalho",
            "description": "Acompanhar a adaptação ao local de trabalho, adequação à equipa e produtividade"
          },
          "wellbeing_social": {
            "name": "Bem-estar & social",
            "description": "Monitorizar o bem-estar, as ligações sociais e o envolvimento comunitário"
          }
        },
        "carePillarsScheduleDesc": "Pilares Care + cronograma de checkpoint: Os talentos completam auto-check-ins em dimensões de bem-estar selecionadas em intervalos de marcos. Programas/Coortes podem ativar/desativar pilares e ajustar o tempo dos checkpoints.",
        "catalogWorkDescription": "Ative objetivos aqui para torná-los disponíveis para Programas e Cohortes. Cada Programa/Cohorte pode então escolher quais objetivos rastrear para os seus talentos.",
        "changesApplyNote": "As alterações aplicar-se-ão a todos os Programas e Cohortes que não personalizaram as suas definições",
        "checkpointSchedule": "Cronograma de checkpoint",
        "checkpointScheduleDescription": "Tempos padrão para check-ins do Pilar Care (marcos pós-chegada). Programas e Coortes podem ajustar a recorrência.",
        "common": "Comum",
        "companyCareBaseline": "Linha de base da empresa Care",
        "customObjectiveAdded": "Objetivo personalizado adicionado ao catálogo",
        "detailedFeedbackDescription": "Selecione funções que podem ver texto de feedback detalhado (outros veem apenas resumos)",
        "detailedFeedbackVisibility": "Visibilidade de feedback detalhado",
        "feedbackCadenceDescription": "Com que frequência os agentes da empresa e os talentos trocam feedback sobre os objetivos",
        "feedbackCadenceLabel": "Frequência de feedback",
        "feedbackConfigDescription": "Com que frequência os agentes da empresa fornecem feedback sobre os Objetivos de Talento e quando os talentos se autoavaliam",
        "feedbackConfiguration": "Configuração de feedback",
        "feedbackFlowDescription": "Em cada intervalo da cadência, os responsáveis selecionados submetem feedback sobre os objetivos do talento. O talento recebe uma notificação e pode ver o feedback e submeter a sua própria autoavaliação.",
        "feedbackFlowTitle": "Fluxo de feedback:",
        "feedbackProviders": "Responsáveis pelo feedback",
        "forObjectives": "Para objetivos",
        "forPillars": "Para pilares",
        "howCatalogWorks": "Como funciona o catálogo:",
        "milestones": {
          "monthNine": "Mês 9",
          "monthOne": "Mês 1",
          "monthSix": "Mês 6",
          "monthThree": "Mês 3",
          "monthTwelve": "Mês 12"
        },
        "objectivePlaceholder": "p.ex., Completar formação de consciencialização sobre segurança",
        "objectivesCatalogDescription": "Biblioteca da empresa de objetivos de adaptação. Ative os que são comumente utilizados — Programas e Cohortes podem então selecionar quais aplicar.",
        "primaryConfig": "Configuração primária",
        "providers": {
          "admin": {
            "description": "Possui o programa de cuidados — revisa sinais sensíveis e dá feedback estratégico sobre os objetivos."
          },
          "teamMember": {
            "description": "Contacto diário — fornece feedback sobre adaptação, adequação ao trabalho e progresso em relação aos objetivos."
          }
        },
        "recommended": "Recomendado",
        "riskSignalsDescription": "Selecione funções que podem ver indicadores de risco sensíveis e alertas de estabilidade",
        "riskSignalsVisibility": "Visibilidade de sinais de risco",
        "saveConfiguration": "Guardar configuração",
        "schedules": {
          "intensive": "Intensivo",
          "intensiveCadence": "Cadência: a cada trimestre + verificação de ajuste do mês-1 (5 checkpoints)",
          "intensiveDescription": "Programas de alta interação que necessitam de monitorização próxima em estágios iniciais e sinais trimestrais adicionais.",
          "light": "Toque leve",
          "lightCadence": "Cadência: semestral (2 checkpoints)",
          "lightDescription": "Cuidados mínimos viáveis — apenas o sinal do primeiro trimestre e o ponto de decisão anual.",
          "standard": "Padrão",
          "standardCadence": "Cadência: primeiro mês, depois trimestral até ao mês 12 (4 checkpoints)",
          "standardDescription": "Checkpoints equilibrados que cobrem a instalação, a adaptação e a retenção anual."
        },
        "talentCheckIns": "Check-ins de talento",
        "talentObjectivesCatalog": "Catálogo de objetivos de talento",
        "talentObjectivesFeedbackDesc": "Objetivos de talento + feedback: Ative objetivos no seu catálogo. Programas/Cohortes selecionam quais objetivos rastrear. Agentes da empresa fornecem feedback e talentos se autoavaliam.",
        "visibilityDescription": "Controle quem pode ver dados sensíveis do Care com base no seu papel",
        "visibilityPrivacy": "Visibilidade & privacidade",
        "pillarRequired": "Requerido",
        "pillarMakeRequired": "Tornar obrigatório",
        "objectives": {
          "language_level": "Alcançar proficiência de trabalho na língua local",
          "office_visits": "Assistir ao escritório regularmente a cada período",
          "onboarding": "Completar o programa de integração da empresa",
          "team_integration": "Estabelecer relações de trabalho produtivas com a equipa",
          "role_competency": "Demonstrar competência no papel através da revisão de marcos",
          "culture_fit": "Compreender e abraçar a cultura e os valores da empresa",
          "communication": "Comunicação eficaz com as partes interessadas",
          "tools_systems": "Proficiência com as ferramentas e sistemas da empresa",
          "network_building": "Construir uma rede profissional interna",
          "feedback_giving": "Participar ativamente nos ciclos de feedback",
          "goal_setting": "Definir e acompanhar objetivos de desenvolvimento pessoal",
          "mentorship": "Interagir com o mentor/amigo designado"
        },
        "objectiveCategory": {
          "Adaptation": "Adaptação",
          "Onboarding": "Integração",
          "Performance": "Desempenho",
          "Culture": "Cultura",
          "Skills": "Competências",
          "Technical": "Técnico",
          "Growth": "Crescimento",
          "Custom": "Personalizado"
        },
        "enabled_one": "{{count}} ativado",
        "enabled_other": "{{count}} ativados",
        "pillarsEnabledCount_one": "{{count}} pilar ativado. Os programas e as coortes herdam-no e podem escolher que pilares estão ativos no seu contexto.",
        "pillarsEnabledCount_other": "{{count}} pilares ativados. Os programas e as coortes herdam-nos e podem escolher que pilares estão ativos no seu contexto."
      },
      "customizeModal": {
        "cancel": "Cancelar",
        "carePillars": "Pilares Care",
        "carePillarsDesc": "Dimensões para check-ins de talento",
        "checkpointSchedule": "Cronograma de checkpoint",
        "checkpointScheduleDesc": "Quando os talentos completam check-ins do Care",
        "cohorts": "Coortes",
        "configSaved": "Configuração do Care personalizada para {{name}}",
        "customized": "Personalizado",
        "feedbackConfig": "Configuração de feedback",
        "feedbackConfigDesc": "Com que frequência o feedback é fornecido sobre os objetivos",
        "feedbackFrequencyInfo": "HRBP e gestores fornecem feedback sobre os objetivos de talento com esta frequência",
        "feedbackMonthly": "Mensal",
        "feedbackMonthlyDesc": "Uma vez por mês",
        "feedbackQuarterly": "Trimestral",
        "feedbackQuarterlyDesc": "A cada 3 meses",
        "inherited": "Herdado",
        "inheritedInfo": "As definições são herdadas de {{from}}. Ative as secções abaixo para personalizar para este {{level}}.",
        "objectivesAllApply": "Nenhum objetivo selecionado — todos os objetivos da empresa aplicam-se. Escolha um subconjunto para restringi-los para este âmbito.",
        "objectivesNoneEnabled": "Nenhum objetivo está habilitado na configuração da empresa Care ainda. Habilite alguns nas Definições da Empresa para que apareçam aqui.",
        "oneMonth": "1 mês",
        "overrideDesc": "Substituir as definições do Care para {{name}}. {{inheritors}} herdarão isto, a menos que tenham as suas próprias personalizações.",
        "pillarHousing": "Habitação",
        "pillarHousingDesc": "Estabilidade da situação de vida",
        "pillarWellbeing": "Bem-estar",
        "pillarWellbeingDesc": "Saúde e bem-estar mental",
        "pillarWork": "Trabalho",
        "pillarWorkDesc": "Adaptação ao emprego e carreira",
        "resetAllToInherited": "Reiniciar todos para herdado",
        "saveChanges": "Guardar alterações",
        "scheduleIntensive": "Intensivo",
        "scheduleIntensiveDesc": "Check-ins frequentes para novos chegados",
        "scheduleLight": "Toque leve",
        "scheduleLightDesc": "Check-ins mínimos para talentos estabelecidos",
        "scheduleStandard": "Padrão",
        "scheduleStandardDesc": "Cronograma de pontos de verificação equilibrado",
        "sixMonths": "6 meses",
        "talentObjectives": "Objetivos dos talentos",
        "talentObjectivesDesc": "Escolha quais objetivos da empresa se aplicam a este âmbito",
        "talents": "Talentos",
        "threeMonths": "3 meses",
        "title": "Personalizar modal",
        "twelveMonths": "12 meses",
        "pillarSchooling": "Educação e cuidados infantis",
        "pillarSchoolingDesc": "Acompanhar a educação e os arranjos de cuidados infantis das crianças",
        "nineMonths": "9 meses",
        "feedbackSemiannual": "Semestral",
        "feedbackSemiannualDesc": "Feedback recolhido duas vezes por ano",
        "objectivesSelected_one": "{{count}} objetivo selecionado. Os agentes da empresa dão feedback sobre ele",
        "objectivesSelected_other": "{{count}} objetivos selecionados. Agentes da empresa fornecem feedback sobre estes",
        "pillarsActive_one": "{{count}} pilar ativo. Os talentos avaliam-no durante os check-ins",
        "pillarsActive_other": "{{count}} pilares ativos. Os talentos irão avaliar cada pilar durante os check-ins"
      },
      "effectiveCard": {
        "cadence": "Cadência",
        "careConfiguration": "Configuração do Care",
        "carePillars": "Pilares Care",
        "customized": "Personalizado",
        "customizedFor": "Personalizado para {{level}}",
        "inherited": "Herdado",
        "inheritedFrom": "Herdado de {{source}}",
        "providers": "Fornecedores",
        "talentObjectives": "Objetivos dos talentos",
        "programSource": "Programa: {{name}}"
      },
      "feedback": {
        "commentWithheld": "Comentário ocultado pelas definições de visibilidade da sua empresa",
        "modal": {
          "description": "Avalie cada objetivo em relação ao seu alvo, depois revise todo o histórico.",
          "provideTab": "Fornecer",
          "historyTab": "Histórico",
          "submit": "Submeter feedback",
          "giveFeedback": "Dar feedback",
          "cycleDue": "Vencimento {{date}}",
          "awaitingSelfEval": "A aguardar autoavaliação",
          "noOpenCycle": "Sem ciclo aberto",
          "historyEmpty": "Nenhum feedback foi registado ainda.",
          "archivedObjective": "Objetivo arquivado",
          "providerValue": "Empresa",
          "selfValue": "Auto"
        }
      },
      "objective": {
        "measureType": {
          "number": "Contagem",
          "scale": "Nível",
          "percent": "Porcentagem",
          "milestone": "Marco",
          "rating": "Classificação"
        },
        "currentLabel": "Atual",
        "targetLabel": "Alvo",
        "baselineLabel": "Base de referência",
        "recordValueLabel": "Este período",
        "valuePlaceholder": "Selecionar…",
        "milestoneDone": "Feito",
        "milestoneNotYet": "Ainda não",
        "editTarget": "Editar alvo",
        "dashboard": {
          "byObjective": "Por objetivo",
          "onTargetShare": "No alvo",
          "avgProgress": "Média de progresso",
          "empty": "Nenhum objetivo está a ser rastreado ainda. Configure-os na estratégia do Care e eles aparecerão à medida que os talentos forem integrados.",
          "talentsCount_one": "{{count}} talento",
          "talentsCount_other": "{{count}} talentos"
        },
        "targetSaved": "Alvo atualizado",
        "targetSaveFailed": "Não foi possível guardar o alvo. Por favor, tente novamente.",
        "nothingToSubmit": "Registe um valor ou comentário para pelo menos um objetivo primeiro.",
        "feedbackSubmitted": "Feedback registado",
        "feedbackSubmitFailed": "Não foi possível registar o feedback. Por favor, tente novamente.",
        "errors": {
          "unitTooLong": "A unidade deve ter 24 caracteres ou menos",
          "targetRequired": "Defina uma base de referência ou um alvo",
          "ratingRange": "A avaliação deve ser de 1 a 5",
          "commentTooLong": "O comentário deve ter 2000 caracteres ou menos",
          "entryEmpty": "Adicionar um valor, avaliação ou comentário"
        },
        "noOpenCycle": "Ainda não há um ciclo de feedback aberto para este talento, por isso não há nada a que submeter."
      },
      "intervention": {
        "actAria": "Intervir em {{name}}",
        "actLabel": "Intervir",
        "assigneeLabel": "Proprietário",
        "assigneeUnassigned": "Não atribuído",
        "inbox": {
          "title": "Acompanhamentos",
          "empty": "Está tudo em dia — sem acompanhamentos abertos.",
          "overdue": "Atrasado",
          "open": "Abrir",
          "done": "Feito",
          "mine": "Meu",
          "all": "Todos",
          "due": "Vencimento {{date}}",
          "search": "Pesquisar por talento…",
          "groupByTalent": "Por talento",
          "flat": "Lista",
          "noMatch": "Nenhuma interação corresponde a esse talento.",
          "expandAll": "Expandir tudo",
          "collapseAll": "Colapsar tudo",
          "overdueCount_one": "{{count}} em atraso",
          "overdueCount_other": "{{count}} em atraso"
        },
        "manageLabel": "Agendamento e proprietário",
        "markDoneLabel": "Registar resultado + minutos",
        "markDoneHint": "Cole aqui as atas da reunião ou notas da gravação (se as tiver) — apenas interno, mantido para avaliação futura.",
        "markDone": "Marcar como feito",
        "ataPlaceholder": "Cole as atas / o que foi discutido aqui (apenas interno)…",
        "commentsLabel": "Comentários",
        "commentsEmpty": "Ainda sem comentários.",
        "commentPlaceholder": "Adicionar um comentário…",
        "commentSend": "Enviar",
        "rescheduledToast": "Interação reagendada",
        "reassignedToast": "Interação reassigned",
        "actionFailed": "Ação falhou. Por favor, tente novamente.",
        "bulkAllFailed": "Nenhuma ação pôde ser criada. Por favor, tente novamente.",
        "bulkPartial": "{{m}} não pôde ser criado",
        "bulkSummary": "{{n}} agendado, {{m}} falhou",
        "cancel": "Cancelar",
        "cancelFailed": "Falha ao cancelar.",
        "cancelledToast": "Intervenção cancelada",
        "descriptionLabel": "Descrição",
        "descriptionPlaceholder": "Adicione qualquer contexto para esta ação…",
        "dialogDescription": "Registe uma ação ou entre em contacto — escolha um tipo e nós tratamos do resto. Ações voltadas para o talento são sempre sem pontuação.",
        "dialogTitle": "Intervir",
        "effect": {
          "logOnly": "Registo interno apenas — nunca chega ao talento.",
          "talentTouch": "Elegível para um contacto quente, sem pontuação, por opt-in ao talento."
        },
        "errors": {
          "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
          "editClosed": "Esta interação está encerrada e não pode mais ser editada.",
          "invalidDate": "Insira uma data válida",
          "resolutionTooLong": "A resolução deve ter 2000 caracteres ou menos",
          "titleRequired": "Um título é necessário",
          "titleTooLong": "O título deve ter 200 caracteres ou menos"
        },
        "errorToast": "Não foi possível criar a ação. Por favor, tente novamente.",
        "edit": "Editar",
        "save": "Guardar alterações",
        "saveSuccess": "Interação atualizada",
        "saveFailed": "Não foi possível guardar as alterações. Por favor, tente novamente.",
        "wizard": {
          "stepType": "Tipo",
          "stepDetails": "Detalhes",
          "stepReview": "Revisão",
          "next": "Próximo",
          "back": "Voltar",
          "progressLabel": "Progresso da configuração da interação",
          "reviewBulk_one": "Isto será criado para {{count}} talento.",
          "reviewBulk_other": "Isto será criado para {{count}} talentos."
        },
        "notesLabel": "Notas",
        "notesPlaceholder": "Notas internas (opcional)…",
        "outcome": {
          "completed": "Completo",
          "noShow": "Falta",
          "rescheduled": "Reagendado",
          "declined": "Recusado"
        },
        "outcomeLabel": "Resultado",
        "priority": {
          "high": "Alto",
          "low": "Baixo",
          "medium": "Médio",
          "urgent": "Urgente"
        },
        "priorityLabel": "Prioridade",
        "resolutionLabel": "Nota de resolução",
        "resolutionPlaceholder": "O que aconteceu? (opcional)",
        "resolve": "Resolver",
        "resolveFailed": "Falha ao resolver.",
        "resolvedToast": "Intervenção resolvida",
        "submit": "Criar",
        "submitting": "A guardar…",
        "successToast": "Ação criada",
        "titleLabel": "Título",
        "titlePlaceholder": "por exemplo, check-in de bem-estar 1:1",
        "scheduledAtLabel": "Data e hora",
        "locationOrLinkLabel": "Link/localização da reunião",
        "locationOrLinkPlaceholder": "por exemplo, https://meet… ou um endereço",
        "requestCheckinHint": "Adiciona um check-in único à linha do tempo do talento que alimenta o seu índice de bem-estar.",
        "type": {
          "call": "Chamada",
          "video_call": "Chamada de vídeo",
          "in_person_meeting": "Reunião presencial",
          "message": "Mensagem",
          "internal_note": "Nota interna",
          "request_checkin": "Solicitar um check-in",
          "buddy_connect": "Ligar a um colega de apoio",
          "checkpoint_trigger": "Ativar um ponto de verificação",
          "coaching_note": "Nota de coaching",
          "manager_alert": "Alertar um gestor",
          "mission_recommend": "Recomendar uma missão",
          "personal_check_in": "Check-in pessoal",
          "reminder": "Definir um lembrete",
          "support_resource": "Partilhar um recurso de apoio"
        },
        "typeLabel": "Tipo de interação",
        "bulkAppliesTo_one": "Este plano aplica-se a {{count}} talento:",
        "bulkAppliesTo_other": "Este plano aplica-se a {{count}} talentos:",
        "dialogTitleBulk_one": "Intervir em {{count}} talento",
        "dialogTitleBulk_other": "Intervir em {{count}} talentos",
        "submitBulk_one": "Criar {{count}} ação",
        "submitBulk_other": "Criar {{count}} ações",
        "bulkAppliesToMatching_one": "Este plano chega ao {{count}} talento que corresponde aos seus filtros e precisa de uma intervenção.",
        "bulkAppliesToMatching_other": "Este plano chega a todos os {{count}} talentos que correspondem aos seus filtros e precisam de uma intervenção."
      },
      "effectiveCare": {
        "scheduleLabel": "{{schedule}} agenda",
        "providersList": "Fornecedores: {{providers}}",
        "customize": "Personalizar",
        "detailsTitle": "Detalhes da configuração Care",
        "fullConfigFor": "Configuração completa para {{name}}",
        "inheritedFromSuffix": "(herdado de {{source}})",
        "activeCarePillars": "Pilares ativos Care",
        "checkpointSchedule": "Cronograma de checkpoint",
        "scheduleTitle": "Agenda {{schedule}}",
        "talentObjectivesCount": "Objetivos de talento ({{count}})",
        "feedbackConfiguration": "Configuração de feedback",
        "inheritanceInfoCustomized": "Este {{level}} tem definições Care personalizadas. Clique em \"Reverter\" para voltar às definições de {{source}}.",
        "inheritanceInfoInherited": "Este {{level}} herda todas as definições Care de {{source}}. Clique em \"Personalizar\" para substituir definições específicas apenas para este {{level}}.",
        "activeCount_one": "{{count}} ativo",
        "activeCount_other": "{{count}} ativos",
        "moreObjectives_one": "+{{count}} objetivo",
        "moreObjectives_other": "+{{count}} mais objetivos"
      }
    },
    "carePage": {
      "act": "Intervir",
      "actAria": "Intervir para {{name}}",
      "activeTab": "Ativo",
      "activeTracking": "Rastreamento ativo",
      "archivedTab": "Arquivado",
      "commitmentDistribution": "Distribuição de compromisso",
      "startedSummary": "{{started}} de {{total}} iniciados",
      "awaitingCheckin": "A aguardar o primeiro check-in",
      "pillarsCardSubtitle": "Bem-estar por pilar em toda a coorte",
      "pillarsEmptyHint": "A saúde do pilar aparece assim que os talentos completam o seu primeiro check-in do Care.",
      "bandChampion": "Campeão",
      "bandCommitted": "Comprometido",
      "bandEngaged": "Envolvido",
      "bandAtRisk": "Em risco",
      "bandFlightRisk": "Risco de saída",
      "bandTracked": "Rastreados",
      "clearSelection": "Limpar seleção",
      "errors": {
        "notesTooLong": "As notas devem ter 2000 caracteres ou menos"
      },
      "feedbackPending": "Feedback pendente",
      "interveneAria": "Intervir para {{name}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "viewAllRisks": "Ver todos os riscos",
      "viewDetails": "Ver detalhes",
      "viewDetailsAria": "Ver detalhes de cuidados para {{name}}",
      "aiCommitmentInsights": "Insights de compromisso AI",
      "allCohorts": "Todas as coortes",
      "allLevels": "Todos os níveis",
      "allPillars": "Todos os pilares",
      "atRiskFilter": "em risco",
      "carePillar": "Pilar Care",
      "carePillarsHealth": "Saúde dos pilares Care",
      "champions": "Campeões",
      "championsDesc": "Os seus talentos mais comprometidos, do maior Commitment Index para o menor",
      "championsFilter": "Campeões",
      "commitment": "Compromisso",
      "commitmentChampions": "Campeões do compromisso",
      "commitmentLabel": "Compromisso",
      "commitmentPercent": "{{value}}%",
      "commitmentRiskAlert": "Alerta de risco de compromisso",
      "coldStartDesc": "Assim que um talento convidado completa a sua avaliação ou primeiro check-in do Care, o seu Índice de Compromisso e a saúde do pilar aparecem aqui.",
      "coldStartTitle": "Nenhuma atividade do Care ainda",
      "committedFilter": "Comprometido",
      "description": "Bem-estar, compromisso e intervenções dos seus talentos patrocinados",
      "engagedFilter": "Envolvido",
      "filterByCohort": "Filtrar por coorte",
      "filterByPillar": "Pilar",
      "flightRiskCount_one": "{{count}} talentos em risco de saída",
      "flightRiskCount_other": "{{count}} talentos em risco de saída",
      "flightRiskFilter": "Risco de saída",
      "healthy": "Saudável",
      "inCare": "Em Care",
      "insights": "Insights",
      "intervene": "Intervir",
      "interventionQueue": "Fila de intervenção",
      "interventionQueueDesc": "Talentos que precisam de intervenção ou devem feedback, os mais urgentes primeiro",
      "needCare": "Necessita de Care",
      "decliningCommitment": "Em declínio",
      "commitmentIndexLabel": "Índice de compromisso",
      "awaitingSelfEvalCount_one": "+{{count}} à espera de autoavaliação",
      "awaitingSelfEvalCount_other": "+{{count}} à espera de autoavaliação",
      "overdueCheckpoints": "Checkpoints em atraso",
      "needIntervention": "Necessita de intervenção",
      "noTalentsFound": "Nenhum talento encontrado",
      "overallTalentLoyalty": "Lealdade geral dos talentos",
      "overdue": "Atrasado",
      "pendingFeedback": "Feedback pendente",
      "pillars": "Pilares",
      "searchTalents": "Pesquisar talentos",
      "selectAllVisible": "Selecionar todos nesta página",
      "selectTalentAria": "Selecionar {{name}} para intervenção em massa",
      "smartRecommendations": "Recomendações inteligentes",
      "talentsLabel": "Talentos",
      "title": "Care",
      "tracked": "Rastreados",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "frequency": {
        "weekly": "Semanal",
        "biweekly": "Quinzenal",
        "monthly": "Mensal",
        "quarterly": "Trimestral",
        "semiannual": "Semestral"
      },
      "commitmentIndexHeading": "Índice de compromisso",
      "gettingStartedBadge": "A começar",
      "allClearTitle": "Tudo limpo",
      "allClearDescription": "Nenhum talento precisa de intervenção imediata",
      "clearFilters": "Limpar filtros",
      "routineStatus": {
        "overdue": "Atrasado",
        "in_progress": "Em progresso",
        "scheduled": "Agendado",
        "completed": "Completo",
        "open": "Abrir",
        "resolved": "Resolvido",
        "cancelled": "Cancelado"
      },
      "commitmentHealth": "Saúde do compromisso",
      "viewPillarTalentsAria": "Ver talentos sob {{pillar}}",
      "weakOnPillar": "Fraco em {{pillar}}",
      "pillarName": {
        "housing_stability": "Habitação",
        "schooling_childcare": "Educação",
        "work_fit": "Trabalho",
        "wellbeing_social": "Bem-estar"
      },
      "pillarStatus": {
        "healthy": "Saudável",
        "moderate": "Moderado",
        "concern": "Preocupação"
      },
      "insightsRecommendations": {
        "socialPillar": "O pilar social está a {{value}}% — considere atividades de união de equipa",
        "schedule1on1s": "Agendar 1:1s",
        "planActivities": "Planear atividades",
        "createProgram": "Criar programa",
        "flightRisk_one": "{{count}} talento está em risco de saída — agende um 1:1 imediato com o HRBP",
        "flightRisk_other": "{{count}} talentos estão em risco de saída — agende 1:1s imediatos com o HRBP",
        "championsProgram_one": "{{count}} campeão identificado — considere um programa de embaixadores",
        "championsProgram_other": "{{count}} campeões identificados — considere um programa de embaixadores"
      },
      "trendMetrics": {
        "avgCommitmentIndex": "Índice médio de compromisso",
        "champions": "Campeões",
        "flightRisk": "Risco de saída"
      },
      "scored": "Pontuado",
      "objectivesTitle": "Objetivos & feedback",
      "objectivesEmpty": "Nenhum objetivo foi atribuído a este talento ainda. Configure-os na estratégia do Care.",
      "objectivesLoadError": "Não foi possível carregar os objetivos.",
      "objectivesRetry": "Tentar novamente",
      "objectiveFeedbackCycleStatus": {
        "provider_submitted": "Prestador submetido",
        "completed": "Completo",
        "overdue": "Atrasado"
      },
      "objectiveFeedbackNoCycle": "Nenhum ciclo de feedback está aberto neste momento. Os objetivos estão listados abaixo; um formulário aparece quando o próximo ciclo se abre.",
      "objectiveFeedbackProviderLabel": "Prestador",
      "objectiveFeedbackSelfLabel": "Autoavaliação",
      "objectiveFeedbackCommentLabel": "Comentário (opcional)",
      "objectiveFeedbackCommentPlaceholder": "Partilhe feedback específico e acionável…",
      "objectiveFeedbackSubmitting": "A submeter…",
      "objectiveFeedbackDueTitle": "Feedback vencido",
      "objectiveFeedbackDueEmpty": "Nenhum ciclo de feedback aberto neste momento. Está tudo em dia.",
      "objectiveFeedbackDueLoadError": "Não foi possível carregar a lista de feedbacks vencidos.",
      "objectiveFeedbackDueRow": "Vencimento {{date}}",
      "objectiveFeedbackDueCurrent": "A visualizar",
      "feedbackStrategyScope": "Configuração de feedback resolvida · {{scope}}",
      "feedbackStrategyLoading": "A Carregar…",
      "feedbackStrategyError": "Não foi possível carregar a estratégia de feedback.",
      "feedbackCadenceLabel": "Cadência",
      "feedbackProvidersLabel": "Fornecedores",
      "feedbackProvidersNone": "Nenhum fornecedor configurado",
      "feedbackProvider": {
        "admin": "Admin",
        "team_member": "Membro da equipa"
      },
      "scopeCompanyWide": "A nível da empresa",
      "scopeCohort": "Coorte selecionada",
      "tabs": {
        "feedback": "Feedback",
        "interactions": "Interações"
      },
      "objectivesProgress": {
        "title": "Progresso dos objetivos",
        "desc": "Participação em alvo e progresso médio por objetivo, em todos os talentos."
      },
      "objectiveFeedback": {
        "title": "Feedback do objetivo",
        "desc": "Feedback estruturado, baseado em objetivos, na cadência configurada. Avalie cada talento em relação aos seus objetivos; eles completam uma autoavaliação em troca.",
        "dueKpi": "Feedback vencido",
        "awaitingSelfEvalKpi": "A aguardar autoavaliação",
        "caughtUp": "Tudo em dia — nenhum feedback devido neste momento.",
        "rowStatusOpen": "Precisa da sua avaliação",
        "rowStatusProviderSubmitted": "A aguardar a autoavaliação do talento",
        "notProvider": "Não é um fornecedor de feedback configurado para este âmbito. Peça a um Admin para adicionar a sua função nas definições do Care.",
        "loadError": "Não foi possível carregar a caixa de entrada de feedback."
      },
      "objectiveFeedbackNotGoverning": "Outra empresa gere o Care deste talento, por isso só ela dá feedback e define metas. Pode ler as autoavaliações do próprio talento.",
      "commitmentAtAGlance": "Compromisso num relance",
      "commitmentAtAGlanceDesc": "Onde estão hoje os seus talentos avaliados",
      "ofScored": "{{value}} de {{total}} avaliados",
      "bulkInterveneCta_one": "Agendar uma intervenção para {{count}} talento",
      "bulkInterveneCta_other": "Agendar uma intervenção para {{count}} talentos",
      "pendingCount_one": "{{count}} pendente",
      "pendingCount_other": "{{count}} pendentes",
      "selectedCount_one": "{{count}} selecionado",
      "selectedCount_other": "{{count}} selecionados",
      "gettingStartedNote_one": "+ {{count}} a começar (ainda sem histórico de check-in suficiente para pontuar)",
      "gettingStartedNote_other": "+ {{count}} a começar (ainda sem histórico de check-in suficiente para pontuar)",
      "interveneAllMatching_one": "Intervir no {{count}} correspondente",
      "interveneAllMatching_other": "Intervir em todos os {{count}} correspondentes",
      "interveneAllFlightRisk_one": "Intervir no {{count}} em risco de saída",
      "interveneAllFlightRisk_other": "Intervir em todos os {{count}} em risco de saída"
    },
    "heroOverview": {
      "title": "Visão geral do percurso",
      "subtitle": "Acompanhar progresso",
      "acquisition": {
        "title": "Aquisição",
        "description": "Talentos convidados que ainda não aceitaram.",
        "open": "Abrir aquisição no Pipeline",
        "pendingInvites": "convite pendente",
        "statusLabel": "Estado",
        "awaitingAcceptance": "A aguardar aceitação",
        "ttl": "TTL do convite de 14 dias",
        "viewInPipeline": "Ver no pipeline",
        "empty": "Todos os convidados aceitaram. Novos convites aparecerão aqui."
      },
      "vetting": {
        "title": "Verificação",
        "description": "Funil pré-patrocínio — convidados, triagem, concluídos.",
        "open": "Abrir vetting",
        "inVetting": "Em vetting",
        "passRate": "Taxa de aprovação",
        "funnel": "Funil",
        "inProgress": "triagem",
        "completed": "concluídos",
        "done": "feito"
      },
      "sponsored": {
        "title": "Patrocinado",
        "empty": "Nenhum talento patrocinado ainda. Assim que um talento for patrocinado, a sua Mobilidade, Adaptação e envolvimento no Care aparecerão aqui.",
        "headcount_one": "{{count}} talento",
        "headcount_other": "{{count}} talentos"
      },
      "mobility": {
        "title": "Mobilidade",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "adaptation": {
        "title": "Adaptação",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "care": {
        "title": "Care",
        "activeOfTotal_one": "{{count}} de {{total}} ativo",
        "activeOfTotal_other": "{{count}} de {{total}} ativos"
      },
      "notStartedYet_one": "{{count}} patrocinado · ainda não iniciado",
      "notStartedYet_other": "{{count}} patrocinados · ainda não iniciados",
      "notStartedMore_one": "+{{count}}",
      "notStartedMore_other": "+{{count}} mais"
    },
    "cohorts": {
      "activeCohorts": "Coortes em curso",
      "addTalents": "Adicionar talentos",
      "adjustFilters": "Ajustar filtros",
      "alerts": "Alertas",
      "all": "Todos",
      "allPrograms": "Todos os programas",
      "allStatus": "Todos os status",
      "askCoPilot": "Perguntar ao CoPilot",
      "atRisk": "em risco",
      "atRiskLabel": "em risco",
      "avgProgress": "Média de progresso",
      "backToCohorts": "Voltar às coortes",
      "biWeekly": "Quinzenal",
      "blocked": "Bloqueado",
      "care": "Care",
      "careRequiresEnterprise": "Care requer Enterprise",
      "careSettingsReset": "Redefinição das definições do Care",
      "careSettingsSaved": "Estratégia do Care guardada",
      "cohortCreated": "Coorte criada",
      "cohortDeleted": "Coorte eliminada",
      "cohortNameLabel": "Nome da coorte",
      "cohortNamePlaceholder": "Introduza o nome da coorte...",
      "cohortPaused": "Coorte pausada",
      "cohortResumed": "Coorte retomada",
      "cohortUpdated": "Coorte atualizada",
      "createCohort": "Criar coorte",
      "createDialogDescription": "Uma coorte é um grupo de talentos que está a conduzir em conjunto ao longo do percurso — mesma janela de início, mesmo destino, mesmo programa.",
      "createFirstCohort": "Criar primeira coorte",
      "createNewCohort": "Criar nova coorte",
      "deleteCohort": "Eliminar coorte",
      "deleteConfirmDescription": "Isto irá eliminar permanentemente a coorte. Esta ação não pode ser desfeita.",
      "deleteConfirmTitle": "Eliminar esta coorte?",
      "deleteFailed": "Falha ao eliminar a coorte",
      "description": "Agrupe talentos por entrada para os acompanhar em conjunto",
      "editCohort": "Editar coorte",
      "editDialogDescription": "Atualizar os detalhes da coorte abaixo.",
      "exportCsv": "Exportar CSV",
      "exportCsvFailed": "Não foi possível exportar esta coorte. Tente novamente.",
      "exportCsvTruncated": "Esta exportação inclui apenas os primeiros 500 talentos — esta coorte tem mais.",
      "exportingCsv": "A exportar…",
      "warningRosterTruncated": "A mostrar {{exported}} de {{total}} talentos — esta coorte é maior do que a lista pode apresentar.",
      "warningAcceptedWithoutJourney_one": "{{count}} convite aceite ainda não tem um percurso registado.",
      "warningAcceptedWithoutJourney_other": "{{count}} convites aceites ainda não têm um percurso registado.",
      "feedbackCadence": "Frequência de feedback",
      "fillRequiredFields": "Preencha os campos obrigatórios",
      "filterByProgram": "Filtrar por programa",
      "getMoreInsights": "Obter mais insights",
      "insights": "Insights",
      "insightsDescription": "Como esta coorte está a progredir",
      "insightCompletionRate": "{{percent}}% dos talentos ativos desta coorte chegaram à fase Evidência.",
      "insightSponsoredWithoutCare_one": "{{count}} talento patrocinado não tem pontos de contacto Care ativos — verifique a cadência de acompanhamento.",
      "insightSponsoredWithoutCare_other": "{{count}} talentos patrocinados não têm pontos de contacto Care ativos — verifique a cadência de acompanhamento.",
      "insightsEmpty": "Ainda não há conclusões para esta coorte.",
      "inviteToVetting": "Convidar para Avaliação",
      "iqulture": "iQulture",
      "journeyOverview": "Visão geral do percurso",
      "latestUpdates": "Últimas atualizações",
      "messageCohort": "Mensagem para a coorte",
      "monthly": "Mensal",
      "noCohortsFound": "Nenhuma coorte encontrada",
      "noProgramUnassigned": "Nenhum programa não atribuído",
      "notFound": "Coorte não encontrada",
      "notFoundDesc": "Esta coorte não existe ou foi eliminada. Tente voltar à lista de coortes.",
      "onTrack": "No caminho certo",
      "overview": "Visão geral",
      "pauseCohort": "Pausar coorte",
      "programOptional": "Programa opcional",
      "progress": "Progresso",
      "quarterly": "Trimestral",
      "recentActivity": "Atividade recente",
      "requestUpdate": "Solicitar atualização",
      "resumeCohort": "Retomar coorte",
      "searchCohorts": "Pesquisar grupos",
      "searchTalents": "Pesquisar talentos",
      "selectProgram": "Selecionar programa",
      "sendMessage": "Enviar mensagem",
      "stability": "Estabilidade",
      "startDateLabel": "Data de início",
      "started": "Iniciado",
      "status": "Estado",
      "statusChangeFailed": "Falha ao alterar o status da coorte",
      "targetArrival": "Chegada prevista",
      "talents": "Talentos",
      "title": "Coortes",
      "totalTalents": "Total de talentos",
      "trackProgress": "Acompanhar progresso",
      "unassigned": "Não atribuído",
      "updateFailed": "Falha ao atualizar a coorte",
      "viewDetails": "Ver detalhes",
      "viewProfile": "Ver perfil",
      "whatHappensNext": "O que acontece a seguir",
      "whatHappensNextDescription": "Será direcionado para a página de detalhes da coorte, onde pode convidar talentos diretamente, atribuí-los a partir do Pool e acompanhar o seu progresso no Vetting e nos heróis patrocinados paralelos (Mobilidade, Adaptação, Care).",
      "errors": {
        "nameRequired": "O nome da coorte é obrigatório",
        "nameTooLong": "O nome da coorte deve ter 200 caracteres ou menos",
        "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
        "planLimit": "O plano gratuito permite 1 coorte ativa. Faça upgrade para o Enterprise para coortes ilimitadas."
      },
      "cohortActionsAria": "Ações para {{name}}",
      "emptyTalentsTitle": "Ainda não há talentos nesta coorte",
      "emptyTalentsDescription": "Convide talentos ou importe uma lista para começar a acompanhá-los através da Avaliação e Patrocínio.",
      "addTalentsAria": "Adicionar talentos a {{name}}",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Notas opcionais sobre esta coorte",
      "targetShort": "Alvo",
      "startDateUnset": "Data de início não definida",
      "feedbackCadenceAria": "Cadência de feedback: {{cadence}}",
      "targetArrivalAria": "Chegada alvo: {{date}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "archiveSuccess": "{{name}} movido para arquivado.",
      "archiveFailed": "Falha ao arquivar coorte",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Falha ao restaurar coorte",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "manageArchivedOnPipeline": "Gerir no pipeline",
      "archivedReadOnly": "Os compromissos arquivados são só de leitura aqui. Restaure-os a partir do Pipeline.",
      "archivedEmptyTitle": "Nenhum compromisso arquivado nesta coorte",
      "selectAllAria": "Selecionar todos os talentos",
      "selectAllCount": "Selecionar todos ({{selected}}/{{total}})",
      "viewInPipeline": "Ver talentos no Pipeline",
      "disabledPausedCohort": "Retome a coorte para habilitar esta ação",
      "disabledPausedProgram": "Retome o programa pai para habilitar esta ação",
      "archive": "Arquivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "Arquivar coorte?",
      "archiveConfirmDescription": "{{name}} passa para o separador Arquivado. Pode restaurá-lo a qualquer momento a partir daí. Os talentos existentes não são afetados.",
      "scope": {
        "active": "Ativo",
        "archived": "Arquivado"
      },
      "form": {
        "talentCountPlaceholder": "por exemplo, 20"
      },
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "inviteCountToVetting_one": "Convidar {{count}} para Vetting",
      "inviteCountToVetting_other": "Convidar {{count}} para Vetting",
      "selectedCount_one": "{{count}} selecionado",
      "selectedCount_other": "{{count}} selecionados"
    },
    "common": {
      "add": "Adicionar",
      "back": "Voltar",
      "cancel": "Cancelar",
      "change": "Alterar",
      "clear": "Limpar",
      "close": "Fechar",
      "confidence": "confiança",
      "confirm": "Confirmar",
      "continue": "Continuar",
      "founded": "Fundado",
      "loading": "A carregar...",
      "of": "de",
      "optional": "Opcional",
      "other": "Outro",
      "save": "Guardar",
      "select": "Selecionar",
      "tryAgain": "Tente novamente",
      "view": "Ver",
      "yourCompany": "a sua empresa",
      "error": {
        "sectionTitle": "Não foi possível carregar esta secção",
        "sectionDescription": "Algo correu mal ao obter os dados. Tente novamente — se o problema persistir, contacte o suporte.",
        "retry": "Tentar novamente"
      },
      "relativeTime": {
        "justNow": "agora mesmo",
        "today": "Hoje",
        "yesterday": "Ontem",
        "weekAgo": "1 semana atrás",
        "monthAgo": "1 mês atrás"
      },
      "contactPlaceholder": "contact@tonnie.ai"
    },
    "components": {
      "addTalentsWizard": {
        "assignToCohort": "Atribuir ao grupo",
        "back": "Voltar",
        "cancel": "Cancelar",
        "chooseCohortTalentsDesc": "Escolha a coorte em que estes talentos entram",
        "bringFromPool": "Trazer do Tonnie Pool",
        "browsePool": "Explorar Pool",
        "chooseImportMethod": "Escolher método de importação",
        "confirmAndImport": "Confirmar & importar",
        "confirmImport": "Confirmar importação",
        "createNewCohort": "Criar nova coorte",
        "createNewProgram": "Criar novo programa",
        "importing": "A importar...",
        "mapColumns": "Mapear colunas",
        "mapColumnsDesc": "Faça corresponder as colunas da folha de cálculo aos campos da Tonnie",
        "needHelpChoosing": "Precisa de ajuda para escolher",
        "needHelpDescriptionNoATS": "Carregue ficheiros Excel ou CSV, ou traga talentos do seu Tonnie Talent Pool (Enterprise), para adicioná-los à sua pipeline. A integração com ATS estará disponível numa versão futura.",
        "next": "Próximo",
        "reviewData": "Rever dados",
        "reviewDataDesc": "Verifique cada linha antes de ser importada",
        "selectImportDesc": "Importe de uma folha de cálculo ou do seu ATS",
        "selectTargetCohort": "Selecionar coorte alvo",
        "uploadExcelCsv": "Carregar Excel csv",
        "uploadFile": "Carregar ficheiro",
        "uploadFileDesc": "Um ficheiro Excel ou CSV com um talento por linha"
      },
      "addToCohort": {
        "addToCohortBtn": "Adicionar à coorte",
        "afterAdding": "Após adicionar",
        "cancel": "Cancelar",
        "chooseCohort": "Escolher coorte",
        "cohortDetails": "Detalhes do cohorte",
        "currentTalents": "Talentos atuais",
        "pleaseSelectCohort": "Por favor, selecione uma coorte",
        "program": "Programa",
        "selectCohort": "Selecionar coorte",
        "title": "Adicionar à coorte",
        "unassigned": "Não atribuído",
        "description_one": "Selecione uma coorte para adicionar o {{count}} talento selecionado",
        "description_other": "Selecione uma coorte para adicionar os {{count}} talentos selecionados",
        "talentsAdded_one": "{{count}} talento adicionado à coorte",
        "talentsAdded_other": "{{count}} talentos adicionados à coorte",
        "talentsSelected_one": "{{count}} talento selecionado",
        "talentsSelected_other": "{{count}} talentos selecionados",
        "talentCount_one": "{{count}} talento",
        "talentCount_other": "{{count}} talentos"
      },
      "confirmDialog": {
        "processing": "A processar"
      },
      "countrySelect": {
        "noResults": "Sem resultados",
        "placeholder": "Placeholder",
        "search": "Pesquisar"
      },
      "pageHeader": {
        "coPilot": "CoPilot",
        "goBack": "Voltar"
      }
    },
    "consent": {
      "objectivesNotShared": "Este talento não partilha o Care com a sua empresa, por isso os objetivos não são mostrados.",
      "withheld": {
        "care_one": "{{count}} talento não partilha o Care",
        "care_other": "{{count}} talentos não partilham o Care",
        "checkup_one": "{{count}} talento não partilha o resultado do CheckUp",
        "checkup_other": "{{count}} talentos não partilham o resultado do CheckUp",
        "passport_stamps_one": "{{count}} talento não partilha o Passport",
        "passport_stamps_other": "{{count}} talentos não partilham o Passport",
        "qultureup_one": "{{count}} talento não partilha o QultureUp",
        "qultureup_other": "{{count}} talentos não partilham o QultureUp",
        "teleportal_one": "{{count}} talento não partilha o TelePortal",
        "teleportal_other": "{{count}} talentos não partilham o TelePortal"
      }
    },
    "copilot": {
      "open": "Abrir CoPilot"
    },
    "dashboard": {
      "activeJourneys": "Percursos ativas",
      "addToTalentPool": "Adicionar ao pool de talentos",
      "aiCoPilot": "AI CoPilot",
      "allClear": "Tudo limpo",
      "allClearTitle": "Tudo limpo",
      "askCoPilot": "Perguntar ao CoPilot",
      "attention": "Precisa de atenção",
      "averageScore": "Pontuação média",
      "coPilotDescription": "Pergunte ao seu assistente de IA sobre insights de mobilidade de talentos, recomendações de programas e análise de dados.",
      "conversionRate": "{{rate}}% de conversão",
      "createCohort": "Criar coorte",
      "critical": "Crítico",
      "evidence": "Evidência",
      "exploreHeroes": "Explorar heróis",
      "healthy": "Saudável",
      "heroes": {
        "assessReadiness": "Avaliar a prontidão dos talentos e a adequação cultural",
        "checkupAndPool": "CheckUp & Pool",
        "commitment": "Compromisso",
        "culturalAdaptation": "Adaptação cultural & iQulture",
        "legalTravelSetup": "Configuração legal, de viagem e de realocação",
        "wellbeingLoyalty": "Monitorização do bem-estar e lealdade",
        "inTransitCount_one": "{{count}} em trânsito",
        "inTransitCount_other": "{{count}} em trânsito",
        "learningCount_one": "{{count}} a aprender",
        "learningCount_other": "{{count}} a aprender",
        "talentsCount_one": "{{count}} talento",
        "talentsCount_other": "{{count}} talentos",
        "thrivingCount_one": "{{count}} a prosperar",
        "thrivingCount_other": "{{count}} a prosperar"
      },
      "importTalents": "Importar talentos",
      "inCheckUp": "Em CheckUp",
      "iqulture": "iQulture",
      "journeyFlow": "Fluxo do percurso",
      "launchProgram": "Lançar programa",
      "milesAndStamps": "{{miles}} milhas · {{stamps}} selos",
      "navigateToDashboards": "Navegar para painéis especializados",
      "needAttention": "Necessita de atenção",
      "needsAttention": "Precisa de atenção",
      "attentionMyTasks": "Minhas tarefas",
      "attentionAtRisk": "Em risco",
      "noRecentEvents": "Sem eventos recentes",
      "noUrgentItems": "Sem itens urgentes que requerem atenção",
      "onTrack": "No caminho certo",
      "organizeTalents": "Organizar talentos em grupos",
      "pipeline": "Pipeline",
      "portfolioHealth": "Saúde do portfólio",
      "portfolioSummary": "A gerir {{programs}} programas e {{cohorts}} coortes",
      "profileCompletion": {
        "addRemainingDetails": "Adicionar detalhes restantes",
        "complexFieldNotice": "Este campo é editável a partir do assistente de integração. Clique em 'Terminar no assistente de integração' para atualizá-lo.",
        "description": "Adicione mais alguns detalhes para desbloquear uma melhor correspondência e faturação mais rápido.",
        "descriptionAlmostThere": "Está quase lá — complete mais alguns detalhes para finalizar o seu perfil.",
        "dialogDesc": "Isto leva alguns segundos e torna a correspondência de talentos mais precisa.",
        "fields": {
          "annualHiringVolume": "Volume de contratações anual",
          "branches": "Escritórios filiais",
          "businessType": "Tipo de negócio",
          "companyName": "Nome da empresa",
          "companySize": "Tamanho da empresa",
          "contactPhone": "Telefone de contacto",
          "contactRole": "Função de contacto",
          "foundedYear": "Ano de fundação",
          "hiringGoals": "Objetivos de contratação",
          "hiringTimeframe": "Prazo de contratação",
          "hqCountry": "País da sede",
          "industry": "Indústria",
          "languages": "Requisitos de língua",
          "legalName": "Nome da entidade legal",
          "mobilityMaturity": "Maturidade de mobilidade",
          "primaryUseCase": "Caso de uso principal",
          "targetMarkets": "Mercados-alvo",
          "targetRoleTypes": "Tipos de funções-alvo",
          "taxId": "NIF / IVA",
          "topChallenges": "Principais desafios",
          "website": "Website",
          "workArrangement": "Arranjo de trabalho"
        },
        "finishInWizard": "Terminar no assistente de integração",
        "seeAll": "Ver todos ({{count}})",
        "title": "Complete o seu perfil",
        "descriptionWithCount_one": "{{count}} detalhe ainda por preencher — leva cerca de um minuto.",
        "descriptionWithCount_other": "{{count}} detalhes ainda a capturar — leva cerca de um minuto."
      },
      "quickActions": "Ações rápidas",
      "recentActivity": "Atividade recente",
      "sendCheckUp": "Enviar CheckUp",
      "sponsored": "Patrocinado",
      "stages": {
        "adaptation": "Adaptação",
        "care": "Care",
        "mobility": "Mobilidade",
        "vetting": "Verificação"
      },
      "startNewMobility": "Iniciar novo programa de mobilidade",
      "startVettingProcess": "Iniciar processo de validação",
      "talentDistribution": "Distribuição de talento ao longo das etapas do percurso",
      "topPerformers": "Melhores desempenhos",
      "urgent": "Urgente",
      "myCareTasks": {
        "title": "Minhas tarefas críticas",
        "viewAll": "Ver tudo em Care"
      },
      "viewAllEvents": "Ver todos os eventos",
      "viewAllIssues": "Ver todos os problemas",
      "viewAnalytics": "Ver análises",
      "welcomeBackBusiness": "Bem-vindo de novo, {{name}}!",
      "onboarding": {
        "title": "Bem-vindo à Tonnie. Vamos configurar os seus primeiros talentos.",
        "body": "O seu painel enche-se assim que importar talentos e agrupá-los num programa. Dois passos e está ativo em aquisição, seleção e patrocínio.",
        "importTitle": "Importar talentos",
        "importBody": "Carregue um CSV ou XLSX, ou adicione candidatos um a um. Os convites são enviados assim que confirmar.",
        "programTitle": "Crie o seu primeiro programa",
        "programBody": "Os programas agrupam coortes e apresentam métricas de aquisição / seleção / patrocínio num só lugar.",
        "helperHint": "Dica: pode fazer qualquer um dos passos primeiro — ligam-se automaticamente um ao outro assim que ambos existirem.",
        "skipToPipeline": "Ir para pipeline",
        "skipToPool": "Navegar na Pool"
      },
      "todayPanel": {
        "blockedSubtitle": "Abra a gaveta para limpar o bloqueador",
        "atRiskSubtitle": "Um empurrão hoje mantém este percurso nos trilhos",
        "title": "Prioridades de hoje",
        "blockedItem": "{{name}}: bloqueado",
        "atRiskItem": "{{name}}: em risco",
        "countLabel_one": "{{count}} ação",
        "countLabel_other": "{{count}} ações",
        "goodNewsItem": "{{name}}: boas notícias"
      },
      "weeklySummary": {
        "thisWeek": "Esta semana"
      },
      "blockedFallback": "Processo bloqueado",
      "riskFallback": "Em risco",
      "attentionAdaptationRisk": "Baixo envolvimento na adaptação",
      "attentionCareRisk": "Compromisso em risco",
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "attentionOverdue_one": "{{count}} em atraso",
      "attentionOverdue_other": "{{count}} em atraso",
      "welcomeBackBusinessNoName": "Bem-vindo de novo!",
      "attentionGoodNews": "Boas notícias"
    },
    "evidence": {},
    "evidencePage": {
      "activeTab": "Ativo",
      "activity": "Atividade",
      "archivedTab": "Arquivado",
      "adaptation": "Adaptação",
      "allClear": "Tudo limpo",
      "allCohorts": "Todas as coortes",
      "allStages": "Todas as etapas",
      "analysis": "Análise",
      "cohortLabel": "Coorte",
      "irrTrendsEmpty": "Ainda não há dados IRR suficientes — o gráfico de evolução é desbloqueado após pelo menos dois meses de atividade.",
      "mesh": {
        "motivation": "Motivação",
        "english": "Inglês",
        "softSkills": "Competências interpessoais",
        "hardSkills": "Competências técnicas"
      },
      "openPassportAria": "Abrir passaporte para {{name}}",
      "sponsoredBadge": "Patrocinado",
      "stageNotShared": "Não partilhado",
      "talentRowActionsAria": "Ações para {{name}}",
      "totalBadges": "Total de distintivos",
      "totalStamps": "Total de selos",
      "averageIQultureScore": "Pontuação Média iQulture",
      "avgIQulture": "Média iQulture",
      "avgProgress": "Média de progresso",
      "careLabel": "Care",
      "carePillarsHealth": "Saúde dos pilares Care",
      "carePillarsHealthDesc": "Como os seus talentos avaliam cada pilar do Care",
      "checkUpProgress": "Progresso do CheckUp",
      "citizenBadges": "Distintivos Citizen",
      "citizenBadgesDesc": "Distintivos que os seus talentos ganharam nos percursos",
      "common": "Comum",
      "description": "A prova do percurso de cada talento: passaportes, selos e distintivos",
      "epic": "Épico",
      "estimatedContribution": "Contribuição estimada",
      "events": "Eventos",
      "iqultureBadgeDist": "Distribuição de crachá iQulture",
      "irrEvolution": "Evolução IRR",
      "irrEvolutionDesc": "Como as evidências dos seus talentos evoluíram ao longo do tempo",
      "legendary": "Lendário",
      "levelsDistributionDesc": "Quantos talentos atingiram cada nível de cidadão",
      "meshScoreBreakdown": "Detalhe MESH",
      "meshScoreDesc": "Pontuações MESH médias dos seus talentos avaliados",
      "milesAndStamps": "{{miles}} milhas · {{stamps}} selos",
      "milesFromAchievements": "Miles de conquistas",
      "mobility": "Mobilidade",
      "needsAttention": "Precisa de atenção",
      "overallHealthScore": "Pontuação geral de saúde",
      "overview": "Visão geral",
      "passports": "Passaportes",
      "rare": "Raro",
      "uncommon": "Incomum",
      "noEvents": "Sem eventos ainda",
      "noPassports": "Nenhum passaporte corresponde aos seus filtros.",
      "rarityDistribution": "Distribuição de raridade",
      "recentEvents": "Eventos recentes",
      "searchTalents": "Pesquisar talentos",
      "sponsoredTalents": "Talentos patrocinados",
      "stageLabel": "Estágio",
      "stampsBadges": "Conquistas",
      "stampsCollection": "Coleção de selos",
      "stampsCollectionDesc": "Selos que os seus talentos recolheram em cada marco",
      "talentReadinessLevels": "Níveis de prontidão de talentos",
      "title": "Evidência",
      "topPerformers": "Melhores desempenhos",
      "totalMiles": "Total de Miles",
      "vettingPool": "Pool de avaliação",
      "talentStatus": {
        "on-track": "Em andamento",
        "at-risk": "Em risco",
        "blocked": "Bloqueado",
        "completed": "Completo",
        "unknown": "Status pendente"
      },
      "pillarScoresPending": "As pontuações Care por pilar aparecerão aqui assim que a projeção do backend Care for lançada.",
      "stages": {
        "vetting": "Verificação",
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care"
      },
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "earned_one": "{{count}} ganho",
      "earned_other": "{{count}} ganhos",
      "passportCount_one": "{{count}} passaporte",
      "passportCount_other": "{{count}} passaportes",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos"
    },
    "feedback": {
      "additionalFeedbackHint": "Pode dar feedback detalhado e anexar capturas de ecrã ou ficheiros para nos ajudar a perceber melhor a sua experiência.",
      "attachFiles": "Anexar ficheiros",
      "categoryDescription": "Selecione a categoria que melhor descreve o seu feedback",
      "categoryQuestion": "Que tipo de feedback é este?",
      "characterCount": "{{current}}/{{max}} caracteres",
      "context": {
        "hero": "Herói",
        "heroPlaceholder": "ex., CheckUp, TelePortal",
        "notDetected": "Nenhum contexto detetado",
        "page": "Página",
        "pagePlaceholder": "ex., /dashboard, /checkup"
      },
      "contextInfo": "Informação de contexto",
      "contextSaved": "Informação de contexto guardada",
      "detailsDescription": "Por favor, forneça detalhes sobre o seu feedback",
      "detailsPlaceholder": "Descreva o seu feedback em detalhe...",
      "detailsQuestion": "Conte-nos mais",
      "editContext": "Editar",
      "fileSizeError": "O tamanho do ficheiro excede o limite de {{maxSize}}",
      "fileUploadDescription": "Adicione capturas de ecrã, PDFs ou outros ficheiros (até 20MB cada) para nos ajudar a entender melhor o seu feedback.",
      "optional": "Opcional",
      "privacyNote": "O seu feedback é anónimo e ajuda-nos a melhorar Tonnie",
      "ratingDescription": "Classifique a sua satisfação geral",
      "ratingQuestion": "Como foi a sua experiência?",
      "selectRatingAndCategory": "Por favor, selecione tanto a classificação como a categoria",
      "submit": "Submeter",
      "submitError": "Falha ao enviar feedback. Por favor, tente novamente.",
      "submitSuccess": "Obrigado! O seu feedback foi enviado.",
      "submitting": "A submeter...",
      "subtitle": "Ajude-nos a melhorar a sua experiência",
      "successMessage": "Agradecemos por dedicar o seu tempo a ajudar-nos a melhorar Tonnie. O seu feedback foi recebido e será analisado pela nossa equipa.",
      "successTitle": "Obrigado pelo seu feedback!",
      "title": "Feedback",
      "toggle": "Enviar feedback",
      "totalFileSize": "{{size}} / {{maxSize}}",
      "uploadFiles": "Carregar ficheiros",
      "validationError": "Por favor, preencha todos os campos obrigatórios"
    },
    "affiliate": {
      "availableBalance": "Saldo disponível",
      "codeCopied": "Código de cupão copiado",
      "colActions": "Ações",
      "colAmount": "Montante",
      "colAmountPaid": "Montante pago",
      "colCommission": "Comissão",
      "colDate": "Data",
      "colProgress": "Progresso",
      "colRequested": "Solicitado",
      "colRoute": "Rota",
      "colScenario": "Cenário",
      "colStatus": "Estado",
      "daysWaiting": "{{count}}d à espera",
      "paidOn": "Pago {{date}}",
      "commission": "Comissão",
      "copyCode": "Copiar código",
      "discountGiven": "Desconto concedido",
      "exportCsv": "Exportar CSV",
      "exporting": "A exportar…",
      "exportReady": "Exportação pronta",
      "exportFailed": "Não foi possível exportar os resgates",
      "filters": {
        "granularityLabel": "Agrupar por",
        "granularity": {
          "day": "Dia",
          "month": "Mês",
          "year": "Ano"
        },
        "rangeLabel": "Período",
        "range": {
          "30d": "30 dias",
          "90d": "90 dias",
          "12m": "12 meses",
          "all": "Todo o tempo"
        },
        "scenarioLabel": "Cenário",
        "scenarioAll": "Todos os cenários",
        "statusLabel": "Estado",
        "statusAll": "Todos os estados"
      },
      "scenario": {
        "unlock": "Desbloqueio do percurso",
        "renewal": "Renovação",
        "pro": "Pro",
        "other": "Outro"
      },
      "noRedemptionsForFilters": "Nenhum resgate corresponde a estes filtros.",
      "redemptionsTitle": "Resgates",
      "rowsPerPage": "Linhas por página",
      "showingRange": "{{from}}–{{to}} de {{total}}",
      "goToPage": "Ir para a página {{page}}",
      "prev": "Anterior",
      "next": "Próximo",
      "checkout": "Tonnie checkout",
      "checkoutSecure": "Seguro · Stripe",
      "customerView": "O que o seu cliente vê",
      "howTitle": "Como o programa funciona",
      "howStep1Title": "Partilhe o seu código",
      "howStep1Body": "Dê {{code}} às pessoas que recomendar à Tonnie.",
      "howStep2Title": "Eles economizam {{percent}}%",
      "howStep2Body": "O código é aplicado no checkout — o preço diminui antes de pagarem.",
      "howStep3Title": "Ganha {{rate}}%",
      "howStep3Body": "Em cada conversão paga, {{rate}}% do que eles pagam é creditado na sua conta.",
      "howStep4Title": "Retirar",
      "howStep4Body": "Uma vez que o seu saldo atinja {{amount}}, solicite um pagamento e carregue a sua fatura para ser pago.",
      "refundsNote": "A comissão acumula-se apenas quando um pagamento é bem-sucedido. Reembolsos dentro da janela revertam automaticamente a comissão correspondente.",
      "sampleProduct": "Pro journey",
      "sampleProductSub": "Assinatura mensal",
      "invoiceOnFile": "Fatura recebida",
      "invoiceUploaded": "Fatura carregada",
      "invoiceUploadFailed": "Falha no carregamento da fatura",
      "minimumPayout": "Pagamento mínimo: {{amount}}",
      "noPayoutsYet": "Ainda não foram solicitados pagamentos.",
      "noRedemptionsYet": "Ainda não houve resgates.",
      "notEnrolledBody": "Esta organização não está inscrita no programa de afiliados Tonnie. Contacte Tonnie para começar.",
      "notEnrolledTitle": "Ainda não é um afiliado",
      "awaitingApproval": "A aguardar aprovação",
      "cancel": "Cancelar",
      "payoutCancelled": "Pagamento cancelado — saldo liberado",
      "payoutCancelFailed": "Não foi possível cancelar o pagamento",
      "payoutFailed": "Não foi possível solicitar pagamento",
      "payoutHistory": "Histórico de pagamentos",
      "payoutRequested": "Pagamento solicitado",
      "payoutStep1Title": "Pedido",
      "payoutStep1Body": "Pede um pagamento do seu saldo disponível.",
      "payoutStep2Title": "Aprovação",
      "payoutStep2Body": "Tonnie revisa e aprova o seu pedido.",
      "payoutStep3Title": "Fatura",
      "payoutStep3Body": "Carrega a sua fatura com o montante.",
      "payoutStep4Title": "Pagamento",
      "payoutStep4Body": "Tonnie paga-lhe por transferência bancária.",
      "payoutStatus": {
        "approved": "Aprovado",
        "cancelled": "Cancelado",
        "invoice_received": "Fatura recebida",
        "paid": "Pago",
        "rejected": "Rejeitado",
        "requested": "Solicitado"
      },
      "percentOff": "{{percent}}% de desconto",
      "platform": {
        "colCommission": "Comissão",
        "colDiscount": "Desconto",
        "colIssuer": "Afiliado",
        "colPaid": "Pago",
        "colRedemptions": "Resgates",
        "errorHint": "Tente novamente ou verifique o seu acesso de equipa Tonnie.",
        "errorTitle": "Não foi possível carregar a visão da plataforma",
        "issuersTitle": "Por afiliado",
        "noIssuers": "Ainda sem resgates pagos.",
        "totalCommission": "Comissão total",
        "totalDiscount": "Desconto total concedido",
        "totalPaid": "Total pago",
        "totalRedemptions": "Total de resgates"
      },
      "yourCommission": "Ganha {{rate}}%",
      "discountHint": "O desconto que os seus clientes recebem na finalização da compra.",
      "commissionHint": "A sua comissão sobre cada montante que eles pagam.",
      "redemptionsOverTime": "Resgates ao longo do tempo",
      "redemptionStatus": {
        "paid": "Pago",
        "pending": "Pendente",
        "refunded": "Reembolsado"
      },
      "requestPayout": "Solicitar pagamento",
      "subtitle": "Acompanhe os resgates do seu cupão e retire a sua comissão.",
      "tabHowItWorks": "Como funciona",
      "tabOverview": "Visão geral",
      "tabPayouts": "Pagamentos",
      "tabPlatform": "Plataforma",
      "title": "Programa de afiliados",
      "totalCommission": "Comissão total",
      "totalRedemptions": "Resgates",
      "uploadInvoice": "Carregar fatura",
      "uploading": "A carregar…",
      "yourCode": "O seu código de cupão"
    },
    "layout": {
      "adaptation": "Adaptação",
      "affiliates": "Afiliados",
      "billing": "Faturação",
      "business": "Business",
      "care": "Care",
      "cohorts": "Coortes",
      "evidence": "Evidência",
      "home": "Início",
      "logout": "Sair",
      "messages": "Mensagens",
      "mobility": "Mobilidade",
      "pipeline": "Pipeline",
      "pool": "Pool",
      "programs": "Programas",
      "settings": "Definições",
      "vetting": "Verificação",
      "inoutOperations": "Operação InOut"
    },
    "legal": {
      "aboutUs": "Sobre nós",
      "backToDashboard": "Voltar ao painel",
      "dataProtection": "Proteção de dados",
      "dataProtectionBody": "Entidade de proteção de dados",
      "gdprBody": "Entidade GDPR",
      "gdprCompliance": "Conformidade GDPR",
      "privacyBody": "Entidade de privacidade",
      "privacyDescription": "Como a Tonnie recolhe, usa e protege dados pessoais",
      "privacyPolicy": "Política de privacidade",
      "rightsDescription": "Os seus direitos sobre os dados que a Tonnie guarda, e como os exercer",
      "subtitle": "Legenda",
      "termsBody": "Entidade de termos",
      "termsDescription": "Os termos que regem o uso da Tonnie pela sua empresa",
      "termsOfService": "Termos de serviço",
      "title": "Termos & privacidade",
      "viewPrivacy": "Ver privacidade",
      "viewTerms": "Ver termos",
      "yourRights": "Os seus direitos"
    },
    "mobilityPage": {
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "allStatus": "Todos os status",
      "allTracks": "Todas as pistas",
      "analytics": "Análises",
      "acrossAllTracks": "Em todas as pistas",
      "avgProgress": "Média de progresso",
      "blocked": "Bloqueado",
      "blockingDocs": "Documentos bloqueadores",
      "complete": "Completo",
      "viewAll": "Ver todos",
      "detailsBtn": "Detalhes",
      "detailsAria": "Abrir detalhes de CoPilot para {{name}}",
      "viewTalentAria": "Ver detalhes para {{name}}",
      "talentRowActionsAria": "Ações para {{name}}",
      "blockingDocsPending": "Documentos bloqueadores pendentes",
      "coTasks": "Tarefas",
      "companyActions": "Ações da empresa",
      "atRiskTalents": "Em risco",
      "overdueTasks": "Tarefas atrasadas",
      "companyActionsRequired": "Ações da empresa necessárias",
      "companyDocsPending": "Documentos da empresa pendentes",
      "companyActionsSectionTitle": "Tarefas da empresa",
      "companyTasksDesc": "Obrigações da empresa em relação aos seus talentos patrocinados — agrupadas por talento.",
      "companyTasksPending": "Tarefas da empresa pendentes",
      "companyTasksPendingCount_one": "{{count}} tarefa da empresa pendente",
      "companyTasksPendingCount_other": "{{count}} tarefas da empresa pendentes",
      "companyTasksTitle": "Tarefas da empresa",
      "companyTasksOpenTab": "Aberto ({{count}})",
      "companyTasksCompletedTab": "Concluído ({{count}})",
      "companyTasksEmpty": "Nenhuma tarefa aqui.",
      "attachUpload": "Anexar & carregar",
      "awaitingUpload": "A aguardar carregamento",
      "docsAttachedCount": "{{uploaded}}/{{total}} docs",
      "noDocsRequired": "Nenhum documento necessário — marque como completo quando terminar.",
      "replaceDocument": "Substituir",
      "reopenTaskAria": "Reabrir {{title}}",
      "requiredDocuments": "Documentos necessários",
      "docsRequiredToCompleteTitle": "Carregar documentos necessários",
      "docsUploadedProgress": "{{uploaded}} de {{total}} documentos carregados",
      "allDocsUploadedReadyToComplete": "Todos os documentos carregados — pode concluir esta tarefa.",
      "taskReopened": "Reaberto \"{{title}}\"",
      "taskReopenFailed": "Falha ao reabrir \"{{title}}\". Por favor, tente novamente.",
      "completed": "Completo",
      "completionRate": "Taxa de conclusão",
      "description": "Vistos, viagem e instalação nas mudanças dos seus talentos patrocinados",
      "documentUploadedSuccess": "{{name}} carregou",
      "done": "Feito",
      "dueDate": "Vencido: {{date}}",
      "filterStatus": "Estado",
      "filterTrack": "Acompanhar",
      "for": "Para",
      "forTalent": "Para {{name}}",
      "inMobility": "Em Mobilidade",
      "inMobilitySplit": "{{inProgress}} em progresso · {{completed}} concluídos",
      "statusInProgress": "Em progresso",
      "engaged": "Envolvido",
      "inProgressShort": "em progresso",
      "noTalentsInTrack": "Ainda não há talentos nesta pista",
      "viewCompletedTalents": "Ver talentos concluídos",
      "viewBlockedTalents": "Ver talentos bloqueados",
      "viewAtRiskTalents": "Ver talentos em risco",
      "trackCompletion": "Conclusão da pista",
      "trackCompletionDescription": "Quantos talentos terminaram cada pista",
      "doneOfEngaged": "{{name}} · {{done}}/{{engaged}}",
      "legal": "Legal",
      "milestones": "Marcos",
      "mobilityTracks": "Pistas de mobilidade",
      "overall": "Global",
      "noDueDate": "Sem data de vencimento",
      "noPendingTasks": "Sem tarefas pendentes",
      "noTalentsFound": "Nenhum talento encontrado",
      "noTalentsInMobility": "Nenhum talento em mobilidade",
      "onTrack": "No caminho certo",
      "pendingTasks": "Tarefas pendentes",
      "reminderSent": "Lembrete enviado para {{title}}",
      "searchTalents": "Pesquisar talentos",
      "setup": "Configuração",
      "statusAtRisk": "Status em risco",
      "statusBlocked": "Status bloqueado",
      "statusOnTrack": "Status em andamento",
      "talentProgress": "Progresso do talento",
      "talentsBlocked": "Talentos bloqueados",
      "taskMarkedComplete": "{{title}} marcado como completo",
      "taskCompleteFailed": "Falha ao marcar \"{{title}}\" como completo. Por favor, tente novamente.",
      "title": "Mobilidade",
      "trackOverview": "Visão geral do rastreamento",
      "travel": "Viagem",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "underReview": "Em revisão",
      "validated": "Validado",
      "waitingOnCompanyCount": "A aguardar a empresa",
      "actionNeeded": "Ação necessária",
      "allTasksCompletedTitle": "Todas as tarefas concluídas!",
      "clearFiltersButton": "Limpar filtros",
      "trackProgressOverview": "Visão geral do progresso do rastreamento",
      "companyActionsSection": "Ações da empresa",
      "completeTaskAria": "Marcar {{title}} como completo",
      "waitingOnCompany": "A aguardar a empresa",
      "statusLabels": {
        "completed": "Completo",
        "on-track": "Em andamento",
        "blocked": "Bloqueado",
        "at-risk": "Em risco"
      },
      "trackStatusLegend": {
        "done": "Feito",
        "inProgress": "Em progresso",
        "blocked": "Bloqueado",
        "notStarted": "Não iniciado"
      },
      "lastActivityUnknown": "Sem atividade ainda",
      "tracks": {
        "legal": {
          "name": "Legal",
          "description": "Visto, permissões de trabalho, documentação"
        },
        "travel": {
          "name": "Viagem",
          "description": "Voos, logística, coordenação de chegada"
        },
        "setup": {
          "name": "Configuração",
          "description": "Habitação, bancos, registo local"
        }
      },
      "urgentTasksSummary_one": "{{count}} tarefa urgente precisa de atenção",
      "urgentTasksSummary_other": "{{count}} tarefas urgentes precisam de atenção",
      "documentUploadFailed": "Falha ao carregar. Tente novamente.",
      "reminderTooSoonGeneric": "Lembrete enviado recentemente.",
      "reminderFailed": "Falha ao enviar lembrete. Tente novamente.",
      "uploadTooLarge": "O ficheiro tem mais de 25 MB. Corte-o ou comprima-o e tente novamente.",
      "docsStillOutstanding_one": "{{count}} documento necessário",
      "docsStillOutstanding_other": "{{count}} documentos necessários",
      "daysOverdue_one": "{{count}} dia de atraso",
      "daysOverdue_other": "{{count}} dias de atraso",
      "dueInDays_one": "Vence em {{count}} dia",
      "dueInDays_other": "Vence em {{count}} dias",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "pendingCount_one": "{{count}} pendente",
      "pendingCount_other": "{{count}} pendentes",
      "talentCountCompleted_one": "{{count}} de {{total}} {{label}}",
      "talentCountCompleted_other": "{{count}} de {{total}} {{label}}",
      "reminderTooSoon_one": "Lembrete enviado recentemente. Tente novamente dentro de {{count}} hora.",
      "reminderTooSoon_other": "Lembrete enviado recentemente. Tente novamente dentro de {{count}} horas."
    },
    "nav": {
      "home": "Início"
    },
    "notFound": {
      "description": "A página que procura não existe ou foi movida.",
      "goHome": "Ir para casa",
      "title": "Página não encontrada"
    },
    "notifications": {
      "justNow": "Agora mesmo",
      "noNotifications": "Sem notificações",
      "title": "Notificações",
      "tabAll": "Todas",
      "unread": "Não lidas",
      "noUnread": "Sem notificações por ler",
      "markAllRead": "Marcar todas como lidas",
      "bellLabel_one": "Notificações, {{shown}} por ler",
      "bellLabel_other": "Notificações, {{shown}} por ler",
      "clearRead": "Limpar lidas",
      "moreActions": "Mais ações",
      "markReadAction": "Marcar como lida",
      "dismiss": "Dispensar",
      "dismissed": "Notificação dispensada",
      "undo": "Anular",
      "viewDismissed": "Ver dispensadas",
      "dismissedTitle": "Dispensadas",
      "restore": "Restaurar",
      "noDismissed": "Sem notificações dispensadas",
      "seeAll": "Ver todas as notificações",
      "showMore": "Ver mais",
      "showLess": "Ver menos",
      "daysAgo_one": "Há {{count}} dia",
      "daysAgo_other": "Há {{count}} dias",
      "hoursAgo_one": "Há {{count}} hora",
      "hoursAgo_other": "Há {{count}} horas",
      "minutesAgo_one": "Há {{count}} minuto",
      "minutesAgo_other": "Há {{count}} minutos"
    },
    "onboarding": {
      "challenges": {
        "candidateDropoff": "Desistência de candidatos durante a relocação",
        "complianceLegal": "Complexidade de conformidade e legal",
        "costManagement": "Gestão de custos",
        "findingCandidates": "Encontrar candidatos internacionais qualificados",
        "immigrationVisa": "Complexidade de imigração e vistos",
        "postArrival": "Adaptação e retenção pós-chegada",
        "trackingReporting": "Rastreamento e relatórios"
      },
      "exitSetup": "Configuração de saída",
      "geographicSetup": {
        "moreRoutes_one": "+{{count}}",
        "moreRoutes_other": "+{{count}}"
      },
      "hiringContext": {
        "selectedChallenges": "Selecionado: {{count}}/3 desafios"
      },
      "hiringGoals": {
        "buildPipeline": "Construir um pipeline de talentos sustentável",
        "improveExperience": "Melhorar a experiência do candidato durante a relocação",
        "improveOnboarding": "Melhorar a integração e adaptação pós-chegada",
        "increaseRetention": "Aumentar a retenção de funcionários relocados",
        "reduceCosts": "Reduzir custos de relocação",
        "reduceTime": "Reduzir o tempo para contratação de candidatos internacionais",
        "streamlineCompliance": "Agilizar processos de conformidade e vistos",
        "trackRoi": "Rastrear e medir o ROI da mobilidade"
      },
      "hiringTimeframes": {
        "immediate": "Imediato — pronto para começar agora",
        "long": "A longo prazo (6–12 meses)",
        "medium": "A médio prazo (3–6 meses)",
        "short": "A curto prazo (1–3 meses)"
      },
      "maturity": {
        "established": "Programa estabelecido — função de mobilidade madura",
        "firstTime": "Primeira vez — novo na contratação internacional",
        "someExperience": "Alguma experiência — fiz algumas relocacões"
      },
      "personalInfo": {
        "addressDetailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
        "addressHint": "Selecione o seu endereço a partir das sugestões",
        "addressPlaceholder": "Comece a escrever o seu endereço...",
        "addressSearchError": "Falha ao pesquisar endereços. Por favor, tente novamente.",
        "loadingAddressDetails": "A carregar detalhes do endereço...",
        "searchAddress": "Pesquisar endereço",
        "searchAddressDescription": "Escreva o seu endereço e selecione nas sugestões do Google Places"
      },
      "saving": "A guardar...",
      "step": "Passo",
      "workArrangements": {
        "flexible": "Flexível",
        "hybrid": "Híbrido",
        "onsite": "Presencial"
      }
    },
    "pipelinePage": {
      "activeTab": "Ativo",
      "addTalents": "Adicionar talentos",
      "allCohorts": "Todas as coortes",
      "allPrograms": "Todos os programas",
      "archivedSubtitle": "Candidatos cujos percursos terminaram — contas arquivadas pelo administrador ou eliminadas pelo próprio",
      "archivedTab": "Arquivado",
      "avgIQulture": "Média iQulture",
      "bucketAcquisition": "Aquisição",
      "bucketAcquisitionDescription": "Fonte / Importado",
      "bucketSponsored": "Patrocinado",
      "bucketSponsoredDescription": "Mobilidade · Adaptação · Care",
      "bucketVetting": "Verificação",
      "bucketVettingDescription": "CheckUp em progresso",
      "clearAll": "Limpar tudo",
      "cohort": "Coorte",
      "description": "Cada talento do primeiro contacto ao patrocínio, fase a fase",
      "filters": "Filtros",
      "formerCandidate": "Ex-candidato",
      "inPipeline": "Em pipeline",
      "needAttention": "Necessita de atenção",
      "noCohortFound": "Nenhum grupo encontrado",
      "noProgramFound": "Nenhum programa encontrado",
      "onTrack": "No caminho certo",
      "pipelineView": "Vista do pipeline",
      "scrollNext": "Próxima coluna",
      "scrollPrev": "Coluna anterior",
      "program": "Programa",
      "searchCohorts": "Pesquisar grupos",
      "searchPlaceholder": "Pesquisar...",
      "searchPrograms": "Pesquisar programas",
      "status": "Estado",
      "statusAtRisk": "Em risco",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completo",
      "statusOnTrack": "No caminho certo",
      "title": "Pipeline",
      "bulkBarAria": "Ações em massa para talentos selecionados",
      "bulkAddToCohort": "Adicionar à coorte",
      "bulkAddToCohortFailed": "Falha ao atribuir talentos selecionados",
      "bulkAddToCohortPartial": "{{added}} atribuídos ao grupo · {{skipped}} não puderam ser atribuídos",
      "cardTag": "Etiqueta do cartão",
      "selectWholeColumn": "Selecionar a coluna inteira",
      "talentsInPipeline_one": "{{count}} talento no pipeline",
      "talentsInPipeline_other": "{{count}} talentos no pipeline",
      "bulkAddToCohortSuccess_one": "{{count}} talento atribuído à coorte",
      "bulkAddToCohortSuccess_other": "{{count}} talentos atribuídos à coorte",
      "searchLabel": "Pesquisar talentos"
    },
    "vettingCard": {
      "acceptedAgo": "Aceite {{when}}",
      "checkupProgress": "CheckUp {{percent}}% · {{done}} de {{total}} etapas",
      "iqultureProgress": "iQulture {{percent}}%",
      "lastSeenAgo": "Visto pela última vez {{when}}",
      "missingSteps": "Em falta: {{steps}}",
      "notYetActive": "Ainda não ativo",
      "startedAgo": "Iniciado {{when}}",
      "stateAwaitingScore": "A calcular iQulture…",
      "stateNotStarted": "Não iniciado",
      "step": {
        "assistantChat": "Chat de assistente",
        "languageTests": "Testes de língua",
        "motivationalAnswers": "Motivação",
        "pitchVideo": "Vídeo de apresentação",
        "videosWatched": "Ver vídeos"
      },
      "submittedAgo": "Submetido {{when}}",
      "testitComplete": "TestIt concluído",
      "testitInvited": "TestIt convidado",
      "testitProgress": "TestIt · {{done}}/{{total}}",
      "scoredAgo": "Pontuado {{when}}",
      "completedAgo": "Concluído {{when}}",
      "sharingWithdrawnAgo": "Partilha retirada {{when}}"
    },
    "pipelineView": {
      "activateAgain": "Ativar novamente",
      "addTalentsCta": "Adicionar talentos",
      "archive": "Arquivar",
      "archiveSponsoredConfirmDescription": "Isto arquiva o percurso patrocinado de {{name}}: o cartão sai do seu pipeline e {{name}} perde o acesso a esta oportunidade. Os resultados do CheckUp e o histórico do percurso ficam guardados para efeitos de conformidade. Pode restaurá-lo no separador Arquivados.",
      "archiveSponsoredConfirmTitle": "Arquivar talento patrocinado",
      "archiving": "A arquivar…",
      "askForCheckup": "Convidar para CheckUp completo",
      "askForTestit": "Convidar para testes específicos",
      "bulkArchiveCta": "Arquivar {{count}}",
      "bulkArchiveFailed": "Falha ao arquivar talentos",
      "bulkArchivePartial": "{{archived}} arquivados · {{failed}} falhados",
      "bulkClear": "Limpar",
      "bulkSendConfirmCta": "Enviar convites",
      "bulkSendConfirmTitle": "Enviar convites para Verificação",
      "bulkSendPartial": "{{sent}} enviados · {{failed}} falhados",
      "bulkSending": "A enviar…",
      "bulkSendingProgress": "A enviar convites… {{sent}}/{{total}}",
      "bulkSponsorCta": "Patrocinar {{count}}",
      "bulkSponsorFailed": "Falha ao patrocinar talentos",
      "bulkSponsorPartial": "{{sponsored}} patrocinados · {{failed}} falhados",
      "citizenLeft": "Candidato saiu da plataforma",
      "citizenLeftTooltip": "Este candidato eliminou a sua conta Tonnie. O seu percurso é preservado para auditoria; os dados identificativos são ocultados.",
      "clearSearch": "Limpar filtro",
      "delete": "Eliminar",
      "deleteConfirmDescription": "Isto irá remover permanentemente {{name}} e todo o histórico de importação (eventos do pipeline, percursos, mensagens). Esta ação não pode ser desfeita.",
      "deleteConfirmTitle": "Eliminar talento",
      "deleteInvitationConfirmDescription": "Isto irá remover permanentemente o convite para {{name}}. Eles não poderão aceitar o link do email. Esta ação não pode ser desfeita.",
      "deleteInvitationConfirmTitle": "Eliminar convite",
      "deleteInvitationFailed": "Falha ao eliminar convite",
      "deleteInvitationSuccess": "Convite eliminado",
      "deleting": "A eliminar…",
      "dragNotAllowed": "Não é possível mover de {{from}} para {{to}} — use o menu kebab para a ação correta",
      "imported": "Importado {{when}}",
      "invitationDeleteFailed": "Falha ao remover convite",
      "invitationDeleted": "Convite de {{name}} removido",
      "invitationResendFailed": "Falha ao reenviar",
      "invitationResent": "Convite reenviado",
      "invitationRevokeFailed": "Falha ao revogar",
      "invitationRevoked": "Convite revogado",
      "invitationSendFailed": "Falha ao enviar convite",
      "invitationSent": "Convite enviado",
      "invitationSentHint": "{{name}} receberá o email e o cartão move-se para Vetting.",
      "inviteToVetting": "Convidar para Vetting",
      "noMatches": "Sem correspondências para \"{{query}}\"",
      "noTalentsInStage": "Sem talentos nesta fase",
      "removeFromPipeline": "Remover do pipeline",
      "removeVettingConfirmDescription": "Isto retira {{name}} do seu pipeline e {{name}} perde o acesso a esta oportunidade. Os dados do CheckUp e o histórico ficam guardados para efeitos de conformidade. Pode restaurá-lo no separador Arquivados.",
      "removeVettingConfirmTitle": "Remover talento do pipeline",
      "invitationEmailNotSent": "O convite ficou guardado, mas não foi possível enviar o e-mail",
      "resendInvitationFailed": "Falha ao reenviar convite",
      "resendInvitationSuccess": "Convite reenviado",
      "revokeInvitationFailed": "Falha ao revogar convite",
      "revokeInvitationSuccess": "Convite revogado",
      "searchPlaceholder": "Filtrar nome, email, função…",
      "selectAllCount": "Selecionar tudo ({{selected}}/{{total}})",
      "selectAllMatching": "Selecionar tudo correspondente ({{visible}})",
      "statusArchived": "Arquivado",
      "stageStatus": {
        "onTrack": "Em andamento",
        "blocked": "Bloqueado",
        "atRisk": "Em risco",
        "completed": "Completo"
      },
      "statusAwaitingAcceptance": "A aguardar aceitação",
      "statusDraft": "Rascunho",
      "subStage": {
        "mobility": "Mobilidade",
        "adaptation": "Adaptação",
        "care": "Care",
        "evidence": "Evidência"
      },
      "talentArchiveFailed": "Falha ao arquivar talento",
      "talentArchived": "{{name}} arquivado",
      "talentDeleteFailed": "Falha ao eliminar talento",
      "talentDeleted": "{{name}} foi removido",
      "talentSponsored": "Talento patrocinado! Instância do percurso criado com rota {{origin}} → {{destination}}",
      "talentSponsoredFailed": "Falha ao patrocinar talento",
      "unarchiveFailed": "Falha ao restaurar talento",
      "unarchiveSuccess": "Talento restaurado — percurso ativo novamente",
      "updated": "Atualizado {{when}}",
      "selectCandidate": "Selecionar candidato",
      "signedUpNotAccepted": "Registou-se, não aceitou",
      "signedUpNotAcceptedTooltip": "Esta pessoa já tem conta Tonnie mas não aceitou o seu convite. Reenviar tem boas probabilidades de a alcançar. O percurso e o CheckUp permanecem privados até que aceite.",
      "tag": {
        "inviteProblem": "Problema no convite",
        "onboardingIncomplete": "A completar perfil",
        "waitingForCheckup": "À espera do CheckUp",
        "checkupInProgress": "CheckUp em curso",
        "awaitingScore": "A calcular pontuação",
        "awaitingReview": "Pronto para análise",
        "testitPending": "Testes pendentes",
        "testitComplete": "Testes concluídos",
        "testitPassed": "Aprovado",
        "testitDeclined": "Recusado",
        "checkupNotRequested": "CheckUp não solicitado",
        "inviteDeclined": "Recusou",
        "inviteExpired": "Convite expirado",
        "sponsorshipOffered": "Patrocínio oferecido",
        "checkupWithheld": "A aguardar o consentimento do talento",
        "consentWithdrawn": "Partilha retirada"
      },
      "since": {
        "delivered": "Entregue {{when}}",
        "opened": "Aberto {{when}}",
        "landed": "Acedeu à página {{when}}",
        "bounced": "Devolvido {{when}}",
        "sent": "Convidado {{when}}",
        "signedUp": "Registou-se {{when}}",
        "asked": "Solicitado {{when}}",
        "expired": "Expirou {{when}}"
      },
      "alreadyArchived": "Este talento já estava arquivado. O quadro está atualizado.",
      "alreadyRestored": "Este percurso já tinha sido restaurada. O quadro está atualizado.",
      "invitationAlreadyAccepted": "Este convite já foi aceite.",
      "bulkArchiveConfirmTitle_one": "Arquivar {{count}} talento",
      "bulkArchiveConfirmTitle_other": "Arquivar {{count}} talentos",
      "bulkArchiveConfirmCta_one": "Arquivar {{count}} talento",
      "bulkArchiveConfirmCta_other": "Arquivar {{count}} talentos",
      "bulkArchiveConfirmDescription_one": "{{count}} talento sai do seu pipeline ativo. Os resultados do CheckUp e o histórico do percurso ficam guardados para efeitos de conformidade. Pode restaurá-lo no separador Arquivados.",
      "bulkArchiveConfirmDescription_other": "{{count}} talentos saem do seu pipeline ativo. Os resultados do CheckUp e o histórico do percurso ficam guardados para efeitos de conformidade. Pode restaurá-los no separador Arquivados.",
      "bulkArchiveSuccess_one": "{{count}} talento arquivado",
      "bulkArchiveSuccess_other": "{{count}} talentos arquivados",
      "atRiskCount_one": "{{count}} em risco",
      "atRiskCount_other": "{{count}} em risco",
      "blockedCount_one": "{{count}} bloqueado",
      "blockedCount_other": "{{count}} bloqueados",
      "bulkSelectedCount_one": "{{count}} selecionado",
      "bulkSelectedCount_other": "{{count}} selecionados",
      "bulkSendCta_one": "Enviar {{count}} convite para Vetting",
      "bulkSendCta_other": "Enviar {{count}} convites para Vetting",
      "searchLabel": "Filtrar talentos em {{stage}}",
      "declinedWhen": "Recusou {{when}}",
      "expiredWhen": "Expirou {{when}}",
      "invitationSentAgain": "Convite enviado novamente",
      "leftProgramme": "Saiu do programa · {{date}}",
      "leftProgrammeTooltip": "Este talento saiu do seu programa, o que terminou a relação. Já não vê o que partilhou. Envie-lhe um novo convite para voltar a trabalhar com ele.",
      "restoreRefusedLeft": "Este talento saiu do seu programa. Envie-lhe um novo convite para voltar a trabalhar com ele.",
      "resendInvitationMessageMismatch": "A mensagem deste convite foi escrita para outro pedido. Envie-o novamente a partir da janela do convite para escrever a mensagem."
    },
    "pool": {
      "smartSearch": {
        "downloadCv": "Descarregar CV",
        "cvUnavailable": "CV indisponível",
        "selectCandidate": "Selecionar candidato",
        "clearSelection": "Limpar",
        "bulkAddTitle": "Adicionar à aquisição",
        "stepReview": "Rever e ordenar",
        "how1": "Cole uma ou mais descrições de função.",
        "how2": "A IA extrai as competências, a senioridade e o foco.",
        "how3": "Ordenamos a sua Pool de Talentos por adequação.",
        "extracting": "A ler a descrição da função…",
        "extractError": "Não foi possível analisar essa descrição de função. Tente novamente.",
        "skillsTitle": "Competências encontradas",
        "skillsHint": "Remova as que não se aplicam ou adicione as suas — a ordenação atualiza em tempo real.",
        "ranking": "A ordenar…",
        "noSkills": "Nenhuma competência extraída",
        "noSkillsHint": "Adicione abaixo as competências-chave para esta função.",
        "addSkillPlaceholder": "Adicionar uma competência…",
        "viewResults": "Ver resultados ordenados",
        "rankedTitle": "Pool ordenada por adequação à função",
        "rankedForTitle": "Ordenada para {{title}}",
        "clear": "Limpar",
        "nSelected_one": "{{count}} selecionado",
        "nSelected_other": "{{count}} selecionados",
        "addNToAcquisition_one": "Adicionar {{count}} à aquisição",
        "addNToAcquisition_other": "Adicionar {{count}} à aquisição",
        "bulkAddDesc_one": "Adicionar {{count}} candidato selecionado à fase de Aquisição do seu pipeline.",
        "bulkAddDesc_other": "Adicionar {{count}} candidatos selecionados à fase de Aquisição do seu pipeline.",
        "bulkAdded_one": "{{count}} adicionado à aquisição",
        "bulkAdded_other": "{{count}} adicionados à aquisição",
        "bulkFailed_one": "{{count}} não foi adicionado",
        "bulkFailed_other": "{{count}} não foram adicionados",
        "analyzing_one": "A analisar {{count}} descrição de função…",
        "analyzing_other": "A analisar {{count}} descrições de função…",
        "resultsFound_one": "{{count}} candidato corresponde",
        "resultsFound_other": "{{count}} candidatos correspondem",
        "bulkDuplicates_one": "{{count}} já está nesta coorte",
        "bulkDuplicates_other": "{{count}} já estão nesta coorte",
        "addSkillLabel": "Adicionar uma competência"
      },
      "matchReason": {
        "mustHaves": "Requisitos: {{met}}/{{total}}",
        "seniority": "Senioridade {{level}}",
        "semantic": "{{score}}% de correspondência de perfil",
        "skills": "{{count}}/{{total}} competências: {{skills}}",
        "readiness": "Prontidão {{score}}",
        "location": "Em {{location}}",
        "niceToHaves_one": "+{{count}} desejável",
        "niceToHaves_other": "+{{count}} desejáveis"
      },
      "savedSearch": {
        "title": "Pesquisas guardadas",
        "savedCount": "Guardadas ({{count}})",
        "save": "Guardar",
        "saved": "Pesquisa guardada",
        "saveFailed": "Não foi possível guardar a pesquisa",
        "delete": "Eliminar pesquisa guardada",
        "deleteFailed": "Não foi possível eliminar a pesquisa",
        "noSkills": "Sem competências",
        "saveTitle": "Guardar esta pesquisa",
        "saveDesc": "Dê-lhe um nome para reexecutar esta pesquisa por descrição de função mais tarde.",
        "nameLabel": "Nome",
        "namePlaceholder": "ex.: Engenheiro Backend Sénior",
        "errors": {
          "name": "É necessário um nome"
        }
      },
      "detail": {
        "unavailable": "Candidato indisponível",
        "unavailableHint": "Este candidato já não está na pool.",
        "curriculum": "Currículo",
        "openCv": "Abrir em novo separador",
        "noCv": "Sem CV disponível",
        "noCvHint": "Este candidato ainda não anexou um currículo.",
        "experience": "Experiência",
        "seniority": "Senioridade",
        "origin": "Origem",
        "inPoolSince": "Na pool desde",
        "languages": "Idiomas",
        "linkedin": "Perfil no LinkedIn",
        "availOpen": "Aberto a propostas",
        "availConsideration": "Em consideração",
        "availUnavailable": "Indisponível",
        "experienceValue_one": "{{count}} ano",
        "experienceValue_other": "{{count}} anos"
      },
      "view": {
        "cards": "Cartões",
        "list": "Lista"
      },
      "advancedSearch": {
        "addAtLeastOneJob": "Por favor, adicione pelo menos uma descrição de trabalho",
        "addedSuccessfully": "Adicionado com sucesso",
        "enterJobDescription": "Por favor, insira uma descrição de trabalho ou URL",
        "stepInput": "Entrada",
        "titleAi": "Pesquisa de talento potenciada por IA",
        "subtitle": "Extrair competências de descrições de funções e encontrar candidatos correspondentes",
        "jobDescriptionN": "Descrição do trabalho {{count}}",
        "jobPlaceholder": "Cole uma descrição de trabalho aqui...\n\nExemplo: Estamos à procura de um Engenheiro de Software Sénior com mais de 5 anos de experiência em React, TypeScript e Node.js...",
        "addToList": "Adicionar à lista",
        "emptyTitle": "Ainda não há descrições de trabalho",
        "emptyHint": "Adicione descrições de trabalho para extrair palavras-chave",
        "jobN": "Trabalho {{count}}",
        "howItWorks": "Como funciona",
        "extractBtn": "Extrair palavras-chave",
        "jobsAdded_one": "{{count}} descrição de função adicionada",
        "jobsAdded_other": "{{count}} descrições de trabalho adicionadas",
        "wordCount_one": "{{count}} palavra",
        "wordCount_other": "{{count}} palavras",
        "jobDescriptionLabel": "Descrição de trabalho"
      },
      "startAdvancedSearch": "Iniciar pesquisa avançada",
      "addToPipeline": "Adicionar ao pipeline",
      "searching": "A procurar no Pool de talentos…",
      "talentCard": {
        "noCheckup": "Sem CheckUp ainda",
        "preVetted": "Tonnie pré-aprovado",
        "inPipeline": "Em pipeline",
        "whyMatched": "Por que correspondido:",
        "iqultureScore": "Pontuação iQulture",
        "skills": "Competências",
        "added": "Adicionado",
        "addToVet": "Adicionar à verificação",
        "matchPercent": "{{score}}% correspondência",
        "top": "TOP",
        "moreCount_one": "+{{count}}",
        "moreCount_other": "+{{count}}"
      },
      "nSelected_one": "{{count}} selecionado",
      "nSelected_other": "{{count}} selecionados",
      "talentsFound_one": "{{count}} talento encontrado",
      "talentsFound_other": "{{count}} talentos encontrados"
    },
    "poolImport": {
      "errors": {
        "country": "O país deve ser um código de 3 letras",
        "email": "Email inválido",
        "empty": "Sem linhas para importar",
        "tooMany": "Linhas em excesso (máx 1000)"
      },
      "failed": "Importação falhou",
      "placeholder": "Cole CSV ou TSV com uma linha de cabeçalho: email, primeiro nome, último nome, título do trabalho, país, cidade, competências",
      "subtitle": "Cole candidatos selecionados para os adicionar ao Pool de Talentos público. Perfis existentes são atualizados.",
      "success": "Importado: {{created}} criado, {{updated}} atualizado",
      "title": "Importar perfis",
      "import_one": "Importar {{count}} perfil",
      "import_other": "Importar {{count}} perfis",
      "parsedCount_one": "{{count}} linha válida pronta para importar",
      "parsedCount_other": "{{count}} linhas válidas prontas para importar"
    },
    "poolPage": {
      "addToVettingDesc": "Adicionar {{name}} ao seu pipeline de avaliação",
      "addToVettingPipeline": "Adicionar ao pipeline de avaliação",
      "advancedSearch": "Pesquisa avançada",
      "advancedSearchDesc": "Encontre talentos que correspondem a uma descrição de função",
      "alphabetical": "Alfabético",
      "alreadyInPipeline": "Já no pipeline",
      "available": "Disponível",
      "description": "Pesquise talentos que escolheram ser encontrados",
      "failedToAdd": "Falha ao adicionar",
      "inPipeline": "Em pipeline",
      "iqultureHighToLow": "iQulture alto para baixo",
      "iqultureLowToHigh": "iQulture baixo para alto",
      "iqultureScore": "Pontuação iQulture",
      "location": "Localização",
      "noCohortsYet": "Ainda não tem coortes — crie uma para adicionar talentos ao seu pipeline.",
      "noLocationsFound": "Sem localizações encontradas",
      "noRolesFound": "Sem funções encontradas",
      "noSkillsFound": "Sem competências encontradas",
      "noTalentsFound": "Nenhum talento encontrado",
      "relevance": "Relevância",
      "role": "Função",
      "searchError": "A pesquisa falhou",
      "searchErrorHint": "Ocorreu um erro ao carregar os talentos. Tente novamente.",
      "searchLocations": "Pesquisar localizações",
      "searchPlaceholder": "Pesquisar...",
      "searchRoles": "Pesquisar funções",
      "searchSkills": "Pesquisar competências",
      "selectACohort": "Selecionar uma coorte",
      "selectCohort": "Selecionar coorte",
      "selectLocations": "Selecionar localizações",
      "selectRoles": "Selecionar funções",
      "selectSkills": "Selecionar competências",
      "skills": "Competências",
      "sortBy": "Ordenar Por",
      "talentAdded": "{{name}} adicionado ao pipeline",
      "title": "Pool",
      "tryAdjustingFilters": "Tente ajustar filtros",
      "upgradeDescription": "Pesquise e adicione talentos pré-avaliados do Tonnie Talent Pool diretamente à sua pipeline.",
      "results": "Resultados",
      "bestMatch": "Melhor correspondência",
      "lowestMatch": "Menor correspondência",
      "searchLabel": "Pesquisar talentos"
    },
    "profile": {
      "accountDescription": "Detalhes sobre a sua conta que não podem ser alterados aqui.",
      "accountTitle": "Conta",
      "avatarDescription": "Mostrado no menu superior direito e em toda a plataforma.",
      "avatarHelper": "PNG, JPG ou GIF até 5 MB. Arraste e solte, ou clique para navegar.",
      "avatarRemoveConfirm": "A sua foto de perfil será substituída pelas suas iniciais. Pode carregar uma nova a qualquer momento.",
      "avatarRemoveConfirmAction": "Remover foto",
      "avatarRemoveFailed": "Não foi possível remover a foto. Por favor, tente novamente.",
      "avatarRemoveTitle": "Remover foto de perfil?",
      "avatarRemoved": "Foto removida",
      "avatarTitle": "Foto de perfil",
      "avatarTooLarge": "A foto é demasiado grande. Máx. 5 MB.",
      "avatarUploadFailed": "Falha ao carregar a foto. Por favor, tente novamente.",
      "avatarUploaded": "Foto atualizada",
      "avatarWrongType": "Só são suportados ficheiros de imagem.",
      "changeAvatar": "Alterar foto de perfil",
      "description": "Gira as suas informações pessoais, o avatar e os dados da conta.",
      "email": "Email",
      "emailManagedByClerk": "Gerido através do início de sessão",
      "firstName": "Primeiro nome",
      "lastName": "Último nome",
      "memberSince": "Membro desde",
      "nameDescription": "Como o seu nome aparece em toda a plataforma.",
      "nameTitle": "O seu nome",
      "remove": "Remover",
      "role": "Função",
      "roleDescription": "Definido pelo administrador da sua organização.",
      "saveChanges": "Guardar alterações",
      "saveFailed": "Não foi possível guardar as alterações. Por favor, tente novamente.",
      "saved": "Perfil atualizado",
      "title": "Perfil",
      "uploadPhoto": "Carregar foto"
    },
    "programs": {
      "activePrograms": "Programas em curso",
      "adjustFilters": "Ajustar filtros",
      "allCohorts": "Todas as coortes",
      "allStatus": "Todos os status",
      "askCoPilot": "Perguntar ao CoPilot",
      "avgProgress": "Média de progresso",
      "backToPrograms": "Voltar aos programas",
      "care": "Care",
      "careRequiresEnterprise": "Care requer Enterprise",
      "careSettingsReset": "Redefinição das definições do Care",
      "cohorts": "Coortes",
      "createCohort": "Criar coorte",
      "createDialogDescription": "Um programa é a camada organizacional de topo para os talentos que patrocina ou convida. As coortes e os percursos estão dentro dele.",
      "createFirstProgram": "Criar primeiro programa",
      "createNewProgram": "Criar novo programa",
      "createProgram": "Criar programa",
      "created": "Criado",
      "description": "Os seus programas de relocalização e as coortes que incluem",
      "descriptionLabel": "Descrição",
      "descriptionPlaceholder": "Introduza a descrição...",
      "editDialogDescription": "Atualize os detalhes do programa abaixo.",
      "editProgram": "Editar programa",
      "filterByStatus": "Filtrar por estado",
      "getMoreInsights": "Obter mais insights",
      "insightPassRate": "Taxa de aprovação",
      "insights": "Insights",
      "insightsDescription": "Como este programa está a progredir",
      "iqulture": "iQulture",
      "latestUpdates": "Últimas atualizações",
      "manageCohorts": "Gerir coortes",
      "noProgramsFound": "Nenhum programa encontrado",
      "notFound": "Programa não encontrado",
      "notFoundDesc": "Este programa não existe ou foi eliminado. Tente voltar à lista de programas.",
      "overview": "Visão geral",
      "pauseProgram": "Pausar programa",
      "programCreated": "Programa criado",
      "programNameLabel": "Nome do programa",
      "programNamePlaceholder": "Introduza o nome do programa...",
      "programPaused": "Programa pausado",
      "programResumed": "Programa retomado",
      "programUpdated": "Programa atualizado",
      "progress": "Progresso",
      "progressLabel": "Progresso",
      "recentActivity": "Atividade recente",
      "resumeProgram": "Retomar programa",
      "searchPrograms": "Pesquisar programas",
      "stability": "Estabilidade",
      "stabilityValue": "{{value}}% de estabilidade",
      "statusChangeFailed": "Falha ao alterar o estado do programa",
      "talents": "Talentos",
      "title": "Programas",
      "totalCohorts": "Total de coortes",
      "totalTalents": "Total de talentos",
      "viewDetails": "Ver detalhes",
      "whatHappensNext": "O que acontece a seguir",
      "whatHappensNextDescription": "Será levado para a página de detalhes do programa, onde pode criar coortes, convidar talentos e acompanhar o percurso deles nas fases de Avaliação e Patrocinado.",
      "errors": {
        "nameRequired": "O nome do programa é obrigatório",
        "nameTooLong": "O nome do programa deve ter 200 caracteres ou menos",
        "descriptionTooLong": "A descrição deve ter 2000 caracteres ou menos",
        "planLimit": "O plano gratuito permite 1 programa ativo. Faça upgrade para o Enterprise para programas ilimitados.",
        "createFailed": "Falha ao criar programa"
      },
      "programActionsAria": "Ações para {{name}}",
      "updateFailed": "Falha ao atualizar programa",
      "archiveSuccess": "{{name}} movido para arquivado.",
      "archiveFailed": "Falha ao arquivar programa",
      "restoreSuccess": "{{name}} restaurado.",
      "restoreFailed": "Falha ao restaurar programa",
      "activeTab": "Ativo",
      "archivedTab": "Arquivado",
      "viewInPipeline": "Ver talentos no Pipeline",
      "archive": "Arquivar",
      "restore": "Restaurar",
      "archiveConfirmTitle": "Arquivar programa?",
      "archiveConfirmDescription": "{{name}} passa para o separador Arquivado. Todas as coortes ativas deste programa também são arquivadas. Restaurar o programa mais tarde NÃO restaura automaticamente as coortes — tem de reativá-las individualmente no separador Coortes Arquivadas.",
      "insightCareGap": "Talentos patrocinados mas sem pontos de contacto ativos Care — verifique a cadência de check-in.",
      "cohortScopeAria": "Escopo da coorte",
      "cohortsEmptyActive": "Ainda não há coortes ativas neste programa. Crie uma para começar a convidar talentos.",
      "cohortsEmptyArchived": "Sem coortes arquivadas. As coortes que arquivar — ou que foram arquivadas em cascata com o programa — aparecerão aqui.",
      "cohortCreated": "Coorte criada.",
      "talentCount_one": "{{count}} talento",
      "talentCount_other": "{{count}} talentos",
      "archiveSuccessWithCascade_one": "{{base}} {{count}} coorte foi arquivada com ele.",
      "archiveSuccessWithCascade_other": "{{base}} {{count}} coortes foram arquivadas com ele.",
      "restoreSuccessWithCohorts_one": "{{base}} {{count}} coorte continua arquivada — restaure-a no separador Coortes.",
      "restoreSuccessWithCohorts_other": "{{base}} {{count}} coortes continuam arquivadas — restaure-as no separador Coortes."
    },
    "sendToVetting": {
      "assessmentIntroTalent": "Estes talentos já têm um percurso com esta empresa, por isso apenas a avaliação é nova — o destino mantém-se.",
      "back": "Voltar",
      "branchCustom": "Destino personalizado…",
      "branchLabel": "Filial / escritório",
      "branchPlaceholder": "Escolha uma filial ou insira um personalizado",
      "bulkSendingProgress": "A enviar convites… {{sent}}/{{total}}",
      "bulkTitle": "Enviar convites para Verificação",
      "customizeToggle": "Personalizar mensagem",
      "description": "Vamos criar uma base de percurso CheckUp gratuita e enviar um e-mail ao candidato. Pode patrocinar o percurso completo mais tarde, se assim decidir.",
      "descriptionTestit": "Vamos criar um esqueleto de percurso gratuito para os testes específicos que escolher e enviar um e-mail ao candidato. Os resultados são reutilizáveis.",
      "destinationLabel": "País de destino",
      "destinationPlaceholder": "Onde eles estarão a trabalhar?",
      "destinationSettingsLink": "Definições da empresa",
      "destinationSource": "A partir das definições da empresa (sede e filiais).",
      "destinationUnset": "Sem sede nem filial nas Definições — escolha uma para este lote, ou adicione-a uma vez nas Definições.",
      "failed": "Falha ao enviar o convite. Por favor, tente novamente.",
      "freeCheckUpHint": "Sem custos até decidir patrocinar o percurso. O candidato recebe o CheckUp e poderá consultar os respetivos resultados MESH + iQulture na Avaliação.",
      "freeCheckUpTitle": "CheckUp gratuito · Patrocine mais tarde se quiser",
      "freeTestitHint": "Sem custo — o candidato completa apenas os testes que escolher, e os resultados podem ser reutilizados em oportunidades futuras. Vê-os em Vetting.",
      "freeTestitTitle": "Grátis · resultados reutilizáveis",
      "next": "Seguinte",
      "opportunityIntro": "Escolha o que o candidato completa e onde fica a função.",
      "outcomeAwaiting": "Ficam em Aquisição até aceitarem.",
      "outcomeMixed": "{{moved}} passaram para Triagem · {{awaiting}} a aguardar aceitação.",
      "partial": "{{sent}} enviados · {{failed}} falhados",
      "reviewAssessment": "Vão completar",
      "reviewDestination": "Destino",
      "reviewEmailHint": "É isto que chega à caixa de entrada.",
      "reviewRecipients": "Destinatários",
      "sending": "A enviar…",
      "singleCta": "Enviar convite",
      "singleSuccess": "Convite enviado para {{name}}",
      "singleTitle": "Enviar convite para {{name}}",
      "stepMessage": "Mensagem",
      "stepOf": "Passo {{current}} de {{total}}",
      "stepOpportunity": "Avaliação",
      "stepReview": "Rever e enviar",
      "workLocationLabel": "Local de trabalho",
      "workLocationPlaceholder": "Cidade, escritório ou remoto",
      "bulkCta_one": "Enviar {{count}} convite",
      "bulkCta_other": "Enviar {{count}} convites",
      "bulkRecipientCount_one": "{{count}} candidato",
      "bulkRecipientCount_other": "{{count}} candidatos",
      "bulkSuccess_one": "{{count}} convite enviado",
      "bulkSuccess_other": "{{count}} convites enviados",
      "outcomeRequested_one": "Foi-lhe pedido que partilhe mais — nada muda até responder.",
      "outcomeRequested_other": "Foi pedido a {{count}} que partilhem mais — nada muda até responderem.",
      "outcomeMoved_one": "Passou para Triagem.",
      "outcomeMoved_other": "{{count}} passaram para Triagem.",
      "reviewAskNotice_one": "Este talento já trabalha consigo, por isso recebe a mensagem adequada à sua situação: um pedido para partilhar o que já tem, ou um lembrete do que falta fazer.",
      "reviewAskNotice_other": "Estes {{count}} talentos já trabalham consigo, por isso cada um recebe a mensagem adequada à sua situação: um pedido para partilhar o que já tem, ou um lembrete do que falta fazer."
    },
    "settings": {
      "customModeActiveDesc": "O modo personalizado está ativo. Personalize as suas cores no separador Cores e carregue recursos no separador Recursos.",
      "draftSaved": "Rascunho guardado com sucesso!",
      "fileSizeError": "O ficheiro tem de ter menos de 2MB",
      "invalidFileFormat": "Formato de ficheiro inválido. Por favor, use PNG, JPG ou SVG",
      "itemRemoved": "{{title}} removido",
      "themeActivated": "Tema ativado com sucesso! Mudado para o modo Personalizado.",
      "uploadSuccess": "{{type}} carregado com sucesso!"
    },
    "shared": {
      "noPhoneCodeFound": "Nenhum código de telefone encontrado.",
      "searchPhoneCode": "Pesquisar código de telefone..."
    },
    "shell": {
      "viewportGuard": {
        "description": "Esta aplicação é otimizada para ecrãs de desktop. Por favor, use um dispositivo com um ecrã maior para a melhor experiência.",
        "hint": "Largura mínima do ecrã: 1024px",
        "title": "Desktop necessário"
      }
    },
    "theme": {
      "configure": "Configurar",
      "custom": "Personalizado",
      "dark": "Escuro",
      "light": "Claro",
      "system": "Sistema",
      "theme": "Tema"
    },
    "userMenu": {
      "billing": "Faturação",
      "logout": "Sair",
      "preferences": "Preferências",
      "profile": "Perfil",
      "roleAdmin": "Admin",
      "roleMember": "Membro da equipa"
    },
    "vetting": {
      "adjustFilters": "Ajustar filtros",
      "allBadges": "Todos os distintivos",
      "allCohorts": "Todas as coortes",
      "allStatus": "Todos os status",
      "allTalents": "Todos os talentos",
      "analytics": "Análises",
      "avgIQulture": "Média iQulture",
      "badgeDistribution": "Distribuição de distintivos",
      "badgeDistributionDesc": "Quantos talentos têm cada distintivo iQulture",
      "byCohort": "Por coorte",
      "checkUpCompleted": "CheckUp concluído",
      "clearFilters": "Limpar filtros",
      "description": "Avalie talentos com o CheckUp antes de os patrocinar",
      "explain": "Explicar",
      "explainAria": "Explicar o resultado de {{name}} com o CoPilot",
      "openTalentAria": "Abrir perfil de talento para {{name}}",
      "percentDone": "{{value}}% concluído",
      "insightBodies": {
        "proInsightBody_one": "{{count}} talento obteve 80%+ no iQulture — uma prontidão excecional para a mobilidade internacional.",
        "proInsightBody_other": "{{count}} talentos pontuaram 80%+ no iQulture, o que indica uma prontidão excecional para a mobilidade internacional.",
        "potentialInsightBody_one": "{{count}} talento mostra forte potencial. Considere o QultureUp para aumentar a sua pontuação.",
        "potentialInsightBody_other": "{{count}} talentos mostram forte potencial. Considere o QultureUp para aumentar as suas pontuações.",
        "pendingInsightBody_one": "{{count}} talento ainda não concluiu o CheckUp. Envie um lembrete para acelerar a triagem.",
        "pendingInsightBody_other": "{{count}} talentos ainda não completaram CheckUp. Envie lembretes para acelerar a avaliação."
      },
      "sponsorAria": "Patrocinar {{name}}",
      "filterByCohort": "Filtrar por coorte",
      "inVetting": "Em Avaliação",
      "iqultureAssessed": "iQulture avaliado",
      "iqultureBadge": "iQulture distintivo",
      "loading": "A Carregar…",
      "loadingDescription": "A Carregar detalhes do talento",
      "mesh": {
        "englishNative": "Inglês",
        "hardOther": "Competências técnicas",
        "motivation": "Motivação",
        "notScored": "Sem pontuação",
        "softCultural": "Soft skills e cultura"
      },
      "noTalentsFound": "Nenhum talento encontrado",
      "noTalentsInVetting": "Nenhum talento em avaliação",
      "noobOnly": "Apenas novatos",
      "notFound": "Talento não encontrado",
      "notFoundDesc": "Este talento não existe ou não tem acesso para ver o respetivo registo.",
      "pendingAction": "Ação pendente",
      "pendingCheckUp": "Pendente CheckUp",
      "percentageReadyForMobility": "Percentagem pronta para mobilidade",
      "potential": "Potencial",
      "potentialInsight": "Insight de potencial",
      "potentialOnly": "Apenas potencial",
      "proAndPotentialWithCheckUp": "Profissional e potencial com CheckUp",
      "proBadges": "Distintivos Pro",
      "proInsight": "Insight Pro",
      "proOnly": "Pro apenas",
      "readyToSponsor": "Pronto para patrocinar",
      "searchTalents": "Pesquisar talentos",
      "sponsor": "Patrocinador",
      "sponsorshipFunnel": "Funil de patrocínio",
      "sponsorshipFunnelDesc": "Do convite ao patrocínio, fase a fase",
      "sponsorshipReadyRate": "Taxa de prontidão para patrocínio",
      "statusCompleted": "Estado concluído",
      "statusInProgress": "Estado em progresso",
      "statusLabel": "Estado",
      "statusPending": "Estado pendente",
      "talentDetail": {
        "analysis": "Análise",
        "archivedReadOnly": "Este percurso já não está ativo. O registo é preservado para auditoria; ações não estão disponíveis.",
        "exportCsv": "Exportar CSV",
        "exportFailed": "Não foi possível exportar este relatório. Tente novamente.",
        "exportPdf": "Exportar PDF",
        "vettingCompleteReadOnly": "A avaliação está concluída — este é um retrato só de leitura da avaliação.",
        "askCoPilot": "Pergunte CoPilot",
        "confidence": "Confiança",
        "copyEmail": "Copiar email",
        "copyEmailSuccess": "Email copiado para a área de transferência",
        "culturalRiskAnalysis": "Análise de risco cultural",
        "lowRiskCras": "CRAs de baixo risco",
        "moderateRiskCras": "CRAs de risco moderado",
        "highRiskCras": "CRAs de alto risco",
        "archetypesSeverityChip": "{{low}} baixo · {{moderate}} moderado · {{high}} alto",
        "topRisksTitle": "Principais riscos culturais",
        "topRisksDescription": "Os arquétipos Tonnie sinalizaram o maior risco de patrocínio para este candidato.",
        "topRisksEmpty": "Nenhum arquétipo de alto risco sinalizado.",
        "topRisks": {
          "severityShort": {
            "high": "Alto",
            "moderate": "Mod"
          },
          "a11yLabel": {
            "high": "Alto risco: {{score}} por cento",
            "moderate": "Risco moderado: {{score}} por cento"
          }
        },
        "meshTagline": {
          "motivation": "Por que este candidato quer se realocar.",
          "english": "Prontidão para a língua de trabalho.",
          "softCultural": "Adequação cultural e como colaboram.",
          "hardOther": "Capacidade técnica e operacional."
        },
        "pillars": {
          "spreadTitle": "Distribuição dos pilares",
          "spreadDescription": "Os sete pilares num só radar — quanto mais perto cada eixo chega da margem exterior, mais forte é a avaliação do candidato nesse pilar.",
          "topGreenFlagsTitle": "Principais forças entre os pilares",
          "topRedFlagsTitle": "Principais preocupações entre os pilares",
          "topFlagsEmpty": "Nada sinalizado.",
          "plan90Days": {
            "title": "Plano sugerido de 90 dias",
            "description": "Sequência recomendada da Tonnie para os primeiros 90 dias após o patrocínio.",
            "empty": "Nenhum plano gerado.",
            "stepDuration": "Dia {{day}}"
          },
          "fullName": {
            "ICM": "Motivação internacional Career",
            "MA": "Adaptabilidade multicultural",
            "WMF": "Flexibilidade no modelo de trabalho",
            "CP": "Proficiência em comunicação",
            "CP_ENGLISH": "Comunicação em Inglês",
            "CP_NATIVE_TARGET": "Língua nativa / Alvo",
            "GPE": "Experiência profissional global",
            "AR": "Prontidão académica",
            "PRM": "Resiliência psicológica para mobilidade"
          }
        },
        "pitch": {
          "sentimentLabel": "Sentimento",
          "sentimentValue": {
            "positive": "Positivo",
            "neutral": "Neutro",
            "negative": "Negativo"
          },
          "deliveryMetric": {
            "communicationClarity": "Clareza na comunicação",
            "confidenceLevel": "Nível de confiança",
            "energyLevel": "Nível de energia",
            "pacing": "Ritmo",
            "articulation": "Articulação",
            "fillerWords": "Palavras de preenchimento"
          },
          "noPitchTitle": "Nenhuma apresentação gravada ainda",
          "noPitchDescription": "{{name}} ainda não gravou a sua introdução de 60 segundos. Envie um lembrete para incentivá-lo — a apresentação é um dos sinais qualitativos mais fortes antes de patrocinar.",
          "pendingAnalysisTitle": "Apresentação gravada — análise em progresso",
          "pendingAnalysisDescription": "A apresentação de {{name}} foi carregada, mas o Brain ainda não terminou de analisá-la. A transcrição e os insights da IA aparecerão aqui dentro de alguns minutos.",
          "playbackMissingTitle": "Análise pronta — reprodução indisponível",
          "playbackMissingDescription": "A Tonnie tem a transcrição e a análise da apresentação abaixo, mas não foi possível carregar o ficheiro de vídeo agora. Atualize daqui a pouco para tentar novamente ou consulte o cofre do cidadão.",
          "videoOnlyTitle": "Apresentação gravada — análise pendente",
          "videoOnlyDescription": "A apresentação de {{name}} está pronta para assistir acima, mas a transcrição, sentimento e análise de entrega da Tonnie ainda não estão anexadas a este CheckUp. Na maioria das vezes, isso significa que o analisador não foi executado para esta execução — reative-o abaixo para preencher os sinais ausentes.",
          "rerunAnalysis": "Reexecutar análise da apresentação",
          "rerunAnalysisInProgress": "A executar novamente a análise da apresentação…",
          "rerunAnalysisError": "Não foi possível reexecutar a análise da apresentação",
          "videoFallback": "O seu browser não consegue reproduzir este formato de vídeo.",
          "duration": "Duração: {{value}}",
          "recordedAt": "Gravado {{date}}",
          "statusReady": "Pronto para revisão",
          "statusAnalyzing": "A analisar",
          "statusPending": "A aguardar carregamento",
          "statusFailed": "Análise falhou",
          "statusEstimated": "Estimativa",
          "failedTitle": "Não foi possível analisar o pitch",
          "failedDescription": "A gravação de {{name}} não produziu análise. Nada neste separador é uma avaliação dela.",
          "heuristicTitle": "Estes sinais são estimativas, não uma análise de IA",
          "heuristicDescription": "A análise de IA não esteve disponível, por isso o sentimento e as métricas de apresentação abaixo vêm de uma heurística simples baseada na contagem de palavras. Não baseie uma decisão nelas — volte a executar a análise.",
          "failedReason": {
            "noInput": "A análise foi executada sem gravação. Volte a executar a análise.",
            "videoNotFound": "Não foi encontrada nenhuma gravação de {{name}} no armazenamento.",
            "storageFetchFailed": "Não foi possível ler a gravação do armazenamento. Volte a executar a análise.",
            "serviceComponentMissing": "Falta ao serviço de análise um componente de que precisa. A nossa equipa foi alertada — volte a executar a análise quando estiver resolvido.",
            "noAudioTrack": "A gravação não tem som. Peça a {{name}} para gravar novamente com o microfone ligado.",
            "unreadableRecording": "Não foi possível descodificar o formato da gravação. Peça a {{name}} para gravar novamente.",
            "timedOut": "O processamento da gravação demorou demasiado. Volte a executar a análise.",
            "noSpeech": "Não foi detetada fala na gravação. Peça a {{name}} para gravar novamente.",
            "serviceRejected": "O serviço de transcrição recusou a gravação. A nossa equipa foi alertada.",
            "serviceUnavailable": "O serviço de transcrição não estava disponível. Volte a executar a análise.",
            "internalError": "Um erro inesperado interrompeu a análise. A nossa equipa foi alertada.",
            "unrecorded": "Este resultado foi produzido antes de os motivos de falha serem registados. Volte a executar a análise para saber porquê."
          },
          "heuristicReason": {
            "modelUnavailable": "Motivo: nenhum modelo de IA estava configurado para a análise.",
            "invalidResponse": "Motivo: não foi possível usar a resposta da IA.",
            "serviceRejected": "Motivo: o serviço de IA recusou o pedido.",
            "serviceUnavailable": "Motivo: o serviço de IA não estava disponível.",
            "unrecorded": "Motivo: não registado — este resultado é anterior a esse registo."
          }
        },
        "skills": {
          "softHardCombinedTitle": "Principais competências suaves e duras",
          "softHardCombinedDescription": "O perfil de cada lista num relance e, por baixo, cada competência ordenada pela sua pontuação de força, com o nível em que a Tonnie a classificou. O número de cada eixo é a sua linha.",
          "additionalSkillsTitle": "Competências adicionais",
          "additionalSkillsDescription": "Capacidades além da lista de principais competências suaves/duras, classificadas por pontuação de poder.",
          "additionalSkillsEmpty": "Nenhuma competência adicional identificada.",
          "softEmpty": "Ainda não surgiram competências interpessoais — a análise da Tonnie ainda não devolveu as principais competências deste candidato.",
          "hardEmpty": "Ainda não surgiram competências técnicas — a análise da Tonnie ainda não devolveu as principais competências deste candidato.",
          "softShapeLabel": "Perfil das principais competências interpessoais, eixos numerados por posição — {{summary}}",
          "hardShapeLabel": "Perfil das principais competências técnicas, eixos numerados por posição — {{summary}}"
        },
        "deliveryMetrics": "Métricas de entrega",
        "drawerDescription": "Revisão da avaliação para {{name}} — progresso em CheckUp, dados do perfil e ações administrativas.",
        "evaluationPillars": "Pilares de avaliação",
        "evaluationPillarsDesc": "Pontuação por pilar, confiança e evidência — o registo de auditoria por trás do veredicto iQulture de {{name}}.",
        "evidenceLabel": "Evidência",
        "greenFlags": "Sinais verdes",
        "hideDetails": "Ocultar detalhes",
        "interviewFirst": "Entrevista primeiro",
        "interviewConfirmTitle": "Enviar convite para entrevista?",
        "interviewConfirmDescription": "A Tonnie enviará a {{name}} um convite por e-mail para uma entrevista pré-patrocínio. Pode retirá-lo mais tarde, mas o e-mail é enviado de imediato.",
        "interviewConfirmCancel": "Cancelar",
        "interviewConfirmAction": "Enviar convite",
        "lastSeenAgo_one": "Visto pela última vez há {{count}} dia",
        "lastSeenAgo_other": "Visto pela última vez há {{count}} dias",
        "lastSeenToday": "Visto pela última vez hoje",
        "menuLabel": "Mais ações",
        "messageSendError": "Não conseguimos enviar a mensagem. Por favor, tente novamente.",
        "messageSent": "Mensagem enviada para {{name}}",
        "messageSentDescription": "Está a caminho — irá vê-la no registo de mensagens em breve.",
        "meshAnalysis": "Análise de MESH",
        "meshAnalysisDesc": "Como {{name}} pontua nas quatro fundações sobre as quais cada patrocínio confiante é construído.",
        "neverSeen": "Ainda não abriu a aplicação",
        "calculating": {
          "title": "A pontuação do CheckUp está a ser calculada",
          "description": "A nova pontuação de {{name}} aparece aqui assim que o cálculo terminar."
        },
        "noneIdentified": "Nenhum identificado",
        "pitchVideoAnalysis": "Análise do vídeo de apresentação",
        "pitchVideoDesc": "A apresentação de 60 segundos de {{name}} — transcrição, sentimento e métricas de entrega com as suas próprias palavras.",
        "recommendations": "Recomendações",
        "redFlags": "Sinais de alerta",
        "reminderSendError": "Não conseguimos enviar o lembrete. Por favor, tente novamente.",
        "reminderSent": "Lembrete enviado para {{name}}",
        "reminderSentDescription": "{{name}} receberá um lembrete por email para completar CheckUp.",
        "reminderTemplateMissing": "O modelo de lembrete de CheckUp ainda não foi configurado. Visite Mensagens para criá-lo.",
        "sendMessage": "Enviar mensagem",
        "sendMessageDescription": "Personalize o assunto e a mensagem antes de enviar — o talento recebe como um e-mail.",
        "sendMessageTitle": "Enviar uma mensagem",
        "sendNow": "Enviar agora",
        "sendReminder": "Enviar lembrete",
        "sending": "A enviar…",
        "showDetails": "Mostrar detalhes",
        "sponsoredDrawerDescription": "Monitorização de talentos patrocinados para {{name}} — progresso do herói, evidências e ações administrativas.",
        "sponsorJourney": "Percurso do patrocinador",
        "sponsorship": {
          "cancelTitle": "Cancelar patrocínio?",
          "cancelLoading": "A calcular o valor do reembolso…",
          "cancelDescription": "Tonnie reembolsará {{refundAmount}} ({{monthsRemaining}} de {{durationMonths}} meses restantes) e o percurso de {{name}} reverterá para acesso básico. Esta ação não pode ser desfeita.",
          "cancelNoRefundDescription": "Este patrocínio não tem saldo reembolsável — a janela total de {{durationMonths}} meses foi consumida. Cancelar reverterá o percurso de {{name}} para acesso básico sem reembolso.",
          "cancelKeep": "Manter patrocínio",
          "cancelAction": "Cancelar e reembolsar {{refundAmount}}",
          "cancelNoRefund": "Cancelar patrocínio (sem reembolso)",
          "cancelSuccess": "Patrocínio cancelado — {{amount}} reembolsados para o seu cartão.",
          "cancelFailed": "Não foi possível cancelar o patrocínio neste momento."
        },
        "tagsHint": "Dica: começar a partir de um modelo preenche automaticamente o nome do talento e outros detalhes. Mensagens personalizadas são enviadas como estão.",
        "waitingDays_one": "A aguardar há {{count}}d",
        "waitingDays_other": "A aguardar há {{count}}d",
        "waitingOverdue_one": "{{count}}d em atraso",
        "waitingOverdue_other": "{{count}}d em atraso",
        "phase": {
          "adaptation": {
            "awaiting": {
              "description": "QultureUp está desbloqueado. {{name}} ainda não começou nenhuma missão de preparação cultural.",
              "title": "A aguardar a primeira atividade"
            },
            "locked": {
              "description": "QultureUp ativa após {{name}} ser patrocinado. As missões de preparação cultural são construídas automaticamente com base no destino.",
              "title": "A adaptação é desbloqueada após o patrocínio"
            }
          },
          "action": {
            "careIntervention": "Intervenção Care",
            "sendReminder": "Enviar lembrete",
            "viewKit": "Ver kit"
          },
          "care": {
            "awaiting": {
              "description": "O Care está desbloqueado. {{name}} ainda não registou um check-in — um lembrete simpático pode ajudar.",
              "title": "A aguardar o primeiro check-in"
            },
            "locked": {
              "description": "O Care ativa-se depois de {{name}} ser patrocinado. O programa de bem-estar é construído em torno da sua adaptação.",
              "title": "Care desbloqueia após o patrocínio"
            }
          },
          "checkup": {
            "awaiting": {
              "description": "{{name}} aceitou o convite, mas ainda não começou CheckUp. Um lembrete geralmente os incentiva a começar.",
              "title": "CheckUp ainda não iniciado"
            },
            "locked": {
              "description": "CheckUp ativa assim que {{name}} aceita o convite e um percurso é criado.",
              "title": "CheckUp ainda não ativado"
            },
            "inProgress": {
              "title": "CheckUp em curso",
              "description": "{{name}} está a fazer o CheckUp — {{done}} de {{total}} etapas concluídas."
            },
            "awaitingScore": {
              "title": "CheckUp enviado",
              "description": "{{name}} concluiu o CheckUp. Estamos a calcular a pontuação iQulture."
            }
          },
          "evidence": {
            "awaiting": {
              "description": "Ainda sem carimbos de passaporte. Os carimbos e milhas acumulam-se à medida que {{name}} avança pelos heróis.",
              "title": "A aguardar os primeiros marcos"
            },
            "locked": {
              "description": "Passport ativa após o patrocínio. Marcos de cada herói ganham selos automaticamente.",
              "title": "A evidência é desbloqueada após patrocínio"
            }
          },
          "mobility": {
            "awaiting": {
              "description": "O kit TelePortal está pronto. {{name}} ainda não começou nenhuma tarefa.",
              "title": "A aguardar a primeira atividade"
            },
            "locked": {
              "description": "TelePortal irá construir automaticamente um kit de realocação personalizado assim que {{name}} for patrocinado.",
              "title": "A mobilidade é desbloqueada após patrocínio"
            }
          }
        },
        "phaseStrip": {
          "scrollNext": "Mostrar fases seguintes",
          "scrollPrevious": "Mostrar fases anteriores",
          "sponsored": {
            "accepted": "Aceite",
            "ariaLabel": "Fase de patrocínio",
            "offered": "Oferecido",
            "sponsored": "Patrocinado",
            "thriving": "A prosperar"
          },
          "vetting": {
            "ariaLabel": "Fase de verificação",
            "invited": "Convidado",
            "scored": "Pontuado",
            "started": "Iniciado",
            "submitted": "Submetido",
            "verdict": "Veredicto"
          }
        },
        "summary": "Resumo",
        "topHardSkills": "Principais competências técnicas",
        "topSoftSkills": "Principais competências interpessoais",
        "transcript": "Transcrição",
        "citizenAccountDeletedTitle": "Conta Citizen eliminada",
        "citizenAccountDeletedBody": "Este candidato eliminou a sua conta Tonnie. O seu perfil + atividade são preservados em forma de leitura apenas para os seus registos; não podem ser tomadas mais ações.",
        "interviewInvitationQueued": "Pedido de entrevista enfileirado para {{name}}. Email enviado; integração do corretor ATS pendente.",
        "interviewInvitationFailed": "Falha ao enviar pedido de entrevista. Tente novamente.",
        "scoreEstimate": {
          "title": "Partes desta pontuação são estimativas, não medições",
          "pitchFailed": "Pitch: não analisado — a pontuação foi calculada sem ele.",
          "pitchHeuristic": "Apresentação do pitch (Motivação): estimada a partir da contagem de palavras — a análise de IA não esteve disponível.",
          "pillarsM": "Motivação: alguns pilares foram estimados com um método simplificado — a avaliação de IA não esteve disponível.",
          "pillarsE": "Inglês: alguns pilares foram estimados com um método simplificado — a avaliação de IA não esteve disponível.",
          "pillarsS": "Competências interpessoais e culturais: alguns pilares foram estimados com um método simplificado — a avaliação de IA não esteve disponível.",
          "pillarsH": "Competências técnicas: alguns pilares foram estimados com um método simplificado — a avaliação de IA não esteve disponível."
        },
        "languages": {
          "title": "Línguas",
          "none": "Ainda sem resultado de língua."
        },
        "leftProgrammeTitle": "Saiu do seu programa a {{date}}",
        "leftProgrammeBody": "A relação terminou, por isso este registo é só de leitura e o que partilhou deixou de estar visível. Envie um novo convite para voltar a trabalhar com ele — é ele quem decide se aceita."
      },
      "title": "Verificação",
      "topCandidates": "Principais candidatos",
      "topCandidatesDescription": "As pontuações mais fortes, prontas para patrocínio",
      "topPick": "Escolha principal",
      "totalCandidates": "Total de candidatos",
      "viewPending": "Ver pendentes",
      "viewPotentialTalents": "Ver talentos potenciais",
      "viewProTalents": "Ver talentos profissionais",
      "completed": "Completo",
      "badge": {
        "pro": "PRO",
        "potential": "POTENCIAL",
        "noob": "NOOB",
        "pending": "Pendente CheckUp"
      },
      "talentsCount_one": "{{count}} talento",
      "talentsCount_other": "{{count}} talentos",
      "readyOfTotal": "{{completed}} de {{total}} pronto",
      "talentRowActionsAria": "Ações para {{name}}",
      "testitCandidates": "Candidatos TestIt",
      "readyCount_one": "{{count}} pronto",
      "readyCount_other": "{{count}} prontos"
    },
    "invitationDetail": {
      "acceptedAt": "Aceite",
      "accessibleDescription": "Estado do convite: {{status}}",
      "accessibleDescriptionLoading": "A carregar detalhes do convite",
      "accessibleTitle": "Detalhes do convite",
      "acquisitionEyebrow": "Aquisição",
      "assessment": "Avaliação",
      "branch": "Filial",
      "createdAt": "Criado",
      "delete": "Eliminar",
      "destination": "Destino",
      "email": "Email",
      "errorDescription": "O convite pode ter sido eliminado, ou o servidor está inacessível.",
      "errorTitle": "Não foi possível carregar o convite",
      "expiresAt": "Expira",
      "historyTitle": "Histórico",
      "name": "Nome",
      "noHistory": "Nenhuma alteração de estado registada.",
      "opportunityTitle": "Oportunidade",
      "recipientTitle": "Destinatário",
      "resend": "Reenviar",
      "resendHint": "Reenviar regenera o token e redefine a expiração.",
      "revoke": "Revogar",
      "scenario": "Cenário",
      "scenarioValue": {
        "pre_immigration": "Pré-imigração",
        "already_abroad": "Já no estrangeiro",
        "relocation_only": "Realocação apenas",
        "integration_only": "Integração apenas"
      },
      "send": "Enviar convite",
      "sentAt": "Enviado",
      "status": {
        "draft": "Rascunho",
        "pending": "Aceitação pendente",
        "accepted": "Aceite",
        "expired": "Expirado",
        "revoked": "Revogado",
        "declined": "Recusado",
        "email_queued": "E-mail em fila",
        "email_skipped": "E-mail ignorado",
        "email_failed": "E-mail não enviado",
        "email_sent": "E-mail enviado",
        "email_delivered": "Entregue",
        "email_opened": "Aberto",
        "email_clicked": "Ligação clicada",
        "email_bounced": "Devolvido",
        "landed": "Abriu a página do convite",
        "email_mismatch": "A sessão iniciada não corresponde",
        "matched_signup": "Registou-se na Tonnie",
        "deferred": "Adiado pelo candidato",
        "email_reminded": "Lembrete enviado",
        "claimed": "Reclamado a partir de outra conta"
      },
      "tokenPreview": "Pré-visualização do token",
      "tokenTitle": "Token e expiração",
      "workLocation": "Local de trabalho",
      "reason": {
        "deleted_sentinel": "Não enviado — o destinatário eliminou a sua conta Tonnie.",
        "email_mismatch": "Tinha sessão iniciada com uma conta diferente.",
        "email_unverified": "O endereço está na conta mas ainda não foi verificado.",
        "expired": "O convite já tinha expirado.",
        "expiry_sweep": "Expirou sem resposta.",
        "jit": "Detetado no primeiro início de sessão.",
        "lazy_expire_on_open": "Já estava fora do prazo quando a página foi aberta.",
        "matched_signup_unaccepted": "Expirou apesar de esta pessoa já estar na Tonnie — reenviar tem boas probabilidades de a alcançar.",
        "ok": "O convite estava aberto e pronto a ser aceite.",
        "onboarding": "Detetado durante a integração.",
        "opted_out": "Não enviado — o destinatário recusou receber e-mails.",
        "revoked": "O convite já tinha sido revogado.",
        "webhook": "Detetado quando a conta foi criada."
      },
      "byActor": "por {{name}}",
      "hasAccountChip": "Registou-se, não aceitou",
      "resendNudge": "Esta pessoa já tem conta Tonnie — reenviar tem boas probabilidades de alcançar alguém que consegue iniciar sessão de imediato.",
      "resendPromoted": "Reenviar convite",
      "candidateRole": "Função",
      "candidateLocation": "Localização",
      "candidateSkills": "Competências",
      "inviteAgain": "Convidar novamente",
      "closed": {
        "declinedTitle": "Recusou o convite em {{when}}",
        "expiredTitle": "O convite expirou em {{when}}",
        "body": "Convide novamente para lhe enviar um novo email com um link novo, ou elimine o convite para o retirar do seu pipeline."
      }
    },
    "talentRowMenu": {
      "viewDetails": "Ver detalhes",
      "sendInvitation": "Enviar convite",
      "resendInvitation": "Reenviar convite",
      "revoke": "Revogar",
      "delete": "Eliminar",
      "sponsorJourney": "Patrocinar o percurso",
      "askCoPilot": "Pergunte CoPilot",
      "askTonnieServices": "Pergunte aos serviços Tonnie",
      "inviteAgain": "Convidar novamente"
    },
    "vettingPage": {
      "activeTab": "Ativo",
      "archivedTab": "Arquivado"
    },
    "motivationalForm": {
      "questionCard": {
        "required": "Requerido",
        "optional": "Opcional",
        "maxCharsHint_one": "Máx. {{max}} carácter • Responda apenas em inglês",
        "maxCharsHint_other": "Máx. {{max}} caracteres • Responda apenas em inglês",
        "answerLabel": "A sua resposta",
        "answerPlaceholder": "Escreva a sua resposta aqui em inglês…",
        "answerPlaceholderOptional": "Escreva a sua resposta aqui em inglês… (opcional)",
        "noComment": "Sem comentário",
        "optionalHint": "Pergunta opcional – pode deixá-la em branco.",
        "validationComment": "Comentário de validação:"
      }
    },
    "quickEdit": {
      "companyPlaceholder": "Acme Corporation, Inc.",
      "taxIdPlaceholder": "EIN, VAT ou ID fiscal nacional"
    },
    "additionalDetails": {
      "languagePlaceholder": "Inglês"
    },
    "acceptInvite": {
      "notFound": "Convite não encontrado",
      "failedToLoad": "Falha ao carregar convite",
      "failedToAccept": "Falha ao aceitar convite",
      "roleAdmin": "Admin",
      "roleTeamMember": "Membro da equipa",
      "invalidLink": "Link de convite inválido. Nenhum token fornecido.",
      "goToLogin": "Ir para início de sessão",
      "welcomeTo": "Bem-vindo ao {{company}}!",
      "joinedAs": "Juntou-se como {{role}}. A redirecionar para o painel...",
      "expiredTitle": "Convite expirado",
      "expiredBody": "Este convite para se juntar à {{company}} expirou. Peça ao administrador da equipa para enviar um novo convite.",
      "alreadyTitle": "Já aceito",
      "alreadyBody": "Este convite já foi aceito.",
      "title": "Convite para a equipa",
      "joinCompany": "Junte-se à {{company}}",
      "invitedAsRole": "Foi convidado a juntar-se como {{role}}",
      "signedInAs": "Sessão iniciada como {{email}}",
      "accepting": "A aceitar...",
      "accept": "Aceitar convite",
      "emailMismatch": "Este convite foi enviado para {{invited}}, mas tem sessão iniciada como {{current}}. Termine sessão e inicie sessão com o endereço de e-mail correto.",
      "invitedToJoin": "Foi convidado a juntar-se à {{company}}",
      "joinAsRole": "Junte-se como {{role}}",
      "invitationSentTo": "Convite enviado para {{email}}",
      "signUpOrLogIn": "Registe-se ou inicie sessão para aceitar este convite e juntar-se à equipa.",
      "haveAccount": "Já tem uma conta? Iniciar Sessão",
      "emailUnverified": "Verifique {{email}} na sua conta e depois aceite o convite novamente."
    },
    "weeklySummary": {
      "title": "Resumo semanal",
      "insightsFor": "Insights gerados por IA para {{period}}",
      "keyAchievements": "Principais conquistas",
      "areasNeedingAttention": "Áreas que precisam de atenção",
      "trends": "Tendências",
      "insights": "Insights",
      "viewFullReport": "Ver relatório completo"
    },
    "nextBestActions": {
      "title": "Próximas melhores ações",
      "empty": "Nenhuma ação requer atenção imediata. Ótimo trabalho!",
      "explainCopilot": "Recomendações impulsionadas por IA para os seus programas de mobilidade",
      "pipelineCopilot": "Recomendações impulsionadas por IA alinhadas ao seu pipeline",
      "categoryCheckup": "CheckUp pendente",
      "categorySponsorship": "Decisão de patrocínio",
      "categoryMobility": "Bloqueador de mobilidade",
      "categoryCare": "Ponto de verificação Care",
      "categoryRisk": "Sinal de risco",
      "urgency": {
        "high": "alto",
        "medium": "médio",
        "low": "baixo"
      },
      "reason": "Razão: {{reason}}",
      "explain": "Explicar"
    },
    "iqultureBadge": {
      "pending": "Pendente",
      "description": {
        "pro": "Prontidão excecional para oportunidades internacionais",
        "potential": "Forte potencial com espaço para crescimento",
        "noob": "A começar o percurso de prontidão",
        "noBadge": "CheckUp ainda não concluído"
      },
      "corporateInsight": {
        "pro": "Talento de topo pronto para mobilidade imediata",
        "potential": "Candidato forte — considerar com plano de preparação",
        "noob": "Estágio inicial — monitorizar progresso através de QultureUp",
        "noBadge": "A aguardar avaliação de iQulture"
      }
    },
    "routeFlags": {
      "srLabel": "{{origin}} para {{destination}}"
    },
    "inviteMessage": {
      "bodyHint": "Edite livremente. As etiquetas são preenchidas por destinatário — a pré-visualização mostra o resultado.",
      "editingSource": "Está a editar a mensagem apenas para este envio. O modelo do tenant não é alterado.",
      "linkPresent": "Ligação de aceitação presente",
      "linkRequired": "Mantenha a ligação de aceitação — sem ela o candidato não tem como começar."
    },
    "attentionReason": {
      "invitation_never_sent": "Convite nunca enviado",
      "invitation_bounced": "E-mail devolvido — verifique o endereço",
      "invitation_expired": "Convite expirado",
      "signed_up_not_accepted": "Registou-se mas não aceitou — reenviar",
      "invite_ignored": "Sem resposta há {{days}} dias",
      "onboarding_stalled": "Perfil incompleto há {{days}} dias",
      "checkup_never_requested": "CheckUp nunca solicitado",
      "checkup_never_started": "CheckUp não iniciado há {{days}} dias",
      "checkup_stalled": "CheckUp parado há {{days}} dias",
      "scoring_stalled": "Cálculo atrasado há {{days}} dias",
      "awaiting_company_review": "À espera da sua análise há {{days}} dias",
      "testit_awaiting_review": "Testes concluídos — à espera do seu parecer",
      "citizen_left": "Candidato saiu da plataforma",
      "mobility_track_blocked": "Patrocinado mas sem percurso iniciado",
      "sponsorship_offer_unanswered": "Oferta de patrocínio sem resposta há {{days}} dias",
      "checkup_not_shared": "Resultado do CheckUp não partilhado há {{days}} dias",
      "sharing_withdrawn": "Partilha retirada há {{days}} dias",
      "academyStalled": "Sem progresso na Languages Academy há {{days}} dias",
      "academyGoalReached": "Alcançou a meta do curso na Languages Academy"
    },
    "companyProfile": {
      "industry": {
        "technology": "Tecnologia",
        "healthcare": "Saúde",
        "finance": "Finanças",
        "manufacturing": "Indústria transformadora",
        "retail": "Retalho",
        "hospitality": "Hotelaria e restauração",
        "construction": "Construção",
        "education": "Educação",
        "consulting": "Consultoria",
        "logistics": "Logística",
        "energy": "Energia",
        "telecommunications": "Telecomunicações",
        "mediaEntertainment": "Media e entretenimento",
        "realEstate": "Imobiliário",
        "other": "Outra"
      },
      "roleType": {
        "engineering": "Engenharia",
        "product": "Produto",
        "design": "Design",
        "dataScience": "Ciência de dados",
        "devops": "DevOps e infraestrutura",
        "marketing": "Marketing",
        "sales": "Vendas",
        "customerSuccess": "Sucesso do cliente",
        "finance": "Finanças",
        "hrPeople": "Recursos humanos",
        "operations": "Operações",
        "executive": "Direção e liderança",
        "other": "Outra"
      },
      "employeesRange": "{{range}} colaboradores",
      "hiresRange": "{{range}} contratações por ano",
      "openLinkedIn": "Abrir perfil ↗"
    },
    "lifecycleStatus": {
      "draft": "Rascunho",
      "active": "Em curso",
      "paused": "Em pausa",
      "completed": "Concluído",
      "archived": "Arquivado"
    },
    "taskPriority": {
      "high": "Alta prioridade"
    },
    "iqulture": {
      "provisional": {
        "label": "Provisório",
        "tooltip": "Faltam alguns dados deste talento, por isso a pontuação é o mínimo possível. Com os dados completos, pode chegar a {{max}}."
      }
    },
    "shareRequest": {
      "badge": {
        "pendingCheckup": "CheckUp pedido — à espera do talento",
        "pendingTests": "Mais testes pedidos — à espera do talento",
        "declinedCheckup": "Pedido de CheckUp recusado · {{date}}",
        "declinedTests": "Pedido de testes recusado · {{date}}",
        "pendingTooltip": "Pedido a {{date}}. Nada mais é partilhado até o talento responder.",
        "declinedTooltip": "Vê o que o talento partilhou antes. Pode voltar a pedir mais tarde."
      },
      "notice": {
        "pendingCheckupTitle": "CheckUp pedido — à espera do talento",
        "pendingTestsTitle": "Mais testes pedidos — à espera do talento",
        "pendingBody": "Pedido a {{date}}. Nada mais é partilhado até responderem — continua a ver o que aceitaram antes.",
        "declinedCheckupTitle": "O talento recusou o seu pedido para ver o CheckUp",
        "declinedTestsTitle": "O talento recusou o seu pedido de mais testes",
        "declinedBody": "Recusado a {{date}}. Nada mudou: vê o que partilharam antes. Pode voltar a pedir mais tarde."
      }
    },
    "inoutOperations": {
      "title": "Operação InOut",
      "subtitle": "Os tickets InOut das assessorias. Só para a equipa Tonnie — cada acesso fica registado.",
      "tabs": {
        "cases": "Tickets",
        "files": "Ficheiros da assessoria",
        "reconciliation": "Reconciliação",
        "portals": "Portais"
      },
      "loading": "A carregar…",
      "loadError": "Não foi possível carregar. Tente de novo.",
      "cases": {
        "empty": "Ainda não há tickets.",
        "caseRef": "Ticket",
        "agency": "Assessoria",
        "state": "Estado",
        "opened": "Aberto em",
        "consultations": "Consultas pagas",
        "requisition": "Requisição",
        "noRequisition": "Nenhuma",
        "refunds": "Devoluções pedidas",
        "lastEvent": "Último evento",
        "noEvent": "Ainda nenhum",
        "open": "Abrir"
      },
      "detail": {
        "title": "Ticket {{caseRef}}",
        "recorded": "A abertura deste ticket fica registada.",
        "person": "Pessoa",
        "personWithheld": "Não mostrada — a pessoa não tem um consentimento em vigor para a assessoria.",
        "consultations": "Consultas",
        "noConsultations": "Nenhuma consulta.",
        "requisition": "Requisição",
        "paid": "{{amount}} pagos · {{credit}} de crédito aplicado",
        "credit": "Crédito disponível: {{amount}}",
        "events": "Eventos",
        "noEvents": "Ainda nenhum evento.",
        "refunds": "Pedidos de devolução",
        "noRefunds": "Nenhum pedido de devolução.",
        "markHandled": "Devolvido no Stripe — marcar tratado",
        "links": "Links do dossiê",
        "noLinks": "Ainda nenhum dossiê enviado.",
        "linkRevoked": "Revogado — o consentimento foi retirado",
        "loadingTitle": "Ticket",
        "handled": "Pedido de reembolso marcado como tratado.",
        "handleFailed": "Não foi possível marcar o pedido de reembolso como tratado. Tente de novo.",
        "linkSent": "Enviado a {{date}}",
        "linkValidUntil": "Válido até {{date}}",
        "linkOpens_one": "Aberto uma vez",
        "linkOpens_other": "Aberto {{opens}} vezes"
      },
      "event": {
        "title": "Registar um evento da assessoria",
        "code": "Evento",
        "note": "Nota",
        "noNote": "Sem nota",
        "when": "Quando aconteceu",
        "submit": "Registar",
        "done": "Evento registado",
        "refused": "O evento não serve para este ticket — confirme o código ou se o ticket está fechado.",
        "failed": "Não foi possível registar o evento. Tente de novo.",
        "whenRequired": "Indique quando aconteceu.",
        "codeRequired": "Escolha o evento."
      },
      "files": {
        "agency": "Assessoria",
        "noAgency": "Ainda nenhuma assessoria tem tickets.",
        "choose": "Escolha o ficheiro da assessoria (CSV, formato v1)",
        "readFailed": "Não foi possível ler o ficheiro.",
        "tooBig": "O ficheiro é maior do que a operação lê.",
        "browserPreview": "O que o seu browser leu",
        "serverReport": "A verificação do servidor",
        "line": "Linha",
        "event": "Evento",
        "when": "Quando",
        "outcome": "Resultado",
        "problems": "Problemas",
        "check": "Verificar e guardar o ficheiro",
        "fixFirst": "Corrija primeiro os problemas do ficheiro — um ficheiro carrega inteiro ou não carrega.",
        "load": "Carregar o ficheiro",
        "loaded": "Ficheiro carregado",
        "closed": "Este ficheiro não pode ser carregado — foi recusado, já foi carregado ou a verificação expirou.",
        "failed": "Não funcionou. Tente de novo.",
        "history": "Ficheiros recebidos",
        "noHistory": "Ainda nenhum ficheiro recebido.",
        "received": "Recebido",
        "fileName": "Ficheiro",
        "rows": "Linhas",
        "state": "Estado"
      },
      "reconciliation": {
        "month": "Mês",
        "empty": "Nada foi pago neste mês.",
        "problem": "A base sem IVA não pode ser calculada agora.",
        "agency": "Assessoria",
        "charged": "Cobrado (com IVA)",
        "refunded": "Devolvido",
        "net": "Base sem IVA",
        "share": "Parte da assessoria",
        "notYet": "Ainda não — um pagamento não tem linha de IVA",
        "payments": "Pagamentos",
        "documentsMissing": "Documentos por emitir",
        "cases": "Tickets"
      },
      "portals": {
        "intro": "Os sites onde a calculadora InOut funciona — o da Tonnie e os dos parceiros. A calculadora de um portal em rascunho não carrega.",
        "empty": "Ainda não há portais.",
        "new": "Novo portal",
        "code": "Código",
        "name": "Nome",
        "status": "Estado",
        "origins": "Sites autorizados",
        "updated": "Atualizado",
        "edit": "Editar",
        "statusDraft": "Rascunho",
        "statusActive": "Ativo",
        "originsCount_one": "{{count}} site",
        "originsCount_other": "{{count}} sites",
        "newTitle": "Novo portal",
        "editTitle": "Portal {{code}}",
        "description": "O que a calculadora mostra neste portal, que sites a podem incorporar e o seu aspeto. Uma alteração guardada chega à calculadora da próxima vez que carregar.",
        "codeHint": "Maiúsculas, algarismos e _ — as páginas do portal chamam-lhe assim (data-portal). Não pode mudar depois.",
        "active": "Ativo — a calculadora carrega neste portal",
        "nameHint": "Aparece no cabeçalho da calculadora.",
        "nameGender": "Como se diz o nome",
        "nameGenderFeminine": "Feminino — «na Tonnie», «na Ei!»",
        "nameGenderMasculine": "Masculino — «no portal»",
        "nameGenderHint": "O género do nome em português: o registo diz que o cálculo foi feito «na Tonnie», «na Ei!» ou «no portal».",
        "website": "Site",
        "logo": "Logótipo",
        "logoHint": "Opcional — um endereço https://, ou uma imagem servida pela calculadora (/assets/partners/…). Mostrado com 32 px de altura: um logótipo horizontal ou um símbolo quadrado.",
        "originsHint": "Os sites autorizados a incorporar a calculadora, cada um como https://anfitrião. Um portal ativo precisa de pelo menos um.",
        "originPlaceholder": "https://www.exemplo.com",
        "addOrigin": "Adicionar",
        "removeOrigin": "Remover {{origin}}",
        "country": "Começa em",
        "countryNone": "O visitante escolhe",
        "language": "Idioma",
        "languageNone": "O do visitante",
        "partner": "Assessoria",
        "partnerNone": "Nenhuma",
        "partnerDraft": "{{name}} (rascunho)",
        "look": "Aspeto",
        "customTheme": "Usar as cores do portal",
        "accent": "Cor de ação",
        "accentForeground": "Texto sobre a cor de ação",
        "pageColours": "Usar as cores de página do portal",
        "background": "Página",
        "foreground": "Texto sobre a página",
        "radius": "Cantos",
        "radiusNone": "Retos",
        "radiusSm": "Ligeiros",
        "radiusMd": "Médios",
        "radiusLg": "Arredondados",
        "radiusXl": "Redondos",
        "font": "Tipo de letra",
        "fontSystem": "O do dispositivo",
        "contrast": "Contraste {{ratio}}:1",
        "contrastOk": "Legível",
        "contrastLow": "Demasiado baixo — pelo menos 4,5:1",
        "preview": "Pré-visualização",
        "embed": "Colocá-la no portal",
        "embedHint": "Cole isto nas páginas do portal: o botão abre a calculadora numa janela; o bloco vazio mostra-a na página.",
        "copy": "Copiar",
        "copied": "Copiado",
        "saved": "Portal guardado.",
        "failed": "Não foi possível guardar o portal. Tente novamente.",
        "refused": "Alguns valores foram recusados — verifique os campos.",
        "partnerUnknown": "Essa assessoria não está no registo de parceiros.",
        "copyFailed": "O browser não deixou copiar. Selecione o código abaixo e copie-o."
      }
    }
  },
  "capture": {
    "uploadFailedDefault": "O carregamento falhou. Por favor, tente novamente."
  },
  "care": {
    "additionalComments": "Comentários adicionais (opcional)",
    "allStatuses": "Todos os estados",
    "alreadyCheckedIn": "Já fez check-in hoje",
    "appOnlyNotice": {
      "message": "Este painel é a sua visão geral, só de leitura. Abra a app Tonnie para registar o seu humor, fazer check-ins rápidos e completar pontos de verificação.",
      "title": "Os check-ins diários acontecem na aplicação"
    },
    "askCopilotAboutThis": "Pergunte CoPilot sobre isso",
    "askCopilotFirst": "Pergunte ao CoPilot cérebro primeiro",
    "assessedOn": "Avaliado em {{date}}",
    "assessment": {
      "completeTitle": "Avaliação completa",
      "completed": "Completo",
      "gateTitle": "Avaliação Care",
      "loading": "A carregar avaliação…",
      "redirecting": "A redirecionar…",
      "retake": "Refazer avaliação",
      "saving": "A guardar…",
      "subtitle": "Um breve check-in para avaliar como está a adaptar-se. Leva cerca de 5 minutos.",
      "title": "Avaliação Care"
    },
    "assessmentEstimatedTime": "Cerca de 5 minutos",
    "assessmentInfoDescription": "As suas respostas ajudam o Care a personalizar os check-ins, sugerir recursos locais e disponibilizar apoio quando precisar.",
    "assessmentInfoIntro": "Faremos algumas perguntas sobre o seu bem-estar em saúde, finanças e comunidade.",
    "baseline": {
      "anxiety": "Ansiedade atual sobre a realocação",
      "concerns": "Principais áreas de preocupação",
      "desc": "Selecione a opção que melhor descreve o seu estado emocional atual.",
      "familyConfidence": "Confiança na adaptação da família",
      "minimal": "Mínimo",
      "notConfident": "Não confiante",
      "selectMultiple": "selecione todas as que se aplicam",
      "significant": "Significativo",
      "supportNeed": "Quanto suporte acha que vai precisar?",
      "title": "Como se sente em relação à mudança?",
      "veryConfident": "Muito confiante"
    },
    "carePillars": "Pilares Care",
    "challengePlaceholder": "Descreva o seu desafio ou pergunta...",
    "checkin": {
      "responseField": {
        "qc_concern": "Preocupações",
        "qc_notes": "Notas"
      },
      "responses": "Respostas"
    },
    "checkinType": {
      "daily_mood": "Humor diário",
      "evening_checkin": "Verificação da noite",
      "morning_checkin": "Verificação da manhã",
      "quick_checkin": "Check-in rápido",
      "weekly_checkin": "Verificação semanal"
    },
    "checkpoint": {
      "complete": {
        "milesEarned": "+{{miles}} Miles ganhas",
        "nextCheckpoint": "Próximo ponto de verificação: {{date}}",
        "recorded": "Respostas registadas no seu Passport",
        "subtitle": "Obrigado por partilhar. As suas respostas ajudam-nos a apoiá-lo melhor.",
        "title": "Ponto de verificação completo!"
      },
      "completed": "Completo",
      "confirmSubmit": {
        "message": "Está pronto para submeter as suas respostas do ponto de verificação? Não poderá alterar as suas respostas após a submissão.",
        "title": "Submeter ponto de verificação?"
      },
      "due": "Devido",
      "feedbackLabel": "Algum feedback adicional? (opcional)",
      "feedbackPlaceholder": "Partilhe os seus pensamentos...",
      "loading": "A carregar ponto de verificação...",
      "notFound": "Ponto de verificação não encontrado",
      "unavailableTitle": "Verificação indisponível",
      "unavailableBody": "Não conseguimos carregar as perguntas para esta verificação neste momento. Por favor, tente novamente mais tarde.",
      "overallScore": "Pontuação geral",
      "overdue": "Atrasado",
      "previous": "Anterior",
      "reviewSubmit": "Rever & submeter",
      "scaleLabels": [
        "Muito insatisfeito",
        "Insatisfeito",
        "Neutro",
        "Satisfeito",
        "Muito satisfeito"
      ],
      "scheduled": "Agendado",
      "scoresSummary": "Resumo das suas pontuações:",
      "skipped": "Ignorado",
      "stepOf": "Passo {{current}} de {{total}}",
      "submit": "Submeter",
      "title": "Checkpoint",
      "typeNames": {
        "ad_hoc": "Check-in",
        "annual": "Checkpoint anual",
        "custom": "Checkpoint",
        "month_1": "Checkpoint de 1 mês",
        "month_12": "Checkpoint de 12 meses",
        "month_3": "Checkpoint de 3 meses",
        "month_6": "Checkpoint de 6 meses",
        "month_9": "Checkpoint de 9 meses",
        "onboarding": "Checkpoint de integração",
        "pre_move_baseline": "Linha de base pré-mudança",
        "week_1": "Checkpoint da semana 1",
        "week_2": "Checkpoint da semana 2"
      },
      "framing": {
        "expectations": "Antes da sua mudança — as suas expectativas",
        "reality": "A instalar-se — como as coisas realmente estão",
        "settling": "A encontrar o seu ritmo",
        "established": "A estabelecer-se",
        "thriving": "De olhos postos no futuro"
      },
      "focusPillar": "Foco",
      "miles_one": "{{count}} Mile",
      "miles_other": "{{count}} Miles",
      "pillarsTime_one": "{{count}} pilar · {{time}} min",
      "pillarsTime_other": "{{count}} pilares · {{time}} min"
    },
    "checkpointCommentsPlaceholder": "Partilhe quaisquer pensamentos ou preocupações sobre a estabilidade do seu agregado familiar e integração...",
    "checkpointCompleted": "Checkpoint concluído com sucesso!",
    "checkpointDescription": "Autoavaliação para bem-estar e integração",
    "checkpointEvolution": "Evolução do checkpoint",
    "checkpointFormDescription": "Conclua este ponto de controlo para acompanhar o seu progresso. Também o pode concluir no telemóvel.",
    "checkpointHistory": "Histórico de checkpoints",
    "checkpointMonth": "Checkpoint de {{month}} meses",
    "checkpointTitle": "Ponto de verificação Care",
    "checkpoints": {
      "status": {
        "completed": "Completo",
        "due": "Devido agora",
        "in_progress": "Em progresso",
        "overdue": "Atrasado",
        "pending": "Próximos",
        "scheduled": "Próximos",
        "skipped": "Ignorado"
      },
      "title": "Checkpoints"
    },
    "checkpointsCompleted": "Checkpoints concluídos",
    "checkpointsDescription": "Veja os checkpoints e complete-os na aplicação móvel",
    "commitment": {
      "at_risk": "Em risco",
      "champion": "Campeão",
      "committed": "Comprometido",
      "engaged": "Envolvido",
      "flight_risk": "Precisa de atenção"
    },
    "companyFeedback": "Feedback da empresa",
    "companyRating": "Classificação da empresa",
    "completeCheckinMobile": "Complete o check-in no móvel",
    "completeCheckpointMobile": "Completo no móvel",
    "completeFirstCycle": "Complete o seu primeiro ciclo de feedback para vê-lo aqui",
    "completedOn": "Concluído em",
    "concern": {
      "family": "Família",
      "finances": "Finanças",
      "healthcare": "Cuidados de saúde",
      "housing": "Habitação",
      "language": "Língua",
      "loneliness": "Solidão",
      "schooling": "Educação",
      "title": "Preocupações",
      "work": "Trabalho"
    },
    "continue": {
      "description": "Começou a sua avaliação Care. Retome exatamente onde parou no Citizen Web — as suas respostas até agora estão guardadas.",
      "title": "Continue a sua avaliação Care"
    },
    "continueOnWeb": "Continuar no Citizen Web",
    "continueOnWebDesc": "Retome a sua avaliação Care de onde parou no Portal Web Citizen.",
    "copilotSuggestions": "💡 sugestões do cérebro CoPilot",
    "copilotSuggestionsText": "Antes de enviar, tente perguntar ao Cérebro CoPilot por ajuda imediata. Ele pode sugerir lições, tarefas ou recursos.",
    "createdOn": "Criado em",
    "current": "Atual",
    "description": "Acompanhe o seu bem-estar",
    "due": "Devido",
    "dueNow": "Devido agora",
    "error": {
      "description": "Puxe para atualizar ou toque em tentar novamente. Se continuar a falhar, verifique a sua ligação.",
      "title": "Não conseguimos carregar os seus dados de Care"
    },
    "excellent": "5 — Excelente",
    "familyMasterOnly": "Apenas o Family Master pode responder aos pontos de verificação de Care",
    "feedbackComment1": "Ótimo desempenho no projeto recente. Continue assim!",
    "feedbackComment2": "Bom progresso, continue a praticar português.",
    "feedbackComment3": "Sinto-me mais confiante nas conversas em português no trabalho.",
    "feedbackComment4": "Ainda a ajustar-se à cultura de trabalho, mas a fazer progresso.",
    "feedbackPillars": "Pilares de feedback",
    "from": "De",
    "getHelpWith": "Obtenha ajuda com {{topic}}",
    "heroBanner": {
      "assessmentComplete": "Avaliação completa",
      "awaitingFirstCheckin": "Comece o seu primeiro check-in de humor",
      "focusFromAssessment": "Áreas de foco da sua avaliação",
      "title": "O seu bem-estar",
      "wellbeing": "Bem-estar",
      "gettingStarted": "A começar"
    },
    "heroMiles": "Miles Care",
    "householdAware": "Consciente da Família",
    "householdAwareDescription": "Este pilar considera o contexto do seu agregado familiar (parceiro, filhos) na avaliação",
    "improving": "A Melhorar",
    "manager": "Gestor",
    "mood": {
      "amazing": "Incrível",
      "checkedIn": "Check-in feito hoje!",
      "earnMiles": "Ganhe milhas ao fazer check-in diariamente",
      "good": "Bom",
      "great": "Ótimo",
      "howAreYou": "Como se sente hoje?",
      "label1": "A lutar",
      "label2": "Ok",
      "label3": "Bom",
      "label4": "Ótimo",
      "label5": "Incrível",
      "okay": "Ok",
      "struggling": "A lutar",
      "streakDays_one": "Sequência de {{count}} dia",
      "streakDays_other": "Sequência de {{count}} dias"
    },
    "mySupportRequests": "Os meus pedidos de apoio",
    "mySupportRequestsDesc": "Acompanhe e reveja os seus pedidos de apoio submetidos",
    "needSupport": "Precisa de apoio?",
    "needsImprovement": "1 — Precisa de melhorar",
    "newRequest": "Novo pedido",
    "noCheckins": "Ainda não há verificações. Comece a acompanhar o seu humor!",
    "noCheckpointsScheduled": "Ainda não há pontos de verificação agendados",
    "noDataYet": "Ainda não há dados",
    "noHistory": "Ainda não há histórico de feedback",
    "noSupportRequests": "Nenhum pedido de apoio corresponde a este filtro",
    "noUpdatesYet": "Ainda não há atualizações",
    "objectiveChildcareArrangement": "Organizar cuidados infantis",
    "objectiveDefinitiveHousing": "Garantir habitação definitiva",
    "objectiveHousingStress": "Reduzir o stress relacionado com a habitação",
    "objectiveSchoolEnrollment": "Completar a matrícula escolar",
    "objectiveSocialIntegration": "Criar ligações sociais",
    "objectiveTemporaryHousing": "Garantir habitação temporária",
    "objectiveWellbeingSupport": "Aceder ao apoio ao bem-estar",
    "objectiveWorkAdaptation": "Adaptar-se à cultura do local de trabalho",
    "objectiveWorkplaceCulture": "Compreender a cultura do local de trabalho",
    "objectives": {
      "title": "Os seus objetivos",
      "subtitle": "O que a sua equipa de patrocinadores está a ajudar a alcançar.",
      "categoryFallback": "Objetivo",
      "currentLabel": "Agora",
      "targetLabel": "Objetivo",
      "milestoneDone": "Feito",
      "milestoneNotYet": "Ainda não",
      "feedbackReadyBadge": "Feedback pronto",
      "viewFeedbackCta": "Ver feedback e autoavaliar-se",
      "sourceCompany": "Da sua empresa",
      "sourcePersonal": "O seu próprio objetivo",
      "currentCycleHeading": "Feedback deste ciclo",
      "selfEmpty": "Ainda não adicionou a sua autoavaliação para este objetivo.",
      "ratingValue": "{{label}} ({{value}}/5)",
      "cadenceNote": "O feedback é revisto {{cadence}}.",
      "cadence": {
        "bi-weekly": "a cada duas semanas",
        "monthly": "mensalmente",
        "quarterly": "trimestralmente"
      },
      "selfEvalBanner": {
        "title": "A sua equipa partilhou novo feedback",
        "message": "Há um ciclo de feedback aberto à espera da sua autoavaliação. Adicione-o na app Tonnie para refletir sobre cada objetivo.",
        "cta": "Adicione a sua autoavaliação na aplicação"
      }
    },
    "objectiveFeedback": {
      "title": "Objetivos & feedback",
      "intro": "A sua equipa de patrocinadores partilhou feedback sobre os seus objetivos. Reflita sobre cada um e adicione a sua própria autoavaliação honesta — fica entre si e a sua equipa.",
      "providerHeading": "O feedback da sua equipa",
      "providerEmpty": "A sua equipa ainda não adicionou uma nota para este objetivo.",
      "selfHeading": "A sua autoavaliação",
      "ratingPrompt": "Como está a correr isto para si?",
      "valuePlaceholder": "Insira o seu número",
      "ratingLabel1": "Apenas a começar",
      "ratingLabel2": "A encontrar o meu caminho",
      "ratingLabel3": "A fazer progressos",
      "ratingLabel4": "A fazer bem",
      "ratingLabel5": "A prosperar",
      "commentLabel": "Algo que gostaria de adicionar? (opcional)",
      "commentPlaceholder": "O que está a correr bem, o que tem sido difícil, o que precisa…",
      "submit": "Submeter autoavaliação",
      "submitting": "A submeter…",
      "noRatingHint": "Classifique pelo menos um objetivo para submeter.",
      "loadingTitle": "A carregar os seus objetivos…",
      "emptyTitle": "Sem objetivos ainda",
      "emptyBody": "Assim que a sua equipa de patrocinadores definir objetivos para si, eles aparecerão aqui.",
      "allCaughtUpTitle": "Está tudo em dia",
      "allCaughtUpBody": "Não há ciclo de feedback aberto neste momento. Avisaremos quando a sua equipa partilhar novos feedbacks.",
      "errorTitle": "Não conseguimos carregar os seus objetivos",
      "errorBody": "Puxe para atualizar ou toque em tentar novamente. Se continuar a falhar, verifique a sua ligação.",
      "successTitle": "Autoavaliação partilhada",
      "successBody": "Obrigado por refletir. A sua equipa pode ver a sua avaliação juntamente com o feedback deles.",
      "successDone": "Feito",
      "dueOn": "Vencimento {{date}}",
      "cadenceNote": "A sua equipa revisa estes {{cadence}}.",
      "cadence": {
        "weekly": "semanalmente",
        "bi-weekly": "a cada duas semanas",
        "biweekly": "a cada duas semanas",
        "monthly": "mensalmente",
        "quarterly": "trimestralmente",
        "semiannual": "duas vezes por ano",
        "annual": "anualmente"
      },
      "trust": {
        "why": "A sua autoavaliação ajuda a sua equipa de patrocinadores a entender os seus objetivos do seu ponto de vista.",
        "who": "As suas respostas só são visíveis para si e para a sua equipa de patrocinadores Tonnie. Nunca são partilhadas com outros colegas.",
        "how": "Refletir sobre os seus objetivos mantém o seu apoio pessoal e no caminho certo."
      }
    },
    "overdue": "Atrasado",
    "phase": {
      "adapting": "A adaptar-se",
      "preMove": "Antes da mudança",
      "settlingIn": "A instalar-se",
      "thriving": "A prosperar"
    },
    "pillar": {
      "housing_stability": {
        "desc": "Habitação temporária e definitiva, stress e risco",
        "name": "Estabilidade habitacional"
      },
      "schooling_childcare": {
        "desc": "Educação e arranjos de cuidados infantis",
        "name": "Educação e cuidados infantis"
      },
      "wellbeing_social": {
        "desc": "Saúde mental, ligações sociais e bem-estar geral",
        "name": "Bem-estar & social"
      },
      "work_fit": {
        "desc": "Adequação ao trabalho e adaptação ao local de trabalho",
        "name": "Adequação ao trabalho e adaptação"
      },
      "housing": {
        "name": "Estabilidade habitacional",
        "description": "Encontrar, instalar-se e sentir-se seguro na sua casa.",
        "obj1": "Habitação estável, adequada e segura",
        "obj2": "Reduzir o stress relacionado com a habitação",
        "obj3": "Instalar-se na vizinhança",
        "q1": "Quão satisfeito está com a sua situação habitacional atual?",
        "q1_hh": "Quão satisfeita está a sua família com a sua situação habitacional atual?",
        "q2": "Quão seguro se sente em relação aos seus arranjos habitacionais?",
        "q2_hh": "Quão segura se sente a sua família em relação aos arranjos habitacionais?",
        "q3": "Quão bem conhece a sua área local e as comodidades?",
        "qPreMove": "Quão preparado se sente em relação aos seus arranjos habitacionais para a mudança?"
      },
      "schooling": {
        "name": "Educação e cuidados infantis",
        "description": "Os arranjos de educação e cuidados infantis dos seus filhos.",
        "obj1": "Inscrever crianças em educação adequada",
        "obj2": "Organizar cuidados infantis fiáveis",
        "obj3": "Ajudar as crianças a integrar-se socialmente",
        "q1": "Quão satisfeito está com os arranjos de educação dos seus filhos?",
        "q2": "Quão bem se integraram os seus filhos na nova escola?",
        "q3": "Quão gerível é a sua situação de cuidados infantis?"
      },
      "work": {
        "name": "Adequação ao trabalho",
        "description": "Quão bem se adaptou ao seu novo papel e local de trabalho.",
        "obj1": "Adaptar-se ao novo papel",
        "obj2": "Integrar-se com a equipa",
        "obj3": "Compreender a cultura do local de trabalho",
        "q1": "Quão bem se sente integrado no seu local de trabalho?",
        "q2": "Quão claros são o seu papel e responsabilidades?",
        "q3": "Quão apoiado se sente pela sua equipa?",
        "q4": "Quão confiante se sente no seu trabalho diário?",
        "qMonth3": "Três meses depois, quão instalado se sente no seu papel?"
      },
      "wellbeing": {
        "name": "Bem-estar & social",
        "description": "O seu bem-estar geral e as suas ligações sociais.",
        "obj1": "Manter o bem-estar emocional",
        "obj2": "Criar ligações sociais",
        "obj3": "Apoiar a integração de companheiros",
        "q1": "Como avaliaria o seu bem-estar geral?",
        "q1_hh": "Como avaliaria o bem-estar geral da sua família?",
        "q2": "Até que ponto se sente ligado às pessoas à sua volta?",
        "q2_hh": "Até que ponto a sua família se sente ligada às pessoas à sua volta?",
        "q3": "Quão bem está a gerir a vida do dia-a-dia aqui?",
        "q4": "Quão otimista se sente em relação à instalação?",
        "q4_hh": "Quão otimista se sente a sua família em relação à instalação?",
        "qMonth1": "Passado um mês, até que ponto se sente ligado às pessoas daqui?"
      }
    },
    "pillarCommunication": "Comunicação",
    "pillarHousingStability": "Estabilidade habitacional",
    "pillarHousingStabilityDesc": "Habitação temporária/definitiva, stress, risco",
    "pillarIntegration": "Comportamento & Adaptação",
    "pillarSchoolingChildcare": "Estabilidade na escolaridade/Cuidados infantis",
    "pillarSchoolingChildcareDesc": "Arranjos de educação e cuidados infantis (se aplicável)",
    "pillarSelector": {
      "conditional": "Condicional",
      "desc": "Recomendamos estes pilares com base no seu perfil. Pode ajustá-los.",
      "selected": "selecionado",
      "title": "Escolha as suas áreas de foco"
    },
    "pillarTechnical": "Competências técnicas",
    "pillarWellbeing": "Bem-estar e adaptação social",
    "pillarWellbeingDesc": "Saúde mental, ligações sociais e bem-estar geral",
    "pillarWorkFit": "Adequação ao trabalho e adaptação",
    "pillarWorkFitDesc": "Adequação ao trabalho e adaptação ao local de trabalho",
    "pillars": {
      "housingStability": "Estabilidade habitacional",
      "schoolingChildcare": "Educação e cuidados infantis",
      "title": "Pilares Care",
      "wellbeingSocial": "Bem-estar & social",
      "workFit": "Adequação ao trabalho e adaptação"
    },
    "plan": {
      "active": "Devido agora",
      "assessmentDone": "Avaliação completa",
      "completed": "Completo",
      "encouragement": "Cada ponto de verificação ajuda-nos a entender como está a adaptar-se e como podemos apoiá-lo melhor.",
      "focusAreas": "As suas áreas de foco",
      "locked": "Próximos",
      "milesReward": "+{{miles}} Miles",
      "milestones": "Marcos de ponto de verificação"
    },
    "preferences": {
      "afternoon": "Tarde",
      "daily": "Diário",
      "desc": "Diga ao Care quando e com que frequência deve verificar como está. Pode mudar isto a qualquer momento.",
      "evening": "Noite",
      "frequencyLabel": "Frequência",
      "moodReminder": "Lembrete de humor",
      "moodReminderDesc": "Receba um lembrete suave para registar como se sente.",
      "morning": "Manhã",
      "timeLabel": "Hora preferida",
      "title": "Preferências Care",
      "weekdays": "Dias de semana",
      "weekly": "Semanal"
    },
    "proFeature": "Recurso Pro — Atualize para aceder",
    "proFeatureDescription": "Atualize para Pro para aceder a todas as funcionalidades, ciclos de feedback e apoio do Care.",
    "proFeatureTitle": "Care & apoio — Funcionalidade Pro",
    "progressOverTime": "O seu progresso ao longo do tempo",
    "quickCheckin": {
      "concern": "Alguma área que gostaria de sinalizar?",
      "continue": "Continuar",
      "notes": "Algo mais que gostaria de partilhar?",
      "overall": "Como se sente esta semana no geral?",
      "copilotPrompts": {
        "concern": "Alguma área que gostaria de sinalizar?",
        "notes": "Algo mais que gostaria de partilhar?",
        "overall": "Como se sente no geral esta semana?"
      },
      "error": {
        "message": "Não conseguimos guardar o seu check-in. Por favor, tente novamente.",
        "title": "Algo correu mal"
      },
      "finish": "Terminar",
      "intro": {
        "quickEasy": "Rápido & fácil",
        "quickEasyDesc": "Apenas 3-5 perguntas, leva 2 minutos",
        "subtitle": "O CoPilot irá guiá-lo através de algumas perguntas",
        "trackProgress": "Acompanhar progresso",
        "trackProgressDesc": "Comparar com os seus check-ins anteriores"
      },
      "processing": {
        "subtitle": "O CoPilot está a preparar os seus insights...",
        "title": "A analisar as suas respostas"
      },
      "questionOf": "Pergunta {{current}} de {{total}}",
      "questions": {
        "notesPlaceholder": "Escreva os seus pensamentos aqui...",
        "qcConcern": "Alguma área que gostaria de sinalizar?",
        "qcNotes": "Algo mais que gostaria de partilhar?",
        "qcOverall": "Como se sente esta semana no geral?",
        "qcOverallLabels": ["Muito mal", "Mal", "Razoável", "Bem", "Ótimo"]
      },
      "results": {
        "areasOfConcern": "Áreas de preocupação",
        "milesEarned": "+{{miles}} Miles ganhas",
        "moodScoreOf": "Pontuação de humor de {{score}}",
        "nextStep1": "Continue os seus check-ins diários para acompanhar o seu bem-estar ao longo do tempo",
        "title": "Check-in completo!",
        "today": "Hoje",
        "trendTitle": "Tendência",
        "whatsNext": "O que vem a seguir",
        "yesterday": "Ontem",
        "yourNotes": "As suas notas",
        "concernHint": "CoPilot irá acompanhar estas áreas",
        "nextStep2": "CoPilot irá acompanhar as suas tendências ao longo do tempo",
        "nextStep3": "Receberá dicas personalizadas para áreas sinalizadas"
      },
      "selectAll": "Selecione tudo o que se aplica",
      "alreadyDone": {
        "title": "Está tudo pronto para hoje",
        "message": "Já completou o check-in de hoje. Volte amanhã!"
      },
      "doneToday": "Concluído hoje",
      "shortDesc": "Verificação rápida de bem-estar diário",
      "startButton": "Iniciar check-in",
      "title": "Check-in rápido",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles"
    },
    "rateProgress": "Como avaliaria o seu progresso?",
    "recentCycles": "Os seus pontos de verificação recentes",
    "requestSupport": "Solicitar apoio",
    "responses": "respostas",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer avaliação na web",
    "retakeOnWebDesc": "Para refazer a sua avaliação Care, use o Portal Web Citizen.",
    "returnToDashboard": "Voltar ao painel",
    "risk": {
      "checkinGap": "Um longo intervalo desde o último check-in",
      "crossHeroStall": "Sem atividade TelePortal ou QultureUp nos últimos 30 dias",
      "isolation": "Pontuações sociais/bem-estar baixas nos pontos de verificação recentes",
      "missedCheckpoint": "Um ponto de verificação está {{overdueDays}} dias em atraso",
      "moodDecline": "Humor baixo durante {{consecutive}} check-ins consecutivos",
      "pillarDrop": "{{pillar}} caiu {{drop}} pts desde o último ponto de verificação"
    },
    "selectPillarOrTheme": "Selecionar pilar ou tema",
    "selectPillarOrThemePlaceholder": "Escolha um pilar ou tema",
    "selectSeverity": "Selecionar gravidade (opcional)",
    "selfFeedback": "Auto-Feedback",
    "severity": {
      "high": "Alto",
      "low": "Baixo",
      "medium": "Médio",
      "urgent": "Urgente"
    },
    "severityHigh": "Alto",
    "severityLow": "Baixo",
    "severityMedium": "Médio",
    "shareThoughts": "Partilhe os seus pensamentos sobre {{pillar}}...",
    "startCheckpoint": "Iniciar ponto de verificação",
    "startOnWeb": "Começar no Citizen Web",
    "startOnWebDesc": "Configure a sua avaliação Care no Portal Web Citizen (cerca de 5 minutos). Uma vez feito, os check-ins diários e os pontos de verificação acontecem aqui na aplicação.",
    "status": {
      "closed": "Fechado",
      "in_progress": "Em progresso",
      "open": "Abrir",
      "resolved": "Resolvido"
    },
    "statusInProgress": "Em progresso",
    "statusOpen": "Abrir",
    "statusResolved": "Resolvido",
    "streak": {
      "awesome": "Incrível!",
      "dayStreak": "{{days}}-dia de série!",
      "badges": {
        "starter": "Primeiros passos",
        "weeklyWarrior": "Uma semana inteira",
        "consistent": "Duas semanas de cuidado",
        "monthlyChampion": "Um mês inteiro",
        "dedicated": "Dois meses de cuidado",
        "unstoppable": "Imparável"
      }
    },
    "submitCheckpoint": "Submeter ponto de verificação",
    "submitRequest": "Submeter pedido",
    "suggestionMicroLearning": "Recomendações de micro-aprendizagem",
    "suggestionQultureUp": "Aulas recomendadas QultureUp",
    "suggestionSelfHelp": "Conteúdo de autoajuda",
    "suggestionTelePortal": "Tarefas TelePortal",
    "support": {
      "footer": "Escolha sobre o que é para pedir ajuda a quem acompanha a sua mudança.",
      "openRequests": "Pedidos de apoio abertos",
      "statusInProgress": "Em progresso",
      "statusOpen": "Abrir",
      "subtitle": "Obtenha ajuda com desafios específicos",
      "title": "Precisa de apoio?"
    },
    "supportCommunication": "Comunicação",
    "supportCultural": "Adequação cultural",
    "supportDescription": "Obtenha ajuda com desafios específicos",
    "supportHelpText": "Selecione um tópico para obter recomendações personalizadas do Tonnie CoPilot ou solicite apoio humano da nossa equipa.",
    "supportHousing": "Habitação",
    "supportRequestActions": "Ações",
    "supportRequestDetails": "Detalhes do pedido de apoio",
    "supportRequestDetailsDesc": "Veja detalhes e atualizações para o seu pedido de apoio",
    "supportRequestSubmitted": "Pedido de apoio submetido! A nossa equipa irá responder em breve.",
    "supportRequestsOpen": "Pedidos abertos",
    "supportSchooling": "Educação",
    "supportTeamWillRespond": "A nossa equipa de apoio irá responder ao seu pedido em breve.",
    "supportTechnical": "Técnico",
    "supportWellbeing": "Bem-estar",
    "tabs": {
      "checkins": "Check-ins",
      "checkpoints": "Checkpoints",
      "objectives": "Objetivos",
      "overview": "Visão geral",
      "support": "Suporte"
    },
    "teamLead": "Líder de equipa",
    "thermometer": {
      "mood": "Humor",
      "settlement": "Liquidação",
      "wellbeing": "Bem-estar"
    },
    "title": "Care & apoio",
    "todaysCare": "O Care de hoje",
    "tonnieSupport": "Apoio Tonnie",
    "topic": "Tópico",
    "trust": {
      "checkpoint": {
        "how": "Ajuda a Tonnie a fornecer apoio e orientação direcionados.",
        "who": "As suas respostas são privadas. As empresas apenas veem resumos agregados.",
        "why": "Os pontos de controlo ajudam-nos a perceber como se está a adaptar e onde é necessário apoio."
      },
      "questions": {
        "how": "Ajuda-nos a identificar opções de apoio adaptadas a si.",
        "who": "As suas respostas só são visíveis para si e para o apoio Tonnie. As empresas veem tendências agregadas.",
        "why": "Fazemos estas perguntas para entender a sua adaptação atual."
      },
      "quickCheckin": {
        "how": "Ajuda-nos a personalizar o apoio e a manter a sua adaptação no caminho certo.",
        "who": "As suas respostas só são visíveis para si e para o apoio Tonnie. As empresas veem apenas tendências agregadas.",
        "why": "Check-ins rápidos ajudam-nos a entender o seu bem-estar diário e a identificar necessidades de apoio precocemente."
      },
      "results": {
        "how": "Os insights ajudam o CoPilot a dar melhores recomendações.",
        "who": "Apenas para si e para o apoio Tonnie. As empresas veem apenas tendências agregadas.",
        "why": "Os seus dados de check-in ajudam-nos a acompanhar o seu bem-estar ao longo do tempo."
      }
    },
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoadData": "Não foi possível carregar os dados Care",
    "upcoming": "Próximos",
    "updates": "Atualizações",
    "weekPulse": {
      "title": "Pulso semanal"
    },
    "welcome": {
      "description": "Care apoia-o ao longo do seu percurso de realocação. Esta configuração única leva cerca de 5 minutos no Citizen Web — depois disso, os seus check-ins diários e apoio ao bem-estar vivem aqui na aplicação.",
      "familyStep": "Família & trabalho",
      "familyStepDesc": "Acompanhe a adaptação da família, escolaridade e integração no local de trabalho",
      "letsStart": "Vamos começar",
      "settlingStep": "Acomodação",
      "settlingStepDesc": "Acompanhe a estabilidade da sua habitação e o conforto da vida diária",
      "timeEstimate": "Leva cerca de 5 minutos para completar",
      "title": "Bem-vindo ao Care",
      "wellbeingStep": "Bem-estar & social",
      "wellbeingStepDesc": "Verifique a sua saúde emocional e as suas ligações sociais"
    },
    "yourChallenge": "o seu desafio",
    "yourRating": "A sua avaliação",
    "interactions": {
      "title": "Com a sua equipa",
      "subtitle": "Chamadas e reuniões que a sua equipa de patrocinadores organizou",
      "upcoming": "Próximos",
      "past": "Feito",
      "type": {
        "call": "Chamada",
        "video_call": "Chamada de vídeo",
        "in_person_meeting": "Reunião presencial",
        "message": "Mensagem",
        "request_checkin": "Check-in"
      }
    },
    "momentum": {
      "event": {
        "checkin": "Fez check-in",
        "checkpoint": "Ponto de verificação concluído",
        "feedback": "Partilhou feedback",
        "intervention": "A sua equipa entrou em contacto",
        "generic": "Atividade Care"
      }
    },
    "zone": {
      "youToday": "O seu estado hoje",
      "forYou": "Para si",
      "yourProgress": "O seu progresso"
    },
    "assessmentDimension": {
      "baseline": "Base emocional",
      "baselineDesc": "O seu estado de espírito, energia e níveis de stress",
      "pillars": "Pilares de bem-estar",
      "pillarsDesc": "Selecione as áreas de foco que mais lhe importam",
      "preferences": "Preferências de check-in",
      "preferencesDesc": "Como e quando deseja ser apoiado"
    },
    "milesAwarded_one": "+{{count}} Mile",
    "milesAwarded_other": "+{{count}} Miles",
    "supportRequest": {
      "title": "Pedir apoio",
      "subtitle": "Diga a quem acompanha a sua mudança aquilo de que precisa.",
      "pillarLabel": "Sobre o que é?",
      "severityLabel": "Qual a urgência?",
      "descriptionLabel": "O que se passa?",
      "descriptionPlaceholder": "Por palavras suas — o que aconteceu e o que ajudaria.",
      "descriptionHint": "Pelo menos {{min}} caracteres.",
      "descriptionCount": "{{count}}/{{max}}",
      "send": "Enviar pedido",
      "sent": "O seu pedido foi enviado.",
      "failed": "O seu pedido não foi enviado. Tente novamente.",
      "waitingForConnection": "Está sem ligação — o pedido é enviado quando voltar a ter ligação.",
      "trustWhy": "Para que o pedido chegue às pessoas certas, com o que precisam para ajudar.",
      "trustWho": "Si e a empresa que patrocina este percurso, se partilhar o Care com ela.",
      "trustHow": "O pedido fica guardado no Care deste percurso.",
      "validation": {
        "pillarRequired": "Escolha sobre o que é.",
        "descriptionShort": "Conte-nos um pouco mais — pelo menos {{min}} caracteres.",
        "descriptionLong": "Use no máximo {{max}} caracteres."
      }
    }
  },
  "career": {
    "achievementsSummary": "Conquistas relevantes para Career",
    "allLocations": "Todas as localizações",
    "allOpportunities": "Todas as oportunidades",
    "allTypes": "Todos os tipos",
    "apply": "Aplicar",
    "avgMatch": "Média de correspondência",
    "careerOverviewDesc": "Visão geral da sua prontidão para a carreira e perfil",
    "careerReadiness": "Prontidão Career",
    "careerReady": "Career pronto",
    "categoryCareer": "Serviços Career",
    "categoryEducation": "Educação",
    "categoryNetworking": "Networking",
    "checkBackLater": "Volte mais tarde para novas correspondências",
    "contract": "Contrato",
    "copilotAnalysis": "Análise cerebral CoPilot para {{title}}",
    "createCV": "Criar CV",
    "createOrEditCV": "Criar ou editar CV",
    "createYourFirstCV": "Crie o seu primeiro CV profissional para mostrar as suas competências",
    "cv": {
      "downloadError": "Não foi possível transferir o CV",
      "generateError": "Falha ao gerar CV"
    },
    "cvDownloaded": "CV {{format}} para {{opportunityTitle}} transferido com sucesso",
    "cvView": "Construtor de CV",
    "cvViewDescription": "Crie e gira o seu CV profissional para candidaturas a empregos",
    "cvsGenerated": "CVs gerados",
    "description": "Descubra oportunidades e faça crescer a sua carreira",
    "disableProactive": "Desativar candidaturas proativas",
    "downloadCV": "Transferir CV",
    "downloadPDF": "Transferir PDF",
    "downloadWord": "Transferir Word",
    "ecosystemPartners": "Parceiros do ecossistema",
    "editCV": "Editar CV",
    "enableProactive": "Ativar candidaturas proativas",
    "experience": "Experiência",
    "experienceMatchDesc": "A sua experiência corresponde ao papel",
    "fullTime": "A tempo inteiro",
    "gotIt": "Entendido",
    "highMatchOpportunities": "Oportunidades de alta correspondência",
    "iWantIt": "Quero isso...",
    "improveMatchText": "Considere melhorar as competências relevantes ou os níveis de língua para aumentar a sua pontuação de correspondência.",
    "languages": "Idiomas",
    "lastGenerated": "Última geração",
    "lastUpdated": "Última atualização",
    "learnMore": "Saiba mais",
    "letCompaniesFind": "Deixe as empresas encontrá-lo",
    "levelLabel": "Nível",
    "lisbon": "Lisboa",
    "location": "Localização",
    "locationMatchDesc": "A localização do trabalho corresponde às suas preferências",
    "mainRole": "Função principal",
    "match": "Correspondência",
    "matchQuality": "Qualidade da correspondência",
    "matchScore": "Pontuação de correspondência",
    "matchScoreLabel": "Pontuação de correspondência",
    "matchingOpportunities": "Oportunidades de correspondência",
    "mostRecentCV": "CV mais recente",
    "noCVsYet": "Ainda não foram criados CVs",
    "noDescription": "Nenhuma descrição disponível",
    "noOpportunities": "Nenhuma oportunidade encontrada",
    "noSavedOpportunities": "Ainda não há oportunidades guardadas",
    "notSpecified": "Não especificado",
    "opportunitiesFound": "Oportunidades encontradas",
    "opportunitiesSaved": "Oportunidades guardadas",
    "opportunitiesView": "Oportunidades",
    "opportunityRemoved": "Oportunidade removida dos guardados",
    "opportunityRequirements": "Requisitos da oportunidade",
    "opportunitySaved": "Oportunidade guardada",
    "partTime": "A tempo parcial",
    "partnerCVDesc": "Revisão e otimização de CV",
    "partnerLinguaDesc": "Cursos de línguas profissionais",
    "partnerNetworkDesc": "Eventos de networking profissional",
    "partnersDescription": "Parceiros Tonnie-Checked para acelerar o seu percurso de carreira",
    "porto": "Porto",
    "proactiveApplications": "Candidaturas proativas",
    "proactiveDescription": "Ative o seu perfil para ser visível para recrutadores e empresas à procura de talento como o seu.",
    "proactiveDisabled": "Candidaturas proativas desativadas. O seu perfil já não é visível para recrutadores.",
    "proactiveEnabled": "Candidaturas proativas ativadas! As empresas agora podem encontrá-lo.",
    "professionalCV": "CV profissional",
    "profileComplete": "Perfil completo",
    "profileCompleteness": "Completação do perfil",
    "profileLabel": "Perfil",
    "readinessLabel": "Prontidão",
    "readinessMessage": "Está bem preparado para oportunidades internacionais. Continue a melhorar as suas competências linguísticas!",
    "readyToApply": "Pronto para candidatar-se",
    "recentCVs": "CVs Recentes",
    "remote": "Remoto",
    "removeFromSaved": "Remover dos guardados",
    "requiredSkills": "Competências necessárias",
    "save": "Guardar",
    "saveOpportunitiesMessage": "Guarde oportunidades para as ver aqui mais tarde",
    "saved": "Guardado",
    "savedJobs": "Empregos guardados",
    "savedOpportunities": "Oportunidades guardadas ({{count}})",
    "savedOpportunitiesTab": "Oportunidades guardadas",
    "savedOpportunitiesTitle": "Oportunidades guardadas",
    "sharedKeyAchievements": "Conquistas chave e marcos Passport",
    "sharedProfileSnapshot": "Resumo do perfil (função, competências, experiência)",
    "sharedReadinessScore": "Pontuação de prontidão (iQulture) e desagregação MESH",
    "skills": "Competências",
    "skillsMatchDesc": "As suas competências alinham-se com os requisitos do trabalho",
    "targetCountries": "Países alvo",
    "tipsToImprove": "💡 dicas para melhorar a correspondência:",
    "title": "Career, oportunidades & criador de CV",
    "total": "Total",
    "type": "Tipo",
    "unsave": "Desguardar",
    "untitledCV": "CV Sem Título",
    "viewAllCVs": "Ver todos os CVs ({{count}})",
    "whatWillBeShared": "O que será partilhado:",
    "why": "Porquê?",
    "whyMatch": "Porquê esta correspondência?",
    "years": "anos",
    "yourCV": "O seu CV",
    "yourReadiness": "A sua prontidão",
    "highMatchCount_one": "{{count}} alta correspondência",
    "highMatchCount_other": "{{count}} altas correspondências",
    "rolesFound_one": "{{count}} função encontrada",
    "rolesFound_other": "{{count}} funções encontradas",
    "savedOpportunitiesDescription_one": "{{count}} oportunidade guardada para rever mais tarde",
    "savedOpportunitiesDescription_other": "{{count}} oportunidades guardadas para rever mais tarde"
  },
  "checkup": {
    "aboutDescription": "Esta avaliação avalia a sua prontidão em múltiplas dimensões:",
    "achievement": "Conquista",
    "additionalSkills": "Competências adicionais",
    "aiTalentSnapshot": "Instantâneo de talento AI",
    "allSet": "Está tudo pronto",
    "allSetDesc": "O seu CheckUp está completo. Agora podemos construir o seu percurso.",
    "analyzingTitle": "A analisar o seu Perfil iQulture",
    "areasToWatch": "Áreas a observar",
    "assessmentDescription": "Avalie a sua prontidão internacional",
    "assessmentHistory": "Histórico de avaliações",
    "assessmentResults": "Resultados da avaliação",
    "assessmentSubmitted": "Avaliação submetida",
    "assessmentTitle": "Avaliação CheckUp",
    "badge": {
      "explorer": "Explorador",
      "explorerTagline": "No início do seu percurso internacional",
      "globalPro": "Global Pro",
      "globalProTagline": "Pronto para o sucesso internacional",
      "risingStar": "Estrela em ascensão",
      "risingStarTagline": "A construir bases sólidas"
    },
    "badgeAlt": "{{badge}} distintivo",
    "band": {
      "noob": "NOOB",
      "potential": "POTENCIAL",
      "pro": "PRO"
    },
    "bandLabels": {
      "emerging": "Emergente",
      "growing": "Em crescimento",
      "power": "Poder",
      "strong": "Forte"
    },
    "buildJourneyCta": "Construir a meu percurso",
    "buildJourneyTitle": "Pronto para construir o seu percurso?",
    "calcTimeEstimate": "Cerca de 30 segundos",
    "calculateScore": "Calcular a minha pontuação",
    "calculating": "A calcular…",
    "calculatingAriaLabel": "A calcular a sua pontuação",
    "calculatingDesc": "A analisar as suas respostas para gerar a sua avaliação MESH personalizada...",
    "calculatingScore": "A calcular a sua pontuação…",
    "calculatingTitle": "A calcular a sua pontuação iQulture…",
    "calculationComplete": "Cálculo completo",
    "calculationError": "Falha ao iniciar o cálculo. Por favor, tente novamente.",
    "calculationTimedOut": "O cálculo do seu CheckUp excedeu o tempo limite. Por favor, inicie-o novamente.",
    "cancelConfirm": {
      "error": "Não foi possível cancelar o seu CheckUp. Por favor, tente novamente.",
      "success": "CheckUp cancelado. Pode iniciar um novo a qualquer momento."
    },
    "capture": {
      "acceptedFormats": "Aceita fotos, PDFs, documentos Word e mais",
      "backToTask": "Voltar à tarefa",
      "backToTelePortal": "Voltar ao TelePortal",
      "cameraPermissionRequired": "O acesso à câmara é necessário para digitalizar documentos.",
      "cameraScanHint": "Aponte a sua câmara para o documento para a melhor qualidade de digitalização",
      "chooseAnother": "Escolher outro",
      "fieldDocType": "Tipo de documento",
      "fieldFile": "Ficheiro",
      "removeFile": "Remover",
      "retakeCamera": "Refazer",
      "selectDocType": "Selecionar tipo de documento",
      "sourceCamera": "Digitalização com câmara",
      "sourceFiles": "Procurar ficheiros",
      "sourceGallery": "Biblioteca de fotos",
      "tapSelectDocType": "Toque para selecionar tipo de documento",
      "tryAgain": "Tente novamente",
      "uploadButton": "Carregar documento",
      "uploadFailed": "O carregamento falhou",
      "uploaded": "Documento carregado",
      "uploadedDesc": "O seu {{type}} foi carregado e anexado.",
      "uploading": "A carregar o seu documento…",
      "uploadingNote": "Isto pode levar um momento"
    },
    "chat": {
      "clickToUpload": "Clique para carregar",
      "notAtAll": "De todo",
      "typeMessage": "Escreva uma mensagem…",
      "typeYourAnswer": "Escreva a sua resposta…",
      "veryMuch": "Muito"
    },
    "checkAgain": "Verifique novamente",
    "checkAgainHelp": "Complete os requisitos acima e depois clique em 'Verifique Novamente'",
    "checkupHistory": "Histórico de CheckUp",
    "checkupHistoryDesc": "Veja as suas avaliações anteriores CheckUp",
    "companyAverage": "A média da sua empresa",
    "companyCohort": "Cohorte da empresa",
    "comparisonsDescription": "A sua pontuação comparada com os outros",
    "comparisonsTitle": "Como se compara",
    "completeMoreCheckUps": "Complete mais CheckUps para ver a sua evolução",
    "completeTitle": "Avaliação completa!",
    "conclusionDesc": "Análise completa da sua prontidão internacional",
    "congratulations": "Parabéns por Completar o Seu iQulture CheckUp!",
    "copilotGuideDescription": "Responda a perguntas sobre o seu histórico e objetivos",
    "copilotGuideTitle": "Guia CoPilot",
    "couldNotLoadResults": "Não conseguimos carregar os seus resultados CheckUp. Por favor, tente novamente.",
    "description": "Avaliação internacional abrangente de prontidão 360°",
    "didYouKnow": "Sabia que?",
    "dimensionInternational": "Experiência internacional",
    "dimensionLanguage": "Proficiência em línguas",
    "dimensionMotivation": "Motivação & mentalidade",
    "dimensionProfessional": "Histórico profissional & competências",
    "dontCloseWarning": "Por favor, não feche esta página.",
    "downloadReport": "Transferir relatório completo",
    "elapsed": "decorrido",
    "errorDescription": "Algo correu mal ao carregar o seu CheckUp. Por favor, tente novamente.",
    "errorMessage": "Falha ao calcular o seu CheckUp. Por favor, tente novamente.",
    "errorTitle": "Ops! Algo correu mal",
    "estimated": "Estimado",
    "estimatedRemaining": "~{{minutes}}m restantes",
    "estimatedTime": "Tempo estimado",
    "evaluationRadar": "Radar de avaliação",
    "exportGenerating": "A gerar exportação...",
    "exportPDFDescription": "Em produção, isto geraria um PDF com os seus resultados CheckUp.",
    "exportResults": "Exportar resultados",
    "exportSuccess": "Resultados CheckUp exportados com sucesso",
    "filePickUnavailable": "A seleção de ficheiros está atualmente indisponível.",
    "finalMessage": "Concluiu uma avaliação abrangente de 360° da sua preparação internacional. O seu distintivo {{badge}} reflete bases sólidas em motivação, adaptabilidade cultural e comunicação. Concentre-se no {{plan}} para reforçar as suas competências técnicas e estará pronto para oportunidades globais.",
    "finalScore": "Pontuação final",
    "goToCheckUp": "Ir para CheckUp",
    "goToQultureUp": "Ir para QultureUp",
    "goToTelePortal": "Ir para TelePortal",
    "greenFlags": "Sinais verdes",
    "heroMiles": "Miles CheckUp",
    "iqultureBand": "Faixa iQulture",
    "journeyStepsSubtitle": "Aqui está o que precisamos para avaliar a sua prontidão.",
    "languageTests": {
      "analyzeResult": "Carregar & analisar",
      "analyzing": "A analisar...",
      "attention": "Atenção:",
      "attentionText": "Guarde o seu resultado como captura de ecrã, ou transfira-o como PDF com texto selecionável ",
      "changeFile": "Alterar ficheiro",
      "completedTest": "Teste concluído",
      "dropHere": "Clique para selecionar o ficheiro do seu resultado",
      "englishTests": "Testes de inglês",
      "iUnderstand": "Eu entendo, continuar",
      "immediatelyAfter": "imediatamente após completar o teste",
      "importantInstructions": "Instruções importantes",
      "instructions": "Carregue o seu resultado como captura de ecrã (PNG, JPG, WEBP ou GIF), PDF com texto selecionável ou documento Word (.docx). Lemos o nível automaticamente.",
      "languageTests": "Testes de língua",
      "listening": "A ouvir",
      "lowConfidenceHint": "Detetámos um resultado, mas não conseguimos lê-lo com confiança. Por favor, reveja e confirme.",
      "modalDesc": "Adicione um resultado de teste de língua para fortalecer o seu perfil.",
      "openPlatform": "Abrir plataforma de teste",
      "openPlatformHint": "Abra a plataforma de teste para descarregar o seu certificado.",
      "portugueseTests": "Testes de português",
      "reUpload": "Recarregar",
      "readCarefully": "Por favor, leia o certificado cuidadosamente antes de carregar.",
      "reading": "Leitura",
      "readyToStart": "Pronto para fazer o teste?",
      "referenceHint": "Use um certificado recente (com menos de 2 anos).",
      "referenceImage": "Referência: Página de resultados esperados",
      "resultDetected": "Resultado detetado",
      "resultLowConfidence": "Resultado detetado — por favor confirme",
      "retakeWarning": "Já tem um resultado para este teste. Carregar um novo substituirá a pontuação anterior.",
      "sampleHint": "Certificados de exemplo: PDF, JPG, PNG.",
      "sampleResults": "Página de resultados de exemplo",
      "screenshotReminder": "Lembre-se de capturar os seus resultados",
      "screenshotReminderDetail": "Certifique-se de que o seu nome e a pontuação estão visíveis no ficheiro que carregar.",
      "speaking": "A falar",
      "stepConfirm": "Confirmar",
      "stepInstructions": "Instruções",
      "stepTakeTest": "Fazer teste",
      "stepUpload": "Carregar",
      "submitResult": "Submeter resultado",
      "submitted": "Resultado submetido!",
      "submittedHint": "Submeteu um resultado. Vamos analisá-lo e atualizar a sua pontuação em breve.",
      "supportedFormats": "Formatos suportados: PNG, JPG, WEBP, GIF, PDF (com texto selecionável), DOCX. Um PDF digitalizado ou uma imagem dentro de um ficheiro Word não pode ser lido.",
      "testOpened": "Plataforma de teste aberta num novo separador",
      "uploadFailed": "Não foi possível carregar. Por favor, tente novamente.",
      "uploadFailedError": "O carregamento falhou. Por favor, tente novamente.",
      "uploadSuccess": "Resultado do teste submetido ao seu Vault",
      "uploading": "A carregar...",
      "useThisExtension": "use esta extensão",
      "alt": {
        "screenshotPreview": "Pré-visualização da captura de ecrã",
        "reference": "Referência",
        "sampleResults": "Resultados de amostra",
        "uploadedResult": "Resultado carregado"
      },
      "failed": {
        "title": "Não conseguimos ler um resultado neste ficheiro",
        "languageMismatch": "Este certificado parece certificar uma língua diferente da deste teste. Carregue o certificado da língua deste teste.",
        "unsupportedDocument": "Não conseguimos ler este ficheiro. Carregue uma imagem PNG, JPG, WEBP ou HEIC, um PDF ou um documento Word (.docx).",
        "archiveTooLarge": "Este documento Word é demasiado grande para o conseguirmos ler. Carregue antes o resultado como imagem (PNG, JPG ou HEIC) ou PDF.",
        "docxEmpty": "Este documento Word não tem texto nem imagem que consigamos ler. Carregue antes o resultado como imagem (PNG, JPG ou HEIC) ou PDF.",
        "tooManyPages": "Este documento tem mais de {{max}} páginas. Carregue apenas as páginas que mostram o seu resultado.",
        "noLevelFound": "Não encontrámos um nível QECR (A1–C2) neste ficheiro. Confirme que o resultado mostra o seu nível e tente novamente.",
        "serviceUnavailable": "O nosso serviço de análise não conseguiu processar o ficheiro neste momento. Tente novamente dentro de alguns minutos.",
        "notCompletedHint": "Este teste só fica concluído quando for lido um nível no seu certificado."
      },
      "cefrLevel": {
        "a1": "Iniciante",
        "a2": "Elementar",
        "b1": "Intermédio",
        "b2": "Intermédio superior",
        "c1": "Avançado",
        "c2": "Proficiente",
        "native": "Falante nativo"
      },
      "notDone": "Por fazer"
    },
    "lastAssessment": "Última avaliação: {{date}}",
    "lastCheckup": "Último CheckUp",
    "legend": {
      "attention": "Atenção",
      "critical": "Crítico",
      "excellent": "Excelente",
      "good": "Bom"
    },
    "loadingAssessment": "A carregar avaliação…",
    "measureReadiness": "Meça a sua prontidão",
    "mesh": {
      "english": "Inglês / Realidade linguística",
      "englishDesc": "As suas competências linguísticas são fortes, com excelente proficiência em inglês e bom progresso em português.",
      "englishRec1": "Continue a praticar português em conversas diárias",
      "englishRec2": "Considere cursos de idiomas avançados",
      "hardSkills": "Hard skills / Competência profissional",
      "hardSkillsDesc": "A sua competência técnica é excelente e está bem alinhada com o mercado-alvo.",
      "hardSkillsRec1": "Mantenha-se atualizado com as últimas tecnologias",
      "hardSkillsRec2": "Considere certificações na sua área",
      "motivation": "Motivação",
      "motivationDesc": "A sua motivação e mentalidade em relação à realocação internacional são fortes. Demonstra objetivos claros e uma atitude positiva.",
      "motivationRec1": "Mantenha a sua atitude positiva",
      "motivationRec2": "Defina metas e marcos claros",
      "softSkills": "Soft skills & comportamentos",
      "softSkillsDesc": "Tem uma boa compreensão das diferenças culturais, mas há margem para melhorar a adaptação ao ambiente de trabalho.",
      "softSkillsRec1": "Complete QultureUp lições sobre a cultura local",
      "softSkillsRec2": "Engaje-se com comunidades locais"
    },
    "meshAnalysisDesc": "Motivação • Inglês • soft cultural • hard & outros",
    "meshAssessmentIntro": "A avaliação MESH mede os quatro pilares da prontidão para uma carreira internacional: Motivação, Inglês, Soft skills e Hard skills.",
    "meshBreakdown": "Análise de MESH",
    "meshBreakdownDesc": "A sua prontidão em Motivação, Inglês, Soft skills e Hard skills",
    "meshInfo": {
      "E": "Inglês",
      "H": "Competências técnicas",
      "M": "Motivação",
      "S": "Competências interpessoais"
    },
    "meshReadinessEvaluation": "Avaliação de prontidão MESH",
    "monthsAgo": "meses atrás",
    "motivational": {
      "questionNumber": "Pergunta {{number}}"
    },
    "nextStepsDesc": "Ações para melhorar a sua prontidão",
    "noAssessmentYet": "Nenhuma avaliação ainda",
    "noCheckUpForJourney": "Este percurso ainda não tem um CheckUp.",
    "noHistory": "Ainda não há CheckUps anteriores",
    "noResultsDesc": "Ainda não completou o seu CheckUp. Complete-o para ver a sua pontuação de prontidão.",
    "noResultsForJourneyDesc": "Este percurso ainda não tem resultados de CheckUp. Complete a avaliação para ver a sua pontuação.",
    "noResultsForJourneyTitle": "Sem resultados para este percurso",
    "noResultsTitle": "Sem resultados ainda",
    "notReadyMessage": "Conclua primeiro estes passos e depois faça o seu CheckUp.",
    "notReadyTitle": "Quase lá!",
    "now": "Agora",
    "phase": {
      "dataCollection": "Recolha de dados",
      "iqultureScoring": "Pontuação de iQulture",
      "meshAnalysis": "Análise de MESH",
      "reportGeneration": "Geração de relatório"
    },
    "photoLibraryUnavailable": "A biblioteca de fotos está atualmente indisponível.",
    "pillar": {
      "AR": {
        "brief": "As suas credenciais, certificações e aprendizagem contínua",
        "name": "Prontidão académica"
      },
      "CP": {
        "brief": "A sua eficácia geral em linguagem e comunicação",
        "name": "Proficiência em comunicação"
      },
      "CP_ENGLISH": {
        "brief": "A sua proficiência em inglês em contextos profissionais",
        "name": "Comunicação em Inglês"
      },
      "CP_NATIVE_TARGET": {
        "brief": "A sua proficiência na língua materna e nas línguas do mercado-alvo",
        "name": "Idioma nativo/Mercado-alvo"
      },
      "GPE": {
        "brief": "O seu historial de trabalho internacional/transfronteiriço",
        "name": "Experiência profissional global"
      },
      "ICM": {
        "brief": "Quão claro e comprometido está o seu plano de carreira internacional",
        "name": "Motivação internacional Career"
      },
      "MA": {
        "brief": "A sua capacidade de se adaptar e prosperar em diferentes culturas",
        "name": "Adaptabilidade multicultural"
      },
      "PRM": {
        "brief": "A sua prontidão mental e estratégias de enfrentamento para a relocação",
        "name": "Resiliência psicológica para mobilidade"
      },
      "WMF": {
        "brief": "A sua abertura a diferentes modelos de trabalho (remoto/híbrido/no local)",
        "name": "Flexibilidade no modelo de trabalho"
      }
    },
    "pillarsDesc": "Sete dimensões chave da prontidão internacional",
    "pillarsPassed": "Pilares aprovados",
    "plan90Days": "Plano de ação de 90 dias",
    "pollingError": "Falha ao verificar o status do cálculo. Por favor, tente novamente.",
    "previousScore": "A sua pontuação anterior",
    "processingInitializing": "A inicialização do cálculo de iQulture está em andamento...",
    "processingStatus": "Status do processamento",
    "processingSubtitle": "Isto pode levar até 5 minutos. Por favor, não feche esta página.",
    "processingTitle": "A analisar o seu Perfil iQulture",
    "progressTitle": "Progresso da avaliação",
    "readinessCheckError": "Falha ao verificar a prontidão. Por favor, tente novamente.",
    "readinessScore": "Receberá a sua pontuação de prontidão",
    "readyForJourney": "Está pronto para o seu percurso",
    "recommendation1Description": "Comece a aprender sobre a cultura e as normas de trabalho portuguesas",
    "recommendation1Title": "Completa a avaliação QultureUp",
    "recommendation2Description": "Obtenha a sua lista de verificação personalizada para relocação",
    "recommendation2Title": "Iniciar avaliação TelePortal",
    "recommendation3Description": "A sua pontuação de comunicação é boa, mas a prática leva à perfeição",
    "recommendation3Title": "Continuar a aprender línguas",
    "recommendations": "Recomendações",
    "recommendedNextSteps": "Próximos passos recomendados",
    "redirecting": "A redirecionar para os seus resultados...",
    "requirementMissing": "Requisito em falta",
    "requirementsTitle": "Lista de verificação de requisitos",
    "results": {
      "activateSubtitle": "O seu CheckUp está completo. Este é o seu caminho a seguir.",
      "activateTitle": "Ative o seu percurso",
      "activeJourney": "Ativo",
      "areasRequiringAttention": "Áreas que requerem atenção",
      "areasToWatch": "Áreas a observar",
      "assessedOn": "Avaliado {{date}}",
      "backToTop": "Voltar ao topo",
      "bandAttention": "Atenção",
      "bandAttentionDesc": "Em desenvolvimento — melhoria direcionada recomendada",
      "bandAttentionRange": "60-69",
      "bandCritical": "Crítico",
      "bandCriticalDesc": "Necessita de foco prioritário antes de avançar",
      "bandCriticalRange": "Abaixo de 60",
      "bandExcellent": "Excelente",
      "bandExcellentDesc": "Forte e consistente — um ativo claro",
      "bandExcellentRange": "80-100",
      "bandGood": "Bom",
      "bandGoodDesc": "Base sólida com espaço para aprimorar",
      "bandGoodRange": "70-79",
      "careDesc": "Obtenha apoio pós-chegada e assistência à integração",
      "caveat": {
        "lowMotivationSignal": "As suas respostas motivacionais foram muito breves, por isso esta pontuação é menos fiável do que as outras. Uma resposta mais completa torná-la-ia mais precisa.",
        "noMotivationData": "Não escreveu nada na avaliação motivacional, por isso não foi possível pontuar a Motivação. Complete-a e recalcule para ver esta dimensão.",
        "noPitch": "Ainda não gravou um vídeo de apresentação, por isso a Motivação baseia-se apenas nas suas respostas escritas.",
        "pitchAnalysisFailed": "Não foi possível analisar o seu vídeo de apresentação, por isso a Motivação baseia-se apenas nas suas respostas escritas.",
        "pitchHeuristicScoring": "A análise completa do seu vídeo de apresentação não esteve disponível, por isso a parte desta pontuação que dele depende é uma estimativa simplificada.",
        "pillarsEstimated": "Parte desta pontuação foi estimada com um método simplificado porque a nossa análise completa não esteve disponível.",
        "skillsInferenceEmpty": "Ainda não foi possível identificar as suas competências com o que partilhou, por isso Competências técnicas e outras não tem pontuação. Adicione as suas competências e experiência ao perfil e recalcule."
      },
      "confidence": "Confiança: {{value}}%",
      "description": "A sua avaliação de prontidão internacional",
      "doctorsRecommendation": "Recomendação do médico",
      "errorDescription": "Houve um problema ao obter os seus resultados de CheckUp. Por favor, tente novamente.",
      "errorTitle": "Não foi possível carregar os resultados",
      "examCount_one": "{{count}} exame",
      "examCount_other": "{{count}} exames",
      "explore": "Explorar",
      "freeAssessmentNote": "Avaliação gratuita concluída • Faça upgrade para aceder a todos os heróis",
      "greenFlags": "Sinais verdes",
      "growthSubtitle": "Onde o seu impulso pode acelerar",
      "growthTitle": "As suas áreas de crescimento",
      "historyTitle": "Histórico de CheckUp",
      "journeys": "Percursos",
      "meshDnaSubtitle": "Quatro pilares que definem a sua prontidão internacional",
      "meshDnaTitle": "O seu DNA MESH",
      "meshE": "Inglês & comunicação",
      "meshELbl": "Inglês",
      "meshH": "Competências técnicas e outras",
      "meshHLbl": "Competências técnicas",
      "meshM": "Motivação",
      "meshMLbl": "Motivação",
      "meshS": "Competências culturais e interpessoais",
      "meshSLbl": "Cultural",
      "moreCheckupsNeeded": "Complete mais CheckUps para ver a sua evolução ao longo do tempo",
      "navActivate": "Ativar percurso",
      "navGrowth": "As suas áreas de crescimento",
      "navHistory": "Histórico de CheckUp",
      "navMeshDna": "DNA de MESH",
      "navPillars": "Resultados da avaliação",
      "navPrescription": "Prescrição de 90 dias",
      "navStrengths": "Os seus pontos fortes",
      "nextSection": "Próximo: {{label}}",
      "notScored": "Sem pontuação",
      "overallScore": "Pontuação geral de prontidão",
      "pillarOverview": "Visão geral dos pilares",
      "pillarPerformance": "O seu desempenho em todas as dimensões de avaliação",
      "pillarTapHint": "Toque num pilar para ver o que mede",
      "pillarSubtitle": "Como um relatório de laboratório médico, cada pilar mede uma dimensão específica da sua prontidão internacional — quão preparado está para o seu percurso em outro país. Cada dimensão é pontuada de 0 a 100: quanto maior a pontuação, mais forte é essa área.",
      "pillarTitle": "Os seus resultados da avaliação",
      "positiveIndicators": "Indicadores positivos",
      "prescriptionSubtitle": "Um plano estruturado para converter potencial em desempenho",
      "prescriptionTitle": "A sua prescrição de 90 dias",
      "progressOverTime": "O seu progresso ao longo do tempo",
      "qultureupDesc": "Aumente a sua prontidão cultural com formação personalizada",
      "scaleCaption": "A sua posição na escala",
      "scaleToNext": "{{points}} pts para {{tier}}",
      "scaleMax": "Chegou ao nível máximo",
      "readingResults": "A ler os seus resultados",
      "recommendedNextSteps": "Próximos passos recomendados",
      "scoreOutOf": "/ 100",
      "scrollBackTop": "Desça para o topo",
      "scrollToNext": "Desça para a secção seguinte",
      "strengthsSubtitle": "O que faz o seu perfil destacar-se",
      "strengthsTitle": "Os seus pontos fortes",
      "teleportalDesc": "Comece o seu plano de mobilidade com verificação de documentos e orientação de visto",
      "title": "Resultados de CheckUp",
      "topHardSkills": "Principais competências técnicas",
      "topSoftSkills": "Principais competências interpessoais",
      "unlockJourney": "Desbloqueie o seu percurso completo",
      "snapshotFallback": "A sua avaliação de iQulture está completa.",
      "badgeReasonFallback": "Com base no seu desempenho geral de avaliação.",
      "provisional": {
        "label": "Provisório",
        "body": "Faltam alguns dos seus dados, por isso esta é a pontuação mínima possível. Com os dados completos, pode chegar a {{max}}.",
        "unlock": {
          "M": "Complete as respostas de Motivação ou grave o seu pitch — até +{{gain}}",
          "E": "Adicione os seus níveis de idiomas, incluindo a língua materna — até +{{gain}}",
          "S": "Complete o CheckUp para medirmos as suas soft skills — até +{{gain}}",
          "H": "Adicione as suas competências e experiência ao perfil — até +{{gain}}"
        }
      },
      "skillsNotEnoughEvidence": "Ainda não há informação suficiente para medir estas competências."
    },
    "resultsError": "Não foi possível obter os resultados. Por favor, tente novamente.",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer avaliação na web",
    "retakeOnWebDesc": "Para refazer a sua avaliação CheckUp, use o Portal Web Citizen num browser de desktop.",
    "score": "Pontuação",
    "scoreEvolution": "Evolução da pontuação",
    "scrollForDetails": "Desça para detalhes",
    "scrollForDetailsHint": "Toque para descer para os seus resultados detalhados",
    "selected": "Selecionado",
    "selectedCheckupDetails": "Detalhes selecionados de CheckUp",
    "shareResults": "Partilhar resultados",
    "similarProfiles": "Perfis Similares",
    "somethingWentWrong": "Algo correu mal",
    "startFailed": "Não foi possível iniciar CheckUp. Por favor, tenta novamente.",
    "startOnWeb": "Começar no Citizen Web",
    "startOnWebDesc": "Complete a sua primeira avaliação CheckUp no Portal Web Citizen para a experiência completa.",
    "step": {
      "assistantChat": "Chat de assistente",
      "assistantChatMsg": "Converse com o nosso assistente de IA para nos dar mais contexto sobre a sua situação.",
      "chatDone": "Chat completo",
      "chatDoneDesc": "Terminou a conversa com o assistente.",
      "journeyInstance": "Configuração do percurso",
      "journeyInstanceMsg": "Diga-nos para onde está a mudar e de onde vem.",
      "languageTests": "Testes de língua",
      "languageTestsDesc": "Adicione resultados de proficiência em línguas.",
      "languageTestsMsg": "Carregue os seus certificados de língua para fortalecer a sua pontuação de prontidão.",
      "motivational": "Motivação",
      "motivationalMsg": "Ajude-nos a entender o que está a impulsionar a sua mudança.",
      "onboarding": "Informações básicas do perfil",
      "onboardingMsg": "Detalhes rápidos sobre si para personalizar o resto.",
      "pitch": "Vídeo de apresentação",
      "pitchMsg": "Grave um vídeo de 30 segundos a apresentar-se.",
      "pitchRecorded": "Pitch gravado",
      "pitchRecordedDesc": "O seu vídeo de pitch está pronto para revisão.",
      "videos": "Ver vídeos",
      "videosMsg": "Veja alguns vídeos curtos sobre o seu destino.",
      "profileComplete": "Complete o seu perfil",
      "profileCompleteMsg": "A sua pontuação precisa de alguns dados de identificação.",
      "profileCompletePercentMsg": "O seu perfil está {{percent}}% completo. A pontuação precisa dele todo."
    },
    "stuckMessage": "Em apuros? Deixe-nos saber — podemos ajudar.",
    "suggestedNextSteps": "Próximos passos sugeridos",
    "tabAnalysis": "Análise",
    "tabComparisons": "Comparações",
    "tabConclusion": "Conclusão 360°",
    "tabHistory": "Histórico",
    "tabInsights": "Insights",
    "tabMESH": "Análise de MESH",
    "tabNextSteps": "Próximos passos",
    "tabOverview": "Visão Geral",
    "tabPillars": "Pilares de avaliação",
    "tabSkills": "Termómetro de competências",
    "tapToCollapse": "Toque para colapsar",
    "tapToReadMore": "Toque para ler o resumo completo",
    "tip": {
      "1": "A sua pontuação MESH mede Motivação, Inglês, Soft skills e Hard skills — os 4 pilares da prontidão para uma carreira internacional.",
      "2": "Os emblemas iQulture (Explorador, Estrela em Ascensão, Profissional Global) refletem a sua preparação geral para trabalhar no estrangeiro.",
      "3": "A nossa IA analisa o seu vídeo de pitch, proficiência linguística e respostas motivacionais para construir um perfil 360°.",
      "4": "O seu plano de ação personalizado de 90 dias incluirá passos específicos para melhorar as suas áreas mais fracas.",
      "5": "A Avaliação de Risco Cultural identifica potenciais desafios de adaptação e como superá-los."
    },
    "title": "iQulture CheckUp",
    "tonnieDatabaseAverage": "Média da base de dados da Tonnie",
    "top10Hard": "Top 10 competências técnicas",
    "top10Soft": "Top 10 competências interpessoais",
    "topHardSkills": "Principais competências técnicas",
    "topSoftSkills": "Principais competências interpessoais",
    "triggerFailed": "Falha ao iniciar o cálculo. Por favor, tente novamente.",
    "tryAgain": "Tente novamente",
    "unableToLoad": "Não foi possível carregar CheckUp",
    "unknownDate": "Data desconhecida",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "vsAverage": "vs média",
    "vsPrevious": "vs anterior",
    "welcome": {
      "chatStep": "Conversa guiada",
      "chatStepDesc": "Responda a algumas perguntas com o nosso assistente de IA",
      "description": "Descubra a sua prontidão internacional com a nossa avaliação MESH. Avalia a sua Motivação, Inglês, Soft Skills e Hard Skills para gerar a sua pontuação iQulture personalizada.",
      "languageStep": "Verificação de língua",
      "languageStepDesc": "Avaliação rápida das suas competências linguísticas",
      "letsStart": "Vamos começar",
      "pitchStep": "Vídeo de pitch curto",
      "pitchStepDesc": "Grave um breve vídeo a apresentar-se",
      "timeEstimate": "Leva cerca de 10-15 minutos para completar",
      "title": "Bem-vindo ao CheckUp"
    },
    "scoreOutOfSuffix": "/100",
    "missingSteps": {
      "journey_instance": {
        "label": "Instância do percurso",
        "message": "Tem de criar um percurso antes de iniciar o seu CheckUp."
      },
      "onboarding_complete": {
        "label": "Integração",
        "message": "Complete a sua integração de perfil para desbloquear CheckUp."
      },
      "assistant_chat": {
        "label": "Chat de avaliação",
        "message": "Complete a conversa de avaliação guiada."
      },
      "motivational_answers": {
        "label": "Perguntas motivacionais",
        "message": "Responda às perguntas motivacionais sobre os seus objetivos."
      },
      "pitch_video": {
        "label": "Vídeo de apresentação",
        "message": "Grave ou carregue o seu vídeo de apresentação."
      },
      "generic": "Este passo precisa ser concluído.",
      "videos_watched": {
        "label": "Ver os vídeos de introdução",
        "message": "Uma breve introdução antes de começar."
      },
      "language_tests": {
        "label": "Testes de línguas",
        "message": "Diga-nos que línguas fala e a que nível."
      },
      "profile_complete": {
        "label": "Complete o seu perfil",
        "message": "A sua pontuação precisa de alguns dados de identificação. Complete-os no portal web."
      }
    },
    "reuse": {
      "title": "Reutilizar o seu resultado guardado?",
      "subtitle": "Já concluiu este teste. Reutilize-o nesta avaliação ou faça um novo.",
      "takenOn": "Feito a {{date}}",
      "reuseCta": "Reutilizar este resultado",
      "newCta": "Fazer um novo",
      "daysLeft_one": "{{count}} dia restante",
      "daysLeft_other": "{{count}} dias restantes"
    },
    "calculatingPct": "A calcular… {{pct}}%",
    "requestedBy": {
      "badge": "Pedido por {{company}}",
      "purpose": "A sua pontuação define as recomendações que recebe e o apoio que lhe podem dar.",
      "whatTheySee": "Veem a sua pontuação e a sua preparação, nunca as suas respostas."
    },
    "reusedFrom": {
      "title": "Reutilizado do seu CheckUp para {{destination}}",
      "body": "As suas respostas e os testes ainda válidos foram aproveitados desse CheckUp. A sua pontuação é calculada de novo para este destino."
    },
    "profileGate": {
      "progressLabel": "Perfil",
      "percent": "{{percent}}%",
      "cta": "Completar perfil",
      "field": {
        "name": "Nome",
        "dateOfBirth": "Data de nascimento",
        "nationality": "Cidadania",
        "currentCountry": "País atual",
        "currentCity": "Cidade atual",
        "phone": "Telefone"
      },
      "fieldMissing": "Em falta"
    },
    "readyToCalculate": {
      "title": "A sua avaliação está completa",
      "description": "Está tudo respondido. A sua pontuação ainda não foi gerada.",
      "ctaTitle": "Gerar a sua pontuação",
      "ctaDescription": "Um toque. Demora alguns minutos, e enviamos-lhe uma notificação quando a sua pontuação estiver pronta.",
      "cta": "Calcular a minha pontuação"
    },
    "awaitingProfile": {
      "assessmentDone": "Avaliação concluída",
      "assessmentDoneDetail": "Todos os passos estão feitos — as suas respostas estão guardadas.",
      "calculateLocked": "Complete o seu perfil para desbloquear a sua pontuação."
    },
    "calculationFailedTitle": "Não foi possível calcular a sua pontuação",
    "calculationFailedBody": "As suas respostas estão guardadas. Calcule a pontuação de novo — demora cerca de um minuto.",
    "calculateAgain": "Calcular de novo"
  },
  "common": {
    "active": "Ativo",
    "appName": "Tonnie Citizen",
    "appShortName": "Citizen",
    "applicationError": "Erro de aplicação",
    "availableSoon": "Disponível em breve",
    "back": "Voltar",
    "backToDashboard": "Voltar ao painel",
    "cancel": "Cancelar",
    "clear": "Limpar",
    "clearFilters": "Limpar filtros",
    "close": "Fechar",
    "collapse": "Colapsar",
    "comingSoon": "Em breve",
    "completed": "Completo",
    "confirm": "Confirmar",
    "continue": "Continuar",
    "continueAssessment": "Continuar avaliação",
    "continueSetup": "Continuar configuração",
    "copiedToClipboard": "{{label}} copiado para a área de transferência",
    "copilot": "CoPilot",
    "copyFailed": "Falha ao copiar {{label}}",
    "countries": {
      "AE": "Emirados Árabes Unidos",
      "AU": "Austrália",
      "BR": "Brasil",
      "CA": "Canadá",
      "CN": "China",
      "DE": "Alemanha",
      "ES": "Espanha",
      "FR": "França",
      "GB": "Reino Unido",
      "IE": "Irlanda",
      "IN": "Índia",
      "IT": "Itália",
      "JP": "Japão",
      "KR": "Coreia do Sul",
      "NL": "Países Baixos",
      "NZ": "Nova Zelândia",
      "PT": "Portugal",
      "SG": "Cingapura",
      "UK": "Reino Unido",
      "US": "Estados Unidos",
      "AF": "Afeganistão",
      "AL": "Albânia",
      "DZ": "Argélia",
      "AD": "Andorra",
      "AO": "Angola",
      "AG": "Antígua e Barbuda",
      "AR": "Argentina",
      "AM": "Arménia",
      "AT": "Áustria",
      "AZ": "Azerbaijão",
      "BS": "Baamas",
      "BH": "Barém",
      "BD": "Bangladeche",
      "BB": "Barbados",
      "BY": "Bielorrússia",
      "BE": "Bélgica",
      "BZ": "Belize",
      "BJ": "Benim",
      "BT": "Butão",
      "BO": "Bolívia",
      "BA": "Bósnia e Herzegovina",
      "BW": "Botsuana",
      "BN": "Brunei",
      "BG": "Bulgária",
      "BF": "Burquina Faso",
      "BI": "Burundi",
      "CV": "Cabo Verde",
      "KH": "Camboja",
      "CM": "Camarões",
      "CF": "República Centro-Africana",
      "TD": "Chade",
      "CL": "Chile",
      "CO": "Colômbia",
      "KM": "Comores",
      "CG": "Congo",
      "CD": "Congo (RDC)",
      "CR": "Costa Rica",
      "CI": "Costa do Marfim",
      "HR": "Croácia",
      "CU": "Cuba",
      "CY": "Chipre",
      "CZ": "Chéquia",
      "DK": "Dinamarca",
      "DJ": "Jibuti",
      "DM": "Domínica",
      "DO": "República Dominicana",
      "EC": "Equador",
      "EG": "Egito",
      "SV": "Salvador",
      "GQ": "Guiné Equatorial",
      "ER": "Eritreia",
      "EE": "Estónia",
      "SZ": "Essuatíni",
      "ET": "Etiópia",
      "FJ": "Fiji",
      "FI": "Finlândia",
      "GA": "Gabão",
      "GM": "Gâmbia",
      "GE": "Geórgia",
      "GH": "Gana",
      "GR": "Grécia",
      "GD": "Granada",
      "GT": "Guatemala",
      "GN": "Guiné",
      "GW": "Guiné-Bissau",
      "GY": "Guiana",
      "HT": "Haiti",
      "HN": "Honduras",
      "HK": "Hong Kong",
      "HU": "Hungria",
      "IS": "Islândia",
      "ID": "Indonésia",
      "IR": "Irão",
      "IQ": "Iraque",
      "IL": "Israel",
      "JM": "Jamaica",
      "JO": "Jordânia",
      "KZ": "Cazaquistão",
      "KE": "Quénia",
      "KI": "Quiribáti",
      "KW": "Koweit",
      "KG": "Quirguistão",
      "LA": "Laos",
      "LV": "Letónia",
      "LB": "Líbano",
      "LS": "Lesoto",
      "LR": "Libéria",
      "LY": "Líbia",
      "LI": "Listenstaine",
      "LT": "Lituânia",
      "LU": "Luxemburgo",
      "MO": "Macau",
      "MG": "Madagáscar",
      "MW": "Maláui",
      "MY": "Malásia",
      "MV": "Maldivas",
      "ML": "Mali",
      "MT": "Malta",
      "MH": "Ilhas Marshall",
      "MR": "Mauritânia",
      "MU": "Maurícia",
      "MX": "México",
      "FM": "Micronésia",
      "MD": "Moldávia",
      "MC": "Mónaco",
      "MN": "Mongólia",
      "ME": "Montenegro",
      "MA": "Marrocos",
      "MZ": "Moçambique",
      "MM": "Mianmar",
      "NA": "Namíbia",
      "NR": "Nauru",
      "NP": "Nepal",
      "NI": "Nicarágua",
      "NE": "Níger",
      "NG": "Nigéria",
      "KP": "Coreia do Norte",
      "MK": "Macedónia do Norte",
      "NO": "Noruega",
      "OM": "Omã",
      "PK": "Paquistão",
      "PW": "Palau",
      "PS": "Palestina",
      "PA": "Panamá",
      "PG": "Papua-Nova Guiné",
      "PY": "Paraguai",
      "PE": "Peru",
      "PH": "Filipinas",
      "PL": "Polónia",
      "QA": "Catar",
      "RO": "Roménia",
      "RU": "Rússia",
      "RW": "Ruanda",
      "KN": "São Cristóvão e Neves",
      "LC": "Santa Lúcia",
      "VC": "São Vicente e Granadinas",
      "WS": "Samoa",
      "SM": "São Marinho",
      "ST": "São Tomé e Príncipe",
      "SA": "Arábia Saudita",
      "SN": "Senegal",
      "RS": "Sérvia",
      "SC": "Seicheles",
      "SL": "Serra Leoa",
      "SK": "Eslováquia",
      "SI": "Eslovénia",
      "SB": "Ilhas Salomão",
      "SO": "Somália",
      "ZA": "África do Sul",
      "SS": "Sudão do Sul",
      "LK": "Sri Lanca",
      "SD": "Sudão",
      "SR": "Suriname",
      "SE": "Suécia",
      "CH": "Suíça",
      "SY": "Síria",
      "TW": "Taiwan",
      "TJ": "Tajiquistão",
      "TZ": "Tanzânia",
      "TH": "Tailândia",
      "TL": "Timor-Leste",
      "TG": "Togo",
      "TO": "Tonga",
      "TT": "Trindade e Tobago",
      "TN": "Tunísia",
      "TR": "Turquia",
      "TM": "Turquemenistão",
      "TV": "Tuvalu",
      "UG": "Uganda",
      "UA": "Ucrânia",
      "UY": "Uruguai",
      "UZ": "Usbequistão",
      "VU": "Vanuatu",
      "VA": "Cidade do Vaticano",
      "VE": "Venezuela",
      "VN": "Vietname",
      "YE": "Iémen",
      "ZM": "Zâmbia",
      "ZW": "Zimbabué"
    },
    "delete": "Eliminar",
    "destination": "Destino",
    "discard": "Descartar",
    "discardChanges": "Descartar alterações?",
    "discardChangesBody": "As suas alterações não guardadas serão perdidas.",
    "discardProgress": "Descartar progresso?",
    "discardProgressBody": "O seu progresso neste ecrã será perdido.",
    "dismiss": "Dispensar",
    "done": "Feito",
    "download": "Descarregar",
    "earned": "Ganho",
    "earnedDateMiles": "Ganho {{date}} • +{{miles}} Miles",
    "edit": "Editar",
    "email": "Email",
    "error": "Erro",
    "errorTitle": "Erro",
    "estimatedTime": "Tempo estimado",
    "expand": "Expandir",
    "familyWillLose": "Os seus membros da família perderão",
    "filter": "Filtrar",
    "free": "Gratuito",
    "goBack": "Voltar",
    "heroes": {
      "care": "Care",
      "checkup": "CheckUp",
      "qultureup": "QultureUp",
      "teleportal": "TelePortal",
      "inout": "InOut"
    },
    "inProgress": "Em progresso",
    "info": "Info",
    "keepEditing": "Continuar a editar",
    "keepFamily": "Manter família",
    "keepPro": "Manter Pro",
    "loading": "A carregar...",
    "locked": "Bloqueado",
    "logout": "Sair",
    "miles": "Miles",
    "minutes": "minutos",
    "more": "mais",
    "next": "Próximo",
    "no": "Não",
    "notAvailable": "Não disponível",
    "of": "de",
    "openInApp": "Abrir na app",
    "optional": "Opcional",
    "origin": "Origem",
    "other": "Outro",
    "page": "Página",
    "pending": "Pendente",
    "plan": {
      "basic": "Básico",
      "pro": "Pro"
    },
    "pleaseRetryLater": "Por favor, tente novamente mais tarde.",
    "previous": "Anterior",
    "progress": "Progresso",
    "refresh": "Atualizar",
    "remove": "Remover",
    "reset": "Reiniciar",
    "resumeWhereYouLeftOff": "Retomar de onde parou",
    "retry": "Tentar novamente",
    "routeSrLabel": "{{origin}} para {{destination}}",
    "review": "Revisão",
    "save": "Guardar",
    "selectLanguage": "Selecionar idioma",
    "send": "Enviar",
    "settings": "Definições",
    "skip": "Saltar",
    "soon": "Em breve",
    "submit": "Submeter",
    "success": "Sucesso",
    "successTitle": "Sucesso",
    "time": {
      "daysAgo": "Há {{n}}d",
      "hoursAgo": "Há {{n}}h",
      "minutesAgo": "Há {{n}}m",
      "monthsAgo": "Há {{n}}mo",
      "now": "agora mesmo",
      "weeksAgo": "Há {{n}}w",
      "yesterday": "ontem"
    },
    "to": "Para",
    "toast": {
      "documentUploaded": "Documento carregado",
      "moodFailed": "Não foi possível guardar o humor, tente novamente",
      "moodRecorded": "Humor registado",
      "settingFailed": "Não foi possível atualizar a configuração",
      "settingSaved": "Configuração guardada",
      "somethingWentWrong": "Algo correu mal, por favor tente novamente",
      "taskCompleted": "Tarefa concluída",
      "taskFailed": "Não foi possível atualizar a tarefa",
      "taskReopened": "Tarefa reaberta"
    },
    "today": "Hoje",
    "tonnieChecked": "Tonnie-Verificado",
    "traveler": "Viajante",
    "trust": {
      "howItHelps": "Como isto o ajuda",
      "tapToSee": "Toque para ver como protegemos os seus dados",
      "whoCanSee": "Quem pode ver isto",
      "whyAsking": "Por que estamos a perguntar",
      "yourDataProtected": "Os seus dados estão protegidos"
    },
    "tryAgain": "Tente novamente",
    "upload": "Carregar",
    "uploading": "A carregar…",
    "view": "Ver",
    "viewAll": "Ver tudo",
    "welcome": "Bem-vindo",
    "yes": "Sim",
    "yesterday": "Ontem",
    "youWillLose": "Perderá acesso a",
    "beta": {
      "bannerMessage": "Acesso antecipado — ajuda a moldar a Tonnie 💜",
      "bannerMessageMobile": "Acesso antecipado — evolui com a Tonnie 💜",
      "bannerCta": "Dar feedback"
    },
    "openActionTitle": "Abrir {{action}}",
    "copy": "Copiar",
    "network": {
      "a11y": {
        "retry": "Tentar novamente solicitações falhadas",
        "dismiss": "Desconsiderar banner de erro de rede",
        "showDetails": "Mostrar detalhes do erro",
        "hideDetails": "Ocultar detalhes do erro",
        "copy": "Copiar detalhes do erro para a área de transferência",
        "dismissOffline": "Fechar o aviso de falta de ligação"
      },
      "hideDetails": "Ocultar detalhes",
      "detailsCount": "Detalhes · {{count}}",
      "noDetails": "Nenhum detalhe capturado ainda.",
      "copy": {
        "unstable": {
          "title": "A ligação está instável",
          "subtitle": "Pausámos as tentativas automáticas para poupar bateria. Toque em Tentar Novamente para tentar novamente.{{countHint}}"
        },
        "network": {
          "title": "Não conseguimos alcançar o servidor",
          "subtitle": "Verifique a sua ligação à internet.{{countHint}}"
        },
        "timeout": {
          "title": "Ligação lenta",
          "subtitle": "As solicitações estão a demorar mais do que o habitual.{{countHint}}"
        },
        "server": {
          "title": "Algo correu mal",
          "subtitle": "A nossa equipa foi notificada. Tente novamente daqui a pouco.{{countHint}}"
        },
        "default": {
          "title": "Problema de ligação",
          "subtitle": "Estamos a ter problemas para carregar os seus dados.{{countHint}}"
        },
        "countHint_one": " ({{count}} pedido falhado)",
        "countHint_other": " ({{count}} pedidos falhados)"
      },
      "offline": {
        "title": "Está sem ligação à internet",
        "subtitle": "Está a ver o que já tinha sido carregado. O que guardar é enviado quando voltar a ter ligação; o CoPilot e os envios de ficheiros precisam de ligação."
      }
    },
    "apiError": {
      "network": "Não conseguimos chegar ao servidor. Verifique a sua ligação.",
      "timeout": "A solicitação demorou demasiado. Tentaremos novamente automaticamente.",
      "unauthorized": "A sua sessão expirou. Por favor, inicie sessão novamente.",
      "forbidden": "Não tem permissão para isso.",
      "notFound": "Recurso não encontrado.",
      "badRequest": "Algo na solicitação estava inválido.",
      "serverError": "Algo correu mal do nosso lado. Estamos a investigar.",
      "unknown": "Algo correu mal."
    },
    "relativeTime": {
      "justNow": "Agora mesmo",
      "minutesAgo_one": "Há {{count}} minuto atrás",
      "minutesAgo_other": "Há {{count}} minutos atrás",
      "hoursAgo_one": "Há {{count}} hora atrás",
      "hoursAgo_other": "Há {{count}} horas atrás",
      "daysAgo_one": "Há {{count}} dia atrás",
      "daysAgo_other": "Há {{count}} dias atrás"
    },
    "device": {
      "unknown": "Dispositivo desconhecido",
      "mobile": "Móvel",
      "desktop": "Desktop"
    },
    "browser": {
      "unknown": "Browser desconhecido"
    },
    "location": {
      "unknown": "Localização desconhecida"
    },
    "searchCountry": "Pesquisar país...",
    "noCountryFound": "Nenhum país encontrado.",
    "phoneCode": "Código",
    "searchPhoneCode": "Pesquisar código de telefone...",
    "noPhoneCodeFound": "Nenhum código de telefone encontrado.",
    "untitled": "Sem título",
    "unassigned": "Não atribuído",
    "unknown": "Desconhecido",
    "member": "Membro",
    "phoneCountryCodeLabel": "Indicativo do país",
    "pageOf": "Página {{page}} de {{total}}",
    "pagination": "Páginas",
    "daysAgo_one": "Há {{count}} dia",
    "daysAgo_other": "Há {{count}} dias",
    "rewardMiles_one": "Recompensa: {{count}} Mile",
    "rewardMiles_other": "Recompensa: {{count}} Miles",
    "removeItem": "Remover {{name}}",
    "milesGained_one": "+{{miles}} Mile",
    "milesGained_other": "+{{miles}} Miles",
    "aiBadge": "IA",
    "list": {
      "two": "{{first}} e {{second}}"
    },
    "heroTabs": {
      "label": "Secções de {{hero}}",
      "strip": "Secções",
      "scrollPrevious": "Mostrar as secções anteriores",
      "scrollNext": "Mostrar mais secções"
    },
    "timeRange": "{{from}}–{{to}}",
    "dateFormat": {
      "day": "dd",
      "month": "mm",
      "year": "aaaa"
    },
    "openSettings": "Abrir Definições",
    "choosePhotoInstead": "Escolher uma fotografia",
    "photoLibraryUnavailable": "Não foi possível abrir as suas fotografias.",
    "aiUnavailable": {
      "title": "Algumas funcionalidades estão temporariamente indisponíveis",
      "description": "Isto precisa da IA da Tonnie, que não consegue responder neste momento. Estamos a tentar novamente — tudo o resto na Tonnie funciona normalmente.",
      "retry": "Tentar novamente"
    }
  },
  "copilot": {
    "beta": {
      "badge": "Beta",
      "tooltipTitle": "Tonnie CoPilot está em beta",
      "tooltipBody": "Estamos a melhorá-lo ativamente — classifique as respostas com 👍 ou 👎 para nos ajudar a torná-lo melhor.",
      "ariaLabel": "Sobre o beta de Tonnie CoPilot"
    },
    "action": {
      "dismiss": "Dispensar",
      "goTo": "Ir para",
      "open": "Abrir"
    },
    "aiDisclaimer": "CoPilot usa IA. As respostas podem não ser sempre precisas.",
    "answered": "Respondido",
    "answersSubmitted": "As suas respostas foram submetidas",
    "askAnything": "Pergunte qualquer coisa...",
    "billingPage": "Página de faturação",
    "brainAssessment": {
      "errorTitle": "Não foi possível carregar perguntas",
      "evaluating": {
        "subtitle": "A nossa IA está a verificar a sua resposta",
        "title": "A avaliar a sua resposta…"
      },
      "feedback": {
        "correct": "Correto!",
        "incorrectEncouragement": "Espere um momento — verá este conceito novamente.",
        "incorrectHeadline": "Quase — aqui está a resposta",
        "movingOn": "A passar para a próxima pergunta…",
        "next": "Próxima pergunta",
        "theAnswerIs": "A resposta é"
      },
      "level": {
        "advanced": {
          "label": "Avançado",
          "desc_one": "Excelente! {{count}} missão está marcada como opcional.",
          "desc_other": "Excelente! {{count}} missões estão marcadas como opcionais."
        },
        "beginner": {
          "desc": "Está no início do seu percurso! Todas as lições estão desbloqueadas e prontas para si.",
          "label": "Iniciante"
        },
        "intermediate": {
          "label": "Intermédio",
          "desc_one": "Ótimo conhecimento! {{count}} missão de iniciante está marcada como opcional.",
          "desc_other": "Ótimo conhecimento! {{count}} missões de iniciante estão marcadas como opcionais."
        }
      },
      "loading": "A carregar perguntas de avaliação…",
      "noQuestions": "Nenhuma pergunta disponível para este mundo.",
      "question": {
        "next": "Próxima pergunta",
        "openAnswerHint": "A sua resposta será avaliada pela IA. Leve o seu tempo!",
        "openAnswerCounter": "{{count}} / {{max}} caracteres",
        "openAnswerMinHint": "Mínimo {{min}} caracteres ({{remaining}} para ir)",
        "openAnswerPlaceholder": "Escreva a sua resposta aqui…",
        "submitFinal": "Submeter & ver resultados"
      },
      "results": {
        "continue": "Continuar",
        "correct": "Correto",
        "questionDetails": "Detalhes da pergunta",
        "retake": "Refazer",
        "score": "Pontuação",
        "total": "Total",
        "yourAnswer": "A sua resposta",
        "skipNote_one": "{{count}} missão será marcada como opcional para o seu nível. Pode ainda concluí-la para ganhar Miles.",
        "skipNote_other": "{{count}} missões serão marcadas como opcionais para o seu nível. Pode ainda concluí-las para ganhar Miles."
      }
    },
    "brainSubtitle": "Powered by Tonnie Brain",
    "bringFamily": "Está a trazer a sua família?",
    "bringingFamilyNoProgram": "A trazer família (sem programa)",
    "cameraError": "Erro de câmara",
    "cameraErrorTitle": "Câmara indisponível",
    "cameraPermissionDenied": "Permissão da câmara negada. Permita o acesso à câmara no seu browser para gravar um vídeo.",
    "chatLog": "Mensagens de chat",
    "playVideo": "Reproduzir vídeo",
    "clickToPlay": "Clique para começar o vídeo",
    "close": "Fechar CoPilot",
    "confidence": "Confiança",
    "contextualGreeting": "Olá! Sou o Tonnie CoPilot, o seu assistente de IA contextual. {{context}}O que gostaria de saber?",
    "couldImprove": "Poderia melhorar",
    "createMyJourney": "Criar a meu percurso",
    "dailyQuotaReached": "Quota diária atingida",
    "destination": "Para onde vai?",
    "disclaimer": "As suas respostas são privadas e usadas apenas para personalizar o seu percurso.",
    "errorLoadingQuestions": "Erro ao carregar perguntas",
    "errorTitle": "Algo correu mal",
    "familyAddon": "Add-on Familiar incluído",
    "familyComingSoonNote": "O Programa Familiar estará disponível em breve. Por agora, o seu percurso está configurado para uso individual.",
    "familyConfig": "Configuração familiar",
    "familyFeature1": "Convidar membros da família (Companheiro & Membros da Família)",
    "familyFeature2": "Controlar permissões de acesso por herói",
    "familyFeature3": "Acompanhar o progresso consciente do agregado familiar",
    "familyFeature4": "Gerir o percurso da família em conjunto",
    "familyJoinQuestion": "Os membros da família vão juntar-se a si neste percurso?",
    "familyJoining": "Os membros da família vão juntar-se ao seu percurso",
    "familyProgramAddon": "Add-on do programa familiar",
    "familyProgramDesc": "Gerir o percurso da sua família em conjunto com acesso partilhado e acompanhamento de progresso",
    "familyProgramEnabled": "Programa familiar ativado",
    "findings": {
      "emptyProfile": "O seu perfil ainda não tem quaisquer descobertas.",
      "expand": "Expandir",
      "looksGood": "Parece bom",
      "profile": "Perfil",
      "profileIntro": "Aqui está o que reunimos sobre o seu perfil a partir das suas respostas.",
      "profileTitle": "Descobertas do perfil"
    },
    "fixErrors": "Corrigir erros",
    "formSubmittedNote": "O seu formulário foi submetido. Obrigado!",
    "goBack": "Voltar",
    "greeting": "Olá! Sou o Tonnie CoPilot, o seu assistente de IA. {{context}}O que gostaria de saber?",
    "guide": {
      "newMessages": "Novas mensagens",
      "typeHere": "Escreva aqui...",
      "avatarAlt": "CoPilot assistente de IA",
      "aria": {
        "stepOf": "Passo {{step}} de {{total}}"
      },
      "taskFallback": "Avaliação"
    },
    "guideCompleted": "Guia concluído",
    "guideCompletedDesc": "Concluiu este guia.",
    "guideTitle": "Guia Tonnie CoPilot",
    "household": {
      "addChild": "Adicionar criança",
      "addPet": "Adicionar animal de estimação",
      "cat": "Gato",
      "child": "Criança",
      "childN": "Criança {{n}}",
      "children": "Crianças",
      "childrenDetails": "Conte-nos sobre cada criança que está a mudar-se consigo.",
      "description": "Conte-nos quem está a mudar-se consigo para que possamos personalizar o seu percurso.",
      "dog": "Cão",
      "hasPassport": "Tem passaporte",
      "name": "Nome",
      "namePlaceholder": "Nome completo",
      "nationality": "Nacionalidade",
      "other": "Outro",
      "partner": "Parceiro",
      "partnerDetails": "Conte-nos sobre o seu parceiro.",
      "pet": "Animal de estimação",
      "petN": "Animal de estimação {{n}}",
      "petName": "Nome do animal de estimação",
      "petNamePlaceholder": "Qual é o nome do seu animal de estimação?",
      "petVaccination": "Vacinações em dia",
      "pets": "Animais de estimação",
      "petsDetails": "Conte-nos sobre cada animal de estimação que está a mudar-se consigo.",
      "relocating": "A mudar-se comigo",
      "selectCountry": "Selecionar país",
      "species": "Espécie",
      "title": "O seu agregado familiar",
      "vaccinationOk": "Vacinações OK",
      "prefilledFromOnboarding": "Pré-preenchido com as respostas que deu no registo. Verifique e altere o que for diferente — nada é guardado até confirmar.",
      "you": "Eu"
    },
    "hybrid": {
      "complete": "Tudo feito! As suas respostas foram registadas.",
      "error": "Algo correu mal. Vamos tentar novamente.",
      "escapeHatch": "Prefiro não responder a isto",
      "placeholder": "Escreva a sua resposta...",
      "progress": "Progresso",
      "selectOption": "Selecione uma opção",
      "stepOf": "Passo {{current}} de {{total}}",
      "title": "Entrevista guiada",
      "typeAnswer": "Escreva a sua resposta",
      "openingFallback": "Vamos começar."
    },
    "includedFeatures": "Funcionalidades incluídas",
    "individualJourney": "Percurso individual",
    "inputPlaceholder": "Pergunta à Tonnie qualquer coisa...",
    "journeyPurpose": "Propósito do percurso",
    "journeyPurposes": "Propósitos do percurso",
    "journeyReady": "O seu percurso está pronto para ser desbloqueado!",
    "journeyRoute": "Rota do percurso",
    "journeyRouteDesc": "Selecione os seus países de origem e destino",
    "journeySummary": "Resumo do seu percurso",
    "justMe": "Só eu",
    "lifecycle": {
      "acknowledge": {
        "default": "Entendo que esta ação não pode ser desfeita."
      },
      "autosave": {
        "justNow": "agora mesmo",
        "offline": "Offline — tentará novamente",
        "saved": "Guardado · {{relative}}",
        "saving": "A guardar…",
        "unsaved": "Guardar pendente"
      },
      "completion": {
        "errorBody": "Algo correu mal ao guardar as suas respostas. Pode tentar novamente — o seu trabalho ainda está aqui.",
        "errorTitle": "Não foi possível guardar os seus resultados",
        "saving": "A guardar os seus resultados…",
        "successBody": "As suas respostas estão guardadas. A levá-lo ao seu painel.",
        "successContinue": "Continuar",
        "successRedirect": "A redirecionar em {{seconds}}…",
        "successStay": "Fique aqui",
        "successTitle": "Tudo feito!"
      },
      "confirm": {
        "stepLabel": "Passo {{currentStep}} de {{totalSteps}} · {{progress}}%"
      },
      "discard": {
        "body": "Está {{progress}}% concluído. Se cancelar agora, o seu trabalho nesta tentativa será eliminado.",
        "bodyTeleportalSetup": "As suas tarefas de TelePortal existentes ficam como estão. As suas respostas em rascunho desta sessão não serão guardadas.",
        "confirm": "Sim, descartar",
        "keep": {
          "history": "Qualquer resultado previamente concluído",
          "teleportalTasks": "As suas tarefas de TelePortal existentes"
        },
        "lose": {
          "answers": "As suas respostas atuais ({{progress}}%)",
          "position": "O seu lugar no passo {{currentStep}}",
          "teleportalDraft": "As respostas em rascunho desta sessão",
          "teleportalPosition": "Vai perder o seu progresso de TelePortal neste percurso"
        },
        "titleTeleportalSetup": "Ignorar a configuração por agora?",
        "confirmTeleportalSetup": "Sim, descartar esta tentativa",
        "titleCheckup": "Descartar o progresso do seu CheckUp?",
        "titleCareAssessment": "Descartar o progresso da sua avaliação de Care?",
        "titleQultureup": "Descartar o progresso do seu teste de nível de QultureUp?",
        "titleJourneyBuilder": "Descartar o percurso que está a construir?"
      },
      "keep": {
        "empty": "Nada é transferido.",
        "title": "A manter"
      },
      "leave": {
        "body": "O seu progresso até ao passo {{currentStep}} já está guardado. Pode retomar a qualquer momento.",
        "confirm": "Sim, afaste-se",
        "keep": {
          "answers": "Cada resposta que completou",
          "progress": "O seu progresso até agora ({{progress}}%)"
        },
        "title": "Afastar-se por agora?"
      },
      "lose": {
        "empty": "Nada é eliminado.",
        "title": "A perder"
      },
      "restart": {
        "body": "As suas respostas atuais serão apagadas. Começará de novo a partir do passo 1.",
        "bodyJourneyBuilder": "Começará o construtor de percursos de novo. As suas respostas em progresso serão apagadas.",
        "bodyTeleportalSetup": "As suas respostas anteriores serão preenchidas automaticamente. A conversa começa novamente do início, e a sua lista de tarefas será reconstruída.",
        "confirm": "Sim, reiniciar",
        "keep": {
          "history": "O seu resultado anterior (se houver)"
        },
        "lose": {
          "answers": "As suas respostas atuais ({{progress}}%)",
          "builderAnswers": "As suas respostas em progresso no construtor",
          "position": "O seu lugar no passo {{currentStep}}"
        },
        "title": "Reiniciar a partir do passo 1?",
        "titleJourneyBuilder": "Reiniciar o construtor de percursos?",
        "titleTeleportalSetup": "Reiniciar a configuração de TelePortal?"
      },
      "retake": {
        "bodyCare": "A sua avaliação de Care anterior está arquivada. A conversa recomeça a partir do passo 1.",
        "bodyCheckup": "O seu resultado de CheckUp anterior está arquivado. A conversa recomeça a partir do passo 1.",
        "bodyQultureup": "Apenas o teste de nível inicial é repetido — as suas missões e conquistas permanecem inalteradas.",
        "confirm": "Sim, refazer",
        "keep": {
          "archived": "O seu resultado anterior (mantido na história)",
          "miles": "Todas as suas Miles ganhas",
          "missions": "O seu progresso na missão"
        },
        "lose": {
          "activeScore": "A sua pontuação ativa & insígnia"
        },
        "titleCheckup": "Refazer o seu CheckUp?",
        "titleCare": "Refazer a sua avaliação de Care?",
        "titleQultureup": "Refazer o seu teste de nível de QultureUp?"
      },
      "reversible": {
        "no": "Não pode ser desfeito",
        "yes": "Pode voltar a isto"
      },
      "stay": "Fique",
      "toolbar": {
        "discard": "Descartar",
        "discardHint": "Cancelar esta tentativa e sair. As suas respostas são eliminadas.",
        "restart": "Reiniciar",
        "restartHint": "Eliminar as suas respostas e recomeçar a partir do passo 1."
      },
      "aria": {
        "whatChanges": "Quais as mudanças"
      }
    },
    "loadingQuestions": "A carregar perguntas…",
    "maxChars": "Máx {{max}} caracteres",
    "validation": {
      "required": "Esta pergunta é obrigatória.",
      "thin": "Uma resposta curta não faz mal — mais algumas frases dão-nos mais com que trabalhar ({{words}} palavras até agora).",
      "tooLong": "Muito longo — mantenha abaixo de {{max}} caracteres.",
      "ok": "Parece ótimo — claro e detalhado."
    },
    "suggestedWords": "Tente escrever {{min}}+ palavras",
    "typeAnswer": "Escreva a sua resposta",
    "words_one": "{{count}} palavra",
    "words_other": "{{count}} palavras",
    "motivationalAssessment": "Avaliação de motivação",
    "motivationalDesc": "Uma breve reflexão para nos ajudar a entender o que motiva a sua mudança.",
    "needsFix": "Precisa de correção",
    "nextVideo": "Próximo vídeo",
    "noCountriesFound": "Nenhum país encontrado",
    "noQuestionsForPersona": "Ainda não temos perguntas para este perfil.",
    "noVideoData": "Sem dados de vídeo",
    "noVideos": "Nenhum vídeo disponível.",
    "notAnsweredYet": "Ainda não respondido",
    "optional": "Opcional",
    "origin": "De onde é?",
    "pitch": {
      "fileTooLarge": "Este ficheiro de vídeo é demasiado grande para carregar. Escolha um ficheiro mais pequeno ou grave o seu pitch aqui.",
      "tooLong": "Este vídeo tem mais de {{minutes}} minutos. Escolha um vídeo mais curto ou grave o seu pitch aqui.",
      "uploadStalled": "O carregamento parou porque a sua ligação deixou de enviar dados. Verifique a ligação e tente novamente.",
      "unreadable": "Não conseguimos ler este vídeo, por isso não é possível verificar a sua duração. Escolha um vídeo MP4 ou WebM que seja reproduzido neste dispositivo ou grave o seu pitch aqui."
    },
    "pitchRecorder": "Gravador de pitch",
    "practiceNote": "Dica: pratique uma vez antes de gravar.",
    "previousVideo": "Vídeo anterior",
    "progressComplete": "{{percent}}% completo",
    "questionN": "Pergunta {{n}}",
    "questionNofM": "Pergunta {{n}} de {{m}}",
    "questions": "Perguntas",
    "questionsLoadError": "Falha ao carregar perguntas",
    "questionsUnavailable": "Perguntas indisponíveis",
    "quota": {
      "exceeded": "Limite diário atingido. Atualize o seu plano para mais mensagens.",
      "remaining": "Mensagens restantes",
      "upgrade": "Atualizar para mais"
    },
    "quotaReached": "Quota atingida! Faça upgrade para Pro para acesso ilimitado.",
    "ready": "Pronto",
    "readyQ": "Pronto para começar?",
    "recordAnswer": "Gravar resposta",
    "recordYourPitch": "Gravar a sua apresentação",
    "required": "Requerido",
    "responseCare": "O seu feedback de Care mostra melhorias em Comunicação e Competências Técnicas. Continue o ótimo trabalho! Para Comportamento e Adaptação, considere juntar-se a comunidades locais e a eventos de networking.",
    "responseCareer": "Com base no seu perfil, está bem posicionado para oportunidades em Portugal. As suas competências técnicas são fortes, e o seu nível de inglês é excelente. Sugiro que se concentre na prática da língua portuguesa para aumentar a sua taxa de correspondência.",
    "responseCheckup": "Com base nos seus resultados de CheckUp, vejo que está a fazer um bom trabalho! A sua pontuação de prontidão de 85 mostra uma forte preparação. Recomendo que se concentre na adaptação cultural, que está em 75. Considere completar lições de QultureUp para melhorar esta área.",
    "responseDefault": "Entendo a sua pergunta. Deixe-me ajudar com isso.",
    "responseHelp": "Estou aqui para ajudar! Posso ajudá-lo a perceber os seus resultados de CheckUp, a navegar nas tarefas de TelePortal, a aprender sobre a cultura no QultureUp, a acompanhar o seu progresso no Care e a encontrar oportunidades de carreira. Em que área específica gostaria de ajuda?",
    "responseQultureup": "Ainda bem que tem interesse no QultureUp! Recomendo começar pelo mundo 'Cultura Local' para se familiarizar com os costumes e tradições portugueses. Isto vai ajudá-lo a adaptar-se mais depressa quando chegar.",
    "responseScore": "A sua pontuação de prontidão atual é 85/100, o que é excelente! Está na categoria 'Quase Pronto'. As principais áreas a focar são Adaptação Cultural (75) e Experiência Internacional (70). Gostaria de recomendações específicas?",
    "responseTeleportal": "No seu percurso de TelePortal, vejo que está na fase de Preparação do Visto. Certifique-se de que reúne todos os documentos necessários e marca a sua entrevista. Quer que o ajude com alguma tarefa específica?",
    "responseVisa": "Para a sua mudança, recomendo começar pela Avaliação de TelePortal para obter uma lista de verificação personalizada. Certifique-se de que tem todos os documentos necessários prontos. O processo de visto demora normalmente 2 a 3 meses, por isso planeie em conformidade.",
    "restartFlow": "Reiniciar",
    "reviewAnswers": "Rever respostas",
    "reviewDesc": "Reserve um momento para rever as suas respostas antes de submeter.",
    "reviewJourney": "Revise a configuração do seu percurso antes de a prepararmos para si",
    "reviewYourAnswers": "Rever as suas respostas",
    "safety": {
      "critical": "Não tem de passar por isto sem ajuda — basta uma chamada.",
      "elevated": "Este tópico requer consideração cuidadosa. CoPilot fornece apenas orientações gerais — consulte um profissional para aconselhamento específico.",
      "standard": "CoPilot utiliza IA. As respostas podem não ser sempre precisas. Verifique sempre informações importantes.",
      "getHelp": "Obter ajuda",
      "help": {
        "title": "Ajuda, agora",
        "intro": "Se estiver em perigo, ou alguém perto de si, ligue já — estas linhas atendem dia e noite.",
        "lines": {
          "emergency": "Número europeu de emergência",
          "sns24": "SNS 24 — saúde e apoio psicológico"
        },
        "availability": {
          "always": "24 horas, todos os dias"
        },
        "care": "Falar com o apoio do Care",
        "careHint": "O Care tem uma equipa e recursos para o que está a sentir."
      }
    },
    "sameCountryWarning": "A origem e o destino não podem ser o mesmo país.",
    "saved": "Guardado",
    "saving": "A guardar…",
    "searchCountry": "Pesquisar país...",
    "selectCountry": "Selecionar...",
    "selectedAsDest": "Selecionado como destino",
    "selectedAsOrigin": "Selecionado como origem",
    "send": "Enviar",
    "situation": {
      "answered": "Respondido",
      "companyProvides": "A minha empresa fornece isto",
      "companySponsored": "Patrocinado pela empresa",
      "companySponsoredDesc": "O meu empregador está a patrocinar a minha relocação.",
      "description": "Escolha a opção que melhor descreve a sua situação.",
      "digitalNomad": "Nómada digital",
      "digitalNomadDesc": "Vou trabalhar remotamente a partir do meu novo país.",
      "employedSelf": "Estou empregado e a mudar-me por conta própria",
      "employedSponsored": "Estou empregado e a minha empresa patrocina a mudança",
      "entrepreneur": "Empreendedor",
      "euCitizen": "Cidadão da UE",
      "euCitizenDesc": "Sou cidadão da UE e não preciso de visto.",
      "familyReunion": "Reunião familiar",
      "familyReunionDesc": "Estou a juntar-me à família já no estrangeiro.",
      "haveHousing": "Já tenho alojamento organizado",
      "haveVisa": "Já tenho um visto",
      "haveVisaDesc": "Já garanti o meu visto para esta mudança.",
      "housingTitle": "Situação de alojamento",
      "jobSeeking": "À procura de emprego",
      "legalTitle": "Situação legal",
      "needFind": "Preciso de encontrar alojamento",
      "needTemp": "Preciso de alojamento temporário",
      "needVisa": "Preciso de obter um visto",
      "needVisaDesc": "Ainda não pedi um visto.",
      "pathwayTitle": "Caminho do visto",
      "pathwaysUnavailable": "Não foi possível carregar os caminhos de visto. Pode continuar sem escolher um.",
      "credentialTitle": "Profissão regulamentada",
      "credentialQuestion": "Exerce uma profissão regulamentada (por exemplo medicina, enfermagem, engenharia ou direito) no país para onde se vai mudar? Se sim, a sua qualificação tem de ser reconhecida lá antes de poder exercer.",
      "credentialYes": "Sim, a minha profissão é regulamentada",
      "credentialNo": "Não",
      "pathway": {
        "workPermit": "Visto de trabalho (patrocinado)",
        "workPermitDesc": "Residência patrocinada pelo empregador",
        "techVisa": "Visto tech",
        "techVisaDesc": "Contratação de tecnologia por empresa certificada",
        "d7": "D7 — Rendimento passivo / remoto",
        "d7Desc": "Baseado em rendimento ou trabalho remoto",
        "euFamily": "UE / reunião familiar",
        "euFamilyDesc": "Nacional da UE ou a juntar-se à família",
        "d1": "D1 — Visto de trabalho",
        "d1Desc": "Trabalho por conta de outrem",
        "d2": "D2 — Empreendedor / trabalhador independente",
        "d2Desc": "Negócio próprio ou atividade independente",
        "d8": "D8 — Nómada digital",
        "d8Desc": "Trabalho remoto para empregadores ou clientes no estrangeiro",
        "startup": "Visto startup",
        "startupDesc": "Criação de uma startup inovadora",
        "notSure": "Ainda não tenho certeza",
        "notSureDesc": "Tonnie ajudará a determinar isso"
      },
      "professionalTitle": "Situação profissional",
      "retired": "Reformado",
      "selfEmployed": "Trabalhador por conta própria",
      "student": "Estudante",
      "studentVisa": "Visto de estudante",
      "studentVisaDesc": "Estou a mudar-me com um visto de estudante.",
      "title": "A sua situação"
    },
    "submitFailed": "Falha ao submeter",
    "subtitle": "O seu assistente de IA está aqui para ajudar",
    "suggestedQuestions": "Perguntas sugeridas:",
    "thinking": "A pensar...",
    "title": "Tonnie CoPilot",
    "launcher": {
      "label": "Perguntar à Tonnie"
    },
    "toggle": "Alternar CoPilot",
    "trace": {
      "artifactUpdate": "Artifact atualizado",
      "cancel": "Cancelar",
      "completeness": "Completação",
      "confirm": "Confirmar",
      "error": "Erro",
      "retry": "Tentar novamente",
      "widget": "Widget"
    },
    "tryAgain": "Tente novamente",
    "unavailable": "O CoPilot está temporariamente indisponível. Por favor, tente novamente daqui a pouco.",
    "unlimited": "Plano Pro: Consultas ilimitadas",
    "unlimitedQuestions": "Perguntas ilimitadas",
    "unlockNote": "O seu percurso personalizado foi criado. Desbloqueie-o a partir do",
    "upgrade": "Atualizar",
    "upgradeToPro": "Atualizar para Pro",
    "uploadNote": "Manteremos o seu vídeo privado — só será visto por si e pela nossa IA.",
    "uploadingVideo": "A carregar vídeo…",
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "videoCompleted": "Completo",
    "videoPlayerDesc": "Reprodutor de vídeo para {{title}}. Clique em reproduzir para começar o vídeo.",
    "videoResume": "Retomar",
    "videoSent": "Vídeo enviado",
    "videoStateInProgress": "Em curso",
    "videoStatePending": "Por ver",
    "videoStateWatched": "Visto",
    "videoSubmitted": "Vídeo submetido",
    "videoToWatch": "Por ver",
    "videoUploadFailed": "O carregamento do vídeo falhou",
    "videoWatchedLabel": "Visto",
    "videosWatched": "vídeos assistidos",
    "voice": {
      "error": "Desculpe, não percebi. Tente novamente.",
      "status": {
        "listening": "Estou a ouvir...",
        "transcribing": "A transcrever…"
      },
      "a11y": {
        "pause": "Pausar a escuta",
        "start": "Começar a entrada de voz"
      }
    },
    "whyWeAsk": "Por que perguntamos",
    "widgetError": "Este widget falhou ao carregar.",
    "widgetNotFound": "Widget \"{{name}}\" não encontrado",
    "yesBringingFamily": "Sim, com a família",
    "aria": {
      "conversation": "Conversa",
      "messageInput": "Mensagem",
      "sendMessage": "Enviar mensagem",
      "answerInput": "A sua resposta"
    },
    "tools": {
      "checkingCohorts": "A verificar os seus programas…",
      "checkingJourney": "A verificar o seu percurso…",
      "checkingTasks": "A verificar as suas tarefas…",
      "checkingCheckup": "A verificar o seu CheckUp…",
      "checkingCare": "A verificar o seu bem-estar…",
      "checkingObjectives": "A verificar os seus objetivos de Care…",
      "checkingPassport": "A verificar o seu Passport…",
      "checkingMiles": "A verificar as suas milhas…",
      "checkingNotifications": "A verificar as suas notificações…",
      "checkingHousehold": "A verificar o seu agregado familiar…",
      "checkingBilling": "A verificar a sua faturação…",
      "checkingCareer": "A verificar oportunidades de carreira…",
      "submittingCheckpoint": "A submeter o seu ponto de controlo…",
      "creatingSupport": "A levantar um pedido de apoio…",
      "schedulingCheckpoints": "A agendar os seus pontos de controlo…",
      "submittingSelfEval": "A submeter a sua autoavaliação…",
      "completingMission": "A completar a sua missão…",
      "submittingQuiz": "A submeter o seu questionário…",
      "markingRead": "A atualizar as suas notificações…",
      "addingMember": "A adicionar um membro da família…",
      "updatingMember": "A atualizar um membro da família…",
      "savingOpportunity": "A guardar a oportunidade…",
      "expressingInterest": "A enviar o seu interesse…",
      "checkingDocuments": "A verificar os seus documentos…",
      "checkingProfile": "A verificar o seu perfil…",
      "checkingMesh": "A verificar o seu MESH…",
      "checkingQultureup": "A verificar o seu QultureUp…",
      "checkingWorlds": "A verificar os seus mundos…",
      "savingToVault": "A guardar no seu Cofre…",
      "attachingFile": "A anexar o ficheiro…",
      "updatingTask": "A atualizar a tarefa…",
      "startingMission": "A iniciar a missão…",
      "checkingProgramSetup": "A verificar a configuração do seu programa…",
      "reopeningTask": "A reabrir a tarefa…",
      "completingTask": "A completar a tarefa…",
      "submittingCheckin": "A registar o seu check-in…",
      "startingRetake": "A iniciar o seu CheckUp…",
      "recallingMemories": "A verificar o que me lembro…",
      "rememberingFact": "A fazer uma nota…",
      "forgettingFact": "A esquecer isso…",
      "searchingKnowledge": "A verificar a base de conhecimento…",
      "readingNote": "A ler sobre isso…",
      "listingPipelineTalents": "A verificar o seu pipeline de talentos…",
      "checkingTalentOverview": "A verificar a visão geral dos talentos…",
      "checkingTalentReadiness": "A verificar a prontidão dos talentos…",
      "checkingTalentMobility": "A verificar o progresso de realocação dos talentos…",
      "checkingTalentAdaptation": "A verificar a adaptação dos talentos…",
      "checkingTalentRisk": "A verificar o bem-estar e risco dos talentos…",
      "checkingTalentEvidence": "A verificar as evidências dos talentos…",
      "checkingCohort": "A verificar a coorte…",
      "checkingProgram": "A verificar o programa…",
      "checkingPipeline": "A verificar o seu pipeline…",
      "checkingAffiliate": "A verificar a sua conta de afiliado…",
      "checkingPoolCounts": "A contar o seu pool de talentos…",
      "checkingPoolTalent": "A verificar o talento do pool…",
      "searchingWeb": "A pesquisar na web…",
      "sponsoringTalent": "A preparar o patrocínio…",
      "addingTalentToCohort": "A adicionar o talento à coorte…",
      "addingTalentNote": "A adicionar uma nota interna…",
      "savingVettingDocument": "A guardar o documento de triagem…",
      "checkingMyWorkQueue": "A verificar o que precisa de si…",
      "messagingTalent": "A preparar a sua mensagem…",
      "requestingCheckin": "A preparar um pedido de check-in…",
      "schedulingMeeting": "A preparar o convite…",
      "checkingCompany": "A verificar o seu perfil de empresa…",
      "checkingPrograms": "A verificar os seus programas…",
      "checkingDashboard": "A verificar o seu painel…",
      "checkingActivity": "A verificar a atividade recente…",
      "checkingAnalytics": "A verificar as suas análises…",
      "checkingVetting": "A verificar a sua visão geral de triagem…",
      "checkingMobility": "A verificar a sua visão geral de mobilidade…",
      "checkingAdaptation": "A verificar a sua visão geral de adaptação…",
      "checkingEvidence": "A verificar a sua visão geral de evidências…",
      "checkingCareConfig": "A verificar a configuração do seu Care…",
      "checkingInvoices": "A verificar as suas faturas…",
      "checkingSponsorships": "A verificar os seus patrocínios…",
      "checkingTeam": "A verificar a sua equipa…",
      "checkingMessageTemplates": "A verificar os seus modelos de mensagem…",
      "checkingMessageAnalytics": "A verificar as suas análises de mensagem…",
      "checkingAuditLog": "A verificar o seu registo de auditoria…",
      "creatingProgram": "A preparar o novo programa…",
      "creatingCohort": "A preparar a nova coorte…",
      "invitingTeamMember": "A preparar o convite para a equipa…",
      "removingTeamMember": "A preparar para remover o membro da equipa…",
      "resolvingInteraction": "A atualizar a interação Care…",
      "reschedulingInteraction": "A reagendar a interação Care…",
      "cancellingInteraction": "A cancelar a interação Care…",
      "commentingInteraction": "A adicionar o seu comentário…",
      "working": "A trabalhar…",
      "preparingNextStep": "A preparar o seu próximo passo…",
      "checkingInOut": "A verificar os seus relógios do InOut…",
      "simulatingTrip": "A simular a sua viagem…"
    },
    "errors": {
      "quota_exceeded": "Atingiu o seu limite diário de mensagens. É reposto à meia-noite.",
      "budget_degraded": "Estou a funcionar num modo limitado neste momento — ainda posso ajudar com respostas fundamentadas.",
      "provider_unavailable": "Estou a ter dificuldades em alcançar as minhas capacidades totais neste momento. Por favor, tente novamente em breve.",
      "capability_disabled": "Essa capacidade está temporariamente indisponível.",
      "stale_proposal": "Isso mudou desde que eu sugeri — pergunte-me novamente e eu farei uma nova análise.",
      "aborted": "Parado.",
      "internal": "Algo correu mal do meu lado. Por favor, tente novamente.",
      "messageRequired": "Por favor, escreva uma mensagem primeiro.",
      "uploadFailed": "O carregamento falhou. Por favor, tente novamente.",
      "ref": "Referência"
    },
    "source": {
      "from": "De",
      "why": "Porque pode confiar nisso",
      "cases": "{{n}} realocações semelhantes",
      "webSources": "Fontes"
    },
    "webSearch": {
      "toggle": "Pesquisar na web",
      "toggleHint": "Deixe Tonnie procurar informações atuais na web para esta questão"
    },
    "feedback": {
      "helpful": "Útil",
      "notHelpful": "Não útil",
      "thanks": "Obrigado pelo feedback"
    },
    "toolResult": {
      "success": "Feito",
      "failed": "Isso não funcionou"
    },
    "suggestions": {
      "complete_checkup": {
        "title": "Conclua o seu CheckUp"
      },
      "explore_qultureup": {
        "title": "Explore o QultureUp"
      },
      "check_passport": {
        "title": "Veja o seu progresso"
      },
      "checkup_incomplete": {
        "title": "Quer terminar o seu CheckUp? Posso ajudá-lo com isso."
      },
      "tasks_blocked": {
        "title_one": "Tem {{count}} tarefa bloqueada — quer ajuda para a desbloquear?",
        "title_other": "Tem {{count}} tarefas bloqueadas — quer ajuda para as desbloquear?"
      },
      "care_pending": {
        "title_one": "Tem {{count}} check-in à espera — vamos fazê-lo?",
        "title_other": "Tem {{count}} check-ins à espera — vamos fazê-los?"
      },
      "docs_expiring": {
        "title_one": "{{count}} documento expira em breve — quer revê-lo?",
        "title_other": "{{count}} documentos expiram em breve — quer revê-los?"
      },
      "checkup_result_published": {
        "title": "Os seus resultados estão disponíveis — quer que eu o ajude a analisá-los?"
      },
      "vetting_backlog": {
        "title_one": "{{count}} talento está à espera no Vetting — quer revê-lo?",
        "title_other": "{{count}} talentos estão à espera no Vetting — quer revê-los?"
      },
      "care_overdue": {
        "title_one": "{{count}} checkpoint de Care está em atraso — quer ver quem precisa de atenção?",
        "title_other": "{{count}} checkpoints de Care estão em atraso — quer ver quem precisa de atenção?"
      }
    },
    "proposal": {
      "aria": "Confirmação de ação",
      "confirm": "Confirmar",
      "confirming": "A confirmar…",
      "dismiss": "Agora não",
      "expired": "Esta oferta expirou — pergunte-me novamente.",
      "stale": "Isto mudou desde que eu sugeri — pergunte-me novamente.",
      "error": "Algo correu mal. Por favor, tente novamente.",
      "untrustedWarning": "Isto veio de um ficheiro carregado — reveja-o antes de confirmar.",
      "typeToConfirm": "Escreva {{token}} para confirmar",
      "confirmed": "✓ Feito — eu completei isso por si.",
      "alreadyCheckedIn": "Já registou um check-in hoje, por isso nada novo foi adicionado.",
      "attachedCompletionPending": "✓ Ficheiro anexado — mas a tarefa ainda não está completa; alguns documentos obrigatórios ainda estão em falta."
    },
    "attachFile": "Anexar um ficheiro",
    "proactive": {
      "dismiss": "Dispensar"
    },
    "newConversation": "Nova conversa",
    "choices": {
      "label": "Opções sugeridas",
      "other": "Outro…"
    },
    "removeAttachment": "Remover ficheiro",
    "depth": {
      "label": "Comprimento da resposta",
      "brief": "Breve",
      "balanced": "Equilibrado",
      "detailed": "Detalhado",
      "briefHint": "Respostas curtas e diretas",
      "balancedHint": "Detalhe equilibrado (padrão)",
      "detailedHint": "Respostas completas e detalhadas"
    },
    "rewrite": {
      "shorter": "Mais curto",
      "longer": "Mais longo",
      "shorterCommand": "Torne a sua resposta anterior mais curta e direta, na mesma língua.",
      "longerCommand": "Expanda a sua resposta anterior com mais detalhes e explicações, na mesma língua."
    },
    "attach": {
      "takePhoto": "Tire uma foto",
      "choosePhoto": "Escolha uma foto",
      "recordVideo": "Grave um vídeo",
      "chooseVideo": "Escolha um vídeo",
      "videoTooLarge": "Esse vídeo é muito grande. Grave um clipe mais curto (até 25 MB) e tente novamente."
    },
    "permissions": {
      "cameraTitle": "Câmara indisponível",
      "cameraDenied": "Permita o acesso à câmara nas definições do seu dispositivo para que possa mostrar Tonnie uma foto ou vídeo.",
      "libraryTitle": "Biblioteca de fotos indisponível",
      "libraryUnavailable": "Não conseguimos abrir a sua biblioteca de fotos. Tente novamente ou permita o acesso nas definições do seu dispositivo.",
      "microphoneDenied": "Permita o acesso ao microfone nas definições do seu dispositivo para que possa falar com a Tonnie em vez de escrever."
    },
    "history": {
      "title": "Conversas",
      "back": "Voltar ao chat",
      "newChat": "Novo chat",
      "searchPlaceholder": "Pesquisar conversas",
      "empty": "Ainda não há conversas",
      "emptySearch": "Sem correspondências",
      "untitled": "Sem título",
      "rename": "Renomear",
      "delete": "Eliminar",
      "actions": "Ações de conversa",
      "deleteTitle": "Eliminar conversa?",
      "deleteBody": "Esta conversa será removida do seu histórico. Isto não pode ser desfeito.",
      "cancel": "Cancelar"
    },
    "familyFromProfile": "Do seu perfil — altere se agora for diferente.",
    "originShort": "Origem",
    "destinationShort": "Destino",
    "actionsAvailable_one": "{{count}} ação disponível",
    "actionsAvailable_other": "{{count}} ações disponíveis",
    "questionsRemaining_one": "{{count}} pergunta restante hoje",
    "questionsRemaining_other": "{{count}} perguntas restantes hoje",
    "offer": {
      "title": "O seu próximo passo com a {{partner}}",
      "kind": {
        "CONSULTATION": "Consulta especializada",
        "REQUISITION": "Requisição — a assessoria trata do seu pedido"
      },
      "vatIncluded": "IVA incluído",
      "credit": "O valor pago pela consulta é descontado na requisição.",
      "open": "Continuar",
      "openOnWeb": "Continuar na web",
      "website": "Sobre a {{partner}}"
    },
    "aiUnavailable": {
      "description": "O CoPilot não consegue responder neste momento. Estamos a tentar novamente — tudo o resto na Tonnie funciona normalmente."
    }
  },
  "coupon": {
    "applied": "Cupão {{code}} aplicado com sucesso!",
    "apply": "Aplicar",
    "enterCode": "Introduza o código do cupão",
    "error": "Falha ao aplicar o cupão. Por favor, tente novamente.",
    "invalid": "Código de cupão inválido"
  },
  "cvBuilder": {
    "addExperience": "Adicionar experiência",
    "addSkill": "Adicionar competência",
    "aiOptimize": "Otimizar IA para o mercado de Portugal",
    "clickEditToExpand": "Clique em Editar para expandir esta secção",
    "complete": "completo",
    "completeAllSections": "Complete todas as secções para obter os melhores resultados",
    "copilotSuggestions": "Sugestões de CoPilot",
    "cvCompleteness": "Completação do CV",
    "cvSections": "Secções do CV",
    "deleteExperience": "Eliminar experiência",
    "description": "Crie um CV profissional adaptado ao seu mercado-alvo",
    "editExperience": "Editar experiência",
    "editSection": "Editar secção",
    "education": "Educação",
    "exportDescription": "Na produção, isto geraria o seu ficheiro CV.",
    "exportFileDesc": "CV_{{firstName}}_{{lastName}}.{{format}} seria descarregado.",
    "exportPDF": "Exportar PDF",
    "exportSuccess": "{{format}} exportado com sucesso!",
    "exportWord": "Exportar word",
    "fullName": "Nome completo",
    "generatingExport": "A gerar exportação {{format}}...",
    "importLinkedIn": "Importar do PDF do LinkedIn",
    "items": "itens",
    "languages": "Idiomas",
    "location": "Localização",
    "mockEducation1": {
      "degree": "Licenciatura em ciência da computação",
      "institution": "Universidade de tecnologia",
      "period": "2014–2018"
    },
    "mockExperience1": {
      "company": "Tech solutions inc.",
      "description": "Liderou o desenvolvimento de aplicações web escaláveis. Colaborou com equipas internacionais.",
      "period": "2020 — Presente",
      "role": "Engenheiro de software sénior"
    },
    "mockExperience2": {
      "company": "StartupXYZ",
      "description": "Desenvolvi e mantive aplicações web com React e Node.js.",
      "period": "2018–2020",
      "role": "Desenvolvedor full-stack"
    },
    "personalInfo": "Informação pessoal",
    "phone": "Telefone",
    "preview": "Pré-visualizar",
    "professionalSummary": "Resumo profissional",
    "quickActions": "Ações rápidas",
    "removeSkill": "Remover competência",
    "skills": "Competências",
    "suggestAddSkills": "Adicione mais competências relevantes para a sua função alvo (5 mais recomendadas)",
    "suggestExpandSummary": "Expanda o seu resumo profissional com conquistas chave",
    "template": "Modelo",
    "templates": {
      "classic": "Clássico",
      "creative": "Criativo",
      "minimal": "Mínimo",
      "modern": "Moderno"
    },
    "title": "Construtor de CV",
    "translateToPortuguese": "Traduzir para Português",
    "wizard": {
      "applyChanges": "Aplicar alterações",
      "applying": "A aplicar...",
      "backToEdit": "Voltar a editar",
      "characters": "caracteres",
      "clickNextToGenerate": "Clique em Gerar para criar o seu CV personalizado",
      "company": "Empresa",
      "companyPlaceholder": "ex., TechCorp Solutions",
      "completeAllSteps": "Por favor, complete todos os passos antes de guardar",
      "createFirstCV": "Crie o seu primeiro CV para começar",
      "cvDeleted": "CV eliminado com sucesso!",
      "cvGeneratedDescription": "O seu CV foi gerado e guardado. Pode agora rever e editar cada secção, ou exportá-lo diretamente.",
      "cvGeneratedSuccess": "CV gerado com sucesso!",
      "cvSaved": "CV guardado com sucesso!",
      "cvUpdated": "CV atualizado com sucesso!",
      "defaultJobTitle": "esta posição",
      "deleteConfirm": "Tem a certeza de que deseja eliminar este CV?",
      "deleteConfirmTitle": "Eliminar CV",
      "description": "Gerar CVs profissionais adaptados a descrições de funções a partir dos seus dados de Percurso",
      "done": "Feito",
      "dragDropFile": "Arraste e solte um ficheiro aqui, ou clique para selecionar",
      "edit": "Editar",
      "enterPrompt": "Por favor, insira instruções de refinamento",
      "fileSelected": "Ficheiro selecionado",
      "fileUploaded": "Ficheiro carregado: {{fileName}}",
      "generateCV": "Gerar CV",
      "generatedEducation": "{{degree}} da {{institution}} ({{period}})",
      "generatedExperience": "{{role}} na {{company}} ({{period}})\n{{description}}",
      "generatedReadiness": "Pontuação de prontidão internacional: {{iqulture}}/100\nanálise de MESH: Motivação {{motivation}}% • Inglês {{english}}% • Competências interpessoais {{softSkills}}% • Competências técnicas {{hardSkills}}%",
      "generatedSummary": "Profissional experiente com uma pontuação de prontidão internacional de {{iqulture}}/100. {{name}} traz uma forte experiência técnica e uma adaptabilidade comprovada a ambientes internacionais — um perfil ideal para {{jobTitle}}.",
      "generating": "A gerar...",
      "generatingCV": "A gerar o seu CV...",
      "generatingDescription": "A IA está a analisar o seu perfil e os requisitos do trabalho",
      "invalidFileType": "Tipo de ficheiro inválido. Por favor, carregue ficheiros .txt, .doc, .docx, ou .pdf.",
      "jobDescription": "Descrição do trabalho",
      "jobDescriptionPlaceholder": "Cole a descrição completa do trabalho aqui...",
      "jobTitle": "Título do trabalho",
      "jobTitlePlaceholder": "ex., Engenheiro de Software Sénior",
      "newCV": "Novo CV",
      "next": "Próximo",
      "noCVs": "Sem CVs ainda",
      "of": "de",
      "optional": "(Opcional)",
      "orCreateNew": "ou crie um novo",
      "orUploadFile": "Ou carregue o ficheiro da descrição do trabalho",
      "preview": "Pré-visualizar",
      "previous": "Anterior",
      "promptPlaceholder": "Ex., Adicione mais detalhes sobre a infraestrutura de nuvem, foque nos serviços AWS...",
      "readyToGenerate": "Pronto para gerar",
      "refine": "Refinar",
      "refineDescription": "Introduza instruções para modificar esta secção:",
      "refineSection": "Refinar secção",
      "refinedBasedOn": "Refinado com base em",
      "refinementSuccess": "Secção refinada com sucesso!",
      "saveCV": "Guardar CV",
      "savedCVs": "CVs Guardados",
      "sections": {
        "education": "Educação",
        "internationalReadiness": "Prontidão internacional",
        "professionalSummary": "Resumo profissional",
        "skills": "Competências",
        "workExperience": "Experiência de trabalho"
      },
      "selectCVToPreview": "Selecione um CV para pré-visualizar",
      "step": "Passo",
      "step1": {
        "description": "Insira a descrição do trabalho para a posição à qual está a candidatar-se. Isso ajudará a personalizar o seu CV.",
        "title": "Descrição do trabalho"
      },
      "step2": {
        "description": "A IA vai analisar a descrição da função e gerar secções de CV personalizadas com base nos seus dados de Percurso.",
        "title": "Geração de CV"
      },
      "step3": {
        "description": "Reveja e refine cada secção. Use prompts para personalizar o conteúdo para requisitos específicos.",
        "title": "Refinamento"
      },
      "step4": {
        "description": "Revise o seu CV final e guarde-o ou exporte-o no seu formato preferido.",
        "title": "Rever & exportar"
      },
      "steps": {
        "generation": "Geração",
        "jobDescription": "Descrição do trabalho",
        "refinement": "Refinamento",
        "review": "Revisão"
      },
      "subtitle": "Crie CVs específicos para o trabalho adaptados a cada oportunidade",
      "supportedFormats": "Suporta: .txt, .doc, .docx, .pdf",
      "title": "Assistente de geração de CV",
      "unsavedChanges": "Tem alterações não guardadas. Tem a certeza de que deseja sair?",
      "unsavedChangesTitle": "Alterações não guardadas"
    },
    "workExperience": "Experiência de trabalho"
  },
  "dashboard": {
    "activity": {
      "checkupUpdated": "Avaliação de CheckUp atualizada",
      "portugueseBasicsCompleted": "Concluído nível 1 de Português básico",
      "twoDaysAgo": "Há 2 dias",
      "twoHoursAgo": "Há 2 horas",
      "visaVerificationPending": "Verificação de documentos de visto pendente",
      "yesterday": "Ontem",
      "title": "Atividade recente",
      "showAll": "Mostrar tudo"
    },
    "allCheckpointsDone": "Todos os pontos de controlo concluídos",
    "banner": {
      "completed": "Feito",
      "notStarted": "Não iniciado",
      "progress": "Progresso"
    },
    "care": {
      "allComplete": "Todos os pontos de controlo concluídos",
      "assessmentDone": "Avaliação concluída",
      "awaitingData": "A aguardar dados",
      "mood": "Humor:",
      "moodCta": "Como se sente hoje?",
      "notStarted": "Acompanhe o seu bem-estar em 5 pilares da vida com check-ins regulares.",
      "startCta": "Iniciar Care",
      "subtitle": "Apoio ao bem-estar e check-ins"
    },
    "checkup": {
      "assessmentDone": "Avaliação completa",
      "calculateCta": "Calcular pontuação",
      "calculating": "A calcular...",
      "calculatingDesc": "A analisar a sua prontidão em Motivação, Inglês, Competências Interpessoais e Competências Técnicas.",
      "iqulture": "Pontuação iQulture",
      "lastAssessment": "Último: {{date}}",
      "notStarted": "Descubra a sua pontuação de prontidão em Motivação, Inglês, Competências Interpessoais e Competências Técnicas.",
      "readyToCalculate": "A sua pontuação de prontidão MESH está pronta para ser calculada.",
      "startCta": "Iniciar avaliação",
      "subtitle": "Meça a sua prontidão com MESH",
      "awaitingProfile": "Perfil em falta",
      "awaitingProfileDesc": "A sua avaliação está feita. Complete o seu perfil para obter a sua pontuação."
    },
    "continueJourney": "Continuar percurso",
    "cta": {
      "continueQultureUp": "Continuar QultureUp",
      "continueTelePortal": "Continuar TelePortal",
      "startCare": "Iniciar Care",
      "startCheckUp": "Iniciar CheckUp",
      "startQultureUp": "Iniciar QultureUp",
      "startTelePortal": "Iniciar TelePortal",
      "viewCheckUp": "Ver CheckUp",
      "viewPassport": "Ver Passport",
      "completeProfile": "Complete o seu perfil",
      "continueCare": "Continuar Care"
    },
    "emptyState": {
      "description": "Crie o seu percurso de carreira internacional para desbloquear o seu painel personalizado com acompanhamento de progresso em todos os heróis.",
      "title": "Construa o seu percurso"
    },
    "errorState": {
      "description": "Ocorreu um erro ao carregar os dados do seu painel. Por favor, tente atualizar a página.",
      "title": "Incapaz de carregar o painel"
    },
    "heroInsight": {
      "care": {
        "checkpoints": "{{done}} de {{total}} checkpoints",
        "notStarted": "Acompanhe o seu bem-estar",
        "startCheckin": "Registe o seu primeiro check-in",
        "streak": "{{n}} dias seguidos",
        "subtitle": "Acompanhe o seu bem-estar"
      },
      "checkup": {
        "notStarted": "Faça a sua avaliação",
        "subtitle": "Meça a sua prontidão"
      },
      "qultureup": {
        "allDone": "Todas as missões completas!",
        "missionsLabel": "missões",
        "notStarted": "Descubra o seu nível cultural",
        "subtitle": "Aprenda a sua nova cultura",
        "todaysMission": "A missão de hoje"
      },
      "teleportal": {
        "allDone": "Sem prazos a aproximar-se",
        "next": "Próximo: {{name}}",
        "notStarted": "Construa o seu plano de realocação",
        "overdue_one": "{{count}} em atraso",
        "overdue_other": "{{count}} em atraso",
        "subtitle": "Planeie a sua realocação",
        "tasksLabel": "tarefas"
      }
    },
    "journeyProgress": "O seu percurso {{route}} está {{percent}}% completa.",
    "journeyProgressDescription": "Acompanhe o seu progresso em cada passo",
    "journeyProgressTitle": "O progresso do seu percurso",
    "journeyReady": "O seu percurso está pronto para começar.",
    "miles": "Miles do percurso",
    "moodLabel": "Humor:",
    "noActivity": "Ainda não há atividade recente. Comece a explorar os seus heróis!",
    "noJourney": "Sem percurso",
    "passport": {
      "badges": "Emblemas",
      "citizenLevelValue": "Nível {{level}}",
      "level": "Nível",
      "noData": "A sua pontuação vai aparecer aqui",
      "readiness": "Prontidão",
      "recentStamps": "Selos recentes",
      "stamps": "Selos",
      "subtitle": "O seu registo de percurso completo",
      "totalMiles": "Total de Miles"
    },
    "qultureup": {
      "missions": "Missões",
      "notStarted": "Explore mundos culturais e complete missões para se adaptar à sua nova casa.",
      "startCta": "Iniciar avaliação",
      "streak": "Sequência de {{days}} dias",
      "subtitle": "Adaptação cultural através da aprendizagem",
      "tracks": "Faixas",
      "worlds": "Mundos"
    },
    "recentActivity": "Atividade recente",
    "recentActivityDescription": "Os seus últimos marcos e atualizações",
    "teleportal": {
      "docs": "Documentos prontos:",
      "notStarted": "Configure o seu plano de realocação com as pistas Legal, Viagem e Configuração.",
      "startCta": "Começar configuração",
      "subtitle": "Planeie e execute a sua realocação"
    },
    "welcomeBack": "Bem-vindo de novo, {{name}}! 👋",
    "hero": {
      "scoreIn": "A sua pontuação chegou",
      "hello": "Olá, {{name}}",
      "helloNoName": "Olá de novo",
      "strongest": "Ponto forte: {{dimension}}",
      "toGrow": "A desenvolver: {{dimension}}",
      "resultsLink": "Ver os resultados completos",
      "day": "Dia {{day}}",
      "dayLabel": "do seu percurso"
    }
  },
  "deepLink": {
    "copyUrl": "Copiar URL",
    "downloadApp": "Descarregar app",
    "error": {
      "invalidAction": "Ação de deep link inválida",
      "noUser": "Utilizador não autenticado"
    },
    "fallbackDescription": "Se a app não abrir automaticamente, instale-a a partir da loja de apps.",
    "landing": {
      "continueIn": "Continuar em",
      "continueOnWeb": "Continuar na web",
      "copied": "Link copiado",
      "copyLink": "Copiar link",
      "desktopBody": "Está a usar um browser de desktop. Abra a app Tonnie no seu telemóvel ou continue na web.",
      "goHome": "Ir para casa",
      "installApp": "Instalar a aplicação",
      "invalidBody": "Este link não é válido ou expirou.",
      "invalidTitle": "Link inválido",
      "mobileBody": "Abra esta ligação na app Tonnie para ter a melhor experiência.",
      "openApp": "Abrir na aplicação",
      "publicNote": "Esta página é pública. Qualquer pessoa com o link pode visualizá-la até que expire.",
      "retryAgain": "Tente novamente"
    },
    "openInMobile": "Abrir na aplicação móvel",
    "qr": {
      "copied": "Link copiado",
      "copyLink": "Copiar link",
      "description": "Leia este código QR com o seu telemóvel para abrir a app Tonnie e continuar.",
      "dontHaveApp": "Ainda não tem a aplicação?",
      "note": "O link expira após o tempo mostrado acima.",
      "title": "Continue no seu telefone"
    },
    "urlCopied": "URL do deep link copiado para a área de transferência"
  },
  "error": {
    "goHome": "Ir para casa",
    "pageDescription": "Lamentamos o inconveniente. Por favor, tente novamente ou volte à página inicial.",
    "pageTitle": "Algo correu mal",
    "retry": "Tentar novamente",
    "sectionDescription": "Esta secção encontrou um erro. Tente atualizar ou continue com as outras secções.",
    "sectionTitle": "Erro na secção",
    "tryAgain": "Tente novamente",
    "clerkMissing": {
      "title": "Serviço de autenticação não configurado",
      "body": "Esta versão está a faltar EXPO_PUBLIC_CLERK_PUBLISHABLE_KEY. Reinstala uma versão mais recente do EAS, ou contacta o suporte se isto persistir."
    }
  },
  "errorBoundary": {
    "goHome": "Ir para casa",
    "pageEncounteredError": "Esta página encontrou um erro",
    "pageMessage": "Lamentamos o inconveniente. Por favor, tente novamente ou volte ao ecrã inicial.",
    "reloadPage": "Recarregar página",
    "retry": "Tentar novamente",
    "sectionError": "Erro na secção",
    "sectionMessage": "Esta secção encontrou um erro. Tente atualizar ou continue com as outras secções.",
    "somethingWentWrong": "Algo correu mal",
    "tryAgain": "Tente novamente",
    "unexpectedError": "Ocorreu um erro inesperado.",
    "appErrorTitle": "Erro de aplicação"
  },
  "evidence": {
    "kind": {
      "adaptationProgress": "Progresso de adaptação",
      "careCheckins": "Registos de bem-estar do Care",
      "careOverview": "Visão geral do Care",
      "checkupProgress": "Progresso do CheckUp",
      "checkupResults": "Resultados do CheckUp",
      "cv": "CV",
      "household": "Agregado familiar",
      "mobilityDocuments": "Documentos de mobilidade",
      "mobilityPlan": "Plano de mobilidade",
      "passportEvidence": "Evidências do Passport",
      "pitchVideo": "Vídeo de apresentação",
      "testitResults": "Resultados do TestIt"
    },
    "redaction": {
      "reason": {
        "controllerMinimisation": "Removido pela empresa para manter apenas o necessário",
        "dataSubjectRequest": "Removido a pedido da pessoa",
        "legalObligation": "Removido para cumprir uma obrigação legal"
      }
    },
    "retention": {
      "reason": {
        "decisionInForce": "Mantido como registo da empresa de uma decisão que continua em vigor. Será eliminado na data indicada, ou antes disso se a relação chegar primeiro a um desfecho.",
        "engagementEnded": "Mantido como registo da empresa de uma decisão de contratação, para defender ou responder a pretensões legais, até ao fim do período de conservação após o fim da relação.",
        "notProgressed": "Mantido como registo da empresa de uma decisão de não avançar, para defender ou responder a pretensões legais, até ao fim do período de conservação."
      },
      "until": "Mantido até {{date}}",
      "noEndDate": "Ainda sem data de fim — é definida quando a relação chega a um desfecho."
    },
    "trigger": {
      "engagementEnd": "Relação terminada",
      "engagementStart": "Início da relação",
      "onDemand": "Guardado a pedido",
      "sponsorshipActivation": "Patrocínio ativado",
      "stageTransition": "Etapa alterada",
      "verdict": "Decisão TestIt"
    },
    "withheld": {
      "scopeNotGranted": "Não partilhado com esta empresa quando a decisão foi tomada"
    },
    "record": {
      "title": "Registos de decisão",
      "description": "O que a sua empresa podia ver sobre {{name}} em cada decisão. Um registo mantém-se exatamente como foi guardado — alterações posteriores ao perfil não o modificam.",
      "captureNow": "Guardar um registo agora",
      "capturing": "A guardar…",
      "captureSuccess": "Registo guardado",
      "captureRefusedEnded": "Esta relação está arquivada ou terminou, pelo que não é possível guardar um novo registo.",
      "captureFailed": "Não foi possível guardar o registo.",
      "listLabel": "Registos de decisão, do mais recente para o mais antigo",
      "empty": "Ainda não há registos de decisão. É guardado um registo sempre que a sua empresa move, decide sobre, patrocina ou termina a relação com este candidato.",
      "loadError": "Não foi possível carregar os registos de decisão.",
      "detailLoadError": "Não foi possível carregar este registo.",
      "retry": "Tentar novamente",
      "itemsTitle": "O que o registo contém",
      "actorBy": "Por {{name}}",
      "actorSystem": "Guardado automaticamente",
      "actorOutsideTeam": "Por uma ação de alguém de fora da sua equipa",
      "decision": {
        "stageMove": "Movido de {{from}} para {{to}}",
        "stageEntered": "Entrou em {{to}}"
      },
      "origin": {
        "backfill": "Registo antigo",
        "backfillNote": "Guardado antes de os registos serem mantidos no servidor. Contém apenas o que o browser enviou na altura, e o consentimento em vigor nessa data não foi registado."
      },
      "listTitle": "Registos · do mais recente",
      "count_one": "{{count}} registo",
      "count_other": "{{count}} registos"
    },
    "item": {
      "legacy": "Enviado pelo browser · não verificado",
      "legacyNote": "Isto é o que o browser enviou com a decisão. Nunca foi verificado no servidor.",
      "redact": "Remover",
      "redactAria": "Remover {{kind}} deste registo",
      "redacted": "Removido do registo",
      "redactedOn": "Removido do registo em {{date}}",
      "viewerRedacted": "Alguns detalhes estão ocultos para a sua função."
    },
    "redact": {
      "title": "Remover {{kind}} deste registo",
      "description": "O conteúdo é removido permanentemente. O registo guarda uma nota de que foi removido, quando e porquê. Não é possível anular.",
      "reasonLabel": "Motivo",
      "reasonRequired": "Escolha um motivo.",
      "confirm": "Remover permanentemente",
      "success": "Removido do registo",
      "notRedactable": "Este item já não tem nada a remover.",
      "failed": "Não foi possível remover o item."
    },
    "file": {
      "open": "Abrir",
      "opening": "A abrir…",
      "openAria": "Abrir {{name}}",
      "auditNote": "Cada abertura fica registada.",
      "openFailed": "Não foi possível abrir o ficheiro.",
      "unavailable": "Este ficheiro já não está disponível: foi removido do registo ou o período de conservação do registo terminou.",
      "notInStorage": "O ficheiro não estava armazenado quando o registo foi guardado, pelo que não é mantida nenhuma cópia."
    },
    "compare": {
      "title": "Na decisão · Atual",
      "show": "Comparar com o atual",
      "hide": "Ocultar comparação",
      "atDecision": "Na decisão",
      "current": "Atual",
      "comparedAt": "Comparado em {{date}}",
      "same": "Igual ao da decisão",
      "different": "Não é igual ao da decisão",
      "notComparable": "Não comparável",
      "currentDated": "valor atual datado de {{date}}",
      "withheldNow": "Atualmente não partilhado com esta empresa",
      "loadError": "Não foi possível carregar a comparação."
    },
    "summary": {
      "nothingAtTheTime": "Nada a registar nesse momento",
      "none": "Nada registado",
      "notScored": "Sem pontuação",
      "percent": "{{value}}%",
      "fraction": "{{done}} de {{total}}",
      "score": "Pontuação",
      "calculatedAt": "Calculado",
      "completedAt": "Concluído",
      "progress": "Progresso",
      "tasks": "Tarefas",
      "documents": "Documentos prontos",
      "missions": "Missões",
      "wellbeing": "Bem-estar",
      "checkpoints": "Pontos de controlo",
      "results": "Resultados",
      "resultsSent": "Resultados enviados",
      "miles": "Miles",
      "stamps": "Carimbos",
      "badges": "Emblemas",
      "fileName": "Ficheiro",
      "fileSize": "Tamanho",
      "uploadedAt": "Carregado",
      "members": "Membros",
      "checkins": "Check-ins",
      "lastCheckin": "Último check-in",
      "nothingNow": "Nada a mostrar agora",
      "files": "Ficheiros"
    },
    "verdict": {
      "title": "Histórico de decisões",
      "earlier": "Decisões anteriores ({{count}})",
      "replacedValue": "Substituiu uma decisão anterior: {{verdict}}",
      "replacedNotRecorded": "Uma eventual decisão anterior não foi registada",
      "viewRecord": "Ver registo",
      "loadError": "Não foi possível carregar o histórico de decisões."
    },
    "notice": {
      "title": "Algumas empresas mantêm um registo",
      "introFile": "O ficheiro saiu do seu cofre. Estas empresas tomaram uma decisão sobre si que o incluía e mantêm o seu próprio registo dessa decisão:",
      "introAccount": "A sua conta foi eliminada. Estas empresas tomaram uma decisão sobre si e mantêm o seu próprio registo dela:",
      "listLabel": "Empresas que mantêm um registo",
      "what": "O quê",
      "until": "Até",
      "why": "Porquê",
      "noEndDate": "Ainda sem data de fim — é definida quando a decisão deles chegar a um desfecho",
      "acknowledge": "Compreendi"
    }
  },
  "family": {
    "admin": "Admin",
    "children": "Crianças",
    "complete": "completo",
    "emailPlaceholder": "membro@exemplo.com",
    "enableFamilyPlan": "Ativar plano familiar",
    "familyPlan": "Plano familiar",
    "hasPartner": "Tem parceiro",
    "hasPets": "Tem animais de estimação",
    "householdConfig": "A sua configuração familiar",
    "householdContext": "Contexto familiar",
    "invalidEmail": "Por favor, insira um endereço de email válido",
    "inviteFamilyMember": "Convidar membro da família",
    "inviteMember": "Convidar membro",
    "inviteSent": "Convite enviado para {{email}}",
    "journeys": "Percursos",
    "manageMembers": "Gerir membros",
    "master": "Mestre",
    "member": "Membro",
    "members": "Membros",
    "membersAccess": "Membros da família com acesso a percursos partilhados",
    "noMembers": "Ainda não foram adicionados membros da família",
    "pendingName": "Pendente",
    "removeMember": "Remover membro",
    "removeMemberConfirm": "Remover este membro da família?",
    "role": "Função",
    "sendInvitation": "Enviar um convite para juntar-se ao seu plano familiar",
    "sendInvite": "Enviar convite",
    "shareJourney": "Partilhe o seu percurso com membros da família e acompanhe o progresso juntos.",
    "sharedJourneys": "Instâncias de percurso partilhado",
    "sharedJourneysSubtitle": "Percursos partilhadas com membros da família",
    "title": "Programa familiar",
    "invite": {
      "emailPlaceholder": "membro@exemplo.com"
    }
  },
  "familyProgram": {
    "accepted": "Aceite",
    "accessRevoked": "Acesso revogado com sucesso",
    "accessRules": "Regras de acesso",
    "accessRulesDesc": "Quem pode aceder a quais funcionalidades",
    "addFamilyMember": "Adicionar membro da família",
    "addMember": "Adicionar membro",
    "care": "Care",
    "careRule": "Apenas o Family Master pode responder aos pontos de verificação Care. O Companion não tem acesso.",
    "career": "Career & oportunidades",
    "careerRule": "O Family Master e o Companion podem aceder às suas próprias Career & Oportunidades",
    "checkup": "CheckUp",
    "checkupRule": "O Family Master e o Companion podem completar a sua própria avaliação CheckUp",
    "children": "Crianças",
    "childrenCount": "Contagem de crianças",
    "complete": "Completo",
    "copilotTip": "Dica CoPilot",
    "description": "Gerir acesso e permissões do agregado familiar",
    "disabled": "Desativado",
    "docs": "Documentos",
    "docsComplete": "Documentos completos",
    "documents": "Documentos",
    "documentsIncompleteMessage": "Os documentos de {{name}} estão incompletos. Carregue os documentos necessários para prosseguir com a candidatura ao visto.",
    "editMember": "Editar membro",
    "educationSupport": "Apoio educacional",
    "educationSupportDesc": "Assistência na colocação escolar, aulas de línguas e recursos educativos.",
    "emailAddress": "Endereço de email",
    "enabled": "Ativado",
    "familyAddonRequired": "Add-on familiar necessário",
    "familyAddonRequiredDesc": "O Programa Familiar requer Pro Journey, Journey Pack ou plano patrocinado. Atualize para ativar o Programa Familiar.",
    "familyAdmin": "Administrador familiar",
    "familyAdminDesc": "Pode gerir membros da família e definições",
    "familyMaster": "Mestre da família",
    "familyMember": "Membro da família",
    "familyMemberDesc": "Membro da família com acesso apenas Citizen",
    "familySponsored": "Patrocinado pela família",
    "familySupportBenefits": "Benefícios de apoio familiar",
    "householdContext": "Contexto familiar",
    "householdContextDesc": "A sua configuração familiar",
    "householdCouple": "Casal",
    "householdCouplePets": "Casal + animais de estimação",
    "householdFamily": "Família",
    "householdFamilyPets": "Família + animais de estimação",
    "householdReadinessOverTime": "Progresso de prontidão do agregado familiar ao longo do tempo",
    "householdSingle": "Solteiro",
    "householdSingleParent": "Pai/Mãe solteiro(a)",
    "householdSinglePets": "Solteiro + animais de estimação",
    "householdType": "Tipo de agregado familiar",
    "incomplete": "Incompleto",
    "invalidEmail": "Por favor, insira um endereço de email válido",
    "inviteError": "Falha ao enviar convite",
    "inviteMember": "Convidar membro",
    "inviteMemberDesc": "Convide um membro da família para se juntar ao seu percurso",
    "inviteNote": "Os membros da família receberão um convite por e-mail para se juntarem ao seu percurso. Eles terão acesso ao conteúdo QultureUp e podem acompanhar o seu próprio progresso.",
    "inviteSent": "Convite enviado para {{email}}",
    "journeyInstance": "Instância do percurso",
    "management": "Gestão",
    "members": "Membros da família",
    "membersDescription": "Gerir acesso para membros da família",
    "milesAndLessonsPerMember": "Miles e lições completadas por membro",
    "monitoring": "Care",
    "monitoringSection": {
      "achievements": "Conquistas",
      "acrossAllMembers": "em todos os membros",
      "active": "ativo",
      "badgesEarned": "distintivos ganhos",
      "careNote": "Os pontos de verificação Care são respondidos pelo Family Master em nome do agregado familiar",
      "checkup": "CheckUp",
      "dayStreak": "sequência de dias",
      "events": "eventos",
      "householdStability": "Estabilidade do agregado familiar",
      "householdStabilityDesc": "Pontuações atuais dos pilares Care (conhecedor do agregado familiar, respondido pelo Family Master)",
      "lessons": "lições",
      "lessonsCompleted": "lições completadas",
      "memberProgress": "Progresso do membro",
      "memberProgressDesc": "Rastreamento de progresso individual para cada membro da família",
      "memberReadiness": "Prontidão do membro",
      "noActivity": "Sem atividade ainda",
      "noMembersToMonitor": "Sem membros da família para seguir ainda",
      "noReadinessData": "Sem dados de prontidão disponíveis para o Acompanhante",
      "noRecentActivity": "Sem atividade recente",
      "notAvailable": "Não disponível",
      "progressTrends": "Tendências de progresso",
      "progressTrendsDesc": "Visualizar o progresso da família ao longo do tempo",
      "qultureupMiles": "QultureUp Miles",
      "qultureupProgress": "Progresso QultureUp",
      "readinessEvolution": "Evolução da prontidão",
      "recentActivity": "Atividade recente",
      "teleportalProgress": "TelePortal",
      "totalAchievements": "Total de conquistas",
      "totalMembers": "Total de membros",
      "totalMiles": "Total de Miles",
      "totalQultureupMiles": "Total de Miles QultureUp"
    },
    "noJourneyInstance": "Sem percurso ativo",
    "noMembers": "Ainda não foram convidados membros da família",
    "noSharedJourneys": "Sem instâncias de percurso partilhadas",
    "passport": "Passport",
    "passportRule": "Cada membro vê a sua própria visão filtrada. O acompanhante acede através da aplicação móvel Tonnie Citizen.",
    "pending": "Pendente",
    "petsPresence": "Animais de estimação",
    "pillar": {
      "housingStability": "Estabilidade habitacional",
      "schoolingChildcare": "Educação e cuidados infantis",
      "wellbeing": "Bem-estar",
      "workFit": "Adequação ao trabalho"
    },
    "purchaseFamilyAddon": "Comprar add-on familiar",
    "qultureup": "QultureUp",
    "qultureupPercent": "QultureUp %",
    "qultureupRule": "Todos os membros da família acedem através da aplicação móvel Tonnie Citizen (o acompanhante não pode aceder através do Citizen Web)",
    "readinessPercent": "Prontidão %",
    "removeError": "Falha ao remover membro",
    "removeMember": "Remover membro",
    "revokeAccess": "Revogar acesso",
    "role": "Função",
    "schoolReady": "Pronto para a escola",
    "sendInvite": "Enviar convite",
    "servicesAvailable": "Serviços disponíveis para a sua família",
    "sharedJourneyInstances": "Instâncias de percurso partilhado",
    "sharedJourneyInstancesDesc": "Instâncias de percurso partilhadas com membros da família",
    "spouseEmployment": "Emprego do cônjuge",
    "spouseEmploymentDesc": "Apoio à procura de emprego, oportunidades de networking e orientação sobre vistos de trabalho.",
    "status": "Estado do programa familiar",
    "statusDescription": "Estado atual do seu Programa Familiar",
    "teleportal": "TelePortal",
    "teleportalRule": "Apenas o Family Master pode controlar as tarefas TelePortal. O Companion não tem acesso.",
    "title": "Programa familiar",
    "totalMiles": "Total de Miles",
    "tryAgainLater": "Por favor, tente novamente mais tarde",
    "unableToLoad": "Incapaz de carregar membros da família",
    "viewDetails": "Ver detalhes",
    "visa": "Visto",
    "visaApproved": "Aprovado",
    "visaDenied": "Negado",
    "visaInProgress": "Em progresso",
    "visaNotStarted": "Não iniciado",
    "visaStatus": "Estado do visto",
    "visasApproved": "Visas aprovados",
    "wellbeingCare": "Bem-estar Care",
    "wellbeingCareDesc": "Inscrição em cuidados de saúde, apoio à saúde mental e integração social.",
    "yearsOld": "{{age}} anos",
    "you": "Eu",
    "sharedJourneyCount_one": "{{count}} percurso partilhado",
    "sharedJourneyCount_other": "{{count}} percursos partilhados"
  },
  "feedback": {
    "additionalFeedbackHint": "Pode dar feedback detalhado e anexar capturas de ecrã ou ficheiros para nos ajudar a perceber melhor a sua experiência.",
    "attachFiles": "Anexar ficheiros",
    "attachFilesOptional": "Anexar ficheiros (opcional)",
    "category": {
      "bug": {
        "description": "Algo não está a funcionar",
        "label": "Relatório de erro"
      },
      "other": {
        "description": "Algo mais",
        "label": "Outro"
      },
      "praise": {
        "description": "Adoro esta funcionalidade",
        "label": "Elogio"
      },
      "question": {
        "description": "Preciso de ajuda",
        "label": "Pergunta"
      },
      "suggestion": {
        "description": "Tenho uma ideia",
        "label": "Sugestão"
      }
    },
    "categoryDescription": "Selecione a categoria que melhor descreve o seu feedback",
    "categoryQuestion": "Que tipo de feedback é este?",
    "characterCount": "{{current}} / {{max}} caracteres",
    "characters": "{{current}}/{{max}} caracteres",
    "close": "Fechar feedback",
    "context": {
      "hero": "Herói",
      "heroPlaceholder": "ex., CheckUp, TelePortal",
      "notDetected": "Nenhum contexto detetado",
      "page": "Página",
      "pagePlaceholder": "ex., /dashboard, /checkup"
    },
    "contextInfo": "Informação de contexto",
    "contextSaved": "Informação de contexto guardada",
    "detailsDescription": "Por favor, forneça detalhes sobre o seu feedback",
    "detailsPlaceholder": "Descreva o seu feedback, sugestão ou problema...",
    "detailsQuestion": "Conte-nos mais",
    "editContext": "Editar",
    "fileSizeError": "O tamanho do ficheiro excede o limite máximo de {{maxSize}}",
    "fileSizeLimit": "Os ficheiros devem ter menos de 20MB",
    "fileUploadDescription": "Adicione capturas de ecrã, PDFs ou outros ficheiros (até 20MB cada) para nos ajudar a entender melhor o seu feedback.",
    "optional": "Opcional",
    "placeholder": "Partilhe os seus pensamentos...",
    "pleaseDescribe": "Por favor, descreva o seu feedback em detalhe",
    "privacyNote": "O seu feedback é anónimo e ajuda-nos a melhorar Tonnie",
    "rating": {
      "1": "Muito insatisfeito",
      "2": "Insatisfeito",
      "3": "Neutro",
      "4": "Satisfeito",
      "5": "Muito satisfeito",
      "veryDissatisfied": "Muito insatisfeito",
      "dissatisfied": "Insatisfeito",
      "neutral": "Neutro",
      "satisfied": "Satisfeito",
      "verySatisfied": "Muito satisfeito"
    },
    "ratingDescription": "Classifique a sua satisfação geral",
    "ratingQuestion": "Como foi a sua experiência?",
    "selectRatingAndCategory": "Por favor, selecione tanto a classificação como a categoria",
    "submit": "Enviar feedback",
    "submitError": "Falha ao enviar feedback. Por favor, tente novamente.",
    "submitFeedback": "Enviar feedback",
    "submitSuccess": "Obrigado! O seu feedback foi enviado.",
    "submitted": "O seu feedback foi enviado.",
    "submitting": "A submeter...",
    "subtitle": "Ajude-nos a melhorar a sua experiência",
    "successMessage": "Agradecemos por dedicar o seu tempo a ajudar-nos a melhorar Tonnie. O seu feedback foi recebido e será analisado pela nossa equipa.",
    "successTitle": "Obrigado pelo seu feedback!",
    "tellUsMore": "Conte-nos mais",
    "thankYou": "Obrigado!",
    "thankYouMessage": "O seu feedback ajuda-nos a melhorar Tonnie.",
    "title": "Partilhar feedback",
    "toggle": "Enviar feedback",
    "totalFileSize": "Total: {{size}} / {{maxSize}}",
    "totalSize": "Total: {{size}} / 20MB máximo",
    "uploadFiles": "Carregar ficheiros",
    "validationError": "Por favor, preencha todos os campos obrigatórios",
    "attachImages": "Anexar capturas de ecrã",
    "removeImage": "Remover {{name}}",
    "aria": {
      "description": "Descrição do feedback",
      "uploadFiles": "Carregar ficheiros",
      "removeFile": "Remover {{name}}",
      "satisfactionRating": "Classificação de satisfação",
      "ratingOption": "{{label}} – {{value}} em 5"
    }
  },
  "form": {
    "addressSearch": {
      "city": "Cidade: ",
      "country": "País: ",
      "postalCode": "Código postal: "
    },
    "datePicker": {
      "cancel": "Cancelar",
      "done": "Feito",
      "months": [
        "janeiro",
        "fevereiro",
        "março",
        "abril",
        "maio",
        "junho",
        "julho",
        "agosto",
        "setembro",
        "outubro",
        "novembro",
        "dezembro"
      ],
      "placeholder": "Selecionar data",
      "selectDate": "Selecionar data",
      "day": "Dia",
      "month": "Mês",
      "year": "Ano"
    },
    "phoneCountryCode": {
      "clearSearch": "Limpar pesquisa",
      "noCountriesFound": "Nenhum país encontrado",
      "placeholder": "+XX",
      "searchPlaceholder": "Pesquisar país ou código...",
      "selectCountryCode": "Selecionar código do país"
    },
    "countrySelect": {
      "searchPlaceholder": "Procurar países"
    },
    "countryList": {
      "remove": "Remover {{country}}"
    },
    "timePicker": {
      "hour": "Hora",
      "minute": "Minuto"
    }
  },
  "gating": {
    "upgrade": "Atualizar",
    "lockedLabel": "Bloqueado",
    "upgradeToUnlock": "Faça upgrade para desbloquear",
    "unlockJourney": {
      "title": "Desbloqueie a sua Percurso",
      "qultureup": "Para desbloquear esta missão do QultureUp, abra o Portal Web e desbloqueie o seu percurso para acesso completo.",
      "teleportal": "Para desbloquear esta tarefa do TelePortal, abra o Portal Web e desbloqueie o seu percurso para acesso completo."
    },
    "upgradeBanner": {
      "passport": "Atualize para Pro para desbloquear análises de passaporte, exportação e funcionalidades de partilha.",
      "qultureup": "Atualize para Pro para aceder a todos os mundos, lições e conteúdos de criadores em QultureUp.",
      "teleportal": "Atualize para Pro para carregar documentos, validar com revisão de IA e desbloquear todas as fases de TelePortal."
    }
  },
  "heroes": {
    "care": {
      "description": "Checkpoints e suporte pós-chegada",
      "title": "Care"
    },
    "career": {
      "description": "Oportunidades & construtor de CV",
      "title": "Career"
    },
    "checkup": {
      "description": "Avaliação de prontidão pré-imigração",
      "readinessScore": "Score de prontidão",
      "title": "CheckUp"
    },
    "passport": {
      "badges": "Emblemas",
      "description": "A sua linha do tempo de percurso",
      "stamps": "Selos",
      "timeline": "Cronograma",
      "title": "Passport"
    },
    "qultureup": {
      "description": "Adaptação Cultural",
      "level2Basics": "Nível 2: Básicos",
      "title": "QultureUp"
    },
    "teleportal": {
      "actionRequired": "Ação necessária",
      "description": "Realocação & Mobilidade",
      "title": "TelePortal",
      "visaProcess": "Processo de visto"
    },
    "vault": {
      "allDocuments": "Todos os documentos",
      "category": {
        "other": "Outro"
      },
      "chooseCategoryDesc": "Selecione o herói a que este documento pertence.",
      "chooseCategoryTitle": "Escolha uma categoria",
      "detail": {
        "by": "Por",
        "certification": "Certificação",
        "details": "Detalhes",
        "documentIdentity": "Identidade do documento",
        "expires": "Expira",
        "issuingAuthority": "Autoridade emitente",
        "location": "Localização",
        "size": "Tamanho",
        "status": "Estado",
        "tags": "Etiquetas",
        "type": "Tipo",
        "uploaded": "Carregado",
        "validation": "Validação",
        "validityPeriod": "Período de validade"
      },
      "documents": "documentos",
      "downloadAll": "Descarregar tudo",
      "downloadSelected": "Transferir {{count}}",
      "downloadToView": "Descarregar para visualizar",
      "selectDocument": "Selecionar documento",
      "emptyState": "Os seus documentos de todos os heróis aparecerão aqui",
      "fetchError": "Falha ao carregar o cofre",
      "filter": {
        "allStatus": "Todos os status",
        "certification": {
          "label": "Certificação",
          "none": "Sem certificação"
        },
        "clear": "Limpar",
        "expired": "Expirado",
        "expiringSoon": "A expirar em breve",
        "expiry": "Data de expiração",
        "sort": "Ordenar",
        "status": "Estado",
        "tags": "Etiquetas",
        "valid": "Válido"
      },
      "noDocuments": "Ainda sem documentos",
      "noResults": "Nenhum documento encontrado",
      "previewError": "A pré-visualização não pôde ser carregada",
      "previewUnavailable": "Pré-visualização não disponível para este tipo de ficheiro",
      "removeConfirmDesc": "Esta ação não pode ser desfeita. O documento será removido permanentemente.",
      "removeDocument": "Remover documento?",
      "searchPlaceholder": "Pesquisar documentos...",
      "sort": {
        "largestFirst": "Maior primeiro",
        "nameAZ": "Nome A-Z",
        "nameZA": "Nome Z-A",
        "newestFirst": "Mais recentes primeiro",
        "oldestFirst": "Mais antigos primeiro",
        "smallestFirst": "Menor primeiro"
      },
      "status": {
        "all": "Todos os estados",
        "pending": "Pendente",
        "rejected": "Rejeitado",
        "uploaded": "Carregado",
        "validated": "Validado"
      },
      "subtitle": "Todos os documentos do seu percurso num só lugar seguro",
      "tag": {
        "approved": "Aprovado",
        "archived": "Arquivado",
        "expiringSoon": "A expirar em breve",
        "important": "Importante",
        "pendingReview": "Revisão pendente",
        "urgent": "Urgente"
      },
      "title": "Cofre",
      "track": {
        "legal": "Legal",
        "setup": "Configuração",
        "travel": "Viagem"
      },
      "verifiedByTonnie": "Verificado por Tonnie",
      "view": {
        "grid": "Vista em grelha",
        "list": "Vista de lista",
        "timeline": "Vista do cronograma"
      },
      "viewDetails": "Ver detalhes",
      "documentActions": "Ações de documentos",
      "searchLabel": "Pesquisar documentos",
      "topic": {
        "pitchVideo": "Vídeo de apresentação",
        "languageTest": "Teste de língua",
        "cv": "CV"
      },
      "links": {
        "title": "Utilizado em",
        "trip": "Viagem de {{from}} a {{to}}",
        "tripAway": "Viagem desde {{from}}, ainda fora",
        "task": "Tarefa do TelePortal: {{document}}",
        "taskUnnamed": "Uma tarefa do TelePortal",
        "removeWarning": "Ao removê-lo, sai também de onde é utilizado — cada viagem perde esta prova e cada tarefa vai precisar de um documento outra vez:",
        "count_one": "Utilizado em 1 sítio",
        "count_other": "Utilizado em {{count}} sítios"
      }
    }
  },
  "invitations": {
    "error": {
      "acceptFailedTitle": "Não conseguimos aceitar este convite",
      "alreadyAcceptedDescription": "Este convite já foi aceite por outra conta.",
      "alreadyAcceptedTitle": "Já aceite",
      "backHome": "Voltar para casa",
      "declinedDescription": "Este convite foi recusado. Peça à {{company}} que envie um novo, se foi por engano.",
      "declinedTitle": "Convite recusado",
      "emailMismatchDescription": "Este convite é para {{email}}. Desconecte-se e conecte-se com esse endereço para aceitar.",
      "emailMismatchTitle": "Conta errada",
      "emailUnverifiedDescription": "O endereço para onde este convite foi enviado está na sua conta, mas ainda não foi confirmado.",
      "emailUnverifiedTitle": "Confirme primeiro este endereço",
      "expiredDescription": "Peça à empresa com a qual tem falado para enviar um novo convite.",
      "expiredTitle": "Este convite expirou",
      "invalidLinkDescription": "Este link está a faltar o token de convite. Verifique o e-mail que recebeu e tente novamente.",
      "invalidLinkTitle": "Link de convite inválido",
      "notFoundDescription": "O link pode estar incompleto. Certifique-se de que usou o e-mail mais recente.",
      "notFoundTitle": "Não conseguimos encontrar esse convite",
      "revokedDescription": "A empresa retirou este convite. Contacte-os se achar que isto é um erro.",
      "revokedTitle": "Este convite foi revogado",
      "tryAgain": "Por favor, tente novamente dentro de momentos.",
      "wrongPortalDescription": "Este convite é para uma conta de cidadão Tonnie. Inicie sessão com a sua conta de cidadão para o abrir.",
      "wrongPortalTitle": "Use a sua conta de cidadão",
      "requestNotYoursTitle": "Este pedido é para outra conta",
      "requestNotYoursDescription": "Inicie sessão com a conta com que esta empresa trabalha para responder.",
      "requestClosedTitle": "Este pedido já não pode ser respondido",
      "requestClosedDescription": "A sua relação com esta empresa já não está ativa, por isso nada mais pode ser partilhado com ela."
    },
    "preview": {
      "acceptCta": "Aceitar convite",
      "accepting": "A aceitar…",
      "branch": "Filial",
      "declineCta": "Recusar",
      "declining": "A recusar…",
      "destination": "Destino",
      "emailHint": "Este convite é para {{email}}",
      "expires": "Este convite expira em {{date}}",
      "headline": "Foi convidado",
      "invitingYou": "Convite de",
      "loading": "A carregar o seu convite…",
      "location": "Localização",
      "opportunity": "Oportunidade",
      "signInCta": "Inicie sessão para aceitar",
      "signUpCta": "Registe-se para aceitar",
      "subheadline": "A {{company}} gostaria que fizesse um CheckUp para explorar uma oportunidade internacional. É gratuito e demora cerca de 20 minutos.",
      "subheadlineNamed": "Olá {{firstName}} — a {{company}} gostaria que fizesse um CheckUp para explorar uma oportunidade internacional. É gratuito e demora cerca de 20 minutos.",
      "subheadlineTestit": "A {{company}} gostaria que completasse alguns testes específicos para explorar uma oportunidade internacional. É grátis e os seus resultados são reutilizáveis.",
      "subheadlineTestitNamed": "Olá {{firstName}} — a {{company}} gostaria que completasse alguns testes específicos para explorar uma oportunidade internacional. É grátis e os seus resultados são reutilizáveis.",
      "testitTestsLabel": "O que vai completar"
    },
    "identity": {
      "addEmailBody": "A {{company}} enviou este convite para {{email}}. Adicione esse endereço à sua conta e confirme-o para aceitar sem ter de começar de novo.",
      "addEmailCta": "Adicionar e confirmar este endereço",
      "addEmailError": "Não conseguimos adicionar esse endereço. Tente novamente daqui a um momento.",
      "addEmailTitle": "Este convite é para outro endereço",
      "cancelCta": "Cancelar",
      "codeInvalid": "Esse código não está correto. Verifique-o e tente de novo.",
      "codeLabel": "Código de 6 dígitos",
      "codeSentBody": "Enviámos um código de 6 dígitos para {{email}}. Introduza-o abaixo para concluir a confirmação.",
      "codeSentHint": "Enviado para {{email}}. Expira dentro de alguns minutos.",
      "codeSentTitle": "Veja a sua caixa de entrada",
      "invitedAddress": "Convite enviado para",
      "sendCodeCta": "Enviar-me um código",
      "sending": "A enviar…",
      "signedInAs": "Sessão iniciada como",
      "switchAccountCta": "Iniciar sessão com outra conta",
      "switchAccountHint": "Voltarás a este convite depois de iniciares sessão.",
      "tryAgainCta": "Tentar de novo",
      "unverifiedBody": "{{email}} já está na sua conta, mas ainda não foi confirmado. A {{company}} enviou este convite para lá, por isso confirmá-lo prova que é seu.",
      "unverifiedTitle": "Confirme este endereço para continuar",
      "verifyCta": "Confirmar e continuar",
      "verifyError": "Não conseguimos confirmar esse endereço. Tente novamente daqui a um momento.",
      "verifying": "A confirmar…"
    },
    "card": {
      "eyebrow": "Convite",
      "titleCheckup": "A {{company}} convidou-o para um CheckUp",
      "titleTestit": "A {{company}} pediu-lhe alguns testes",
      "detail": "Enviado para {{email}} · mudança para {{country}}",
      "detailNoCountry": "Enviado para {{email}}",
      "expires": "Expira a {{date}}",
      "review": "Ver convite",
      "notNow": "Agora não",
      "decline": "Recusar",
      "actionFailed": "Não foi possível concluir. Verifique a ligação e tente novamente.",
      "declineTitle": "Recusar o convite da {{company}}?",
      "declineBody": "A {{company}} vai saber que recusou, e este convite deixa de poder ser usado.",
      "declineConfirm": "Recusar convite",
      "declineCancel": "Manter"
    },
    "review": {
      "title": "Juntar-se à {{company}}",
      "bodyCheckup": "A {{company}} pede-lhe que faça um CheckUp para a sua mudança para {{country}}.",
      "bodyCheckupNoCountry": "A {{company}} pede-lhe que faça um CheckUp.",
      "accept": "Aceitar convite",
      "accepting": "A aceitar…",
      "residenceBody": "O seu percurso com a {{company}} começa aqui e abre no momento em que aceitar.",
      "deferredUntil": "Adiou este convite por agora. Fica aqui à espera até decidir e volta ao Início a {{date}}."
    },
    "claim": {
      "title": "Esse endereço tem uma conta Tonnie própria",
      "subtitle": "{{email}} pertence a outra conta Tonnie.",
      "body": "Se essa conta também é sua, pode aceitar aqui o convite de {{company}}. Enviamos um código para esse endereço para confirmar que é seu.",
      "sendCta": "Enviar-me um código",
      "sending": "A enviar…",
      "switchInstead": "Entrar antes com essa conta",
      "codeSentBody": "Enviámos um código de 6 dígitos para {{email}}. Expira dentro de {{minutes}} minutos.",
      "resendCta": "Enviar um novo código",
      "resendIn": "Enviar um novo código dentro de {{seconds}} s",
      "codeWrong_one": "Esse código não está certo. Resta {{count}} tentativa.",
      "codeWrong_other": "Esse código não está certo. Restam {{count}} tentativas.",
      "codeExpired": "Esse código expirou ou já foi esgotado. Envie um novo.",
      "tooManyCodes": "Já enviámos vários códigos. Tente mais tarde.",
      "noOtherAccount": "Nenhuma outra conta Tonnie usa agora este endereço. Adicione-o antes a esta conta.",
      "failed": "Algo correu mal. Tente novamente.",
      "retireNote": "{{email}} está confirmado como seu. A sua outra conta Tonnie com este endereço não tem nada, por isso será encerrada quando aceitar. Ficará com uma só conta.",
      "keptNote": "{{email}} está confirmado como seu. A sua outra conta Tonnie com este endereço mantém o seu percurso, e continua a poder entrar nela."
    },
    "choice": {
      "checking": "A verificar os seus percursos…",
      "loadFailed": "Não foi possível carregar os seus percursos. Tente novamente antes de aceitar.",
      "legend": "Que percurso partilha com a {{company}}?",
      "route": "{{origin}} → {{destination}}",
      "companyJourney": "A {{company}} já o acompanha neste percurso",
      "sharedWith": "Também partilhada com {{companies}}",
      "checkupShared": "A {{company}} vai ver o seu CheckUp de {{date}}",
      "newTitle": "Um novo percurso para a {{company}}",
      "newBody": "Começa do zero: a {{company}} só vê o que fizer nela a partir de agora.",
      "newCapped_one": "Já tem {{count}} percurso nesta rota — o máximo possível. Arquive-o para começar outro.",
      "newCapped_other": "Já tem {{count}} percursos nesta rota — o máximo possível. Arquive um para começar outro.",
      "newOnly": "Vamos começar um novo percurso para {{country}} para a {{company}}.",
      "newOnlyNoCountry": "Vamos começar um novo percurso para a {{company}}.",
      "blocked_one": "O seu percurso nesta rota pertence a outra empresa, e já tem {{count}} — o máximo por rota. Arquive um para aceitar o convite da {{company}}.",
      "blocked_other": "Os seus percursos nesta rota pertencem a outras empresas, e já tem {{count}} — o máximo por rota. Arquive um para aceitar o convite da {{company}}."
    },
    "list": {
      "title": "A {{company}} convidou-o",
      "deferredUntil": "Adiado até {{date}}",
      "expires": "Válido até {{date}}",
      "openHint": "Abre o convite para o aceitar ou recusar"
    },
    "request": {
      "eyebrow": "Pedido",
      "titleCheckup": "A {{company}} pede para ver a pontuação do seu CheckUp",
      "titleTests": "A {{company}} pede para ver os seus resultados em {{tests}}",
      "cardBody": "Nada é partilhado até decidir. Veja o que passariam a ver e depois decida.",
      "bodyCheckupScored": "A sua pontuação está pronta. Nada é partilhado até decidir.",
      "bodyCheckupPending": "Se partilhar, veem a sua pontuação quando o CheckUp estiver calculado. Nada é partilhado até decidir.",
      "bodyTests": "Os resultados que já tem são reutilizados. Nada é partilhado até decidir.",
      "willSeeTitle": "Se partilhar, a {{company}} vê",
      "wontSeeTitle": "A {{company}} continua sem ver",
      "new": "Novo",
      "share": "Partilhar",
      "sharing": "A partilhar…",
      "declineTitle": "Recusar o pedido da {{company}}?",
      "declineBody": "A {{company}} é informada. Nada mais muda: continua a ver apenas o que partilhou antes.",
      "declineConfirm": "Recusar pedido",
      "sharedToast": "Partilhado com a {{company}}",
      "sharedToastBody": "Já o podem ver. Pode mudar o que veem a qualquer momento em As meus percursos.",
      "declinedToast": "Recusou o pedido da {{company}}",
      "listTitle": "A {{company}} pede para ver mais",
      "kindCheckup": "A pontuação do seu CheckUp",
      "kindTests": "Os seus resultados de testes",
      "signInBody": "Inicie sessão na conta com que a {{company}} trabalha para ver exatamente o que pede, e decidir.",
      "signIn": "Iniciar sessão",
      "notWaitingTitle": "Este pedido não está à sua espera",
      "notWaitingBody": "Já foi respondido ou retirado, ou é para outra conta."
    },
    "testit": {
      "title": "A {{company}} pede os resultados dos seus testes",
      "body": "A {{company}} pede-lhe os testes abaixo. Faz os que ainda não fez depois de aceitar.",
      "bodyAllDone": "Já fez todos os testes que a {{company}} pede. Não há nada de novo para fazer.",
      "listLabel": "O que a {{company}} pede",
      "testDone": "Já feito — o seu resultado de {{date}} será partilhado",
      "testPending": "Para fazer depois de aceitar",
      "scopeTestsOnly": "Ao aceitar, partilha os resultados destes testes com a {{company}}. Não partilha o seu CheckUp.",
      "scopeUnchanged": "Ao aceitar, acrescenta os resultados destes testes. A {{company}} continua a ver o que já partilha com ela.",
      "accept": "Aceitar e fazer os testes",
      "acceptShare": "Partilhar os meus resultados",
      "confirmTitle": "Os seus resultados foram partilhados com a {{company}}",
      "confirmBody": "A {{company}} já pode ver os seus resultados nestes testes. Não lhe falta fazer nada.",
      "confirmDone": "Concluir"
    }
  },
  "journey": {
    "arrives": "Chega {{date}}",
    "buildFirstJourney": "Construa a sua primeiro percurso internacional para começar",
    "buildYourFirstJourney": "Construa a sua primeiro percurso",
    "builder": {
      "title": "Construtor de percurso",
      "createErrorFallback": "Falha ao criar percurso",
      "notAuthenticated": "Deve estar autenticado para continuar",
      "missingCountries": "Não conseguimos identificar onde começa e termina o seu percurso. Escolha o seu país atual e o seu destino e tente novamente.",
      "alsoToDestination": "Também tem um percurso para {{destination}} a partir de {{origins}}.",
      "advice": {
        "title": "Já tem esta rota",
        "body": "Já tem um percurso de {{origin}} para {{destination}}. Abra-o, ou crie outro.",
        "capTitle": "Esta rota está completa",
        "capBody_one": "Já tem {{count}} percurso de {{origin}} para {{destination}} — o máximo por rota. Abra-o.",
        "capBody_other": "Já tem {{count}} percursos de {{origin}} para {{destination}} — o máximo por rota. Abra um deles.",
        "listLabel": "Os seus percursos nesta rota",
        "open": "Abrir",
        "buildAnother": "Criar outra",
        "notNow": "Agora não"
      }
    },
    "daysOnJourney": "Dias no percurso",
    "details": {
      "amount": "Montante",
      "featuresIncluded": "Recursos incluídos",
      "paymentInfo": "Informações de pagamento",
      "scenario": "Cenário",
      "scenario_already_abroad": "Já no estrangeiro",
      "scenario_integration_only": "Apenas integração",
      "scenario_pre_immigration": "Pré-Imigração",
      "scenario_relocation_only": "Apenas realocação",
      "status": "Estado",
      "title": "Detalhes do percurso",
      "type": "Tipo"
    },
    "expires": "Expira",
    "family": "Família",
    "govSponsored": "Patrocinado pelo governo",
    "guard": {
      "buildDescription": "Antes de poder aceder a esta funcionalidade, precisa de criar o seu percurso de carreira internacional. Isso leva apenas alguns minutos.",
      "buildFirst": "Construa a sua primeiro percurso",
      "buildNew": "Construir novo percurso",
      "buildTitle": "Construa primeiro o seu percurso",
      "builderHint": "O construtor de percursos vai ajudá-lo a definir a sua origem, destino e objetivos de carreira.",
      "expiredDescription": "Este percurso atingiu o fim do seu plano. Renove ou atualize para continuar a usar os seus heróis.",
      "expiredTitle": "O seu percurso expirou",
      "goToDashboard": "Ir para o painel",
      "loadErrorDescription": "Algo correu mal ao carregar os seus percursos. Os seus dados estão seguros — por favor, tente novamente.",
      "loadErrorTitle": "Não conseguimos carregar os seus percursos",
      "noActiveDescription": "Todos os seus percursos podem estar pausados, expirados ou concluídos. Selecione um no cabeçalho ou construa um novo.",
      "noActiveTitle": "Sem percurso ativo",
      "pausedDescription": "O acesso está temporariamente pausado — normalmente porque o pagamento de um patrocinador não foi processado, ou porque um administrador pausou o percurso. Contacte o seu patrocinador ou verifique a faturação para retomar.",
      "pausedTitle": "O seu percurso está pausado",
      "pendingSetupDescription": "Reservámos este percurso para si. Diga-nos de onde se está a mudar e ele abre de imediato.",
      "pendingSetupTitle": "Termine de configurar o seu percurso",
      "renewJourney": "Renovar",
      "selectDescription": "Tem de selecionar uma instância de percurso ativo para aceder a esta funcionalidade. Utilize o seletor de percursos no cabeçalho acima para escolher uma.",
      "selectTitle": "Selecione um percurso",
      "selectorHint": "Dica: Use o seletor de percurso na barra de navegação superior para alternar entre os seus percursos.",
      "unavailableDescription": "Este percurso já não está acessível. Escolha outro ou construa um novo percurso para continuar.",
      "unavailableTitle": "Percurso indisponível",
      "viewBilling": "Ver faturação",
      "errorTitle": "Não conseguimos carregar os seus percursos",
      "errorDescription": "Não conseguimos chegar ao servidor. Verifique a sua ligação e tente novamente.",
      "openSelector": "Abrir seletor de percurso",
      "openJourney": "Abrir a meu percurso"
    },
    "loadingJourneys": "A carregar percursos…",
    "milesToGo": "Miles a percorrer",
    "nextMilestone": "Próximo marco",
    "pro": "Pro",
    "progress": "Progresso",
    "selectJourney": "Selecionar percurso",
    "selector": {
      "andMore_one": "e mais 1",
      "andMore_other": "e mais {{count}}",
      "basicAccess": "Acesso básico",
      "buildFirst": "Crie a sua primeiro percurso",
      "buildNew": "Construir novo percurso",
      "buildOne": "Criar um percurso",
      "buildOneShort": "Criar percurso",
      "companiesHint": "Mostra todas as empresas deste percurso",
      "companiesTitle": "Empresas neste percurso",
      "company": "Empresa",
      "expired": "Expirado",
      "expiresOn": "Expira",
      "family": "Família",
      "from": "de {{country}}",
      "fromUnknown": "De desconhecido",
      "fullAccess": "Acesso completo",
      "government": "Governo",
      "invitedBy": "Convidado por {{company}}",
      "invitedOnly": "Convidado apenas",
      "loadingJourneys": "A carregar percursos…",
      "locked": "Bloqueado",
      "noJourneys": "Ainda sem percursos",
      "noJourneysDescription": "Ainda não tem nenhum percurso. Comece um para iniciar a sua mudança.",
      "noJourneysTitle": "Ainda sem percursos",
      "paused": "Pausado",
      "setupPending": "Configuração pendente",
      "sponsored": "Patrocinado",
      "unlocked": "Desbloqueado",
      "sharedWith": "Partilhada com {{company}}"
    },
    "sponsored": "Patrocinado",
    "status": {
      "active": "Ativo",
      "completed": "Completo",
      "draft": "Rascunho",
      "expired": "Expirado",
      "limited": "Limitado",
      "paused": "Pausado"
    },
    "statusActive": "Ativo",
    "statusExpired": "Expirado",
    "statusLimited": "Limitado",
    "switchBetweenJourneys": "Alternar entre os seus percursos ativos",
    "yourJourneyTo": "O seu percurso para {{country}}",
    "originPending": "Origem pendente",
    "invited": "Convidado",
    "yourJourneyToUnknown": "O seu percurso",
    "relationship": {
      "live": "Ativo",
      "archivedByCompany": "Arquivado pela empresa",
      "ended": "Terminado",
      "left": "Saiu"
    },
    "manage": {
      "accessUntil": "Acesso até {{date}}",
      "activeDescription": "Cada percurso guarda o seu próprio progresso no CheckUp, TelePortal e Care. O percurso atual é o que o seu painel mostra.",
      "activeSection": "Percursos ativas",
      "archive": "Arquivar",
      "archiveCanRestore": "Pode recuperá-la nesta página sempre que quiser.",
      "archiveConfirm": "Arquivar percurso",
      "archiveDialogDescription": "Sai da sua lista de percursos. Nada do que contém se perde.",
      "archiveDialogTitle": "Arquivar o seu percurso para {{destination}}?",
      "archiveFailed": "Não foi possível arquivar este percurso. Tente novamente.",
      "archiveKeepsProgress": "Nada é eliminado — o progresso no CheckUp, TelePortal e Care fica guardado com ela.",
      "archiveSwitchesCurrent": "Este é o seu percurso atual, por isso a Tonnie muda-o para outro, se tiver.",
      "archivedDescription": "Os percursos arquivados guardam tudo. Recupere um para continuar onde parou.",
      "archivedOn": "Arquivada a {{date}}",
      "archivedSection": "Arquivadas",
      "archivedToastBody": "O seu percurso para {{destination}} está arquivado. Nada foi eliminado.",
      "archivedToastTitle": "Percurso arquivado",
      "blockedLiveProgramBody": "Saia primeiro do programa — isso termina a sua relação com a empresa — e depois poderá arquivar este percurso.",
      "blockedLiveProgramTitle": "Uma empresa ainda mantém este programa",
      "blockedSponsorshipBody": "O patrocínio tem de terminar antes de este percurso poder ser arquivado.",
      "blockedSponsorshipTitle": "Este percurso é patrocinado",
      "continueJourney": "Continuar percurso",
      "current": "Atual",
      "emptyWithArchived": "Não tem nenhum percurso ativo. Comece um novo ou recupere um que arquivou.",
      "leaveConfirm": "Sair do programa",
      "leaveDialogTitle": "Sair do programa da {{company}}?",
      "leaveFailed": "Não foi possível retirá-lo do programa. Tente novamente.",
      "leaveFinerHint": "Só quer ocultar algumas coisas? Escolha exatamente o que podem ver.",
      "leaveKeepsJourney": "O seu percurso, o progresso e os seus documentos continuam a ser seus.",
      "leaveProgramme": "Sair do programa",
      "leaveCompanyProgramme": "Sair do programa, {{company}}",
      "leaveWithdrawsAccess": "Retira o acesso da {{company}} aos dados que partilhou neste percurso.",
      "leftToastCanArchive": "Deixaram de ver os seus dados e a relação terminou. Já pode arquivar este percurso.",
      "leftToastTitle": "Saiu do programa da {{company}}",
      "manageConsents": "O que veem",
      "manageJourneys": "Gerir percursos",
      "newJourney": "Novo percurso",
      "openExisting": "Abrir",
      "recoverArchived": "Recuperar um percurso arquivado ({{count}})",
      "restore": "Recuperar",
      "restoreFailed": "Não foi possível recuperar este percurso. Tente novamente.",
      "restoredToastTitle": "Percurso recuperada",
      "startedOn": "Iniciada a {{date}}",
      "subtitle": "Alterne entre os seus percursos, arquive as que não está a utilizar e decida o que as empresas podem ver.",
      "switchToJourney": "Mudar para este percurso",
      "title": "As meus percursos",
      "undo": "Anular",
      "actionsLabel": "Gerir percurso",
      "actionsHint": "Mantenha premido, ou use o menu de ações, para arquivar ou sair",
      "restoreCapTitle": "Esta rota está completa",
      "restoreCapBody_one": "Já tem {{count}} percurso ativo para {{destination}} a partir desta origem. Abra-o, ou arquive-o antes de restaurar este.",
      "restoreCapBody_other": "Já tem {{count}} percursos ativos para {{destination}} a partir desta origem. Abra um, ou arquive um antes de restaurar este.",
      "labelField": "Nome do percurso",
      "labelPlaceholder": "ex.: Trabalho — Lisboa",
      "nameIt": "Dar nome",
      "rename": "Mudar o nome",
      "renamedToast": "Nome do percurso alterado",
      "nameClearedToast": "Nome do percurso removido",
      "renameFailed": "Não foi possível guardar o nome. Tente novamente.",
      "leaveDialogDescriptionInvited": "A {{company}} convidou-o para o seu percurso para {{destination}}.",
      "leaveDialogDescriptionShared": "Partilhou o seu percurso para {{destination}} com a {{company}}.",
      "leaveEndsRelationship": "A sua relação com a {{company}} neste percurso termina. Podem voltar a convidá-lo, e é o utilizador quem decide se aceita.",
      "leftToastOtherProgramme": "Deixaram de ver os seus dados e a relação terminou. O programa de outra empresa continua neste percurso, por isso ele mantém-se.",
      "leftToastSponsorshipHolds": "Deixaram de ver os seus dados e a relação terminou. Um patrocínio continua ativo neste percurso, por isso ele mantém-se até o patrocínio terminar.",
      "archiveAfterSponsorship": "Este percurso é patrocinado até {{date}}. Pode arquivá-lo quando o patrocínio terminar.",
      "archiveAfterSponsorshipNoDate": "Há um patrocínio ativo neste percurso. Pode arquivá-lo quando o patrocínio terminar."
    },
    "consent": {
      "action": {
        "granted": "Partilhado",
        "narrowed": "Partilhou menos",
        "revoked": "Deixou de partilhar",
        "widened": "Partilhou mais"
      },
      "allRevoked": "Já não veem os seus resultados neste percurso.",
      "archivedByCompany": "Arquivado pela empresa",
      "changeFailed": "A alteração não foi aplicada. Nada mudou.",
      "changedToastBody": "{{company}} · {{scope}}",
      "empty": "Nenhuma empresa tem acesso aos seus dados neste percurso.",
      "grantedOn": "Partilhado desde {{date}}",
      "grantedToast": "Voltou a partilhar",
      "grantedUnknown": "Partilhado antes de começarmos a registar datas de consentimento",
      "groupJourney": "Neste percurso",
      "groupProfile": "Do seu perfil",
      "revokedToast": "Deixou de partilhar",
      "scope": {
        "care": "O meu registo Care",
        "care_checkins": "Os meus check-ins diários",
        "checkup": "Os meus resultados CheckUp",
        "cv": "O meu CV",
        "household": "Os dados da minha família",
        "irr": "O meu histórico de atividade",
        "passport_stamps": "Os meus selos e milhas Passport",
        "pitch_video": "A minha gravação de apresentação",
        "qultureup": "O meu progresso QultureUp",
        "teleportal": "O meu plano de mudança",
        "testit": "Os meus resultados TestIt"
      },
      "sharingCount": "{{shared}} de {{total}} partilhados",
      "subtitle": "Cada empresa abaixo tem acesso a uma parte do seu percurso. Desligue o que quiser e deixam de ver; volte a ligar quando quiser. Nada do que fez é apagado.",
      "title": "Quem vê os meus dados",
      "trailTitle": "O que mudou",
      "leftOn": "Saiu a {{date}}",
      "endedOn": "Terminou a {{date}}",
      "stoppedOn": "Deixou de partilhar a {{date}}",
      "leftReadOnly": "Esta relação terminou. Nada volta a ser partilhado com a {{company}}, a não ser que aceite um novo convite deles."
    }
  },
  "journeyBuilder": {
    "aboutDescription": "Crie a configuração personalizada do seu percurso internacional",
    "creatingMessage": "A configurar o seu percurso — isto demora apenas um momento.",
    "creatingTitle": "A criar o seu percurso…",
    "creationErrorTitle": "Não foi possível criar o seu percurso",
    "description": "Vamos configurar o seu percurso internacional",
    "estimatedTime": "Tempo estimado",
    "infoCountries": "Escolha os seus países de origem e destino",
    "infoDescription": "Diga-nos algumas coisas sobre a sua mudança para que possamos personalizar o seu percurso.",
    "infoDestination": "Destino",
    "infoDestinationDesc": "Para onde está a mudar.",
    "infoFeatures": "Selecione quais características incluir no seu percurso",
    "infoHousehold": "Configure a composição do seu agregado familiar e a sua estrutura familiar",
    "infoIntro": "Construir um percurso leva alguns minutos. Uma vez concluído, verá o seu roteiro personalizado.",
    "infoJourney": "Percurso",
    "infoJourneyDesc": "O plano completo da origem ao destino.",
    "infoOrigin": "Origem",
    "infoOriginDesc": "De onde está a mudar.",
    "infoProfile": "Perfil",
    "infoProfileDesc": "Os seus dados pessoais — usados para personalizar recomendações.",
    "infoScenario": "Selecione o propósito do seu percurso e o que está à procura",
    "progress": "Progresso",
    "progressTitle": "Progresso",
    "purposeCare": "Apoio e cuidado para chegar lá",
    "purposeCheckup": "Verifique as suas Competências Internacionais",
    "purposeCulture": "Conheça a Cultura e torne-se um Citizen",
    "purposeJob": "Tenha uma oportunidade de trabalho e apoio",
    "purposeRelocation": "Apoio no processo de realocação",
    "redirectingMessage": "A redirecionar para o seu painel...",
    "scenario": "Qual é a sua situação?",
    "scenarioAlreadyAbroad": "Já estou a viver no estrangeiro",
    "scenarioAlreadyAbroadDesc": "Já se mudou e quer melhorar a sua integração",
    "scenarioIntegration": "Apoio à integração apenas",
    "scenarioIntegrationDesc": "Quer focar-se na cultura, língua e desenvolvimento de carreira",
    "scenarioPreImmigration": "Estou a planear mudar-me para o estrangeiro",
    "scenarioPreImmigrationDesc": "Ainda está no seu país de origem e a planear a sua mudança internacional",
    "scenarioRelocation": "Apoio à realocação apenas",
    "scenarioRelocationDesc": "Precisa de ajuda com o lado logístico da mudança: visto, habitação, legal",
    "successTitle": "Percurso configurada! 🎉",
    "successToast": "Percurso configurada com sucesso!",
    "title": "Construtor de percurso",
    "mobile": {
      "stepOf": "Crie o seu percurso · {{current}} de {{total}}",
      "create": "Criar a meu percurso",
      "sameCountry": "Escolha o país que está a deixar — não pode ser o seu destino.",
      "createFailed": "Não conseguimos criar o seu percurso. Verifique a ligação e tente novamente.",
      "gateBody": "Três perguntas e o seu percurso está pronto — aqui mesmo no seu telemóvel.",
      "adviceFailed": "Não foi possível verificar os seus percursos nesta rota. Tente novamente."
    }
  },
  "language": {
    "languages": {
      "de": "Deutsch",
      "en": "Inglês",
      "es": "Español",
      "fr": "Français",
      "it": "Italiano",
      "pt": "Português"
    }
  },
  "legal": {
    "privacy": {
      "changes": {
        "content": "Podemos atualizar esta Política de Privacidade periodicamente. Notificá-lo-emos de quaisquer alterações através da publicação da nova política nesta página.",
        "title": "10. Alterações a esta política"
      },
      "children": {
        "content": "O nosso Serviço não é destinado a crianças com menos de 16 anos. Não recolhemos intencionalmente dados pessoais de crianças com menos de 16 anos.",
        "title": "9. Privacidade das crianças"
      },
      "collect": {
        "account": "Informação da conta (nome, email, número de telefone)",
        "assessment": "Respostas a avaliações e dados de progresso",
        "documents": "Documentos carregados no nosso serviço Vault",
        "intro": "Recolhemos informações que nos fornece diretamente, incluindo:",
        "location": "Dados de localização (país atual, país de destino)",
        "profile": "Informação do perfil (profissão, educação, competências)",
        "title": "1. Informação que recolhemos"
      },
      "contact": {
        "content": "Para questões sobre esta Política de Privacidade ou para exercer os seus direitos de dados, contacte o nosso Encarregado de Proteção de Dados em",
        "title": "11. Contacte-nos"
      },
      "cookies": {
        "content": "Utilizamos cookies e tecnologias semelhantes para melhorar a sua experiência, analisar padrões de utilização e fornecer conteúdo personalizado. Pode gerir as preferências de cookies através das definições do seu browser.",
        "title": "7. Cookies e rastreio"
      },
      "international": {
        "content": "As suas informações podem ser transferidas e processadas em países diferentes do seu país de residência. Garantimos que existem salvaguardas apropriadas para proteger os seus dados de acordo com esta Política de Privacidade.",
        "title": "8. Transferências internacionais de dados"
      },
      "lastUpdated": "Última atualização: {{date}}",
      "retention": {
        "content": "Mantemos os seus dados pessoais enquanto a sua conta estiver ativa ou enquanto for necessário para lhe prestar os serviços. Pode pedir-nos a eliminação dos seus dados a qualquer momento.",
        "title": "5. Retenção de dados"
      },
      "rights": {
        "access": "Aceder aos seus dados pessoais",
        "correct": "Corrigir dados imprecisos",
        "delete": "Solicitar a eliminação dos seus dados",
        "intro": "Nos termos das leis de proteção de dados aplicáveis, tem o direito de:",
        "object": "Opor-se ao tratamento dos seus dados",
        "portability": "Solicitar a portabilidade dos dados",
        "title": "6. Os seus direitos"
      },
      "security": {
        "content": "Implementamos medidas técnicas e organizacionais apropriadas para proteger os seus dados pessoais contra acesso não autorizado, alteração, divulgação ou destruição. Todos os dados são encriptados em trânsito e em repouso.",
        "title": "4. Segurança dos dados"
      },
      "sharing": {
        "employers": "Com empregadores que patrocinam o seu percurso (com o seu consentimento explícito)",
        "intro": "Podemos partilhar as suas informações:",
        "legal": "Quando exigido por lei ou para proteger os nossos direitos",
        "providers": "Com prestadores de serviços que ajudam a operar a nossa plataforma",
        "title": "3. Partilha de informação"
      },
      "title": "Política de privacidade",
      "use": {
        "communicate": "Comunicar consigo sobre o progresso do seu percurso",
        "intro": "Utilizamos as informações que recolhemos para:",
        "personalize": "Personalizar a sua experiência e recomendações de percurso",
        "process": "Processar as suas avaliações de iQulture e gerar insights",
        "protect": "Proteger contra fraudes e acessos não autorizados",
        "provide": "Fornecer, manter e melhorar o nosso Serviço",
        "title": "2. Como utilizamos as suas informações"
      }
    },
    "terms": {
      "acceptance": {
        "content": "Ao aceder e utilizar a Plataforma Tonnie (\"Serviço\"), concorda em estar vinculado a estes Termos de Serviço (\"Termos\"). Se não concordar com estes Termos, não utilize o Serviço.",
        "title": "1. Aceitação dos termos"
      },
      "accounts": {
        "content": "Para utilizar certas funcionalidades do Serviço, deve criar uma conta. É responsável por manter a confidencialidade das credenciais da sua conta e por todas as atividades que ocorrem sob a sua conta.",
        "title": "3. Contas de utilizador"
      },
      "changes": {
        "content": "Reservamo-nos o direito de modificar estes Termos a qualquer momento. Notificá-lo-emos de quaisquer alterações através da publicação dos novos Termos nesta página e da atualização da data de \"Última atualização\".",
        "title": "8. Alterações aos termos"
      },
      "contact": {
        "content": "Se tiver questões sobre estes Termos, por favor contacte-nos em",
        "title": "9. Contacto"
      },
      "ip": {
        "content": "O Serviço e o seu conteúdo original, funcionalidades e características são propriedade da Tonnie e estão protegidos por leis internacionais de direitos autorais, marcas registadas e outras leis de propriedade intelectual.",
        "title": "5. Propriedade intelectual"
      },
      "lastUpdated": "Última atualização: {{date}}",
      "liability": {
        "content": "Em nenhuma circunstância Tonnie será responsável por quaisquer danos indiretos, incidentais, especiais, consequenciais ou punitivos decorrentes ou relacionados com a sua utilização do Serviço.",
        "title": "7. Limitação de responsabilidade"
      },
      "responsibilities": {
        "accurate": "Fornecer informações precisas e completas",
        "compliance": "Utilizar o Serviço em conformidade com as leis aplicáveis",
        "intro": "Concorda em:",
        "noMisuse": "Não abusar ou tentar contornar as funcionalidades de segurança do Serviço",
        "title": "4. Responsabilidades do utilizador",
        "upToDate": "Manter as informações da sua conta atualizadas"
      },
      "serviceDesc": {
        "care": "Care — Suporte ao bem-estar",
        "checkup": "CheckUp — Avaliações de prontidão",
        "content": "Tonnie fornece uma plataforma global de mobilidade de talentos que assiste indivíduos (\"Talentos\") com realocação internacional e ajuda empresas (\"Empregadores\") a gerir programas globais de talentos. O Serviço inclui:",
        "passport": "Passport — Acompanhamento de progresso e verificação",
        "qultureup": "QultureUp — Módulos de aprendizagem cultural",
        "teleportal": "TelePortal — Gestão de tarefas de realocação",
        "title": "2. Descrição do serviço"
      },
      "termination": {
        "content": "Podemos terminar ou suspender a sua conta e o acesso ao Serviço imediatamente, sem aviso prévio, por conduta que acreditamos violar estes Termos ou ser prejudicial a outros utilizadores, a nós ou a terceiros.",
        "title": "6. Rescisão"
      },
      "title": "Termos de serviço"
    }
  },
  "mission": {
    "almostThere": "Quase lá!",
    "answerPlaceholder": "Escreva a sua resposta aqui...",
    "complete": "Completar missão",
    "completeToEarn": "Completar para ganhar",
    "completedBadge": "Concluído!",
    "completedSuccess": "Missão completa!",
    "correct": "Correto",
    "correctOf": "{{correct}} de {{total}} corretos",
    "exitForNow": "Sair por agora",
    "milesEarnedLabel": "Miles ganhas",
    "milesHint": "Miles acompanha o seu progresso de aprendizagem cultural em QultureUp",
    "needToPass": "Precisa de 75% para passar. Reveja o conteúdo e tente novamente.",
    "next": "Próximo",
    "notFound": "Missão não encontrada",
    "notPassed": "Não aprovado",
    "passed": "Aprovado",
    "perfectScoreBonus": "Bónus de pontuação perfeita",
    "previous": "Anterior",
    "progressWarning": "Vai perder o seu progresso. Tem a certeza?",
    "progressWarningTitle": "Sair da missão?",
    "questionBreakdown": "Análise das perguntas",
    "quizResults": "Resultados do quiz",
    "review": "Revisão",
    "reviewAndTryAgain": "Rever & tentar novamente",
    "startMission": "Iniciar missão",
    "watchVideo": "Ver vídeo",
    "scrollToContinue": "Desça até ao fim para continuar",
    "startQuiz": "Iniciar quiz",
    "submit": "Submeter",
    "submitAnyway": "Submeter de qualquer forma",
    "submitError": "Falha ao submeter o quiz. Por favor, tenta novamente.",
    "tipReread": "Dica: Leia o conteúdo novamente",
    "tipRereadDetail": "Preste atenção às secções em que falhou. As perguntas do questionário vêm diretamente do material da lição.",
    "title": "Missão",
    "unansweredTitle": "Perguntas sem resposta",
    "whatYoullLearn": "O que vai aprender",
    "wrong": "Errado",
    "lockedError": "Esta missão ainda está bloqueada. Conclua primeiro as missões anteriores.",
    "milesEarned_one": "+{{count}} Mile",
    "milesEarned_other": "+{{count}} Miles",
    "questionsCount_one": "{{count}} pergunta",
    "questionsCount_other": "{{count}} perguntas",
    "unansweredMessage_one": "Tem {{count}} pergunta sem resposta. Submeter mesmo assim?",
    "unansweredMessage_other": "Tem {{count}} perguntas sem resposta. Submeter mesmo assim?",
    "sectionOf": "{{current}} de {{total}}",
    "questionOf": "Pergunta {{current}} de {{total}}"
  },
  "nav": {
    "billing": "Faturação",
    "care": "Care",
    "career": "Career",
    "checkup": "CheckUp",
    "family": "Família",
    "home": "Início",
    "passport": "Passport",
    "profile": "Perfil",
    "qultureup": "QultureUp",
    "settings": "Definições",
    "teleportal": "TelePortal",
    "testit": "TestIt",
    "userMenu": {
      "billing": "Faturação",
      "loggingOut": "A sair…",
      "logout": "Sair",
      "preferences": "Preferências",
      "profile": "Perfil",
      "howItWorks": "Como funciona a Tonnie"
    },
    "vault": "Cofre",
    "inout": "InOut"
  },
  "notFound": {
    "description": "A página que procura não existe ou foi movida.",
    "goBack": "Voltar",
    "goHome": "Ir para casa",
    "message": "A página que procura não existe.",
    "title": "Página não encontrada"
  },
  "inbox": {
    "title": "Caixa de entrada",
    "subtitle": "Todas as mensagens enviadas para si — por email e na aplicação — num só lugar.",
    "tabInbox": "Caixa de entrada",
    "tabUnread": "Não lidas",
    "tabArchived": "Arquivadas",
    "unreadCount_one": "{{count}} mensagem não lida",
    "unreadCount_other": "{{count}} mensagens não lidas",
    "unreadLabel": "Não lida",
    "emptyInbox": "Ainda não há mensagens.",
    "emptyUnread": "Não tem mensagens por ler.",
    "emptyArchived": "Não há mensagens arquivadas.",
    "loadError": "Não foi possível carregar as suas mensagens.",
    "retry": "Tentar novamente",
    "loadMore": "Carregar mais",
    "archive": "Arquivar",
    "restore": "Mover para a caixa de entrada",
    "back": "Voltar às mensagens",
    "fromPlatform": "Tonnie",
    "channelEmail": "Email",
    "channelInApp": "Na aplicação",
    "channelPush": "Notificação push",
    "notRetainedTitle": "Conteúdo não guardado",
    "notRetainedBody": "Este email foi enviado antes de a Tonnie guardar uma cópia das mensagens que envia, por isso o texto não pode ser apresentado aqui.",
    "openAction": "Abrir",
    "selectPrompt": "Selecione uma mensagem para a ler.",
    "actionError": "Não foi possível concluir. Tente novamente.",
    "sentAt": "Enviada em {{date}}",
    "openFromBell": "Abrir caixa de entrada",
    "markAllRead": "Marcar tudo como lido",
    "markAllReadDone": "Todas as mensagens foram marcadas como lidas",
    "allCaughtUp": "Sem mensagens por ler",
    "archived": "Mensagem arquivada",
    "restored": "Movida para a caixa de entrada",
    "undo": "Anular",
    "markUnread": "Marcar como não lida",
    "markRead": "Marcar como lida",
    "markedUnread": "Marcada como não lida",
    "markedRead": "Marcada como lida",
    "groupToday": "Hoje",
    "groupYesterday": "Ontem",
    "groupThisWeek": "Esta semana",
    "groupEarlier": "Mais antigas",
    "selectTitle": "Nenhuma mensagem selecionada",
    "emptyInboxHint": "Os emails e as mensagens da app enviados pela Tonnie e pelas empresas com que trabalha aparecem aqui.",
    "emptyUnreadHint": "As novas mensagens aparecem aqui assim que chegarem.",
    "emptyArchivedHint": "As mensagens que arquivar ficam aqui e pode devolvê-las à caixa de entrada a qualquer momento.",
    "loadErrorHint": "Verifique a sua ligação e tente novamente.",
    "loading": "A carregar as suas mensagens",
    "readerLabel": "Mensagem",
    "messageNotFound": "Esta mensagem não está aqui",
    "messageNotFoundHint": "Pode ter sido eliminada ou enviada para outra conta.",
    "notRetainedPreview": "O texto deste email não foi guardado.",
    "opensInNewTab": "(abre num novo separador)",
    "viewArchived": "Ver arquivadas",
    "invitationsSection": "Convites · {{count}}",
    "invitationsWaiting_one": "{{count}} convite à espera da sua resposta",
    "invitationsWaiting_other": "{{count}} convites à espera da sua resposta",
    "notificationSettings": "Definições de notificações"
  },
  "notifications": {
    "care": {
      "checkpointOverdueTitle": "O seu check-in está à espera",
      "coachingAssignedTitle": {
        "encourage": "Atribuído a si: enviar uma palavra de incentivo",
        "challenge": "Atribuído a si: lançar um novo desafio",
        "checkin": "Atribuído a si: saber como está",
        "celebrate": "Atribuído a si: celebrar o progresso",
        "remind": "Atribuído a si: enviar um lembrete amigável"
      },
      "coachingTouchTitle": {
        "encourage": "A sua equipa enviou-lhe uma palavra de incentivo",
        "challenge": "A sua equipa lançou-lhe um novo desafio",
        "checkin": "A sua equipa quer saber como está",
        "celebrate": "A sua equipa está a celebrar o seu progresso",
        "remind": "Um lembrete amigável da sua equipa"
      },
      "checkpointOverdueBody": "Um check-in de Care está atrasado — leva apenas cerca de 3 minutos. Abra Care para completá-lo.",
      "interactionAssignedBody": "Foi-lhe atribuída uma interação de Care.",
      "interventionTouchBody": "A sua equipa de patrocinadores agendou algum suporte para si. Abra Care para ver mais.",
      "objectiveFeedbackCycleOpenTitle": "Nova ronda de feedback",
      "objectiveFeedbackCycleOpenBody": "A sua equipa vai partilhar o feedback em breve — depois poderá adicionar a sua autoavaliação. Abra Care para ver os seus objetivos.",
      "objectiveFeedbackDueTitle": "Feedback solicitado",
      "objectiveFeedbackDueBody": "É altura de partilhar o seu feedback sobre os objetivos desta ronda. Abra Care para o dar.",
      "objectiveFeedbackReceivedTitle": "Novo feedback recebido",
      "objectiveFeedbackReceivedBody": "A sua equipa partilhou feedback sobre os seus objetivos. Abra Care para o rever e adicionar a sua autoavaliação."
    },
    "checkup": {
      "scoreReadyBody": "{{score}} — veja o que significa, pilar a pilar.",
      "scoreReadyTitle": "A pontuação iQulture chegou"
    },
    "billing": {
      "actionRequiredBody": "O seu banco precisa que autorize este pagamento. Abra a Faturação para concluir.",
      "actionRequiredTitle": "Confirme o seu pagamento",
      "paymentFailedBody": "Não foi possível processar o seu pagamento. Atualize o método de pagamento para manter o acesso.",
      "paymentFailedTitle": "Pagamento falhou"
    },
    "testit": {
      "reminderBody": "Conclua o seu TestIt para que a empresa que o avalia possa ver os seus resultados.",
      "reminderTitle": "O seu TestIt está à espera"
    },
    "justNow": "Agora mesmo",
    "bellLabel_one": "Notificações, {{shown}} por ler",
    "bellLabel_other": "Notificações, {{shown}} por ler",
    "title": "Notificações",
    "moreActions": "Mais ações",
    "tabAll": "Todas",
    "markReadAction": "Marcar como lida",
    "unsubscribe": {
      "confirmBody": "Vamos deixar de enviar emails de «{{category}}» para {{email}}.",
      "confirmCta": "Cancelar subscrição",
      "confirmTitle": "Cancelar a subscrição destes emails?",
      "confirming": "A cancelar…",
      "doneBody": "Não voltará a receber emails de «{{category}}».",
      "doneTitle": "Subscrição cancelada",
      "failed": "Não foi possível concluir. Tente novamente.",
      "invalidBody": "Pode já ter sido utilizada ou a conta a que pertencia foi encerrada. Nada foi alterado.",
      "invalidTitle": "Esta ligação já não é válida",
      "loading": "A verificar a sua ligação…",
      "malformedBody": "A ligação de cancelamento parece truncada. Algumas aplicações de email cortam ligações longas — tente abrir a mensagem num browser ou utilize o botão Cancelar subscrição que a sua aplicação de email mostra no topo da mensagem.",
      "malformedTitle": "Esta ligação está incompleta",
      "stillReceive": "Os emails essenciais da conta — reposições de palavra-passe e avisos de segurança — continuarão a chegar-lhe."
    },
    "showMore": "Ver mais",
    "showLess": "Ver menos",
    "journey": {
      "relationshipMovedTitle": "Os seus percursos mudaram",
      "relationshipMovedBody": "A {{company}} acompanha-o agora num percurso só seu, na mesma rota. Veja-o em Os meus percursos."
    },
    "bellLabelNeedsYou_one": "Notificações, {{shown}} à sua espera, incluindo um convite",
    "bellLabelNeedsYou_other": "Notificações, {{shown}} à sua espera, incluindo convites",
    "tabInvitations": "Convites",
    "company": {
      "programmeLeftTitle": "Um talento saiu do programa",
      "programmeLeftBody": "O cartão de {{name}} passou para o separador Arquivado do seu Pipeline e já não vê o que partilhou consigo.",
      "programmeLeftSponsoredBody": "{{name}} saiu e já não vê o que partilhou consigo. O seu patrocínio continua até {{date}}, o fim do período pago.",
      "programmeLeftSponsoredOpenEndedBody": "{{name}} saiu e já não vê o que partilhou consigo. O seu patrocínio continua até ao fim do período pago.",
      "shareRequestDeclinedTitle": "Pedido recusado",
      "shareRequestDeclinedBody": "{{name}} recusou. Nada mudou: vê exatamente o que já tinha sido partilhado consigo. Pode voltar a pedir mais tarde no cartão.",
      "testitCompletedTitle": "Testes pedidos concluídos",
      "testitCompletedBody": "{{name}} concluiu os testes que pediu. Abra o cartão no seu Pipeline para os rever e registar a sua decisão.",
      "sponsorshipAcceptedTitle": "Patrocínio aceite",
      "sponsorshipAcceptedBody": "{{name}} aceitou. O cartão está agora na coluna Patrocinado do seu Pipeline, onde pode acompanhar o progresso.",
      "sponsorshipDeclinedTitle": "Patrocínio recusado",
      "sponsorshipDeclinedBody": "{{name}} recusou. O que pagou é reembolsado automaticamente. Pode fazer uma nova oferta a partir do cartão no seu Pipeline.",
      "nudgeDigestTitle": "À espera da sua equipa",
      "nudgeDigestBody": "À sua espera: {{count}}. Convites por enviar ou devolvidos e ofertas de patrocínio sem resposta — só a sua equipa os faz avançar."
    },
    "inout": {
      "confirmationBody": "Esteve no país de acolhimento todos os dias de {{from}} a {{to}}, exceto nas ausências que registou? Responda no InOut.",
      "confirmationTitle": "Confirme se esteve cá",
      "leadTimeBody": "Com a ausência e as viagens planeadas, um limite de residência seria atingido a {{date}}. Veja no InOut o que fazer antes de sair.",
      "leadTimeTitle": "Limite de residência próximo",
      "renewalWindowBody": "Já pode pedir a renovação do seu título de residência, até {{date}}.",
      "renewalWindowTitle": "Janela de renovação aberta",
      "consultationBookedTitle": "Consulta marcada",
      "consultationBookedBody": "A sua consulta com a assessoria está marcada. Veja o dia, a hora e a ligação para entrar no InOut.",
      "consultationRebookTitle": "Escolha outra hora",
      "consultationRebookBody": "A hora que escolheu foi ocupada enquanto pagava. Escolha outra no InOut — não paga outra vez.",
      "consultationCancelledTitle": "Consulta cancelada",
      "consultationCancelledBody": "A assessoria cancelou a sua consulta. Escolha uma nova hora no InOut — não paga outra vez.",
      "documentsRequestedTitle": "Documentos para o seu ticket",
      "documentsRequestedBody": "A sua assessoria pediu documentos para o seu ticket. Veja no email dela o que precisa.",
      "refundHandledTitle": "O seu reembolso foi tratado",
      "refundHandledBody": "A assessoria tratou o reembolso que pediu. Veja o seu ticket no InOut.",
      "dossierDeliveredTitle": "O seu dossiê foi entregue",
      "dossierDeliveredBody": "O seu dossiê foi entregue à assessoria. O passo seguinte é da assessoria — veja o seu ticket no InOut."
    },
    "qultureup": {
      "academyInactiveTitle": "Hora de uma aula",
      "academyInactiveBody": "Já passou algum tempo desde o seu último progresso na Languages Academy. Uma aula curta mantém a sua língua em movimento."
    }
  },
  "onboarding": {
    "completed": "Completar integração",
    "education": {
      "addEducation": "Adicionar educação",
      "bachelor": "Licenciatura",
      "degree": "Grau",
      "description": "Adicione o seu histórico educacional",
      "emptyDescription": "Adicione o seu histórico de educação para nos ajudar a entender melhor o seu percurso e qualificações.",
      "emptyTitle": "Ainda não há entradas de educação",
      "entry": "Entrada de educação",
      "field": "Área de estudo",
      "fieldPlaceholder": "ex: Ciência da Computação",
      "graduationYear": "Ano de graduação",
      "institution": "Instituição",
      "institutionPlaceholder": "Nome da Universidade",
      "master": "Mestrado",
      "phd": "Doutoramento",
      "selectDegree": "Selecionar tipo de grau",
      "title": "Histórico educacional"
    },
    "experience": {
      "addExperience": "Adicionar experiência",
      "company": "Empresa",
      "companyPlaceholder": "Nome da Empresa",
      "current": "Atual",
      "currentJob": "Deixe em branco se for atual",
      "description": "Descrição",
      "descriptionPlaceholder": "Descreva o seu papel e conquistas...",
      "emptyDescription": "Adicione a sua experiência de trabalho para mostrar o seu percurso profissional e as suas competências.",
      "emptyTitle": "Ainda não há experiência de trabalho",
      "endDate": "Data de fim",
      "endDateHint": "Deixe em branco se esta for a sua posição atual",
      "entry": "Entrada de experiência",
      "locationCity": "Cidade",
      "locationCityPlaceholder": "ex: São Francisco",
      "locationCountry": "País",
      "locationCountryPlaceholder": "Selecionar país",
      "role": "Função / Título",
      "rolePlaceholder": "Título do trabalho",
      "startDate": "Data de início",
      "title": "Experiência de trabalho"
    },
    "family": {
      "childrenCount": "Número de filhos",
      "description": "Conte-nos sobre o seu agregado familiar",
      "familyProgramHint": "Pode configurar o Programa Familiar mais tarde para convidar membros da família para o seu percurso",
      "hasChildren": "Tenho filhos",
      "hasPartner": "Tenho um parceiro/cônjuge",
      "hasPets": "Tenho animais de estimação",
      "householdInfo": "Informações sobre o agregado familiar",
      "householdInfoDesc": "Isto ajuda-nos a personalizar os seus pontos de verificação de TelePortal e Care",
      "title": "Configuração familiar"
    },
    "fieldFilledFromImport": "Preenchido a partir do perfil importado",
    "fieldImportHint": "Importar perfil para preencher este campo",
    "languages": {
      "addLanguage": "Adicionar Idioma",
      "advanced": "Avançado",
      "beginner": "Iniciante",
      "description": "Fale-nos das suas competências linguísticas",
      "elementary": "Elementar",
      "emptyDescription": "Adicione as línguas que fala para nos ajudar a avaliar a sua prontidão para a comunicação.",
      "emptyTitle": "Ainda não há línguas adicionadas",
      "entry": "Língua",
      "intermediate": "Intermédio",
      "language": "Língua",
      "level": "Nível de Proficiência",
      "native": "Nativo",
      "proficient": "Proficiente",
      "selectLanguage": "Selecionar uma língua",
      "selectLevel": "Selecionar nível de proficiência",
      "title": "Idiomas",
      "upperIntermediate": "Intermediário Superior"
    },
    "linkedin": {
      "dropPdfSubtitle": "ou clique para navegar",
      "dropPdfTitle": "Deixe o seu PDF do Perfil do LinkedIn aqui",
      "fileTooLarge": "O ficheiro é demasiado grande. O tamanho máximo é 10 MB.",
      "invalidFileType": "Tipo de ficheiro não suportado. Por favor, carregue um PDF, documento Word ou ficheiro de texto.",
      "parseFailed": "Falha ao extrair dados do documento. Por favor, tente um ficheiro diferente.",
      "pdfInstructions": {
        "step1": "Vá ao LinkedIn e inicie sessão",
        "step2": "Navegue até Definições & Privacidade → Privacidade de Dados → Obter uma cópia dos seus dados",
        "step3": "Selecione 'Perfil' e transfira-o como PDF",
        "step4": "Carregue o ficheiro PDF abaixo",
        "title": "Como obter o seu PDF do Perfil do LinkedIn"
      },
      "pdfUploadError": "Falha ao carregar o PDF. Por favor, tente novamente.",
      "selectPdfFile": "Selecionar ficheiro PDF",
      "uploadDifferentFile": "Carregar ficheiro diferente",
      "uploading": "A carregar...",
      "wizard": {
        "compliance": {
          "description": "Os seus dados permanecem privados. Apenas lemos o documento que carregar — nada é armazenado ou partilhado sem o seu consentimento.",
          "title": "Conformidade com o GDPR e LinkedIn"
        },
        "confirmAndContinue": "Confirmar & continuar",
        "getStarted": "Começar",
        "guide": {
          "cv": {
            "subtitle": "Algumas dicas para obter os melhores resultados do seu CV",
            "tip1": {
              "description": "Carregue o seu CV mais atualizado para a importação de perfil mais precisa.",
              "title": "Use uma versão recente"
            },
            "tip2": {
              "description": "CVs com secções claras (Experiência, Formação, Competências) dão os melhores resultados de extração.",
              "title": "Formatos estruturados funcionam melhor"
            },
            "tip3": {
              "description": "Aceitamos ficheiros PDF, DOCX, DOC e TXT até 10 MB.",
              "title": "Formatos suportados"
            },
            "title": "Dicas para o seu carregamento de CV"
          },
          "linkedin": {
            "openLinkedIn": "Abrir LinkedIn",
            "step1": {
              "description": "Vá a linkedin.com, inicie sessão e navegue até à sua página de perfil.",
              "title": "Abrir o seu perfil"
            },
            "step2": {
              "description": "Na sua página de perfil, clique no botão \"Mais\" abaixo do seu título, depois selecione \"Guardar como PDF\".",
              "title": "Clique em \"Mais\" e depois em \"Guardar como PDF\""
            },
            "step3": {
              "description": "O LinkedIn vai gerar um PDF. Guarde-o no seu computador — irá carregá-lo no passo seguinte.",
              "title": "Transferir o ficheiro"
            },
            "subtitle": "Siga estes 3 passos simples para transferir o seu perfil",
            "tip": "O PDF é gerado instantaneamente a partir da sua página de perfil. Não é necessário solicitar uma exportação de dados.",
            "title": "Como obter o seu PDF do LinkedIn"
          }
        },
        "processing": {
          "analyzing": "A analisar com IA",
          "extracting": "A extrair o conteúdo de texto",
          "structuring": "A estruturar os seus dados",
          "subtitle": "Por favor, aguarde enquanto analisamos o seu documento...",
          "title": "A extrair o seu perfil",
          "uploading": "A carregar o documento"
        },
        "progress": "Progresso",
        "readyToUpload": "Estou pronto para carregar",
        "review": {
          "at": "em",
          "editHint": "Pode editar todos os detalhes nos próximos passos de integração.",
          "fieldCertifications": "Certificações",
          "fieldEducation": "Educação",
          "fieldExperience": "Experiência de trabalho",
          "fieldHeadline": "Título profissional",
          "fieldLanguages": "Idiomas",
          "fieldNames": "Nome",
          "fieldSkills": "Competências",
          "fieldWebsites": "Sites & links",
          "noDataFound": "Não foi possível extrair dados. Por favor, confirme que o ficheiro é um documento de perfil válido (PDF, DOCX ou TXT).",
          "present": "Presente",
          "previewDescription": "Os seguintes campos serão preenchidos automaticamente no seu perfil da Tonnie:",
          "subtitle": "Encontrámos as seguintes informações no seu documento. Revise e confirme para continuar.",
          "title": "O seu perfil extraído",
          "entries_one": "{{count}} entrada",
          "entries_other": "{{count}} entradas",
          "languagesCount_one": "{{count}} idioma",
          "languagesCount_other": "{{count}} idiomas",
          "positions_one": "{{count}} cargo",
          "positions_other": "{{count}} cargos",
          "skillsCount_one": "{{count}} competência",
          "skillsCount_other": "{{count}} competências",
          "summaryStats_one": "{{count}} campo extraído do seu documento",
          "summaryStats_other": "{{count}} campos extraídos do seu documento"
        },
        "reviewData": "Rever dados",
        "source": {
          "cvCard": {
            "description": "Carregue o seu CV ou currículo existente em formato PDF, DOCX ou TXT. Funciona com qualquer layout.",
            "title": "CV / Currículo pessoal"
          },
          "linkedinCard": {
            "description": "Descarregue o seu perfil do LinkedIn e carregue o PDF. Melhor para dados estruturados e precisos.",
            "tag": "Recomendado",
            "title": "PDF do perfil do LinkedIn"
          },
          "subtitle": "Escolha como gostaria de importar o seu perfil profissional. Vamos extrair automaticamente a sua experiência, educação e competências.",
          "title": "Importar o seu perfil"
        },
        "steps": {
          "guide": "Guia",
          "processing": "A processar",
          "review": "Revisão",
          "source": "Fonte",
          "upload": "Carregar"
        },
        "success": {
          "description": "Os seus dados foram importados. Agora pode gerar CVs profissionais e gerir várias versões.",
          "title": "Perfil importado com sucesso!"
        },
        "upload": {
          "subtitle": "Arraste e largue o seu ficheiro ou clique para procurar. Aceitamos ficheiros PDF, DOCX e TXT.",
          "title": "Carregar o seu documento"
        },
        "aria": {
          "progress": "Progresso do mago"
        }
      }
    },
    "linkedinBound": "Perfil importado",
    "linkedinConnectionError": "Falha ao importar perfil. Por favor, tente novamente.",
    "location": {
      "currentCountry": "País atual",
      "description": "Onde está agora e para onde deseja ir?",
      "goal": "O seu objetivo",
      "goalHint": "Isto ajuda-nos a personalizar o seu percurso",
      "goalPlaceholder": "Conte-nos sobre os seus objetivos e expectativas de relocação...",
      "selectCountry": "Selecione um país",
      "targetCountry": "País alvo",
      "title": "Localização & objetivos"
    },
    "mobility": {
      "citizenship": "Países de cidadania",
      "citizenshipHint": "Selecione todos os países onde possui cidadania",
      "description": "Conte-nos sobre os seus interesses de cidadania e relocação",
      "selectCitizenship": "Selecione um país...",
      "removeCitizenship": "Remover {{country}}",
      "title": "Mobilidade",
      "validPassport": "Tem um passaporte válido?",
      "validPassportHint": "Os detalhes de Passport serão geridos em TelePortal"
    },
    "personalInfo": {
      "addAddress": "Adicionar endereço",
      "addWebsiteUrl": "Adicionar URL do site",
      "address": "Endereço",
      "addressDetails": "Detalhes do endereço",
      "addressDetailsError": "Falha ao obter detalhes do endereço. Por favor, tente novamente.",
      "addressHint": "Selecione o seu endereço a partir das sugestões",
      "addressInitError": "Falha ao inicializar a pesquisa de endereço. Por favor, tente novamente.",
      "addressInvalid": "Dados de endereço inválidos. Por favor, tente selecionar outro endereço.",
      "addressLoadError": "Falha ao carregar a pesquisa de endereço. Por favor, atualize a página.",
      "addressPlaceholder": "Comece a escrever o seu endereço...",
      "addressSearchError": "Falha ao pesquisar endereços. Por favor, tente novamente.",
      "addressSelected": "Endereço selecionado",
      "addressSuggestions": "Sugestões de endereços",
      "avatarFileSizeError": "O tamanho do ficheiro deve ser inferior a 5MB",
      "avatarFileTypeError": "Por favor, carregue um ficheiro de imagem válido (JPG, PNG, GIF ou WEBP)",
      "avatarRemoved": "Foto removida com sucesso!",
      "avatarUploadFailed": "Falha ao carregar o avatar",
      "avatarUploaded": "Foto carregada com sucesso!",
      "changePhoto": "Alterar foto",
      "city": "Cidade",
      "clickEditToAdd": "Clique em Editar para adicionar o seu endereço",
      "clickToUpload": "Clique para carregar",
      "complement": "Complemento",
      "complementPlaceholder": "Apartamento, suíte, unidade, etc.",
      "country": "País",
      "dateOfBirth": "Data de nascimento",
      "description": "Fale-nos sobre si",
      "firstName": "Primeiro nome",
      "firstNamePlaceholder": "Introduza o seu nome próprio",
      "lastName": "Último nome",
      "lastNamePlaceholder": "Introduza o seu apelido",
      "linkedinConnected": "Dados do perfil importados do LinkedIn",
      "loadingAddressDetails": "A carregar detalhes do endereço...",
      "noAddress": "Nenhum endereço adicionado ainda",
      "phone": "Número de telefone",
      "phoneHint": "Usaremos isto para contactá-lo sobre o seu percurso",
      "phonePlaceholder": "Introduza o seu número de telefone",
      "photoFileTypes": "JPG, PNG, GIF ou WEBP. Máx. 5MB.",
      "photoInstructions": "Adicione uma foto profissional para personalizar o seu perfil. Isso ajuda recrutadores e empresas a reconhecê-lo.",
      "profilePhoto": "Foto de perfil",
      "removePhoto": "Remover foto",
      "searchAddress": "Pesquisar endereço",
      "searchAddressDescription": "Escreva o seu endereço e selecione nas sugestões do Google Places",
      "state": "Estado/Província",
      "street": "Rua",
      "title": "Informação pessoal",
      "uploadPhoto": "Carregar foto",
      "websiteLabelPlaceholder": "Rótulo personalizado (ex.: Meu Blog)",
      "websiteType": {
        "blog": "Blog",
        "facebook": "Facebook",
        "github": "GitHub",
        "gitlab": "GitLab",
        "instagram": "Instagram",
        "linkedin": "LinkedIn",
        "other": "Outro",
        "personal": "Pessoal",
        "portfolio": "Portfólio",
        "twitter": "Twitter / X",
        "website": "Website",
        "youtube": "YouTube"
      },
      "websiteUrlPlaceholder": "https://...",
      "websiteUrls": "URLs de websites & links sociais",
      "websiteUrlsHint": "Adicione o seu portfólio, website pessoal, GitHub, LinkedIn ou outros links profissionais",
      "workModel": {
        "flexible": "Flexível",
        "hybrid": "Híbrido",
        "on-site": "Presencial",
        "remote": "Remoto"
      },
      "workModelPreference": "Preferência de modelo de trabalho",
      "workModelPreferenceHint": "Selecione os modelos de trabalho que está disposto a aceitar",
      "zipCode": "Código postal",
      "websiteTypeLabel": "Tipo de link",
      "websiteUrlLabel": "URL do link",
      "websiteCustomLabel": "Rótulo personalizado",
      "removeWebsiteUrl": "Remover link"
    },
    "professional": {
      "advanced": "Avançado",
      "beginner": "Iniciante",
      "description": "Conte-nos sobre a sua carreira",
      "elementary": "Elementar",
      "englishLevel": "Proficiência em Inglês",
      "englishLevelHint": "Isto ajuda-nos a avaliar a sua prontidão",
      "intermediate": "Intermédio",
      "junior": "Júnior",
      "mid": "Nível Médio",
      "proficient": "Proficiente",
      "role": "Função atual / Título do trabalho",
      "rolePlaceholder": "ex: Engenheiro de Software",
      "selectEnglishLevel": "Selecione o seu nível de inglês",
      "selectSeniority": "Selecione o seu nível de senioridade",
      "senior": "Sénior",
      "seniority": "Nível de senioridade",
      "title": "Experiência profissional",
      "upperIntermediate": "Intermediário superior"
    },
    "review": {
      "address": "Endereço",
      "careerTime": "Tempo de Career",
      "certifications": "Certificações",
      "countriesOfInterest": "Países de interesse",
      "currentRole": "Função atual",
      "education": "Educação",
      "experience": "Experiência",
      "familyConfig": "Configuração familiar",
      "hardSkills": "Competências técnicas",
      "hasChildren": "Tem filhos",
      "hasPartner": "Tem parceiro",
      "hasPets": "Tem animais de estimação",
      "mobility": "Mobilidade",
      "passport": "Válido Passport",
      "personalInfo": "Informação pessoal",
      "profilePhoto": "Foto de perfil",
      "profilePhotoSet": "A foto de perfil foi definida",
      "skills": "Competências & especializações",
      "softSkills": "Competências interpessoais",
      "spokenLanguages": "Idiomas falados",
      "websiteUrls": "URLs de websites & links sociais",
      "workModel": "Preferência de modelo de trabalho",
      "years": "anos"
    },
    "saveError": "Falha ao guardar progresso. Por favor, tente novamente.",
    "saved": "Progresso guardado com sucesso",
    "skills": {
      "addCertification": "Adicionar certificação",
      "addHardSkill": "Adicionar competência técnica",
      "addLanguage": "Adicionar idioma",
      "addSoftSkill": "Adicionar competência interpessoal",
      "careerTime": "Tempo de Career",
      "certification": "Certificação",
      "certificationAuthority": "Autoridade emitente",
      "certificationAuthorityPlaceholder": "ex: Amazon Web Services",
      "certificationExpiryDate": "Data de expiração",
      "certificationExpiryDatePlaceholder": "Deixe em branco se não houver expiração",
      "certificationIssueDate": "Data de emissão",
      "certificationLicenseNumber": "Número da licença",
      "certificationLicenseNumberPlaceholder": "Número da licença ou certificado (opcional)",
      "certificationName": "Nome da certificação",
      "certificationNamePlaceholder": "ex: AWS Certified Solutions Architect",
      "certificationUrl": "URL do certificado",
      "certificationUrlPlaceholder": "https://...",
      "certifications": "Certificações",
      "certificationsHint": "Adicione certificações e licenças profissionais",
      "currentRole": "Função atual",
      "description": "Fale-nos das suas competências e da sua experiência profissional",
      "experienceYears": {
        "0_1": "0-1 anos",
        "11_15": "11-15 anos",
        "16_plus": "16+ anos",
        "2_3": "2-3 anos",
        "4_5": "4-5 anos",
        "6_10": "6-10 anos"
      },
      "hardSkills": "Competências técnicas",
      "hardSkillsHint": "Adicione competências técnicas e os seus anos de experiência",
      "hardSkillsInfo": "Indique pelo menos 5 das suas competências técnicas mais fortes e o tempo de experiência.",
      "languageLevels": {
        "A1": "A1 — Iniciante",
        "A2": "A2 — Elementar",
        "B1": "B1 — Intermediário",
        "B2": "B2 — Intermediário superior",
        "C1": "C1 — Avançado",
        "C2": "C2 — Proficiência",
        "native": "Nativo"
      },
      "languages": "Idiomas falados",
      "languagesHint": "Adicione os idiomas que conhece e o seu nível de proficiência",
      "languagesInfo": "É importante adicionar, pelo menos, as suas competências em inglês e na sua língua nativa. Quanto mais informação indicar, mais oportunidades estarão disponíveis.",
      "noHardSkillFound": "Nenhuma competência técnica encontrada.",
      "noLanguageFound": "Nenhum idioma encontrado.",
      "noRoleFound": "Nenhuma função encontrada.",
      "noSoftSkillFound": "Nenhuma competência interpessoal encontrada.",
      "searchHardSkill": "Pesquisar competências técnicas...",
      "searchLanguage": "Pesquisar idiomas...",
      "searchRole": "Pesquisar funções...",
      "searchSoftSkill": "Pesquisar competências interpessoais...",
      "selectExperience": "Selecionar experiência",
      "selectLevel": "Selecionar nível",
      "selectRole": "Selecione a sua função...",
      "skillExperience": {
        "0_1": "0-1 anos",
        "11_plus": "11+ anos",
        "2_3": "2-3 anos",
        "4_5": "4-5 anos",
        "6_10": "6-10 anos"
      },
      "softSkillLevels": {
        "advanced": "Avançado",
        "beginner": "Iniciante",
        "expert": "Especialista",
        "intermediate": "Intermédio"
      },
      "softSkills": "Competências interpessoais",
      "softSkillsHint": "Adicione competências interpessoais e o seu nível de proficiência",
      "softSkillsInfo": "Indique pelo menos 3 das suas competências interpessoais mais fortes.",
      "title": "Autoavaliação de competências",
      "levelFor": "Nível de {{name}}",
      "experienceFor": "Experiência em {{name}}"
    },
    "validation": {
      "address_city_country_required": "Por favor, forneça pelo menos a sua cidade e país",
      "address_city_required": "A cidade é obrigatória",
      "address_country_required": "O país é obrigatório",
      "career_experience_required": "Por favor, selecione a sua experiência profissional",
      "certification_authority_required": "A entidade emissora é obrigatória",
      "certification_name_required": "O nome da certificação é obrigatório",
      "citizenship_required": "Por favor, selecione pelo menos uma cidadania",
      "company_required": "A empresa é obrigatória",
      "dateOfBirth_invalid": "Por favor, insira uma data de nascimento válida",
      "dateOfBirth_invalid_format": "Formato de data inválido",
      "dateOfBirth_min_age": "Tem de ter pelo menos {{minAge}} anos",
      "dateOfBirth_required": "A data de nascimento é obrigatória",
      "degree_required": "O grau é obrigatório",
      "end_date_after_start": "A data de término deve ser após a data de início",
      "exp_role_required": "O cargo é obrigatório",
      "field_of_study_required": "O campo de estudo é obrigatório",
      "firstName_max_length": "O primeiro nome deve ter no máximo 100 caracteres",
      "firstName_min_length": "O primeiro nome deve ter pelo menos 2 caracteres",
      "firstName_required": "O primeiro nome é obrigatório",
      "fixErrors": "Por favor, corrija os campos destacados antes de continuar.",
      "graduation_year_invalid": "Por favor, insira um ano de graduação válido",
      "institution_required": "A instituição é obrigatória",
      "lastName_max_length": "O sobrenome deve ter no máximo 100 caracteres",
      "lastName_min_length": "O sobrenome deve ter pelo menos 2 caracteres",
      "lastName_required": "O sobrenome é obrigatório",
      "passport_required": "Por favor, indique se tem um passaporte válido",
      "phone_invalid_characters": "O número de telefone contém caracteres inválidos",
      "phone_max_digits": "O número de telefone deve ter no máximo {{maxDigits}} dígitos",
      "phone_min_digits": "O número de telefone deve ter pelo menos {{minDigits}} dígitos",
      "phone_required": "O número de telefone é obrigatório",
      "role_select_required": "Por favor, selecione o seu cargo atual",
      "start_date_required": "A data de início é obrigatória",
      "url_invalid": "Por favor, insira uma URL válida (ex: https://...)",
      "work_model_required": "Por favor, selecione pelo menos uma preferência de modelo de trabalho"
    }
  },
  "passport": {
    "achievementUnlocked": "🎉 Conquista desbloqueada: {{name}}!",
    "activeJourneys": "Percursos ativas",
    "adjustFilters": "Ajuste os seus filtros ou complete atividades para ver eventos",
    "allTime": "Todo o tempo",
    "badgeMilesReward": "+{{miles}} milhas",
    "badges": "Emblemas",
    "badgesCount": "{{earned}} de {{total}} emblemas conquistados",
    "badgesEarned": "{{earned}} de {{total}} conquistados",
    "badgesProgress": "Progresso dos emblemas",
    "bio": {
      "address": "Endereço",
      "citizenLevel": "Nível Citizen",
      "dateOfBirth": "Data de nascimento",
      "email": "Email",
      "fullName": "Nome completo",
      "nationality": "Cidadania",
      "phone": "Telefone"
    },
    "rarityHeading": "Raridade",
    "citizenBadges": "Distintivos Citizen",
    "citizenBadgesDesc": "Emblemas especiais ganhos ao demonstrar adaptação cultural e conclusão de percurso",
    "citizenBadgesSection": "Distintivos Citizen",
    "citizenLevel": {
      "starter": "Iniciante"
    },
    "companyCohort": "Cohort da empresa",
    "completeForBadges": "Complete atividades para ganhar emblemas de cidadão!",
    "coverSubtitle": "Passport",
    "coverTitle": "Citizen",
    "daysOnJourney": "Dias no percurso",
    "description": "O seu registo de percurso",
    "earnBadgesMessage": "Complete avaliações e lições para ganhar emblemas!",
    "earned": "Ganho",
    "earnedOn": "Ganho em",
    "errors": {
      "tryAgain": "Por favor, tente novamente mais tarde.",
      "unableToLoad": "Incapaz de carregar dados de Passport"
    },
    "event": {
      "ACHIEVEMENT_EARNED.desc": "Ganhou uma conquista"
    },
    "eventCategory": "Categoria",
    "eventData": "Dados do evento",
    "eventDetails": "Detalhes do evento",
    "eventType": "Tipo de evento",
    "heroBanner": {
      "levelLabel": "Nível {{level}}",
      "milesToNextLevel": "{{miles}} milhas até {{nextLevel}}",
      "subtitle": "Acompanhe os seus selos, emblemas e marcos em cada herói no seu percurso de realojamento.",
      "title": "O seu percurso Passport"
    },
    "heroes": "Heróis",
    "identification": "Identificação",
    "insightCultural": "🌍 A integração cultural é fundamental",
    "insightCulturalDesc": "Concentre-se nas lições de QultureUp para aumentar a sua prontidão para a integração.",
    "insightProgress": "🎯 Está a progredir mais depressa do que o esperado!",
    "insightProgressDesc": "O seu score de prontidão melhorou em 15 pontos nas últimas 2 semanas.",
    "insightStreak": "📚 Mantenha a sua sequência de aprendizagem ativa",
    "insightStreakDesc": "Está numa sequência de 7 dias. Mais um dia para desbloquear um novo emblema!",
    "insights": "Insights",
    "issued": "Emitido: {{date}}",
    "journeyMiles": "Miles",
    "journeyStamps": "Selos do percurso",
    "journeySummary": "Resumo do percurso",
    "journeyTimeline": "Cronologia do percurso",
    "journeyTimelineDesc": "Um registo dos seus marcos e conquistas no percurso",
    "keepGoingMilestones": "Continue a avançar para ganhar marcos!",
    "kpiSectionDesc": "Evolução geral da prontidão e tendências dos pilares M/E/S/H",
    "last3Months": "Últimos 3 meses",
    "level": "Nível",
    "levelCurrent": "Atual",
    "levelMilesThreshold": "{{miles}} Miles",
    "levelMilesToReach": "{{miles}} Miles adicionais para atingir este nível",
    "levelProgress": "Progresso de nível",
    "levels": {
      "ambassador": "Embaixador",
      "explorer": "Explorador",
      "newcomer": "Recém-chegado",
      "pioneer": "Pioneiro",
      "voyager": "Viajante"
    },
    "levelsCollection": "Níveis do percurso",
    "levelsCount": "{{achieved}} de {{total}} níveis alcançados",
    "limitedJourneys": "Percursos limitadas",
    "loading": "A carregar o seu passaporte...",
    "locked": "Bloqueado",
    "maxLevel": "(Máx)",
    "meshPillarTrends": "Tendências do pilar m/E/S/H",
    "miles": "Miles",
    "milesAbbr": "mi",
    "milesThisWeek": "Miles esta semana",
    "milesToNextLevel": "Miles para o próximo nível",
    "milesValue": "Valor das Miles",
    "milestonesAchievements": "Marcos & conquistas",
    "milestonesSection": "Marcos",
    "mobileApp": {
      "description": "Veja o seu passaporte completo, partilhe as suas conquistas e acompanhe o progresso do seu percurso com a app móvel.",
      "openApp": "Abrir na app",
      "title": "Passport no móvel"
    },
    "nextMilestone": "Próximo: {{name}}",
    "noAchievements": "Sem conquistas ainda",
    "noBadgesYet": "Sem emblemas de cidadão ainda. Complete atividades do percurso para ganhar emblemas.",
    "noRecentActivity": "Sem atividade recente. Comece o seu percurso para ganhar milhas!",
    "noStampsYet": "Sem carimbos ainda",
    "noTimelineYet": "Sem eventos na linha do tempo ainda. Complete atividades do percurso para ver o seu histórico.",
    "notReady": {
      "badges": "Distintivos Citizen",
      "badgesDesc": "Desbloqueie emblemas especiais que reconhecem a sua adaptação cultural",
      "miles": "Miles do percurso",
      "milesDesc": "Acumule milhas à medida que avança na sua relocação",
      "progress": "Acompanhar progresso",
      "progressDesc": "Veja a sua linha do tempo completa do percurso e marcos",
      "stamps": "Colecione selos",
      "stampsDesc": "Ganhe selos ao completar atividades com todos os heróis",
      "startCheckup": "Iniciar avaliação de CheckUp",
      "subtitle": "Complete as suas primeiras atividades de herói para começar a colecionar carimbos, ganhar emblemas e construir o seu registo de realocação.",
      "title": "O seu Passport aguarda!"
    },
    "openInApp": "Abrir na app",
    "overallReadinessEvolution": "Evolução geral da prontidão",
    "pagePrefix": "P.",
    "percentComplete": "{{percent}}% completo",
    "photo": "Foto",
    "progress": "Progresso",
    "progressLabel": "Progresso",
    "rarity": {
      "common": "Comum",
      "epic": "Épico",
      "legendary": "Lendário",
      "rare": "Raro",
      "uncommon": "Incomum"
    },
    "readinessScore": "Score de prontidão",
    "recentActivity": "Atividade recente",
    "recentActivityDesc": "As suas últimas milhas do percurso ganhas",
    "returnToDashboard": "Voltar ao painel",
    "reward": "Recompensa",
    "searchEvents": "Pesquisar eventos...",
    "shareAchievement": "Partilhar conquista",
    "shareMessage": "Ganhei o selo {{name}} na Tonnie! +{{miles}} Miles 🏆",
    "since": "Desde",
    "stampArrived": "Chegado ao destino",
    "stampArrivedDesc": "Chegou ao seu país de destino",
    "stampCultureStarter": "Início da Cultura",
    "stampCultureStarterDesc": "Concluiu o seu primeiro mundo de QultureUp",
    "stampCategory": {
      "onboarding": "Primeiros passos",
      "checkup": "CheckUp",
      "teleportal": "TelePortal",
      "qultureup": "QultureUp",
      "care": "Care",
      "inout": "InOut",
      "cross_hero": "Entre heróis"
    },
    "stampDetail": {
      "earned": "Selo obtido!",
      "locked": "Ainda não obtido",
      "milesReward": "Recompensa de Miles",
      "milesValueUnit": "{{value}} Miles",
      "title": "Detalhes do selo",
      "source": "Origem: {{category}}"
    },
    "stampFirstCare": "Primeiro ciclo de Care",
    "stampFirstCareDesc": "Concluiu o seu primeiro ciclo de feedback de Care",
    "stampFirstCheckup": "Primeiro CheckUp",
    "stampFirstCheckupDesc": "Concluiu a sua primeira avaliação de prontidão",
    "stampNotFound": "Selo não encontrado",
    "stampVisaApproved": "Visto aprovado",
    "stampVisaApprovedDesc": "A sua candidatura ao visto foi aprovada",
    "stamps": "Selos",
    "stampsCollection": "Coleção de selos",
    "stampsCollectionDesc": "Ganhe selos ao completar conquistas ao longo do seu percurso",
    "stampsCount": "{{earned}} de {{total}} selos ganhos",
    "stampsEarned": "Selos obtidos",
    "stampsSection": "Selos",
    "status": "Estado",
    "swipeToOpen": "Deslize para abrir",
    "tabs": {
      "levels": "Níveis",
      "overview": "Visão geral",
      "stamps": "Selos",
      "timeline": "Cronograma"
    },
    "thisWeek": "Esta semana",
    "timelineCheckupCompleted": "CheckUp concluído",
    "timelineCheckupCompletedDesc": "A sua pontuação de prontidão: 85/100",
    "timelineCultureBadge": "Distintivo de início da cultura obtido",
    "timelineCultureBadgeDesc": "Concluiu CheckUp + 5 lições de cultura",
    "timelineFeedbackChampion": "Campeão de feedback",
    "timelineFeedbackChampionDesc": "Concluiu o seu 3º ciclo de feedback",
    "timelineJourneyStarted": "Percurso iniciada",
    "timelineJourneyStartedDesc": "Bem-vindo ao seu percurso internacional!",
    "timelineLessonsCompleted": "10 lições concluídas",
    "timelineLessonsCompletedDesc": "Concluiu 10 lições de QultureUp",
    "timelineStreak": "Sequência de 7 dias",
    "timelineStreakDesc": "Tem aprendido de forma consistente durante 7 dias",
    "timelineVisaDocs": "Documentos do visto carregados",
    "timelineVisaDocsDesc": "Todos os documentos necessários verificados e prontos",
    "toNextLevel": "Próximo nível",
    "tonnieAverage": "Média da Tonnie",
    "title": "Passport",
    "totalJourneys": "Total de percursos",
    "totalMiles": "Total de Miles",
    "totalStamps": "Total de selos",
    "tryDifferentSearch": "Experimente um termo de pesquisa diferente",
    "unlocked": "Desbloqueado",
    "viewInMobile": "Ver em móvel",
    "visibility": "Visibilidade",
    "visibleToCompany": "Empresa",
    "visibleToTalent": "Talento",
    "visibleToTonnie": "Tonnie",
    "vsCompanyCohort": "vs coorte da empresa",
    "vsSelfHistory": "vs história pessoal",
    "vsTonnieDatabase": "vs base de dados Tonnie",
    "welcome": {
      "badgesStep": "Distintivos Citizen",
      "badgesStepDesc": "Desbloqueie distintivos que reconhecem a sua adaptação cultural",
      "description": "O seu Passport é o seu registo de realocação. Complete atividades de herói para começar a colecionar selos, ganhar emblemas e acompanhar os marcos do seu percurso.",
      "hint": "Complete o seu primeiro CheckUp para começar a colecionar selos",
      "progressStep": "Acompanhe o seu percurso",
      "progressStepDesc": "Veja a sua linha do tempo completa, marcos e quilómetros",
      "stampsStep": "Colecione selos",
      "stampsStepDesc": "Ganhe selos ao completar atividades com todos os heróis",
      "startJourney": "Comece o seu percurso",
      "title": "O seu Passport aguarda"
    },
    "yourScore": "A sua pontuação"
  },
  "payment": {
    "addPaymentMethod": "Adicionar método de pagamento",
    "amount": "Montante",
    "basePrice": "Preço base",
    "cancelFamilyAddon": "Cancelar adicional familiar",
    "cancelFamilyAddonDesc": "Tem a certeza de que deseja cancelar o seu Adicional Familiar? Manterá o acesso até ao final do seu período de faturação.",
    "cancelFamilyAddonWarning": "Após o cancelamento, perderá o acesso às funcionalidades do Programa Familiar no final do seu período de faturação.",
    "cardEnding": "Cartão terminado em {{last4}}",
    "cardExpires": "Expira {{month}}/{{year}}",
    "checkoutCancelled": "Checkout cancelado",
    "checkoutError": "Falha ao iniciar o checkout. Por favor, tente novamente.",
    "checkoutSuccess": "Pagamento bem-sucedido! A processar o seu pedido...",
    "citizenOnly": "Citizen apenas",
    "confirmAndPay": "Confirmar & pagar",
    "coupon": {
      "apply": "Aplicar",
      "applied": "{{code}} · {{percent}}% de desconto aplicado",
      "applyOrClear": "Aplique o cupão para o usar, ou limpe-o para continuar sem um.",
      "invalid": "Este código de cupão não é válido.",
      "label": "Tem um cupão?",
      "placeholder": "Introduza o código",
      "remove": "Remover",
      "errors": {
        "notFound": "Este código de cupão não existe. Verifique-o e tente novamente.",
        "expired": "Este cupão expirou ou ainda não está ativo.",
        "disabled": "Este cupão já não está disponível.",
        "exhausted": "Este cupão atingiu o limite de utilizações e não pode voltar a ser usado.",
        "wrongProduct": "Este cupão não pode ser usado nesta compra."
      }
    },
    "confirmCancelFamily": "Confirmar cancelamento",
    "confirmCancelPro": "Confirmar cancelamento",
    "confirmDowngrade": "Tem a certeza de que deseja cancelar a sua subscrição Pro? Manterá o acesso até ao final do seu período de faturação.",
    "confirmRenewal": "Confirmar renovação",
    "createFirstJourney": "Crie a sua primeiro percurso",
    "createJourneyFirst": "Por favor, crie primeiro uma instância de percurso",
    "createNewJourney": "Criar novo percurso",
    "creditSourcePromotion": "Bónus de Boas-Vindas",
    "creditSourceReferral": "Convidou 2 amigos",
    "currentExpiration": "Data de expiração atual",
    "currentPlan": "Plano atual",
    "discount": "Desconto",
    "downgradeToJourney": "Cancelar subscrição Pro",
    "downgradeWarning": "Após o cancelamento, manterá o acesso Pro até ao fim do seu período de faturação. Depois, os percursos cobertos pelo Pro voltam ao acesso básico; um percurso que desbloqueou ou que uma empresa patrocina mantém o acesso total.",
    "downgradedToJourney": "Subscrição Pro cancelada. Manterá o acesso até ao final do seu período de faturação.",
    "editPaymentMethod": "Editar",
    "expiresOn": "Expira em",
    "expiringSoon": "A expirar em breve",
    "familyAddon": "Adicional familiar",
    "familyAddonActive": "Programa Familiar está ativo",
    "familyAddonCancelled": "Adicional Familiar cancelado com sucesso!",
    "familyAddonDesc": "Junte a sua família no seu percurso. Convide membros da família para partilhar acesso, gerir tarefas do agregado familiar juntos e apoiar o sucesso da integração de todos.",
    "familyAddonFeature1": "Convide membros da família — todos obtêm acesso Citizen e funcionalidades Citizen Web",
    "familyAddonFeature2": "TelePortal e Care a pensar no agregado familiar — gerir a realocação em conjunto",
    "familyAddonFeature3": "Progresso do percurso partilhado — todos ficam ligados e apoiados",
    "familyAddonFeatures": "Gerir membros da família e permissões",
    "familyAddonPurchased": "Adicional Familiar adquirido com sucesso!",
    "familyAddonTitle": "Acesso ao programa familiar",
    "featureAdvancedCare": "Recursos completos de Care: pontos de verificação, ciclos de feedback e suporte",
    "featureAllHeroes": "Todos os 5 heróis desbloqueados",
    "featureBasicCareer": "Oportunidades de Career e criador de CV",
    "featureBasicCheckup": "Avaliação completa de CheckUp e resultados",
    "featureBasicPassport": "Passport: Miles, selos, distintivos Citizen e níveis",
    "featureCareer": "Oportunidades de Career, correspondência e candidaturas proativas",
    "featureFullAccess": "Acesso total a todas as funcionalidades do percurso",
    "featureFullCheckup": "Complete CheckUp com análise completa de MESH e pontuações de iQulture",
    "featureFullPassport": "Passport completo, incluindo o Cronograma do seu percurso",
    "featureFullQultureup": "Complete QultureUp: todos os mundos, lições e conteúdo do criador",
    "featureFullTeleportal": "TelePortal completo: todas as fases, validação de documentos e revisão de IA",
    "featureLimitedCopilot": "Consultas limitadas de CoPilot",
    "featureLimitedQultureup": "Missões limitadas de QultureUp",
    "featureLimitedTeleportal": "Apenas a lista de verificação de TelePortal (sem carregamento de documentos)",
    "featureNoExtra": "Nenhum pagamento adicional necessário",
    "featurePriority": "Suporte prioritário e respostas mais rápidas",
    "featureProPeriod": "Acesso durante a duração da sua subscrição Pro",
    "featureUnlimitedCopilot": "CoPilot ilimitado (guia, cérebro e agente) — todos os modos",
    "featureEveryJourneyFull": "Acesso total em todas os percursos que criar",
    "freePlan": "Plano gratuito",
    "freePlanDesc": "Crie quantos percursos precisar — cada um começa com acesso básico às funcionalidades essenciais. Desbloqueie um percurso ou passe a Pro para ter acesso total.",
    "fullAccessEnabled": "Acesso total ativado",
    "includedInPro": "Incluído no seu plano Pro",
    "includedInSubscription": "Incluído na subscrição Pro",
    "installmentPeriod": "Período de prestações",
    "installmentPlan": "Plano de prestações",
    "installments": "Prestações",
    "instantUnlock": "Desbloqueio instantâneo",
    "invoiceHistory": "Histórico de faturas",
    "invoiceHistoryDesc": "Veja e transfira as suas faturas",
    "journeyRenewed": "Percurso renovada com sucesso!",
    "journeyUnlocked": "Percurso desbloqueada com sucesso!",
    "managePaymentMethods": "Gerir os seus métodos de pagamento",
    "month": "mês",
    "monthly": "Mensal",
    "monthlyPayment": "Pagamento mensal",
    "newExpiration": "Nova expiração",
    "noInvoices": "Ainda sem faturas",
    "noInvoicesHint": "As faturas aparecerão aqui após o seu primeiro pagamento",
    "noJourneyInstances": "Ainda sem percursos configuradas",
    "oneTimePayment": "Pagamento único",
    "paymentMethods": "Métodos de pagamento",
    "paymentOption": "Opção de pagamento",
    "paymentSecurity": "O seu pagamento é seguro e encriptado. Aceitamos principais cartões de crédito e métodos de pagamento locais (SIBS para Portugal, Stripe para outros).",
    "paymentType": "Tipo de pagamento",
    "price": "Preço",
    "proJourney": "Plano Pro",
    "proJourneyDesc": "Acesso total em todas os percursos que criar — todos os heróis, funcionalidades avançadas e suporte premium.",
    "proEndsOn": "O seu plano Pro termina a {{date}}",
    "proUnlockDesc": "Desbloqueie este percurso instantaneamente com a sua subscrição Pro",
    "proUnlockError": "Falha ao desbloquear o percurso. Por favor, tente novamente.",
    "proUnlockSuccess": "Percurso desbloqueada instantaneamente com a sua subscrição Pro!",
    "proceedToPayment": "Proceder ao pagamento",
    "processing": "A processar...",
    "purchaseFamilyAddon": "Comprar add-on familiar",
    "purchaseJourneyInstance": "Comprar instância do percurso",
    "purchaseJourneyInstanceDesc": "Desbloqueie todas as funcionalidades deste percurso",
    "purchasedOn": "Comprado em",
    "recommended": "Recomendado",
    "removePaymentMethod": "Remover",
    "renewJourneyInstance": "Renovar instância do percurso",
    "renewJourneyInstanceDesc": "Prolongue o seu acesso a este percurso",
    "renewNow": "Renovar agora",
    "renewalPrice": "Preço de renovação",
    "saveYearly": "Poupe {{amount}} por ano!",
    "scenarioAlreadyAbroad": "Já no estrangeiro",
    "scenarioIntegrationOnly": "Integração apenas",
    "scenarioPreImmigration": "Pré-imigração",
    "scenarioRelocationOnly": "Realocação apenas",
    "secureCheckout": "Checkout seguro powered by Stripe",
    "selectInstallmentPeriod": "Selecionar período de parcelamento",
    "selectJourneyToPurchase": "Selecione uma instância de percurso para comprar",
    "selfPaidJourneys": "Percursos pagas pelo próprio",
    "sponsoredJourneys": "Percursos patrocinadas",
    "total": "Total",
    "totalAmount": "Montante total",
    "unlockInstant": "Desbloquear instantaneamente",
    "unlockJourney": "Desbloquear percurso",
    "unlockNow": "Desbloquear agora",
    "unlockedJourneys": "Percursos configuradas",
    "unlockedJourneysDesc": "Todas as suas instâncias de percurso compradas e patrocinadas",
    "unlocking": "A desbloquear...",
    "upfront": "Pagamento antecipado",
    "upfrontPrice": "Pagamento antecipado",
    "upgradeDescription": "Desbloqueie todas as funcionalidades e acelere o seu percurso",
    "upgradeToPro": "Atualizar para Pro",
    "upgradedToPro": "Atualizado para o plano Pro!",
    "whatYouGet": "O que recebe",
    "year": "ano",
    "yearly": "Anual",
    "featureMonthsAccess_one": "{{count}} mês de acesso ilimitado",
    "featureMonthsAccess_other": "{{count}} meses de acesso ilimitado",
    "coveredByPro": "A sua subscrição Pro já cobre este percurso — desbloqueie-o com o Pro, sem custo adicional.",
    "renewNotRenewable": "Este percurso não pode ser renovado enquanto uma empresa o patrocina.",
    "paymentReference": "Ref. de pagamento {{reference}}",
    "refunded": "Reembolsado {{amount}}",
    "documentUnavailable": "Não foi possível abrir este documento agora. Tente novamente.",
    "invoicesLoadFailed": "Não foi possível carregar as suas faturas."
  },
  "persona": {
    "familyMaster": {
      "badge": "Controlador",
      "controlsHousehold": "Controla o TelePortal e o Care do seu agregado familiar",
      "description": "Talento principal que controla o percurso da família. Acesso completo a todas as funcionalidades, além de responsabilidades de gestão do agregado familiar.",
      "title": "Mestre da família"
    },
    "info": {
      "description": "A sua persona determina o seu nível de acesso e as funcionalidades disponíveis. Pode alterá-la mais tarde nas definições do seu perfil, se necessário.",
      "title": "Sobre personas"
    },
    "loading": "A carregar...",
    "matrix": {
      "allowed": "Acesso completo",
      "billingCompanySponsored": "Faturação gerida pela empresa patrocinadora",
      "billingDescription": "Gestão de plano e faturação",
      "billingGovernmentSponsored": "Faturação gerida pelo governo/programa patrocinador",
      "careDescription": "Pontos de verificação e suporte pós-chegada",
      "careerDescription": "Oportunidades de emprego e ferramentas de carreira",
      "checkupDescription": "Avaliação de prontidão pré-imigração",
      "citizenMobile": "Citizen móvel",
      "controls": "Controles",
      "cvBuilder": "Construtor de CV",
      "cvBuilderDescription": "Gerador de CV e templates ao estilo da UE",
      "description": "Compare o acesso às funcionalidades entre todas as personas. Selecione uma persona para continuar.",
      "familyProgramDescription": "Gestão e convites do programa familiar",
      "familyProgramViaBilling": "Disponível através da faturação. Compre um plano para se tornar o mestre da família e geri-lo",
      "features": "Funcionalidades",
      "homeDescription": "Painel e visão geral do percurso",
      "journeyBuilder": "Construtor de percurso",
      "journeyBuilderDescription": "Configure e construa o seu percurso personalizado",
      "journeyBuilderViaBilling": "Disponível após a compra de um plano via Faturação",
      "journeyBuilderViaBillingBecomesTalent": "Disponível via faturação. Após a compra de créditos/pro, torna-se fluxo de talento",
      "legend": {
        "allowed": "Acesso completo",
        "citizenMobile": "Disponível através da aplicação móvel Citizen",
        "controls": "Funcionalidade de controles",
        "limited": "Acesso limitado (apenas próprio)",
        "notAllowed": "Não disponível",
        "viaBilling": "Disponível via faturação/Aprimoramento"
      },
      "limited": "Acesso limitado",
      "notAllowed": "Não disponível",
      "passportDescription": "Linha do tempo do percurso e conquistas",
      "profileDescription": "Definições e preferências do perfil",
      "qultureupDescription": "Integração cultural e aprendizagem",
      "selected": "Selecionado",
      "teleportalDescription": "Tarefas de realocação e mobilidade",
      "title": "Matriz de acesso a funcionalidades",
      "viaBilling": "Via faturação"
    },
    "select": "Selecione este papel",
    "subtitle": "Escolha a persona que melhor corresponde ao seu papel no percurso. Isto determinará as funcionalidades a que pode aceder.",
    "talent": {
      "description": "Principal talento a planear uma mudança de carreira internacional. Acesso total a todas as funcionalidades Citizen.",
      "title": "Talento (individual)"
    },
    "talentB2B2C": {
      "badge": "Patrocinado pela empresa",
      "description": "Talento com percurso patrocinado por uma empresa. Funcionalidades de nível Pro, sem pagamento necessário.",
      "title": "Talento (patrocinado pela empresa)"
    },
    "talentB2G": {
      "badge": "Patrocinado pelo governo",
      "description": "Talento com percurso patrocinado por programa governamental/público. Funcionalidades de nível Pro, sem pagamento necessário.",
      "title": "Talento (patrocinado pelo governo)"
    },
    "title": "Selecione o seu papel no percurso"
  },
  "preferences": {
    "title": "Preferências"
  },
  "profile": {
    "aboutAndLegal": "Sobre & legal",
    "aboutTonnieJourney": "Sobre Tonnie Citizen",
    "address": "Endereço",
    "allowCohortComparisons": "Permitir benchmarking da empresa",
    "allowCohortComparisonsDesc": "Permita que empresas parceiras comparem o seu perfil anonimizado para obter insights sobre talentos",
    "backupCodesDesc": "Guarde estes códigos num local seguro. Cada código só pode ser utilizado uma vez para aceder à sua conta se perder o seu dispositivo de autenticação.",
    "backupCodesDone": "Guardei os meus códigos",
    "backupCodesTitle": "Guarde os seus códigos de backup",
    "cantScanQr": "Não consegue ler o código? Introduza esta chave manualmente:",
    "changePhoto": "Alterar foto",
    "photo": {
      "actionSheetTitle": "Foto de perfil",
      "takePhoto": "Tirar foto",
      "chooseFromLibrary": "Escolher da biblioteca",
      "remove": "Remover foto",
      "removeConfirmTitle": "Remover foto de perfil?",
      "removeConfirmBody": "A sua foto será removida e as suas iniciais serão mostradas em vez disso.",
      "uploadSuccess": "Foto de perfil atualizada",
      "uploadError": "Não foi possível atualizar a sua foto. Por favor, tente novamente.",
      "removeSuccess": "Foto de perfil removida",
      "managedByTitle": "Gerido por {{provider}}",
      "genericProvider": "o seu fornecedor de autenticação",
      "cameraPermissionTitle": "Acesso à câmara necessário",
      "cameraPermissionMessage": "Para tirar uma nova foto de perfil, permita o acesso à câmara para a Tonnie nas definições do seu dispositivo.",
      "libraryUnavailableTitle": "Biblioteca de fotos indisponível",
      "libraryUnavailableMessage": "Não conseguimos abrir a sua biblioteca de fotos. Por favor, tente novamente."
    },
    "completeOnWeb": "Completar perfil na web",
    "completeOnWebDesc": "Defina as suas metas de mobilidade e edite os detalhes da sua carreira no Portal Web Citizen.",
    "completeProfile": "Complete o seu perfil",
    "confirmDeleteAccount": "Sim, eliminar a minha conta",
    "confirmDisable2FA": "Sim, Desativar 2FA",
    "connectLinkedInIdentity": "Ligar o LinkedIn (para identidade)",
    "contactSupport": "Entre em contacto com a nossa equipa de suporte",
    "contactSupportButton": "Contactar suporte",
    "copyBackupCodes": "Copiar todos os códigos",
    "copyright": "© 2024 Tonnie. Todos os direitos reservados.",
    "currentRole": "Função atual",
    "currentSession": "Sessão atual",
    "dangerZone": "Zona de perigo",
    "dataProtection": "Proteção de dados",
    "dataProtectionDesc": "Tem o direito de aceder, modificar ou eliminar os seus dados pessoais a qualquer momento. Para mais informações sobre a forma como tratamos os seus dados, consulte a nossa Política de Privacidade.",
    "dateOfBirth": "Data de nascimento",
    "deleteAccount": "Eliminar conta",
    "deleteAccountError": "Falha ao eliminar a conta. Por favor, tente novamente.",
    "deleteAccountTitle": "Eliminar a sua conta",
    "deleteAccountWarning": "Esta ação é permanente. Todos os seus dados, progresso do percurso e documentos carregados serão eliminados permanentemente. Isto não pode ser desfeito.",
    "description": "Gerir a sua conta e preferências",
    "disable2FA": "Desativar 2FA",
    "disable2FATitle": "Desativar autenticação em duas etapas",
    "disable2FAWarning": "Tem certeza de que deseja desativar a autenticação em duas etapas? A sua conta será menos segura sem ela.",
    "disconnectIdentity": "Desconectar identidade",
    "educationCount": "Educação ({{count}})",
    "educationalBackground": "Percurso educacional",
    "email": "Email",
    "emailNotifications": "Notificações por email",
    "emailNotificationsDesc": "Receber atualizações por email",
    "enable2FA": "Ativar 2FA",
    "enabled": "Ativado",
    "experienceCount": "Experiência ({{count}})",
    "feature": {
      "billingManagement": "Gestão de faturação e subscrições",
      "careCheckpoints": "Gestão de pontos de verificação de Care e acompanhamento do bem-estar",
      "careerOpportunities": "Oportunidades de Career e criador de CV",
      "checkupAssessments": "Avaliações completas de CheckUp e acompanhamento da prontidão",
      "familyProgram": "Gestão do programa familiar",
      "passportTimeline": "Linha do tempo de Passport, selos e emblemas",
      "qultureupLearning": "Sumários de aprendizagem de QultureUp e painéis de progresso",
      "teleportalManagement": "Gestão do plano de TelePortal e coordenação de tarefas"
    },
    "firstName": "Primeiro nome",
    "firstNamePlaceholder": "Introduza o primeiro nome",
    "fullName": "Nome completo",
    "gdprCompliance": "Conformidade com o GDPR",
    "gdprComplianceDesc": "A Tonnie cumpre o Regulamento Geral sobre a Proteção de Dados (RGPD) e as outras leis de proteção de dados aplicáveis. Pode exercer os seus direitos através de contacto connosco na app ou no site.",
    "keyFeatures": "Principais funcionalidades",
    "languages": "Idiomas",
    "lastName": "Último nome",
    "lastNamePlaceholder": "Introduza o último nome",
    "lastPdfUpload": "Último PDF carregado: {{date}}",
    "learnMoreAboutTonnie": "Saiba mais sobre Tonnie Citizen e a nossa plataforma",
    "legalInformation": "Informações legais e políticas",
    "linkedInDisconnected": "LinkedIn desconectado",
    "logOut": "Sair",
    "mobility": "Mobilidade",
    "mobilityDescription": "Cidadania, passaporte e interesses de realocação",
    "needHelp": "Precisa de ajuda?",
    "notProvided": "—",
    "notificationSettings": "Definições de notificação",
    "ongoing": "Em andamento",
    "personalInfo": "Informações do perfil",
    "personalInfoDescription": "Atualize as suas informações pessoais e detalhes do perfil",
    "phone": "Telefone",
    "phoneInvalidFormat": "O número de telefone só pode conter dígitos, espaços, hífens e +",
    "phoneNumber": "Número de telefone",
    "phonePlaceholder": "912 345 678",
    "phoneTooShort": "O número de telefone é muito curto (mínimo 6 dígitos)",
    "photoSet": "Foto definida",
    "platformOverview": "Visão geral da plataforma",
    "platformOverviewDescription": "Tonnie Citizen Web funciona perfeitamente com Tonnie Citizen Mobile para proporcionar uma experiência de realocação completa. A aplicação móvel é o seu companheiro diário para ações rápidas e funcionalidades mobile-first, enquanto o portal web fornece ferramentas de planeamento abrangentes, avaliações detalhadas e acompanhamento de progresso.",
    "preferenceSettings": "Definições de preferências",
    "preferences": "Preferências",
    "preferencesSaveError": "Falha ao guardar a preferência",
    "privacyImportance": "A sua privacidade é importante para nós. A nossa Política de Privacidade explica como recolhemos, utilizamos e protegemos as suas informações pessoais.",
    "privacyPolicy": "Política de privacidade",
    "privacyPolicyDesc": "Como tratamos e protegemos os seus dados pessoais",
    "privacySettingUpdated": "Configuração de privacidade atualizada",
    "privacySettings": "Definições de privacidade",
    "professionalWorkExperience": "Experiência profissional",
    "profile": "Perfil",
    "profilePhoto": "Foto de perfil",
    "profileUpdateFailed": "Falha ao atualizar o perfil. Por favor, tente novamente.",
    "profileUpdated": "Perfil atualizado com sucesso!",
    "pushNotifications": "Notificações push",
    "pushNotificationsDesc": "Receba notificações no seu dispositivo",
    "readyToComplete": "Pronto para completar a sua integração!",
    "reviewAndComplete": "Revise todas as informações acima e clique em \"Completar\" para finalizar.",
    "scanQrCode": "Leia este código QR",
    "scanQrCodeDesc": "Use a sua aplicação de autenticação (por exemplo, Google Authenticator, Authy) para ler o código QR abaixo.",
    "security": "Segurança",
    "sessionBrowserOnDevice": "{{browser}} em {{device}}",
    "settingDisabled": "{{setting}} desativado",
    "settingEnabled": "{{setting}} ativado",
    "shareAnalytics": "Partilhar análises",
    "shareAnalyticsDesc": "Ajude a melhorar a nossa plataforma com dados de utilização anonimizados",
    "showInTalentPool": "Mostre-me no Talent Pool",
    "showInTalentPoolDesc": "Deixe as empresas contratantes na Tonnie descobrirem o seu perfil. Pode optar por sair a qualquer momento.",
    "skills": "Competências",
    "skillsDescription": "Competências e especialização profissional",
    "quietHours": "Horário de silêncio",
    "quietHoursDesc": "Pausar notificações push durante este período.",
    "quietHoursEnd": "Até",
    "quietHoursTimezone": "As horas estão em {{timeZone}}.",
    "quietHoursStart": "De",
    "termsAgreement": "Ao utilizar o Tonnie Citizen, aceita os nossos Termos de Serviço. Reveja os termos completos para compreender os seus direitos e obrigações.",
    "termsAndPrivacy": "Termos & privacidade",
    "termsOfService": "Termos de serviço",
    "termsOfServiceDesc": "Os nossos termos e condições para usar Tonnie Citizen",
    "title": "Perfil",
    "tonnieJourney": "Tonnie Citizen",
    "tonnieJourneyDescription": "O Tonnie Citizen é a sua plataforma completa para planear e gerir o seu percurso de realocação internacional. Acompanhe o seu progresso, aceda a painéis detalhados e coordene a sua mudança com precisão.",
    "twoFactor": {
      "backupCodesLabel": "Códigos de backup",
      "disableError": "Falha ao desativar 2FA",
      "disabledToast": "Autenticação de dois fatores desativada",
      "enableError": "Falha ao iniciar a configuração de 2FA",
      "enabledToast": "Autenticação de dois fatores ativada",
      "copySecretKey": "Copiar chave secreta",
      "secretKeyLabel": "Chave secreta",
      "verifyError": "Código de verificação inválido. Por favor, tente novamente."
    },
    "twoFactorAuth": "Autenticação de dois fatores",
    "twoFactorAuthDesc": "Adicione uma camada extra de segurança",
    "verificationCode": "Código de verificação",
    "verify": "Verificar",
    "version": "Versão {{version}}",
    "viewPolicy": "Ver política",
    "viewTerms": "Ver termos",
    "yourRights": "Os seus direitos",
    "notifCatHero": "Percurso e progresso",
    "notifCatHeroDesc": "Novidades do CheckUp, Care, QultureUp, TelePortal e Passport.",
    "notifCatSystem": "Conta e sistema",
    "notifCatSystemDesc": "Segurança, conta e manutenção da plataforma.",
    "notifCatSocial": "Pessoas e empresas",
    "notifCatSocialDesc": "Convites, avaliações, equipa e mensagens.",
    "notifCatAlert": "Alertas e lembretes",
    "notifCatAlertDesc": "Sensíveis a tempo ou dinheiro: faturas, pagamentos e prazos.",
    "notifMatrixTitle": "Como é avisado de cada atualização",
    "notifMatrixDesc": "Escolha email e push para cada tipo de atualização. A sua caixa de entrada guarda sempre uma cópia.",
    "notifMatrixCategory": "Categoria",
    "notifMatrixInApp": "Na aplicação",
    "notifMatrixEmail": "Email",
    "notifMatrixPush": "Push",
    "notifMatrixInAppAlways": "Sempre ativo — a sua caixa de entrada guarda todas as mensagens",
    "notifMatrixEmailOff": "As Notificações por Email estão desativadas, por isso nenhuma categoria envia email. Ative-as para escolher aqui.",
    "notifMatrixPushOff": "As Notificações Push estão desativadas, por isso nenhuma categoria envia push. Ative-as para escolher aqui.",
    "notifMatrixCell": "{{channel}} para {{category}}",
    "identitySection": "Identidade",
    "currentCountry": "País atual",
    "currentCountryPlaceholder": "Selecione onde vive atualmente",
    "currentCity": "Cidade atual",
    "currentCityPlaceholder": "A cidade onde vive atualmente",
    "sections": {
      "add": "Adicionar {{section}}",
      "saved": "Guardado.",
      "saveFailed": "Não foi possível guardar. Tente novamente.",
      "importSaved": "Importado para o seu perfil.",
      "fixErrors_one": "{{count}} campo precisa de atenção",
      "fixErrors_other": "{{count}} campos precisam de atenção",
      "status": {
        "complete": "Completa",
        "empty": "Por preencher"
      },
      "identity": {
        "title": "Identidade",
        "description": "O seu nome, data de nascimento, telefone e onde vive."
      },
      "mobility": {
        "title": "Mobilidade e passaporte",
        "description": "A sua cidadania, passaporte, agregado familiar e como prefere trabalhar."
      },
      "skills": {
        "title": "Competências",
        "description": "A sua função, anos de experiência, idiomas e competências."
      },
      "education": {
        "title": "Formação",
        "description": "Os seus cursos e graus académicos."
      },
      "experience": {
        "title": "Experiência",
        "description": "Onde trabalhou e o que fez."
      },
      "import": {
        "title": "Importar do seu CV ou do LinkedIn",
        "description": "Carregue um CV ou um PDF do LinkedIn e preenchemos as suas competências, formação e experiência. Revê tudo antes de ser guardado.",
        "cta": "Importar CV ou LinkedIn"
      }
    },
    "strengthen": {
      "title": "Reforce o seu perfil",
      "description": "A sua pontuação está pronta. Dê a conhecer mais sobre si às empresas: acrescente qualquer um destes quando quiser. Nada disto é obrigatório."
    },
    "degreeInField": "{{degree}} em {{field}}",
    "strength": {
      "gaugeCaption": "força",
      "gaugeLabel": "Força do perfil: {{percent}} por cento",
      "headline": "O seu perfil está {{percent}}% completo",
      "headlineComplete": "O seu perfil está completo",
      "subline_one": "Falta {{count}} elemento. Os assinalados abaixo influenciam a sua pontuação iQulture.",
      "subline_other": "Faltam {{count}} elementos. Os assinalados abaixo influenciam a sua pontuação iQulture.",
      "sublineComplete": "O seu CheckUp tem tudo o que o perfil lhe pode dar, e as empresas veem tudo.",
      "level": {
        "getting_started": "A começar",
        "good": "Bom",
        "strong": "Forte",
        "complete": "Completo"
      },
      "next": {
        "label": "Próximo passo",
        "labelFastest": "Próximo passo · o mais rápido",
        "documentFills": "Um só carregamento preenche: {{items}}",
        "documentButton": "Carregar passaporte"
      },
      "why": {
        "start": "Necessário para iniciar o seu CheckUp",
        "persona": "Necessário para iniciar · define como o iQulture o lê",
        "languages": "O seu nível de inglês influencia a pontuação de Comunicação",
        "experience": "Influencia a sua pontuação de Experiência Global",
        "years": "Influencia as suas pontuações de competências e experiência",
        "skills": "Influencia a sua pontuação de competências",
        "education": "Influencia a sua pontuação de Preparação Académica",
        "workModel": "Influencia a sua pontuação de Flexibilidade de Modelo de Trabalho",
        "passport": "A sua mudança precisa dele — o TelePortal usa-o"
      },
      "readiness": {
        "startTitle": "Necessário para iniciar o seu CheckUp",
        "startDone": "Tudo pronto. O seu CheckUp pode começar quando quiser.",
        "scoreTitle": "Influencia a sua pontuação iQulture",
        "scoreHint": "A pontuação é calculada sem isto, mas com menos informação:",
        "scoreDone": "A sua pontuação tem tudo o que o perfil lhe pode dar.",
        "more_one": "+{{count}}",
        "more_other": "+{{count}}"
      },
      "tag": {
        "start": "Necessário para iniciar",
        "score": "Influencia o iQulture",
        "journey": "Para o seu percurso"
      },
      "item": {
        "name": "Nome completo",
        "date_of_birth": "Data de nascimento",
        "phone": "Telefone",
        "residence": "Onde vive",
        "nationality": "Cidadania",
        "passport": "Passaporte válido",
        "work_model": "Como prefere trabalhar",
        "current_role": "Cargo atual",
        "years_experience": "Anos de experiência",
        "skills": "Competências",
        "languages": "Nível de inglês",
        "education": "Um curso ou formação",
        "experience": "Um cargo que tenha ocupado"
      },
      "addItem": "Adicionar {{item}}",
      "sectionBar": "Secções do perfil",
      "sectionCount": "{{complete}} de {{total}}",
      "fillFaster": {
        "recommended": "Recomendado"
      },
      "missing": "Ainda falta",
      "fromCareerCv": "O seu CV no Career já dá isto à sua pontuação iQulture. Adicione aqui também para o mostrar no seu perfil.",
      "loadFailed": "Não conseguimos carregar o quão completo está o seu perfil.",
      "tiles": {
        "start": "Para começar o CheckUp",
        "score": "Para o seu score iQulture",
        "sections": "Secções completas"
      }
    },
    "identityDocument": {
      "title": "Preencha com o seu passaporte ou Cartão de Cidadão",
      "subtitle": "Carregue uma vez. Nós lemos e mostramos-lhe o resultado para confirmar.",
      "close": "Fechar",
      "typeGroup": "Tipo de documento",
      "passport": "O meu passaporte",
      "passportHint": "Uma só página. Preenche mais, e qualquer mudança de país precisa dele.",
      "idCard": "O meu cartão de cidadão",
      "idCardHint": "Frente e verso. Preenche o seu nome, data de nascimento e nacionalidade.",
      "uploadPassport": "A página com fotografia do seu passaporte",
      "uploadFront": "Frente do seu Cartão de Cidadão",
      "uploadBack": "Verso do seu Cartão de Cidadão",
      "uploadHint": "Uma fotografia ou digitalização · JPG, PNG, HEIC ou PDF, até {{size}} MB",
      "chooseFile": "Escolher ficheiro",
      "source": {
        "camera": "Tirar uma fotografia",
        "library": "Escolher uma fotografia",
        "files": "Escolher um ficheiro"
      },
      "cameraPermission": "Precisamos de acesso à câmara para fotografar o seu documento. Pode permitir nas Definições.",
      "pickUnavailable": "Não é possível escolher um ficheiro agora.",
      "replaceFile": "Alterar",
      "aiNotice": "O seu documento é lido pelo nosso serviço de IA para preencher o seu perfil. Nada é guardado no seu perfil até confirmar. O ficheiro fica no seu Cofre e pode eliminá-lo quando quiser.",
      "continue": "Continuar",
      "back": "Voltar",
      "cancel": "Cancelar",
      "read": "Ler documento",
      "reading": {
        "saving": "A guardar no seu Cofre",
        "reading": "A ler o documento"
      },
      "review": {
        "intro": "Assinale o que pretende usar. Onde o seu perfil já diz algo diferente, fica por assinalar para que nada mude de surpresa.",
        "verified": "Conferido",
        "unverified": "Lido por IA — confirme",
        "onFile": "No seu perfil: {{value}}",
        "passportValid": "Válido até {{date}}",
        "passportExpired": "Caducou a {{date}}",
        "profileYes": "Sim",
        "profileNo": "Não",
        "documentNumber": "Documento terminado em {{last4}}",
        "expiredWarning": "Este passaporte caducou. Usá-lo regista que não tem um passaporte válido.",
        "save": "Guardar no meu perfil",
        "discard": "Descartar",
        "matches": "Igual ao seu perfil"
      },
      "done": {
        "title": "O seu documento foi adicionado",
        "bodyPassport": "Guardado no seu Cofre e preenchido no seu perfil. O TelePortal vai usá-lo nas tarefas do passaporte, sem novo carregamento.",
        "bodyIdCard": "Guardado no seu Cofre e preenchido no seu perfil.",
        "close": "Concluir"
      },
      "error": {
        "notIdentity": "Isto não parece um passaporte nem um Cartão de Cidadão. Experimente uma fotografia nítida da página com fotografia.",
        "unreadable": "Não conseguimos ler esse ficheiro. Experimente uma fotografia mais nítida ou um PDF digitalizado.",
        "unsupported": "Esse tipo de ficheiro não é suportado. Use JPG, PNG, HEIC ou PDF.",
        "tooLarge": "Esse ficheiro tem mais de {{size}} MB. Use uma fotografia ou digitalização mais pequena.",
        "unavailable": "A leitura de documentos não está disponível neste momento. Tente novamente dentro de instantes.",
        "generic": "Ocorreu um erro ao ler o seu documento. Tente novamente.",
        "upload": "O carregamento não terminou. Tente novamente.",
        "save": "Não conseguimos guardar. Tente novamente.",
        "tryAgain": "Experimentar outro ficheiro"
      },
      "steps": {
        "document": "Documento",
        "upload": "Carregamento",
        "reading": "Leitura",
        "review": "Revisão"
      },
      "stepsAria": "Progresso do carregamento",
      "start": "Começar",
      "privacyTitle": "Privado por definição.",
      "upload": {
        "title": "Adicione uma fotografia ou digitalização nítida",
        "tipFrame": "A página inteira, plana e focada",
        "tipGlare": "Sem reflexos nem dedos sobre o texto",
        "tipMrzPassport": "As duas linhas de código no fundo da página totalmente visíveis",
        "tipMrzIdCard": "As linhas de código do verso totalmente visíveis",
        "dropHint": "Arraste uma fotografia ou PDF para aqui"
      },
      "readingView": {
        "title": "A ler o seu documento",
        "subtitle": "Demora alguns segundos. Nada chega ao seu perfil até confirmar.",
        "savingCount": "A guardar no seu Vault · {{saved}} de {{total}}"
      },
      "reviewView": {
        "title": "Confirme o que lemos",
        "mrzVerified": "A zona de leitura ótica está correta",
        "mrzUnverified": "Não foi possível verificar uma zona de leitura ótica — reveja cada linha",
        "selected_one": "{{count}} linha a guardar",
        "selected_other": "{{count}} linhas a guardar"
      },
      "doneView": {
        "applied": "Já no seu perfil",
        "nothingApplied": "O seu documento está no seu Vault. Nada mudou no seu perfil."
      },
      "line": {
        "name": "Nome legal, como no documento",
        "account_name": "Usar como nome da sua conta",
        "date_of_birth": "Data de nascimento",
        "nationality": "Nacionalidade",
        "passport": "Passaporte válido"
      },
      "legalName": {
        "label": "Nome no seu passaporte ou cartão de cidadão",
        "hint": "Lido do seu documento. Preenche os formulários em que o documento tem de coincidir; o nome da conta acima é o que as pessoas veem."
      },
      "sourceShort": {
        "camera": "Câmara",
        "library": "Fotos",
        "files": "Ficheiros"
      },
      "slot": {
        "empty": "Ainda não adicionado",
        "added": "Adicionado"
      }
    },
    "emailChange": {
      "sameAsCurrent": "Este já é o seu email de acesso.",
      "taken": "Este endereço pertence a outra conta Tonnie. Use outro.",
      "done": "O seu email de acesso é agora {{email}}. Enviámos um aviso para o endereço anterior.",
      "oldKept": "Agora inicia sessão com {{email}}, mas {{old}} continua na sua conta.",
      "oldLinked": "{{old}} continua na sua conta: continua a iniciar sessão com {{provider}} através dele.",
      "oldLinkedOther": "{{old}} continua na sua conta: um método de acesso que usa está ligado a ele.",
      "removeOld": "Remover o endereço antigo",
      "sendError": "Não conseguimos enviar o código neste momento. Tente novamente dentro de alguns minutos.",
      "verifyError": "Não conseguimos verificar o código neste momento. Tente novamente dentro de alguns minutos.",
      "switchError": "O novo endereço está confirmado, mas não conseguimos torná-lo o seu email de acesso. Tente novamente."
    },
    "review": {
      "company": {
        "children_one": "1 filho",
        "children_other": "{{count}} filhos",
        "partner": "Cônjuge",
        "personalInfoDescription": "O que o talento partilhou sobre si",
        "pets": "Animais de estimação",
        "validPassport": "Passaporte válido"
      },
      "present": "Atual",
      "showMore": "Ver mais",
      "showLess": "Ver menos"
    },
    "ways": {
      "document": {
        "title": "Passaporte ou cartão de cidadão",
        "body": "Preenche a data de nascimento, a nacionalidade e o passaporte — a partir de uma foto.",
        "cta": "Digitalizar o passaporte"
      },
      "import": {
        "title": "PDF do LinkedIn ou CV",
        "body": "Preenche a experiência, a formação, as competências e os idiomas — a partir de um PDF.",
        "cta": "Importar um PDF"
      },
      "fastest": "Mais rápido"
    },
    "citizenshipsAdd": "Adicionar cidadania",
    "preferencesLoadError": "Não foi possível carregar as suas preferências."
  },
  "qultureup": {
    "aboutDescription": "Esta avaliação avalia o seu conhecimento sobre:",
    "aboveLevel": "Acima do nível",
    "achievementAdvanced": "Especialista cultural",
    "achievementAdvancedDesc": "Alcançar nível Avançado",
    "achievementCultureExplorer": "Explorador cultural",
    "achievementCultureExplorerDesc": "Começou 2+ mundos",
    "achievementFirstMission": "Primeira missão",
    "achievementFirstMissionDesc": "Concluiu a sua primeira missão",
    "achievementStreak3": "3 dias seguidos",
    "achievementStreak3Desc": "A aprender durante 3 dias seguidos",
    "achievementWorldMaster": "Mestre do mundo",
    "achievementWorldMasterDesc": "Completar um mundo inteiro",
    "achievements": "Conquistas",
    "ariaWeeklyActivityChart": "Gráfico de atividade semanal",
    "assessedOn": "Avaliado em {{date}}",
    "assessment": {
      "aboutDesc": "Uma breve avaliação de alinhamento cultural que leva cerca de 10 minutos.",
      "completeMessage": "A sua avaliação QultureUp está completa. Explore os mundos para continuar a aprender.",
      "completeTitle": "Avaliação completa",
      "description": "Responda a algumas perguntas sobre a sua orientação cultural para que possamos personalizar o seu percurso.",
      "saving": "A guardar…",
      "subtitle": "Cerca de 10 minutos",
      "title": "Avaliação QultureUp"
    },
    "assessmentDescription": "Determine o seu nível de aprendizagem",
    "assessmentTitle": "Avaliação QultureUp",
    "coPilot": "CoPilot",
    "complete": "completo",
    "completeDescription": "O seu caminho de aprendizagem foi personalizado.",
    "completePreviousTrack": "Complete a pista anterior para desbloquear esta",
    "completePreviousWorld": "Completar mundo anterior",
    "completeTitle": "Avaliação completa!",
    "continue": "Continuar",
    "continueDescription": "Começou a sua avaliação QultureUp. Retome exatamente onde parou no Citizen Web — as suas respostas até agora estão guardadas.",
    "continueInApp": "Continuar na app",
    "continueInAppButton": "Continuar na app",
    "continueLearning": "Continuar a aprender",
    "continueOnWeb": "Continuar no Citizen Web",
    "continueOnWebDesc": "Retome a sua avaliação QultureUp de onde parou no Portal Web Citizen.",
    "continueTitle": "Continue a sua avaliação QultureUp",
    "copilotGuideDescription": "Responda a perguntas sobre o seu conhecimento cultural",
    "copilotGuideTitle": "Guia CoPilot",
    "dayStreak": "Sequência de dias",
    "description": "Aprenda a sua nova cultura",
    "difficultyAdvanced": "Avançado",
    "difficultyBeginner": "Iniciante",
    "difficultyIntermediate": "Intermédio",
    "dimensionCulture": "Cultura e normas locais",
    "dimensionHistory": "História e vida quotidiana",
    "dimensionLanguage": "Realidade linguística (nativo + inglês, e frases básicas na língua-alvo)",
    "dimensionWorkplace": "Cultura do local de trabalho e direitos/deveres básicos",
    "error": {
      "description": "Não conseguimos carregar os seus dados QultureUp. Por favor, tente novamente.",
      "retry": "Tente novamente",
      "title": "Algo correu mal"
    },
    "estimatedTime": "Tempo estimado",
    "filterAdvanced": "Avançado",
    "filterAll": "Todos os níveis",
    "filterBeginner": "Iniciante",
    "filterIntermediate": "Intermédio",
    "heroBanner": {
      "subtitle": "Domine o lado cultural da sua mudança",
      "title": "QultureUp"
    },
    "heroMiles": "QultureUp Miles",
    "hours": "h",
    "learnOnTheGo": "Aprender em movimento",
    "learnOnTheGoDesc": "Complete missões, ganhe Miles e acompanhe o seu progresso de aprendizagem cultural com a app móvel.",
    "loadingAssessment": "A carregar avaliação…",
    "miles": "Miles",
    "minutes": "min",
    "missionDetailsInApp": "Detalhes da missão disponíveis na app móvel",
    "missions": "Missões",
    "missionsCompleted": "{{completed}} de {{total}} missões concluídas",
    "missionsCount": "{{completed}}/{{total}} missões",
    "missionsLabel": "Missões",
    "nextMission": "Próximo",
    "noMissionsForLevel": "Sem missões neste nível para esta pista.",
    "noTracksAvailable": "Ainda não há pistas disponíveis para este mundo.",
    "noUnlockedWorlds": "Sem mundos desbloqueados ainda.",
    "noWorldsAvailable": "Ainda não há mundos disponíveis. Volte em breve!",
    "ofTotal": "{{completed}} de {{total}}",
    "ofTotalCompleted": "{{completed}} de {{total}} concluídos",
    "openInApp": "Abrir na app",
    "openTonnieCitizen": "Abrir na app",
    "percentComplete": "{{percent}}% completo",
    "progressTitle": "Progresso da avaliação",
    "qultureupMiles": "QultureUp milhas",
    "recentlyCompleted": "Recentemente concluído",
    "retakeAssessment": "Refazer avaliação",
    "retakeOnWeb": "Refazer no web Citizen",
    "retakeOnWebDesc": "Refaça a sua avaliação QultureUp no Portal Web Citizen para atualizar o seu caminho de aprendizagem personalizado.",
    "returnToDashboard": "Voltar ao painel",
    "score": "Pontuação: {{score}}%",
    "start": "Começar",
    "startInApp": "Começar no app",
    "startMission": "Iniciar missão",
    "startOnWeb": "Começar no Citizen Web",
    "startOnWebDesc": "Complete a sua avaliação QultureUp no Portal Web Citizen para desbloquear o seu caminho de aprendizagem personalizado.",
    "tabOverview": "Visão geral",
    "tabTracksAndMissions": "Percursos & missões",
    "tabWorlds": "Mundos",
    "thisWeek": "Esta semana",
    "timeLearning": "Tempo de aprendizagem",
    "title": "QultureUp",
    "todaysMission": "Missão de hoje",
    "tracks": "Faixas",
    "tracksCompleted": "{{completed}} de {{total}} percursos concluídos",
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoad": "Não foi possível carregar os dados QultureUp",
    "upNext": "Próximo",
    "welcome": {
      "cultureStep": "Cultura & história",
      "cultureStepDesc": "Explore tradições locais, património e vida cívica",
      "description": "Descubra a sua prontidão cultural e desbloqueie um caminho de aprendizagem personalizado. A nossa avaliação avalia o seu conhecimento em dimensões chave da cidadania para orientar o seu percurso de integração.",
      "languageStep": "Língua e comunicação",
      "languageStepDesc": "Construa confiança em interações diárias e oficiais",
      "letsStart": "Vamos começar",
      "socialStep": "Normas sociais e de trabalho",
      "socialStepDesc": "Compreenda os costumes do dia-a-dia e as expectativas profissionais",
      "timeEstimate": "Leva cerca de 5-10 minutos para completar",
      "title": "Bem-vindo ao QultureUp"
    },
    "world": {
      "completed": "Completo"
    },
    "worlds": "Mundos",
    "questionTier": {
      "easy": "Fácil",
      "medium": "Média",
      "hard": "Difícil"
    },
    "difficultyA11y": "Dificuldade: {{level}}",
    "min_one": "{{count}} min",
    "min_other": "{{count}} min",
    "sectionsLabel_one": "{{count}} secção",
    "sectionsLabel_other": "{{count}} secções",
    "comingSoon": {
      "body": "Estamos a preparar os mundos e as missões para {{country}}. Vão abrir aqui assim que estiverem prontos.",
      "title": "O QultureUp para {{country}} chega em breve"
    },
    "academy": {
      "title": "Tonnie Languages Academy",
      "poweredBy": "Com a {{partner}}",
      "card": {
        "body": "Aprenda inglês, português europeu, espanhol ou italiano com professores ao vivo e estudo autónomo.",
        "cta": "Ver a Academy",
        "level": "Nível {{band}}",
        "completion": "{{percent}} do percurso",
        "next": "Próxima missão",
        "neverSynced": "O seu progresso aparece aqui depois da sua primeira visita.",
        "paused": "Progresso em pausa — consentimento retirado",
        "goalReached": "Meta alcançada: {{band}}"
      },
      "page": {
        "description": "Cursos de línguas com a {{partner}}, com a sua conta Tonnie."
      },
      "about": {
        "title": "O que é a Academy",
        "live": "Aulas ao vivo com professores reais, individuais ou em pequenos grupos.",
        "selfStudy": "Estudo autónomo entre as aulas, com exercícios e comentários em cada atividade.",
        "billing": "Na aplicação Tonnie nada é vendido: a {{partner}} apresenta os seus planos e cobra-os no seu próprio site.",
        "noPassword": "Entra na {{partner}} com a sua conta Tonnie — sem nova palavra-passe."
      },
      "language": {
        "title": "Que língua quer aprender?",
        "fixedTitle": "A sua língua na Academy",
        "names": {
          "en": "English",
          "ptPT": "Português de Portugal",
          "es": "Español",
          "it": "Italiano"
        },
        "level": "O seu nível no TestIt: {{level}}",
        "levelHint": "A {{partner}} confirma o seu ponto de partida com o seu próprio teste de nível.",
        "required": "Escolha uma língua para abrir a Academy.",
        "fixed": "Fixa para esta escola: a {{partner}} cria o seu curso na língua da sua primeira abertura e mantém-na."
      },
      "consent": {
        "title": "O que a Tonnie partilha com a {{partner}}",
        "intro": "Para abrir a Academy com a sua conta, a Tonnie envia à {{partner}}:",
        "fields": {
          "name": "O seu nome",
          "email": "O seu email verificado",
          "learningLanguage": "A língua que escolher",
          "level": "O seu nível no TestIt nessa língua, se o tiver",
          "uiLanguage": "A língua em que usa a aplicação",
          "birthDate": "A sua data de nascimento, se estiver no seu perfil",
          "phone": "O seu número de telefone, se estiver no seu perfil",
          "nationality": "A sua nacionalidade, se estiver no seu perfil"
        },
        "version": "Texto do consentimento, versão {{version}}",
        "give": "Aceito partilhar estes dados com a {{partner}}",
        "given": "Aceitou a {{date}}.",
        "withdraw": "Retirar o consentimento",
        "withdrawHint": "Depois de o retirar, a Tonnie não partilha mais nada e a {{partner}} deixa de poder iniciar a sua sessão a partir da Tonnie.",
        "outdated": "O texto do consentimento mudou. Leia-o e aceite novamente para abrir a Academy."
      },
      "open": {
        "action": "Abrir a Academy",
        "opening": "A abrir…",
        "hintWeb": "Abre num novo separador.",
        "hintPhone": "Abre no browser do seu telemóvel."
      },
      "demo": {
        "action": "Ver a Academy (demonstração)",
        "note": "Uma demonstração do site da {{partner}}, sem a sua conta Tonnie — nada seu é partilhado."
      },
      "blocked": {
        "title": "O seu browser bloqueou o novo separador",
        "body": "Abra a Academy com a ligação abaixo — funciona durante um minuto.",
        "link": "Abrir a Academy agora"
      },
      "unavailable": {
        "assessmentRequired": "Faça primeiro a avaliação do QultureUp — a Tonnie Languages Academy abre logo a seguir.",
        "notConfigured": "A Academy ainda não está aberta aqui.",
        "partnerPending": "A Academy abre assim que o acordo da Tonnie com a {{partner}} estiver assinado."
      },
      "refusal": {
        "consentRequired": "Aceite o que é partilhado antes de abrir a Academy.",
        "languageFixed": "O seu curso na {{partner}} já é noutra língua — é fixa para esta escola. Abra a Academy nessa língua.",
        "profileIncomplete": {
          "name": "A {{partner}} precisa do seu nome. Acrescente-o ao seu perfil e abra a Academy.",
          "email": "A {{partner}} precisa de um email verificado. Verifique o seu email e abra a Academy.",
          "both": "A {{partner}} precisa do seu nome e de um email verificado. Acrescente-os e abra a Academy."
        },
        "fixName": "Acrescentar o seu nome",
        "fixEmail": "Verificar o seu email",
        "generic": "Não foi possível abrir a Academy. Tente novamente."
      },
      "load": {
        "error": "Não foi possível carregar a Academy."
      },
      "progress": {
        "title": "O seu progresso na Academy",
        "neverSynced": {
          "title": "Ainda sem progresso",
          "body": "O seu percurso aparece aqui assim que a {{partner}} enviar o seu primeiro progresso — normalmente logo após a sua primeira visita."
        },
        "paused": {
          "title": "Progresso em pausa",
          "body": "Retirou o seu consentimento, por isso a {{partner}} deixou de enviar o seu progresso. É assim que estava na última atualização."
        },
        "goalReached": {
          "title": "Meta alcançada",
          "body": "Alcançou o nível {{band}}, a meta do seu curso. Pode continuar a aprender na {{partner}}."
        },
        "level": "Nível {{band}}",
        "bandProgress": "{{percent}} do nível {{band}}",
        "startTarget": "Começou em {{start}} · Meta {{target}}",
        "scale": "Nível {{level}} de {{max}} na escala da {{partner}}.",
        "completed": "{{completed}} de {{total}} missões",
        "completedPercent": "{{percent}} do percurso",
        "miles_one": "Ganhou {{count}} Mile na Academy",
        "miles_other": "Ganhou {{count}} Miles na Academy",
        "lastSync": "Última atualização da {{partner}}: {{date}}",
        "reduced": "Por agora, a {{partner}} envia apenas o seu nível atual; estas são as missões dele. O seu progresso global é o seu nível na escala de 0 a {{max}}.",
        "next": {
          "title": "Próxima missão",
          "in": "Nível {{band}}"
        },
        "allDone": "Todas as missões do seu percurso estão concluídas.",
        "path": {
          "title": "O seu percurso",
          "titlesNote": {
            "en": "Missões em inglês, com os nomes que a {{partner}} lhes dá.",
            "ptPT": "Missões em português europeu, com os nomes que a {{partner}} lhes dá.",
            "es": "Missões em espanhol, com os nomes que a {{partner}} lhes dá.",
            "it": "Missões em italiano, com os nomes que a {{partner}} lhes dá."
          }
        },
        "module": {
          "band": "Nível {{band}}",
          "current": "Está aqui",
          "count": "{{completed}}/{{total}}"
        },
        "mission": {
          "completed": "Concluída",
          "inProgress": "Em curso · {{percent}}",
          "notStarted": "Por começar",
          "startingPoint": "Já sabia",
          "startingPointHint": "Já a sabia quando começou na Academy: conta para o seu percurso e não dá Miles.",
          "miles_one": "+{{count}} Mile",
          "miles_other": "+{{count}} Miles",
          "capped": "Limite diário de Miles"
        },
        "milestones": {
          "title": "Marcos",
          "band": "Nível {{band}} alcançado",
          "goal": "Meta alcançada"
        },
        "retired": {
          "title": "Concluídas antes",
          "body": "Missões que concluiu e que já não fazem parte do seu percurso."
        }
      }
    }
  },
  "settings": {
    "about": {
      "title": "Sobre"
    },
    "billing": "Faturação",
    "dark": "Escuro",
    "deleteAccount": "Eliminar conta",
    "deleteAccountConfirm": "Isto irá eliminar permanentemente a sua conta e todos os dados. Isto não pode ser desfeito.",
    "deleteAccountFailed": "Falha ao eliminar a conta. Por favor, tente novamente.",
    "freePlan": "Plano gratuito",
    "language": {
      "title": "Língua"
    },
    "light": "Claro",
    "myCheckups": "Os meus CheckUps",
    "myFamily": "A minha família",
    "myJourneys": "As meus percursos",
    "preferences": "Preferências",
    "profile": "Perfil",
    "security": "Segurança",
    "sendFeedback": "Enviar feedback",
    "signOut": "Sair",
    "signOutConfirm": "Tem a certeza de que deseja sair?",
    "termsPrivacy": "Termos & privacidade",
    "theme": {
      "title": "Tema"
    },
    "themeSystem": "Sistema ({{mode}})",
    "title": "Definições",
    "sessions": {
      "notFound": "Sessão não encontrada",
      "signedOut": "Sessão encerrada",
      "signOutFailed": "Falha ao encerrar sessão",
      "loadFailed": "Falha ao carregar sessões"
    },
    "preferencesLanguageFallback": "Inglês",
    "membersCount_one": "{{count}} membro",
    "membersCount_other": "{{count}} membros",
    "groups": {
      "journey": "O seu percurso",
      "app": "Aplicação",
      "help": "Ajuda e informação legal"
    },
    "profileStrength": "Perfil: {{level}} · {{percent}}",
    "pro": "Pro",
    "inout": "InOut — dias fora",
    "inoutPaused": "Em pausa",
    "inoutNotStarted": "Não começado",
    "myDocuments": "Os meus documentos"
  },
  "splash": {
    "authenticateToContinue": "Autentique-se para continuar",
    "biometricFailed": "Falha na autenticação biométrica",
    "tryAgain": "Tente novamente",
    "unlockPrompt": "Desbloquear Tonnie Citizen",
    "usePasswordInstead": "Usar palavra-passe em vez disso"
  },
  "sponsorship": {
    "companySponsored": "Patrocinado pela empresa",
    "familySponsored": "Patrocinado pela família",
    "governmentSponsored": "Patrocinado pelo governo",
    "selfPaid": "Pago pelo Próprio"
  },
  "stepper": {
    "care": "Care",
    "checkup": "CheckUp",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "start": "Começar",
    "teleportal": "TelePortal"
  },
  "tabs": {
    "care": "Care",
    "home": "Início",
    "passport": "Passport",
    "qultureup": "QultureUp",
    "teleportal": "TelePortal",
    "inout": "InOut"
  },
  "teleportal": {
    "aboutDescription": "Esta avaliação ajuda-nos a entender as suas necessidades de realocação:",
    "aboutTitle": "Sobre esta avaliação",
    "addNote": "Adicionar nota",
    "agentDate": "Data",
    "agentHistory": "Histórico de interações com o agente",
    "agentHistoryDescription": "Veja interações passadas com o Agente Consultor TelePortal",
    "agentInteraction": "Interação",
    "agentSummary": "Resumo",
    "all": "Todos",
    "allScope": "Todos os membros",
    "allStatus": "Todos os status",
    "allTracks": "Todas as pistas",
    "applicationPackages": "Pacotes de candidatura",
    "applicationPackagesDescription": "Ver os seus pacotes de documentos organizados",
    "askCoPilot": "Pergunte ao CoPilot sobre esta tarefa",
    "assessment": {
      "destination": "Destino",
      "education": "Educação",
      "educationBachelor": "Licenciatura",
      "educationHighSchool": "Ensino secundário",
      "educationMaster": "Mestrado",
      "educationPhd": "Doutoramento",
      "educationVocational": "Vocacional / Técnico",
      "experience": "Experiência",
      "experience0to2": "0-2 anos",
      "experience10Plus": "Mais de 10 anos",
      "experience3to5": "3-5 anos",
      "experience6to10": "6-10 anos",
      "infoDestination": "Preferências de país de destino",
      "infoPurpose": "Propósito da realocação",
      "infoQualifications": "Avaliação de qualificações",
      "infoTimeline": "Cronograma e urgência",
      "purpose": "Propósito",
      "purposeEntrepreneur": "Iniciar um negócio",
      "purposeFamily": "Reunião familiar",
      "purposeRetire": "Reforma",
      "purposeStudy": "Estudo / Educação",
      "purposeWork": "Emprego / Trabalho",
      "questionDestination": "Qual país está a almejar para a realocação?",
      "questionEducation": "Qual é o seu nível mais alto de educação?",
      "questionExperience": "Quantos anos de experiência profissional tem?",
      "questionPurpose": "Qual é o seu principal propósito para se realocar?",
      "questionTimeline": "Quando planeia realocar-se?",
      "timeline": "Cronograma",
      "timeline1Year": "Dentro de 1 ano",
      "timeline3Months": "Dentro de 3 meses",
      "timeline6Months": "Dentro de 6 meses",
      "timelineAsap": "Assim que possível",
      "timelineExploring": "Apenas a explorar"
    },
    "assessmentCompleteMessage": "Analisámos o seu perfil e identificámos potenciais caminhos de visto para o seu destino alvo.",
    "assessmentDescription": "Configure o seu percurso de realocação",
    "assessmentTitle": "Avaliação TelePortal",
    "associatedWithTasks": "Associado a tarefas",
    "attachExistingDocument": "Anexar documento existente",
    "backToDashboard": "Voltar ao painel",
    "blocked": "Bloqueado",
    "blockedBy": "Bloqueado Por",
    "blocking": "Bloqueante",
    "blockingOnly": "Apenas tarefas bloqueantes",
    "brain": {
      "error": "Algo correu mal ao construir o seu kit. Por favor, tente novamente daqui a pouco.",
      "destinationNotSupported": "Ainda não conseguimos criar um kit de mudança para este destino. O seu percurso está guardado — o TelePortal abre aqui assim que este destino for suportado.",
      "phase1": "A analisar o seu perfil",
      "phase2": "A mapear os documentos necessários",
      "phase3": "A construir a lista de tarefas",
      "phase4": "A personalizar os marcos",
      "phase5": "A finalizar o seu kit",
      "ready": "O seu kit está pronto",
      "reviewKit": "Revise o seu kit",
      "stat": {
        "docsNeeded": "Documentos necessários",
        "fromVault": "Do seu cofre",
        "members": "Membros",
        "tasks": "Tarefas"
      },
      "subtitle": "A construir o seu kit de realocação personalizado",
      "title": "Cérebro TelePortal",
      "complexity": {
        "simple": "Simples",
        "standard": "Padrão",
        "complex": "Complexo"
      }
    },
    "captureMobile": "Capturar no móvel",
    "certificationLabel": "Certificação",
    "certificationRequired": "{{type}}",
    "clearFilters": "Limpar filtros",
    "clickToUpload": "Clique para carregar ou arraste e solte",
    "collapseDetails": "Colapsar detalhes",
    "comingSoon": "Em breve",
    "companionCareerProgress": "Progresso do companheiro Career",
    "companionEmploymentReadiness": "Avaliação de prontidão para emprego do acompanhante",
    "companionIntegrationSupport": "Marcos de apoio à adaptação do acompanhante",
    "companionProgram": "Programa do acompanhante",
    "companionProgramDesc": "Redução de risco para lares com dupla carreira — rastrear a prontidão para emprego e apoio à integração do acompanhante",
    "complete": "Completo",
    "completeInMobile": "Completo no móvel",
    "completeTasksOnMobile": "Completar tarefas no móvel",
    "completeTitle": "Avaliação completa!",
    "completed": "Completo",
    "completedDate": "Completo {{date}}",
    "completedSection": "Completo",
    "completionNotesPlaceholder": "Adicionar notas de conclusão (opcional)...",
    "complexity": {
      "complex": "Complexo",
      "simple": "Simples",
      "standard": "Padrão"
    },
    "consultantAgent": "Agente consultor TelePortal",
    "consultantAgentDesc": "Obtenha orientação especializada dos nossos consultores de imigração",
    "consultantAgentDescription": "Obtenha ajuda com os seus documentos e tarefas TelePortal",
    "consultantAgentHelp": "O Agente Consultor pode ajudá-lo a validar, organizar e anexar documentos automaticamente",
    "continue": {
      "description": "Começou a sua configuração TelePortal. Retome exatamente onde parou no Citizen Web — as suas respostas até agora estão guardadas.",
      "title": "Continue a sua configuração TelePortal"
    },
    "continueOnWeb": "Continuar no Citizen Web",
    "continueOnWebDesc": "Retome a sua configuração TelePortal de onde parou no Portal Web Citizen.",
    "copilotGuideDescription": "Responda a perguntas sobre as suas necessidades de realocação",
    "copilotGuideTitle": "Guia CoPilot",
    "couldNotLoad": "Não conseguimos carregar os seus dados TelePortal. Por favor, tente novamente.",
    "createApplicationPackage": "Criar pacote de aplicação",
    "createApplicationPackageDesc": "Prepare e organize todos os seus documentos de aplicação",
    "createApplicationPackageDescription": "Agrupe múltiplos documentos para aplicações de visto e outras submissões",
    "createInMobile": "Criar no móvel",
    "criticalTasks": "Tarefas críticas",
    "currentProofDocuments": "Documentos de prova atuais",
    "currentlyInProgress": "Atualmente em progresso",
    "daysLeft": "{{count}}d restantes",
    "deleteDocumentDescription": "Esta ação não pode ser desfeita. O documento será removido permanentemente.",
    "deleteDocumentTitle": "Eliminar documento?",
    "dependencies": {
      "allTracks": "Todas as pistas",
      "blockedBy": "Bloqueado por",
      "blocking": "Bloqueante",
      "blocks": "Bloqueios",
      "connectedTasks": "tarefas ligadas",
      "criticalPath": "Caminho crítico",
      "dependsOn": "Depende de",
      "description": "Veja como as tarefas dependem umas das outras nas várias pistas",
      "empty": "Sem dependências de tarefas para exibir",
      "emptyHint": "As dependências vão aparecer quando o seu kit de realocação tiver tarefas ligadas entre si",
      "enterFullscreen": "Entrar em ecrã inteiro",
      "exitFullscreen": "Sair de ecrã inteiro",
      "filterByTrack": "Filtrar por pista",
      "graphLabel": "Gráfico de dependência de tarefas",
      "graphView": "Vista gráfica",
      "independentTasks": "tarefas independentes",
      "insightBanner": "Visão geral de dependências",
      "listView": "Vista de lista",
      "members": "Membros",
      "resetView": "Redefinir vista",
      "shared": "Partilhado",
      "tabTitle": "Dependências",
      "title": "Gráfico de dependência de tarefas",
      "zoomIn": "Aproximar",
      "zoomOut": "Afastar"
    },
    "dependenciesResolved": "Dependências (resolvidas)",
    "description": "Descrição",
    "dimensionFamily": "Configuração familiar",
    "dimensionStatus": "Estado atual",
    "dimensionTimeline": "Cronograma e prazos",
    "dimensionVisa": "Tipo de visto e requisitos",
    "docDetail": {
      "actions": "Ações",
      "certification": "Certificação",
      "certificationNone": "Não requerido",
      "certificationRequired": "Requerido ({{type}})",
      "expired": "Expirado",
      "expiryDate": "Data de expiração",
      "issuingAuthority": "Autoridade emitente",
      "location": "Localização",
      "locationHomeCountry": "País de origem",
      "locationOnline": "Online",
      "locationTargetCountry": "País alvo",
      "noExpiry": "Sem data de expiração",
      "status": "Estado",
      "title": "Detalhes do documento",
      "type": "Tipo de documento",
      "upload": "Carregar documento",
      "uploadedAt": "Carregado",
      "validityPeriod": "Período de validade",
      "view": "Ver documento",
      "viewFailed": "Falha ao abrir documento",
      "openWith": "Abrir documento com…",
      "expiresIn_one": "Expira em {{count}} dia",
      "expiresIn_other": "Expira em {{count}} dias",
      "validFor_one": "Válido por {{count}} dia",
      "validFor_other": "Válido por {{count}} dias"
    },
    "docEmployment": "Contrato de trabalho",
    "docIncome": "Prova de rendimento",
    "docInsurance": "Seguro de saúde",
    "docNeedsReview": "Documento precisa de revisão — o formato pode não ser ideal",
    "docNotUploaded": "Documento ainda não carregado",
    "docPassport": "Passport",
    "docStatusMissing": "Em falta",
    "docStatusPending": "Pendente",
    "docStatusRejected": "Rejeitado",
    "docStatusUploaded": "Carregado",
    "docStatusVerified": "Verificado",
    "docSuggestion1": "Assegure-se de que o documento está claro e legível",
    "docSuggestion2": "Verifique a data de expiração",
    "docTypeEducation": "Educação",
    "docTypeFinancial": "Financeiro",
    "docTypeHousing": "Habitação",
    "docTypeIdentity": "Identidade",
    "docTypeLegal": "Legal",
    "docTypeOther": "Outro",
    "docTypeTravel": "Viagem",
    "docUploadedPendingValidation": "Documento carregado, pendente de validação",
    "docValid": "Documento verificado e válido",
    "document": {
      "apostille": "Apostilha necessária",
      "certification": "Certificação",
      "certificationRequired": "Certificação necessária",
      "docExpired": "Este documento expirou",
      "docExpiring": "Este documento expira em {{days}} dias",
      "expired": "Expirado",
      "expiresIn": "Expira em {{days}} dias",
      "expiresSoon": "Expira em breve",
      "haia": "Apostilha da haia",
      "validFor": "Válido por {{duration}}"
    },
    "documentDeleted": "Documento eliminado",
    "documentDownloaded": "Documento descarregado",
    "documentName": "Nome do documento",
    "documentNamePlaceholder": "ex: Passport, Certidão de Nascimento...",
    "documentType": "Tipo de documento",
    "documentUploadError": "Falha ao carregar documento. Por favor, tente novamente.",
    "documentUploadRequired": "Carregamento de documento necessário",
    "documentUploadedSuccess": "Documento carregado com sucesso",
    "documentValidatedSuccess": "Documento validado com sucesso",
    "documentValidationError": "Falha ao validar documento. Por favor, tente novamente.",
    "documents": "documentos",
    "documentsDescription": "Carregue e verifique os documentos necessários para a sua candidatura de visto e realocação.",
    "documentsGathered": "Documentos reunidos",
    "documentsReady": "Documentos prontos",
    "documentsStatus": "Estado dos documentos",
    "documentsUploaded": "Documentos carregados com sucesso",
    "done": "Feito",
    "dueDate": "Data de vencimento",
    "dueToday": "Vence hoje",
    "dueTomorrow": "Vence amanhã",
    "editNote": "Editar nota",
    "editTask": "Editar tarefa",
    "employerFull": "Sim, patrocínio total",
    "employerNA": "Não aplicável",
    "employerNone": "Não, auto-patrocinado",
    "employerPartial": "Sim, apoio parcial",
    "entireFamily": "Toda a família",
    "estimatedDuration": "Duração estimada",
    "estimatedTime": "Tempo estimado",
    "eventTargetArrival": "Chegada prevista",
    "eventVisaDecision": "Decisão do visto",
    "eventVisaInterview": "Entrevista de visto",
    "expandDetails": "Expandir detalhes",
    "expired": "Expirado",
    "expiredCount": "Expirado",
    "expiresInDays": "Expira em {{count}}d",
    "downloadAllDocuments": "Transferir tudo ({{count}})",
    "downloadSelectedDocuments": "Transferir {{count}}",
    "selectDocument": "Selecionar documento",
    "expiresOn": "Expira: {{date}}",
    "expiringSoon": "A expirar em breve",
    "explainTask": "Explicar tarefa",
    "family": "Família",
    "familyBoth": "Com parceiro e filhos",
    "familyChildren": "Com filhos",
    "familyConfig": {
      "applicableTracks": "Pistas aplicáveis",
      "childNumber": "Filho {{number}}",
      "companion": "Acompanhante",
      "configureTracksDescription": "Selecione as pistas (Legal, Viagem, Configuração) que se aplicam a cada membro da família",
      "configureTracksTitle": "Configurar as pistas de cada membro",
      "dependent": "Dependente",
      "description": "Configurar o acesso às pistas para cada membro da família, animal de estimação, acompanhante ou dependente",
      "familyMember": "Membro da família",
      "justMe": "Só eu",
      "legal": "Legal",
      "mainQuestion": "Vai mudar-se com membros da família?",
      "partnerSpouse": "Parceiro/Cônjuge",
      "pet": "Animal de estimação",
      "pets": "Animais de estimação",
      "setup": "Configuração",
      "travel": "Viagem",
      "yesBringingFamily": "Sim, com a família",
      "membersConfigured_one": "{{count}} membro configurado",
      "membersConfigured_other": "{{count}} membros configurados"
    },
    "familyJustMe": "Só eu",
    "familyMasterOnly": "Apenas o Mestre da Família pode modificar as tarefas TelePortal",
    "familyMasterOnlyDesc": "Apenas o Mestre da Família pode iniciar ou controlar a avaliação e tarefas TelePortal. Contacte o seu Mestre da Família para assistência.",
    "familyPartner": "Com parceiro/cônjuge",
    "filter": {
      "allExpiry": "Todas as expirações",
      "clearAll": "Limpar",
      "expired": "Expirado",
      "expiringSoon": "A expirar em breve",
      "location": "Localização",
      "locationAll": "Todas as localizações",
      "locationHome": "País de origem",
      "locationOnline": "Online",
      "locationTarget": "País alvo",
      "member": "Membro",
      "memberAll": "Todos os membros",
      "selectMember": "Selecionar membro",
      "sort": "Ordenar",
      "sortDefault": "Padrão",
      "sortDueDate": "Data de vencimento",
      "sortPriority": "Prioridade",
      "valid": "Válido"
    },
    "ganttView": "Vista Gantt",
    "generatingChecklist": "A gerar a sua lista de verificação personalizada...",
    "goToJourneyBuilder": "Ir para o construtor de percurso",
    "groupBy": {
      "byTrack": "Por pista",
      "label": "Agrupar por",
      "location": "Agrupar por localização"
    },
    "guideSetupSubtitle": "Vamos guiá-lo na configuração — responda a algumas perguntas e construiremos o seu kit.",
    "heroBanner": {
      "complete": "Completo",
      "documents": "Documentos",
      "household": "Agregado familiar",
      "milestones": "Marcos",
      "subtitle": "O seu centro de comando de realocação",
      "tasks": "Tarefas",
      "title": "TelePortal"
    },
    "heroMiles": "TelePortal Miles",
    "highPriority": "Alta prioridade",
    "household": {
      "everyone": "Todos",
      "bar": {
        "allMembers": "Todos os membros",
        "filterBy": "Filtrar por membro",
        "filterByMember": "Filtrar por membro"
      },
      "petSpecies": {
        "cat": "Gato",
        "dog": "Cão",
        "other": "Outro"
      },
      "schoolStages": {
        "higher": "Educação superior",
        "pre_school": "Pré-escolar",
        "primary": "Escola primária",
        "secondary": "Escola secundária"
      },
      "talent": "Eu"
    },
    "householdAware": "Consciente da família",
    "householdMembers": "Membros da família",
    "inProgressSection": "Em progresso",
    "keyDates": "Datas chave",
    "kit": {
      "activate": "Ativar kit",
      "activateModified": "Ativar kit modificado",
      "buildFailed": "Não foi possível construir o seu kit",
      "buildFailedHint": "Tente novamente ou contacte o suporte se o problema persistir.",
      "byMember": "Por membro",
      "byTrack": "Por pista",
      "complexity": {
        "complex": "Complexo",
        "simple": "Simples",
        "standard": "Padrão"
      },
      "defaultMember": "Eu",
      "dependencyWarning": "Algumas tarefas dependem de outras. Remover uma pode bloquear o trabalho subsequente.",
      "docs": "Documentos",
      "docsLinked": "Do cofre",
      "docsNeeded": "Docs necessários",
      "editHint": "Clique em qualquer tarefa para editar, remover ou reorganizar.",
      "loading": "A carregar kit…",
      "members": "Membros",
      "miles": "Miles",
      "modified": "Modificado",
      "rebuild": "Reconstruir",
      "rebuildConfirm": "Reconstruir kit",
      "rebuildConfirmDesc": "A reconstrução criará um novo kit com base no seu perfil mais recente. As modificações que fez serão perdidas.",
      "rebuildConfirmTitle": "Reconstruir o seu kit?",
      "removeTask": "Remover tarefa",
      "removedTasks": "Tarefas removidas",
      "required": "Requerido",
      "requiredTask": "Tarefa requerida",
      "restore": "Restaurar",
      "retry": "Tentar novamente",
      "tasks": "Tarefas",
      "title": "O seu kit TelePortal",
      "vaultLinked": "Ligado do cofre",
      "taskCount_one": "{{count}} tarefa",
      "taskCount_other": "{{count}} tarefas",
      "milestoneCount_one": "{{count}} marco",
      "milestoneCount_other": "{{count}} marcos"
    },
    "location": {
      "all": "Todos",
      "either": "Qualquer país",
      "filter": "Localização",
      "filterLabel": "Localização",
      "homeCountry": "País de origem",
      "online": "Online",
      "other": "Outro",
      "targetCountry": "País alvo"
    },
    "locationEither": "Qualquer",
    "locationHome": "Casa",
    "locationOnline": "Online",
    "locationTarget": "Alvo",
    "manageJourney": "Planeie a sua realocação",
    "markAsDone": "Marcar como concluído",
    "markComplete": "Marcar completo",
    "milesEarned": "+{{miles}} Miles do Percurso ganhas",
    "milestoneArrivalPlanning": "Planeamento de chegada",
    "milestoneDocumentCollection": "Recolha de documentos",
    "milestoneEssentialServices": "Serviços essenciais",
    "milestoneFinancialSetup": "Configuração financeira",
    "milestoneHousing": "Habitação",
    "milestoneTravelBooking": "Reserva de viagem",
    "milestoneVisaApplication": "Candidatura de visto",
    "milestones": {
      "admin_complete": "Admin completo",
      "arrived_in_destination": "Chegado ao destino",
      "arrived_in_portugal": "Chegado a Portugal",
      "documents_gathered": "Documentos reunidos",
      "documents_legalized": "Documentos legalizados",
      "fully_settled": "Totalmente instalado",
      "housing_secured": "Habitação garantida",
      "legal_registration_complete": "Registo legal completo",
      "travel_booked": "Viagem reservada",
      "visa_approved": "Visto aprovado"
    },
    "milestonesCount": "{{completed}}/{{total}} marcos",
    "milestonesLabel": "Marcos",
    "missing": "Em falta",
    "mobileAppDescription": "Use a app móvel para carregar documentos, completar tarefas e obter orientação em tempo real do Agente Consultor TelePortal.",
    "needHelp": "Precisa de ajuda?",
    "needsAttention": "Precisa de atenção",
    "noAgentHistory": "Ainda sem interações de agentes",
    "noAgentHistoryDescription": "Use o Agente Consultor TelePortal na app móvel para obter ajuda com documentos",
    "noDocumentsAttached": "Sem documentos anexados ainda",
    "noDocumentsInTrack": "Ainda sem documentos nesta pista",
    "noDocumentsUploaded": "Ainda sem documentos carregados",
    "noJourneySelected": "Nenhum percurso selecionado",
    "noJourneySelectedDesc": "Selecione um percurso para ver as suas tarefas e progresso TelePortal",
    "noMilestonesYet": "Ainda sem marcos",
    "noPackages": "Ainda sem pacotes de aplicação criados",
    "noPackagesDescription": "Crie pacotes na aplicação móvel para organizar documentos para submissões",
    "noProofAttached": "Ainda sem documento de prova anexado",
    "noTasksAnyTrack": "Ainda sem tarefas disponíveis em nenhuma pista",
    "noTasksFoundForFilter": "Nenhuma tarefa encontrada para o filtro selecionado",
    "noTasksInProgress": "Ainda sem tarefas em progresso",
    "noTasksInTrack": "Ainda sem tarefas disponíveis nesta pista",
    "noTasksMatchingFilters": "Nenhuma tarefa corresponde aos seus filtros atuais",
    "notePlaceholder": "Adicione as suas notas aqui...",
    "noteSaved": "Nota guardada",
    "notes": "Notas",
    "openInApp": "Abrir na app",
    "openInMobile": "Abrir no móvel",
    "openTonnieCitizen": "Abrir na app",
    "openingDocument": "A abrir o documento...",
    "orDragAndDrop": "PDF, JPG, PNG até 10MB",
    "orUploadNewProof": "Ou carregar novo documento de prova",
    "otherDocuments": "Outros documentos",
    "overallProgress": "Progresso geral",
    "overdue": "Atrasado",
    "packageCreated": "Criado",
    "packageDocuments": "Documentos",
    "packageDownload": "Transferir pacote",
    "packageName": "Nome do pacote",
    "packagePurpose": "Propósito",
    "pending": "Pendente",
    "pendingReview": "Pendente de revisão",
    "preparingSetup": "A preparar a configuração…",
    "priorityBlockedTasks": "Tarefas prioritárias & bloqueadas",
    "priorityTasksRequiringAttention": "Tarefas prioritárias que requerem atenção",
    "proOnly": "Pro apenas",
    "processing": "A processar...",
    "progress": "Progresso",
    "progressComplete": "{{percent}}% completo",
    "progressSummary": "Já percorreu {{progress}}% do seu percurso de realocação. {{attention}} tarefas precisam da sua atenção.",
    "progressTitle": "Progresso da avaliação",
    "proof": "Prova",
    "proofOfDone": "Prova de conclusão",
    "proofOfDoneDescription": "Anexe um documento como prova de que esta tarefa foi concluída",
    "proofRequired": "Esta tarefa requer prova de conclusão. Por favor, anexe um documento.",
    "questionCurrentStatus": "Qual é o seu estado atual?",
    "questionEmployerSupport": "Tem apoio ou patrocínio do empregador?",
    "questionFamily": "Vai mudar-se com membros da família?",
    "questionTargetDate": "Qual é a sua data de mudança prevista?",
    "questionTargetDateFormatted": "Qual é a sua data de mudança prevista? (MM/AAAA)",
    "questionVisaType": "Que tipo de visto ou via de realocação está a planear?",
    "readOnly": "Vista só de leitura",
    "readOnlyDescription": "As tarefas podem ser concluídas na aplicação móvel",
    "redirectingIn": "A redirecionar...",
    "rejected": "Rejeitado",
    "required": "Requerido",
    "requiredDocuments": "Documentos necessários",
    "requiredForTask": "Requerido para",
    "requiresProof": "Requer prova",
    "resolveNow": "Resolver agora",
    "retakeOnWeb": "Refazer configuração no web Citizen",
    "retakeOnWebDesc": "Refaça o assistente de configuração TelePortal no Portal Web Citizen para atualizar o seu plano de realocação personalizado.",
    "retakeSetup": {
      "label": "Repetir configuração",
      "acknowledge": "Eu entendo",
      "cleanDocs": "Limpar os documentos associados",
      "cleanTasks": "Limpar tarefas modificadas",
      "confirmReset": "Redefinir e reconstruir",
      "preFilled": "As suas respostas anteriores estão pré-preenchidas. Atualize o que mudou.",
      "rebuildTasks": "Reconstruir lista de tarefas"
    },
    "returnToDashboard": "Voltar ao painel",
    "saveNote": "Guardar nota",
    "searchTasks": "Pesquisar tarefas...",
    "selectDocumentType": "Selecionar tipo...",
    "selected": "Selecionado",
    "setup": {
      "dimensions": {
        "household": {
          "addMember": "Adicionar membro da família",
          "memberTypes": {
            "child": "Criança",
            "extended_family": "Família alargada",
            "partner": "Parceiro / Cônjuge",
            "pet": "Animal de estimação",
            "talent": "Candidato principal (eu)"
          },
          "subtitle": "Quem se vai mudar consigo?",
          "title": "O seu agregado familiar"
        },
        "housing": {
          "plans": {
            "buy": "Comprar uma propriedade",
            "company_provided": "Habitação fornecida pela empresa",
            "rent": "Alugar um apartamento",
            "temporary": "Acomodação temporária primeiro"
          },
          "subtitle": "Onde vai viver?",
          "title": "Plano habitacional"
        },
        "legalStatus": {
          "currentStatus": "Estado de imigração atual",
          "subtitle": "A sua situação legal atual",
          "title": "Estado legal & de imigração",
          "visaType": "Tipo de visto"
        },
        "professional": {
          "sponsorshipTypes": {
            "company_sponsored": "Patrocinado pela empresa",
            "freelancer": "Freelancer / Nómada digital",
            "intra_company": "Transferência intra-empresa",
            "job_seeker": "À procura de emprego",
            "other": "Outro",
            "retired": "Reformado",
            "self_employed": "Trabalhador por conta própria",
            "startup": "Iniciar um negócio",
            "student": "Estudante"
          },
          "subtitle": "A sua situação profissional",
          "title": "Contexto profissional"
        },
        "specialCircumstances": {
          "freeTextPlaceholder": "Diga-nos mais alguma coisa...",
          "options": {
            "custody_arrangement": "Acordo de custódia",
            "dietary_needs": "Necessidades dietéticas especiais",
            "disability_accommodation": "Acomodações para deficiência",
            "medical_needs": "Necessidades médicas ou tratamento contínuo",
            "military_service": "Obrigações de serviço militar",
            "pending_legal": "Questões legais pendentes",
            "religious_requirements": "Requisitos religiosos"
          },
          "subtitle": "Mais alguma coisa que deveríamos saber?",
          "title": "Circunstâncias especiais"
        },
        "timeline": {
          "subtitle": "Quando precisa de se mudar?",
          "title": "Cronograma",
          "urgencies": {
            "flexible": "Flexível / Sem pressa",
            "immediate": "Imediatamente (dentro de 1 mês)",
            "within_3_months": "Dentro de 3 meses",
            "within_6_months": "Dentro de 6 meses"
          }
        },
        "travel": {
          "modes": {
            "already_there": "Já no destino",
            "one_way": "Viagem de ida",
            "round_trip": "Viagem de ida e volta (regressa primeiro)"
          },
          "subtitle": "Como e quando vai viajar?",
          "title": "Logística de viagem"
        },
        "vaultScan": {
          "linked": "Associado a partir do cofre",
          "outdated": "Precisa de atualização",
          "skip": "Pular por agora",
          "subtitle": "Vamos verificar que documentos já tem",
          "title": "Digitalização de documentos"
        }
      },
      "processing": {
        "subtitle": "A Tonnie está a analisar a sua situação e a criar um plano personalizado...",
        "title": "A construir o seu kit de realocação"
      },
      "refresh": {
        "button": "Atualizar meu kit de realocação",
        "cancel": "Cancelar",
        "confirm": "Atualizar",
        "confirmMessage": "As suas tarefas concluídas serão preservadas. Novas tarefas podem ser adicionadas e algumas podem ser arquivadas.",
        "confirmTitle": "Atualizar kit de realocação?"
      },
      "subtitle": "Vamos personalizar o seu plano de realocação",
      "summary": {
        "beginJourney": "Começar meu percurso",
        "complexityLabel": "Complexidade",
        "documentsLabel": "Documentos necessários",
        "householdLabel": "Membros da família",
        "tasksLabel": "Total de tarefas",
        "title": "O seu kit de realocação",
        "tracksLabel": "Faixas"
      },
      "title": "Construa o seu kit de realocação",
      "welcome": {
        "prePopulated": "Pré-preenchemos algumas informações do seu perfil",
        "subtitle": "Vamos construir um Kit de Realocação personalizado com base na sua situação",
        "title": "Bem-vindo à configuração TelePortal"
      },
      "aria": {
        "collapsePanel": "Colapsar painel",
        "pinPanel": "Fixar painel",
        "unpinPanel": "Desafixar painel"
      }
    },
    "setupActivateError": "Falha ao ativar o kit",
    "setupActivatingMessage": "A ativar o seu kit — isto demora apenas um momento.",
    "setupActivatingTitle": "A ativar…",
    "setupComplete": "Configuração completa",
    "setupCompletedOn": "Configuração concluída em {{date}}",
    "setupConfigError": "Não conseguimos carregar a sua configuração de setup",
    "setupError": "Erro de configuração",
    "setupEstimatedTime": "Cerca de 5 minutos",
    "setupInfoDescription": "Vamos fazer algumas perguntas para personalizar o seu kit — o que trazer, quem vem e o seu cronograma.",
    "setupInfoIntro": "TelePortal é o seu centro de comando de realocação. A configuração ajuda-nos a adaptar o kit à sua mudança.",
    "setupMissingJourney": "Não conseguimos encontrar um percurso para configurar.",
    "setupNoJourney": "Nenhum percurso selecionado",
    "setupNoJourneyMessage": "Escolha um percurso primeiro, depois construiremos o seu kit TelePortal.",
    "setupOnWeb": "Configurar no web Citizen",
    "setupOnWebDesc": "Complete o assistente de configuração TelePortal no Portal Web Citizen para construir o seu plano de realocação personalizado.",
    "setupProgress": "Progresso da configuração",
    "setupSubtitle": "Personalize o seu kit de realocação",
    "setupSuccessMessage": "O seu kit está pronto. Vamos começar a sua realocação.",
    "setupSuccessTitle": "Está tudo pronto",
    "setupTitle": "Configuração do TelePortal",
    "somethingWentWrong": "Algo correu mal",
    "startAssessment": "Iniciar avaliação",
    "startTask": "Iniciar tarefa",
    "status": "Estado",
    "statusBlocked": "Bloqueado",
    "statusCompleted": "Completo",
    "statusHome": "Ainda no país de origem",
    "statusInProgress": "Em progresso",
    "statusMoved": "Já se mudou para o destino",
    "statusOverdue": "Atrasado",
    "statusTodo": "A fazer",
    "statusTransit": "Em trânsito",
    "stepOf": "Passo {{current}} de {{total}}",
    "summary": {
      "assessmentDetails": "Detalhes da avaliação",
      "checklistPreviewTitle": "A sua lista de verificação personalizada incluirá:",
      "currentStatus": "Estado atual",
      "description": "Revise os detalhes da sua realocação antes de gerarmos a sua lista de verificação personalizada",
      "destination": "Destino",
      "employerSupport": "Apoio do empregador",
      "familyConfiguration": "Configuração familiar",
      "generateChecklist": "Gerar lista de verificação",
      "journeyRoute": "Rota do percurso",
      "legalTrackDesc": "Rastreio legal — Preparação legal e documentos",
      "makeChanges": "Fazer alterações",
      "notSelected": "Não selecionado",
      "origin": "Origem",
      "setupTrackDesc": "Rastreio de configuração — Alojamento, reconhecimento de credenciais e primeiras semanas",
      "targetMoveDate": "Data de mudança alvo",
      "title": "Resumo da avaliação TelePortal",
      "travelTrackDesc": "Rastreio de viagem — Logística e planeamento de viagens",
      "viewModeDescription": "Informações completas sobre a sua avaliação de realocação",
      "visaType": "Tipo de visto"
    },
    "tabDocuments": "Documentos",
    "tabOverview": "Visão geral",
    "tabTasks": "Tarefas",
    "tabTimeline": "Cronograma",
    "tabTracks": "Rastreios & tarefas",
    "targetDate": "Data alvo",
    "task": {
      "allMembers": "Todos os membros",
      "ask": "Perguntar",
      "askCopilotTask": "Pergunte ao CoPilot sobre esta tarefa",
      "blockedBy": "Bloqueado Por",
      "blockedComplete": "Bloqueado — Complete as dependências primeiro",
      "completeError": "Falha ao concluir a tarefa. Por favor, tente novamente.",
      "completionNotesPlaceholder": "Adicionar notas de conclusão (opcional)...",
      "confirmComplete": {
        "message": "Tem certeza de que deseja marcar esta tarefa como concluída? Esta ação não pode ser desfeita.",
        "title": "Marcar tarefa como completa?"
      },
      "dependenciesResolved": "Dependências (resolvidas)",
      "docStatusMissing": "Em falta",
      "docStatusPending": "Pendente",
      "docStatusRejected": "Rejeitado",
      "docStatusUploaded": "Carregado",
      "docStatusVerified": "Verificado",
      "documents": "Documentos",
      "documentsRequired": "Documentos necessários",
      "dueToday": "Vence hoje",
      "dueTomorrow": "Vence amanhã",
      "entireFamily": "Toda a família",
      "markComplete": "Marcar como completo",
      "needHelp": "Precisa de ajuda?",
      "noAdditionalDocs": "Sem documentos adicionais",
      "noDocsAttached": "Sem documentos anexados ainda",
      "notFound": "Tarefa não encontrada",
      "notes": "Notas",
      "otherDocuments": "Outros documentos",
      "reopenError": "Falha ao reabrir a tarefa. Por favor, tente novamente.",
      "reopenTask": "Reabrir tarefa",
      "requiredDocuments": "Documentos necessários",
      "statusBlocked": "Bloqueado",
      "statusCompleted": "Completo",
      "statusInProgress": "Em progresso",
      "statusOverdue": "Atrasado",
      "statusTodo": "A fazer",
      "taskBlocked": "Tarefa bloqueada",
      "taskBlockedMsg": "Complete as tarefas bloqueadoras primeiro antes de marcar esta como concluída.",
      "title": "Tarefa",
      "trackLegal": "Legal",
      "trackSetup": "Configuração",
      "trackTravel": "Viagem",
      "uploadDocument": "Carregar documento",
      "uploadDocumentHint": "Usar a câmara, a biblioteca de fotos ou ficheiros",
      "uploadRequired": "Carregar necessário",
      "uploaded": "Carregado",
      "validated": "Validado",
      "companyOwnedNote": "Esta tarefa é tratada pela sua empresa — eles irão completá-la do lado deles.",
      "companyProvidesDoc": "A sua empresa fornece isto",
      "daysOverdue_one": "{{count}} dia de atraso",
      "daysOverdue_other": "{{count}} dias de atraso",
      "documentsRequiredMsg_one": "Carregue os documentos necessários antes de concluir esta tarefa. Ainda falta {{count}} documento.",
      "documentsRequiredMsg_other": "Carregue os documentos necessários antes de concluir esta tarefa. Ainda faltam {{count}} documentos.",
      "dueInDays_one": "Vence em {{count}} dia",
      "dueInDays_other": "Vence em {{count}} dias",
      "milesReward_one": "+{{count}} Mile",
      "milesReward_other": "+{{count}} Miles",
      "missingCount_one": "{{count}} em falta",
      "missingCount_other": "{{count}} em falta",
      "uploadDocsFirst_one": "Carregue primeiro {{count}} documento necessário",
      "uploadDocsFirst_other": "Carregue primeiro {{count}} documentos necessários"
    },
    "taskArrangePickup": "Organizar transporte do aeroporto",
    "taskArrangePickupDesc": "Organizar transporte a partir do aeroporto",
    "taskBookFlights": "Reservar voos",
    "taskBookFlightsDesc": "Reserve os seus voos para o país de destino",
    "taskCompleted": "Tarefa concluída",
    "taskCompletedError": "Falha ao concluir a tarefa. Por favor, tente novamente.",
    "taskCompletedSuccess": "Tarefa concluída com sucesso!",
    "taskCredentialRecognition": "Complete o processo de reconhecimento de credenciais",
    "taskCredentialRecognitionDesc": "Complete o processo de reconhecimento de credenciais para profissões regulamentadas",
    "taskDefinitiveHousing": "Encontrar habitação definitiva",
    "taskDefinitiveHousingDesc": "Encontrar e garantir habitação permanente",
    "taskFillApplication": "Preencher formulário de pedido de visto",
    "taskFillApplicationDesc": "Complete o formulário de pedido de visto com informações precisas",
    "taskGatherDocuments": "Reunir documentos necessários",
    "taskGatherDocumentsDesc": "Reúna todos os documentos necessários para o seu pedido de visto",
    "taskNotFound": "Tarefa não encontrada",
    "taskNoteDescription": "Adicionar uma nota pessoal para esta tarefa",
    "taskNoteTitle": "Nota da tarefa: {{title}}",
    "taskPlanItinerary": "Planear itinerário de chegada",
    "taskPlanItineraryDesc": "Planeie o seu itinerário de chegada e primeiros dias",
    "taskPrepareMaterials": "Preparar materiais para a entrevista",
    "taskPrepareMaterialsDesc": "Prepare todos os materiais necessários para a entrevista",
    "taskReopened": "Tarefa reaberta",
    "taskScheduleInterview": "Agendar entrevista de visto",
    "taskScheduleInterviewDesc": "Agende a sua entrevista de visto",
    "taskSchoolingChildcare": "Organizar escolaridade e cuidados infantis",
    "taskSchoolingChildcareDesc": "Organizar escolaridade e cuidados infantis para crianças",
    "taskStatus": {
      "blocked": "Bloqueado",
      "completed": "Completo",
      "in_progress": "Em progresso",
      "not_started": "Não iniciado",
      "overdue": "Atrasado",
      "pending": "Pendente",
      "todo": "A fazer"
    },
    "taskTemporaryHousing": "Garantir habitação temporária",
    "taskTemporaryHousingDesc": "Garantir alojamento temporário para a sua chegada",
    "tasks": {
      "apostille_documents": {
        "description": "Obter selos de apostilha oficiais em todos os documentos necessários",
        "title": "Apostilhar documentos"
      },
      "baggage_shipping": {
        "company_title": "Organizar envio de bagagem",
        "description": "Organizar o envio de bens pessoais para o destino",
        "title": "Envio de bagagem"
      },
      "child_dependent_visa": {
        "description": "Submeter pedido de visto de dependente para crianças",
        "title": "Visto de dependente para crianças"
      },
      "collect_birth_certificate": {
        "description": "Obter certidões de nascimento certificadas para todos os membros da família que se mudam",
        "title": "Recolher certidão de nascimento"
      },
      "collect_marriage_certificate": {
        "description": "Obter certidão de casamento certificada para pedidos de visto",
        "title": "Recolher certidão de casamento"
      },
      "collect_passport": {
        "description": "Reunir passaportes válidos para todos os membros da família que se mudam",
        "title": "Levantar Passport"
      },
      "credential_recognition": {
        "description": "Solicitar reconhecimento de credenciais profissionais no país de destino",
        "title": "Reconhecimento de credenciais"
      },
      "criminal_record": {
        "description": "Solicitar certificado de registo criminal do seu país de origem",
        "title": "Obter registo criminal"
      },
      "drivers_license_exchange": {
        "description": "Trocar a sua carta de condução estrangeira por uma local",
        "title": "Troca de carta de condução"
      },
      "employment_contract": {
        "company_title": "Emitir contrato de trabalho",
        "description": "Garantir o seu contrato de trabalho assinado pelo seu empregador",
        "title": "Contrato de trabalho"
      },
      "find_housing": {
        "company_title": "Organizar apoio à habitação",
        "description": "Pesquisar e encontrar alojamento permanente",
        "title": "Encontrar habitação"
      },
      "flight_booking": {
        "company_title": "Organizar reserva de voo",
        "description": "Reservar voos para todos os membros da família que se mudam",
        "title": "Reservar voos"
      },
      "get_codice_fiscale": {
        "description": "Obter o seu código fiscal italiano",
        "title": "Obter codice fiscale"
      },
      "get_nie": {
        "description": "Obter o seu número de identificação de estrangeiro espanhol",
        "title": "Obter NIE"
      },
      "get_nif": {
        "description": "Solicitar o seu número de identificação fiscal português (NIF)",
        "title": "Obter NIF (número de contribuinte)"
      },
      "get_niss": {
        "description": "Pedir o número de segurança social português (NISS)",
        "title": "Obter NISS (segurança social)"
      },
      "groupBy": {
        "member": "Agrupar por membro",
        "shared": "Partilhado (domicílio)",
        "status": "Agrupar por estado"
      },
      "health_insurance_enrollment": {
        "company_title": "Organizar seguro de saúde",
        "description": "Inscrever-se em cobertura de seguro de saúde",
        "title": "Seguro de saúde"
      },
      "health_registration": {
        "description": "Inscrever-se no sistema de saúde local",
        "title": "Inscrição na saúde"
      },
      "local_sim": {
        "description": "Comprar um cartão SIM local ou eSIM para o seu país de destino",
        "title": "Obter cartão SIM local"
      },
      "marriage_certificate": {
        "description": "Recolher a sua certidão de casamento",
        "title": "Certidão de casamento"
      },
      "municipality_registration": {
        "description": "Registar-se na câmara municipal da sua zona (Junta de Freguesia)",
        "title": "Registo municipal"
      },
      "nif_partner": {
        "description": "Solicitar o número de identificação fiscal português do seu parceiro",
        "title": "NIF do parceiro (número de contribuinte)"
      },
      "open_bank_account": {
        "description": "Abrir uma conta bancária no seu país de destino",
        "title": "Abrir conta bancária"
      },
      "ownership": {
        "company": "Tarefa da empresa",
        "dual": "Responsabilidade partilhada",
        "government": "Processo governamental",
        "talent": "A sua tarefa"
      },
      "partner_visa_application": {
        "description": "Submeter pedido de visto para o seu parceiro/cônjuge",
        "title": "Pedido de visto para parceiro"
      },
      "pet_microchip_verification": {
        "description": "Verificar se o microchip do seu animal de estimação é compatível com ISO e legível",
        "title": "Verificação de microchip de animal de estimação"
      },
      "pet_passport": {
        "description": "Obter passaporte de animal de estimação da UE com registos de vacinação",
        "title": "Passaporte do animal de estimação"
      },
      "pet_transport": {
        "description": "Organizar transporte seguro para o seu animal de estimação até ao destino",
        "title": "Transporte de animal de estimação"
      },
      "pet_vaccination": {
        "description": "Garantir que todas as vacinas necessárias estão atualizadas para o seu animal de estimação",
        "title": "Vacinação de animal de estimação"
      },
      "portuguese_bank_transfer": {
        "description": "Configurar transferências internacionais para a sua conta bancária portuguesa",
        "title": "Transferência bancária internacional"
      },
      "proof_of_address": {
        "description": "Obter prova oficial do seu endereço residencial",
        "title": "Prova de endereço"
      },
      "proof_of_income": {
        "description": "Reunir extratos bancários e prova de meios financeiros",
        "title": "Prova de rendimento"
      },
      "provide_employment_contract": {
        "company_title": "Fornecer contrato de trabalho ao talento",
        "description": "A empresa fornece o contrato de trabalho assinado",
        "title": "Fornecer contrato de trabalho"
      },
      "promise_contract": {
        "company_title": "Fornecer contrato de promessa de trabalho",
        "description": "A empresa emite a promessa de contrato de trabalho assinado para o pedido de visto",
        "title": "Contrato de promessa de trabalho"
      },
      "consulate_invitation_letter": {
        "company_title": "Fornecer carta de convite para o consulado",
        "description": "A empresa emite a carta de convite / declaração que o talento apresenta no consulado",
        "title": "Carta de convite para o consulado"
      },
      "term_of_responsibility": {
        "company_title": "Fornecer termo de responsabilidade",
        "description": "A empresa assina o termo de responsabilidade notarial que cobre a estadia do talento",
        "title": "Termo de responsabilidade"
      },
      "techvisa_endorsement": {
        "company_title": "Fornecer endosse de empresa para visto tecnológico",
        "description": "Empresa certificada emite o endosse do Visto Tecnológico / termo de responsabilidade para a contratação reconhecida pelo IAPMEI",
        "title": "Endosse do visto tecnológico"
      },
      "reopen": {
        "button": "Reabrir tarefa",
        "confirmMessage": "Isto moverá a tarefa de volta para o estado pendente.",
        "confirmTitle": "Reabrir esta tarefa?",
        "reason": "Razão para reabertura (opcional)"
      },
      "residence_permit_renewal": {
        "description": "Acompanhe e planeie o cronograma de renovação do seu visto de residência",
        "title": "Renovação do visto de residência"
      },
      "salary_proof": {
        "description": "Reúna recibos de salário ou prova de compensação",
        "title": "Prova de salário"
      },
      "school_enrollment": {
        "description": "Inscrever crianças em escolas locais",
        "title": "Inscrição escolar"
      },
      "school_records": {
        "description": "Reunir os registos escolares e os certificados de notas das crianças",
        "title": "Registos escolares"
      },
      "sef_aima_appointment": {
        "description": "Marcar e comparecer ao atendimento na autoridade de imigração",
        "title": "Marcação na AIMA"
      },
      "sign_lease": {
        "description": "Rever e assinar o seu contrato de arrendamento",
        "title": "Assinar contrato de arrendamento"
      },
      "sns_registration": {
        "description": "Registar-se no serviço nacional de saúde (SNS)",
        "title": "Registo SNS"
      },
      "sponsor_letter": {
        "company_title": "Fornecer carta de patrocínio",
        "description": "Obter carta de patrocínio do seu empregador",
        "title": "Carta de patrocínio"
      },
      "temp_accommodation": {
        "company_title": "Organizar alojamento temporário",
        "description": "Organizar alojamento temporário para as suas primeiras semanas",
        "title": "Alojamento temporário"
      },
      "translate_documents": {
        "description": "Obter traduções certificadas de todos os documentos necessários",
        "title": "Traduzir documentos"
      },
      "travel_insurance": {
        "description": "Organizar cobertura de seguro de viagem para o período de realocação",
        "title": "Seguro de viagem"
      },
      "utilities_setup": {
        "description": "Configurar eletricidade, água, gás e internet na sua nova casa",
        "title": "Configuração de utilidades"
      },
      "visa_application": {
        "description": "Submeter a sua candidatura de visto no consulado ou portal online",
        "title": "Candidatura de visto"
      },
      "visa_pickup": {
        "description": "Levantar o visto aprovado no consulado ou na embaixada",
        "title": "Levantamento de visto"
      }
    },
    "tasksCompleted": "Tarefas concluídas",
    "tasksCount": "{{completed}}/{{total}} tarefas",
    "tasksDone": "Tarefas feitas",
    "tasksLabel": "Tarefas",
    "tasksOfTotal": "{{completed}}/{{total}} tarefas",
    "timelineDescription": "Cronograma visual das suas fases de realocação",
    "timelineTitle": "Cronograma & vista Gantt",
    "timelineView": "Vista do cronograma",
    "title": "TelePortal",
    "toDo": "A fazer",
    "tonnieChecked": "Tonnie-Verificado",
    "track": {
      "legal": "Legal",
      "setup": "Configuração",
      "travel": "Viagem"
    },
    "trackJourneyProgress": "Acompanhe o progresso do seu percurso de realocação",
    "trackLegal": "Acompanhamento legal",
    "trackLegalDesc": "Prontidão legal baseada em rotas, listas de verificação de documentos (consciente do agregado familiar)",
    "trackLegalDescShort": "Visto, permissões e documentação legal",
    "trackProgress": "Acompanhar progresso",
    "trackSetup": "Configuração de acompanhamento",
    "trackSetupDesc": "Camada de estabilização (primeiras semanas) incluindo alojamento, reconhecimento de credenciais, escolaridade/creche e marcos do Programa de Acompanhamento",
    "trackSetupDescShort": "Habitação, banca e integração",
    "trackSuffix": "Acompanhar",
    "trackTasksProgress": "{{completed}}/{{total}} tarefas",
    "trackTravel": "Acompanhamento de viagem",
    "trackTravelDesc": "Prontidão logística, planeamento de viagem consciente do agregado familiar",
    "trackTravelDescShort": "Voos, alojamento e logística",
    "tracks": {
      "legal": "Legal & documentos",
      "setup": "Configuração local",
      "travel": "Viagem & logística"
    },
    "tracksCompleted": "Pistas concluídas",
    "tryAgain": "Tente novamente",
    "tryAgainLater": "Por favor, tente novamente mais tarde.",
    "unableToLoadData": "Incapaz de carregar dados de TelePortal",
    "unlockPro": "Desbloquear com Pro",
    "upcomingDeadlines": "Prazos iminentes",
    "upcomingTasks": "Tarefas iminentes",
    "upgradeMessage": "Atualize para aceder a todas as fases e funcionalidades avançadas de TelePortal.",
    "upload": "Carregar",
    "uploadDocument": "Carregar documento",
    "uploadDocumentDescription": "Adicione um documento ao seu percurso TelePortal",
    "uploadFromMobile": "Carregar do móvel",
    "uploadFromMobileDescription": "Use Tonnie Citizen para digitalizar e carregar documentos instantaneamente",
    "uploadFromMobileTitle": "Carregar documentos a partir do móvel",
    "uploadInMobile": "Carregar no móvel",
    "uploaded": "carregado",
    "uploading": "A carregar...",
    "validate": "Validar",
    "validated": "Validado",
    "vault": {
      "continue": "Continuar",
      "continueWithPending": "Continuar (pendente de revisão)",
      "documentsFound": "documentos encontrados no seu Cofre",
      "empty": "Cofre vazio",
      "emptyMessage": "O seu cofre está vazio. Vamos adicionar documentos aqui à medida que concluir tarefas.",
      "expired": "Expirado",
      "expiringSoon": "A expirar em breve",
      "hint": "Ligue documentos do seu cofre para evitar carregamentos.",
      "link": "Ligar",
      "linked": "Ligado",
      "remaining": "restante",
      "scanning": "A analisar o cofre…",
      "skip": "Saltar",
      "undo": "Desfazer",
      "validUntil": "Válido até {{date}}",
      "skipped": "Saltado"
    },
    "verifiedByTonnieGuard": "Verificado por Tonnie guard",
    "viewDetails": "Ver detalhes",
    "viewDocumentInMobile": "Carregar e gerir este documento na aplicação móvel",
    "viewMyOptions": "Ver as minhas opções",
    "viewTaskInMobile": "Ver e completar esta tarefa na aplicação móvel",
    "visaBlueCard": "Cartão azul da UE",
    "visaFamily": "Reunião familiar",
    "visaNomad": "Nómada digital / Trabalhador remoto",
    "visaStudent": "Visto de estudante",
    "visaWork": "Visto de trabalho / Emprego",
    "welcome": {
      "description": "Construa o seu plano de realocação personalizado. Vamos guiá-lo através de uma configuração rápida para criar o seu painel com tarefas, documentos e prazos adaptados ao seu percurso.",
      "docsStep": "Documentos & tarefas",
      "docsStepDesc": "Obtenha uma lista de verificação personalizada de tudo o que precisa",
      "householdStep": "O seu agregado familiar & visto",
      "householdStepDesc": "Diga-nos quem está a realocar e a sua situação de imigração",
      "letsStart": "Vamos começar",
      "planStep": "Habitação & logística",
      "planStepDesc": "Configure o seu plano de habitação, viagem e cronograma",
      "timeEstimate": "Leva cerca de 5-10 minutos para completar",
      "title": "Bem-vindo ao TelePortal"
    },
    "welcomeMessage": "Bem-vindo à Avaliação TelePortal! Vou ajudá-lo a criar uma lista de verificação personalizada para a relocação. Vamos começar por entender a sua situação.",
    "you": "Eu",
    "yourNextStep": "O seu próximo passo",
    "setupDimension": {
      "profile": "Perfil",
      "profileDesc": "Origem, destino e contexto de realocação",
      "household": "Agregado familiar",
      "householdDesc": "Membros da família que se juntam à mudança",
      "documents": "Documentos",
      "documentsDesc": "Digitalização e ligação de documentos Vault",
      "preferences": "Preferências",
      "preferencesDesc": "Preferências de viagem, alojamento e estilo de vida"
    },
    "docType": {
      "accommodation": "Comprovativo de alojamento",
      "bank_statements": "Extratos bancários",
      "birth_certificate": "Certificado de nascimento",
      "boarding_pass": "Cartão de embarque",
      "certificate": "Certificado",
      "certified_translation": "Tradução certificada",
      "consulate_invitation_letter": "Carta de convite do consulado",
      "contract": "Contrato",
      "criminal_record": "Registo criminal",
      "drivers_license": "Carta de condução",
      "employer_declaration": "Declaração da entidade empregadora",
      "employment_contract": "Contrato de trabalho",
      "health_insurance_policy": "Apólice de seguro de saúde",
      "id_card": "Cartão de cidadão",
      "insurance": "Seguro",
      "lease_agreement": "Contrato de arrendamento",
      "marriage_certificate": "Certidão de casamento",
      "medical_documentation": "Documentação médica",
      "official_document": "Documento oficial",
      "other": "Outro documento",
      "passport": "Passaporte",
      "passport_stamp": "Carimbo no passaporte",
      "pet_passport": "Passaporte do animal de estimação",
      "photo": "Fotografia tipo passe",
      "promise_contract": "Contrato de promessa",
      "proof_of_address": "Prova de endereço",
      "proof_of_income": "Prova de rendimento",
      "residence_permit": "Título de residência",
      "salary_proof": "Comprovativo de salário",
      "school_records": "Registos escolares",
      "sponsor_letter": "Carta de patrocínio",
      "tax_document": "Documento fiscal",
      "techvisa_endorsement": "Endosse do TechVisa",
      "term_of_responsibility": "Termo de responsabilidade",
      "ticket": "Bilhete",
      "travel_insurance": "Seguro de viagem",
      "visa": "Visto",
      "work_permit": "Autorização de trabalho"
    },
    "duration": {
      "1_2_days": "1-2 dias",
      "1_2_weeks": "1-2 semanas",
      "1_3_days": "1-3 dias",
      "1_day": "1 dia",
      "1_week": "1 semana",
      "2_3_weeks": "2-3 semanas",
      "2_4_weeks": "2-4 semanas",
      "2_6_weeks": "2-6 semanas",
      "2_8_weeks": "2-8 semanas",
      "3_5_days": "3-5 dias",
      "4_12_weeks": "4-12 semanas",
      "4_8_weeks": "4-8 semanas",
      "ongoing": "Em andamento"
    },
    "daysOverdue_one": "{{count}} dia de atraso",
    "daysOverdue_other": "{{count}} dias de atraso",
    "documentsAttached_one": "{{count}} documento anexado",
    "documentsAttached_other": "{{count}} documentos anexados",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "dueInDays_one": "Vence em {{count}} dia",
    "dueInDays_other": "Vence em {{count}} dias",
    "inProgressCount_one": "{{count}} em curso",
    "inProgressCount_other": "{{count}} em progresso",
    "missingDocs_one": "{{count}} em falta",
    "missingDocs_other": "{{count}} em falta",
    "moreCompleted_one": "+{{count}} concluída",
    "moreCompleted_other": "+{{count}} concluídas",
    "needsAttentionCount_one": "{{count}} precisa de atenção",
    "needsAttentionCount_other": "{{count}} precisam de atenção",
    "pendingCount_one": "{{count}} pendente",
    "pendingCount_other": "{{count}} pendentes",
    "timeMinutes_one": "~{{count}} minuto",
    "timeMinutes_other": "~{{count}} minutos",
    "capture": {
      "reading": "A ler o documento…",
      "readAsOther": "Parece ser {{type}} — confirme que é o documento que esta tarefa pede.",
      "saving": "A guardar no seu Cofre…",
      "savingProgress": "A guardar no seu Cofre… {{percent}}%"
    },
    "deleteDocumentError": "Não foi possível remover o documento. Tente novamente."
  },
  "termsPrivacy": {
    "gdprRights": "Nos termos do RGPD e das leis de proteção de dados aplicáveis, tem o direito de aceder aos seus dados pessoais, retificá-los, apagá-los e transferi-los. Pode exercer esses direitos a qualquer momento através das Definições ou do contacto com o nosso Encarregado de Proteção de Dados.",
    "privacyPolicy": "Política de privacidade",
    "termsOfService": "Termos de serviço",
    "title": "Termos & privacidade",
    "yourRights": "Os seus direitos"
  },
  "theme": {
    "autoMatchSystem": "A app vai acompanhar automaticamente as definições de tema do seu dispositivo.",
    "configure": "Configurar",
    "custom": "Personalizado",
    "dark": "Escuro",
    "darkTheme": "Tema escuro",
    "followSystem": "Seguir sistema ({{mode}})",
    "light": "Claro",
    "lightTheme": "Tema claro",
    "system": "Sistema",
    "theme": "Tema",
    "themeSelection": "Seleção de tema",
    "useFixedTheme": "A aplicação usará o tema {{mode}} independentemente das definições do seu dispositivo."
  },
  "validation": {
    "passwordUpdateFailed": "Falha ao atualizar a palavra-passe. Por favor, tente novamente.",
    "passwordUpdated": "Palavra-passe atualizada com sucesso",
    "required": "Este campo é obrigatório",
    "email": {
      "invalid": "Endereço de email inválido",
      "required": "Introduza o seu endereço de email."
    },
    "password": {
      "min": "A palavra-passe precisa de ter pelo menos {{passwordMinLength}} caracteres.",
      "mismatch": "As palavras-passe não coincidem",
      "max": "A palavra-passe pode ter no máximo {{passwordMaxLength}} caracteres.",
      "required": "Introduza a sua palavra-passe.",
      "confirmRequired": "Confirme a sua palavra-passe."
    },
    "firstName": {
      "required": "O primeiro nome é obrigatório",
      "tooLong": "O nome próprio pode ter no máximo 50 caracteres."
    },
    "lastName": {
      "required": "O sobrenome é obrigatório",
      "tooLong": "O apelido pode ter no máximo 50 caracteres."
    },
    "uuid": {
      "invalid": "UUID inválido"
    },
    "phone": {
      "invalid": "Número de telefone inválido"
    },
    "url": {
      "invalid": "URL inválido"
    },
    "countryCode": {
      "length": "O código do país deve ter 2 caracteres (ISO 3166-1 alpha-2)"
    },
    "dateRange": {
      "endAfterStart": "A data de término deve ser após a data de início"
    },
    "field": {
      "required": "Este campo é obrigatório"
    },
    "iqulture": {},
    "city": {
      "required": "Indique a cidade onde vive",
      "tooLong": "O nome da cidade é demasiado longo (máximo 100 caracteres)"
    },
    "originCountry": {
      "required": "Escolha o país de onde está a sair"
    },
    "nationality": {},
    "timeZone": {
      "invalid": "Esse fuso horário não é reconhecido."
    },
    "timeOfDay": {
      "invalid": "Use uma hora como 22:00."
    },
    "code": {
      "sixDigits": "Introduza o código de 6 dígitos."
    },
    "destination": {
      "notOpen": "Ainda não oferecemos este destino. Hoje, o destino disponível é Portugal."
    },
    "journey": {
      "requestIdRequired": "Um novo percurso precisa de um identificador de pedido",
      "newIntentOnly": "Só um novo percurso aceita um identificador de pedido ou um nome",
      "labelRequired": "Escreva um nome ou apague-o",
      "labelTooLong": "Use 40 caracteres ou menos"
    },
    "inoutPortal": {
      "code": "Maiúsculas, algarismos e _ — a começar por uma letra, de 2 a 40 caracteres.",
      "colour": "Uma cor como #RRGGBB.",
      "origin": "Um site como https://anfitrião (http só para localhost).",
      "originTwice": "Este site está repetido.",
      "originsTooMany": "No máximo 20 sites.",
      "activeNeedsOrigin": "Um portal ativo precisa de pelo menos um site.",
      "httpsUrl": "Um endereço https://.",
      "logo": "Um endereço https://, ou uma imagem servida pela calculadora (/assets/partners/nome.png).",
      "nameTooLong": "No máximo 120 caracteres.",
      "partner": "Escolha uma assessoria do registo.",
      "accentUnreadable": "Ilegível sobre a cor de ação — contraste abaixo de 4,5:1.",
      "pagePair": "A página e o seu texto vêm juntos.",
      "pageUnreadable": "Ilegível sobre a página — contraste abaixo de 4,5:1."
    }
  },
  "vault": {
    "downloadError": "Falha ao descarregar",
    "downloadSuccess": "Descarregado",
    "downloadZipError": "Falha ao descarregar documentos",
    "loadingPreview": "A carregar pré-visualização…",
    "removeError": "Falha ao remover",
    "removeSuccess": "Removido",
    "uploadError": "Falha ao carregar",
    "uploadSuccess": "Carregado",
    "uploadRejected": {
      "mimeNotAllowed": "Este tipo de ficheiro não é aceite nesta secção. Escolha outro ficheiro.",
      "unidentifiable": "Não conseguimos reconhecer este ficheiro. Pode estar danificado — tente exportá-lo novamente.",
      "declaredMimeMismatch": "O conteúdo deste ficheiro não corresponde ao seu tipo. Carregue o ficheiro original.",
      "pitchTooLong": "Este vídeo tem mais de {{minutes}} minutos. Escolha um vídeo mais curto.",
      "fileTooLarge": "Este ficheiro é demasiado grande para carregar. Escolha um ficheiro mais pequeno.",
      "uploadStalled": "O carregamento parou porque a sua ligação deixou de enviar dados. Verifique a ligação e tente novamente.",
      "fileNotLinkable": "Esse documento já não está no seu Cofre — escolha outro."
    },
    "downloadZipSuccess_one": "A descarregar {{count}} documento",
    "downloadZipSuccess_other": "A descarregar {{count}} documentos",
    "documentsCount_one": "{{count}} documento",
    "documentsCount_other": "{{count}} documentos",
    "pick": {
      "title": "Escolher do Cofre",
      "description": "Um documento que já guarda — de qualquer herói.",
      "source": "Do seu Cofre",
      "sourceShort": "Cofre",
      "sourceHint": "Um documento que já guarda",
      "whatItIs": "O que é",
      "yourDocuments": "Os seus documentos",
      "attach": "Anexar",
      "empty": "Ainda não há no seu Cofre um documento que sirva aqui.",
      "errorTitle": "Não foi possível ler o seu Cofre",
      "errorBody": "Tente novamente daqui a pouco.",
      "suggested": "Sugeridos"
    },
    "preview": {
      "openWith": "Abrir com…"
    },
    "add": {
      "title": "Adicionar um documento",
      "description": "Fica no seu Cofre, no herói que escolher.",
      "where": "Onde guardar",
      "camera": "Tirar foto",
      "library": "Das fotos",
      "files": "Dos ficheiros",
      "uploading": "A enviar…"
    }
  },
  "viewport": {
    "description": "O Tonnie Citizen Web foi concebido para ecrãs maiores. Para a melhor experiência móvel, transfira a app móvel.",
    "downloadAppStore": "Descarregar na app store",
    "downloadPlayStore": "Obtenha-o no Google play",
    "orAccessDesktop": "Ou aceda a partir de um tablet ou desktop",
    "switchToMobile": "Mudar para Tonnie Citizen"
  },
  "webPortal": {
    "availableOnWeb": "Disponível no portal web Citizen",
    "copied": "Copiado!",
    "copyLink": "Copiar link para desktop",
    "hint": "O Portal Web Citizen requer um browser de desktop.",
    "shareLink": "Partilhar link"
  },
  "widgets": {
    "continue": "Continuar",
    "motivationalForm": {
      "sharePlaceholder": "Partilhe os seus pensamentos..."
    },
    "rating": {
      "notAtAll": "De todo",
      "veryMuch": "Muito"
    },
    "timeline": {
      "12plusMonths": "12+ meses",
      "12plusMonthsDesc": "Planeamento futuro",
      "1to3months": "1-3 meses",
      "1to3monthsDesc": "Planeamento a curto prazo",
      "3to6months": "3-6 meses",
      "3to6monthsDesc": "Planeamento a médio prazo",
      "6to12months": "6-12 meses",
      "6to12monthsDesc": "Planeamento a longo prazo",
      "asap": "Assim que possível",
      "asapDesc": "Dentro do próximo mês",
      "flexible": "Flexível",
      "flexibleDesc": "Sem cronograma específico"
    }
  },
  "world": {
    "completeToUnlock": "Complete missões anteriores para desbloquear",
    "upgradeToUnlock": "Faça upgrade para desbloquear",
    "completed": "Completo",
    "notFound": "Mundo não encontrado",
    "backToQultureUp": "Voltar ao QultureUp",
    "ofMissions": "{{completed}} de {{total}} missões",
    "overallProgress": "Progresso geral",
    "remaining": "Restante",
    "title": "Mundo",
    "tracks": "Faixas",
    "milesReward_one": "+{{count}} Mile",
    "milesReward_other": "+{{count}} Miles"
  },
  "pricing": {
    "betaPriceLabel": "Preço de acesso antecipado",
    "percentOffLabel": "−{{percent}}%",
    "betaDisclaimer": "Preço de acesso antecipado — preço regular {{listPrice}} após o lançamento."
  },
  "ui": {
    "sidebar": {
      "toggle": "Alternar barra lateral"
    },
    "carousel": {
      "prev": "Slide anterior",
      "next": "Próximo slide"
    },
    "command": {
      "title": "Paleta de comandos",
      "description": "Procure um comando para executar..."
    }
  },
  "plan": {
    "upgrade": {
      "teleportal": "Desbloqueie este percurso ou passe a Pro para abrir todas as fases de TelePortal",
      "qultureup": "Desbloqueie este percurso ou passe a Pro para aceder a todos os mundos de QultureUp",
      "care": "Desbloqueie este percurso ou passe a Pro para aceder a Care & Suporte",
      "passport": "Desbloqueie este percurso ou passe a Pro para ter o Passport completo",
      "career": "Atualize para Pro para recursos de carreira aprimorados",
      "copilot": "Atualize para Pro para consultas ilimitadas CoPilot",
      "familyProgram": "Desbloqueie este percurso ou passe a Pro para ativar o Programa Familiar",
      "default": "Atualize para desbloquear este recurso"
    }
  },
  "appUpdate": {
    "required": {
      "title": "Atualização necessária",
      "body": "Esta versão da Tonnie já não é suportada. Atualize para continuar.",
      "cta": "Atualizar agora"
    },
    "available": {
      "title": "Atualização disponível",
      "body": "Está disponível uma nova versão da Tonnie.",
      "cta": "Atualizar"
    },
    "dismiss": "Mais tarde"
  },
  "setup": {
    "title": "De que país está a sair?",
    "countryLabel": "País de onde está a sair",
    "countryPlaceholder": "Selecione um país",
    "cityLabel": "Cidade onde vive",
    "cityPlaceholder": "Comece a escrever a sua cidade…",
    "destinationLabel": "Destino",
    "destinationOpenToday": "{{country}} é o destino disponível hoje. Em breve haverá mais.",
    "submit": "Continuar",
    "saving": "A configurar o seu percurso…",
    "saveFailed": "Não foi possível guardar. Verifique a ligação e tente novamente."
  },
  "profileComplete": {
    "known": "Já no seu perfil",
    "countryPlaceholder": "Selecione um país",
    "cityPlaceholder": "Comece a escrever a sua cidade…",
    "phonePlaceholder": "O seu número de telefone",
    "optionalNote": "Os dados do passaporte, o CV e o agregado familiar são opcionais. Nunca bloqueiam a sua pontuação.",
    "saving": "A guardar…",
    "saveFailed": "Não foi possível guardar. Verifique a ligação e tente novamente.",
    "label": {
      "firstName": "Nome próprio",
      "lastName": "Apelido",
      "dateOfBirth": "Data de nascimento",
      "currentCountry": "País onde vive",
      "currentCity": "Cidade onde vive",
      "phone": "Telefone"
    },
    "loadFailed": "Não foi possível carregar o seu perfil. Verifique a ligação e tente novamente."
  },
  "profileBasics": {
    "title": "Os seus dados básicos",
    "subtitle": "O que o seu CheckUp precisa para começar. Deixe um documento escrever por si — confirma tudo antes de ser guardado.",
    "progressLabel": "Essenciais para o seu CheckUp",
    "close": "Fechar",
    "back": "Voltar aos seus dados",
    "faster": {
      "title": "Preencha mais depressa",
      "fastest": "Mais rápido",
      "document": {
        "title": "Digitalizar passaporte ou cartão",
        "fills": "Data de nascimento · cidadania"
      },
      "import": {
        "title": "PDF do LinkedIn ou CV",
        "fills": "Experiência · formação · competências · idiomas"
      }
    },
    "orType": "ou escreva",
    "filled": {
      "document_one": "O seu documento preencheu {{count}} dado. Veja o que falta abaixo.",
      "document_other": "O seu documento preencheu {{count}} dados. Veja o que falta abaixo.",
      "documentNone": "Nada foi adicionado a partir do documento.",
      "import": "O seu PDF do LinkedIn ou CV já está no perfil — torna a sua pontuação mais precisa."
    },
    "done": {
      "title": "Os seus dados básicos estão completos",
      "body": "Tudo o que o seu CheckUp precisa para começar já está registado. Um PDF do LinkedIn ou um CV ainda torna a pontuação mais precisa."
    },
    "doneCta": "Concluído",
    "privacy": "Nada é guardado até carregar em Guardar.",
    "later": "Mais tarde",
    "save": "Guardar os meus dados",
    "saved": "Os seus dados foram guardados."
  },
  "citizenHome": {
    "needsYou": {
      "checkin": {
        "action": "Fazer check-in",
        "body": "O seu check-in diário demora um minuto.",
        "last": "Último check-in: {{date}}",
        "title": "Como está hoje?"
      },
      "checkpoint": {
        "action": "Começar",
        "body": "Conte-nos como está a correr a sua integração.",
        "overdueTitle": "Um checkpoint Care está em atraso",
        "title": "Tem um checkpoint Care pendente"
      },
      "invitation": {
        "action": "Rever",
        "body": "Reveja o convite para decidir se quer aderir.",
        "title": "Convite de {{company}}"
      },
      "later": "Mais tarde",
      "laterA11y": "Mais tarde: {{title}}",
      "seeAll": "Ver tudo",
      "showLess": "Ver menos",
      "seeAllA11y_one": "Ver a {{count}} coisa que precisa de si",
      "seeAllA11y_other": "Ver as {{count}} coisas que precisam de si",
      "profile": {
        "action": "Completar perfil",
        "body": "A sua pontuação CheckUp precisa de mais alguns dados seus.",
        "title": "Complete o seu perfil",
        "secondary": "Carregar passaporte"
      },
      "taskOverdue": {
        "action": "Abrir tarefa",
        "body": "Alguns prazos da sua mudança já passaram.",
        "title_one": "{{count}} tarefa em atraso",
        "title_other": "{{count}} tarefas em atraso"
      },
      "title": "Precisa de si",
      "unread": {
        "action": "Ler",
        "body": "Veja as novidades.",
        "title_one": "{{count}} mensagem por ler",
        "title_other": "{{count}} mensagens por ler"
      },
      "dismiss": "Dispensar",
      "dismissA11y": "Dispensar: {{title}}",
      "sponsorship": {
        "title": "A {{company}} quer patrocinar o seu percurso",
        "body": "Todos os capítulos abrem — TelePortal, QultureUp, Care e Passport — sem qualquer custo para si.",
        "action": "Ver oferta"
      },
      "testit": {
        "title_one": "A {{company}} pede-lhe {{count}} teste",
        "title_other": "A {{company}} pede-lhe {{count}} testes",
        "body_one": "Falta {{count}}. Os resultados ficam seus para reutilizar.",
        "body_other": "Faltam {{count}}. Os resultados ficam seus para reutilizar.",
        "action": "Fazer os testes"
      },
      "checkupRequested": {
        "title": "A {{company}} está à espera do seu CheckUp",
        "bodyStart": "Foi a sua pontuação iQulture que pediram. Leva cerca de 10–15 minutos.",
        "actionStart": "Começar CheckUp",
        "bodyContinue": "Termine o seu CheckUp — foi a sua pontuação iQulture que pediram.",
        "actionContinue": "Continuar CheckUp",
        "bodyProfile": "O seu CheckUp está feito. Acrescente alguns dados ao perfil e a sua pontuação fica pronta.",
        "actionProfile": "Completar perfil",
        "bodyCalculate": "Todos os passos estão feitos. Calcule a sua pontuação para responder ao pedido.",
        "actionCalculate": "Calcular pontuação",
        "bodyCalculating": "A sua pontuação está a ser calculada. Não demora.",
        "actionCalculating": "Ver CheckUp",
        "bodyConsent": "A sua pontuação está pronta. Só a veem se escolher partilhá-la.",
        "actionConsent": "Escolher o que veem",
        "titleConsent": "A {{company}} pede para ver a pontuação do seu CheckUp"
      },
      "checkupShared": {
        "title": "A {{company}} pode ver o seu CheckUp",
        "body": "Veem a sua pontuação e a sua preparação, nunca as suas respostas. Pode mudar isso a qualquer momento.",
        "action": "Gerir partilha"
      },
      "countAria_one": "{{count}} coisa precisa de si",
      "countAria_other": "{{count}} coisas precisam de si",
      "request": {
        "titleTests": "A {{company}} pede para ver mais resultados dos seus testes",
        "body": "Veja o que passariam a ver e decida. Nada é partilhado até lá.",
        "action": "Rever"
      },
      "inout": {
        "title": "Esteve cá?",
        "body": "O InOut pergunta por {{from}} – {{to}}. Sem resposta, esses dias ficam incertos.",
        "action": "Responder"
      },
      "inoutLimit": {
        "title": "Um limite de residência está perto",
        "body": "Com as viagens à frente, um limite seria atingido a {{date}}. Veja o que pode fazer antes de sair.",
        "reachedTitle": "Um limite de residência foi ultrapassado",
        "reachedBody": "A regra que conta primeiro passou o limite. Veja o que significa e quem pode ajudar.",
        "action": "Abrir o InOut"
      },
      "inoutRenewal": {
        "title": "A sua janela de renovação está aberta",
        "body": "Pode pedir a renovação do seu título de residência até {{date}}.",
        "action": "Abrir o InOut"
      }
    },
    "handoff": {
      "testit": {
        "title": "Faça os seus testes",
        "description": "O TestIt funciona na Citizen Web, com a câmara e o microfone de que alguns testes precisam."
      },
      "sharing": {
        "title": "Escolha o que as empresas veem",
        "description": "Quem vê os seus dados, e o que vê, gere-se na Citizen Web, em As meus percursos."
      }
    },
    "welcome": {
      "badge": "Bem-vindo à Tonnie",
      "badgeInvited": "Convidado pela {{company}}",
      "title": "{{name}}, a sua mudança para o estrangeiro começa aqui.",
      "titleNoName": "A sua mudança para o estrangeiro começa aqui.",
      "titleInvited": "Bem-vindo, {{name}}. A {{company}} está à sua espera.",
      "titleInvitedNoName": "Bem-vindo. A {{company}} está à sua espera.",
      "body": "Crie o seu percurso, descubra até que ponto está preparado com um CheckUp tão completo como um check-up médico e planeie cada documento e cada prazo — até ser um Citizen.",
      "bodyInvited": "Aceite o convite e o seu percurso começa: primeiro o que a {{company}} pediu, depois um plano para cada documento e prazo da sua mudança.",
      "ctaBuild": "Criar o seu percurso",
      "ctaReview": "Ver convite",
      "ctaBasics": "Adicionar os meus dados · 1 min",
      "ctaHow": "Como funciona",
      "routeAria": "Quatro capítulos: o seu percurso, o CheckUp, planear e mudar, tornar-se Citizen",
      "route": {
        "build": {
          "title": "Crie o seu percurso",
          "sub": "Para onde vai"
        },
        "accept": {
          "title": "Aceite o convite",
          "sub": "O percurso é criado"
        },
        "checkup": {
          "title": "CheckUp",
          "sub": "Quão preparado está"
        },
        "plan": {
          "title": "Planear e mudar",
          "sub": "Documentos, prazos"
        },
        "citizen": {
          "title": "Tornar-se Citizen",
          "sub": "Cultura, cuidado, passaporte"
        }
      }
    },
    "quickStart": {
      "eyebrow": "Início rápido",
      "title": "Os seus dados básicos em cerca de um minuto",
      "body": "Deixe um documento escrever por si — confirma tudo antes de ser guardado.",
      "progress": "Essenciais para o seu CheckUp: {{done}} de {{total}}",
      "type": {
        "title": "Escrever à mão",
        "body": "Só o que ainda falta — cerca de dois minutos.",
        "cta": "Adicionar à mão"
      }
    },
    "path": {
      "eyebrow": "Primeiros passos",
      "title": "Os seus primeiros cinco passos",
      "progress": "{{done}} de {{total}} feitos",
      "progressAria": "{{done}} de {{total}} passos feitos",
      "parts": "{{done}} de {{total}}",
      "note": "O CheckUp é gratuito para todos. Os passos 3 e 4 são mais rápidos com o seu passaporte ou CV.",
      "status": {
        "done": "Feito",
        "in_progress": "Em curso",
        "available": "Disponível agora",
        "locked": "Bloqueado"
      },
      "optional": "Opcional · melhor pontuação",
      "missing": "Ainda falta: {{items}}",
      "steps": {
        "journey": {
          "title": "Crie o seu percurso",
          "titleInvited": "Aceite o convite da {{company}}",
          "text": "Diga-nos para onde vai e construímos o plano à volta disso.",
          "textInvited": "Ao aceitar, o seu percurso é criado, com a {{company}}.",
          "textDone": "O seu percurso está pronto.",
          "meta": "Cerca de 3 minutos",
          "metaInvited": "1 minuto",
          "cta": "Criar percurso",
          "ctaInvited": "Ver convite"
        },
        "essential": {
          "title": "Adicione os dados essenciais",
          "text": "O que o CheckUp precisa para começar: nome, data de nascimento, cidadania, onde vive e telefone.",
          "textDone": "Tudo o que o CheckUp precisa para começar.",
          "meta": "2 minutos · ou uma foto do passaporte",
          "cta": "Adicionar num minuto"
        },
        "assessment": {
          "title": "Faça a avaliação CheckUp",
          "text": "Cinco partes curtas: vídeos, o seu pitch, línguas, motivação e uma conversa.",
          "textLocked": "Abre quando o seu percurso existir.",
          "textDone": "As cinco partes estão feitas.",
          "next": "A seguir: {{part}}.",
          "meta": "Cerca de 20 minutos · pode pausar quando quiser",
          "cta": "Começar",
          "ctaContinue": "Continuar",
          "parts": {
            "videos_watched": "os vídeos de introdução",
            "pitch_video": "o seu vídeo de pitch",
            "language_tests": "os seus testes de línguas",
            "motivational_answers": "as suas respostas sobre motivação",
            "assistant_chat": "a conversa com a Tonnie"
          }
        },
        "moreData": {
          "title": "Adicione mais dados",
          "text": "Competências, línguas, formação e experiência afinam a sua pontuação.",
          "textDone": "Tudo o que a pontuação lê está preenchido.",
          "meta": "1 minuto com um PDF do LinkedIn ou CV",
          "cta": "Importar LinkedIn ou CV"
        },
        "score": {
          "title": "Obtenha a sua pontuação iQulture",
          "titleShared": "Envie a sua pontuação à {{company}}",
          "text": "A sua preparação, pilar a pilar — e o que trabalhar a seguir.",
          "textShared": "Calculada com um clique, e a {{company}} vê-a.",
          "meta": "Um clique, depois dos passos 2 e 3",
          "cta": "Calcular a minha pontuação",
          "ctaCalculating": "Ver progresso",
          "ctaDone": "Ver resultados"
        }
      }
    },
    "chapters": {
      "eyebrow": "Como funciona",
      "title": "Quatro capítulos até se tornar Citizen",
      "free": "Gratuito para todos",
      "planOrSponsor": "Plano ou patrocínio",
      "basics": {
        "title": "Tudo começa pelos seus dados básicos",
        "body": "O seu CheckUp precisa de alguns dados sobre si — e um documento pode escrever a maioria por si.",
        "document": "Uma foto do passaporte ou do cartão de cidadão preenche a data de nascimento e a cidadania.",
        "import": "Um PDF do LinkedIn ou um CV preenche a experiência, a formação, as competências e os idiomas.",
        "check": "Nada é guardado sem a sua confirmação. Só escreve onde vive e o telefone.",
        "cta": "Adicionar os meus dados"
      },
      "checkup": {
        "title": "Um diagnóstico, não um questionário",
        "body": "Como um check-up médico para a sua mudança: a sua pontuação iQulture, pilar a pilar — o que está forte e o que trabalhar."
      },
      "teleportal": {
        "title": "A sua mudança, planeada ao dia",
        "body": "Cada passo do visto, documento e prazo da sua rota, com os documentos guardados no seu Vault."
      },
      "qultureup": {
        "title": "Conheça o país antes de chegar",
        "body": "Missões e mundos sobre a cultura, o trabalho e o dia a dia do seu destino. Ganhe milhas pelo caminho."
      },
      "care": {
        "label": "Care e Passport",
        "title": "Instale-se, e mostre-o",
        "body": "Check-ins que o mantêm bem depois de chegar, e um Passport que junta cada carimbo do seu percurso."
      }
    },
    "unlock": {
      "badge": "Desbloqueie todos os capítulos",
      "title": "O CheckUp é gratuito. O resto do percurso abre de duas formas.",
      "body": "TelePortal, QultureUp, Care e Passport abrem com um plano seu, ou quando uma empresa patrocina o seu percurso.",
      "plan": {
        "title": "Escolha um plano",
        "body": "Todos os capítulos do seu percurso abrem no momento em que escolhe.",
        "cta": "Ver planos"
      },
      "sponsor": {
        "title": "Seja patrocinado por uma empresa",
        "body": "As empresas que contratam no estrangeiro podem pagar todo o seu percurso. Quando uma o fizer, a oferta aparece aqui."
      }
    },
    "error": {
      "title": "Não foi possível carregar o início",
      "body": "Verifique a ligação e tente novamente."
    },
    "ready": {
      "chipInvited": "Convidado pela {{company}}",
      "chipSponsored": "Patrocinado pela {{company}}",
      "chipRoute": "O seu percurso · {{origin}} → {{destination}}",
      "title": "Olá, {{name}} — a sua mudança para {{country}} começa aqui.",
      "titleNoName": "A sua mudança para {{country}} começa aqui.",
      "titleNoCountry": "Olá, {{name}} — a sua mudança começa aqui.",
      "titleBare": "A sua mudança começa aqui.",
      "body": "Cinco passos até à sua pontuação iQulture — a sua preparação, pilar a pilar, e o que trabalhar a seguir. Cada capítulo da sua mudança é ajustado por ela.",
      "bodyWaiting": "Cinco passos até à sua pontuação iQulture. A {{company}} está à espera dela — e cada capítulo do seu percurso é ajustado por ela.",
      "bodyYours": "Cinco passos até à sua pontuação iQulture — é sua. Decide se a {{company}} a vê.",
      "stepsAria": "Cinco passos até à sua pontuação iQulture",
      "ofTotal": "de {{total}} feitos",
      "now": "Agora",
      "privacyShared": "A {{company}} vê a sua pontuação e a sua preparação — nunca as suas respostas.",
      "privacyOwn": "As suas respostas são suas. Ninguém vê a sua pontuação a menos que a partilhe.",
      "next": {
        "eyebrow": "O seu próximo passo",
        "whatIs": "O que é o CheckUp?",
        "parts": {
          "videos_watched": "Vídeos",
          "pitch_video": "O seu pitch",
          "language_tests": "Línguas",
          "motivational_answers": "Motivação",
          "assistant_chat": "Uma conversa curta"
        },
        "assessment": {
          "title": "Faça a avaliação CheckUp",
          "body": "Cinco partes curtas — cerca de 15 minutos. Pode parar e retomar onde ficou.",
          "cta": "Começar CheckUp"
        },
        "assessmentContinue": {
          "title": "Termine a avaliação CheckUp",
          "body": "{{done}} de {{total}} partes feitas. A seguir: {{part}}.",
          "cta": "Continuar CheckUp"
        },
        "essential": {
          "title_one": "Acrescente {{count}} dado para ter a sua pontuação",
          "title_other": "Acrescente {{count}} dados para ter a sua pontuação",
          "body": "{{items}} — menos de um minuto. As suas respostas estão guardadas; nada se perde.",
          "cta": "Acrescentar os dados"
        },
        "moreData": {
          "title": "Afine a sua pontuação",
          "body": "Competências, línguas e experiência — opcional, e cada uma conta.",
          "cta": "Importar LinkedIn ou CV"
        },
        "score": {
          "title": "Obtenha a sua pontuação iQulture",
          "titleShared": "Calcule a sua pontuação e envie-a à {{company}}",
          "body": "Um clique. A sua preparação, pilar a pilar — e o que trabalhar a seguir. Continua a ser sua, a menos que a partilhe.",
          "bodyShared": "Um clique. A {{company}} vê a sua pontuação e a sua preparação — nunca as suas respostas.",
          "cta": "Obter a minha pontuação",
          "ctaShared": "Calcular a minha pontuação"
        },
        "retry": {
          "title": "Tente o cálculo de novo",
          "body": "Algo correu mal do nosso lado. As suas respostas estão guardadas — não há nada a refazer.",
          "cta": "Calcular de novo",
          "bodyAiUnavailable": "A IA da Tonnie esteve temporariamente indisponível — não foi nada que tenha feito. As suas respostas estão guardadas — não há nada a refazer."
        },
        "calculating": {
          "title": "A sua pontuação está a ser calculada",
          "body": "Estamos a pesar as suas respostas, o seu pitch e as suas línguas. Pode sair — vai estar aqui quando voltar.",
          "status": "A calcular…",
          "cta": "Ver CheckUp"
        },
        "failed": {
          "title": "Não foi possível calcular a sua pontuação",
          "body": "Algo correu mal do nosso lado. Abra o seu CheckUp para retomar onde parou.",
          "cta": "Abrir CheckUp",
          "bodyAiUnavailable": "A IA da Tonnie esteve temporariamente indisponível — não foi nada que tenha feito. Abra o seu CheckUp para calcular de novo."
        }
      },
      "chapters": {
        "title": "O que se abre depois da sua pontuação",
        "body": "A sua pontuação iQulture ajusta cada capítulo da mudança a si.",
        "bodyPlan": "Tudo se abre com um plano, ou quando uma empresa patrocina o seu percurso.",
        "seePlans": "Ver planos",
        "bodySponsored": "Patrocinado pela {{company}} — todos os capítulos estão abertos.",
        "teleportal": "Cada tarefa da mudança — legal, viagem, instalação — por ordem.",
        "qultureup": "Conheça a cultura antes de chegar, um mundo de cada vez.",
        "care": "Apoio depois de chegar — check-ins de bem-estar e marcos.",
        "passport": "Cada marco do seu percurso, carimbado.",
        "open": "Aberto",
        "basic": "Básico · aberto agora",
        "locked": "Abre com um plano ou um patrocínio",
        "passportStatus_one": "{{count}} carimbo · {{miles}} milhas",
        "passportStatus_other": "{{count}} carimbos · {{miles}} milhas",
        "passportStamps_one": "{{count}} carimbo",
        "passportStamps_other": "{{count}} carimbos",
        "explore": "Explorar",
        "view": "Ver"
      },
      "latest": {
        "eyebrow": "Mais recente",
        "empty": "Os seus primeiros carimbos e milhas vão aparecer aqui."
      },
      "ask": {
        "title": "Dúvidas sobre o CheckUp?",
        "cta": "Perguntar à Tonnie"
      }
    },
    "phone": {
      "surface": {
        "phone": "No seu telemóvel",
        "computer": "Num computador",
        "either": "Telemóvel ou computador"
      },
      "emailLink": "Envie-me o link por e-mail",
      "shareLink": "Partilhar o link",
      "emailSent": "Enviámos-lhe o link por e-mail — abra-o no computador.",
      "emailHeld": "De momento não conseguimos enviar-lhe e-mails. Use «Partilhar o link» para o enviar a si próprio.",
      "emailFailed": "O e-mail não foi enviado. Tente novamente ou partilhe o link.",
      "next": {
        "assessment": {
          "title": "Faça a avaliação do CheckUp num computador",
          "body": "Cinco partes curtas — cerca de 15 minutos, com vídeo e o seu pitch, por isso foi feita para um ecrã maior. Pode parar e continuar onde ficou."
        },
        "assessmentContinue": {
          "title": "Termine a avaliação do CheckUp num computador"
        },
        "calculating": {
          "body": "Estamos a avaliar as suas respostas, o seu pitch e os seus idiomas. Enviamos-lhe uma notificação quando estiver pronto."
        },
        "score": {
          "body": "Um toque. A sua preparação, pilar a pilar — e no que trabalhar a seguir. É sua, a menos que a partilhe.",
          "bodyShared": "Um toque. A {{company}} vê a sua pontuação e preparação — nunca as suas respostas."
        }
      },
      "header": {
        "route": "{{origin}} → {{destination}}",
        "switchJourney": "Mudar de percurso. Atual: {{route}}"
      },
      "welcome": {
        "meta": "3 perguntas · no seu telemóvel"
      },
      "quickStart": {
        "eyebrow": "Já que está aqui",
        "title": "Adicione os seus dados básicos · 1 min",
        "body": "Uma fotografia do seu passaporte preenche a data de nascimento e a cidadania."
      },
      "meanwhile": {
        "title": "Entretanto, no seu telemóvel",
        "essential": {
          "title_one": "Adicione {{count}} dado de que a sua pontuação precisa",
          "title_other": "Adicione {{count}} dados de que a sua pontuação precisa",
          "body": "{{items}} · uma fotografia do passaporte preenche a maioria"
        }
      },
      "stepsTitle": "Os seus cinco passos",
      "steps": {
        "assessment": {
          "text": "Cinco partes curtas, cerca de 20 minutos — num computador. Enviamos-lhe o link por e-mail."
        },
        "score": {
          "text": "Um toque, quando os passos 2 e 3 estiverem feitos.",
          "textShared": "Um toque, quando os passos 2 e 3 estiverem feitos — e a {{company}} vê-a."
        }
      },
      "stepper": {
        "notStarted": "Não iniciado"
      }
    },
    "how": {
      "intro": {
        "eyebrow": "O seu companheiro",
        "title": "Tonnie, todos os dias da sua mudança",
        "body": "Dos primeiros planos até se instalar, a Tonnie acompanha-o — no telemóvel e na web."
      },
      "chapters": {
        "checkup": {
          "title": "Saiba onde está",
          "body": "A sua pontuação de preparação para a mudança e no que trabalhar a seguir. A avaliação é feita num computador; a sua pontuação vai consigo para todo o lado."
        },
        "teleportal": {
          "title": "A sua mudança, passo a passo",
          "body": "Acompanhe as suas tarefas e marcos da mudança e assinale-os à medida que avança."
        },
        "qultureup": {
          "title": "Sinta-se em casa mais depressa",
          "body": "Missões curtas para aprender a cultura, a língua e o dia a dia do seu destino."
        },
        "care": {
          "title": "Apoio quando precisa",
          "body": "Fale com a sua equipa de mudança — mensagens, pontos de situação e reuniões, tudo num só lugar."
        },
        "passport": {
          "title": "O seu progresso, carimbado",
          "body": "Ganhe carimbos e veja o quão longe já chegou no seu percurso de mudança."
        }
      },
      "title": "Como funciona a Tonnie",
      "start": {
        "title": "Tudo começa pelo seu percurso",
        "body": "Três perguntas — para onde vai, a sua situação, a sua família — e o seu percurso está pronto, no telemóvel ou na web. É ele que move tudo o que vem a seguir."
      }
    }
  },
  "profileImport": {
    "phone": {
      "source": {
        "subtitle": "Lemos a sua experiência, formação, competências e idiomas — confere-os antes de algo ser guardado.",
        "linkedin": "O seu perfil do LinkedIn, guardado como PDF.",
        "cv": "O seu CV — PDF, Word ou texto, até 10 MB."
      },
      "guide": {
        "title": "Obtenha o seu PDF do LinkedIn",
        "choose": "Escolher o PDF",
        "steps": {
          "computer": "Num computador, abra o seu perfil em linkedin.com",
          "save": "Escolha Mais e depois Guardar em PDF",
          "send": "Envie o PDF para este telemóvel — por email, Ficheiros ou iCloud",
          "choose": "Volte aqui e escolha-o"
        }
      },
      "review": {
        "privacy": "Nada é guardado até tocar em Guardar. O seu nome fica como está.",
        "save": "Guardar no meu perfil",
        "showAll": "Ver todos ({{count}})",
        "showLess": "Ver menos",
        "present": "Atual",
        "languageNoLevel_one": "{{names}}: o documento não indica o nível, por isso não é guardado — adicione-o no seu perfil.",
        "languageNoLevel_other": "{{names}}: o documento não indica o nível, por isso não são guardados — adicione-os no seu perfil."
      },
      "saved": {
        "title": "O seu perfil foi atualizado",
        "body": "A sua experiência, competências e idiomas tornam agora a sua pontuação mais precisa."
      },
      "saveFailed": "Não conseguimos guardar. Verifique a ligação e tente novamente."
    }
  },
  "profileQuality": {
    "calculate": {
      "anyway": "Calcular com o que tenho",
      "footnote": "Pode acrescentar detalhes e recalcular quando quiser."
    },
    "backTo": "Voltar a {{hero}}",
    "returnHint": "Cada detalhe que acrescentar aqui torna o {{hero}} mais preciso."
  },
  "checkupCard": {
    "status": {
      "answersDone": "Respostas completas"
    },
    "title": {
      "welcome": "A sua pontuação iQulture, em duas partes",
      "ready": "As suas respostas estão completas"
    },
    "subtitle": {
      "welcome": "A sua pontuação lê as suas respostas e o seu perfil em conjunto — quanto mais completos estiverem, mais precisa será.",
      "ready": "A sua pontuação lê-as em conjunto com o seu perfil. Acrescente o que falta para uma pontuação mais precisa, ou calcule já.",
      "readyComplete": "O seu perfil também está completo — a sua pontuação lê todos os detalhes."
    },
    "ring": {
      "caption": "a sua pontuação",
      "label": "A sua pontuação iQulture aparece aqui quando for calculada"
    },
    "next": {},
    "part": {
      "answers": "As suas respostas",
      "done": "Concluído",
      "profileRead": "A pontuação lê {{complete}} de {{total}} detalhes",
      "profileOptional": "Opcional — torna a pontuação mais precisa, e pode começar já.",
      "profileComplete": "Completo — a pontuação lê todos os detalhes."
    },
    "calculate": {
      "improveFirst": "Melhorar o meu perfil primeiro"
    },
    "basics": {
      "title": "A um passo da sua pontuação",
      "subtitle": "As suas respostas estão guardadas. Adicione os dados básicos para desbloquear o cálculo — e complete o perfil para a pontuação mais precisa.",
      "lockedHint": "Desbloqueia quando os dados básicos estiverem preenchidos.",
      "lockedLabel": "Calcular a minha pontuação — bloqueado até preencher os dados básicos"
    },
    "path": {
      "label": "O seu caminho até à pontuação",
      "answers": "As suas respostas",
      "answersState": "Concluído",
      "basics": "Dados básicos",
      "basicsState": "Obrigatório · {{complete}} de {{total}}",
      "profile": "Perfil completo",
      "profileState": "Recomendado · {{percent}}",
      "calculate": "A sua pontuação",
      "calculateState": "Bloqueado"
    },
    "required": {
      "eyebrow": "Obrigatório para calcular",
      "title_one": "Adicione {{count}} detalhe para desbloquear a pontuação",
      "title_other": "Adicione {{count}} detalhes para desbloquear a pontuação",
      "addField": "Adicionar {{field}}",
      "fastest": "Mais rápido: digitalize o seu passaporte — preenche {{items}} de uma vez."
    },
    "recommended": {
      "eyebrow": "Recomendado",
      "title": "Para a pontuação mais precisa",
      "body": "A sua pontuação lê {{complete}} de {{total}} detalhes do perfil. Cada um que acrescenta torna os pilares e as recomendações mais precisos."
    }
  },
  "heroStart": {
    "status": {
      "notStarted": "Por começar",
      "inProgress": "Em curso"
    },
    "next": {
      "eyebrow": "O seu próximo passo"
    },
    "part": {
      "profile": "O seu perfil",
      "addBasics": "Adicionar os dados básicos",
      "improve": "Melhorar o meu perfil"
    },
    "profileRead": "{{complete}} de {{total}} detalhes do perfil preenchidos",
    "profileComplete": "Completo — todos os detalhes estão preenchidos.",
    "teleportal": {
      "title": "O seu plano de mudança, em duas partes",
      "subtitle": "O TelePortal constrói o seu plano a partir da configuração e do seu perfil — quanto mais completos estiverem, mais precisas são as tarefas e os prazos.",
      "ringCaption": "o seu plano",
      "steps": "A sua configuração",
      "why": "A sua nacionalidade, residência e agregado definem o seu caminho de visto.",
      "optional": "Opcional — torna o seu plano mais preciso, e pode começar já."
    },
    "qultureup": {
      "title": "O seu percurso de aprendizagem, em duas partes",
      "subtitle": "O QultureUp ajusta o seu percurso à sua avaliação e ao seu perfil — quanto mais completos estiverem, mais se ajusta a si.",
      "ringCaption": "o seu percurso",
      "steps": "A sua avaliação",
      "why": "De onde é e onde vive definem o seu ponto de partida.",
      "optional": "Opcional — aproxima o percurso de si, e pode começar já."
    },
    "care": {
      "title": "Care, ao lado do seu percurso",
      "subtitle": "O Care começa com uma breve avaliação de como se está a adaptar. O seu perfil é a base que todo o percurso lê.",
      "ringCaption": "o seu cuidado",
      "steps": "A sua avaliação",
      "why": "A sua pontuação, o plano de mudança e o percurso de aprendizagem leem-no.",
      "optional": "Opcional — mantém todo o percurso exato, e pode começar já."
    },
    "inout": {
      "title": "InOut, para o seu título de residência",
      "subtitle": "Conta os dias que passa fora face aos limites do seu título e avisa-o a tempo. Quatro passos curtos para começar.",
      "ringCaption": "dias restantes",
      "steps": "A configuração",
      "why": "O InOut conta a partir do seu título e das suas viagens — o seu perfil não altera os números.",
      "optional": "Opcional para o InOut — mantém rigorosa o resto do seu percurso."
    }
  },
  "inout": {
    "start": {
      "cta": "Começar o InOut",
      "timeEstimate": "Cerca de 3 minutos",
      "titleStep": "O seu título",
      "titleStepDesc": "O título de residência que tem.",
      "tripsStep": "As suas viagens",
      "tripsStepDesc": "Cada vez que esteve fora desde que foi emitido.",
      "countryStep": "O seu país",
      "countryStepDesc": "O país do seu título de residência.",
      "datesStep": "As datas",
      "datesStepDesc": "Quando foi emitido e até quando é válido.",
      "recover": "Recuperar do histórico"
    },
    "page": {
      "title": "InOut",
      "subtitle": "Os seus dias fora do país de residência, contados face ao seu título.",
      "errorTitle": "Não conseguimos ler os seus contadores",
      "errorBody": "O seu registo está seguro. Tente novamente daqui a pouco.",
      "short": "Dias fora, contados"
    },
    "tabs": {
      "overview": "Resumo",
      "trips": "Viagens",
      "documents": "Documentos",
      "notices": "Avisos",
      "agency": "Assessoria",
      "limits": "Limites",
      "history": "Histórico"
    },
    "banner": {
      "away": "Fora",
      "inHost": "Em {{country}}",
      "noTitle": "Nenhum título em vigor hoje",
      "humanCheck": "O seu título segue regras próprias, que a assessoria ainda está a ler — uma pessoa verifica-o, por isso o InOut não mostra números.",
      "noBinding": "Nenhum limite se aplica hoje ao seu título.",
      "bindingUnresolved": "{{rule}} é o primeiro limite, mas ainda não sabemos como a lei se lê aqui — sem número até lá.",
      "daysStillNeeded": "dias de presença em falta",
      "noNumber": "ainda sem número",
      "hourglassLabel": "Ampulheta: restam {{left}} de {{limit}} dias",
      "daysLeft": "dias restantes",
      "toConfirmChip_one": "{{days}} dia por confirmar",
      "toConfirmChip_other": "{{days}} dias por confirmar",
      "otherSchengen_one": "Noutros países Schengen: até {{days}} dia",
      "otherSchengen_other": "Noutros países Schengen: até {{days}} dias",
      "noTitleOn": "Nenhum título em vigor a {{date}}",
      "noBindingOn": "Nenhum limite se aplicava ao seu título a {{date}}."
    },
    "answer": {
      "presenceNeeded_one": "Precisa de mais {{days}} dia em {{country}}",
      "presenceNeeded_other": "Precisa de mais {{days}} dias em {{country}}",
      "beyond": "{{rule}}: acima do limite",
      "unresolved": "Ainda sem número",
      "humanCheck": "Uma pessoa verifica o seu título",
      "headline": "{{rule}}: {{counted}}",
      "headlineAndFirst": "{{headline}}. {{first}}",
      "oneTrip_one": "Pode estar fora de {{country}} até {{days}} dia numa só viagem",
      "oneTrip_other": "Pode estar fora de {{country}} até {{days}} dias numa só viagem",
      "thisTrip_one": "Pode ficar fora de {{country}} mais {{days}} dia nesta viagem",
      "thisTrip_other": "Pode ficar fora de {{country}} mais {{days}} dias nesta viagem",
      "oneTripOutsideEu_one": "Pode estar fora da UE até {{days}} dia numa só viagem",
      "oneTripOutsideEu_other": "Pode estar fora da UE até {{days}} dias numa só viagem",
      "thisTripOutsideEu_one": "Pode ficar fora da UE mais {{days}} dia nesta viagem",
      "thisTripOutsideEu_other": "Pode ficar fora da UE mais {{days}} dias nesta viagem",
      "unit": {
        "oneTrip": "dias numa só viagem",
        "thisTrip": "dias a mais nesta viagem"
      },
      "short": {
        "oneTrip_one": "Pode estar fora até {{days}} dia",
        "oneTrip_other": "Pode estar fora até {{days}} dias",
        "thisTrip_one": "Pode ficar fora mais {{days}} dia",
        "thisTrip_other": "Pode ficar fora mais {{days}} dias"
      },
      "detail": {
        "oneTrip": "Numa só viagem fora de {{country}}, a partir de hoje, sem passar nenhum limite do seu título.",
        "thisTrip": "Nesta viagem, sem passar nenhum limite do seu título.",
        "oneTripOutsideEu": "Numa só viagem fora da UE, a partir de hoje, sem passar nenhum limite do seu título.",
        "thisTripOutsideEu": "Nesta viagem fora da UE, sem passar nenhum limite do seu título.",
        "oneTripFrom": "Numa só viagem fora de {{country}}, a partir de {{date}}, sem passar nenhum limite do seu título.",
        "oneTripOutsideEuFrom": "Numa só viagem fora da UE, a partir de {{date}}, sem passar nenhum limite do seu título.",
        "thisTripOn": "Na viagem em curso a {{date}}, sem passar nenhum limite do seu título.",
        "thisTripOutsideEuOn": "Na viagem fora da UE em curso a {{date}}, sem passar nenhum limite do seu título."
      }
    },
    "binding": {
      "alreadyReached": "{{rule}}: os dias que registou já ultrapassam o limite.",
      "mayBeReached": "{{rule}}: o limite pode ser ultrapassado se os dias por confirmar contarem.",
      "earliestExhaustion": "{{rule}} é o primeiro a chegar ao limite — a {{date}}, a este ritmo.",
      "leastRemaining": "{{rule}} é o mais perto do limite."
    },
    "switch": {
      "inHost": "Em {{country}}",
      "awaySince": "Fora desde {{date}}",
      "leave": "Saio hoje",
      "back": "Voltei hoje a {{country}}",
      "caption": "Um toque é um registo — pode corrigi-lo logo a seguir.",
      "confirm": {
        "leftTitle": "Está fora desde {{date}}",
        "leftBody": "Registado. Boa viagem.",
        "leftTo": "Registado — para {{country}}, como planeou. Boa viagem.",
        "undo": "Desfazer",
        "correct": "Corrigir",
        "done": "Concluído",
        "undone": "Desfeito — nada ficou registado.",
        "backTitle": "Bem-vindo de novo",
        "backBody_one": "Esteve fora de {{from}} a {{to}} — {{days}} dia.",
        "backBody_other": "Esteve fora de {{from}} a {{to}} — {{days}} dias.",
        "adjust": "Ajustar as datas",
        "yes": "Sim, está certo",
        "correctTitle": "Saiu noutro dia ou quer dizer para onde foi?",
        "correctHint": "A data e o destino ajustam-se aqui.",
        "undoTitle": "Tocou por engano?",
        "undoHint": "Nada fica registado.",
        "adjustTitle": "As datas foram outras?",
        "adjustHint": "Ajuste o dia em que saiu e o dia em que voltou.",
        "continuedTitle": "Saiu de novo hoje",
        "continuedBody": "A sua viagem de {{from}} continua — o dia de hoje já contava e conta uma só vez.",
        "undoContinuedHint": "A viagem volta a terminar hoje, como estava."
      }
    },
    "clocks": {
      "title": "Os seus limites",
      "humanCheck": "O seu título segue regras próprias, que a assessoria ainda está a ler. Uma pessoa verifica-o; entretanto, o InOut não mostra números.",
      "empty": "Nenhuma regra se aplica hoje ao seu título.",
      "disclaimer": "O InOut faz a aritmética do seu registo — nunca é um parecer jurídico. Para uma decisão, fale com a assessoria.",
      "emptyOn": "Nenhuma regra se aplicava ao seu título a {{date}}."
    },
    "clock": {
      "name": {
        "awayFromHost": "Dias fora de {{country}}",
        "outsideEu": "Dias fora da UE",
        "countedInHost": "Dias contados em {{country}}",
        "otherSchengen": "Dias noutros países Schengen",
        "eachTripFromHost": "Cada saída de {{country}}",
        "eachTripOutsideEu": "Cada saída da UE",
        "eachStayInHost": "Cada estadia em {{country}}",
        "eachStayOtherSchengen": "Cada estadia noutros países Schengen",
        "neededOutsideHost": "Dias necessários fora de {{country}}",
        "neededOutsideEu": "Dias necessários fora da UE",
        "neededInHost": "Dias necessários em {{country}}",
        "neededOtherSchengen": "Dias necessários noutros países Schengen",
        "unbrokenOutsideHost": "Tempo seguido necessário fora de {{country}}",
        "unbrokenOutsideEu": "Tempo seguido necessário fora da UE",
        "unbrokenInHost": "Tempo seguido necessário em {{country}}",
        "unbrokenOtherSchengen": "Tempo seguido necessário noutros países Schengen"
      },
      "window": "contados de {{from}} a {{to}}",
      "windowOpen": "contados desde {{from}}",
      "status": {
        "within": "Dentro do limite",
        "depends": "Depende de dias por confirmar",
        "beyond": "Acima do limite",
        "unresolved": "Em definição",
        "notApplicable": "Não se aplica"
      },
      "plannedBy": "Leitura mais estrita",
      "counted": "{{value}} de {{limit}} dias",
      "longestTrip": "A mais longa até agora: {{value}} de {{limit}} dias",
      "longestTripOn": "A mais longa até {{date}}: {{value}} de {{limit}} dias",
      "tripUpTo_one": "a partir de hoje, até {{days}} dia seguido fora",
      "tripUpTo_other": "a partir de hoje, até {{days}} dias seguidos fora",
      "left_one": "falta {{days}} dia",
      "left_other": "faltam {{days}} dias",
      "stillNeeded_one": "falta {{days}} dia de presença",
      "stillNeeded_other": "faltam {{days}} dias de presença",
      "margin_one": "±{{days}} dia ainda por confirmar — depende de si.",
      "margin_other": "±{{days}} dias ainda por confirmar — depende de si.",
      "settleMargin": "Confirmar",
      "exhaustsOn": "A este ritmo, o limite seria ultrapassado a {{date}}.",
      "riskZone": "Duas normas divergem entre {{from}} e {{to}} dias — uma zona de risco, não uma margem.",
      "inRiskZone": "Está nessa zona.",
      "noNumber": "Ainda sem número para esta regra.",
      "owner": {
        "agency": "A assessoria está a ler esta regra — não há nada a fazer da sua parte.",
        "tonnie": "A Tonnie está a fixar a leitura — não há nada a fazer da sua parte.",
        "user": "Só o próprio pode resolver isto — o CoPilot explica o que falta."
      },
      "consequence": {
        "mayCancel": "Acima dele, a lei permite o cancelamento do título.",
        "losesStatus": "Acima dele, a lei diz que o estatuto se perde.",
        "blocksAcquisition": "Acima dele, o tempo deixa de contar para um direito de longa duração.",
        "irregularStay": "Acima dele, a estadia nesses países fica irregular."
      },
      "info": "Sobre «{{rule}}»",
      "lawTitle": "O que diz a lei",
      "exceptionsTitle": "Exceções que a lei prevê",
      "exceptionTiming": "{{timing}} ({{source}})",
      "short": {
        "awayFromHost": "Dias fora",
        "outsideEu": "Fora da UE",
        "countedInHost": "Dias contados",
        "otherSchengen": "Schengen",
        "eachTripFromHost": "Cada saída",
        "eachTripOutsideEu": "Cada saída da UE",
        "eachStayInHost": "Cada estadia",
        "eachStayOtherSchengen": "Estadias Schengen",
        "neededOutsideHost": "Dias no estrangeiro",
        "neededOutsideEu": "Fora da UE",
        "neededInHost": "Dias cá",
        "neededOtherSchengen": "Dias Schengen",
        "unbrokenOutsideHost": "Tempo no estrangeiro",
        "unbrokenOutsideEu": "Tempo fora da UE",
        "unbrokenInHost": "Tempo cá",
        "unbrokenOtherSchengen": "Tempo Schengen"
      },
      "tripUpToFrom_one": "a partir de {{date}}, até {{days}} dia seguido fora",
      "tripUpToFrom_other": "a partir de {{date}}, até {{days}} dias seguidos fora",
      "marginOn_one": "±{{days}} dia por confirmar a {{date}}.",
      "marginOn_other": "±{{days}} dias por confirmar a {{date}}.",
      "exhaustsOnFrom": "Ao ritmo que tinha a {{asOf}}, o limite seria ultrapassado a {{date}}.",
      "inRiskZoneOn": "A {{date}} estava nessa zona."
    },
    "exceptions": {
      "timing": {
        "beforeDeparture": "a pedir antes de sair",
        "any": "pode ser pedida a qualquer momento"
      }
    },
    "precision": {
      "margin_one": "{{days}} dia que ninguém confirmou pode mudar um limite.",
      "margin_other": "{{days}} dias que ninguém confirmou podem mudar um limite.",
      "addTrip": "Acrescentar viagem",
      "answerQuestion": "Responder ao InOut",
      "title": "Dias por confirmar",
      "complete": "O seu registo está {{percent}} completo.",
      "checkTrip": "Ver as viagens",
      "reason": {
        "openQuestion": "A pergunta aberta do InOut é sobre estes dias.",
        "unanswered": "A pergunta destes dias fechou sem resposta — ainda pode acrescentar uma viagem desse período.",
        "wasAway": "Disse que esteve fora — falta acrescentar a viagem.",
        "notAskedYet": "Ainda nenhuma pergunta foi sobre estes dias — a próxima será.",
        "uncertainTrip": "Uma viagem cujas datas não são certas."
      }
    },
    "renewal": {
      "title": "Janela de renovação",
      "none": "O seu título não tem janela de renovação.",
      "window": "De {{opens}} a {{closes}}",
      "planTrips": "Planeie as viagens à volta dela — a renovação pede-se presencialmente."
    },
    "acquisition": {
      "title": "Rumo a um direito de longa duração",
      "subtitle": "Aquilo para que o seu tempo no país está a contar.",
      "status": {
        "accruing": "A contar",
        "complete": "Período completo",
        "depends": "Depende de dias por confirmar",
        "toleranceExceeded": "Ausências acima da tolerância",
        "unresolved": "Em definição",
        "notApplicable": "Não se aplica"
      },
      "completesOn": "O período ficaria completo a {{date}} se as tolerâncias se mantiverem.",
      "cumulative": "Ausências no total: {{value}} de {{tolerance}} dias tolerados",
      "consecutive": "Ausência mais longa: {{value}} de {{tolerance}} dias tolerados",
      "info": "Sobre «{{right}}»",
      "completeOn": "Completo a {{date}}",
      "progress_one": "{{done}} de {{total}} ano",
      "progress_other": "{{done}} de {{total}} anos"
    },
    "chronology": {
      "title": "As suas viagens",
      "subtitle": "Todas as vezes que esteve fora. Os dias que ninguém confirma ficam incertos — nunca contam como dias em que esteve cá.",
      "add": "Acrescentar viagem",
      "error": "Não conseguimos ler as suas viagens.",
      "short": "Todas as suas viagens",
      "group": {
        "now": "Agora",
        "done": "Feitas",
        "planned": "Planeadas"
      },
      "emptyTitle": "Ainda sem viagens",
      "emptyBody": "Use o interruptor quando sair, ou acrescente uma que já fez."
    },
    "absence": {
      "range": "{{from}} – {{to}}",
      "stillAway": "Desde {{from}} — ainda fora",
      "days_one": "{{days}} dia",
      "days_other": "{{days}} dias",
      "noDestination": "Destino não indicado",
      "bySwitch": "Registada com «Saio hoje»",
      "documents_one": "{{count}} documento",
      "documents_other": "{{count}} documentos",
      "edit": "Corrigir a viagem de {{from}}",
      "remove": "Remover a viagem de {{from}}",
      "addTitle": "Acrescentar uma viagem",
      "editTitle": "Corrigir uma viagem",
      "description": "O dia em que saiu e o dia em que voltou contam ambos como dias fora.",
      "departedOn": "Saída",
      "returnedOn": "Regresso",
      "stillAwayHint": "Ainda fora? Deixe a data de regresso em branco.",
      "destination": "Para onde foi",
      "destinationPlaceholder": "Escolha um país (opcional)",
      "destinationHint": "Algumas regras só contam certos países. Sem destino, esses dias ficam incertos.",
      "saved": "Viagem guardada.",
      "removeTitle": "Remover esta viagem?",
      "removeBody": "Só para uma viagem registada por engano: os dias deixam de contar e os documentos ficam no seu Cofre.",
      "removeConfirm": "Remover viagem",
      "removed": "Viagem removida.",
      "fromPassTitle": "Confirmar a viagem do cartão de embarque",
      "fromPassDescription": "Lemos estas datas e o destino do seu cartão. Confira-os e guarde.",
      "removeThis": "Remover esta viagem",
      "join": "Juntar numa só viagem",
      "joined": "Viagens juntas numa só."
    },
    "form": {
      "dateRequired": "Escolha as datas.",
      "dateInvalid": "Escreva uma data válida ou escolha-a no calendário.",
      "returnBeforeDeparture": "O regresso é antes da saída.",
      "pickDate": "Escolha uma data"
    },
    "planner": {
      "title": "Planear uma viagem",
      "subtitle": "Veja o que uma viagem faz aos seus limites antes de a marcar. Uma viagem planeada permite que o aviso chegue antes de sair.",
      "departsOn": "Saída",
      "returnsOn": "Regresso",
      "destination": "Para onde vai",
      "simulate": "Ver o efeito",
      "plan": "Planear",
      "planned": "Viagem planeada.",
      "onReturn": "No regresso, a {{date}}",
      "duringRenewalWindow": "Esta viagem cai na janela de renovação — a renovação pede-se presencialmente.",
      "outlastsTitle": "Voltaria depois de o seu título expirar.",
      "ahead": "Próximas viagens",
      "empty": "Nenhuma viagem planeada.",
      "listError": "Não conseguimos ler as viagens planeadas.",
      "remove": "Remover a viagem planeada de {{from}}",
      "removed": "Viagem planeada removida.",
      "now": "Hoje",
      "removeTitle": "Remover esta viagem planeada?",
      "removeBody": "Sai das viagens previstas e o InOut deixa de a lembrar.",
      "removeConfirm": "Remover viagem planeada",
      "limitMoved": "{{name}}: {{from}} → {{to}} de {{limit}} dias"
    },
    "timeline": {
      "title": "O seu registo no tempo",
      "window": "A janela de «{{rule}}», com as suas viagens",
      "today": "Hoje",
      "trip": "Viagem",
      "planned": "Planeada",
      "renewal": "Janela de renovação",
      "loadError": "Não foi possível ler as suas viagens planeadas, por isso a linha não é mostrada.",
      "away": "Ainda fora",
      "uncertain": "Dias por confirmar",
      "emptyWindow": "Ainda não há viagens na janela de {{from}} a {{to}}.",
      "empty": "Ainda não há viagens nesta janela — cada viagem que juntar aparece aqui."
    },
    "documents": {
      "title": "Documentos das suas viagens",
      "subtitle": "Os documentos de cada viagem: o que prova a viagem e o contexto da ausência.",
      "provisional": "Esta organização é provisória até a assessoria confirmar a lista.",
      "provisionalBadge": "Lista provisória",
      "scope": "Não lhe dizemos de que documentos precisa — isso é uma avaliação jurídica, feita pela assessoria. Nós guardamos, organizamos e entregamos.",
      "info": "Sobre estes documentos",
      "empty": "Ainda sem viagens — os documentos juntam-se a uma viagem.",
      "error": "Não conseguimos ler os seus documentos.",
      "none": "Sem documentos",
      "whatItIs": "O que é",
      "uploading": "A guardar…",
      "attached": "Documento junto à viagem.",
      "detach": "Retirar {{name}} desta viagem",
      "addTitle": "Adicionar um documento",
      "add": "Adicionar",
      "addDocument": "Adicionar documento",
      "whichDocument": "Que documento é?",
      "uploadingFile": "A guardar {{name}}…",
      "open": "Abrir {{item}} — {{name}}",
      "openError": "Não foi possível abrir este documento. Tente novamente.",
      "detached": "Documento retirado da viagem.",
      "short": "Provas de cada viagem",
      "reason": {
        "label": "Motivo da ausência",
        "none": "Sem motivo indicado",
        "info": "Sobre o motivo",
        "hint": "Fica no seu registo e no dossiê para a assessoria. Não altera a contagem dos dias."
      },
      "addToFamily": "Adicionar a «{{family}}» — a viagem de {{from}}",
      "undo": "Desfazer",
      "reattached": "Documento junto de novo à viagem.",
      "emptyTitle": "Ainda sem viagens",
      "emptyBody": "Os documentos juntam-se a uma viagem: acrescente a primeira.",
      "fromVaultDescription": "Para «{{family}}» — a viagem de {{from}}."
    },
    "notices": {
      "leadTimeTitle": "Avisar-me antes de um limite ser ultrapassado",
      "leadTimeWhy": "Tempo para pedir autorização prévia antes de sair — a lei pede-a antes da partida.",
      "leadTimeOption_one": "{{days}} dia antes",
      "leadTimeOption_other": "{{days}} dias antes",
      "cadenceTitle": "Perguntar-me se estive no país",
      "cadenceWhy": "Mantém o seu registo completo. Se não responder, nada se assume — esses dias ficam por confirmar.",
      "cadence": {
        "P15D": "De 15 em 15 dias",
        "P30D": "De 30 em 30 dias",
        "P1M": "Uma vez por mês",
        "OFF": "Nunca"
      },
      "channelsTitle": "Por onde chegam",
      "push": "Notificações push",
      "email": "Email",
      "error": "Não conseguimos ler os seus avisos.",
      "questionsError": "Não foi possível ler as perguntas do InOut.",
      "questionsTitle": "Perguntas do InOut",
      "questionsSubtitle": "Só perguntamos se esteve no país — nunca onde está.",
      "question": "Esteve em {{country}} todos os dias de {{from}} a {{to}}, fora as viagens que registou?",
      "answerInHost": "Sim, estive",
      "answerWasAway": "Não, estive fora",
      "wasAwayHint": "As datas perguntadas abrem uma viagem nova, pronta a guardar.",
      "questionWhy": "Sem resposta, estes dias ficam por confirmar — nunca contam como dias em que esteve cá.",
      "thanksInHost": "Obrigado — esses dias ficam confirmados.",
      "addTheTrip": "Disse-nos que esteve fora.",
      "noHistory": "Nenhuma pergunta anterior.",
      "whyLabel": "Porque é que isto importa",
      "confirmation": {
        "state": {
          "open": "À espera da sua resposta",
          "inHost": "Confirmou que esteve cá",
          "wasAway": "Disse que esteve fora",
          "noAnswer": "Sem resposta — dias por confirmar"
        }
      },
      "next": {
        "none": "Não há avisos à vista — o InOut avisa-o quando houver."
      },
      "upcomingTitle": "Próximos avisos",
      "upcomingSubtitle": "O que o InOut lhe vai enviar, e quando — pelas regras de {{country}} e pelas suas escolhas.",
      "upcoming": {
        "leadTime": "Aviso antes de um limite",
        "leadTimeDetail_one": "Com as viagens em curso e planeadas, «{{rule}}» chegaria ao limite a {{date}} — avisamos {{days}} dia antes.",
        "leadTimeDetail_other": "Com as viagens em curso e planeadas, «{{rule}}» chegaria ao limite a {{date}} — avisamos {{days}} dias antes.",
        "confirmation": "Pergunta de presença",
        "confirmationDetail": "Se esteve em {{country}} de {{from}} a {{to}} — sim ou não.",
        "renewalWindow": "Abre a janela de renovação",
        "renewalWindowDetail": "Pode pedir a renovação do seu título de {{from}} a {{to}}.",
        "inDays_one": "daqui a {{days}} dia",
        "inDays_other": "daqui a {{days}} dias"
      },
      "chip": {
        "app": "App",
        "push": "Push",
        "email": "Email"
      },
      "appChannel": "Na app",
      "appHint": "Aqui e no telemóvel.",
      "pushHint": "No telemóvel, mesmo com a app fechada.",
      "emailHint": "Para o email da sua conta.",
      "preferencesTitle": "As suas preferências",
      "preferencesSubtitle": "Cada escolha fica guardada logo.",
      "saving": "A guardar…",
      "savedShort": "Guardado",
      "recommended": "Recomendado",
      "cadenceOffNote": "Sem perguntas, os dias seguintes ficam por confirmar até os confirmar no Resumo.",
      "upToDate": "Está em dia",
      "noOpenQuestionNext": "Nenhuma pergunta à sua espera. A próxima chega a {{date}}.",
      "noOpenQuestionOff": "Nenhuma pergunta à sua espera — as perguntas estão desligadas.",
      "historyTitle": "Respostas anteriores",
      "seeTrips": "Ver as viagens",
      "leadTimeUnit_one": "dia antes",
      "leadTimeUnit_other": "dias antes",
      "always": "Sempre",
      "comesBy": "Chegam por",
      "screenSubtitle": "O que o InOut lhe perguntou, e o que vem a seguir"
    },
    "errors": {
      "overlap": "Partilha um dia com a sua viagem de {{from}} – {{to}}. Corrija uma delas.",
      "overlapOpen": "Já está fora desde {{from}}. Feche primeiro essa viagem.",
      "notSetUp": "Comece primeiro o InOut — as viagens contam face ao seu título.",
      "deactivated": "O seu InOut está em pausa — retome-o para voltar a registar viagens.",
      "caseOpen": "O InOut continua a correr enquanto o seu ticket com a assessoria estiver aberto.",
      "handoffNotFound": "Este cálculo expirou ou já foi usado — calcule de novo, demora um minuto.",
      "ruleValue": "Essa opção não é uma das do seu país.",
      "datesOutOfOrder": "As datas estão fora de ordem.",
      "notAway": "Essa viagem já está fechada.",
      "calculationRefused": "As regras do país mudaram desde o seu cálculo. Faça-o de novo na calculadora do InOut — ela lê as regras como estão agora.",
      "lastTitle": "O seu InOut precisa de um título de residência. Para recomeçar, comece um novo InOut.",
      "confirmationClosed": "Essa pergunta já está fechada.",
      "notFound": "Não encontrámos isso no seu registo.",
      "generic": "Algo correu mal. Tente novamente daqui a pouco.",
      "agencyUnavailable": "A assessoria do seu país ainda não aceita pedidos.",
      "consentRequired": "Aprove primeiro o que partilha com a assessoria.",
      "slotUnavailable": "Esse horário já não está livre. Escolha outro.",
      "tooCloseToMove": "Já está demasiado perto da consulta para a remarcar.",
      "notMovable": "Esta consulta não pode ser remarcada.",
      "requisitionExists": "Este ticket já tem a sua requisição.",
      "calendarUnavailable": "Não é possível aceder à agenda da assessoria neste momento.",
      "calendarAvailable": "A agenda da assessoria voltou a estar disponível — escolha um horário.",
      "fileNotLinkable": "Esse documento já não está no seu Cofre — escolha outro.",
      "aiUnavailable": "A calculadora do InOut não consegue responder neste momento. Tente novamente daqui a pouco — o seu registo está guardado.",
      "touches": "Começa ou acaba no dia da sua viagem de {{from}} – {{to}}. Junte-as numa só — esse dia conta uma vez.",
      "touchesOpen": "Acaba no dia em que começou a sua viagem ainda em curso, {{from}}. Junte-as numa só — esse dia conta uma vez.",
      "notJoinable": "Estas viagens já não se tocam num só dia — corrija as datas e guarde de novo.",
      "caseOpenChange": "O seu InOut fica como está enquanto o seu ticket com a assessoria estiver aberto — a assessoria trabalha sobre ele.",
      "recordInUse": "Este InOut pertence a um ticket com a assessoria — não pode ser apagado.",
      "notClosed": "Só um InOut do seu histórico pode ser recuperado ou apagado.",
      "noTitle": "Este InOut não tem nenhum título de residência — não pode voltar a ser o seu InOut. Comece antes um novo."
    },
    "setup": {
      "notServed": "O InOut ainda não conta dias para {{country}}.",
      "regimesError": "Não conseguimos ler as autorizações deste país.",
      "regime": "O título que tem",
      "regimeRequired": "Escolha o seu título.",
      "subtype": "Que tipo",
      "issuedOn": "Emitida a",
      "validUntil": "Válida até",
      "expiresBeforeIssued": "A validade é anterior à emissão."
    },
    "calculator": {
      "back": "Voltar",
      "poweredBy": "Powered by Tonnie",
      "name": "Calculadora de ausências",
      "stepOf": "Passo {{step}} de {{total}}",
      "stepAnnouncement": "{{step}}: {{title}}",
      "progress": "O seu progresso",
      "country": {
        "question": "Que país emitiu o seu título de residência?",
        "hint": "O InOut conta os seus dias pelas regras desse país.",
        "comingSoon": "Brevemente",
        "required": "Escolha o país."
      },
      "title": {
        "question": "Que título tem?",
        "hint": "Cada uma tem os seus próprios limites de tempo fora. O nome está no seu cartão.",
        "showAll_one": "Ver mais {{titles}} título",
        "showAll_other": "Ver mais {{titles}} títulos",
        "subtypeNone": "Escolha o tipo",
        "notSure": "Não tenho a certeza",
        "notSureHelp": "O tipo de título está impresso no seu cartão de residência. Ainda não tem cartão? Escolha o título que pediu — pode corrigi-lo no InOut mais tarde. Uma assessoria migratória regulada pode dizer-lhe qual se aplica."
      },
      "dates": {
        "question": "Quando foi emitida?",
        "hint": "As duas datas estão no seu cartão. Os seus dias contam a partir da data de emissão.",
        "issuedPlaceholder": "Escolha a data de emissão",
        "validPlaceholder": "Escolha a data de validade",
        "noEnd": "O meu título não tem data de validade",
        "noEndSet": "Sem data de validade."
      },
      "trips": {
        "question": "Quando esteve fora?",
        "hint": "Todas as viagens desde a emissão do título — o dia em que saiu e o dia em que voltou contam ambos.",
        "add": "Adicionar uma viagem",
        "none": "Não saiu do país? Então não há nada a acrescentar — veja já os seus dias.",
        "save": "Guardar viagem",
        "saveFirst": "Guarde ou cancele primeiro a viagem que está a escrever.",
        "calculate": "Ver os meus dias"
      },
      "result": {
        "title": "Os seus dias, contados",
        "subtitle": "Lidos pelo mesmo motor do InOut na Tonnie Citizen. Nada foi guardado.",
        "asOf": "À data de {{date}}",
        "startTitle": "Começar o InOut com isto",
        "startWhy": "O seu registo fica como o descreveu, e o InOut avisa-o antes de um limite. Pode alterá-lo a qualquer momento.",
        "start": "Começar o InOut",
        "uncertainBetween": "Não indicou se esteve cá entre as viagens, por isso esses dias contam como talvez fora.",
        "countRest": "Estive em {{country}}",
        "whatIfTitle": "E se eu viajar?",
        "whatIfSubtitle": "Experimente uma viagem antes de a reservar: os seus dias são lidos no dia em que voltaria. Nada é guardado.",
        "change": "Alterar as minhas respostas",
        "restart": "Recomeçar"
      },
      "dialogDescription": "Descreva o seu título de residência e as suas viagens; guardar a resposta começa o InOut com ela.",
      "discard": {
        "title": "Fechar a calculadora?",
        "body": "As suas respostas não ficam guardadas — ao fechar, perdem-se.",
        "confirm": "Fechar e descartar",
        "keep": "Continuar a responder",
        "restartTitle": "Recomeçar?",
        "restartBody": "As respostas que deu serão apagadas."
      }
    },
    "embed": {
      "language": "Idioma",
      "keepTitle": "Guarde-o na Tonnie e seja avisado antes de um limite",
      "keepWhy": "As suas respostas ficam neste browser até continuar. Ao continuar, são enviadas à Tonnie, que as guarda durante 72 horas para criar a sua conta e começar o InOut com elas.",
      "keep": "Continuar na Tonnie",
      "handedOffTitle": "Continue na Tonnie",
      "handedOffBody": "A Tonnie abriu num novo separador com o seu cálculo. Crie lá a sua conta para o guardar. A ligação funciona uma vez, durante 72 horas.",
      "blockedBody": "O seu browser não abriu um novo separador. Continue com o botão abaixo. A ligação funciona uma vez, durante 72 horas.",
      "continue": "Abrir a Tonnie",
      "unavailableTitle": "A calculadora não está disponível aqui",
      "unavailableBody": "Esta página não está configurada para mostrar a calculadora InOut.",
      "loadFailedTitle": "Não foi possível carregar a calculadora",
      "loadFailedBody": "Não foi possível contactar a Tonnie. Verifique a ligação e tente novamente."
    },
    "presence": {
      "restInHost": "No resto do tempo, estive em {{country}}",
      "restInHostHint": "Sem isto, os dias entre as suas viagens contam como talvez fora.",
      "title": "Os seus anos, dia a dia",
      "subtitle": "Cada dia do seu registo — para lá da janela de qualquer regra.",
      "here": "Em {{country}}",
      "away": "Fora",
      "travel": "Dia de viagem",
      "uncertain": "Por confirmar",
      "planned": "Planeado",
      "hereCount_one": "{{days}} dia em {{country}}",
      "hereCount_other": "{{days}} dias em {{country}}",
      "awayCount_one": "{{days}} dia fora",
      "awayCount_other": "{{days}} dias fora",
      "travelCount_one": "{{days}} dia de viagem",
      "travelCount_other": "{{days}} dias de viagem",
      "uncertainCount_one": "{{days}} dia por confirmar",
      "uncertainCount_other": "{{days}} dias por confirmar",
      "plannedCount_one": "{{days}} dia planeado",
      "plannedCount_other": "{{days}} dias planeados",
      "year": "{{year}}: {{summary}}",
      "travelNote": "Um dia de viagem — o dia em que sai ou regressa — conta como dizem as regras de {{country}}.",
      "loadError": "Não foi possível ler os seus dias ao longo dos anos."
    },
    "adopt": {
      "working": "A configurar o InOut com o seu cálculo…",
      "recorded": "O InOut está configurado com o seu cálculo.",
      "already": "O InOut já estava configurado — o seu registo mantém-se como está.",
      "refusedTitle": "Não foi possível usar o seu cálculo",
      "waitingTitle": "Um cálculo à espera",
      "waitingBody": "Calculou num portal parceiro e já tem um InOut. Fica como está — ou comece um novo InOut com este cálculo, e o atual vai para o seu histórico.",
      "keepMine": "Manter o meu InOut",
      "newWithIt": "Começar novo InOut com este cálculo",
      "newDone": "O seu novo InOut está a funcionar com o cálculo do portal — o anterior está no seu histórico."
    },
    "signup": {
      "titleFeminine": "Guarde o cálculo InOut que fez na {{portal}}",
      "titleMasculine": "Guarde o cálculo InOut que fez no {{portal}}",
      "description_one": "Guardámos o seu cálculo: {{count}} viagem. Crie a conta para o manter.",
      "description_other": "Guardámos o seu cálculo: {{count}} viagens. Crie a conta para o manter.",
      "descriptionAnswer": "{{answer}}. Crie a conta para guardar este cálculo.",
      "descriptionBeyond": "Um dos seus limites já foi ultrapassado. Crie a conta para guardar este cálculo e ver qual.",
      "goneTitle": "Essa ligação para o cálculo expirou",
      "goneDescription": "Funciona uma vez, durante 72 horas. Crie a sua conta — a calculadora do InOut está à distância de um toque lá dentro.",
      "unreadTitle": "O seu cálculo está guardado",
      "unreadDescription": "Não foi possível mostrá-lo agora, mas fica guardado: o InOut usa-o assim que a sua conta existir."
    },
    "phone": {
      "title": "Guarde o seu cálculo na app Tonnie",
      "body": "A app guarda-o, conta os seus dias e avisa-o antes de um limite. A ligação funciona uma vez, durante 72 horas.",
      "openApp": "Abrir na app",
      "installApp": "Instalar a app",
      "installHint": "Depois de instalar, abra a app nos 15 minutos seguintes: o seu cálculo vai com ela.",
      "goneBody": "Funciona uma vez, durante 72 horas. Na app Tonnie, a calculadora do InOut está à distância de um toque."
    },
    "keepCalculation": {
      "signUp": "Criar a minha conta",
      "signIn": "Já tenho conta"
    },
    "sharedDossier": {
      "title": "Dossiê de um ticket InOut",
      "body": "Uma pessoa partilhou o seu registo de residência com a sua assessoria para a requisição. O dossiê é gerado a partir do registo dela quando o descarregar.",
      "download": "Descarregar o dossiê (PDF)",
      "downloading": "A preparar o dossiê…",
      "failed": "Não foi possível descarregar o dossiê. Tente novamente daqui a pouco.",
      "unavailableTitle": "Esta ligação não pode ser aberta",
      "unavailableBody": "Pode ter expirado, ou a pessoa pode ter retirado o consentimento. Contacte a Tonnie se ainda precisar do dossiê."
    },
    "case": {
      "state": {
        "open": "Aberto",
        "inProgress": "Em curso",
        "closed": "Fechado"
      },
      "closedReason": {
        "completed": "Concluído",
        "withoutSubmission": "Fechado sem submissão"
      }
    },
    "consultation": {
      "state": {
        "pendingPayment": "A aguardar pagamento",
        "paid": "Paga — a marcar",
        "scheduled": "Marcada",
        "completed": "Realizada",
        "paymentReceivedRebook": "Paga — escolha outra hora",
        "cancelledByAgency": "Cancelada pela assessoria — marque de novo",
        "checkoutExpired": "Não paga"
      }
    },
    "requisition": {
      "state": {
        "pendingPayment": "A aguardar pagamento",
        "paid": "Paga — dossiê a caminho",
        "delivered": "Dossiê com a assessoria",
        "inProgress": "Em curso",
        "completed": "Concluída",
        "closedWithoutSubmission": "Fechada sem submissão",
        "checkoutExpired": "Não paga"
      },
      "stepsLabel": "Onde está a sua requisição",
      "step": {
        "delivered": "Dossiê entregue",
        "working": "A assessoria trata dele",
        "done": "Concluído",
        "closed": "Fechado"
      },
      "next": {
        "paid": "O seu dossiê está a ser preparado e enviado para a {{agency}}.",
        "delivered": "A {{agency}} tem o seu dossiê e contacta-o sobre o passo seguinte.",
        "inProgress": "A {{agency}} está a tratar do seu pedido e contacta-o se precisar de alguma coisa.",
        "completed": "A {{agency}} concluiu o seu pedido.",
        "closedWithoutSubmission": "A {{agency}} fechou o pedido sem o submeter. Se não esperava isto, contacte a {{agency}}."
      },
      "receives": "O que a {{agency}} recebe"
    },
    "refundRequest": {
      "state": {
        "requested": "Pedida",
        "handledExternally": "Tratada"
      }
    },
    "operations": {
      "eventSource": {
        "agencyFile": "Ficheiro da assessoria",
        "operator": "Registado pela Tonnie"
      },
      "files": {
        "state": {
          "previewed": "Verificado — pronto a carregar",
          "accepted": "Carregado",
          "rejected": "Recusado — nada carregado",
          "expired": "Expirado — verifique de novo"
        },
        "outcome": {
          "new": "Novo",
          "duplicate": "Já carregado",
          "error": "Com erro"
        }
      },
      "problem": {
        "emptyFile": "O ficheiro não tem eventos.",
        "headerMismatch": "O cabeçalho não é o formato v1.",
        "columnCount": "A linha não tem 7 colunas.",
        "unclosedQuote": "Há aspas por fechar.",
        "formatVersion": "Não é a versão 1 do formato.",
        "agencyMismatch": "Código de outra assessoria.",
        "eventIdMissing": "Sem id do evento.",
        "eventIdRepeated": "O id do evento repete-se no ficheiro.",
        "caseRefMissing": "Sem referência do ticket.",
        "eventCodeUnknown": "Um código de evento que o país não conhece.",
        "noteCodeUnknown": "Um código de nota que o país não conhece.",
        "occurredAtInvalid": "A data não está em ISO 8601 com o fuso.",
        "caseUnknown": "Nenhum ticket desta assessoria tem esta referência.",
        "caseClosed": "O ticket está fechado."
      }
    },
    "agency": {
      "purpose": {
        "consultation": "Consulta",
        "requisition": "Requisição"
      },
      "field": {
        "identity": "O seu nome e dados de identificação",
        "contact": "Como o contactar (email, telefone, fuso horário)",
        "title": "O seu título de residência e as suas datas",
        "absences": "As viagens ao estrangeiro que registou",
        "plannedTrips": "As viagens que planeou",
        "clocks": "As suas contagens de ausência, com a sua incerteza",
        "evidenceDocuments": "A lista dos documentos das suas viagens"
      },
      "consent": {
        "intro": "Finalidade: {{purpose}}. A {{agency}} recebe isto do seu registo InOut:",
        "fields": "O que é partilhado",
        "version": "Versão do texto {{version}}",
        "withdraw": "Pode retirar esta aprovação a qualquer momento neste separador; a partir daí nada mais é partilhado.",
        "approve": "Aprovo partilhar isto com a {{agency}}.",
        "submit": "Aprovar e continuar",
        "readFull": "Ler o texto completo"
      },
      "purchase": {
        "consultationTitle": "Consulta com a {{agency}}",
        "requisitionTitle": "Requisição pela {{agency}}",
        "price": "Preço",
        "credit": "Crédito das suas consultas",
        "toPay": "A pagar agora",
        "accept": "Li este aviso e aceito-o.",
        "pay": "Pagar {{amount}}",
        "confirmCredit": "Confirmar — coberto pelo seu crédito",
        "subtitle": "Prestado pela {{agency}} · pago aqui, em segurança",
        "stepsLabel": "Passos da compra",
        "steps": {
          "summary": "O serviço",
          "share": "Partilha",
          "billing": "Fatura",
          "pay": "Pagar"
        },
        "when": "{{date}} · {{from}}–{{to}}",
        "whenShort": "{{date}} · {{time}}",
        "summary": {
          "title": "O que está a comprar",
          "lead": "Confirme o serviço e o valor antes de continuar.",
          "changeTime": "Mudar a hora"
        },
        "share": {
          "title": "O que a {{agency}} recebe do seu registo",
          "leadConsultation": "Para a consulta, a {{agency}} precisa disto — e só disto.",
          "leadRequisition": "Para a requisição, a {{agency}} precisa disto — e só disto.",
          "standingTitle": "Já aprovou esta partilha",
          "standing": "Aprovada a {{date}} · versão {{version}} do texto. Nada muda — siga para o passo seguinte."
        },
        "billing": {
          "title": "Para quem é a fatura",
          "lead": "Cada pagamento tem a sua fatura-recibo. Diga-nos a quem a emitir — fica guardado para as próximas.",
          "leadSaved": "Cada pagamento tem a sua fatura-recibo, com estes dados.",
          "change": "Alterar",
          "incomplete": "Faltam dados para a fatura — complete-os para seguir para o pagamento."
        },
        "payStep": {
          "title": "Confirme e pague",
          "lead": "O resumo, o aviso da {{agency}} e o pagamento.",
          "service": "Serviço",
          "invoice": "Fatura",
          "amount": "A pagar",
          "vat": "IVA incluído",
          "withCredit": "Depois de {{credit}} de crédito",
          "after": "Depois de pagar",
          "afterConsultation": "A hora fica marcada no calendário da {{agency}} e a ligação da videochamada chega por email.",
          "afterRequisition": "A {{agency}} recebe o seu dossiê e contacta-o para começar.",
          "afterCase": "Acompanha tudo no seu ticket, no separador Assessoria.",
          "afterReceipt": "A fatura-recibo fica disponível na Faturação."
        },
        "secure": "Pagamento seguro com Stripe",
        "back": "Voltar",
        "next": "Continuar",
        "approveNext": "Aprovar e continuar",
        "saveNext": "Guardar e continuar"
      },
      "slots": {
        "previousWeek": "Semana anterior",
        "nextWeek": "Semana seguinte",
        "week": "{{from}} – {{to}}",
        "loadError": "Não foi possível carregar os horários livres.",
        "empty": "Sem horários livres nesta semana. Experimente a seguinte.",
        "pickDay": "Escolha um dia",
        "pickTime": "Escolha uma hora",
        "zone": "Horas no seu fuso horário: {{zone}}",
        "current": "a sua hora"
      },
      "contact": {
        "title": "A agenda da {{agency}} não está disponível agora",
        "body": "Peça à {{agency}} que o contacte: ela escreve-lhe para combinar um horário.",
        "request": "Pedir à {{agency}} que me contacte",
        "sent": "Enviado. A {{agency}} vai contactá-lo.",
        "alreadySent": "Já pediu hoje. A {{agency}} vai contactá-lo.",
        "consentTitle": "Antes de a {{agency}} o contactar",
        "consentDescription": "A {{agency}} recebe o que a consulta partilha, para a preparar."
      },
      "move": {
        "title": "Remarcar a consulta",
        "description": "Escolha outro horário livre. Uma consulta marcada pode ser remarcada até {{hours}} h antes.",
        "rebookTitle": "Escolha um novo horário",
        "rebookDescription": "O seu pagamento mantém-se — escolha outro horário livre, sem custo adicional.",
        "confirm": "Confirmar o novo horário",
        "done": "O novo horário está a ser marcado. A confirmação chega por email.",
        "current": "A sua consulta",
        "chosen": "Nova hora: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Escolha a nova hora."
      },
      "refund": {
        "title": "Pedir reembolso",
        "description": "Ticket {{caseRef}} com a {{agency}}.",
        "reason": "Porque está a pedir?",
        "chooseReason": "Escolha um motivo.",
        "handledBy": "A {{agency}} e a Tonnie tratam do pedido e escrevem-lhe.",
        "submit": "Enviar o pedido",
        "done": "Pedido enviado. Receberá resposta por email.",
        "paid": "O que pagou neste ticket",
        "paidConsultation": "Consulta de {{date}}",
        "paidRequisition": "Requisição"
      },
      "case": {
        "title": "O seu ticket com a {{agency}}",
        "opened": "Aberto a {{date}}",
        "movableUntil": "Pode ser remarcada até {{date}}",
        "join": "Entrar na reunião",
        "move": "Remarcar",
        "chooseTime": "Escolher horário",
        "credit": "Crédito para a requisição: {{amount}}",
        "requisition": "Requisição",
        "requisitionPaid": "Pago: {{amount}}",
        "continuePayment": "Continuar para o pagamento",
        "confirmingPayment": "A confirmar o seu pagamento…",
        "dossier": "Descarregar a sua cópia do dossiê",
        "dossierPreparing": "A preparar o dossiê…",
        "dossierFailed": "Não foi possível descarregar o dossiê. Tente de novo dentro de momentos.",
        "requisitionOffer": "A {{agency}} avalia a sua situação, prepara o pedido e submete-o.",
        "buyRequisition": "Pedir a requisição",
        "noRequisition": "Nenhuma requisição neste ticket.",
        "refunds": "Reembolsos",
        "askRefund": "Pedir reembolso",
        "consultations_one": "Consulta",
        "consultations_other": "Consultas",
        "creditTaken": "{{credit}} da consulta descontados",
        "toPay": "Por pagar",
        "refundsHint": "Se algo não correu como combinado, pode pedir reembolso à {{agency}} por um dos motivos previstos.",
        "refundAsked": "Pedido a {{date}} · {{reason}}",
        "next": {
          "label": "Próximo passo",
          "payRequisition": "A requisição espera o pagamento: {{amount}}",
          "chooseTime": "A consulta precisa de outra hora — o pagamento mantém-se.",
          "consultationBooked": "Consulta {{date}}, {{from}}–{{to}}",
          "consultationBooking": "A consulta está paga; a hora está a ser marcada.",
          "buyRequisition": "A requisição pode ser pedida: {{amount}}"
        }
      },
      "identity": {
        "byCountry": "A assessoria do InOut em {{country}}.",
        "legalName": "Denominação",
        "taxId": "NIF",
        "registry": "Registo",
        "address": "Morada",
        "dataProtection": "Contacto de proteção de dados",
        "dpa": "Acordo de tratamento de dados",
        "dpaValue": "{{reference}}, versão {{version}}",
        "website": "Visitar o site da assessoria",
        "about": "Sobre a {{agency}}",
        "addressValue": "{{line}}, {{postalCode}} {{city}}, {{country}}"
      },
      "offer": {
        "credited": "O preço é abatido na requisição do mesmo ticket.",
        "requisition": "Requisição",
        "buyRequisition": "Pedir a requisição",
        "bookConsultation": "Marcar uma consulta",
        "vatIncluded": "Preços com IVA incluído."
      },
      "consents": {
        "none": "Não partilhou nada com a assessoria.",
        "grantedOn": "Aprovado a {{date}} · versão {{version}} do texto",
        "revokedOn": "Retirado a {{date}}",
        "withdraw": "Retirar",
        "withdrawn": "Retirado. Nada mais é partilhado.",
        "confirmTitle": "Retirar esta aprovação?",
        "confirmConsultation": "A assessoria deixa de receber dados para consultas. Para marcar outra, volte a aprovar.",
        "confirmRequisition": "A assessoria deixa de receber dados, e a ligação do dossiê que tem deixa de abrir.",
        "titleWith": "O que partilha com a {{agency}}",
        "approvedState": "Aprovada",
        "withdrawnState": "Retirada",
        "fields": "O que é partilhado",
        "beforeNote": "Ao marcar uma consulta ou pedir a requisição, vê exatamente o que é partilhado antes de aprovar."
      },
      "booking": {
        "title": "Marcar uma consulta com a {{agency}}",
        "online": "Os horários vêm da agenda da própria assessoria. A reunião é online; a ligação chega por email e aparece no seu ticket depois de marcada.",
        "continue": "Continuar",
        "chosen": "Escolheu: {{date}}, {{from}}–{{to}}",
        "chooseTime": "Escolha uma hora para continuar."
      },
      "checkout": {
        "success": "Pagamento recebido. O seu ticket, abaixo, mostra o que acontece a seguir.",
        "cancelled": "Pagamento cancelado. Nada foi cobrado."
      },
      "requisition": {
        "paidByCredit": "Pago com o seu crédito. A assessoria recebe o seu dossiê."
      },
      "loadError": "Não foi possível carregar a assessoria.",
      "casesError": "Não foi possível carregar os seus tickets.",
      "notReady": {
        "title": "A assessoria do seu país ainda não está pronta",
        "body": "Os termos de proteção de dados ainda estão a ser concluídos. Até lá nada é partilhado com ela e nada pode ser comprado."
      },
      "storefront": {
        "eyebrow": "A sua assessoria migratória em {{country}}",
        "title": "Leve a sua situação à {{agency}}, com o seu registo já pronto.",
        "lead": "Uma consulta online para saber o que fazer, ou a requisição completa: a {{agency}} avalia a sua situação, prepara e submete o pedido e acompanha-o até à decisão.",
        "trustDossier": "O seu registo do InOut, entregue em dossiê",
        "trustVat": "Preços com IVA incluído",
        "once": "pagamento único",
        "complete": "o processo completo",
        "closeCalendar": "Fechar o calendário",
        "consultation": {
          "meeting": "Uma reunião com a {{agency}} sobre a sua situação",
          "record": "A {{agency}} recebe antes o seu registo — não começa do zero",
          "movable": "Pode ser mudada até {{hours}} h antes",
          "credited": "O preço é abatido na requisição do mesmo ticket"
        },
        "requisition": {
          "tag": "Tudo tratado pela {{agency}}",
          "assess": "A {{agency}} avalia a sua situação",
          "submit": "Prepara e submete o pedido por si",
          "follow": "Acompanha-o até à decisão",
          "dossier": "O seu registo e os seus documentos seguem em dossiê",
          "inCase": "Tem um ticket aberto — a requisição pede-se nele.",
          "showCase": "Ver o seu ticket",
          "unreadable": "Não conseguimos ler os seus tickets — tente de novo acima."
        }
      },
      "how": {
        "title": "Como funciona",
        "choose": "Escolha e pague aqui",
        "chooseBody": "A consulta ou a requisição, com pagamento seguro e fatura em seu nome.",
        "share": "Aprove a partilha do seu registo",
        "shareBody": "Só o que cada serviço precisa. Pode retirar a aprovação quando quiser.",
        "firm": "A {{agency}} trata consigo",
        "firmBody": "Na consulta, à hora marcada; na requisição, do pedido até à decisão."
      },
      "providers": {
        "title": "Quem presta o serviço",
        "firm": "A {{agency}} presta a consulta e a requisição",
        "firmBody": "Sociedade regulada, sob a sua própria responsabilidade profissional: a avaliação jurídica e o pedido são seus.",
        "tonnie": "A Tonnie guarda o seu registo",
        "tonnieBody": "Conta os seus dias, organiza os seus documentos e entrega-os à {{agency}} — com a sua aprovação."
      }
    },
    "mobile": {
      "setupOnWeb": "Começar o InOut no Citizen Web",
      "setupOnWebDesc": "A calculadora abre lá; guarde a resposta para começar o InOut. Depois, o interruptor, os prazos e as perguntas do InOut também ficam aqui.",
      "calculatorErrorTitle": "A calculadora não abriu",
      "calculatorErrorBody": "Verifique a sua ligação e tente novamente.",
      "noticesLink": "Perguntas e avisos",
      "agencyOnWeb": "A assessoria, no Citizen Web",
      "agencyOnWebDesc": "As consultas, a requisição e os seus tickets com a assessoria estão no Citizen Web — a app não vende.",
      "answer": "Responder",
      "sourceCamera": "Tirar foto",
      "sourceLibrary": "Das fotos",
      "sourceFiles": "Dos ficheiros",
      "cameraTitle": "Acesso à câmara",
      "cameraMessage": "Para fotografar um documento da sua viagem, permita que a Tonnie use a câmara nas definições do telemóvel.",
      "pickerUnavailableTitle": "Não é possível abrir os seus documentos",
      "pickerUnavailableMessage": "Tente de novo ou escolha o documento de outra forma.",
      "pauseConfirmBody": "O InOut guarda tudo como está, mas não conta nem pergunta nada. O seu separador sai da aplicação até o retomar nas Definições.",
      "titleOnWebDesc": "Corrija-o, ou junte o cartão renovado — no Citizen Web.",
      "newOnWebDesc": "Comece um novo InOut a partir de um cálculo novo — no Citizen Web. O seu InOut atual vai para o histórico; nada se apaga.",
      "historySubtitle": "Todos os InOuts que guarda"
    },
    "paused": {
      "title": "O InOut está em pausa",
      "body": "Em pausa desde {{date}}. O seu título, as suas viagens e os seus documentos ficam como estavam, mas o InOut não conta nem pergunta nada até o retomar.",
      "resume": "Retomar o InOut",
      "resumed": "O InOut voltou a funcionar.",
      "failed": "Não foi possível retomar o InOut. Tente novamente.",
      "history": "O seu histórico do InOut"
    },
    "menu": {
      "label": "Opções do InOut",
      "title": "Atualizar o meu título",
      "pause": "Pausar o InOut",
      "new": "Novo InOut",
      "close": "Encerrar o InOut"
    },
    "titleDialog": {
      "title": "Atualizar o meu título",
      "description": "O país mantém-se. Outro país é um InOut novo.",
      "renewed": "Recebi um cartão novo",
      "renewedHint": "Fica no lugar do atual; os seus dias contam nos dois.",
      "saved": "O seu título foi atualizado.",
      "correct": "Corrigir o atual",
      "correctHint": "Está diferente do que diz o cartão."
    },
    "pause": {
      "confirmTitle": "Pausar o InOut?",
      "confirmBody": "O InOut guarda tudo como está, mas não conta nem pergunta nada até o retomar aqui.",
      "confirm": "Pausar o InOut",
      "done": "O InOut está em pausa.",
      "caseOpenTitle": "O InOut continua a correr",
      "caseOpenBody": "A assessoria trabalha sobre o seu registo enquanto o ticket estiver aberto, por isso o InOut não pode parar agora.",
      "caseOpenLead": "Pode pausá-lo quando o ticket fechar."
    },
    "askBefore": {
      "title": "Peça-a antes de sair",
      "body": "Para uma ausência como esta, a lei prevê “{{exception}}” — pede-se antes de sair. Não damos parecer jurídico: o CoPilot explica o que implica, e a assessoria pode aconselhá-lo.",
      "askCoPilot": "Perguntar ao CoPilot",
      "agency": "Falar com a assessoria",
      "questionNext": "Preciso de pedir “{{exception}}” antes da minha próxima viagem?",
      "questionTrip": "Antes da minha viagem de {{from}} a {{to}}, preciso de pedir “{{exception}}”?"
    },
    "shortStay": {
      "open": "Como se aplica a si o 90/180",
      "title": "A regra dos 90/180 — onde se aplica a si",
      "lead": "O que ouviu sobre 90 dias em cada 180 aplica-se a si — mas não em {{country}}.",
      "where": "Onde está",
      "away": "Conta como fora de {{country}}",
      "shortStay": "Conta para os 90/180",
      "inHost": "Em {{country}}",
      "otherSchengen": "Noutro país Schengen",
      "outsideSchengen": "Fora do espaço Schengen",
      "yes": "Sim",
      "no": "Não",
      "twice": "Um dia noutro país Schengen conta duas vezes: como dia fora de {{country}} e para os 90 dias em cada 180 desse espaço. O InOut conta os dois.",
      "calculator": "A calculadora de estadas de curta duração da UE é para visitantes. Ela própria o diz: quem tem um título de residência não está sujeito a ela, nem deve introduzir lá as suas estadas.",
      "source": "Artigo 21.º da Convenção de Aplicação do Acordo de Schengen",
      "today": "Hoje: {{figures}}",
      "youAreHere": "Está aqui",
      "on": "A {{date}}: {{figures}}",
      "youWereHere": "Onde estava a {{date}}"
    },
    "severity": {
      "title": "Nível de alerta",
      "subtitle": "Onde o seu registo está hoje, de informativo a urgente.",
      "ladder": "Nível {{rank}} de {{total}}: {{level}}",
      "level": {
        "informative": "Informativo",
        "attention": "Atenção",
        "potentialRisk": "Risco potencial",
        "professionalReview": "Revisão profissional recomendada",
        "urgent": "Urgente"
      },
      "informative": "Nada precisa de si agora. O InOut continua a contar e avisa-o com antecedência.",
      "uncertainDays_one": "{{days}} dia do seu registo ainda está por confirmar — até lá, os seus números são menos precisos.",
      "uncertainDays_other": "{{days}} dias do seu registo ainda estão por confirmar — até lá, os seus números são menos precisos.",
      "renewalWindow": "A janela para renovar o seu título está aberta.",
      "riskZone": "Está na faixa em que duas leituras de «{{rule}}» não coincidem.",
      "dependsOnUncertain": "Se «{{rule}}» fica dentro do limite depende de dias ainda por confirmar.",
      "nearLimit": "«{{rule}}» está perto do limite.",
      "passing": "As suas viagens levariam «{{rule}}» ao limite a {{date}}.",
      "passingException": "{{exception}} pode ser feito antes de sair — a assessoria pode prepará-lo.",
      "passingAgency": "A assessoria pode analisar isto consigo antes de ir.",
      "urgent": "«{{rule}}» passou o limite. Isso não quer dizer que a sua residência esteja perdida: a lei prevê respostas, com audiência prévia. A assessoria pode ajudar.",
      "daysLeft_one": "Resta {{days}} dia",
      "daysLeft_other": "Restam {{days}} dias",
      "untilCloses_one": "{{days}} dia até fechar",
      "untilCloses_other": "{{days}} dias até fechar",
      "toAct_one": "{{days}} dia para agir",
      "toAct_other": "{{days}} dias para agir",
      "action": {
        "agency": "Falar com a assessoria",
        "confirmDays": "Confirmar os dias",
        "limits": "Ver os seus limites",
        "renewal": "Ver a renovação"
      }
    },
    "export": {
      "title": "O seu registo, pronto para uma auditoria",
      "body": "Os seus títulos, as suas viagens, as viagens que planeia, os seus limites e os seus documentos num só PDF — seu, para guardar ou entregar a quem o pedir.",
      "download": "Descarregar o seu registo (PDF)",
      "failed": "Não foi possível descarregar o seu registo. Tente de novo.",
      "onWeb": "Descarregar o seu registo",
      "onWebDesc": "O seu registo em PDF descarrega-se no Citizen Web."
    },
    "boardingPass": {
      "add": "A partir de um cartão de embarque",
      "hint": "Uma fotografia do cartão, ou o PDF da companhia aérea: a viagem é lida a partir dele, para confirmar, e o cartão fica guardado como prova.",
      "elsewhere": "Este voo vai de {{from}} para {{to}} — não é uma viagem de entrada ou saída do seu país de residência, por isso nada foi registado.",
      "proofNotKept": "A viagem foi guardada, mas não foi possível guardar o cartão de embarque. Adicione-o em Documentos.",
      "failed": {
        "notBoardingPass": "Isso não é um cartão de embarque. Fotografe o próprio cartão.",
        "unreadable": "Não foi possível ler o voo. Tente uma fotografia mais nítida, com a data e os aeroportos à vista.",
        "unsupported": "Esse ficheiro não pode ser lido. Use uma fotografia ou um PDF.",
        "tooLarge": "Esse ficheiro é demasiado grande. Use uma fotografia mais pequena.",
        "unavailable": "De momento não é possível ler cartões de embarque. Tente daqui a pouco ou registe a viagem à mão.",
        "generic": "Não foi possível ler o cartão de embarque. Tente de novo."
      },
      "fromFile": "Uma foto ou um ficheiro",
      "fromVaultDescription": "Um cartão de embarque que já guarda — lido na viagem que é."
    },
    "summary": {
      "detail": "Ver o detalhe",
      "perTrip": "até {{limit}} dias seguidos em cada saída",
      "unit": {
        "total": "dias",
        "eachTrip": "dias seguidos",
        "needed": "dias em falta"
      }
    },
    "offer": {
      "subtitle": "A sua assessoria migratória",
      "title": {
        "calm": "Tenha a certeza antes de sair",
        "review": "Fale com a assessoria antes de partir",
        "urgent": "A assessoria pode ajudar já"
      },
      "body": {
        "calm": "O InOut conta os seus dias; a {{agency}} diz-lhe o que fazer com eles.",
        "review": "As suas viagens aproximam-se de um limite: veja com a {{agency}} o que fazer antes de partir.",
        "urgent": "Um limite foi ultrapassado. Isso não quer dizer que perdeu a residência: a {{agency}} prepara a resposta que a lei prevê."
      },
      "case": {
        "title": "O seu ticket com a {{agency}}",
        "body": "O Ticket {{caseRef}} está em curso.",
        "open": "Ver o ticket"
      },
      "consultationTitle": "Consulta online",
      "consultationMeta": "{{minutes}} min · por videochamada",
      "nextSlot": "Próxima vaga: {{date}} · {{time}}",
      "requisitionMeta": "Preparada e submetida pela {{agency}}",
      "regulated": "Sociedade regulada"
    },
    "milestones": {
      "label": "O que vem a seguir",
      "renewal": "Renovação a partir de {{date}}",
      "acquisition": "{{name}} a {{date}}",
      "planTrip": "Planear uma viagem",
      "title": "Os seus marcos",
      "subtitle": "Renovação e direitos de longa duração"
    },
    "stage": {
      "inHost": "Em Portugal",
      "away": "Fora de Portugal",
      "tapToLeave": "Toque no círculo ao sair",
      "tapToReturn": "Desde {{date}} · toque ao voltar",
      "mine": "O meu InOut",
      "noNumber": "ainda sem número",
      "unit": {
        "days": "dias"
      },
      "leftNotice": "Saída registada a {{date}}",
      "backNotice_one": "Regresso registado — {{days}} dia fora",
      "backNotice_other": "Regresso registado — {{days}} dias fora",
      "attention": {
        "beyond": "acima do limite",
        "daysLeft_one": "falta {{days}} dia",
        "daysLeft_other": "faltam {{days}} dias",
        "check": "a verificar",
        "questions": "Por responder",
        "questionCount_one": "{{questions}} pergunta",
        "questionCount_other": "{{questions}} perguntas",
        "toConfirm": "Dias por confirmar",
        "days_one": "{{days}} dia",
        "days_other": "{{days}} dias",
        "none": "Tudo em dia",
        "unread": "Não conseguimos ler os seus avisos"
      },
      "upTo_one": "até {{days}} dia",
      "upTo_other": "até {{days}} dias",
      "upToInARow_one": "até {{days}} dia seguido",
      "upToInARow_other": "até {{days}} dias seguidos",
      "continuedNotice": "Saiu de novo — a viagem de hoje continua"
    },
    "help": {
      "title": "Pedir ajuda",
      "description": "Pergunte já, ou fale com quem decide.",
      "copilot": "Perguntar ao CoPilot",
      "copilotHint": "Responde já, a qualquer hora, sobre o seu registo.",
      "agency": "Falar com a assessoria",
      "agencyHint": "Uma consulta com quem decide, no Citizen Web."
    },
    "hub": {
      "subtitle": "Tudo num só lugar",
      "titleOverline": "O seu título",
      "where": "Onde está",
      "validUntil": "Válido até",
      "renewalFrom": "Renovação a partir de",
      "all": "Tudo sobre o seu InOut",
      "manage": "Gerir",
      "onWeb": "No Citizen Web",
      "agency": "A assessoria",
      "documents": "Documentos",
      "planned_one": "{{count}} planeada",
      "planned_other": "{{count}} planeadas"
    },
    "limits": {
      "title": "Os seus limites",
      "subtitle": "Uma regra de cada vez",
      "unit": {
        "left": "dias que ainda pode estar fora",
        "inARow": "dias seguidos, a partir de hoje",
        "needed": "dias que ainda faltam no país"
      },
      "others": "Outras regras",
      "why": {
        "title_one": "Porque uma viagem pode durar {{days}} dia e não {{other}}",
        "title_other": "Porque uma viagem pode durar {{days}} dias e não {{other}}",
        "byTotal_one": "Numa viagem conta o mais curto dos dois limites. Hoje é o total: resta-lhe {{left}} dia dos {{limit}}.",
        "byTotal_other": "Numa viagem conta o mais curto dos dois limites. Hoje é o total: restam-lhe {{left}} dias dos {{limit}}.",
        "byInARow_one": "Numa viagem conta o mais curto dos dois limites. Hoje é o de seguidos: uma viagem fora de {{country}} não pode passar de {{limit}} dia.",
        "byInARow_other": "Numa viagem conta o mais curto dos dois limites. Hoje é o de seguidos: uma viagem fora de {{country}} não pode passar dos {{limit}} dias.",
        "titleFrom_one": "Porque uma viagem a partir de {{date}} podia durar {{days}} dia e não {{other}}",
        "titleFrom_other": "Porque uma viagem a partir de {{date}} podia durar {{days}} dias e não {{other}}",
        "byTotalOn_one": "Numa viagem conta o mais curto dos dois limites. A {{date}} era o total: restava {{left}} dia dos {{limit}}.",
        "byTotalOn_other": "Numa viagem conta o mais curto dos dois limites. A {{date}} era o total: restavam {{left}} dias dos {{limit}}.",
        "byInARowOn_one": "Numa viagem conta o mais curto dos dois limites. A {{date}} era o de seguidos: uma viagem fora de {{country}} não podia passar de {{limit}} dia.",
        "byInARowOn_other": "Numa viagem conta o mais curto dos dois limites. A {{date}} era o de seguidos: uma viagem fora de {{country}} não podia passar dos {{limit}} dias."
      },
      "line": {
        "today": "hoje",
        "away": "dias fora",
        "toConfirm": "por confirmar",
        "closed": "encerrado"
      },
      "run_one": "{{from}} – {{to}} · {{days}} dia",
      "run_other": "{{from}} – {{to}} · {{days}} dias",
      "trips": {
        "thisTrip_one": "Esta viagem, desde {{from}} · {{days}} dia",
        "thisTrip_other": "Esta viagem, desde {{from}} · {{days}} dias",
        "next_one": "A próxima viagem: até {{days}} dia — o total atinge o limite antes dos {{limit}}",
        "next_other": "A próxima viagem: até {{days}} dias — o total atinge o limite antes dos {{limit}}",
        "none": "Ainda nenhuma viagem contou.",
        "thisTripOn_one": "A viagem em curso a {{date}}, desde {{from}} · {{days}} dia",
        "thisTripOn_other": "A viagem em curso a {{date}}, desde {{from}} · {{days}} dias",
        "nextFrom_one": "Uma viagem a partir de {{date}}: até {{days}} dia — o total atinge o limite antes dos {{limit}}",
        "nextFrom_other": "Uma viagem a partir de {{date}}: até {{days}} dias — o total atinge o limite antes dos {{limit}}"
      }
    },
    "trips": {
      "passHint": "Fotografe-o: a viagem é lida e a fotografia fica como prova.",
      "tab": {
        "trips": "Viagens",
        "record": "Registo"
      },
      "count_one": "{{count}} viagem",
      "count_other": "{{count}} viagens",
      "yearHeading": "{{year}} · {{trips}}"
    },
    "duration": {
      "days_one": "{{value}} dia",
      "days_other": "{{value}} dias",
      "months_one": "{{value}} mês",
      "months_other": "{{value}} meses",
      "years_one": "{{value}} ano",
      "years_other": "{{value}} anos"
    },
    "meter": {
      "title": "Os limites de ausência do seu título",
      "name": {
        "inTotal": "No total",
        "inARow": "Seguidos",
        "outsideEuInTotal": "Fora da UE, no total",
        "outsideEuInARow": "Fora da UE, seguidos"
      },
      "detail": {
        "perTrip": "{{limit}} por viagem",
        "perTripRolling": "{{limit}} por viagem, em qualquer período de {{window}}",
        "perTripCalendarYear": "{{limit}} por viagem, em cada ano civil",
        "perTripFromIssue": "{{limit}} por viagem, nos primeiros {{window}}",
        "total": "{{limit}}",
        "totalPermit": "{{limit}} no título",
        "totalPermitAndRenewals": "{{limit}} no título e nas renovações",
        "totalRolling": "{{limit}} em qualquer período de {{window}}",
        "totalCalendarYear": "{{limit}} em cada ano civil",
        "totalFromIssue": "{{limit}} nos primeiros {{window}}"
      },
      "fraction": "{{taken}} / {{limit}}",
      "valueText": "{{taken}} de {{limit}} dias, restam {{left}}",
      "definesAnswer": "Define a sua resposta"
    },
    "holds": {
      "trips": "Viagens",
      "planned": "Viagens planeadas",
      "documents": "Documentos anexados",
      "daysAway_one": "{{days}} dia fora",
      "daysAway_other": "{{days}} dias fora"
    },
    "newRecord": {
      "confirmTitle": "Começar um novo InOut?",
      "confirmBody": "O seu InOut atual vai para o histórico com tudo o que guarda — nada se apaga, e pode torná-lo principal de novo quando quiser.",
      "confirm": "Começar um novo InOut",
      "holdsLabel": "O que vai para o histórico",
      "keepTitle": "Começar um novo InOut com isto",
      "keepWhy": "Isto passa a ser o seu InOut: o título, as viagens e o tempo no país, como os acabou de descrever. O atual vai para o seu histórico.",
      "keep": "Começar novo InOut",
      "done": "O seu novo InOut está a funcionar — o anterior está no seu histórico."
    },
    "recordCase": {
      "title": "O seu InOut fica como está",
      "body": "A assessoria trabalha sobre este InOut enquanto o seu ticket estiver aberto, por isso não pode ir para o histórico agora.",
      "leadNew": "Pode começar um novo InOut quando o ticket fechar.",
      "leadClose": "Pode encerrá-lo quando o ticket fechar."
    },
    "close": {
      "confirmTitle": "Encerrar o InOut?",
      "confirmBody": "O seu InOut vai para o histórico com tudo o que guarda — nada se apaga. O InOut não conta nem envia avisos até começar um novo ou tornar principal um do histórico.",
      "confirm": "Encerrar o InOut",
      "done": "O seu InOut está encerrado e guardado no histórico."
    },
    "history": {
      "principalTitle": "O seu InOut",
      "closedTitle": "No seu histórico",
      "closedLead": "Os InOuts que substituiu ou encerrou, guardados como estavam — cada um lido à data em que foi encerrado.",
      "stateActive": "Ativo",
      "statePaused": "Pausado",
      "sinceActive": "A funcionar desde {{date}}",
      "sincePaused": "Em pausa desde {{date}}",
      "goToInOut": "Ir para o InOut",
      "view": "Ver",
      "restore": "Tornar principal",
      "delete": "Apagar",
      "noTitle": "Sem título de residência",
      "period": "{{from}} – {{to}}",
      "periodOpen": "Desde {{from}}, sem data de fim",
      "trips_one": "{{trips}} viagem",
      "trips_other": "{{trips}} viagens",
      "daysAway_one": "{{days}} dia fora",
      "daysAway_other": "{{days}} dias fora",
      "documents_one": "{{documents}} documento",
      "documents_other": "{{documents}} documentos",
      "closedReplaced": "Encerrado a {{date}} — um novo InOut ficou no seu lugar",
      "closedRestoredOther": "Encerrado a {{date}} — outro do seu histórico passou a principal",
      "closedByYou": "Encerrado por si a {{date}}",
      "closedLegacy": "Guardado de antes de o InOut ter histórico",
      "emptyTitle": "Ainda não há nada no seu histórico",
      "emptyBody": "Quando começar um novo InOut ou encerrar o atual, ele fica guardado aqui — nada se apaga.",
      "noneTitle": "Ainda não tem InOut",
      "noneBody": "Comece o InOut com a calculadora. Cada InOut que começar fica guardado aqui.",
      "loadError": "Não conseguimos ler o seu histórico",
      "restoreTitle": "Tornar este InOut principal?",
      "restoreBody": "O seu InOut atual vai para o histórico. Este volta em pausa — retome-o quando quiser.",
      "restoreBodyNone": "Volta em pausa — retome-o quando quiser.",
      "restoreConfirm": "Tornar principal",
      "restored": "Voltou a ser o seu InOut, em pausa — retome-o quando quiser.",
      "deleteTitle": "Apagar este InOut de vez?",
      "deleteBody": "Sai do seu histórico e não pode ser recuperado. O que guarda é apagado com ele; os ficheiros ficam no seu Cofre.",
      "deleteConfirm": "Apagar de vez",
      "deleteHolds": "O que é apagado",
      "deleted": "O InOut foi apagado.",
      "back": "O seu histórico",
      "detail": {
        "closedPill": "Encerrado",
        "asOf": "Os números como estavam a {{date}}, o dia em que foi encerrado.",
        "noReading": "Este InOut não tem título de residência — não há nada para contar.",
        "principalTitle": "Este é o seu InOut",
        "principalBody": "Funciona na página do InOut — está lá tudo sobre ele.",
        "tripsTitle": "As suas viagens",
        "tripsEmpty": "Não ficou nenhuma viagem registada neste InOut.",
        "plannedTitle": "Viagens que ainda tinha planeadas",
        "documentsTitle": "Documentos",
        "documents_one": "{{documents}} documento anexado às viagens. O ficheiro está no seu Cofre.",
        "documents_other": "{{documents}} documentos anexados às viagens. Os ficheiros estão no seu Cofre.",
        "documentsNone": "Não foi anexado nenhum documento às viagens.",
        "notFoundTitle": "Este InOut não está no seu histórico",
        "notFoundBody": "Pode ter sido apagado. O seu histórico tem todos os InOuts que guarda.",
        "loadError": "Não conseguimos ler este InOut"
      }
    }
  }
}
